/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * YaksonOS Backend
 * Phase 0 scaffold for the Next.js → FastAPI migration. Serves the same REST contract as the legacy Next.js routes; responses are camelCase (ADR D5). See docs/architecture/python-migration/.
 * OpenAPI spec version: 0.1.0
 */
import { apiFetch } from '../mutator';
/**
 * GET /api/admin/access-rules response body.
 */
export interface AccessRuleListResponse {
  userTypes?: string[];
  features?: string[];
  cells?: AccessRuleResponse[];
}

export type AccessRuleResponseDefault = boolean | 'own';

export type AccessRuleResponseEffective = boolean | 'own';

/**
 * Single effective access-matrix cell.
 */
export interface AccessRuleResponse {
  userType: string;
  feature: string;
  default: AccessRuleResponseDefault;
  effective: AccessRuleResponseEffective;
  overridden: boolean;
}

export type AccessRuleUpsertRequestLevel = boolean | 'own';

/**
 * PATCH /api/admin/access-rules request body.
 */
export interface AccessRuleUpsertRequest {
  userType: string;
  feature: string;
  level: AccessRuleUpsertRequestLevel;
}

export type ActionPlanItemArea = string | null;

export type ActionPlanItemText = string | null;

export interface ActionPlanItem {
  area?: ActionPlanItemArea;
  text?: ActionPlanItemText;
}

export type ActionStatus = typeof ActionStatus[keyof typeof ActionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  DROPPED: 'DROPPED',
} as const;

export type ActiveAppointmentResponseProgramId = string | null;

export type ActiveAppointmentResponsePackageId = string | null;

export type ActiveAppointmentResponseRoomId = string | null;

export type ActiveAppointmentResponseLinkedAppointmentId = string | null;

export type ActiveAppointmentResponseBookingGroupId = string | null;

export type ActiveAppointmentResponseConsultantId = string | null;

export type ActiveAppointmentResponseMasterId = string | null;

export type ActiveAppointmentResponseNotes = string | null;

export type ActiveAppointmentResponseCreatedById = string | null;

export type ActiveAppointmentResponseConfirmedByStaffId = string | null;

export type ActiveAppointmentResponseConfirmedAt = string | null;

export type ActiveAppointmentResponseActualStartTime = string | null;

export type ActiveAppointmentResponseActualStartLockedAt = string | null;

export type ActiveAppointmentResponseProgram = AppointmentProgramResponse | null;

export type ActiveAppointmentResponseRoom = AppointmentRoomResponse | null;

export type ActiveAppointmentResponseOutlet = AppointmentOutletResponse | null;

export type ActiveAppointmentResponseConsultationStartedAt = string | null;

export interface ActiveAppointmentResponse {
  id: string;
  customerId: string;
  outletId: string;
  programId?: ActiveAppointmentResponseProgramId;
  packageId?: ActiveAppointmentResponsePackageId;
  roomId?: ActiveAppointmentResponseRoomId;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  appointmentType: string;
  isWaitlist?: boolean;
  linkedAppointmentId?: ActiveAppointmentResponseLinkedAppointmentId;
  bookingGroupId?: ActiveAppointmentResponseBookingGroupId;
  consultantId?: ActiveAppointmentResponseConsultantId;
  masterId?: ActiveAppointmentResponseMasterId;
  notes?: ActiveAppointmentResponseNotes;
  createdById?: ActiveAppointmentResponseCreatedById;
  confirmedByStaffId?: ActiveAppointmentResponseConfirmedByStaffId;
  confirmedAt?: ActiveAppointmentResponseConfirmedAt;
  actualStartTime?: ActiveAppointmentResponseActualStartTime;
  actualStartLockedAt?: ActiveAppointmentResponseActualStartLockedAt;
  createdAt: string;
  updatedAt: string;
  customer: AppointmentCustomerResponse;
  program?: ActiveAppointmentResponseProgram;
  room?: ActiveAppointmentResponseRoom;
  outlet?: ActiveAppointmentResponseOutlet;
  steps?: StepResponse[];
  progress: ProgressResponse;
  consultationStartedAt?: ActiveAppointmentResponseConsultationStartedAt;
  consultationStartPressed?: boolean;
}

export type AddRuleRequestCategory = typeof AddRuleRequestCategory[keyof typeof AddRuleRequestCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddRuleRequestCategory = {
  HR: 'HR',
  ADMIN: 'ADMIN',
  SALES: 'SALES',
  CUSTCARE: 'CUSTCARE',
  TRAINING: 'TRAINING',
  MARKETING: 'MARKETING',
} as const;

export type AddRuleRequestFrequency = typeof AddRuleRequestFrequency[keyof typeof AddRuleRequestFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddRuleRequestFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ON_EVENT: 'ON_EVENT',
} as const;

export type AddRuleRequestWeekday = number | null;

export type AddRuleRequestMonthDay = number | null;

export type AddRuleRequestMonths = string | null;

export type AddRuleRequestKpi = string | null;

export type AddRuleRequestNote = string | null;

export type AddRuleRequestReason = string | null;

export interface AddRuleRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  title: string;
  category: AddRuleRequestCategory;
  frequency: AddRuleRequestFrequency;
  weekday?: AddRuleRequestWeekday;
  monthDay?: AddRuleRequestMonthDay;
  months?: AddRuleRequestMonths;
  kpi?: AddRuleRequestKpi;
  note?: AddRuleRequestNote;
  /**
   * @minLength 1
   * @maxLength 100
   */
  ownerName: string;
  reason?: AddRuleRequestReason;
}

export type AddTaskRequestCategory = 'HR' | 'ADMIN' | 'SALES' | 'CUSTCARE' | 'TRAINING' | 'MARKETING' | null;

export type AddTaskRequestDueDate = string | null;

export type AddTaskRequestKpi = string | null;

export interface AddTaskRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  title: string;
  category?: AddTaskRequestCategory;
  dueDate?: AddTaskRequestDueDate;
  kpi?: AddTaskRequestKpi;
}

export type AdditionalProgrammeRequestPackageId = string | null;

/**
 * Spec 14 — an extra programme in a multi-programme visit. Shape mirrors
``FollowUpTreatmentRequest`` on purpose: same fields, same order, so the two
sequential-booking paths read alike. Each carries its OWN ``packageId``,
which is what keeps per-leg package deduction correct.
 */
export interface AdditionalProgrammeRequest {
  programId: string;
  roomId: string;
  staffAssignments?: StaffAssignmentInput[];
  packageId?: AdditionalProgrammeRequestPackageId;
}

export type AiAskRequestLanguage = string | null;

export interface AiAskRequest {
  /**
   * @minLength 1
   * @maxLength 1000
   */
  question: string;
  language?: AiAskRequestLanguage;
}

export interface AiAskResponse {
  id: string;
  question: string;
  answer: string;
  result: AiResult;
  sources?: AiSource[];
  language: string;
  askedAt: string;
}

export interface AiChunkOut {
  position: number;
  ref: string;
  text: string;
}

export interface AiDocumentListResponse {
  items?: AiDocumentOut[];
  total: number;
  areas?: string[];
}

export type AiDocumentOutEffectiveFrom = string | null;

export type AiDocumentOutSopDocumentId = string | null;

export interface AiDocumentOut {
  id: string;
  title: string;
  sourceFile: string;
  fileKind: string;
  area: string;
  version: string;
  effectiveFrom?: AiDocumentOutEffectiveFrom;
  whoCanAsk: WhoCanAsk;
  status: DocStatus;
  fileSize: number;
  chunkCount: number;
  updatedAt: string;
  source?: string;
  sopDocumentId?: AiDocumentOutSopDocumentId;
}

export interface AiDocumentPreview {
  document: AiDocumentOut;
  chunks: AiChunkOut[];
}

export type AiDocumentUpdateTitle = string | null;

export type AiDocumentUpdateArea = string | null;

export type AiDocumentUpdateVersion = string | null;

export type AiDocumentUpdateEffectiveFrom = string | null;

export type AiDocumentUpdateWhoCanAsk = WhoCanAsk | null;

export type AiDocumentUpdateStatus = DocStatus | null;

export interface AiDocumentUpdate {
  title?: AiDocumentUpdateTitle;
  area?: AiDocumentUpdateArea;
  version?: AiDocumentUpdateVersion;
  effectiveFrom?: AiDocumentUpdateEffectiveFrom;
  whoCanAsk?: AiDocumentUpdateWhoCanAsk;
  status?: AiDocumentUpdateStatus;
}

export interface AiFaqItem {
  id: string;
  question: string;
  area: string;
}

export interface AiFaqList {
  items?: AiFaqItem[];
}

/**
 * GEN-12-17 — the FAQ rows' ids, top to bottom.
 */
export interface AiFaqOrder {
  /**
   * @minItems 1
   * @maxItems 500
   */
  ids: string[];
}

export type AiFollowUp = typeof AiFollowUp[keyof typeof AiFollowUp];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiFollowUp = {
  OPEN: 'OPEN',
  ANSWERED: 'ANSWERED',
  DISMISSED: 'DISMISSED',
} as const;

export interface AiHistoryCounts {
  questions?: number;
  answered?: number;
  fixed?: number;
  notInDocs?: number;
  refused?: number;
}

export type AiHistoryItemOutletName = string | null;

export type AiHistoryItemRole = string | null;

export type AiHistoryItemFollowUp = string | null;

export interface AiHistoryItem {
  id: string;
  question: string;
  answer: string;
  result: AiResult;
  sources?: AiSource[];
  language: string;
  askedAt: string;
  askedByName: string;
  outletName?: AiHistoryItemOutletName;
  role?: AiHistoryItemRole;
  followUp?: AiHistoryItemFollowUp;
}

export interface AiHistoryOption {
  id: string;
  name: string;
}

export interface AiHistoryResponse {
  items?: AiHistoryItem[];
  total: number;
  counts: AiHistoryCounts;
  outlets?: AiHistoryOption[];
  roles?: string[];
}

export interface AiHome {
  unreadCount?: number;
  recent?: AiRecentChat[];
  topics?: AiTopic[];
}

/**
 * GEN-12-15 — HQ's answer to her question, shown to her once.
 */
export interface AiHqAnswer {
  questionId: string;
  question: string;
  answer: string;
  answeredAt: string;
}

export interface AiHqAnswers {
  items?: AiHqAnswer[];
}

export interface AiPassageOut {
  documentId: string;
  title: string;
  sourceFile: string;
  area: string;
  version: string;
  ref: string;
  text: string;
  score: number;
}

export type AiQaItemFaqNumber = number | null;

export interface AiQaItem {
  id: string;
  question: string;
  otherWays: string;
  answer: string;
  area: string;
  whoCanAsk: AiWhoCanAsk;
  inFaq: boolean;
  faqNumber?: AiQaItemFaqNumber;
  active: boolean;
  updatedAt: string;
}

export interface AiQaList {
  items?: AiQaItem[];
  areas?: string[];
}

/**
 * The Q&A editor: Question and Answer are required (GEN-12-13).
 */
export interface AiQaWrite {
  /**
   * @minLength 1
   * @maxLength 1000
   */
  question: string;
  /** @maxLength 4000 */
  otherWays?: string;
  /**
   * @minLength 1
   * @maxLength 8000
   */
  answer: string;
  /** @maxLength 100 */
  area?: string;
  whoCanAsk?: AiWhoCanAsk;
  inFaq?: boolean;
  active?: boolean;
}

export type AiRecentChatHqAnswer = string | null;

export type AiRecentChatHqAnsweredAt = string | null;

/**
 * One of her own last conversations; ``unread`` = HQ answered it and she has not opened it.
 */
export interface AiRecentChat {
  id: string;
  question: string;
  answer: string;
  result: AiResult;
  sources?: AiSource[];
  askedAt: string;
  unread?: boolean;
  hqAnswer?: AiRecentChatHqAnswer;
  hqAnsweredAt?: AiRecentChatHqAnsweredAt;
}

export type AiResult = typeof AiResult[keyof typeof AiResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiResult = {
  ANSWERED: 'ANSWERED',
  FIXED: 'FIXED',
  NOT_IN_DOCS: 'NOT_IN_DOCS',
  REFUSED: 'REFUSED',
} as const;

export interface AiSearchResponse {
  query: string;
  passages?: AiPassageOut[];
}

export interface AiSource {
  title: string;
  sourceFile?: string;
  area?: string;
  version?: string;
  ref?: string;
  text?: string;
}

/**
 * A Knowledge area she may ask about, with its suggested questions (may be empty).
 */
export interface AiTopic {
  area: string;
  questions?: AiTopicQuestion[];
}

export interface AiTopicQuestion {
  id: string;
  question: string;
}

export type AiUnansweredItemOutletName = string | null;

export type AiUnansweredItemRole = string | null;

export type AiUnansweredItemAnsweredQaId = string | null;

export type AiUnansweredItemAnsweredAt = string | null;

/**
 * GEN-12-12 — a question Sunny could not answer.
 */
export interface AiUnansweredItem {
  id: string;
  askedAt: string;
  askedByName: string;
  outletName?: AiUnansweredItemOutletName;
  role?: AiUnansweredItemRole;
  language: string;
  question: string;
  status: AiFollowUp;
  answeredQaId?: AiUnansweredItemAnsweredQaId;
  answeredAt?: AiUnansweredItemAnsweredAt;
}

export interface AiUnansweredList {
  items?: AiUnansweredItem[];
  openCount?: number;
}

export interface AiUnreadCount {
  count?: number;
}

export type AiWhoCanAsk = typeof AiWhoCanAsk[keyof typeof AiWhoCanAsk];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiWhoCanAsk = {
  ALL: 'ALL',
  HQ: 'HQ',
} as const;

export interface AppointmentCheckResponse {
  asOf: string;
  tomorrow: string;
  beforeClosing?: boolean;
  confirmations?: CheckConfirmation[];
  confirmedCount?: number;
  freedSlots?: CheckFreedSlot[];
  consultations?: CheckConsultation[];
  complaints?: CheckComplaint[];
  left?: number;
}

export type AppointmentComboResponseTreatment = AppointmentResponse | null;

export interface AppointmentComboResponse {
  consultation: AppointmentResponse;
  treatment?: AppointmentComboResponseTreatment;
}

export interface AppointmentCompleteBody {
  id: string;
  status: string;
}

export type AppointmentCompleteRequestReason = string | null;

export interface AppointmentCompleteRequest {
  reason?: AppointmentCompleteRequestReason;
}

export type AppointmentCompleteResponseCommission = { [key: string]: unknown };

export interface AppointmentCompleteResponse {
  success: boolean;
  appointment: AppointmentCompleteBody;
  commission: AppointmentCompleteResponseCommission;
}

export type AppointmentConsultationAddRequestPosition = typeof AppointmentConsultationAddRequestPosition[keyof typeof AppointmentConsultationAddRequestPosition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentConsultationAddRequestPosition = {
  before: 'before',
  after: 'after',
} as const;

export type AppointmentConsultationAddRequestConsultantId = string | null;

export type AppointmentConsultationAddRequestMasterId = string | null;

export type AppointmentConsultationAddRequestRoomId = string | null;

/**
 * SPEC-R5-01 — bolt a 30-minute consultation onto an ALREADY-BOOKED visit.

Deliberately the same vocabulary as ``FollowUpConsultationRequest``, the
booking-time toggle (#446): same ``position``, same optional
consultant/master, so the two paths cannot drift on what "before" means.

``roomId`` is optional here and defaults to the visit's own room — one visit,
one room (Angela 2026-07-28 B2). At booking time it is required because there
is no existing leg to inherit it from.
 */
export interface AppointmentConsultationAddRequest {
  position?: AppointmentConsultationAddRequestPosition;
  consultantId?: AppointmentConsultationAddRequestConsultantId;
  masterId?: AppointmentConsultationAddRequestMasterId;
  roomId?: AppointmentConsultationAddRequestRoomId;
  force?: boolean;
}

export type AppointmentCreateRoomId = string | null;

export type AppointmentCreateEndTime = string | null;

export type AppointmentCreateProgramId = string | null;

export type AppointmentCreateStaffAssignments = StaffAssignmentInput[] | null;

export type AppointmentCreateConsultantId = string | null;

export type AppointmentCreateMasterId = string | null;

export type AppointmentCreateFollowUpTreatment = FollowUpTreatmentRequest | null;

export type AppointmentCreateFollowUpConsultation = FollowUpConsultationRequest | null;

export type AppointmentCreatePackageId = string | null;

export type AppointmentCreateLinkedAppointmentId = string | null;

export type AppointmentCreateAdditionalPrograms = AdditionalProgrammeRequest[] | null;

export type AppointmentCreateNotes = string | null;

export type AppointmentCreateManualStaffId = string | null;

export type AppointmentCreateManualStaffIds = string[] | null;

export type AppointmentCreateManualDuration = number | null;

export type AppointmentCreateStepOrder = string[] | null;

export interface AppointmentCreate {
  customerId: string;
  outletId: string;
  roomId?: AppointmentCreateRoomId;
  date: string;
  startTime: string;
  endTime?: AppointmentCreateEndTime;
  programId?: AppointmentCreateProgramId;
  staffAssignments?: AppointmentCreateStaffAssignments;
  appointmentType?: BookingAppointmentType;
  consultantId?: AppointmentCreateConsultantId;
  masterId?: AppointmentCreateMasterId;
  followUpTreatment?: AppointmentCreateFollowUpTreatment;
  followUpConsultation?: AppointmentCreateFollowUpConsultation;
  packageId?: AppointmentCreatePackageId;
  linkedAppointmentId?: AppointmentCreateLinkedAppointmentId;
  additionalPrograms?: AppointmentCreateAdditionalPrograms;
  notes?: AppointmentCreateNotes;
  manualStaffId?: AppointmentCreateManualStaffId;
  manualStaffIds?: AppointmentCreateManualStaffIds;
  manualDuration?: AppointmentCreateManualDuration;
  force?: boolean;
  stepOrder?: AppointmentCreateStepOrder;
  isWaitlist?: boolean;
}

export type AppointmentCustomerResponsePhone = string | null;

export type AppointmentCustomerResponseEmail = string | null;

export type AppointmentCustomerResponseDob = string | null;

export type AppointmentCustomerResponseGender = string | null;

export type AppointmentCustomerResponseNationality = string | null;

export type AppointmentCustomerResponseMaritalStatus = string | null;

export type AppointmentCustomerResponseAddress = string | null;

export type AppointmentCustomerResponseReferralSource = string | null;

export type AppointmentCustomerResponseReferralDetail = string | null;

export type AppointmentCustomerResponsePhotoUrl = string | null;

export type AppointmentCustomerResponsePrefOutletId = string | null;

export type AppointmentCustomerResponseSpecialRequests = string | null;

export type AppointmentCustomerResponseNotes = string | null;

export type AppointmentCustomerResponseCreatedAt = string | null;

export type AppointmentCustomerResponseUpdatedAt = string | null;

export interface AppointmentCustomerResponse {
  id: string;
  name: string;
  phone?: AppointmentCustomerResponsePhone;
  email?: AppointmentCustomerResponseEmail;
  dob?: AppointmentCustomerResponseDob;
  gender?: AppointmentCustomerResponseGender;
  nationality?: AppointmentCustomerResponseNationality;
  maritalStatus?: AppointmentCustomerResponseMaritalStatus;
  address?: AppointmentCustomerResponseAddress;
  referralSource?: AppointmentCustomerResponseReferralSource;
  referralDetail?: AppointmentCustomerResponseReferralDetail;
  photoUrl?: AppointmentCustomerResponsePhotoUrl;
  prefOutletId?: AppointmentCustomerResponsePrefOutletId;
  specialRequests?: AppointmentCustomerResponseSpecialRequests;
  notes?: AppointmentCustomerResponseNotes;
  createdAt?: AppointmentCustomerResponseCreatedAt;
  updatedAt?: AppointmentCustomerResponseUpdatedAt;
  preferences?: CustomerPreference[];
}

export interface AppointmentDeleteRequest {
  /** @minLength 1 */
  reason: string;
}

export type AppointmentDetailsResponseProgramId = string | null;

export type AppointmentDetailsResponsePackageId = string | null;

export type AppointmentDetailsResponseRoomId = string | null;

export type AppointmentDetailsResponseLinkedAppointmentId = string | null;

export type AppointmentDetailsResponseBookingGroupId = string | null;

export type AppointmentDetailsResponseConsultantId = string | null;

export type AppointmentDetailsResponseMasterId = string | null;

export type AppointmentDetailsResponseNotes = string | null;

export type AppointmentDetailsResponseCreatedById = string | null;

export type AppointmentDetailsResponseConfirmedByStaffId = string | null;

export type AppointmentDetailsResponseConfirmedAt = string | null;

export type AppointmentDetailsResponseActualStartTime = string | null;

export type AppointmentDetailsResponseActualStartLockedAt = string | null;

export type AppointmentDetailsResponseProgram = AppointmentProgramResponse | null;

export type AppointmentDetailsResponsePackage = AppointmentPackageResponse | null;

export type AppointmentDetailsResponseRoom = AppointmentRoomResponse | null;

export type AppointmentDetailsResponseOutlet = AppointmentOutletResponse | null;

export type AppointmentDetailsResponseConsultant = AppointmentStaffResponse | null;

export type AppointmentDetailsResponseMaster = AppointmentStaffResponse | null;

export type AppointmentDetailsResponseWaitlistFrom = string | null;

export type AppointmentDetailsResponseWaitlistUntil = string | null;

export type AppointmentDetailsResponseAddOnOnlyConfirmedById = string | null;

export type AppointmentDetailsResponseAddOnOnlyConfirmedAt = string | null;

export type AppointmentDetailsResponseConsultationTargetPackageId = string | null;

export type AppointmentDetailsResponseConsultationType = string | null;

export type AppointmentDetailsResponseConsultationPurpose = string | null;

export type AppointmentDetailsResponseConsultationReason = string | null;

export type AppointmentDetailsResponseConsultationRemaining = number | null;

export type AppointmentDetailsResponseConsultationPackageState = string | null;

export type AppointmentDetailsResponseConsultationStartedAt = string | null;

export type AppointmentDetailsResponseExtensionNeed = AppointmentExtensionNeedResponse | null;

export interface AppointmentDetailsResponse {
  id: string;
  customerId: string;
  outletId: string;
  programId?: AppointmentDetailsResponseProgramId;
  packageId?: AppointmentDetailsResponsePackageId;
  roomId?: AppointmentDetailsResponseRoomId;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  appointmentType: string;
  isWaitlist?: boolean;
  linkedAppointmentId?: AppointmentDetailsResponseLinkedAppointmentId;
  bookingGroupId?: AppointmentDetailsResponseBookingGroupId;
  consultantId?: AppointmentDetailsResponseConsultantId;
  masterId?: AppointmentDetailsResponseMasterId;
  notes?: AppointmentDetailsResponseNotes;
  createdById?: AppointmentDetailsResponseCreatedById;
  confirmedByStaffId?: AppointmentDetailsResponseConfirmedByStaffId;
  confirmedAt?: AppointmentDetailsResponseConfirmedAt;
  actualStartTime?: AppointmentDetailsResponseActualStartTime;
  actualStartLockedAt?: AppointmentDetailsResponseActualStartLockedAt;
  createdAt: string;
  updatedAt: string;
  customer: AppointmentCustomerResponse;
  program?: AppointmentDetailsResponseProgram;
  package?: AppointmentDetailsResponsePackage;
  room?: AppointmentDetailsResponseRoom;
  outlet?: AppointmentDetailsResponseOutlet;
  consultant?: AppointmentDetailsResponseConsultant;
  master?: AppointmentDetailsResponseMaster;
  steps?: StepResponse[];
  waitlistFrom?: AppointmentDetailsResponseWaitlistFrom;
  waitlistUntil?: AppointmentDetailsResponseWaitlistUntil;
  addOnOnly?: boolean;
  addOnOnlyConfirmedById?: AppointmentDetailsResponseAddOnOnlyConfirmedById;
  addOnOnlyConfirmedAt?: AppointmentDetailsResponseAddOnOnlyConfirmedAt;
  consultationTargetPackageId?: AppointmentDetailsResponseConsultationTargetPackageId;
  consultationType?: AppointmentDetailsResponseConsultationType;
  consultationPurpose?: AppointmentDetailsResponseConsultationPurpose;
  consultationReason?: AppointmentDetailsResponseConsultationReason;
  consultationRemaining?: AppointmentDetailsResponseConsultationRemaining;
  consultationPackageState?: AppointmentDetailsResponseConsultationPackageState;
  consultationStartedAt?: AppointmentDetailsResponseConsultationStartedAt;
  consultationStartPressed?: boolean;
  groupAppointmentIds?: string[];
  extensionNeed?: AppointmentDetailsResponseExtensionNeed;
  usedBeforeExtensionApproval?: boolean;
  statusHistory?: StatusHistoryEntry[];
}

export type AppointmentExtensionNeedResponsePackageChangeId = string | null;

export type AppointmentExtensionNeedResponseRejectReason = string | null;

/**
 * OPS-20 — the extension request a booking on an expired package waits for.
 */
export interface AppointmentExtensionNeedResponse {
  id: string;
  packageId: string;
  status: string;
  packageChangeId?: AppointmentExtensionNeedResponsePackageChangeId;
  rejectReason?: AppointmentExtensionNeedResponseRejectReason;
}

export type AppointmentGroupMoveRequestDate = string | null;

export type AppointmentGroupMoveRequestStaffReassignment = StaffReassignment | null;

/**
 * SPEC-R5-03 — move a WHOLE visit, atomically.

``startTime`` is where the DRAGGED leg lands; every other leg of the visit
shifts by the same delta, so the relative offsets — and therefore the order
and any gaps — survive the move. Per-leg room and staff are preserved unless
``staffReassignment`` says otherwise.
 */
export interface AppointmentGroupMoveRequest {
  startTime: string;
  date?: AppointmentGroupMoveRequestDate;
  staffReassignment?: AppointmentGroupMoveRequestStaffReassignment;
  force?: boolean;
}

/**
 * SPEC-R5-03 — every leg the move touched, at its new time, earliest first.

The whole visit comes back rather than just the dragged leg: the caller has
just moved rows it did not name, and the grid needs all of them to redraw
without a second round trip.
 */
export interface AppointmentGroupMoveResponse {
  appointments?: AppointmentResponse[];
}

export type AppointmentLegCreateRoomId = string | null;

export type AppointmentLegCreatePackageId = string | null;

/**
 * Spec §3.2 — add a programme to an already-booked visit. The new leg joins
the existing ``bookingGroupId`` and starts at the end of the last leg,
back-to-back with no rest gap (the Spec 14 rule).
 */
export interface AppointmentLegCreate {
  programId: string;
  roomId?: AppointmentLegCreateRoomId;
  staffAssignments: StaffAssignmentInput[];
  packageId?: AppointmentLegCreatePackageId;
  force?: boolean;
}

export type AppointmentListItemProgramId = string | null;

export type AppointmentListItemPackageId = string | null;

export type AppointmentListItemRoomId = string | null;

export type AppointmentListItemLinkedAppointmentId = string | null;

export type AppointmentListItemBookingGroupId = string | null;

export type AppointmentListItemConsultantId = string | null;

export type AppointmentListItemMasterId = string | null;

export type AppointmentListItemNotes = string | null;

export type AppointmentListItemCreatedById = string | null;

export type AppointmentListItemConfirmedByStaffId = string | null;

export type AppointmentListItemConfirmedAt = string | null;

export type AppointmentListItemActualStartTime = string | null;

export type AppointmentListItemActualStartLockedAt = string | null;

export type AppointmentListItemCustomer = AppointmentCustomerResponse | null;

export type AppointmentListItemProgram = AppointmentProgramResponse | null;

export type AppointmentListItemRoom = AppointmentRoomResponse | null;

export type AppointmentListItemOutlet = AppointmentOutletResponse | null;

export interface AppointmentListItem {
  id: string;
  customerId: string;
  outletId: string;
  programId?: AppointmentListItemProgramId;
  packageId?: AppointmentListItemPackageId;
  roomId?: AppointmentListItemRoomId;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  appointmentType: string;
  isWaitlist?: boolean;
  linkedAppointmentId?: AppointmentListItemLinkedAppointmentId;
  bookingGroupId?: AppointmentListItemBookingGroupId;
  consultantId?: AppointmentListItemConsultantId;
  masterId?: AppointmentListItemMasterId;
  notes?: AppointmentListItemNotes;
  createdById?: AppointmentListItemCreatedById;
  confirmedByStaffId?: AppointmentListItemConfirmedByStaffId;
  confirmedAt?: AppointmentListItemConfirmedAt;
  actualStartTime?: AppointmentListItemActualStartTime;
  actualStartLockedAt?: AppointmentListItemActualStartLockedAt;
  createdAt: string;
  updatedAt: string;
  customer?: AppointmentListItemCustomer;
  program?: AppointmentListItemProgram;
  room?: AppointmentListItemRoom;
  outlet?: AppointmentListItemOutlet;
  steps?: StepResponse[];
}

export type AppointmentOutletResponseAddress = string | null;

export type AppointmentOutletResponsePhone = string | null;

export type AppointmentOutletResponseWeekdayOpen = string | null;

export type AppointmentOutletResponseWeekdayClose = string | null;

export type AppointmentOutletResponseWeekendOpen = string | null;

export type AppointmentOutletResponseWeekendClose = string | null;

export type AppointmentOutletResponseRestTimeMinutes = number | null;

export type AppointmentOutletResponseCreatedAt = string | null;

export type AppointmentOutletResponseUpdatedAt = string | null;

export interface AppointmentOutletResponse {
  id: string;
  name: string;
  code: string;
  address?: AppointmentOutletResponseAddress;
  phone?: AppointmentOutletResponsePhone;
  weekdayOpen?: AppointmentOutletResponseWeekdayOpen;
  weekdayClose?: AppointmentOutletResponseWeekdayClose;
  weekendOpen?: AppointmentOutletResponseWeekendOpen;
  weekendClose?: AppointmentOutletResponseWeekendClose;
  restTimeMinutes?: AppointmentOutletResponseRestTimeMinutes;
  createdAt?: AppointmentOutletResponseCreatedAt;
  updatedAt?: AppointmentOutletResponseUpdatedAt;
}

export interface AppointmentPackageResponse {
  id: string;
  totalSessions: number;
  usedSessions: number;
}

export type AppointmentProgramResponseNameKo = string | null;

export type AppointmentProgramResponseNameZh = string | null;

export type AppointmentProgramResponseNameVi = string | null;

export type AppointmentProgramResponseCategory = string | null;

export type AppointmentProgramResponseTotalDuration = number | null;

export type AppointmentProgramResponsePriceAlaCarte = number | number | null;

export type AppointmentProgramResponsePrice5Sessions = number | number | null;

export type AppointmentProgramResponsePrice10Sessions = number | number | null;

export type AppointmentProgramResponsePrice20Sessions = number | number | null;

export type AppointmentProgramResponseIsActive = boolean | null;

export type AppointmentProgramResponseCreatedAt = string | null;

export type AppointmentProgramResponseUpdatedAt = string | null;

export interface AppointmentProgramResponse {
  id: string;
  name: string;
  nameKo?: AppointmentProgramResponseNameKo;
  nameZh?: AppointmentProgramResponseNameZh;
  nameVi?: AppointmentProgramResponseNameVi;
  category?: AppointmentProgramResponseCategory;
  totalDuration?: AppointmentProgramResponseTotalDuration;
  priceAlaCarte?: AppointmentProgramResponsePriceAlaCarte;
  price5Sessions?: AppointmentProgramResponsePrice5Sessions;
  price10Sessions?: AppointmentProgramResponsePrice10Sessions;
  price20Sessions?: AppointmentProgramResponsePrice20Sessions;
  isActive?: AppointmentProgramResponseIsActive;
  createdAt?: AppointmentProgramResponseCreatedAt;
  updatedAt?: AppointmentProgramResponseUpdatedAt;
  steps?: ProgramStepResponse[];
}

export type AppointmentRatingRequestRating = OverallRating | 'DISSATISFIED' | 'NEUTRAL' | 'SATISFIED' | 'VERY_SATISFIED' | null;

export type AppointmentRatingRequestComments = string | null;

export type AppointmentRatingRequestFollowUp = string | null;

export interface AppointmentRatingRequest {
  rating?: AppointmentRatingRequestRating;
  comments?: AppointmentRatingRequestComments;
  followUp?: AppointmentRatingRequestFollowUp;
  steps?: StepRatingInput[];
}

export type AppointmentRatingResponseId = string | null;

export type AppointmentRatingResponseAppointmentId = string | null;

export type AppointmentRatingResponseRating = string | null;

export type AppointmentRatingResponseComments = string | null;

export type AppointmentRatingResponseFollowUp = string | null;

export type AppointmentRatingResponseRatedAt = string | null;

export interface AppointmentRatingResponse {
  id?: AppointmentRatingResponseId;
  appointmentId?: AppointmentRatingResponseAppointmentId;
  rating?: AppointmentRatingResponseRating;
  comments?: AppointmentRatingResponseComments;
  followUp?: AppointmentRatingResponseFollowUp;
  ratedAt?: AppointmentRatingResponseRatedAt;
  steps?: StepRatingResponse[];
}

export interface AppointmentRatingSubmitResponse {
  ok: boolean;
}

/**
 * Response from ``GET /api/reports/appointments``.

``total`` excludes cancellations and the rates divide by it, matching
``GET /api/reports/dashboard`` — so the two never disagree about how many
appointments a period had. ``rows`` still lists the cancellations.
 */
export interface AppointmentReportResponse {
  period: OperationsPeriod;
  total?: number;
  completed?: number;
  cancelled?: number;
  noShow?: number;
  newCustomer?: number;
  existingCustomer?: number;
  newNeverTreated?: number;
  newTried?: number;
  treatments?: number;
  consultations?: number;
  completionRate?: number;
  cancellationRate?: number;
  noShowRate?: number;
  rows?: AppointmentReportRow[];
}

/**
 * One appointment, as N-06's combined detail table reads it.
 */
export interface AppointmentReportRow {
  id: string;
  date: string;
  time: string;
  endTime: string;
  customerName: string;
  customerId?: string;
  outletId?: string;
  customerType: string;
  customerKind?: string;
  treatmentName: string;
  staffNames?: string[];
  outletCode?: string;
  appointmentType: string;
  status: string;
}

export type AppointmentResponseProgramId = string | null;

export type AppointmentResponsePackageId = string | null;

export type AppointmentResponseRoomId = string | null;

export type AppointmentResponseLinkedAppointmentId = string | null;

export type AppointmentResponseBookingGroupId = string | null;

export type AppointmentResponseConsultantId = string | null;

export type AppointmentResponseMasterId = string | null;

export type AppointmentResponseNotes = string | null;

export type AppointmentResponseCreatedById = string | null;

export type AppointmentResponseConfirmedByStaffId = string | null;

export type AppointmentResponseConfirmedAt = string | null;

export type AppointmentResponseActualStartTime = string | null;

export type AppointmentResponseActualStartLockedAt = string | null;

export type AppointmentResponseProgram = AppointmentProgramResponse | null;

export type AppointmentResponsePackage = AppointmentPackageResponse | null;

export type AppointmentResponseRoom = AppointmentRoomResponse | null;

export type AppointmentResponseOutlet = AppointmentOutletResponse | null;

export type AppointmentResponseConsultant = AppointmentStaffResponse | null;

export type AppointmentResponseMaster = AppointmentStaffResponse | null;

export type AppointmentResponseWaitlistFrom = string | null;

export type AppointmentResponseWaitlistUntil = string | null;

export type AppointmentResponseAddOnOnlyConfirmedById = string | null;

export type AppointmentResponseAddOnOnlyConfirmedAt = string | null;

export type AppointmentResponseConsultationTargetPackageId = string | null;

export type AppointmentResponseConsultationType = string | null;

export type AppointmentResponseConsultationPurpose = string | null;

export type AppointmentResponseConsultationReason = string | null;

export type AppointmentResponseConsultationRemaining = number | null;

export type AppointmentResponseConsultationPackageState = string | null;

export type AppointmentResponseConsultationStartedAt = string | null;

export type AppointmentResponseExtensionNeed = AppointmentExtensionNeedResponse | null;

export interface AppointmentResponse {
  id: string;
  customerId: string;
  outletId: string;
  programId?: AppointmentResponseProgramId;
  packageId?: AppointmentResponsePackageId;
  roomId?: AppointmentResponseRoomId;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  appointmentType: string;
  isWaitlist?: boolean;
  linkedAppointmentId?: AppointmentResponseLinkedAppointmentId;
  bookingGroupId?: AppointmentResponseBookingGroupId;
  consultantId?: AppointmentResponseConsultantId;
  masterId?: AppointmentResponseMasterId;
  notes?: AppointmentResponseNotes;
  createdById?: AppointmentResponseCreatedById;
  confirmedByStaffId?: AppointmentResponseConfirmedByStaffId;
  confirmedAt?: AppointmentResponseConfirmedAt;
  actualStartTime?: AppointmentResponseActualStartTime;
  actualStartLockedAt?: AppointmentResponseActualStartLockedAt;
  createdAt: string;
  updatedAt: string;
  customer: AppointmentCustomerResponse;
  program?: AppointmentResponseProgram;
  package?: AppointmentResponsePackage;
  room?: AppointmentResponseRoom;
  outlet?: AppointmentResponseOutlet;
  consultant?: AppointmentResponseConsultant;
  master?: AppointmentResponseMaster;
  steps?: StepResponse[];
  waitlistFrom?: AppointmentResponseWaitlistFrom;
  waitlistUntil?: AppointmentResponseWaitlistUntil;
  addOnOnly?: boolean;
  addOnOnlyConfirmedById?: AppointmentResponseAddOnOnlyConfirmedById;
  addOnOnlyConfirmedAt?: AppointmentResponseAddOnOnlyConfirmedAt;
  consultationTargetPackageId?: AppointmentResponseConsultationTargetPackageId;
  consultationType?: AppointmentResponseConsultationType;
  consultationPurpose?: AppointmentResponseConsultationPurpose;
  consultationReason?: AppointmentResponseConsultationReason;
  consultationRemaining?: AppointmentResponseConsultationRemaining;
  consultationPackageState?: AppointmentResponseConsultationPackageState;
  consultationStartedAt?: AppointmentResponseConsultationStartedAt;
  consultationStartPressed?: boolean;
  groupAppointmentIds?: string[];
  extensionNeed?: AppointmentResponseExtensionNeed;
  usedBeforeExtensionApproval?: boolean;
}

export type AppointmentRoomResponseOutletId = string | null;

export type AppointmentRoomResponseType = string | null;

export type AppointmentRoomResponseBedCount = number | null;

export type AppointmentRoomResponseIsActive = boolean | null;

export type AppointmentRoomResponseCreatedAt = string | null;

export interface AppointmentRoomResponse {
  id: string;
  outletId?: AppointmentRoomResponseOutletId;
  name: string;
  type?: AppointmentRoomResponseType;
  bedCount?: AppointmentRoomResponseBedCount;
  isActive?: AppointmentRoomResponseIsActive;
  createdAt?: AppointmentRoomResponseCreatedAt;
}

export type AppointmentStaffResponseOutletId = string | null;

export type AppointmentStaffResponseRole = string | null;

export type AppointmentStaffResponseSkillLevel = number | null;

export type AppointmentStaffResponseEmploymentType = string | null;

export type AppointmentStaffResponseStartDate = string | null;

export type AppointmentStaffResponseIsProbation = boolean | null;

export type AppointmentStaffResponseProbationEndDate = string | null;

export type AppointmentStaffResponsePhone = string | null;

export type AppointmentStaffResponsePhotoUrl = string | null;

export type AppointmentStaffResponsePreferredLang = string | null;

export type AppointmentStaffResponseIsActive = boolean | null;

export type AppointmentStaffResponseCreatedAt = string | null;

export type AppointmentStaffResponseUpdatedAt = string | null;

export interface AppointmentStaffResponse {
  id: string;
  outletId?: AppointmentStaffResponseOutletId;
  name: string;
  role?: AppointmentStaffResponseRole;
  skillLevel?: AppointmentStaffResponseSkillLevel;
  employmentType?: AppointmentStaffResponseEmploymentType;
  startDate?: AppointmentStaffResponseStartDate;
  isProbation?: AppointmentStaffResponseIsProbation;
  probationEndDate?: AppointmentStaffResponseProbationEndDate;
  phone?: AppointmentStaffResponsePhone;
  photoUrl?: AppointmentStaffResponsePhotoUrl;
  preferredLang?: AppointmentStaffResponsePreferredLang;
  isActive?: AppointmentStaffResponseIsActive;
  createdAt?: AppointmentStaffResponseCreatedAt;
  updatedAt?: AppointmentStaffResponseUpdatedAt;
}

export interface AppointmentStartResponse {
  actualStartTime: string;
  alreadyStarted: boolean;
}

export type AppointmentStatus = typeof AppointmentStatus[keyof typeof AppointmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentStatus = {
  BOOKED: 'BOOKED',
  REMINDER_SENT: 'REMINDER_SENT',
  CONFIRMED: 'CONFIRMED',
  ARRIVED: 'ARRIVED',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  NO_SHOW: 'NO_SHOW',
  DELETED: 'DELETED',
} as const;

export type AppointmentStatusUpdateReason = string | null;

export interface AppointmentStatusUpdate {
  status: AppointmentStatus;
  reason?: AppointmentStatusUpdateReason;
}

export type AppointmentStatusUpdateResponseCommissionAnyOf = { [key: string]: unknown };

export type AppointmentStatusUpdateResponseCommission = AppointmentStatusUpdateResponseCommissionAnyOf | null;

export interface AppointmentStatusUpdateResponse {
  success: boolean;
  appointment: AppointmentResponse;
  commission?: AppointmentStatusUpdateResponseCommission;
  cascadedAppointmentIds?: string[];
}

export type AppointmentStepStaffSummaryRole = string | null;

export type AppointmentStepStaffSummarySkillLevel = number | null;

export type AppointmentStepStaffSummaryOutletId = string | null;

export interface AppointmentStepStaffSummary {
  id: string;
  name: string;
  role?: AppointmentStepStaffSummaryRole;
  skillLevel?: AppointmentStepStaffSummarySkillLevel;
  outletId?: AppointmentStepStaffSummaryOutletId;
}

export type AppointmentStepStatus = typeof AppointmentStepStatus[keyof typeof AppointmentStepStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentStepStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export type AppointmentStepsResponseAppointmentType = string | null;

export type AppointmentStepsResponseProgram = AppointmentProgramResponse | null;

export type AppointmentStepsResponseRoom = AppointmentRoomResponse | null;

export type AppointmentStepsResponseOutlet = AppointmentOutletResponse | null;

export type AppointmentStepsResponseActualStartTime = string | null;

export type AppointmentStepsResponseActualStartLockedAt = string | null;

export interface AppointmentStepsResponse {
  id: string;
  status: string;
  appointmentType?: AppointmentStepsResponseAppointmentType;
  customerId: string;
  customer: OriginalStaffSummary;
  program?: AppointmentStepsResponseProgram;
  room?: AppointmentStepsResponseRoom;
  outlet?: AppointmentStepsResponseOutlet;
  date: string;
  startTime: string;
  endTime: string;
  actualStartTime?: AppointmentStepsResponseActualStartTime;
  actualStartLockedAt?: AppointmentStepsResponseActualStartLockedAt;
  steps?: StepResponse[];
  progress: ProgressResponse;
}

export type AppointmentType = typeof AppointmentType[keyof typeof AppointmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentType = {
  TREATMENT: 'TREATMENT',
  CONSULTATION: 'CONSULTATION',
} as const;

export type AppointmentUpdateRoomId = string | null;

export type AppointmentUpdateDate = string | null;

export type AppointmentUpdateStartTime = string | null;

export type AppointmentUpdateEndTime = string | null;

export type AppointmentUpdateStatus = AppointmentStatus | null;

export type AppointmentUpdateStaffAssignments = StaffAssignmentInput[] | null;

export type AppointmentUpdateConsultantId = string | null;

export type AppointmentUpdateMasterId = string | null;

export type AppointmentUpdateProgramId = string | null;

export type AppointmentUpdatePackageId = string | null;

export type AppointmentUpdateStepOrder = string[] | null;

export type AppointmentUpdateIsWaitlist = boolean | null;

export type AppointmentUpdateNotes = string | null;

export type AppointmentUpdateStaffReassignment = StaffReassignment | null;

export interface AppointmentUpdate {
  roomId?: AppointmentUpdateRoomId;
  date?: AppointmentUpdateDate;
  startTime?: AppointmentUpdateStartTime;
  endTime?: AppointmentUpdateEndTime;
  status?: AppointmentUpdateStatus;
  staffAssignments?: AppointmentUpdateStaffAssignments;
  consultantId?: AppointmentUpdateConsultantId;
  masterId?: AppointmentUpdateMasterId;
  programId?: AppointmentUpdateProgramId;
  packageId?: AppointmentUpdatePackageId;
  clearPackage?: boolean;
  confirmRechain?: boolean;
  force?: boolean;
  stepOrder?: AppointmentUpdateStepOrder;
  isWaitlist?: AppointmentUpdateIsWaitlist;
  notes?: AppointmentUpdateNotes;
  staffReassignment?: AppointmentUpdateStaffReassignment;
}

export type ApprovalDecisionNote = string | null;

/**
 * Body for approve / reject — the optional reviewer note.
 */
export interface ApprovalDecision {
  note?: ApprovalDecisionNote;
}

export type ApprovalRequestNote = string | null;

/**
 * POST /finance/package-changes/{id}/approve|reject — the optional reviewer
note recorded on ``PackageChange.approvalNote``.
 */
export interface ApprovalRequest {
  note?: ApprovalRequestNote;
}

export interface ApprovalRequestListResponse {
  items?: ApprovalRequestResponse[];
  total: number;
}

export type ApprovalRequestResponsePackageChangeId = string | null;

export type ApprovalRequestResponseSaleId = string | null;

export type ApprovalRequestResponseCreditNoteId = string | null;

export type ApprovalRequestResponseUsageId = string | null;

export type ApprovalRequestResponseOutletId = string | null;

export type ApprovalRequestResponseOutletName = string | null;

export type ApprovalRequestResponseCustomerId = string | null;

export type ApprovalRequestResponseCustomerName = string | null;

export type ApprovalRequestResponseReference = string | null;

export type ApprovalRequestResponseProgramName = string | null;

export type ApprovalRequestResponseAmount = string | null;

export type ApprovalRequestResponseRequestReason = string | null;

export type ApprovalRequestResponseRequestedByName = string | null;

export type ApprovalRequestResponseRequestedExpiryDate = string | null;

export type ApprovalRequestResponseRefundSessions = number | null;

export type ApprovalRequestResponseQuotedAmount = string | null;

export type ApprovalRequestResponseRequestedAmount = string | null;

export type ApprovalRequestResponseAdminChargeAmount = string | null;

export type ApprovalRequestResponseLevel1ByName = string | null;

export type ApprovalRequestResponseLevel1At = string | null;

export type ApprovalRequestResponseLevel1Note = string | null;

export type ApprovalRequestResponseLevel2ByName = string | null;

export type ApprovalRequestResponseLevel2At = string | null;

export type ApprovalRequestResponseLevel2Note = string | null;

export type ApprovalRequestResponseVoidPaid = string | null;

export type ApprovalRequestResponseVoidUsed = string | null;

export type ApprovalRequestResponseVoidToReturn = string | null;

export type ApprovalRequestResponseSettlementRefund = string | null;

export type ApprovalRequestResponseSettlementCredit = string | null;

export type ApprovalRequestResponseSettlementCreditNoteNumber = string | null;

export type ApprovalRequestResponseSettlementNote = string | null;

export type ApprovalRequestResponseSettledAt = string | null;

/**
 * One queue row, with what the reviewer needs to decide resolved inline.
 */
export interface ApprovalRequestResponse {
  id: string;
  category: string;
  status: string;
  reviewOnly: boolean;
  canAct: boolean;
  packageChangeId?: ApprovalRequestResponsePackageChangeId;
  saleId?: ApprovalRequestResponseSaleId;
  creditNoteId?: ApprovalRequestResponseCreditNoteId;
  usageId?: ApprovalRequestResponseUsageId;
  outletId?: ApprovalRequestResponseOutletId;
  outletName?: ApprovalRequestResponseOutletName;
  customerId?: ApprovalRequestResponseCustomerId;
  customerName?: ApprovalRequestResponseCustomerName;
  reference?: ApprovalRequestResponseReference;
  programName?: ApprovalRequestResponseProgramName;
  amount?: ApprovalRequestResponseAmount;
  requestReason?: ApprovalRequestResponseRequestReason;
  requestedByName?: ApprovalRequestResponseRequestedByName;
  requestedExpiryDate?: ApprovalRequestResponseRequestedExpiryDate;
  extensionReasons?: string[];
  attachments?: string[];
  refundSessions?: ApprovalRequestResponseRefundSessions;
  quotedAmount?: ApprovalRequestResponseQuotedAmount;
  requestedAmount?: ApprovalRequestResponseRequestedAmount;
  adminChargeAmount?: ApprovalRequestResponseAdminChargeAmount;
  overHalfUsed?: boolean;
  level1ByName?: ApprovalRequestResponseLevel1ByName;
  level1At?: ApprovalRequestResponseLevel1At;
  level1Note?: ApprovalRequestResponseLevel1Note;
  level2ByName?: ApprovalRequestResponseLevel2ByName;
  level2At?: ApprovalRequestResponseLevel2At;
  level2Note?: ApprovalRequestResponseLevel2Note;
  createdAt: string;
  voidPaid?: ApprovalRequestResponseVoidPaid;
  voidUsed?: ApprovalRequestResponseVoidUsed;
  voidToReturn?: ApprovalRequestResponseVoidToReturn;
  voidPayNotices?: VoidPayNotice[];
  settlementPending?: boolean;
  settlementRefund?: ApprovalRequestResponseSettlementRefund;
  settlementCredit?: ApprovalRequestResponseSettlementCredit;
  settlementCreditNoteNumber?: ApprovalRequestResponseSettlementCreditNoteNumber;
  settlementNote?: ApprovalRequestResponseSettlementNote;
  settledAt?: ApprovalRequestResponseSettledAt;
}

/**
 * Dashboard box (R5-51): requests raised this week, what is waiting on the
current user, and everything still pending.
 */
export interface ApprovalSummaryResponse {
  thisWeek: number;
  awaitingMe: number;
  pendingTotal: number;
  canApprove: boolean;
}

export type AreaCardHint = string | null;

/**
 * DSH-08-08 — one card for the person's area; ``link`` = the screen it opens.
 */
export interface AreaCard {
  key: string;
  title: string;
  hint?: AreaCardHint;
  link: string;
  rows: AreaRow[];
}

/**
 * GET /office-desk/desks/{owner}/area-cards (DSH-08-08).
 */
export interface AreaCardsResponse {
  cards: AreaCard[];
  goals: OutletGoal[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothNetSales: string;
  incentiveMarks: number[];
  breakEven: number;
}

export type AreaRowDetail = string | null;

export type AreaRowCount = number | null;

export type AreaRowBadge = string | null;

export interface AreaRow {
  label: string;
  detail?: AreaRowDetail;
  count?: AreaRowCount;
  badge?: AreaRowBadge;
  red?: boolean;
}

export interface AssignRoleRequest {
  roleId: string;
}

/**
 * POST /finance/attachments — a stored supporting document (R5-38).
 */
export interface AttachmentUploadResponse {
  url: string;
  filename: string;
}

export type AttendanceAction = typeof AttendanceAction[keyof typeof AttendanceAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendanceAction = {
  CLOCK_IN: 'CLOCK_IN',
  BREAK_START: 'BREAK_START',
  BREAK_END: 'BREAK_END',
  CLOCK_OUT: 'CLOCK_OUT',
} as const;

export interface AttendanceReport {
  fromDate: string;
  toDate: string;
  tiles: ReportTiles;
  rows?: ReportRow[];
  toCheck?: ToCheckItem[];
}

/**
 * A customer named on a Needs-attention line: name and time only.
 */
export interface AttentionCustomer {
  customerId: string;
  name: string;
  time: string;
}

export type AttentionLineTime = string | null;

export type AttentionLineTicketNo = string | null;

export type AttentionLineOpened = string | null;

/**
 * DSH-19-02 — one line that is true today. ``key`` is ``red_customers``,
``free_slot``, ``open_complaint`` or ``no_reply``; ``customers`` names who is
behind a ``no_reply`` line. A ``free_slot`` line is one freed slot today:
``time`` is when it starts, ``matches`` the waitlist customers who fit
(name · wanted window), ``count`` how many. An ``open_complaint`` line counts
the complaints not yet completed; ``ticket_no`` / ``opened`` are the oldest.
 */
export interface AttentionLine {
  key: string;
  count: number;
  customers?: AttentionCustomer[];
  time?: AttentionLineTime;
  matches?: string[];
  ticketNo?: AttentionLineTicketNo;
  opened?: AttentionLineOpened;
}

export type AudienceDefinitionUnavailableReason = string | null;

/**
 * One audience a promotion can go to. ``available`` is False while the
list it reads from is not built on this base (the first audience, 'Waiting
for a promotion', is Leads list LEA-14).
 */
export interface AudienceDefinition {
  key: string;
  label: string;
  available: boolean;
  unavailableReason: AudienceDefinitionUnavailableReason;
}

export type AudienceOutletCountOutletId = string | null;

export interface AudienceOutletCount {
  outletId: AudienceOutletCountOutletId;
  outletName: string;
  count: number;
}

export interface AudiencePreviewResponse {
  audiences: AudienceDefinition[];
  counts: AudienceOutletCount[];
  total: number;
}

export interface AuditListResponse {
  items: AuditRow[];
  total: number;
  page: number;
  pageSize: number;
}

export interface AuditOptionsResponse {
  modules: string[];
  events: string[];
  users: AuditUserOption[];
}

export type AuditRowIpAddress = string | null;

export type AuditRowUserId = string | null;

export type AuditRowUserName = string | null;

export type AuditRowDetail = string | null;

export type AuditRowEntityType = string | null;

export type AuditRowEntityId = string | null;

export interface AuditRow {
  id: string;
  createdAt: string;
  time: string;
  ipAddress?: AuditRowIpAddress;
  userId?: AuditRowUserId;
  userName?: AuditRowUserName;
  module: string;
  event: string;
  detail?: AuditRowDetail;
  entityType?: AuditRowEntityType;
  entityId?: AuditRowEntityId;
}

export interface AuditUserOption {
  id: string;
  name: string;
}

export type AuthorityLimitAllowed = boolean | null;

export type AuthorityLimitLimitText = string | null;

export interface AuthorityLimit {
  packageSessions: number;
  purchaseMethod: string;
  allowed: AuthorityLimitAllowed;
  limitText: AuthorityLimitLimitText;
}

export interface AutoScheduleRequest {
  steps: TreatmentStep[];
  startTime: string;
  availableStaff: AvailableStaff[];
  preferredStaffIds?: string[];
  excludedStaffIds?: string[];
}

export interface AvailabilityConflict {
  startTime: string;
  endTime: string;
}

export type AvailabilityResponseDuration = number | null;

export type AvailabilityResponseOutletOpenTime = string | null;

export type AvailabilityResponseOutletCloseTime = string | null;

export type AvailabilityResponseOutletClosedReason = string | null;

export interface AvailabilityResponse {
  date: string;
  outletId: string;
  startTime: string;
  endTime: string;
  appointmentType: string;
  duration?: AvailabilityResponseDuration;
  availableConsultants?: AvailabilityStaffSummary[];
  availableMasters?: AvailabilityStaffSummary[];
  steps?: AvailabilityStepResponse[];
  availableRooms?: AvailabilityRoomResponse[];
  staffForScheduling?: SchedulingStaffResponse[];
  treatmentSteps?: AvailabilityTreatmentStepResponse[];
  outletClosed?: boolean;
  outletOpenTime?: AvailabilityResponseOutletOpenTime;
  outletCloseTime?: AvailabilityResponseOutletCloseTime;
  outletClosedReason?: AvailabilityResponseOutletClosedReason;
}

export interface AvailabilityRoomResponse {
  id: string;
  name: string;
  type: string;
  bedCount: number;
}

export interface AvailabilityStaffSummary {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
}

export interface AvailabilityStepResponse {
  stepId: string;
  stepName: string;
  minSkillLevel: number;
  duration: number;
  startTime: string;
  endTime: string;
  availableStaff?: AvailabilityStaffSummary[];
}

export interface AvailabilityTreatmentStepResponse {
  id: string;
  sequence: number;
  name: string;
  duration: number;
  minSkillLevel: number;
}

/**
 * A type the signed-in staff member may request leave under.
 */
export interface AvailableLeaveTypeItem {
  requestCode: string;
  code: string;
  name: string;
  countedIn: string;
  documentRequired: boolean;
  isBuiltIn: boolean;
}

export interface AvailableLeaveTypesResponse {
  items?: AvailableLeaveTypeItem[];
}

export interface AvailableStaff {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  availableFrom: string;
  availableTo: string;
  conflicts?: StaffConflict[];
}

/**
 * One person away: name, outlet and role ONLY. Never the leave type,
the reason or any medical detail (DSH-00-10, DSH-17-06).
 */
export interface AwayPerson {
  staffId: string;
  name: string;
  outletCode: string;
  role: string;
}

export type AwayResponseLeavePlannedThisMonth = PlannedLeave[] | null;

/**
 * GET /dashboard/away — 'MC today' / 'On leave today' (Office and Management
views) and, for the Management view only, 'Leave planned this month'.
 */
export interface AwayResponse {
  date: string;
  mcToday: AwayPerson[];
  onLeaveToday: AwayPerson[];
  leavePlannedThisMonth?: AwayResponseLeavePlannedThisMonth;
}

export type BackBarUsageRequestAppointmentId = string | null;

export type BackBarUsageRequestRemarks = string | null;

export type BackBarUsageRequestBatchId = string | null;

export type BackBarUsageRequestUsageDate = string | null;

/**
 * Record manual back-bar product consumption — spec §7.3 / §11.3.

``appointmentId`` is optional: usage CAN be attributed to a treatment when
known, but Angela has not supplied a bill of materials and the spec
explicitly defers BOM-driven auto-deduction.
 */
export interface BackBarUsageRequest {
  /** @minLength 1 */
  locationId: string;
  /** @minLength 1 */
  productId: string;
  /** */
  qty: number;
  appointmentId?: BackBarUsageRequestAppointmentId;
  /** @maxLength 40 */
  usedFor?: string;
  remarks?: BackBarUsageRequestRemarks;
  batchId?: BackBarUsageRequestBatchId;
  usageDate?: BackBarUsageRequestUsageDate;
}

export type BacklogLineKey = typeof BacklogLineKey[keyof typeof BacklogLineKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BacklogLineKey = {
  unpaid_balances: 'unpaid_balances',
  expiring_packages: 'expiring_packages',
  open_complaints: 'open_complaints',
} as const;

export type BacklogLineWaiting = number | null;

export type BacklogLineOldestDays = number | null;

export type BacklogLineNote = string | null;

export type BacklogLineScreen = string | null;

/**
 * DSH-18-03: customer-level work stays on the Outlet / Office views;
management sees how many are waiting and how old the oldest is.
 */
export interface BacklogLine {
  key: BacklogLineKey;
  waiting: BacklogLineWaiting;
  oldestDays: BacklogLineOldestDays;
  note?: BacklogLineNote;
  screen?: BacklogLineScreen;
}

export type BalanceMarkIhipPlanInvoiceNumber = string | null;

/**
 * An IHIP plan with money still owing (``IHIPPlan.outstanding``).
 */
export interface BalanceMarkIhipPlan {
  packageId: string;
  invoiceNumber?: BalanceMarkIhipPlanInvoiceNumber;
  planVariant: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountPaid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  completeBy: string;
  daysLeft: number;
  overdue: boolean;
  instalmentLate: boolean;
}

export type BalanceMarkInvoiceInvoiceNumber = string | null;

/**
 * An invoice with money still owing (the Balance Payment rule).
 */
export interface BalanceMarkInvoice {
  saleId: string;
  invoiceNumber?: BalanceMarkInvoiceInvoiceNumber;
  invoiceDate: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  daysOutstanding: number;
}

export type BalancePaymentCreatePaymentTime = string | null;

export type BalancePaymentCreateRemarks = string | null;

/**
 * POST /finance/balance-payments request body.
 */
export interface BalancePaymentCreate {
  saleId: string;
  outletId: string;
  paymentTime?: BalancePaymentCreatePaymentTime;
  payments?: BalancePaymentEntryInput[];
  remarks?: BalancePaymentCreateRemarks;
}

export type BalancePaymentEntryInputAmount = number | string;

export type BalancePaymentEntryInputInfo = string | null;

/**
 * One tender on a balance payment. ``info`` is free text (card last-4, ref
number, …) and lands in ``Payment.notes``.
 */
export interface BalancePaymentEntryInput {
  method: string;
  amount: BalancePaymentEntryInputAmount;
  info?: BalancePaymentEntryInputInfo;
}

export type BalancePaymentEntryOutputInfo = string | null;

/**
 * One tender on a balance payment. ``info`` is free text (card last-4, ref
number, …) and lands in ``Payment.notes``.
 */
export interface BalancePaymentEntryOutput {
  method: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  info?: BalancePaymentEntryOutputInfo;
}

export type BalancePaymentResponseInvoiceNumber = string | null;

/**
 * The minted receipt plus the invoice's post-payment position.
 */
export interface BalancePaymentResponse {
  receiptNumber: string;
  saleId: string;
  invoiceNumber?: BalancePaymentResponseInvoiceNumber;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalPaidNow: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  newOutstanding: string;
  payments?: BalancePaymentEntryOutput[];
}

export interface BandChangeResponse {
  changed: number;
}

/**
 * OPS-36-07 — remove a band; its shift types move to Other.
 */
export interface BandRemoveRequest {
  /**
   * @minLength 1
   * @maxLength 40
   */
  band: string;
}

/**
 * OPS-36-07 — rename a band (``band`` = the stored code or name).
 */
export interface BandRenameRequest {
  /**
   * @minLength 1
   * @maxLength 40
   */
  band: string;
  /**
   * @minLength 1
   * @maxLength 40
   */
  newName: string;
}

export type BeforeClosingClosesAt = string | null;

/**
 * LEA-26-10: 'Left today: tab 1 n · red customers n' from n hours before
closing.
 */
export interface BeforeClosing {
  active?: boolean;
  closesAt?: BeforeClosingClosesAt;
  redLeft?: number;
  tab1Left?: number;
}

export type BenefitCapInfoAnnualCap = string | null;

export type BenefitCapInfoRemaining = string | null;

/**
 * Per-benefit-type cap + consumption summary for the requested year.
 */
export interface BenefitCapInfo {
  benefitType: string;
  annualCap?: BenefitCapInfoAnnualCap;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  used: string;
  remaining?: BenefitCapInfoRemaining;
}

export type BenefitUsageCreateRequestAmount = number | string;

export type BenefitUsageCreateRequestClaimDate = string | null;

export type BenefitUsageCreateRequestNote = string | null;

/**
 * POST /salary/benefit-usage request body (admin records a claim).
 */
export interface BenefitUsageCreateRequest {
  staffId: string;
  benefitType: string;
  periodYear: number;
  amount: BenefitUsageCreateRequestAmount;
  claimDate?: BenefitUsageCreateRequestClaimDate;
  note?: BenefitUsageCreateRequestNote;
}

/**
 * GET /salary/benefit-usage response body (entries + remaining caps).
 */
export interface BenefitUsageListResponse {
  usages?: BenefitUsageResponse[];
  caps?: BenefitCapInfo[];
}

export type BenefitUsageResponseClaimDate = string | null;

export type BenefitUsageResponseNote = string | null;

export type BenefitUsageResponseCreatedAt = string | null;

/**
 * A single benefit-usage entry.
 */
export interface BenefitUsageResponse {
  id: string;
  staffId: string;
  benefitType: string;
  periodYear: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  claimDate?: BenefitUsageResponseClaimDate;
  note?: BenefitUsageResponseNote;
  createdAt?: BenefitUsageResponseCreatedAt;
}

export type BodyAddDocumentApiAiKnowledgeDocumentsPostEffectiveFrom = string | null;

export interface BodyAddDocumentApiAiKnowledgeDocumentsPost {
  file: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 60
   */
  area: string;
  /**
   * @minLength 1
   * @maxLength 120
   */
  version: string;
  effectiveFrom?: BodyAddDocumentApiAiKnowledgeDocumentsPostEffectiveFrom;
  whoCanAsk?: WhoCanAsk;
  status?: DocStatus;
}

export type BodyAddDocumentApiHrSopLibraryDocumentsPostVersionLabel = string | null;

export type BodyAddDocumentApiHrSopLibraryDocumentsPostEffectiveFrom = string | null;

export type BodyAddDocumentApiHrSopLibraryDocumentsPostTrainingSopId = string | null;

export type BodyAddDocumentApiHrSopLibraryDocumentsPostNote = string | null;

export interface BodyAddDocumentApiHrSopLibraryDocumentsPost {
  file: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 60
   */
  area: string;
  versionLabel?: BodyAddDocumentApiHrSopLibraryDocumentsPostVersionLabel;
  effectiveFrom?: BodyAddDocumentApiHrSopLibraryDocumentsPostEffectiveFrom;
  trainingSopId?: BodyAddDocumentApiHrSopLibraryDocumentsPostTrainingSopId;
  note?: BodyAddDocumentApiHrSopLibraryDocumentsPostNote;
}

export interface BodyImportConfirmApiLeadsTemplatesImportPost {
  file: string;
}

export interface BodyImportPreviewApiLeadsTemplatesImportPreviewPost {
  file: string;
}

export type BodyLoginApiAuthLoginPostGrantType = string | null;

export type BodyLoginApiAuthLoginPostClientId = string | null;

export type BodyLoginApiAuthLoginPostClientSecret = string | null;

export interface BodyLoginApiAuthLoginPost {
  grant_type?: BodyLoginApiAuthLoginPostGrantType;
  username: string;
  password: string;
  scope?: string;
  client_id?: BodyLoginApiAuthLoginPostClientId;
  client_secret?: BodyLoginApiAuthLoginPostClientSecret;
}

export interface BodyPreviewMinStockImportApiInventoryMinStockImportPreviewPost {
  file: string;
}

export interface BodyPreviewProductMasterImportApiInventoryProductsMasterImportPreviewPost {
  file: string;
}

export type BodyPreviewReviewImportApiPerformanceReviewImportPreviewPostQuarter = string | null;

export interface BodyPreviewReviewImportApiPerformanceReviewImportPreviewPost {
  file: string;
  quarter?: BodyPreviewReviewImportApiPerformanceReviewImportPreviewPostQuarter;
}

export interface BodyPreviewTrainingImportApiTrainingSessionsImportPreviewPost {
  file: string;
}

export interface BodyPreviewTrialImportApiTreatmentsTrialImportPreviewPost {
  file: string;
}

export type BodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePutVersion = string | null;

export type BodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePutEffectiveFrom = string | null;

export interface BodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut {
  file: string;
  version?: BodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePutVersion;
  effectiveFrom?: BodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePutEffectiveFrom;
}

export type BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePutVersionLabel = string | null;

export type BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePutEffectiveFrom = string | null;

export type BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePutNote = string | null;

export interface BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut {
  file: string;
  versionLabel?: BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePutVersionLabel;
  effectiveFrom?: BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePutEffectiveFrom;
  note?: BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePutNote;
}

export interface BodyRunMinStockImportApiInventoryMinStockImportPost {
  file: string;
}

export interface BodyRunProductMasterImportApiInventoryProductsMasterImportPost {
  file: string;
}

export type BodyRunReviewImportApiPerformanceReviewImportPostQuarter = string | null;

export interface BodyRunReviewImportApiPerformanceReviewImportPost {
  file: string;
  quarter?: BodyRunReviewImportApiPerformanceReviewImportPostQuarter;
}

export interface BodyRunTrainingImportApiTrainingSessionsImportPost {
  file: string;
}

export type BodyRunTrialImportApiTreatmentsTrialImportPostBelowMinimumReason = string | null;

export interface BodyRunTrialImportApiTreatmentsTrialImportPost {
  file: string;
  belowMinimumReason?: BodyRunTrialImportApiTreatmentsTrialImportPostBelowMinimumReason;
}

export interface BodyUploadAttachmentApiHrFormsUploadPost {
  file: string;
}

export interface BodyUploadFinanceAttachmentApiFinanceAttachmentsPost {
  file: string;
}

export interface BodyUploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPost {
  file: string;
}

export interface BodyUploadPictureApiLeadsTemplatesPicturesPost {
  file: string;
  /**
   * @minLength 1
   * @maxLength 120
   */
  name: string;
  group?: PictureGroup;
}

export type BookingAppointmentType = typeof BookingAppointmentType[keyof typeof BookingAppointmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingAppointmentType = {
  TREATMENT: 'TREATMENT',
  CONSULTATION: 'CONSULTATION',
  MANUAL: 'MANUAL',
  MAKE_UP: 'MAKE_UP',
} as const;

export type BookingOptionsCustomerPhone = string | null;

export type BookingOptionsCustomerDob = string | null;

export type BookingOptionsCustomerPrefOutletName = string | null;

export type BookingOptionsCustomerLastVisit = string | null;

export interface BookingOptionsCustomer {
  id: string;
  name: string;
  phone?: BookingOptionsCustomerPhone;
  dob?: BookingOptionsCustomerDob;
  prefOutletName?: BookingOptionsCustomerPrefOutletName;
  lastVisit?: BookingOptionsCustomerLastVisit;
  visitedWithin12Months?: boolean;
}

export type BookingOptionsItemPrice = number | null;

/**
 * One catalogue item the 'Search treatments & add-ons' box can add.
 */
export interface BookingOptionsItem {
  programId: string;
  name: string;
  duration: number;
  price?: BookingOptionsItemPrice;
  isAddOn?: boolean;
}

export type BookingOptionsPackageInvoiceNumber = string | null;

export type BookingOptionsPackageState = typeof BookingOptionsPackageState[keyof typeof BookingOptionsPackageState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingOptionsPackageState = {
  USABLE: 'USABLE',
  EXPIRED: 'EXPIRED',
  USED_UP: 'USED_UP',
} as const;

/**
 * One of the customer's packages as the booking page shows it (OPS-19-02).
 */
export interface BookingOptionsPackage {
  id: string;
  programId: string;
  programName: string;
  invoiceNumber?: BookingOptionsPackageInvoiceNumber;
  totalSessions: number;
  remaining: number;
  bookedAhead: number;
  expiryDate: string;
  expiryBusinessDate: string;
  state: BookingOptionsPackageState;
  isAddOn?: boolean;
}

export type BookingOptionsResponseCustomer = BookingOptionsCustomer | null;

export interface BookingOptionsResponse {
  date: string;
  outletId: string;
  items?: BookingOptionsItem[];
  staff?: BookingOptionsStaff[];
  customer?: BookingOptionsResponseCustomer;
  packages?: BookingOptionsPackage[];
}

export type BookingOptionsStaffShiftStart = string | null;

export type BookingOptionsStaffShiftEnd = string | null;

export interface BookingOptionsStaff {
  id: string;
  name: string;
  role: string;
  isSalesConsultant?: boolean;
  shiftStart?: BookingOptionsStaffShiftStart;
  shiftEnd?: BookingOptionsStaffShiftEnd;
}

export type BreakdownConfirmRequestStaffIds = string[] | null;

export interface BreakdownConfirmRequest {
  month: string;
  staffIds?: BreakdownConfirmRequestStaffIds;
}

export type BreakdownEmailSendFrom = string | null;

export interface BreakdownEmail {
  staffId: string;
  staffName: string;
  to: string;
  sendFrom?: BreakdownEmailSendFrom;
  subject: string;
  message: string;
}

export interface BreakdownListResponse {
  month: string;
  replyBy: string;
  settings: BreakdownSettings;
  rows?: BreakdownRow[];
}

export interface BreakdownMonthRequest {
  month: string;
}

export interface BreakdownPreviewResponse {
  emails?: BreakdownEmail[];
  noEmail?: string[];
}

export interface BreakdownReopenRequest {
  month: string;
  staffId: string;
}

export type BreakdownReplyRequestQuestion = string | null;

export interface BreakdownReplyRequest {
  accept: boolean;
  question?: BreakdownReplyRequestQuestion;
}

export type BreakdownRowRole = string | null;

export type BreakdownRowEmail = string | null;

export type BreakdownRowServiceComm = string | null;

export type BreakdownRowSalesComm = string | null;

export type BreakdownRowIncentive = string | null;

export type BreakdownRowConfirmedAt = string | null;

export type BreakdownRowSentAt = string | null;

export type BreakdownRowSentTo = string | null;

export type BreakdownRowReplyBy = string | null;

export type BreakdownRowRepliedAt = string | null;

export type BreakdownRowQueryText = string | null;

export interface BreakdownRow {
  id: string;
  staffId: string;
  staffName: string;
  role?: BreakdownRowRole;
  email?: BreakdownRowEmail;
  month: string;
  status: string;
  serviceComm?: BreakdownRowServiceComm;
  salesComm?: BreakdownRowSalesComm;
  incentive?: BreakdownRowIncentive;
  confirmedAt?: BreakdownRowConfirmedAt;
  sentAt?: BreakdownRowSentAt;
  sentTo?: BreakdownRowSentTo;
  replyBy?: BreakdownRowReplyBy;
  revision?: number;
  repliedAt?: BreakdownRowRepliedAt;
  queryText?: BreakdownRowQueryText;
}

export interface BreakdownSendResponse {
  sent: number;
  noEmail?: string[];
}

export type BreakdownSettingsSendFrom = string | null;

export interface BreakdownSettings {
  sendFrom?: BreakdownSettingsSendFrom;
  subject: string;
  message: string;
}

export type BreakdownSettingsUpdateSendFrom = string | null;

export type BreakdownSettingsUpdateSubject = string | null;

export type BreakdownSettingsUpdateMessage = string | null;

export type BreakdownSettingsUpdateMonth = string | null;

export type BreakdownSettingsUpdateReplyBy = string | null;

export interface BreakdownSettingsUpdate {
  sendFrom?: BreakdownSettingsUpdateSendFrom;
  subject?: BreakdownSettingsUpdateSubject;
  message?: BreakdownSettingsUpdateMessage;
  month?: BreakdownSettingsUpdateMonth;
  replyBy?: BreakdownSettingsUpdateReplyBy;
}

export type BusinessCustomersResponseOutletCode = string | null;

export type BusinessCustomersResponseAverageInvoiceValue = string | null;

/**
 * GET /dashboard/business/customers — Customers tab.
 */
export interface BusinessCustomersResponse {
  period: string;
  firstDay: string;
  lastDay: string;
  outletCode?: BusinessCustomersResponseOutletCode;
  totalCustomers: number;
  newCustomers: number;
  activeCustomers: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalInvoiceValue: string;
  averageInvoiceValue?: BusinessCustomersResponseAverageInvoiceValue;
  growth: MonthGrowth[];
  sources: SourceRow[];
}

export type BusinessMarketingResponseOutletCode = string | null;

/**
 * GET /dashboard/business/marketing — Marketing tab.
 */
export interface BusinessMarketingResponse {
  period: string;
  firstDay: string;
  lastDay: string;
  outletCode?: BusinessMarketingResponseOutletCode;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  byActivity: NamedValue[];
  byMedia: NamedValue[];
}

export type BusinessSalesResponseOutletCode = string | null;

/**
 * GET /dashboard/business/sales — Sales tab.
 */
export interface BusinessSalesResponse {
  period: string;
  firstDay: string;
  lastDay: string;
  outletCode?: BusinessSalesResponseOutletCode;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  revenue: string;
  byOutlet: OutletMonths[];
  bySegment: NamedValue[];
  byTreatment: NamedValue[];
  weeks: WeekTrend[];
}

export type BusinessStaffResponseOutletCode = string | null;

export type BusinessStaffResponseCloseRate = number | null;

/**
 * GET /dashboard/business/staff — Staff tab.
 */
export interface BusinessStaffResponse {
  period: string;
  firstDay: string;
  lastDay: string;
  outletCode?: BusinessStaffResponseOutletCode;
  people: number;
  held: number;
  closeRate?: BusinessStaffResponseCloseRate;
  consultations: StaffConsultRow[];
  hours: StaffHoursRow[];
}

export type BusinessSummaryResponseOutletCode = string | null;

export type BusinessSummaryResponseAverageInvoice = string | null;

export type BusinessSummaryResponseClosedRate = number | null;

export type BusinessSummaryResponsePackagesRate = number | null;

export type BusinessSummaryResponseWalkedRate = number | null;

export type BusinessSummaryResponseSalesFromNewShare = number | null;

export type BusinessSummaryResponseClientFacingShare = number | null;

export type BusinessSummaryResponseActivityRecorded = number | null;

/**
 * GET /dashboard/business/summary — Summary tab (GEN-11-03).
 */
export interface BusinessSummaryResponse {
  period: string;
  firstDay: string;
  lastDay: string;
  outletCode?: BusinessSummaryResponseOutletCode;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  revenue: string;
  invoices: number;
  averageInvoice?: BusinessSummaryResponseAverageInvoice;
  consultationsHeld: number;
  closedToSale: number;
  closedRate?: BusinessSummaryResponseClosedRate;
  packagesSigned: number;
  packagesRate?: BusinessSummaryResponsePackagesRate;
  singleOnly: number;
  walkedWithoutBuying: number;
  walkedRate?: BusinessSummaryResponseWalkedRate;
  newCustomers: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  salesFromNew: string;
  salesFromNewShare?: BusinessSummaryResponseSalesFromNewShare;
  clientFacingShare?: BusinessSummaryResponseClientFacingShare;
  clientFacingHours: number;
  rosteredHours: number;
  activityRecorded?: BusinessSummaryResponseActivityRecorded;
  invoicesWithoutActivity: number;
  consultantsByCloseRate: CloseRateBand[];
  outlets: OutletFigures[];
}

export type BusinessYoyResponseOutletCode = string | null;

/**
 * GET /dashboard/business/yoy — net sales per month of each year asked.
 */
export interface BusinessYoyResponse {
  outletCode?: BusinessYoyResponseOutletCode;
  today: string;
  years: YearMonths[];
}

export interface CanBookResponse {
  canBook: boolean;
}

export interface CanCreateMeetingsResponse {
  canCreateMeetings: boolean;
}

export interface CanEditFaceChartResponse {
  canEdit: boolean;
}

export interface CanMediateResponse {
  canMediate: boolean;
}

export interface CancellationReasonEntry {
  reason: string;
  count?: number;
}

/**
 * Response from ``GET /api/reports/cancellations``.
 */
export interface CancellationReportResponse {
  period: OperationsPeriod;
  total?: number;
  cancelled?: number;
  noShow?: number;
  within24Hours?: number;
  moreThan24Hours?: number;
  unknownTiming?: number;
  byReason?: CancellationReasonEntry[];
  reasons?: string[];
  rows?: CancellationRow[];
}

export type CancellationRowCancelledAt = string | null;

/**
 * One cancelled or no-show appointment, as R5-13's detail table reads it.
 */
export interface CancellationRow {
  id: string;
  date: string;
  time: string;
  customerName: string;
  customerId?: string;
  outletId?: string;
  treatmentName: string;
  staffNames?: string[];
  outletCode?: string;
  status: string;
  reason: string;
  cancelledAt?: CancellationRowCancelledAt;
  timing: string;
}

export type CapabilityLevel = typeof CapabilityLevel[keyof typeof CapabilityLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CapabilityLevel = {
  full: 'full',
  partial: 'partial',
  none: 'none',
} as const;

export type CarryForwardResponseExpiresAt = string | null;

/**
 * Q41 — leave carried INTO ``leaveYear`` from the year before (BUG-884).
``days`` 0 and ``expiresAt`` null when nothing was carried.
 */
export interface CarryForwardResponse {
  staffId: string;
  leaveYear: number;
  days: number;
  usedDays: number;
  expiresAt?: CarryForwardResponseExpiresAt;
}

/**
 * PUT /leave/carry-forward/{staffId} — HQ sets the carried days by hand.
 */
export interface CarryForwardUpdateRequest {
  leaveYear: number;
  days: number;
  remark: string;
}

export type CertifiedTreatmentProgramNameKo = string | null;

export type CertifiedTreatmentProgramNameZh = string | null;

export type CertifiedTreatmentProgramNameVi = string | null;

export type CertifiedTreatmentProgramCategory = TreatmentCategory | null;

export type CertifiedTreatmentProgramTotalDuration = number | null;

export interface CertifiedTreatmentProgram {
  id: string;
  name: string;
  nameKo?: CertifiedTreatmentProgramNameKo;
  nameZh?: CertifiedTreatmentProgramNameZh;
  nameVi?: CertifiedTreatmentProgramNameVi;
  category?: CertifiedTreatmentProgramCategory;
  totalDuration?: CertifiedTreatmentProgramTotalDuration;
}

/**
 * POST /api/users/change-password request body.
 */
export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

/**
 * POST /finance/packages/{id}/change — submit a PENDING treatment change
(FIN-B2, mgmt approval). Same/lower price; rule-gated (§8.9 CHANGE).
 */
export interface ChangeRequest {
  toProgramId: string;
  reason: string;
}

export interface CheckCancelIn {
  /**
   * @minLength 1
   * @maxLength 200
   */
  reason: string;
}

export type CheckComplaintCustomerId = string | null;

export type CheckComplaintDetail = string | null;

export interface CheckComplaint {
  ticketId: string;
  customerId?: CheckComplaintCustomerId;
  name: string;
  category: string;
  detail?: CheckComplaintDetail;
  status: string;
  createdAt: string;
  sameDay?: boolean;
}

export type CheckConfirmationItem = string | null;

/**
 * One of tomorrow's appointments (block 1).
 */
export interface CheckConfirmation {
  appointmentId: string;
  customerId: string;
  name: string;
  mobile: string;
  time: string;
  item?: CheckConfirmationItem;
  status: string;
  confirmed?: boolean;
  tried?: boolean;
}

/**
 * A customer with an appointment and no 30-minute consultation on it
(block 3): no package at all, or on Finishing (LEA-24-05).
 */
export interface CheckConsultation {
  appointmentId: string;
  customerId: string;
  name: string;
  day: string;
  time: string;
  why: string;
}

export type CheckDecideNote = string | null;

export type CheckDecideTime = string | null;

/**
 * POST /attendance/checks — HQ decides one To check item.
 */
export interface CheckDecide {
  staffId: string;
  date: string;
  kind: CheckKind;
  decision: CheckDecision;
  note?: CheckDecideNote;
  time?: CheckDecideTime;
}

export type CheckDecision = typeof CheckDecision[keyof typeof CheckDecision];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckDecision = {
  FIX_TIME: 'FIX_TIME',
  ACCEPT: 'ACCEPT',
  NOTE: 'NOTE',
  MARK_LEAVE: 'MARK_LEAVE',
  APPROVE_OT: 'APPROVE_OT',
  REJECT_OT: 'REJECT_OT',
} as const;

export type CheckFreedSlotItem = string | null;

/**
 * A cancellation or no-show for today or tomorrow (block 2) with the
waitlist customers who fit (same outlet, same day).
 */
export interface CheckFreedSlot {
  appointmentId: string;
  day: string;
  time: string;
  item?: CheckFreedSlotItem;
  cancelledCustomer: string;
  matches?: string[];
  matchCustomerIds?: string[];
}

export type CheckKind = typeof CheckKind[keyof typeof CheckKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckKind = {
  MISSING_CLOCK_OUT: 'MISSING_CLOCK_OUT',
  LATE: 'LATE',
  ABSENT: 'ABSENT',
  OVERTIME: 'OVERTIME',
} as const;

/**
 * One department's month (HR-20-02 / -04).
 */
export interface ClaimAllowance {
  outletId: string;
  outletName: string;
  isHq: boolean;
  period: string;
  fullTimeStaff: number;
  partTimeStaff: number;
  fullTimeStaffNames: string[];
  partTimeStaffNames: string[];
  limitedType: string;
  unlimitedType: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  available: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  used: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balance: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unlimitedTotal: string;
  toPayCount: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  toPayAmount: string;
}

export interface ClaimResponses {
  allowances: ClaimAllowance[];
  claims?: StaffClaimOut[];
}

export interface CloseRateBand {
  label: string;
  consultants: number;
}

/**
 * The Close dropdown (LEA-04-07). Provisional until Leads settings.
 */
export interface CloseReasonList {
  reasons: string[];
  other: string;
}

export interface ClosingReportCell {
  count?: number;
  names?: string[];
}

/**
 * Contacted and Appointments made PER LIST, from logged contacts — counts
only, no targets, no table by consultant (LEA-26-02).
 */
export interface ClosingReportLine {
  day: string;
  listKey: LeadListKey;
  contacted: ClosingReportCell;
  appointmentsMade: ClosingReportCell;
}

export interface ClosingReportResponse {
  start: string;
  end: string;
  lines?: ClosingReportLine[];
  totalContacted?: number;
  totalAppointments?: number;
}

export type ColleagueItemResponseId = string | null;

export interface ColleagueItem {
  staffId: string;
  name: string;
  role: string;
  isMaster: boolean;
  submitted: boolean;
  responseId?: ColleagueItemResponseId;
}

export type CommissionEarningResponseStepName = string | null;

export type CommissionEarningResponseChangedAfterApprovalAt = string | null;

export type CommissionEarningResponseChangedAfterApprovalBy = string | null;

export type CommissionEarningResponseChangedAfterApprovalNote = string | null;

/**
 * Single commission earning entry.
 */
export interface CommissionEarningResponse {
  id: string;
  staffId: string;
  sessionDate: string;
  rateId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  stepName?: CommissionEarningResponseStepName;
  performerCount?: number;
  performers?: string[];
  changedAfterApprovalAt?: CommissionEarningResponseChangedAfterApprovalAt;
  changedAfterApprovalBy?: CommissionEarningResponseChangedAfterApprovalBy;
  changedAfterApprovalNote?: CommissionEarningResponseChangedAfterApprovalNote;
}

export type CommissionRateResponseEffectiveDate = string | null;

/**
 * Single commission rate entry.
 */
export interface CommissionRateResponse {
  id: string;
  roleType: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  flatRate: string;
  effectiveDate?: CommissionRateResponseEffectiveDate;
  isActive: boolean;
}

export type CommissionSchemeCreateRequestFlatPercent = number | string | null;

export type CommissionSchemeCreateRequestTiers = string | null;

export type CommissionSchemeCreateRequestTargetServedPct = number | string | null;

export type CommissionSchemeCreateRequestTargetSalesPct = number | string | null;

/**
 * POST /salary/commission-schemes request body.
 */
export interface CommissionSchemeCreateRequest {
  position: string;
  commissionType: string;
  formulaType: string;
  flatPercent?: CommissionSchemeCreateRequestFlatPercent;
  tiers?: CommissionSchemeCreateRequestTiers;
  targetServedPct?: CommissionSchemeCreateRequestTargetServedPct;
  targetSalesPct?: CommissionSchemeCreateRequestTargetSalesPct;
  isActive?: boolean;
}

/**
 * GET /salary/commission-schemes response body.
 */
export interface CommissionSchemeListResponse {
  commissionSchemes?: CommissionSchemeResponse[];
}

export type CommissionSchemeResponseFlatPercent = string | null;

export type CommissionSchemeResponseTiers = string | null;

export type CommissionSchemeResponseTargetServedPct = string | null;

export type CommissionSchemeResponseTargetSalesPct = string | null;

export type CommissionSchemeResponseCreatedAt = string | null;

export type CommissionSchemeResponseUpdatedAt = string | null;

/**
 * A single commission-scheme config row.
 */
export interface CommissionSchemeResponse {
  id: string;
  position: string;
  commissionType: string;
  formulaType: string;
  flatPercent?: CommissionSchemeResponseFlatPercent;
  tiers?: CommissionSchemeResponseTiers;
  targetServedPct?: CommissionSchemeResponseTargetServedPct;
  targetSalesPct?: CommissionSchemeResponseTargetSalesPct;
  isActive: boolean;
  createdAt?: CommissionSchemeResponseCreatedAt;
  updatedAt?: CommissionSchemeResponseUpdatedAt;
}

export type CommissionSchemeUpdateRequestFormulaType = string | null;

export type CommissionSchemeUpdateRequestFlatPercent = number | string | null;

export type CommissionSchemeUpdateRequestTiers = string | null;

export type CommissionSchemeUpdateRequestTargetServedPct = number | string | null;

export type CommissionSchemeUpdateRequestTargetSalesPct = number | string | null;

export type CommissionSchemeUpdateRequestIsActive = boolean | null;

/**
 * PUT /salary/commission-schemes/{id} request body — all fields optional.
 */
export interface CommissionSchemeUpdateRequest {
  formulaType?: CommissionSchemeUpdateRequestFormulaType;
  flatPercent?: CommissionSchemeUpdateRequestFlatPercent;
  tiers?: CommissionSchemeUpdateRequestTiers;
  targetServedPct?: CommissionSchemeUpdateRequestTargetServedPct;
  targetSalesPct?: CommissionSchemeUpdateRequestTargetSalesPct;
  isActive?: CommissionSchemeUpdateRequestIsActive;
}

export type CommissionStatusResponseLastCalculatedAt = string | null;

/**
 * Commission status summary for a staff member.
 */
export interface CommissionStatusResponse {
  id: string;
  staffId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalEarned: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalPending: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalPaid: string;
  lastCalculatedAt?: CommissionStatusResponseLastCalculatedAt;
}

export type CommissionStatusUpdateRequestCommissionIds = string[] | null;

export type CommissionStatusUpdateRequestStatus = string | null;

/**
 * Request body for bulk commission status updates.
 */
export interface CommissionStatusUpdateRequest {
  commissionIds?: CommissionStatusUpdateRequestCommissionIds;
  status?: CommissionStatusUpdateRequestStatus;
}

/**
 * Response body for bulk commission status updates.
 */
export interface CommissionStatusUpdateResponse {
  success: boolean;
  updated: number;
}

export type ConditionKindOutParams = {[key: string]: string};

export interface ConditionKindOut {
  key: string;
  label: string;
  params?: ConditionKindOutParams;
  applied?: boolean;
}

/**
 * Per-consultant net-sales attribution (best-effort v1 — §9 F open).
 */
export interface ConsultantNetSales {
  staffId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales: string;
}

export type ConsultationGroupRowPurchaseRate = number | null;

export type ConsultationGroupRowPackageRate = number | null;

/**
 * One line of 'By outlet / consultant / type' (OPS-22-07).
 */
export interface ConsultationGroupRow {
  key: string;
  label: string;
  completed?: number;
  anyPurchase?: number;
  purchaseRate?: ConsultationGroupRowPurchaseRate;
  withPackage?: number;
  packageRate?: ConsultationGroupRowPackageRate;
  noPurchase?: number;
  notEntered?: number;
}

export interface ConsultationOption {
  id: string;
  name: string;
}

export type ConsultationOutcomeInReasonDetail = string | null;

export type ConsultationOutcomeInNote = string | null;

export type ConsultationOutcomeInSaleId = string | null;

/**
 * PUT /reports/consultations/{id}/outcome — the SAL-20 step, saved once.
 */
export interface ConsultationOutcomeIn {
  /**
   * @minLength 1
   * @maxLength 200
   */
  reason: string;
  reasonDetail?: ConsultationOutcomeInReasonDetail;
  note?: ConsultationOutcomeInNote;
  saleId?: ConsultationOutcomeInSaleId;
}

export type ConsultationOutcomeOutReasonDetail = string | null;

export type ConsultationOutcomeOutNote = string | null;

export type ConsultationOutcomeOutRecordedBy = string | null;

export interface ConsultationOutcomeOut {
  appointmentId: string;
  customerId: string;
  reason: string;
  reasonDetail?: ConsultationOutcomeOutReasonDetail;
  note?: ConsultationOutcomeOutNote;
  recordedBy?: ConsultationOutcomeOutRecordedBy;
  recordedAt: string;
}

export type ConsultationReasonCountReason = string | null;

export interface ConsultationReasonCount {
  reason?: ConsultationReasonCountReason;
  count?: number;
}

/**
 * The dropdown (SAL-20-06): the top eight first, the rest under 'More';
'Finish balance first' asks which kind (SAL-20-07).
 */
export interface ConsultationReasonList {
  reasons: string[];
  top: number;
  finishBalanceFirst: string;
  finishBalanceKinds: string[];
  other: string;
}

/**
 * Response from ``GET /api/reports/consultations``.
 */
export interface ConsultationReportResponse {
  period: OperationsPeriod;
  booked?: number;
  completed?: number;
  cancelled?: number;
  noShow?: number;
  attachedToTreatment?: number;
  standalone?: number;
  newCustomerCompleted?: number;
  converted?: number;
  conversionRate?: number;
  allCustomersConverted?: number;
  allCustomersConversionRate?: number;
  consultants?: ConsultationStaffEntry[];
  rows?: ConsultationRow[];
}

export type ConsultationRequestPreferredConsultantId = string | null;

export type ConsultationRequestPreferredMasterId = string | null;

export interface ConsultationRequest {
  startTime: string;
  availableStaff: AvailableStaff[];
  preferredConsultantId?: ConsultationRequestPreferredConsultantId;
  preferredMasterId?: ConsultationRequestPreferredMasterId;
  excludedStaffIds?: string[];
}

export type ConsultationResultConsultant = ConsultationStaff | null;

export type ConsultationResultMaster = ConsultationStaff | null;

export interface ConsultationResult {
  success: boolean;
  consultant?: ConsultationResultConsultant;
  master?: ConsultationResultMaster;
  endTime: string;
  duration: number;
  reason: string;
}

export interface ConsultationResultCount {
  result: string;
  count?: number;
}

export type ConsultationResultReportPurchaseRate = number | null;

export type ConsultationResultReportPackageRate = number | null;

export type ConsultationResultReportNewCustomerRate = number | null;

/**
 * Response from ``GET /api/reports/consultations/results``.
 */
export interface ConsultationResultReport {
  month: string;
  booked?: number;
  completed?: number;
  cancelled?: number;
  noShow?: number;
  anyPurchase?: number;
  withPackage?: number;
  purchaseRate?: ConsultationResultReportPurchaseRate;
  packageRate?: ConsultationResultReportPackageRate;
  newCustomerCompleted?: number;
  newCustomerConverted?: number;
  newCustomerRate?: ConsultationResultReportNewCustomerRate;
  toCheck?: number;
  results?: ConsultationResultCount[];
  reasons?: ConsultationReasonCount[];
  byOutlet?: ConsultationGroupRow[];
  byConsultant?: ConsultationGroupRow[];
  byType?: ConsultationGroupRow[];
  consultants?: ConsultationOption[];
  sources?: ConsultationOption[];
  rows?: ConsultationResultRow[];
}

export type ConsultationResultRowConsultantName = string | null;

export type ConsultationResultRowMasterName = string | null;

export type ConsultationResultRowConsultationType = string | null;

export type ConsultationResultRowPurpose = string | null;

export type ConsultationResultRowResult = string | null;

export type ConsultationResultRowSource = string | null;

export type ConsultationResultRowOutcomeReason = string | null;

export type ConsultationResultRowOutcomeDetail = string | null;

export type ConsultationResultRowOutcomeNote = string | null;

export type ConsultationResultRowOutcomeRecordedBy = string | null;

export type ConsultationResultRowNextAppointment = string | null;

/**
 * One consultation in the detail table (OPS-22-08).
 */
export interface ConsultationResultRow {
  id: string;
  date: string;
  time: string;
  status: string;
  customerName: string;
  outletCode?: string;
  consultantName?: ConsultationResultRowConsultantName;
  masterName?: ConsultationResultRowMasterName;
  attachedToTreatment?: boolean;
  newCustomer?: boolean;
  consultationType?: ConsultationResultRowConsultationType;
  purpose?: ConsultationResultRowPurpose;
  result?: ConsultationResultRowResult;
  converted?: boolean;
  refundedSameDay?: boolean;
  relatedInvoices?: string[];
  toCheck?: string[];
  source?: ConsultationResultRowSource;
  outcomeReason?: ConsultationResultRowOutcomeReason;
  outcomeDetail?: ConsultationResultRowOutcomeDetail;
  outcomeNote?: ConsultationResultRowOutcomeNote;
  outcomeRecordedBy?: ConsultationResultRowOutcomeRecordedBy;
  nextAppointment?: ConsultationResultRowNextAppointment;
}

export type ConsultationRowConsultantName = string | null;

export type ConsultationRowMasterName = string | null;

export type ConsultationRowOutcomeReason = string | null;

export type ConsultationRowOutcomeDetail = string | null;

export type ConsultationRowOutcomeNote = string | null;

export type ConsultationRowOutcomeRecordedBy = string | null;

export type ConsultationRowNextAppointment = string | null;

/**
 * One consultation appointment, as R5-64's detail list reads it.
 */
export interface ConsultationRow {
  id: string;
  date: string;
  time: string;
  customerName: string;
  consultantName?: ConsultationRowConsultantName;
  masterName?: ConsultationRowMasterName;
  outletCode?: string;
  status: string;
  attachedToTreatment?: boolean;
  newCustomer?: boolean;
  converted?: boolean;
  refundedSameDay?: boolean;
  outcomeReason?: ConsultationRowOutcomeReason;
  outcomeDetail?: ConsultationRowOutcomeDetail;
  outcomeNote?: ConsultationRowOutcomeNote;
  outcomeRecordedBy?: ConsultationRowOutcomeRecordedBy;
  nextAppointment?: ConsultationRowNextAppointment;
}

export interface ConsultationStaff {
  id: string;
  name: string;
  role: string;
}

export interface ConsultationStaffEntry {
  id: string;
  name: string;
}

export type ConsultationStartResponseConsultationRemaining = number | null;

export type ConsultationStartResponseConsultationPackageState = string | null;

/**
 * OPS-24-07 — the consultation's actual start, recorded once.
 */
export interface ConsultationStartResponse {
  consultationStartedAt: string;
  consultationStartPressed: boolean;
  consultationRemaining?: ConsultationStartResponseConsultationRemaining;
  consultationPackageState?: ConsultationStartResponseConsultationPackageState;
  status: string;
  alreadyStarted: boolean;
}

export type ConsultationTodayOutStartTime = string | null;

export type ConsultationTodayOutOutletId = string | null;

export type ConsultationTodayOutOutletName = string | null;

export type ConsultationTodayOutConsultantName = string | null;

export type ConsultationTodayOutReason = string | null;

export type ConsultationTodayOutReasonDetail = string | null;

export type ConsultationTodayOutNote = string | null;

/**
 * SAL-23 — the customer's consultation today (Singapore day), filled by the
OS on Create Invoice. Nothing to choose: the invoice is matched to it by
the same-day rule (OPS-22).
 */
export interface ConsultationTodayOut {
  appointmentId: string;
  startTime?: ConsultationTodayOutStartTime;
  outletId?: ConsultationTodayOutOutletId;
  outletName?: ConsultationTodayOutOutletName;
  consultantName?: ConsultationTodayOutConsultantName;
  status: string;
  reason?: ConsultationTodayOutReason;
  reasonDetail?: ConsultationTodayOutReasonDetail;
  note?: ConsultationTodayOutNote;
}

export type ConsultationTodayResponseConsultation = ConsultationTodayOut | null;

export interface ConsultationTodayResponse {
  consultation?: ConsultationTodayResponseConsultation;
}

export type ContactBoxChannel = ContactChannel | null;

export type ContactBoxStaffName = string | null;

export type ContactBoxResult = string | null;

/**
 * One filled contact box on a row (LEA-01-03): the date of that contact;
hovering shows the channel and the staff name.
 */
export interface ContactBox {
  number: number;
  date: string;
  channel?: ContactBoxChannel;
  staffName?: ContactBoxStaffName;
  result?: ContactBoxResult;
}

/**
 * Which button was pressed first (LEA-03-06). Call first; WhatsApp when
she does not pick up.
 */
export type ContactChannel = typeof ContactChannel[keyof typeof ContactChannel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactChannel = {
  CALL: 'CALL',
  WHATSAPP: 'WHATSAPP',
} as const;

/**
 * Pink dots are contacts made by staff; grey dots are written by the
system (LEA-15-02).
 */
export type ContactKind = typeof ContactKind[keyof typeof ContactKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactKind = {
  STAFF: 'STAFF',
  SYSTEM: 'SYSTEM',
} as const;

/**
 * The ten result buttons, in LEA-04-01 order (most used first).
 */
export type ContactResult = typeof ContactResult[keyof typeof ContactResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactResult = {
  SENT_TEXT: 'SENT_TEXT',
  DIDNT_PICK_UP: 'DIDNT_PICK_UP',
  BOOKED: 'BOOKED',
  CONSULT_BOOKED: 'CONSULT_BOOKED',
  NOT_INTERESTED: 'NOT_INTERESTED',
  CONSIDERING: 'CONSIDERING',
  NO_SUITABLE_DATES: 'NO_SUITABLE_DATES',
  CLOSE: 'CLOSE',
  DNC: 'DNC',
  OTHER: 'OTHER',
} as const;

export type ContraEligiblePackageInvoiceNumber = string | null;

/**
 * One ACTIVE package a customer may trade sessions out of.

``unitValue`` is the package's per-session value (``amountPaid /
totalSessions``) rounded to cents, and ``paidRemaining`` is that unit value
times the sessions left. Both are rounded the same way, and the same way the
create path computes the offset, so the form's ``sessions x unitValue``
arithmetic reconciles to the cent against what the server charges.
 */
export interface ContraEligiblePackage {
  packageId: string;
  invoiceNumber?: ContraEligiblePackageInvoiceNumber;
  programName: string;
  totalSessions: number;
  usedSessions: number;
  remainingSessions: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paidRemaining: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unitValue: string;
  status: string;
}

/**
 * GET /finance/packages/{customerId}/contra-eligible — the customer's
tradeable packages plus the total value they represent.
 */
export interface ContraEligiblePackageListResponse {
  customerId: string;
  packages?: ContraEligiblePackage[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalRemainingValue: string;
}

/**
 * One package being contra'd, and how many of its sessions to surrender.
 */
export interface ContraLineCreate {
  packageId: string;
  sessionsToDeduct: number;
}

export type ContraLineResponseInvoiceNumber = string | null;

/**
 * What one contra line did: the value taken off this invoice, and the
state the surrendered-from package was left in.
 */
export interface ContraLineResponse {
  packageId: string;
  invoiceNumber?: ContraLineResponseInvoiceNumber;
  programName: string;
  sessionsDeducted: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unitValue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  contraValue: string;
  remainingSessions: number;
  status: string;
}

export type ContraSaleCreateCreditApplied = number | string;

export type ContraSaleCreateDiscountType = string | null;

export type ContraSaleCreateDiscountValue = number | string | null;

export type ContraSaleCreateDiscountReason = string | null;

export type ContraSaleCreateDiscountNote = string | null;

export type ContraSaleCreateGstAmountOverride = number | string | null;

export type ContraSaleCreateSaleDate = string | null;

export type ContraSaleCreatePackageExpiryDate = string | null;

export type ContraSaleCreateNotes = string | null;

export type ContraSaleCreateCustomerSignature = string | null;

export type ContraSaleCreateStaffSignature = string | null;

export type ContraSaleCreatePromotion = string | null;

export type ContraSaleCreateMedia = string | null;

export type ContraSaleCreateIhipAgreement = IHIPAgreementCreate | null;

/**
 * POST /finance/sales/contra — a checkout sale offset by traded sessions.

Mirrors ``SaleCreate`` minus the fields a contra cannot carry: there is no
``ihipPlanVariant`` (IHIP on a contra invoice is chosen with ``paymentKind`` and
always uses the 30% plan) and no
``appointmentId`` (a contra is a package trade, not a visit). ``customerId``
is required — the packages being traded belong to someone.
 */
export interface ContraSaleCreate {
  customerId: string;
  outletId: string;
  saleType?: string;
  lines?: SaleLineCreate[];
  payments?: PaymentCreate[];
  creditApplied?: ContraSaleCreateCreditApplied;
  discountType?: ContraSaleCreateDiscountType;
  discountValue?: ContraSaleCreateDiscountValue;
  discountReason?: ContraSaleCreateDiscountReason;
  discountNote?: ContraSaleCreateDiscountNote;
  gstAmountOverride?: ContraSaleCreateGstAmountOverride;
  saleDate?: ContraSaleCreateSaleDate;
  packageExpiryDate?: ContraSaleCreatePackageExpiryDate;
  notes?: ContraSaleCreateNotes;
  customerSignature?: ContraSaleCreateCustomerSignature;
  staffSignature?: ContraSaleCreateStaffSignature;
  contraLines?: ContraLineCreate[];
  servedBy?: ServedByCreate[];
  promotion?: ContraSaleCreatePromotion;
  media?: ContraSaleCreateMedia;
  paymentKind?: string;
  ihipAgreement?: ContraSaleCreateIhipAgreement;
}

export type ContraSaleResponseCustomerId = string | null;

export type ContraSaleResponseCustomerName = string | null;

export type ContraSaleResponseInvoiceNumber = string | null;

export type ContraSaleResponsePresalesNumber = string | null;

export type ContraSaleResponseAcknowledgedById = string | null;

export type ContraSaleResponseAcknowledgedAt = string | null;

export type ContraSaleResponseContraAmount = string | null;

export type ContraSaleResponseRelatedSaleId = string | null;

export type ContraSaleResponseCreatedById = string | null;

export type ContraSaleResponseNotes = string | null;

export type ContraSaleResponseCustomerSignature = string | null;

export type ContraSaleResponseStaffSignature = string | null;

export type ContraSaleResponseCreatedAt = string | null;

export type ContraSaleResponseUpdatedAt = string | null;

export type ContraSaleResponseDiscountType = string | null;

export type ContraSaleResponseDiscountValue = string | null;

export type ContraSaleResponseDiscountReason = string | null;

export type ContraSaleResponseDiscountNote = string | null;

export type ContraSaleResponseDiscountById = string | null;

export type ContraSaleResponseFreeReason = string | null;

export type ContraSaleResponseFreeNote = string | null;

export type ContraSaleResponseSaleTypeAmendedFrom = string | null;

export type ContraSaleResponseSaleTypeAmendedById = string | null;

export type ContraSaleResponseSaleTypeAmendedAt = string | null;

export type ContraSaleResponseSaleTypeAmendReason = string | null;

export type ContraSaleResponsePromotion = string | null;

export type ContraSaleResponseMedia = string | null;

/**
 * POST /finance/sales/contra — the new sale plus its contra trail.
 */
export interface ContraSaleResponse {
  id: string;
  customerId?: ContraSaleResponseCustomerId;
  customerName?: ContraSaleResponseCustomerName;
  outletId: string;
  saleType: string;
  invoiceNumber?: ContraSaleResponseInvoiceNumber;
  presalesNumber?: ContraSaleResponsePresalesNumber;
  acknowledgedById?: ContraSaleResponseAcknowledgedById;
  acknowledgedAt?: ContraSaleResponseAcknowledgedAt;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  subtotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gstAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  creditApplied: string;
  contraAmount?: ContraSaleResponseContraAmount;
  status: string;
  paymentKind?: string;
  relatedSaleId?: ContraSaleResponseRelatedSaleId;
  createdById?: ContraSaleResponseCreatedById;
  notes?: ContraSaleResponseNotes;
  customerSignature?: ContraSaleResponseCustomerSignature;
  staffSignature?: ContraSaleResponseStaffSignature;
  createdAt?: ContraSaleResponseCreatedAt;
  updatedAt?: ContraSaleResponseUpdatedAt;
  discountType?: ContraSaleResponseDiscountType;
  discountValue?: ContraSaleResponseDiscountValue;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  discountAmount?: string;
  discountReason?: ContraSaleResponseDiscountReason;
  discountNote?: ContraSaleResponseDiscountNote;
  discountById?: ContraSaleResponseDiscountById;
  freeReason?: ContraSaleResponseFreeReason;
  freeNote?: ContraSaleResponseFreeNote;
  gstOverridden?: boolean;
  saleTypeAmendedFrom?: ContraSaleResponseSaleTypeAmendedFrom;
  saleTypeAmendedById?: ContraSaleResponseSaleTypeAmendedById;
  saleTypeAmendedAt?: ContraSaleResponseSaleTypeAmendedAt;
  saleTypeAmendReason?: ContraSaleResponseSaleTypeAmendReason;
  promotion?: ContraSaleResponsePromotion;
  media?: ContraSaleResponseMedia;
  contraLines?: ContraLineResponse[];
}

/**
 * GET /finance/credits/{customerId} — non-expired balance + full ledger.
 */
export interface CreditBalanceResponse {
  customerId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balance: string;
  ledger?: CreditLedgerResponse[];
}

export type CreditEarnCreateSubType = string | null;

export type CreditEarnCreateAmount = number | string | null;

export type CreditEarnCreateReason = string | null;

/**
 * POST /finance/credits/{customerId}/earn — grant a credit (FIN-D1).

``amount`` is optional: when omitted the catalog (§8.6) value is looked up
from ``(category, subType)``. ``subType`` selects the catalog row where a
category has several (e.g. REFERRAL → ``YA_20``).
 */
export interface CreditEarnCreate {
  category: string;
  subType?: CreditEarnCreateSubType;
  amount?: CreditEarnCreateAmount;
  reason?: CreditEarnCreateReason;
}

export type CreditLedgerResponseCategory = string | null;

export type CreditLedgerResponseSaleId = string | null;

export type CreditLedgerResponseInvoiceNumber = string | null;

export type CreditLedgerResponseReason = string | null;

export type CreditLedgerResponseIssuedAt = string | null;

export type CreditLedgerResponseExpiresAt = string | null;

export type CreditLedgerResponseGrantedById = string | null;

export type CreditLedgerResponseCreatedAt = string | null;

/**
 * A single persisted CreditLedger row (§5.6).
 */
export interface CreditLedgerResponse {
  id: string;
  customerId: string;
  entryType: string;
  category?: CreditLedgerResponseCategory;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  saleId?: CreditLedgerResponseSaleId;
  invoiceNumber?: CreditLedgerResponseInvoiceNumber;
  reason?: CreditLedgerResponseReason;
  issuedAt?: CreditLedgerResponseIssuedAt;
  expiresAt?: CreditLedgerResponseExpiresAt;
  grantedById?: CreditLedgerResponseGrantedById;
  createdAt?: CreditLedgerResponseCreatedAt;
}

export type CreditNoteCreateAmount = number | string;

export type CreditNoteCreateIssuedDate = string | null;

export type CreditNoteCreateExpiryDate = string | null;

export type CreditNoteCreateCreditType = string | null;

export type CreditNoteCreateRemarks = string | null;

export type CreditNoteCreateOutletId = string | null;

export type CreditNoteCreateRevokesCreditNoteId = string | null;

/**
 * POST /finance/credit-notes — issue or redeem store credit.
 */
export interface CreditNoteCreate {
  type: string;
  customerId: string;
  amount: CreditNoteCreateAmount;
  issuedDate?: CreditNoteCreateIssuedDate;
  expiryDate?: CreditNoteCreateExpiryDate;
  creditType?: CreditNoteCreateCreditType;
  remarks?: CreditNoteCreateRemarks;
  outletId?: CreditNoteCreateOutletId;
  revokesCreditNoteId?: CreditNoteCreateRevokesCreditNoteId;
}

export interface CreditNoteListResponse {
  items?: CreditNoteResponse[];
}

export type CreditNoteResponseExpiryDate = string | null;

export type CreditNoteResponseCreditType = string | null;

export type CreditNoteResponseRemarks = string | null;

export type CreditNoteResponseUsed = string | null;

export type CreditNoteResponseRevoked = string | null;

export type CreditNoteResponseAvailable = string | null;

export type CreditNoteResponseNoteStatus = string | null;

export type CreditNoteResponseRevokesCreditNoteId = string | null;

export type CreditNoteResponseRevokesCreditNoteNumber = string | null;

export type CreditNoteResponseRevokedAfterUse = string | null;

export type CreditNoteResponseOutletId = string | null;

export type CreditNoteResponseOutletName = string | null;

/**
 * A persisted credit note. ``customer_name`` and ``new_balance`` are
denormalized for display — the list page must not fan out per row.
 */
export interface CreditNoteResponse {
  id: string;
  creditNoteNumber: string;
  type: string;
  customerId: string;
  customerName: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  issuedDate: string;
  expiryDate?: CreditNoteResponseExpiryDate;
  creditType?: CreditNoteResponseCreditType;
  remarks?: CreditNoteResponseRemarks;
  status?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  newBalance: string;
  createdAt: string;
  used?: CreditNoteResponseUsed;
  revoked?: CreditNoteResponseRevoked;
  available?: CreditNoteResponseAvailable;
  noteStatus?: CreditNoteResponseNoteStatus;
  revokesCreditNoteId?: CreditNoteResponseRevokesCreditNoteId;
  revokesCreditNoteNumber?: CreditNoteResponseRevokesCreditNoteNumber;
  revokedAfterUse?: CreditNoteResponseRevokedAfterUse;
  outletId?: CreditNoteResponseOutletId;
  outletName?: CreditNoteResponseOutletName;
}

/**
 * GET /finance/credit-rates — the full credit earn-value catalog.
 */
export interface CreditRateListResponse {
  rates: CreditRateResponse[];
}

export type CreditRateResponseSubType = string | null;

/**
 * An admin-editable §8.6 credit earn-value row.
 */
export interface CreditRateResponse {
  id: string;
  category: string;
  subType?: CreditRateResponseSubType;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
}

export type CreditRateUpdateAmount = number | string;

/**
 * PATCH /finance/credit-rates/{id} — set a new earn amount.
 */
export interface CreditRateUpdate {
  amount: CreditRateUpdateAmount;
}

export type CreditReasonItemInputKey = string | null;

export type CreditReasonItemInputCap = number | string | null;

/**
 * V3 — one Customer Credit form reason: its name, what it is booked as,
its cap (``None`` = no cap) and whether the form offers it. ``key`` is
empty for a reason HQ is adding.
 */
export interface CreditReasonItemInput {
  key?: CreditReasonItemInputKey;
  label: string;
  category: string;
  cap?: CreditReasonItemInputCap;
  active?: boolean;
}

export type CreditReasonItemOutputKey = string | null;

export type CreditReasonItemOutputCap = string | null;

/**
 * V3 — one Customer Credit form reason: its name, what it is booked as,
its cap (``None`` = no cap) and whether the form offers it. ``key`` is
empty for a reason HQ is adding.
 */
export interface CreditReasonItemOutput {
  key?: CreditReasonItemOutputKey;
  label: string;
  category: string;
  cap?: CreditReasonItemOutputCap;
  active?: boolean;
}

export type CreditReasonListCategories = {[key: string]: string};

export interface CreditReasonList {
  reasons: CreditReasonItemOutput[];
  categories: CreditReasonListCategories;
}

/**
 * The whole list, in form order.
 */
export interface CreditReasonUpdate {
  reasons: CreditReasonItemInput[];
}

export type CreditRedeemDraftRequestedAmount = number | string;

/**
 * POST /finance/credits/{customerId}/redeem/validate request — a lightweight
sale draft the T&C check (§8.7) reads. ``lineTypes`` are the SaleLine.lineType
values on the draft; ``hasPromoLine`` flags a promotion line (e.g.
PROMO_1FOR1) for the not-stackable rule.
 */
export interface CreditRedeemDraft {
  saleType: string;
  lineTypes?: string[];
  hasPromoLine?: boolean;
  requestedAmount: CreditRedeemDraftRequestedAmount;
}

/**
 * GET/POST /finance/credits/{customerId}/redeem/validate response — the
enforced §8.7 T&C verdict (validation only, no write).
 */
export interface CreditRedeemValidationResponse {
  allowed: boolean;
  reasons?: string[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  maxRedeemable: string;
}

export type CriterionCheckHave = number | null;

export type CriterionCheckNeed = number | null;

export interface CriterionCheck {
  met: boolean;
  have?: CriterionCheckHave;
  need?: CriterionCheckNeed;
}

export interface CustomerAgeBand {
  key: string;
  label: string;
  count?: number;
  percent?: number;
}

export type CustomerAgeGroupSummaryAverageAge = number | null;

export interface CustomerAgeGroupSummary {
  asOf: string;
  total?: number;
  withDob?: number;
  averageAge?: CustomerAgeGroupSummaryAverageAge;
  bands?: CustomerAgeBand[];
}

export type CustomerAnalyticsResponseByGender = {[key: string]: number};

export type CustomerAnalyticsResponseByMembership = {[key: string]: number};

export type CustomerAnalyticsResponseByReferralSource = {[key: string]: number};

export type CustomerAnalyticsResponseByEnrollmentMonth = {[key: string]: number};

export type CustomerAnalyticsResponseByAgeGroup = CustomerAgeGroupSummary | null;

/**
 * Response from ``GET /api/reports/customers``.

The ``by*`` breakdowns are open-ended maps - gender, membership and referral
source are free text on ``Customer``, so their keys are whatever the data
holds, plus ``report_service.NOT_SPECIFIED_LABEL`` for the unfilled ones.
 */
export interface CustomerAnalyticsResponse {
  period: OperationsPeriod;
  total?: number;
  active?: number;
  inactive?: number;
  newThisPeriod?: number;
  byGender?: CustomerAnalyticsResponseByGender;
  byMembership?: CustomerAnalyticsResponseByMembership;
  byReferralSource?: CustomerAnalyticsResponseByReferralSource;
  byEnrollmentMonth?: CustomerAnalyticsResponseByEnrollmentMonth;
  upcomingBirthdays?: CustomerBirthdayEntry[];
  byAgeGroup?: CustomerAnalyticsResponseByAgeGroup;
}

/**
 * Reduced appointment shape returned from ``GET /api/customers``.
 */
export interface CustomerAppointmentListItem {
  date: string;
}

export type CustomerAppointmentProgramSummaryNameKo = string | null;

export type CustomerAppointmentProgramSummaryNameZh = string | null;

export type CustomerAppointmentProgramSummaryNameVi = string | null;

/**
 * Program summary embedded in customer appointment history.
 */
export interface CustomerAppointmentProgramSummary {
  id: string;
  name: string;
  nameKo?: CustomerAppointmentProgramSummaryNameKo;
  nameZh?: CustomerAppointmentProgramSummaryNameZh;
  nameVi?: CustomerAppointmentProgramSummaryNameVi;
}

export type CustomerAppointmentResponseProgramId = string | null;

export type CustomerAppointmentResponsePackageId = string | null;

export type CustomerAppointmentResponseRoomId = string | null;

export type CustomerAppointmentResponseLinkedAppointmentId = string | null;

export type CustomerAppointmentResponseConsultantId = string | null;

export type CustomerAppointmentResponseMasterId = string | null;

export type CustomerAppointmentResponseNotes = string | null;

export type CustomerAppointmentResponseCreatedById = string | null;

export type CustomerAppointmentResponseConfirmedByStaffId = string | null;

export type CustomerAppointmentResponseConfirmedAt = string | null;

export type CustomerAppointmentResponseActualStartTime = string | null;

export type CustomerAppointmentResponseActualStartLockedAt = string | null;

export type CustomerAppointmentResponseProgram = CustomerAppointmentProgramSummary | null;

/**
 * Appointment history row embedded in customer detail.
 */
export interface CustomerAppointmentResponse {
  id: string;
  customerId: string;
  outletId: string;
  programId?: CustomerAppointmentResponseProgramId;
  packageId?: CustomerAppointmentResponsePackageId;
  roomId?: CustomerAppointmentResponseRoomId;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  appointmentType: string;
  linkedAppointmentId?: CustomerAppointmentResponseLinkedAppointmentId;
  consultantId?: CustomerAppointmentResponseConsultantId;
  masterId?: CustomerAppointmentResponseMasterId;
  notes?: CustomerAppointmentResponseNotes;
  createdById?: CustomerAppointmentResponseCreatedById;
  confirmedByStaffId?: CustomerAppointmentResponseConfirmedByStaffId;
  confirmedAt?: CustomerAppointmentResponseConfirmedAt;
  actualStartTime?: CustomerAppointmentResponseActualStartTime;
  actualStartLockedAt?: CustomerAppointmentResponseActualStartLockedAt;
  createdAt: string;
  updatedAt: string;
  program?: CustomerAppointmentResponseProgram;
  outlet: OutletSummary;
}

/**
 * GET /customers/{id}/balance-mark — the chip beside the name and the red
card above the tabs (CUS-07). Read only; nothing here changes a balance.
 */
export interface CustomerBalanceMarkResponse {
  customerId: string;
  asOf: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalOutstanding?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  invoiceOutstanding?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  ihipOutstanding?: string;
  overdue?: boolean;
  invoices?: BalanceMarkInvoice[];
  ihipPlans?: BalanceMarkIhipPlan[];
}

export interface CustomerBalancesResponse {
  items: CustomerPackageBalance[];
}

export interface CustomerBirthdayEntry {
  id: string;
  name: string;
  dob: string;
  daysUntil: number;
}

/**
 * DSH-11-05 right column 'Customer care · both outlets' — counts only.
 */
export interface CustomerCareBox {
  unsatisfiedToday?: number;
  openComplaints?: number;
  openRequests?: number;
}

export type CustomerConsentResponseId = string | null;

export type CustomerConsentResponseCustomerId = string | null;

export type CustomerConsentResponseSignedByName = string | null;

export type CustomerConsentResponseSignedAt = string | null;

export type CustomerConsentResponseCreatedAt = string | null;

export type CustomerConsentResponseUpdatedAt = string | null;

/**
 * Consent response shape for ``GET`` and ``PUT`` consent routes.

``GET`` returns a stub (``{dataPrivacy: false, marketing: false}``) when no
row exists yet, mirroring the survey-stub pattern; the id/customerId/
timestamp fields are then null.
 */
export interface CustomerConsentResponse {
  id?: CustomerConsentResponseId;
  customerId?: CustomerConsentResponseCustomerId;
  dataPrivacy: boolean;
  marketing: boolean;
  signedByName?: CustomerConsentResponseSignedByName;
  signedAt?: CustomerConsentResponseSignedAt;
  createdAt?: CustomerConsentResponseCreatedAt;
  updatedAt?: CustomerConsentResponseUpdatedAt;
}

export type CustomerConsentSummarySignedAt = string | null;

/**
 * Lightweight consent badge embedded in customer detail (A8).

Lets the docket render a consent badge without a second round-trip. Mirrors
the GET-consent stub when no row exists yet (``dataPrivacy``/``marketing``
default false, ``signedAt`` null).
 */
export interface CustomerConsentSummary {
  dataPrivacy?: boolean;
  marketing?: boolean;
  signedAt?: CustomerConsentSummarySignedAt;
}

export type CustomerConsentUpsertSignedByName = string | null;

/**
 * Request body for ``PUT /api/customers/[id]/consent``.
 */
export interface CustomerConsentUpsert {
  dataPrivacy: boolean;
  marketing: boolean;
  signedByName?: CustomerConsentUpsertSignedByName;
}

export type CustomerCreateFirstName = string | null;

export type CustomerCreateLastName = string | null;

export type CustomerCreateEmail = string | null;

export type CustomerCreateDob = string | null;

export type CustomerCreateGender = string | null;

export type CustomerCreateNationality = string | null;

export type CustomerCreateMaritalStatus = string | null;

export type CustomerCreateAddress = string | null;

export type CustomerCreateNricLast4 = string | null;

export type CustomerCreateReferralSource = string | null;

export type CustomerCreateReferralDetail = string | null;

export type CustomerCreatePhotoUrl = string | null;

export type CustomerCreatePrefOutletId = string | null;

export type CustomerCreateSpecialRequests = string | null;

export type CustomerCreateNotes = string | null;

export type CustomerCreateCautionNotes = string | null;

export type CustomerCreateCustomerType = string | null;

export type CustomerCreateIsActive = boolean | null;

/**
 * Request body for ``POST /api/customers``.
 */
export interface CustomerCreate {
  name: string;
  firstName?: CustomerCreateFirstName;
  lastName?: CustomerCreateLastName;
  phone: string;
  email?: CustomerCreateEmail;
  dob?: CustomerCreateDob;
  gender?: CustomerCreateGender;
  nationality?: CustomerCreateNationality;
  maritalStatus?: CustomerCreateMaritalStatus;
  address?: CustomerCreateAddress;
  nricLast4?: CustomerCreateNricLast4;
  referralSource?: CustomerCreateReferralSource;
  referralDetail?: CustomerCreateReferralDetail;
  photoUrl?: CustomerCreatePhotoUrl;
  prefOutletId?: CustomerCreatePrefOutletId;
  specialRequests?: CustomerCreateSpecialRequests;
  notes?: CustomerCreateNotes;
  cautionNotes?: CustomerCreateCautionNotes;
  customerType?: CustomerCreateCustomerType;
  isActive?: CustomerCreateIsActive;
}

export type CustomerCreditNoteBalanceCreditType = string | null;

export type CustomerCreditNoteBalanceExpiryDate = string | null;

/**
 * SAL-17-11 / SAL-38-03 — one credit note the customer holds.
 */
export interface CustomerCreditNoteBalance {
  id: string;
  creditNoteNumber: string;
  creditType?: CustomerCreditNoteBalanceCreditType;
  issuedDate: string;
  expiryDate?: CustomerCreditNoteBalanceExpiryDate;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  issued: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  used: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  revoked: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  available: string;
  noteStatus: string;
}

export interface CustomerCreditNoteBalanceList {
  customerId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  availableTotal: string;
  items?: CustomerCreditNoteBalance[];
}

export type CustomerDetailResponseFirstName = string | null;

export type CustomerDetailResponseLastName = string | null;

export type CustomerDetailResponseEmail = string | null;

export type CustomerDetailResponseDob = string | null;

export type CustomerDetailResponseGender = string | null;

export type CustomerDetailResponseNationality = string | null;

export type CustomerDetailResponseMaritalStatus = string | null;

export type CustomerDetailResponseAddress = string | null;

export type CustomerDetailResponseNricLast4 = string | null;

export type CustomerDetailResponseReferralSource = string | null;

export type CustomerDetailResponseReferralDetail = string | null;

export type CustomerDetailResponsePhotoUrl = string | null;

export type CustomerDetailResponsePrefOutletId = string | null;

export type CustomerDetailResponseSpecialRequests = string | null;

export type CustomerDetailResponseNotes = string | null;

export type CustomerDetailResponseCautionNotes = string | null;

export type CustomerDetailResponseCustomerType = string | null;

export type CustomerDetailResponseIsActive = boolean | null;

export type CustomerDetailResponseCustomerKind = string | null;

export type CustomerDetailResponseMembership = string | null;

export type CustomerDetailResponseSourceRef = string | null;

export type CustomerDetailResponseRegisteredOutletName = string | null;

export type CustomerDetailResponseRegisteredOutletId = string | null;

export type CustomerDetailResponsePrefOutlet = OutletSummary | null;

/**
 * Full customer detail response from ``GET /api/customers/[id]``.
 */
export interface CustomerDetailResponse {
  name: string;
  firstName?: CustomerDetailResponseFirstName;
  lastName?: CustomerDetailResponseLastName;
  phone: string;
  email?: CustomerDetailResponseEmail;
  dob?: CustomerDetailResponseDob;
  gender?: CustomerDetailResponseGender;
  nationality?: CustomerDetailResponseNationality;
  maritalStatus?: CustomerDetailResponseMaritalStatus;
  address?: CustomerDetailResponseAddress;
  nricLast4?: CustomerDetailResponseNricLast4;
  referralSource?: CustomerDetailResponseReferralSource;
  referralDetail?: CustomerDetailResponseReferralDetail;
  photoUrl?: CustomerDetailResponsePhotoUrl;
  prefOutletId?: CustomerDetailResponsePrefOutletId;
  specialRequests?: CustomerDetailResponseSpecialRequests;
  notes?: CustomerDetailResponseNotes;
  cautionNotes?: CustomerDetailResponseCautionNotes;
  customerType?: CustomerDetailResponseCustomerType;
  isActive?: CustomerDetailResponseIsActive;
  customerKind?: CustomerDetailResponseCustomerKind;
  membership?: CustomerDetailResponseMembership;
  sourceRef?: CustomerDetailResponseSourceRef;
  registeredOutletName?: CustomerDetailResponseRegisteredOutletName;
  registeredOutletId?: CustomerDetailResponseRegisteredOutletId;
  registeredAtHq?: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
  prefOutlet?: CustomerDetailResponsePrefOutlet;
  preferences?: CustomerPreferenceResponse[];
  packages?: CustomerPackageResponse[];
  appointments?: CustomerAppointmentResponse[];
  preferredTherapists?: CustomerTherapistSummary[];
  excludedTherapists?: CustomerTherapistSummary[];
  consent?: CustomerConsentSummary;
}

export interface CustomerEnrollmentByMediaResponse {
  dateFrom: string;
  dateTo: string;
  fields: string[];
  summary: EnrollmentSummaryRow[];
  details: EnrollmentDetailGroup[];
  total: number;
}

/**
 * MKT-02-12 — new customers between two dates, per Promotion of her first
invoice (MKT-02-03a).
 */
export interface CustomerEnrollmentByPromotionResponse {
  dateFrom: string;
  dateTo: string;
  fields: string[];
  summary: PromotionEnrollmentSummaryRow[];
  details: PromotionEnrollmentDetailGroup[];
  total: number;
}

export type CustomerFieldBulkValuesResponseValues = {[key: string]: {[key: string]: string}};

/**
 * Custom-field values for several customers: customer id -> field id -> value.
 */
export interface CustomerFieldBulkValuesResponse {
  values?: CustomerFieldBulkValuesResponseValues;
}

export type CustomerFieldCreateDataType = typeof CustomerFieldCreateDataType[keyof typeof CustomerFieldCreateDataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerFieldCreateDataType = {
  TEXT: 'TEXT',
  TEXT_MULTI: 'TEXT_MULTI',
  EMAIL: 'EMAIL',
  SELECT: 'SELECT',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  YES_NO: 'YES_NO',
} as const;

export type CustomerFieldCreateDescription = string | null;

export interface CustomerFieldCreate {
  name: string;
  groupName: string;
  dataType: CustomerFieldCreateDataType;
  description?: CustomerFieldCreateDescription;
  options?: string[];
  inSummary?: boolean;
}

export interface CustomerFieldListResponse {
  items: CustomerFieldResponse[];
}

/**
 * Every field id in its new order (built-in and custom together).
 */
export interface CustomerFieldReorder {
  ids: string[];
}

export type CustomerFieldResponseBuiltinKey = string | null;

export type CustomerFieldResponseDataType = typeof CustomerFieldResponseDataType[keyof typeof CustomerFieldResponseDataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerFieldResponseDataType = {
  TEXT: 'TEXT',
  TEXT_MULTI: 'TEXT_MULTI',
  EMAIL: 'EMAIL',
  SELECT: 'SELECT',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  YES_NO: 'YES_NO',
} as const;

export type CustomerFieldResponseDescription = string | null;

export interface CustomerFieldResponse {
  id: string;
  builtinKey?: CustomerFieldResponseBuiltinKey;
  isBuiltin: boolean;
  name: string;
  groupName: string;
  dataType: CustomerFieldResponseDataType;
  description?: CustomerFieldResponseDescription;
  options?: string[];
  inSummary: boolean;
  sortOrder: number;
  isActive: boolean;
}

export type CustomerFieldUpdateName = string | null;

export type CustomerFieldUpdateGroupName = string | null;

export type CustomerFieldUpdateDataType = 'TEXT' | 'TEXT_MULTI' | 'EMAIL' | 'SELECT' | 'DATE' | 'NUMBER' | 'YES_NO' | null;

export type CustomerFieldUpdateDescription = string | null;

export type CustomerFieldUpdateOptions = string[] | null;

export type CustomerFieldUpdateInSummary = boolean | null;

export type CustomerFieldUpdateSortOrder = number | null;

export type CustomerFieldUpdateIsActive = boolean | null;

/**
 * Built-in fields accept only description, groupName, inSummary, sortOrder.
 */
export interface CustomerFieldUpdate {
  name?: CustomerFieldUpdateName;
  groupName?: CustomerFieldUpdateGroupName;
  dataType?: CustomerFieldUpdateDataType;
  description?: CustomerFieldUpdateDescription;
  options?: CustomerFieldUpdateOptions;
  inSummary?: CustomerFieldUpdateInSummary;
  sortOrder?: CustomerFieldUpdateSortOrder;
  isActive?: CustomerFieldUpdateIsActive;
}

export type CustomerFieldValuesResponseValues = {[key: string]: string};

/**
 * Custom-field values for one customer, keyed by field id.
 */
export interface CustomerFieldValuesResponse {
  values?: CustomerFieldValuesResponseValues;
}

export type CustomerFieldValuesUpdateValues = {[key: string]: string};

/**
 * Field id -> value. An empty string clears the value.
 */
export interface CustomerFieldValuesUpdate {
  values?: CustomerFieldValuesUpdateValues;
}

export type CustomerGroupChipDetail = string | null;

export interface CustomerGroupChip {
  groupId: string;
  name: string;
  label: string;
  detail?: CustomerGroupChipDetail;
  groupType: string;
  joinedAt: string;
}

export type CustomerGroupChipItemDetail = string | null;

/**
 * One group chip under a customer's name (CUS-09-10).
 */
export interface CustomerGroupChipItem {
  groupId: string;
  name: string;
  label: string;
  detail?: CustomerGroupChipItemDetail;
  groupType: string;
}

export type CustomerGroupCreateConditionKind = string | null;

export type CustomerGroupCreateConditionParams = { [key: string]: unknown };

export type CustomerGroupCreateChipLabel = string | null;

export interface CustomerGroupCreate {
  name: string;
  groupType: string;
  conditionKind?: CustomerGroupCreateConditionKind;
  conditionParams?: CustomerGroupCreateConditionParams;
  chipLabel?: CustomerGroupCreateChipLabel;
}

export type CustomerGroupEventOutDetail = { [key: string]: unknown };

export type CustomerGroupEventOutActor = string | null;

export interface CustomerGroupEventOut {
  id: string;
  action: string;
  detail?: CustomerGroupEventOutDetail;
  actor?: CustomerGroupEventOutActor;
  createdAt: string;
}

export interface CustomerGroupListResponse {
  groups?: CustomerGroupOut[];
  total?: number;
  shown?: number;
  kinds?: ConditionKindOut[];
}

export interface CustomerGroupMemberRequest {
  customerId: string;
}

export type CustomerGroupOutConditionKind = string | null;

export type CustomerGroupOutConditionParams = { [key: string]: unknown };

export type CustomerGroupOutBuiltinKey = string | null;

export type CustomerGroupOutLastCheckedAt = string | null;

export type CustomerGroupOutLastChangedBy = string | null;

export interface CustomerGroupOut {
  id: string;
  name: string;
  groupType: string;
  conditionKind?: CustomerGroupOutConditionKind;
  conditionParams?: CustomerGroupOutConditionParams;
  conditionText: string;
  chipLabel: string;
  status: string;
  builtinKey?: CustomerGroupOutBuiltinKey;
  customers?: number;
  everHadCustomers?: boolean;
  lastCheckedAt?: CustomerGroupOutLastCheckedAt;
  lastChangedAt: string;
  lastChangedBy?: CustomerGroupOutLastChangedBy;
}

/**
 * 'n joined, m left' after a Save or Active (CUS-09-07 (3)).
 */
export interface CustomerGroupRecheckResult {
  group: CustomerGroupOut;
  joined?: number;
  left?: number;
}

export interface CustomerGroupStatusUpdate {
  status: string;
}

export type CustomerGroupUpdateConditionParams = { [key: string]: unknown };

export type CustomerGroupUpdateChipLabel = string | null;

export interface CustomerGroupUpdate {
  name: string;
  conditionParams?: CustomerGroupUpdateConditionParams;
  chipLabel?: CustomerGroupUpdateChipLabel;
}

/**
 * GET /customers/{id}/groups — her chips, her past stays and the manual
groups HQ can still add her to.
 */
export interface CustomerGroupsResponse {
  customerId: string;
  groups?: CustomerGroupChip[];
  past?: CustomerPastGroup[];
  manualChoices?: ManualGroupChoice[];
}

/**
 * GET /finance/customers/{id}/invoices — newest first.
 */
export interface CustomerInvoiceListResponse {
  invoices?: CustomerInvoiceRow[];
}

export type CustomerInvoiceRowInvoiceNumber = string | null;

export type CustomerInvoiceRowPresalesNumber = string | null;

export type CustomerInvoiceRowCreatedAt = string | null;

export type CustomerInvoiceRowOutletCode = string | null;

export type CustomerInvoiceRowVoidBlockReason = string | null;

export type CustomerInvoiceRowExpiryDate = string | null;

export type CustomerInvoiceRowSessionsTotal = number | null;

export type CustomerInvoiceRowSessionsUsed = number | null;

export type CustomerInvoiceRowPackageId = string | null;

/**
 * N-02 — one row of the customer drawer's Invoices tab.
 */
export interface CustomerInvoiceRow {
  id: string;
  invoiceNumber?: CustomerInvoiceRowInvoiceNumber;
  presalesNumber?: CustomerInvoiceRowPresalesNumber;
  createdAt?: CustomerInvoiceRowCreatedAt;
  saleType: string;
  status: string;
  outletCode?: CustomerInvoiceRowOutletCode;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paidAmount: string;
  items?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding?: string;
  voidPending?: boolean;
  voidBlockReason?: CustomerInvoiceRowVoidBlockReason;
  expiryDate?: CustomerInvoiceRowExpiryDate;
  sessionsTotal?: CustomerInvoiceRowSessionsTotal;
  sessionsUsed?: CustomerInvoiceRowSessionsUsed;
  expiredWithSessionsLeft?: boolean;
  packageId?: CustomerInvoiceRowPackageId;
}

export type CustomerListItemResponseFirstName = string | null;

export type CustomerListItemResponseLastName = string | null;

export type CustomerListItemResponseEmail = string | null;

export type CustomerListItemResponseDob = string | null;

export type CustomerListItemResponseGender = string | null;

export type CustomerListItemResponseNationality = string | null;

export type CustomerListItemResponseMaritalStatus = string | null;

export type CustomerListItemResponseAddress = string | null;

export type CustomerListItemResponseNricLast4 = string | null;

export type CustomerListItemResponseReferralSource = string | null;

export type CustomerListItemResponseReferralDetail = string | null;

export type CustomerListItemResponsePhotoUrl = string | null;

export type CustomerListItemResponsePrefOutletId = string | null;

export type CustomerListItemResponseSpecialRequests = string | null;

export type CustomerListItemResponseNotes = string | null;

export type CustomerListItemResponseCautionNotes = string | null;

export type CustomerListItemResponseCustomerType = string | null;

export type CustomerListItemResponseIsActive = boolean | null;

export type CustomerListItemResponseCustomerKind = string | null;

export type CustomerListItemResponseMembership = string | null;

export type CustomerListItemResponseSourceRef = string | null;

export type CustomerListItemResponseRegisteredOutletName = string | null;

export type CustomerListItemResponseRegisteredOutletId = string | null;

export type CustomerListItemResponsePrefOutlet = OutletSummary | null;

export type CustomerListItemResponseLastVisit = string | null;

/**
 * Single customer row from ``GET /api/customers``.
 */
export interface CustomerListItemResponse {
  name: string;
  firstName?: CustomerListItemResponseFirstName;
  lastName?: CustomerListItemResponseLastName;
  phone: string;
  email?: CustomerListItemResponseEmail;
  dob?: CustomerListItemResponseDob;
  gender?: CustomerListItemResponseGender;
  nationality?: CustomerListItemResponseNationality;
  maritalStatus?: CustomerListItemResponseMaritalStatus;
  address?: CustomerListItemResponseAddress;
  nricLast4?: CustomerListItemResponseNricLast4;
  referralSource?: CustomerListItemResponseReferralSource;
  referralDetail?: CustomerListItemResponseReferralDetail;
  photoUrl?: CustomerListItemResponsePhotoUrl;
  prefOutletId?: CustomerListItemResponsePrefOutletId;
  specialRequests?: CustomerListItemResponseSpecialRequests;
  notes?: CustomerListItemResponseNotes;
  cautionNotes?: CustomerListItemResponseCautionNotes;
  customerType?: CustomerListItemResponseCustomerType;
  isActive?: CustomerListItemResponseIsActive;
  customerKind?: CustomerListItemResponseCustomerKind;
  membership?: CustomerListItemResponseMembership;
  sourceRef?: CustomerListItemResponseSourceRef;
  registeredOutletName?: CustomerListItemResponseRegisteredOutletName;
  registeredOutletId?: CustomerListItemResponseRegisteredOutletId;
  registeredAtHq?: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
  prefOutlet?: CustomerListItemResponsePrefOutlet;
  packages?: CustomerPackageListItem[];
  groups?: CustomerGroupChipItem[];
  appointments?: CustomerAppointmentListItem[];
  activePackages: number;
  lastVisit?: CustomerListItemResponseLastVisit;
}

/**
 * Paginated customer list response.
 */
export interface CustomerListResponse {
  customers?: CustomerListItemResponse[];
  total: number;
  limit: number;
  offset: number;
}

/**
 * How many rows each re-pointed table contributed to the merge.

Named fields rather than a free-form map so the generated TS client can type
the confirmation summary. Every key counts rows that actually MOVED. Rows the
survivor already has its own version of — a preference for the same staff, a
lifestyle survey, a consent record — stay behind on the archived duplicate
and are counted as 0; they are never deleted.
 */
export interface CustomerMergeCounts {
  appointments?: number;
  sales?: number;
  packages?: number;
  payments?: number;
  ihipPlans?: number;
  creditLedger?: number;
  faceDrawings?: number;
  photos?: number;
  consents?: number;
  preferences?: number;
  lifestyleSurveys?: number;
  importedBalances?: number;
}

/**
 * Request body for ``POST /api/customers/merge``.

``sourceId`` is the duplicate being retired; ``targetId`` is the surviving
record that inherits its history.
 */
export interface CustomerMergeRequest {
  sourceId: string;
  targetId: string;
}

/**
 * Summary of a completed merge.
 */
export interface CustomerMergeResponse {
  sourceId: string;
  targetId: string;
  sourceName: string;
  targetName: string;
  mergedCounts: CustomerMergeCounts;
}

export type CustomerMutationResponseFirstName = string | null;

export type CustomerMutationResponseLastName = string | null;

export type CustomerMutationResponseEmail = string | null;

export type CustomerMutationResponseDob = string | null;

export type CustomerMutationResponseGender = string | null;

export type CustomerMutationResponseNationality = string | null;

export type CustomerMutationResponseMaritalStatus = string | null;

export type CustomerMutationResponseAddress = string | null;

export type CustomerMutationResponseNricLast4 = string | null;

export type CustomerMutationResponseReferralSource = string | null;

export type CustomerMutationResponseReferralDetail = string | null;

export type CustomerMutationResponsePhotoUrl = string | null;

export type CustomerMutationResponsePrefOutletId = string | null;

export type CustomerMutationResponseSpecialRequests = string | null;

export type CustomerMutationResponseNotes = string | null;

export type CustomerMutationResponseCautionNotes = string | null;

export type CustomerMutationResponseCustomerType = string | null;

export type CustomerMutationResponseIsActive = boolean | null;

export type CustomerMutationResponsePrefOutlet = OutletSummary | null;

export type CustomerMutationResponseSourceRef = string | null;

/**
 * Create/update response shape.
 */
export interface CustomerMutationResponse {
  name: string;
  firstName?: CustomerMutationResponseFirstName;
  lastName?: CustomerMutationResponseLastName;
  phone: string;
  email?: CustomerMutationResponseEmail;
  dob?: CustomerMutationResponseDob;
  gender?: CustomerMutationResponseGender;
  nationality?: CustomerMutationResponseNationality;
  maritalStatus?: CustomerMutationResponseMaritalStatus;
  address?: CustomerMutationResponseAddress;
  nricLast4?: CustomerMutationResponseNricLast4;
  referralSource?: CustomerMutationResponseReferralSource;
  referralDetail?: CustomerMutationResponseReferralDetail;
  photoUrl?: CustomerMutationResponsePhotoUrl;
  prefOutletId?: CustomerMutationResponsePrefOutletId;
  specialRequests?: CustomerMutationResponseSpecialRequests;
  notes?: CustomerMutationResponseNotes;
  cautionNotes?: CustomerMutationResponseCautionNotes;
  customerType?: CustomerMutationResponseCustomerType;
  isActive?: CustomerMutationResponseIsActive;
  id: string;
  createdAt: string;
  updatedAt: string;
  prefOutlet?: CustomerMutationResponsePrefOutlet;
  sourceRef?: CustomerMutationResponseSourceRef;
}

/**
 * The Preferred Outlet change log, newest first, and the outlets where she
also has sessions (CUS-06-04) — information only.
 */
export interface CustomerOutletInfoResponse {
  changes?: OutletChangeItem[];
  registeredChanges?: OutletChangeItem[];
  alsoHasSessionsAt?: string[];
}

export interface CustomerPackageBalance {
  packageId: string;
  programName: string;
  steps?: TreatmentStepOption[];
  totalSessions: number;
  usedSessions: number;
  remainingSessions: number;
  status: string;
  expiryDate: string;
}

/**
 * Reduced active-package shape returned from ``GET /api/customers``.
 */
export interface CustomerPackageListItem {
  id: string;
  totalSessions: number;
  usedSessions: number;
  expiryDate: string;
}

export type CustomerPackageProgramSummaryNameKo = string | null;

export type CustomerPackageProgramSummaryNameZh = string | null;

export type CustomerPackageProgramSummaryNameVi = string | null;

export type CustomerPackageProgramSummaryCategory = string | null;

/**
 * Treatment program shape embedded in customer package responses.
 */
export interface CustomerPackageProgramSummary {
  id: string;
  name: string;
  nameKo?: CustomerPackageProgramSummaryNameKo;
  nameZh?: CustomerPackageProgramSummaryNameZh;
  nameVi?: CustomerPackageProgramSummaryNameVi;
  category?: CustomerPackageProgramSummaryCategory;
}

export type CustomerPackageResponseInvoiceNumber = string | null;

export type CustomerPackageResponseNotes = string | null;

/**
 * Full package shape embedded in customer detail.
 */
export interface CustomerPackageResponse {
  id: string;
  customerId: string;
  programId: string;
  invoiceNumber?: CustomerPackageResponseInvoiceNumber;
  purchaseDate: string;
  expiryDate: string;
  totalSessions: number;
  usedSessions: number;
  amountPaid: number;
  totalPrice: number;
  status: string;
  notes?: CustomerPackageResponseNotes;
  createdAt: string;
  updatedAt: string;
  pendingChange?: boolean;
  program: CustomerPackageProgramSummary;
}

export type CustomerPastGroupLeftAt = string | null;

export type CustomerPastGroupReason = string | null;

export interface CustomerPastGroup {
  groupId: string;
  name: string;
  joinedAt: string;
  leftAt?: CustomerPastGroupLeftAt;
  reason?: CustomerPastGroupReason;
}

export type CustomerPhotoCreateCaption = string | null;

export type CustomerPhotoCreateAngle = string | null;

export type CustomerPhotoCreateTakenAt = string | null;

export type CustomerPhotoCreateSessionMilestone = number | null;

/**
 * Request body for ``POST /api/customers/[id]/photos``.
 */
export interface CustomerPhotoCreate {
  imageData: string;
  caption?: CustomerPhotoCreateCaption;
  angle?: CustomerPhotoCreateAngle;
  takenAt?: CustomerPhotoCreateTakenAt;
  sessionMilestone?: CustomerPhotoCreateSessionMilestone;
}

export type CustomerPhotoResponseCaption = string | null;

export type CustomerPhotoResponseAngle = string | null;

export type CustomerPhotoResponseSessionMilestone = number | null;

export type CustomerPhotoResponseUploadedByName = string | null;

/**
 * Single saved customer photo.

``imageData`` is a large base64 JPEG/PNG data URL and should be treated as a
volatile field in tests/fixtures (like ``FaceChartDrawingResponse``).
 */
export interface CustomerPhotoResponse {
  id: string;
  imageData: string;
  caption?: CustomerPhotoResponseCaption;
  angle?: CustomerPhotoResponseAngle;
  takenAt: string;
  sessionMilestone?: CustomerPhotoResponseSessionMilestone;
  uploadedByName?: CustomerPhotoResponseUploadedByName;
  createdAt: string;
}

export type CustomerPicksDone = {[key: string]: string};

export interface CustomerPicks {
  customerId: string;
  picks: string[];
  done?: CustomerPicksDone;
}

export interface CustomerPreference {
  id: string;
  customerId: string;
  staffId: string;
  type: string;
  createdAt: string;
  staff: CustomerPreferenceStaff;
}

/**
 * Single customer preference row with nested staff detail.
 */
export interface CustomerPreferenceResponse {
  id: string;
  customerId: string;
  staffId: string;
  type: string;
  createdAt: string;
  staff: CustomerTherapistSummary;
}

export type CustomerPreferenceStaffProbationEndDate = string | null;

export type CustomerPreferenceStaffPhone = string | null;

export type CustomerPreferenceStaffPhotoUrl = string | null;

export type CustomerPreferenceStaffPreferredLang = string | null;

export interface CustomerPreferenceStaff {
  id: string;
  outletId: string;
  name: string;
  role: string;
  skillLevel: number;
  employmentType: string;
  startDate: string;
  isProbation: boolean;
  probationEndDate?: CustomerPreferenceStaffProbationEndDate;
  phone?: CustomerPreferenceStaffPhone;
  photoUrl?: CustomerPreferenceStaffPhotoUrl;
  preferredLang?: CustomerPreferenceStaffPreferredLang;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Updated customer therapist preferences.
 */
export interface CustomerPreferencesResponse {
  preferredTherapists?: CustomerTherapistSummary[];
  excludedTherapists?: CustomerTherapistSummary[];
}

/**
 * Request body for ``PUT /api/customers/[id]/preferences``.
 */
export interface CustomerPreferencesUpdate {
  preferredStaffIds?: string[];
  excludedStaffIds?: string[];
}

/**
 * Per-active-aesthetic-package reminder row.
 */
export interface CustomerReminderItem {
  packageId: string;
  programName: string;
  usedSessions: number;
  photoDue: boolean;
  maskDue: boolean;
}

/**
 * Derived photo/mask reminders for a customer (A6).
 */
export interface CustomerRemindersResponse {
  photoDue?: boolean;
  maskDue?: boolean;
  items?: CustomerReminderItem[];
}

export type CustomerSpecialRequestsResponseSpecialRequests = string | null;

export type CustomerSpecialRequestsResponseCautionNotes = string | null;

export type CustomerSpecialRequestsResponseAllergies = string | null;

/**
 * R5-04 — everything the special request banner shows, in one read.

Shown at booking, in the customer drawer and before a treatment starts, so
it is deliberately small and readable by any signed-in staff member (the
therapist about to start the treatment needs it most).
 */
export interface CustomerSpecialRequestsResponse {
  customerId: string;
  preferredTherapists?: SpecialRequestTherapist[];
  specialRequests?: CustomerSpecialRequestsResponseSpecialRequests;
  cautionNotes?: CustomerSpecialRequestsResponseCautionNotes;
  allergies?: CustomerSpecialRequestsResponseAllergies;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstandingBalance?: string;
}

export type CustomerSummaryPhone = string | null;

export interface CustomerSummary {
  id: string;
  name: string;
  phone?: CustomerSummaryPhone;
}

export type CustomerSurveyResponseId = string | null;

export type CustomerSurveyResponseCustomerId = string | null;

export type CustomerSurveyResponseLastEdit = SurveyHistoryEntry | null;

export type CustomerSurveyResponseEmail = string | null;

export type CustomerSurveyResponseBloodPressure = string | null;

export type CustomerSurveyResponseSurgeryHistory = boolean | null;

export type CustomerSurveyResponseSurgeryHistoryDetail = string | null;

export type CustomerSurveyResponsePlasticSurgery = boolean | null;

export type CustomerSurveyResponsePlasticSurgeryDetail = string | null;

export type CustomerSurveyResponseJawSounds = boolean | null;

export type CustomerSurveyResponseJawSoundsDetail = string | null;

export type CustomerSurveyResponseJawDiseaseHistory = boolean | null;

export type CustomerSurveyResponseJawDiseaseDetail = string | null;

export type CustomerSurveyResponseDentalTreatment = boolean | null;

export type CustomerSurveyResponseDentalTreatmentDetail = string | null;

export type CustomerSurveyResponseSkinAllergies = boolean | null;

export type CustomerSurveyResponseSkinAllergiesDetail = string | null;

export type CustomerSurveyResponseSpecialConditions = string | null;

export type CustomerSurveyResponseSpecialConditionsOther = string | null;

export type CustomerSurveyResponseIsPregnant = boolean | null;

export type CustomerSurveyResponseExpectedDeliveryDate = string | null;

export type CustomerSurveyResponseBodyPartsCaution = string | null;

export type CustomerSurveyResponseSleepRegular = boolean | null;

export type CustomerSurveyResponseSleepHours = string | null;

export type CustomerSurveyResponseSleepBedTime = string | null;

export type CustomerSurveyResponseSleepWakeTime = string | null;

export type CustomerSurveyResponseHasInsomnia = boolean | null;

export type CustomerSurveyResponseHeadacheFrequency = string | null;

export type CustomerSurveyResponseDigestion = string | null;

export type CustomerSurveyResponseDigestionOther = string | null;

export type CustomerSurveyResponseBowelFrequency = string | null;

export type CustomerSurveyResponseHasSwelling = boolean | null;

export type CustomerSurveyResponseSwellingArea = string | null;

export type CustomerSurveyResponseSwellingTime = string | null;

export type CustomerSurveyResponseCrossLegsOrLean = boolean | null;

export type CustomerSurveyResponseDailyWaterIntake = string | null;

export type CustomerSurveyResponseWaterTemperature = string | null;

export type CustomerSurveyResponseUsualDrinks = string | null;

export type CustomerSurveyResponseUsualDrinksOther = string | null;

export type CustomerSurveyResponseDrinksAlcohol = boolean | null;

export type CustomerSurveyResponseDoesExercise = boolean | null;

export type CustomerSurveyResponseExerciseTypes = string | null;

export type CustomerSurveyResponseExerciseTypesOther = string | null;

export type CustomerSurveyResponseExerciseFrequency = string | null;

export type CustomerSurveyResponseHasAestheticExperience = boolean | null;

export type CustomerSurveyResponseAestheticExperienceDetail = string | null;

export type CustomerSurveyResponseCustomerNote = string | null;

export type CustomerSurveyResponseCustomerConcern = string | null;

export type CustomerSurveyResponseSkinAnalysis = string | null;

export type CustomerSurveyResponseStaffNote = string | null;

export type CustomerSurveyResponseRecommendedProgram = string | null;

export type CustomerSurveyResponseFilledAt = string | null;

export type CustomerSurveyResponseFilledBy = string | null;

export type CustomerSurveyResponseCreatedAt = string | null;

export type CustomerSurveyResponseUpdatedAt = string | null;

export type CustomerSurveyResponseCustomerEmail = string | null;

/**
 * Survey response shape for ``GET`` and ``PUT`` survey routes.

``GET`` returns either the survey fields plus ``customerEmail`` or a stub
object containing only ``customerEmail`` when the survey does not exist yet.
``PUT`` returns the persisted survey row without ``customerEmail``.
 */
export interface CustomerSurveyResponse {
  id?: CustomerSurveyResponseId;
  customerId?: CustomerSurveyResponseCustomerId;
  refillDue?: boolean;
  lastEdit?: CustomerSurveyResponseLastEdit;
  email?: CustomerSurveyResponseEmail;
  bloodPressure?: CustomerSurveyResponseBloodPressure;
  surgeryHistory?: CustomerSurveyResponseSurgeryHistory;
  surgeryHistoryDetail?: CustomerSurveyResponseSurgeryHistoryDetail;
  plasticSurgery?: CustomerSurveyResponsePlasticSurgery;
  plasticSurgeryDetail?: CustomerSurveyResponsePlasticSurgeryDetail;
  jawSounds?: CustomerSurveyResponseJawSounds;
  jawSoundsDetail?: CustomerSurveyResponseJawSoundsDetail;
  jawDiseaseHistory?: CustomerSurveyResponseJawDiseaseHistory;
  jawDiseaseDetail?: CustomerSurveyResponseJawDiseaseDetail;
  dentalTreatment?: CustomerSurveyResponseDentalTreatment;
  dentalTreatmentDetail?: CustomerSurveyResponseDentalTreatmentDetail;
  skinAllergies?: CustomerSurveyResponseSkinAllergies;
  skinAllergiesDetail?: CustomerSurveyResponseSkinAllergiesDetail;
  specialConditions?: CustomerSurveyResponseSpecialConditions;
  specialConditionsOther?: CustomerSurveyResponseSpecialConditionsOther;
  isPregnant?: CustomerSurveyResponseIsPregnant;
  expectedDeliveryDate?: CustomerSurveyResponseExpectedDeliveryDate;
  bodyPartsCaution?: CustomerSurveyResponseBodyPartsCaution;
  sleepRegular?: CustomerSurveyResponseSleepRegular;
  sleepHours?: CustomerSurveyResponseSleepHours;
  sleepBedTime?: CustomerSurveyResponseSleepBedTime;
  sleepWakeTime?: CustomerSurveyResponseSleepWakeTime;
  hasInsomnia?: CustomerSurveyResponseHasInsomnia;
  headacheFrequency?: CustomerSurveyResponseHeadacheFrequency;
  digestion?: CustomerSurveyResponseDigestion;
  digestionOther?: CustomerSurveyResponseDigestionOther;
  bowelFrequency?: CustomerSurveyResponseBowelFrequency;
  hasSwelling?: CustomerSurveyResponseHasSwelling;
  swellingArea?: CustomerSurveyResponseSwellingArea;
  swellingTime?: CustomerSurveyResponseSwellingTime;
  crossLegsOrLean?: CustomerSurveyResponseCrossLegsOrLean;
  dailyWaterIntake?: CustomerSurveyResponseDailyWaterIntake;
  waterTemperature?: CustomerSurveyResponseWaterTemperature;
  usualDrinks?: CustomerSurveyResponseUsualDrinks;
  usualDrinksOther?: CustomerSurveyResponseUsualDrinksOther;
  drinksAlcohol?: CustomerSurveyResponseDrinksAlcohol;
  doesExercise?: CustomerSurveyResponseDoesExercise;
  exerciseTypes?: CustomerSurveyResponseExerciseTypes;
  exerciseTypesOther?: CustomerSurveyResponseExerciseTypesOther;
  exerciseFrequency?: CustomerSurveyResponseExerciseFrequency;
  hasAestheticExperience?: CustomerSurveyResponseHasAestheticExperience;
  aestheticExperienceDetail?: CustomerSurveyResponseAestheticExperienceDetail;
  customerNote?: CustomerSurveyResponseCustomerNote;
  customerConcern?: CustomerSurveyResponseCustomerConcern;
  skinAnalysis?: CustomerSurveyResponseSkinAnalysis;
  staffNote?: CustomerSurveyResponseStaffNote;
  recommendedProgram?: CustomerSurveyResponseRecommendedProgram;
  filledAt?: CustomerSurveyResponseFilledAt;
  filledBy?: CustomerSurveyResponseFilledBy;
  createdAt?: CustomerSurveyResponseCreatedAt;
  updatedAt?: CustomerSurveyResponseUpdatedAt;
  customerEmail?: CustomerSurveyResponseCustomerEmail;
}

export type CustomerSurveyUpsertRecordAs = 'STAFF' | 'TABLET' | null;

export type CustomerSurveyUpsertEmail = string | null;

export type CustomerSurveyUpsertBloodPressure = string | null;

export type CustomerSurveyUpsertSurgeryHistory = boolean | null;

export type CustomerSurveyUpsertSurgeryHistoryDetail = string | null;

export type CustomerSurveyUpsertPlasticSurgery = boolean | null;

export type CustomerSurveyUpsertPlasticSurgeryDetail = string | null;

export type CustomerSurveyUpsertJawSounds = boolean | null;

export type CustomerSurveyUpsertJawSoundsDetail = string | null;

export type CustomerSurveyUpsertJawDiseaseHistory = boolean | null;

export type CustomerSurveyUpsertJawDiseaseDetail = string | null;

export type CustomerSurveyUpsertDentalTreatment = boolean | null;

export type CustomerSurveyUpsertDentalTreatmentDetail = string | null;

export type CustomerSurveyUpsertSkinAllergies = boolean | null;

export type CustomerSurveyUpsertSkinAllergiesDetail = string | null;

export type CustomerSurveyUpsertSpecialConditions = string | null;

export type CustomerSurveyUpsertSpecialConditionsOther = string | null;

export type CustomerSurveyUpsertIsPregnant = boolean | null;

export type CustomerSurveyUpsertExpectedDeliveryDate = string | null;

export type CustomerSurveyUpsertBodyPartsCaution = string | null;

export type CustomerSurveyUpsertSleepRegular = boolean | null;

export type CustomerSurveyUpsertSleepHours = string | null;

export type CustomerSurveyUpsertSleepBedTime = string | null;

export type CustomerSurveyUpsertSleepWakeTime = string | null;

export type CustomerSurveyUpsertHasInsomnia = boolean | null;

export type CustomerSurveyUpsertHeadacheFrequency = string | null;

export type CustomerSurveyUpsertDigestion = string | null;

export type CustomerSurveyUpsertDigestionOther = string | null;

export type CustomerSurveyUpsertBowelFrequency = string | null;

export type CustomerSurveyUpsertHasSwelling = boolean | null;

export type CustomerSurveyUpsertSwellingArea = string | null;

export type CustomerSurveyUpsertSwellingTime = string | null;

export type CustomerSurveyUpsertCrossLegsOrLean = boolean | null;

export type CustomerSurveyUpsertDailyWaterIntake = string | null;

export type CustomerSurveyUpsertWaterTemperature = string | null;

export type CustomerSurveyUpsertUsualDrinks = string | null;

export type CustomerSurveyUpsertUsualDrinksOther = string | null;

export type CustomerSurveyUpsertDrinksAlcohol = boolean | null;

export type CustomerSurveyUpsertDoesExercise = boolean | null;

export type CustomerSurveyUpsertExerciseTypes = string | null;

export type CustomerSurveyUpsertExerciseTypesOther = string | null;

export type CustomerSurveyUpsertExerciseFrequency = string | null;

export type CustomerSurveyUpsertHasAestheticExperience = boolean | null;

export type CustomerSurveyUpsertAestheticExperienceDetail = string | null;

export type CustomerSurveyUpsertCustomerNote = string | null;

export type CustomerSurveyUpsertCustomerConcern = string | null;

export type CustomerSurveyUpsertSkinAnalysis = string | null;

export type CustomerSurveyUpsertStaffNote = string | null;

export type CustomerSurveyUpsertFilledBy = string | null;

/**
 * Request body for ``PUT /api/customers/[id]/survey``.
 */
export interface CustomerSurveyUpsert {
  recordAs?: CustomerSurveyUpsertRecordAs;
  email?: CustomerSurveyUpsertEmail;
  bloodPressure?: CustomerSurveyUpsertBloodPressure;
  surgeryHistory?: CustomerSurveyUpsertSurgeryHistory;
  surgeryHistoryDetail?: CustomerSurveyUpsertSurgeryHistoryDetail;
  plasticSurgery?: CustomerSurveyUpsertPlasticSurgery;
  plasticSurgeryDetail?: CustomerSurveyUpsertPlasticSurgeryDetail;
  jawSounds?: CustomerSurveyUpsertJawSounds;
  jawSoundsDetail?: CustomerSurveyUpsertJawSoundsDetail;
  jawDiseaseHistory?: CustomerSurveyUpsertJawDiseaseHistory;
  jawDiseaseDetail?: CustomerSurveyUpsertJawDiseaseDetail;
  dentalTreatment?: CustomerSurveyUpsertDentalTreatment;
  dentalTreatmentDetail?: CustomerSurveyUpsertDentalTreatmentDetail;
  skinAllergies?: CustomerSurveyUpsertSkinAllergies;
  skinAllergiesDetail?: CustomerSurveyUpsertSkinAllergiesDetail;
  specialConditions?: CustomerSurveyUpsertSpecialConditions;
  specialConditionsOther?: CustomerSurveyUpsertSpecialConditionsOther;
  isPregnant?: CustomerSurveyUpsertIsPregnant;
  expectedDeliveryDate?: CustomerSurveyUpsertExpectedDeliveryDate;
  bodyPartsCaution?: CustomerSurveyUpsertBodyPartsCaution;
  sleepRegular?: CustomerSurveyUpsertSleepRegular;
  sleepHours?: CustomerSurveyUpsertSleepHours;
  sleepBedTime?: CustomerSurveyUpsertSleepBedTime;
  sleepWakeTime?: CustomerSurveyUpsertSleepWakeTime;
  hasInsomnia?: CustomerSurveyUpsertHasInsomnia;
  headacheFrequency?: CustomerSurveyUpsertHeadacheFrequency;
  digestion?: CustomerSurveyUpsertDigestion;
  digestionOther?: CustomerSurveyUpsertDigestionOther;
  bowelFrequency?: CustomerSurveyUpsertBowelFrequency;
  hasSwelling?: CustomerSurveyUpsertHasSwelling;
  swellingArea?: CustomerSurveyUpsertSwellingArea;
  swellingTime?: CustomerSurveyUpsertSwellingTime;
  crossLegsOrLean?: CustomerSurveyUpsertCrossLegsOrLean;
  dailyWaterIntake?: CustomerSurveyUpsertDailyWaterIntake;
  waterTemperature?: CustomerSurveyUpsertWaterTemperature;
  usualDrinks?: CustomerSurveyUpsertUsualDrinks;
  usualDrinksOther?: CustomerSurveyUpsertUsualDrinksOther;
  drinksAlcohol?: CustomerSurveyUpsertDrinksAlcohol;
  doesExercise?: CustomerSurveyUpsertDoesExercise;
  exerciseTypes?: CustomerSurveyUpsertExerciseTypes;
  exerciseTypesOther?: CustomerSurveyUpsertExerciseTypesOther;
  exerciseFrequency?: CustomerSurveyUpsertExerciseFrequency;
  hasAestheticExperience?: CustomerSurveyUpsertHasAestheticExperience;
  aestheticExperienceDetail?: CustomerSurveyUpsertAestheticExperienceDetail;
  customerNote?: CustomerSurveyUpsertCustomerNote;
  customerConcern?: CustomerSurveyUpsertCustomerConcern;
  skinAnalysis?: CustomerSurveyUpsertSkinAnalysis;
  staffNote?: CustomerSurveyUpsertStaffNote;
  filledBy?: CustomerSurveyUpsertFilledBy;
}

/**
 * Lean therapist shape embedded in customer detail/preferences responses.
 */
export interface CustomerTherapistSummary {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  outlet: OutletSummary;
}

export type CustomerTicketCreateCustomerId = string | null;

export type CustomerTicketCreateCustomerPhone = string | null;

export type CustomerTicketCreateSubCategory = string | null;

export type CustomerTicketCreateDetail = string | null;

export type CustomerTicketCreateStaffId = string | null;

export type CustomerTicketCreateHandledById = string | null;

export type CustomerTicketCreateResolution = string | null;

export type CustomerTicketCreateTicketDate = string | null;

/**
 * POST body.

``customerName`` is required even when ``customerId`` is supplied; the
service backfills it from the customer when it arrives blank, so the client
may send an empty string for a picked customer and still get a named ticket.

``resolvedById`` / ``completedAt`` are absent by design — the two audit
fields are never client-supplied (see the service). ``ticketDate`` defaults
to today in Singapore.
 */
export interface CustomerTicketCreate {
  /** @minLength 1 */
  outletId: string;
  customerId?: CustomerTicketCreateCustomerId;
  /** @maxLength 200 */
  customerName?: string;
  customerPhone?: CustomerTicketCreateCustomerPhone;
  type: TicketType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  category: string;
  subCategory?: CustomerTicketCreateSubCategory;
  detail?: CustomerTicketCreateDetail;
  staffId?: CustomerTicketCreateStaffId;
  handledById?: CustomerTicketCreateHandledById;
  resolution?: CustomerTicketCreateResolution;
  ticketDate?: CustomerTicketCreateTicketDate;
  status?: TicketStatus;
}

/**
 * Paginated list. ``total`` is the unpaginated count, so the FE can render
"1-50 of 1335" without a second request.
 */
export interface CustomerTicketListResponse {
  items?: CustomerTicketResponse[];
  total: number;
}

export type CustomerTicketResponseCustomerId = string | null;

export type CustomerTicketResponseCustomerPhone = string | null;

export type CustomerTicketResponseSubCategory = string | null;

export type CustomerTicketResponseDetail = string | null;

export type CustomerTicketResponseStaffId = string | null;

export type CustomerTicketResponseStaffName = string | null;

export type CustomerTicketResponseResolution = string | null;

export type CustomerTicketResponseResolvedById = string | null;

export type CustomerTicketResponseResolvedByName = string | null;

export type CustomerTicketResponseTicketNo = string | null;

export type CustomerTicketResponseTicketDate = string | null;

export type CustomerTicketResponseHandledById = string | null;

export type CustomerTicketResponseHandledByName = string | null;

export type CustomerTicketResponseCreatedById = string | null;

export type CustomerTicketResponseCreatedByName = string | null;

export type CustomerTicketResponseCompletedAt = string | null;

export type CustomerTicketResponseCustomer = TicketCustomerRef | null;

export type CustomerTicketResponseStaff = TicketStaffRef | null;

export type CustomerTicketResponseResolvedBy = TicketStaffRef | null;

/**
 * ⛔ Every nullable column is declared ``| None`` (defect class 1).
 */
export interface CustomerTicketResponse {
  id: string;
  outletId: string;
  outletName: string;
  customerId?: CustomerTicketResponseCustomerId;
  customerName: string;
  customerPhone?: CustomerTicketResponseCustomerPhone;
  type: string;
  category: string;
  subCategory?: CustomerTicketResponseSubCategory;
  detail?: CustomerTicketResponseDetail;
  staffId?: CustomerTicketResponseStaffId;
  staffName?: CustomerTicketResponseStaffName;
  resolution?: CustomerTicketResponseResolution;
  resolvedById?: CustomerTicketResponseResolvedById;
  resolvedByName?: CustomerTicketResponseResolvedByName;
  ticketNo?: CustomerTicketResponseTicketNo;
  ticketDate?: CustomerTicketResponseTicketDate;
  handledById?: CustomerTicketResponseHandledById;
  handledByName?: CustomerTicketResponseHandledByName;
  createdById?: CustomerTicketResponseCreatedById;
  createdByName?: CustomerTicketResponseCreatedByName;
  changeLog?: TicketChange[];
  status: string;
  completedAt?: CustomerTicketResponseCompletedAt;
  createdAt: string;
  updatedAt: string;
  customer?: CustomerTicketResponseCustomer;
  staff?: CustomerTicketResponseStaff;
  resolvedBy?: CustomerTicketResponseResolvedBy;
}

export type CustomerTicketUpdateOutletId = string | null;

export type CustomerTicketUpdateCustomerId = string | null;

export type CustomerTicketUpdateCustomerName = string | null;

export type CustomerTicketUpdateCustomerPhone = string | null;

export type CustomerTicketUpdateType = TicketType | null;

export type CustomerTicketUpdateCategory = string | null;

export type CustomerTicketUpdateSubCategory = string | null;

export type CustomerTicketUpdateDetail = string | null;

export type CustomerTicketUpdateStaffId = string | null;

export type CustomerTicketUpdateHandledById = string | null;

export type CustomerTicketUpdateTicketDate = string | null;

export type CustomerTicketUpdateResolution = string | null;

export type CustomerTicketUpdateResolvedById = string | null;

export type CustomerTicketUpdateStatus = TicketStatus | null;

/**
 * PATCH body — ⛔ every writable field, all optional (defect class 2).

The service applies ``model_dump(exclude_unset=True)``, so a key the client
did not send is left alone while an explicit ``null`` clears the column.
That distinction is what lets "remove the staff attribution" and "don't
touch the staff attribution" be different requests.

``resolvedById`` is declared because the spec lists it as writable, but the
service ignores it on any COMPLETED transition and stamps the authenticated
actor instead — see ``CustomerTicketService.update_ticket``.
 */
export interface CustomerTicketUpdate {
  outletId?: CustomerTicketUpdateOutletId;
  customerId?: CustomerTicketUpdateCustomerId;
  customerName?: CustomerTicketUpdateCustomerName;
  customerPhone?: CustomerTicketUpdateCustomerPhone;
  type?: CustomerTicketUpdateType;
  category?: CustomerTicketUpdateCategory;
  subCategory?: CustomerTicketUpdateSubCategory;
  detail?: CustomerTicketUpdateDetail;
  staffId?: CustomerTicketUpdateStaffId;
  handledById?: CustomerTicketUpdateHandledById;
  ticketDate?: CustomerTicketUpdateTicketDate;
  resolution?: CustomerTicketUpdateResolution;
  resolvedById?: CustomerTicketUpdateResolvedById;
  status?: CustomerTicketUpdateStatus;
}

export type CustomerUpdateFirstName = string | null;

export type CustomerUpdateLastName = string | null;

export type CustomerUpdateEmail = string | null;

export type CustomerUpdateDob = string | null;

export type CustomerUpdateGender = string | null;

export type CustomerUpdateNationality = string | null;

export type CustomerUpdateMaritalStatus = string | null;

export type CustomerUpdateAddress = string | null;

export type CustomerUpdateNricLast4 = string | null;

export type CustomerUpdateReferralSource = string | null;

export type CustomerUpdateReferralDetail = string | null;

export type CustomerUpdatePhotoUrl = string | null;

export type CustomerUpdatePrefOutletId = string | null;

export type CustomerUpdateSpecialRequests = string | null;

export type CustomerUpdateNotes = string | null;

export type CustomerUpdateCautionNotes = string | null;

export type CustomerUpdateCustomerType = string | null;

export type CustomerUpdateIsActive = boolean | null;

/**
 * Request body for ``PUT /api/customers/[id]``.

The legacy route requires ``name`` and ``phone`` on update as well.
 */
export interface CustomerUpdate {
  name: string;
  firstName?: CustomerUpdateFirstName;
  lastName?: CustomerUpdateLastName;
  phone: string;
  email?: CustomerUpdateEmail;
  dob?: CustomerUpdateDob;
  gender?: CustomerUpdateGender;
  nationality?: CustomerUpdateNationality;
  maritalStatus?: CustomerUpdateMaritalStatus;
  address?: CustomerUpdateAddress;
  nricLast4?: CustomerUpdateNricLast4;
  referralSource?: CustomerUpdateReferralSource;
  referralDetail?: CustomerUpdateReferralDetail;
  photoUrl?: CustomerUpdatePhotoUrl;
  prefOutletId?: CustomerUpdatePrefOutletId;
  specialRequests?: CustomerUpdateSpecialRequests;
  notes?: CustomerUpdateNotes;
  cautionNotes?: CustomerUpdateCautionNotes;
  customerType?: CustomerUpdateCustomerType;
  isActive?: CustomerUpdateIsActive;
}

export type DailyCloseCreateCashierTotal = number | string | null;

export type DailyCloseCreateNotes = string | null;

/**
 * POST /finance/daily-close — record (upsert) the daily close for an
(outletId, businessDate). ``cashierTotal`` is the manual external-cashier
daily total (v1; FIN-E2 auto-pull fills it later). When present, the close
flips OPEN → CLOSED and the variance is computed.
 */
export interface DailyCloseCreate {
  outletId: string;
  businessDate: string;
  cashierTotal?: DailyCloseCreateCashierTotal;
  notes?: DailyCloseCreateNotes;
}

export type DailyCloseResponseId = string | null;

export type DailyCloseResponseBusinessDate = string | null;

export type DailyCloseResponseCashierTotal = string | null;

export type DailyCloseResponseVariance = string | null;

export type DailyCloseResponseClosedById = string | null;

export type DailyCloseResponseClosedAt = string | null;

export type DailyCloseResponseNotes = string | null;

export type DailyCloseResponseStandaloneIhipNote = string | null;

export type DailyCloseResponseCreatedAt = string | null;

export type DailyCloseResponseUpdatedAt = string | null;

/**
 * GET/POST /finance/daily-close — the computed YaksonOS totals by method for
the outlet+businessDate, plus the persisted close (if one exists) and the
variance (``yaksonTotal - cashierTotal``; null when no cashierTotal).

⛔ v1 attribution gap: standalone IHIP installment collections (``Payment``
with no ``saleId``, ``paymentType=INSTALLMENT``) have no Sale→outlet link, so
they are **excluded** from these outlet totals. ``standaloneIhipNote`` flags
this known gap; the daily close therefore reflects Sale-linked payments only.
 */
export interface DailyCloseResponse {
  id?: DailyCloseResponseId;
  outletId: string;
  businessDate?: DailyCloseResponseBusinessDate;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cashTotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  payNowTotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cardTotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  ihipTotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  voucherTotal?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  yaksonTotal: string;
  cashierTotal?: DailyCloseResponseCashierTotal;
  cashierSource: string;
  variance?: DailyCloseResponseVariance;
  status: string;
  needsReview?: boolean;
  closedById?: DailyCloseResponseClosedById;
  closedAt?: DailyCloseResponseClosedAt;
  notes?: DailyCloseResponseNotes;
  standaloneIhipNote?: DailyCloseResponseStandaloneIhipNote;
  createdAt?: DailyCloseResponseCreatedAt;
  updatedAt?: DailyCloseResponseUpdatedAt;
}

/**
 * Yesterday's daily close: how many outlets closed their day. A count, never
the till totals or the variance.
 */
export interface DailyCloseStatus {
  businessDate: string;
  closed: number;
  outlets: number;
}

export type DailyReportAppointmentResponseProgram = DailyReportProgramResponse | null;

export type DailyReportAppointmentResponseRoom = DailyReportRoomResponse | null;

export interface DailyReportAppointmentResponse {
  id: string;
  startTime: string;
  endTime: string;
  customer: DailyReportCustomerResponse;
  program?: DailyReportAppointmentResponseProgram;
  room?: DailyReportAppointmentResponseRoom;
  outlet: DailyReportOutletResponse;
}

export interface DailyReportCommissionDetail {
  staffId: string;
  staffName: string;
  stepName: string;
  durationMins: number;
  hourlyRate: number;
  amount: number;
}

export interface DailyReportCommissionResult {
  success: boolean;
  commissionsCreated: number;
  totalAmount: number;
  errors?: string[];
  details?: DailyReportCommissionDetail[];
}

export type DailyReportConfirmRequestStaffId = string | null;

export type DailyReportConfirmRequestNote = string | null;

export interface DailyReportConfirmRequest {
  staffId?: DailyReportConfirmRequestStaffId;
  date: string;
  note?: DailyReportConfirmRequestNote;
}

export type DailyReportConfirmationPayloadNote = string | null;

export type DailyReportConfirmationPayloadResolvedDisputeId = string | null;

export interface DailyReportConfirmationPayload {
  id: string;
  staffId: string;
  date: string;
  confirmedAt: string;
  note?: DailyReportConfirmationPayloadNote;
  autoConfirmed: boolean;
  resolvedDisputeId?: DailyReportConfirmationPayloadResolvedDisputeId;
}

export type DailyReportConfirmationResponseNote = string | null;

export type DailyReportConfirmationResponseResolvedDisputeId = string | null;

export interface DailyReportConfirmationResponse {
  id: string;
  staffId: string;
  date: string;
  confirmedAt: string;
  note?: DailyReportConfirmationResponseNote;
  autoConfirmed: boolean;
  resolvedDisputeId?: DailyReportConfirmationResponseResolvedDisputeId;
  commission: DailyReportCommissionResult;
}

export interface DailyReportCustomerResponse {
  id: string;
  name: string;
}

export interface DailyReportOriginalStaffResponse {
  id: string;
  name: string;
}

export interface DailyReportOutletResponse {
  id: string;
  code: string;
}

export interface DailyReportProgramResponse {
  id: string;
  name: string;
}

export type DailyReportResponseConfirmation = DailyReportConfirmationPayload | null;

export type DailyReportResponseOpenDispute = DisputeResponse | null;

export interface DailyReportResponse {
  totalSteps: number;
  totalMinutes: number;
  staff: DailyReportStaffResponse;
  date: string;
  steps?: DailyReportStepResponse[];
  confirmation?: DailyReportResponseConfirmation;
  openDispute?: DailyReportResponseOpenDispute;
  disputes?: DisputeResponse[];
}

export interface DailyReportRoomResponse {
  id: string;
  name: string;
}

export interface DailyReportStaffResponse {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  outletId: string;
}

export interface DailyReportStepDefinitionResponse {
  id: string;
  name: string;
  sequence: number;
  duration: number;
}

export type DailyReportStepResponseActualStartTime = string | null;

export type DailyReportStepResponseActualEndTime = string | null;

export type DailyReportStepResponseOriginalStaff = DailyReportOriginalStaffResponse | null;

export interface DailyReportStepResponse {
  id: string;
  startTime: string;
  endTime: string;
  actualStartTime?: DailyReportStepResponseActualStartTime;
  actualEndTime?: DailyReportStepResponseActualEndTime;
  step: DailyReportStepDefinitionResponse;
  originalStaff?: DailyReportStepResponseOriginalStaff;
  appointment: DailyReportAppointmentResponse;
}

export interface DailyScheduleResponse {
  date: string;
  isWeekend: boolean;
  staff: ScheduleStaffSummary[];
  appointments: ScheduleAppointment[];
  [key: string]: unknown;
 }

export type DashboardTargetChangeOutletId = string | null;

export type DashboardTargetChangeChangedBy = string | null;

/**
 * One line of the Set targets log: what, where, old → new, who, when.
 */
export interface DashboardTargetChange {
  id: string;
  key: string;
  outletId?: DashboardTargetChangeOutletId;
  value: unknown;
  previous?: unknown;
  effectiveFrom: string;
  changedBy?: DashboardTargetChangeChangedBy;
  changedAt: string;
}

export type DashboardTargetUpdateOutletId = string | null;

export interface DashboardTargetUpdate {
  value: unknown;
  outletId?: DashboardTargetUpdateOutletId;
}

export type DashboardTargetsOutletValues = { [key: string]: unknown };

/**
 * Set targets (3c) — the values in force tomorrow for one outlet.
 */
export interface DashboardTargetsOutlet {
  outletId: string;
  outletCode: string;
  outletName: string;
  values: DashboardTargetsOutletValues;
}

export type DashboardTargetsScreenShared = { [key: string]: unknown };

/**
 * GET /dashboard/targets (DSH-17-03): every outlet's targets, the shared
ones, the break-even, the KPI list and the change log.
 */
export interface DashboardTargetsScreen {
  asOf: string;
  shared: DashboardTargetsScreenShared;
  outlets: DashboardTargetsOutlet[];
  breakEven: number;
  kpiKeys: string[];
  changes: DashboardTargetChange[];
}

export type DayItemRuleId = string | null;

export type DayItemCheckMethod = 'OS' | 'HAND' | null;

export interface DayItem {
  date: string;
  title: string;
  ruleId: DayItemRuleId;
  checkMethod: DayItemCheckMethod;
}

export type DayLogOutletName = string | null;

export type DayLogShiftStart = string | null;

export type DayLogShiftEnd = string | null;

export type DayLogClockIn = string | null;

export type DayLogBreakStart = string | null;

export type DayLogBreakEnd = string | null;

export type DayLogClockOut = string | null;

export type DayLogLeaveType = string | null;

export interface DayLog {
  date: string;
  outletName?: DayLogOutletName;
  shiftStart?: DayLogShiftStart;
  shiftEnd?: DayLogShiftEnd;
  clockIn?: DayLogClockIn;
  breakStart?: DayLogBreakStart;
  breakEnd?: DayLogBreakEnd;
  clockOut?: DayLogClockOut;
  status: string;
  lateMinutes?: number;
  workedMinutes?: number;
  rosteredMinutes?: number;
  leaveType?: DayLogLeaveType;
  remarks?: RemarkNote[];
}

export type DecisionRequestNote = string | null;

export interface DecisionRequest {
  note?: DecisionRequestNote;
}

export type DeskDayCardStaffId = string | null;

export type DeskDayCardKpisBehind = number | null;

/**
 * Management view, F - People, Office desks today (DSH-17-02 / DSH-08-09):
one office person's day on one card. Counts only.
 */
export interface DeskDayCard {
  ownerName: string;
  ownerUserId: string;
  staffId?: DeskDayCardStaffId;
  done: number;
  planned: number;
  carriedOver: number;
  weekDone: number;
  weekTotal: number;
  givenWaiting: number;
  kpisBehind?: DeskDayCardKpisBehind;
}

/**
 * GET /office-desk/desks-today — one card per office person, in the order
management set on Desk order.
 */
export interface DeskDaysResponse {
  date: string;
  cards: DeskDayCard[];
}

/**
 * GET /office-desk/desk-order — the desk tab order (DSH-08-01, owner 15 Oct).
 */
export interface DeskOrderResponse {
  desks: string[];
  order: string[];
  defaultOrder: string[];
  isDefault: boolean;
  canEdit: boolean;
}

/**
 * PUT /office-desk/desk-order — the full order; [] = back to the default.
 */
export interface DeskOrderUpdate {
  /** @maxItems 50 */
  order?: string[];
}

/**
 * DSH-02-04 / DSH-07-01: the ring counts only what this person has to do.
 */
export interface DeskSummary {
  ringDone: number;
  ringTotal: number;
  leftToDo: number;
  waiting: number;
  doneByOs: number;
  doneByYou: number;
}

export type DeskTabOwnerUserId = string | null;

export type DeskTabStaffId = string | null;

/**
 * One desk tab (DSH-08-01): own desk first.
 */
export interface DeskTab {
  ownerName: string;
  ownerUserId: DeskTabOwnerUserId;
  staffId: DeskTabStaffId;
  isMine: boolean;
  canEdit?: boolean;
}

export interface DeskTabsResponse {
  desks: DeskTab[];
  canManage: boolean;
  canConfirmRules: boolean;
  unmatchedOwners: string[];
}

export type DeskTaskCategory = string | null;

export type DeskTaskKpi = string | null;

export type DeskTaskKind = typeof DeskTaskKind[keyof typeof DeskTaskKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeskTaskKind = {
  CARD: 'CARD',
  OS_LINE: 'OS_LINE',
  PROGRESS: 'PROGRESS',
} as const;

export type DeskTaskSource = typeof DeskTaskSource[keyof typeof DeskTaskSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeskTaskSource = {
  RULE: 'RULE',
  EVENT: 'EVENT',
  OS: 'OS',
  TYPED: 'TYPED',
  MANAGEMENT: 'MANAGEMENT',
} as const;

export type DeskTaskStatus = typeof DeskTaskStatus[keyof typeof DeskTaskStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeskTaskStatus = {
  OPEN: 'OPEN',
  DONE: 'DONE',
  NOT_TODAY: 'NOT_TODAY',
  WAITING: 'WAITING',
  CARRIED: 'CARRIED',
  MOVED: 'MOVED',
} as const;

export type DeskTaskDueDate = string | null;

export type DeskTaskOsCount = number | null;

export type DeskTaskOsTarget = number | null;

export type DeskTaskOsDetail = string | null;

export type DeskTaskRemarks = string | null;

export type DeskTaskNotTodayReason = string | null;

export type DeskTaskWaitingOn = string | null;

export type DeskTaskWaitingSince = string | null;

export type DeskTaskWaitingDays = number | null;

export type DeskTaskWaitingLevel = 'GREY' | 'AMBER' | 'RED' | null;

export type DeskTaskDoneBy = 'PERSON' | 'OS' | null;

export type DeskTaskDoneAt = string | null;

export type DeskTaskRuleId = string | null;

export type DeskTaskScreen = string | null;

export type DeskTaskProposedBy = string | null;

export type DeskTaskProposedDate = string | null;

export interface DeskTask {
  id: string;
  title: string;
  category: DeskTaskCategory;
  kpi: DeskTaskKpi;
  kind: DeskTaskKind;
  source: DeskTaskSource;
  status: DeskTaskStatus;
  taskDate: string;
  startedOn: string;
  carriedOver: boolean;
  dueDate: DeskTaskDueDate;
  overdue: boolean;
  osCount: DeskTaskOsCount;
  osTarget: DeskTaskOsTarget;
  osDetail: DeskTaskOsDetail;
  waitsOnOthers: boolean;
  remarks: DeskTaskRemarks;
  notTodayReason: DeskTaskNotTodayReason;
  waitingOn: DeskTaskWaitingOn;
  waitingSince: DeskTaskWaitingSince;
  waitingDays: DeskTaskWaitingDays;
  waitingLevel: DeskTaskWaitingLevel;
  doneBy: DeskTaskDoneBy;
  doneAt: DeskTaskDoneAt;
  ruleId: DeskTaskRuleId;
  screen: DeskTaskScreen;
  proposedBy?: DeskTaskProposedBy;
  proposedDate?: DeskTaskProposedDate;
}

export interface DeskTodayResponse {
  ownerName: string;
  ownerUserId: string;
  date: string;
  isMine: boolean;
  canEdit: boolean;
  summary: DeskSummary;
  now: DeskTask[];
  done: DeskTask[];
  waiting: DeskTask[];
  thisWeek: WeekDay[];
  comingUp: DayItem[];
  ruleCount: number;
}

export interface DeviceListResponse {
  items?: DeviceOut[];
}

export type DeviceOutRegisteredById = string | null;

export type DeviceOutRegisteredByName = string | null;

export type DeviceOutRevokedAt = string | null;

export type DeviceOutLastSeenAt = string | null;

export interface DeviceOut {
  id: string;
  outletId: string;
  outletName: string;
  name: string;
  registeredById?: DeviceOutRegisteredById;
  registeredByName?: DeviceOutRegisteredByName;
  registeredAt: string;
  revokedAt?: DeviceOutRevokedAt;
  lastSeenAt?: DeviceOutLastSeenAt;
}

export interface DeviceRegister {
  outletId: string;
  /**
   * @minLength 1
   * @maxLength 80
   */
  name: string;
}

export interface DeviceRegistered {
  device: DeviceOut;
  token: string;
}

export interface DiscountApproverListResponse {
  items: DiscountApproverResponse[];
}

export type DiscountApproverResponseRole = string | null;

export type DiscountApproverResponseSkillLevel = number | null;

/**
 * A staff member the DISCOUNT_APPROVER list admits. Every field is read
from the LIVE ``Staff`` row — an entry whose staff member is inactive or
soft-deleted is dropped from the list rather than reported from its label
snapshot, so the roster can never offer a departed colleague.
 */
export interface DiscountApproverResponse {
  staffId: string;
  name: string;
  role: DiscountApproverResponseRole;
  skillLevel: DiscountApproverResponseSkillLevel;
}

export type DisposeLineCreateBatchId = string | null;

/**
 * One row of the Dispose form (INV-06-12).

``batchId`` null = earliest expiry first. ``reason`` is one of EXPIRED ·
DAMAGED · DEFECTIVE · LOST · OTHER (the service validates; OTHER needs the
form's remarks).
 */
export interface DisposeLineCreate {
  /** @minLength 1 */
  productId: string;
  batchId?: DisposeLineCreateBatchId;
  /** */
  qty: number;
  /**
   * @minLength 1
   * @maxLength 40
   */
  reason: string;
}

export type DisputeCreateRequestStaffId = string | null;

export interface DisputeCreateRequest {
  staffId?: DisputeCreateRequestStaffId;
  date: string;
  reason: string;
}

export type DisputeListResponse = DisputeWithStaffResponse[];

export type DisputeOutcome = typeof DisputeOutcome[keyof typeof DisputeOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DisputeOutcome = {
  DISMISSED: 'DISMISSED',
  UPHELD: 'UPHELD',
} as const;

export type DisputeResolveRequestOutcome = DisputeOutcome | null;

export interface DisputeResolveRequest {
  resolution: string;
  outcome?: DisputeResolveRequestOutcome;
}

export type DisputeResponseOutcome = DisputeOutcome | null;

export type DisputeResponseResolvedBy = string | null;

export type DisputeResponseResolvedAt = string | null;

export type DisputeResponseResolution = string | null;

export interface DisputeResponse {
  id: string;
  staffId: string;
  date: string;
  reason: string;
  status: DisputeStatus;
  outcome?: DisputeResponseOutcome;
  openedAt: string;
  resolvedBy?: DisputeResponseResolvedBy;
  resolvedAt?: DisputeResponseResolvedAt;
  resolution?: DisputeResponseResolution;
}

export type DisputeStaffResponseOutletId = string | null;

export interface DisputeStaffResponse {
  id: string;
  name: string;
  role: string;
  outletId?: DisputeStaffResponseOutletId;
}

export type DisputeStatus = typeof DisputeStatus[keyof typeof DisputeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DisputeStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
  WITHDRAWN: 'WITHDRAWN',
} as const;

export type DisputeWithStaffResponseOutcome = DisputeOutcome | null;

export type DisputeWithStaffResponseResolvedBy = string | null;

export type DisputeWithStaffResponseResolvedAt = string | null;

export type DisputeWithStaffResponseResolution = string | null;

export interface DisputeWithStaffResponse {
  id: string;
  staffId: string;
  date: string;
  reason: string;
  status: DisputeStatus;
  outcome?: DisputeWithStaffResponseOutcome;
  openedAt: string;
  resolvedBy?: DisputeWithStaffResponseResolvedBy;
  resolvedAt?: DisputeWithStaffResponseResolvedAt;
  resolution?: DisputeWithStaffResponseResolution;
  staff: DisputeStaffResponse;
}

export interface DisputeWithdrawRequest { [key: string]: unknown }

export type DncConsentRowLastVisit = string | null;

export interface DncConsentRow {
  customerId: string;
  name: string;
  mobile: string;
  lastVisit?: DncConsentRowLastVisit;
  sessionsLeft?: number;
}

export type DncCreatePeriod = DncPeriod | null;

export type DncCreateUntil = string | null;

export type DncCreateNote = string | null;

export type DncCreateListKey = LeadListKey | null;

/**
 * The DNC window (LEA-06): kind, reason (required), period for temporary,
the confirmations checkbox, and an optional note.
 */
export interface DncCreate {
  kind: DncKind;
  /**
   * @minLength 1
   * @maxLength 200
   */
  reason: string;
  period?: DncCreatePeriod;
  until?: DncCreateUntil;
  confirmationsOk?: boolean;
  note?: DncCreateNote;
  listKey?: DncCreateListKey;
}

export type DncKind = typeof DncKind[keyof typeof DncKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DncKind = {
  TEMPORARY: 'TEMPORARY',
  NEVER: 'NEVER',
} as const;

export interface DncListResponse {
  asOf: string;
  items?: DncOut[];
  noMarketingConsent?: DncConsentRow[];
}

export type DncOutPeriod = DncPeriod | null;

export type DncOutUntil = string | null;

export type DncOutNote = string | null;

export type DncOutAddedBy = string | null;

export type DncOutReleasedAt = string | null;

export type DncOutReleasedBy = string | null;

export type DncOutLastVisit = string | null;

export interface DncOut {
  id: string;
  customerId: string;
  name: string;
  mobile: string;
  kind: DncKind;
  status: DncStatus;
  reason: string;
  period?: DncOutPeriod;
  until?: DncOutUntil;
  confirmationsOk?: boolean;
  note?: DncOutNote;
  source: DncSource;
  addedBy?: DncOutAddedBy;
  addedOn: string;
  releasedAt?: DncOutReleasedAt;
  releasedBy?: DncOutReleasedBy;
  lastVisit?: DncOutLastVisit;
  sessionsLeft?: number;
}

/**
 * Temporary also needs a period (LEA-06-03).
 */
export type DncPeriod = typeof DncPeriod[keyof typeof DncPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DncPeriod = {
  '1M': '1M',
  '2M': '2M',
  '3M': '3M',
  '6M': '6M',
  '1Y': '1Y',
  NO_END: 'NO_END',
  DATE: 'DATE',
} as const;

export interface DncReasons {
  temporary: string[];
  never: string[];
  other: string;
}

export type DncSource = typeof DncSource[keyof typeof DncSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DncSource = {
  STAFF: 'STAFF',
  SM: 'SM',
  SHEET: 'SHEET',
} as const;

/**
 * The three tabs of the Do Not Contact screen (LEA-13-01).
 */
export type DncStatus = typeof DncStatus[keyof typeof DncStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DncStatus = {
  TEMPORARY: 'TEMPORARY',
  NEVER: 'NEVER',
  RELEASED: 'RELEASED',
} as const;

export type DocStatus = typeof DocStatus[keyof typeof DocStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
} as const;

/**
 * Backs the `Invoice on hold (N)` badge without shipping the whole list.
 */
export interface DraftCountResponse {
  count: number;
}

export interface DraftSaleListResponse {
  items: DraftSaleResponse[];
}

export type DraftSaleResponsePresalesNumber = string | null;

export type DraftSaleResponseInvoiceNumber = string | null;

export type DraftSaleResponseCreatedByName = string | null;

export type DraftSaleResponseCustomerName = string | null;

export type DraftSaleResponseOutletName = string | null;

export type DraftSaleResponseAcknowledgedByName = string | null;

export type DraftSaleResponseAcknowledgedAt = string | null;

/**
 * One row of the draft queue.
 */
export interface DraftSaleResponse {
  id: string;
  presalesNumber?: DraftSaleResponsePresalesNumber;
  invoiceNumber?: DraftSaleResponseInvoiceNumber;
  createdAt: string;
  createdByName?: DraftSaleResponseCreatedByName;
  customerName?: DraftSaleResponseCustomerName;
  outletName?: DraftSaleResponseOutletName;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  status: string;
  acknowledgedByName?: DraftSaleResponseAcknowledgedByName;
  acknowledgedAt?: DraftSaleResponseAcknowledgedAt;
}

export interface DutyRosterReport {
  /** YYYY-MM */
  month: string;
  outletId: string;
  outletName: string;
  staff: DutyRosterStaff[];
  rows: DutyRosterRow[];
}

/**
 * One printed row: a date and the staff (one, or several with identical
Roster info and Activities).
 */
export interface DutyRosterRow {
  /** YYYY-MM-DD, the Singapore calendar day */
  date: string;
  staff: DutyRosterStaff[];
  rosterInfo: string;
  activities: string;
}

export interface DutyRosterStaff {
  id: string;
  name: string;
}

/**
 * GET /api/commission/earnings — per-staff overview + totals (the shape the
commission page renders; mirrors the legacy all-staff earnings response).
 */
export interface EarningsByStaffResponse {
  staffEarnings: StaffEarningEntry[];
  totals: EarningsTotals;
}

/**
 * Aggregate totals across all staff (the KPI cards). Float amounts (JSON
numbers) — see StaffEarningSummary.
 */
export interface EarningsTotals {
  totalEarnings: number;
  pendingAmount: number;
  approvedAmount: number;
  paidAmount: number;
  totalMinutes: number;
  totalHours: number;
  appointmentCount: number;
  changedAfterApprovalCount?: number;
}

export type EditRuleRequestCategory = typeof EditRuleRequestCategory[keyof typeof EditRuleRequestCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditRuleRequestCategory = {
  HR: 'HR',
  ADMIN: 'ADMIN',
  SALES: 'SALES',
  CUSTCARE: 'CUSTCARE',
  TRAINING: 'TRAINING',
  MARKETING: 'MARKETING',
} as const;

export type EditRuleRequestFrequency = typeof EditRuleRequestFrequency[keyof typeof EditRuleRequestFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditRuleRequestFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ON_EVENT: 'ON_EVENT',
} as const;

export type EditRuleRequestWeekday = number | null;

export type EditRuleRequestMonthDay = number | null;

export type EditRuleRequestMonths = string | null;

export type EditRuleRequestKpi = string | null;

export type EditRuleRequestNote = string | null;

export type EditRuleRequestReason = string | null;

export interface EditRuleRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  title: string;
  category: EditRuleRequestCategory;
  frequency: EditRuleRequestFrequency;
  weekday?: EditRuleRequestWeekday;
  monthDay?: EditRuleRequestMonthDay;
  months?: EditRuleRequestMonths;
  kpi?: EditRuleRequestKpi;
  note?: EditRuleRequestNote;
  reason?: EditRuleRequestReason;
}

export type EmploymentType = typeof EmploymentType[keyof typeof EmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmploymentType = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
} as const;

export interface EnrollmentDetailGroup {
  media: string;
  rows: EnrollmentDetailRow[];
}

export type EnrollmentDetailRowCustomerRef = string | null;

export type EnrollmentDetailRowContactNumber = string | null;

export type EnrollmentDetailRowEmail = string | null;

export type EnrollmentDetailRowGender = string | null;

export type EnrollmentDetailRowNationality = string | null;

/**
 * One new customer in a Detail table; fields not asked for are null.
 */
export interface EnrollmentDetailRow {
  enrollmentDate: string;
  customerId: string;
  customerName: string;
  customerRef?: EnrollmentDetailRowCustomerRef;
  contactNumber?: EnrollmentDetailRowContactNumber;
  email?: EnrollmentDetailRowEmail;
  gender?: EnrollmentDetailRowGender;
  nationality?: EnrollmentDetailRowNationality;
}

/**
 * Customer Enrollment by Media - Summary: new customers per media (MKT-02-12).
 */
export interface EnrollmentSummaryRow {
  media: string;
  customers: number;
}

export interface EntitlementSummaryResponse {
  year: number;
  rows?: EntitlementSummaryRow[];
}

export type EntitlementSummaryRowPresetAl = number | null;

export type EntitlementSummaryRowAlDays = number | null;

export type EntitlementSummaryRowAlLeft = number | null;

/**
 * HR-05-02 — one staff member's row of the 'Entitlement overrides' table:
AL / PH days set, used and left for the year, and OT earned / used / left.
'left' never goes below 0 here; a day taken beyond it is ``*Over``
(HR-05-06 step 3).
 */
export interface EntitlementSummaryRow {
  staffId: string;
  name: string;
  role: string;
  employmentType: string;
  presetAl?: EntitlementSummaryRowPresetAl;
  hasOverride?: boolean;
  alDays?: EntitlementSummaryRowAlDays;
  alUsed?: number;
  alLeft?: EntitlementSummaryRowAlLeft;
  alOver?: number;
  phDays?: number;
  phUsed?: number;
  phLeft?: number;
  phOver?: number;
  otEarnedMinutes?: number;
  otUsedMinutes?: number;
  otLeftMinutes?: number;
}

export type ExpiringBatchItemProductSku = string | null;

export type ExpiringBatchItemBatchCode = string | null;

/**
 * One dated batch that is due (or overdue), flattened for the alert card.

Product and location are flattened onto the row rather than nested: the card
and the row indicator both want "Hydrating Cleanser at the Office", and a
nested object would make the two surfaces unpack it differently.

⛔ ``unitCost`` is deliberately ABSENT from this shape — not nulled, absent.
``GET /inventory/stock`` has to redact it per-caller because its response
carries whole batch rows; this feed simply never carries the supplier price,
so the alert card needs no permission branch and cannot leak a margin by
someone later forgetting one. An expiry alert has no use for what we paid.

``expiryDate`` is non-null here by construction: undated batches never enter
this list (they are counted in ``ExpiringStockResponse.totalBatches``
instead), because a NULL expiry means *unknown*, not *imminent*.
 */
export interface ExpiringBatchItem {
  batchId: string;
  productId: string;
  productName: string;
  productSku: ExpiringBatchItemProductSku;
  unit: string;
  stockLocationId: string;
  stockLocationName: string;
  stockLocationCode: string;
  batchCode: ExpiringBatchItemBatchCode;
  expiryDate: string;
  receivedDate: string;
  qtyOnHand: number;
  daysUntilExpiry: number;
  tier: string;
}

/**
 * Single package row from ``GET /api/packages/expiring``.
 */
export interface ExpiringPackageItem {
  id: string;
  customerId: string;
  customerName: string;
  programName: string;
  expiryDate: string;
  daysRemaining: number;
  remainingSessions: number;
}

/**
 * Response from ``GET /api/packages/expiring``.
 */
export interface ExpiringPackagesResponse {
  items?: ExpiringPackageItem[];
  total: number;
}

/**
 * The feed, **plus the counts that explain an empty feed** — spec §8.3.

⛔⛔ THE COUNTS ARE NOT TELEMETRY. They are the only thing that lets the UI
tell two genuinely different situations apart, both of which arrive as
``items == []``:

| ``totalWithExpiry`` | means | required copy |
|---|---|---|
| ``0``   | no dates recorded anywhere | "No expiry dates recorded yet — add
            them on the Stock page." |
| ``> 0`` | dates exist, none inside the window | "Nothing expiring in the
            next N days." |

Per C4 Studio Manager exports no expiry dates, so every batch starts NULL and
the first row is the NORMAL launch state for an unbounded period. Rendering
the second message over the first situation is a **false clean bill of health
on the exact feature built to catch expiring stock**, which is why the
endpoint refuses to return a bare list.

``totalBatches == 0`` is a third, milder case: no stock has been received at
all, so there is nothing to invite dates onto yet and the card hides itself
(the Stock page's own empty state covers it).

Both counts are scoped exactly like ``items`` — same filters, same
stock-on-hand rule — so they answer the question the caller actually asked.
 */
export interface ExpiringStockResponse {
  items: ExpiringBatchItem[];
  totalBatches: number;
  totalWithExpiry: number;
  withinDays: number;
  asOfDate: string;
}

export type ExtensionQuoteResponseCurrentExpiryDate = string | null;

export type ExtensionQuoteResponseFreeExtensionMonths = number | null;

export type ExtensionQuoteResponseSuggestedExpiryDate = string | null;

export type ExtensionQuoteResponseFreeExtensionUsedAt = string | null;

/**
 * GET /finance/packages/{id}/extension/quote — what the Expiry Extension
form (R5-37) needs: the current expiry, remaining sessions and whether the
one-time free extension is still available, with its tiered length.
 */
export interface ExtensionQuoteResponse {
  packageId: string;
  currentExpiryDate?: ExtensionQuoteResponseCurrentExpiryDate;
  remainingSessions: number;
  freeExtensionAvailable: boolean;
  freeExtensionMonths?: ExtensionQuoteResponseFreeExtensionMonths;
  suggestedExpiryDate?: ExtensionQuoteResponseSuggestedExpiryDate;
  freeExtensionUsed?: boolean;
  freeExtensionUsedAt?: ExtensionQuoteResponseFreeExtensionUsedAt;
  freeExtensionPending?: boolean;
}

export type ExtensionRequestOutletId = string | null;

export type ExtensionRequestOtherReason = string | null;

export type ExtensionRequestCustomerSignature = string | null;

export type ExtensionRequestStaffSignature = string | null;

/**
 * POST /finance/packages/{id}/extension — submit a PENDING Expiry
Extension (R5-37-41). The new expiry is applied on approval.
 */
export interface ExtensionRequest {
  outletId?: ExtensionRequestOutletId;
  reasons: string[];
  otherReason?: ExtensionRequestOtherReason;
  requestedExpiryDate: string;
  attachments?: string[];
  termsAccepted?: boolean;
  customerSignature?: ExtensionRequestCustomerSignature;
  staffSignature?: ExtensionRequestStaffSignature;
}

/**
 * One pickable "drawn by" for the face chart (R5 N-09).

``id`` is a ``Staff.id`` when ``kind`` is ``STAFF`` and a ``User.id`` when it
is ``USER`` — the office accounts (customercare@, admin@) have no Staff row,
so a login is the only thing that identifies them. ``role`` is the Staff role
(HEAD_MASTER, SENIOR_CONSULTANT, …) or, for a USER, its userType.
 */
export interface FaceChartAuthorOption {
  id: string;
  name: string;
  role: string;
  kind: string;
}

export type FaceChartCreateStep = number | null;

export type FaceChartCreateDrawnByStaffId = string | null;

/**
 * Request body for ``POST /api/customers/[id]/face-chart``.
 */
export interface FaceChartCreate {
  imageData: string;
  step?: FaceChartCreateStep;
  drawnByStaffId?: FaceChartCreateDrawnByStaffId;
}

export type FaceChartDrawingResponseStep = number | null;

export type FaceChartDrawingResponseCreatedByName = string | null;

export type FaceChartDrawingResponseDrawnByStaffId = string | null;

export type FaceChartDrawingResponseDrawnByName = string | null;

/**
 * Single saved face-chart drawing.

``imageData`` is a large base64 PNG data URL and should be treated as a
volatile field in tests/fixtures.
 */
export interface FaceChartDrawingResponse {
  id: string;
  imageData: string;
  step?: FaceChartDrawingResponseStep;
  createdByName?: FaceChartDrawingResponseCreatedByName;
  drawnByStaffId?: FaceChartDrawingResponseDrawnByStaffId;
  drawnByName?: FaceChartDrawingResponseDrawnByName;
  createdAt: string;
}

export interface FillFromMinimumResponse {
  rows: FillFromMinimumRowResponse[];
  total: number;
}

export type FillFromMinimumRowResponseProductSku = string | null;

/**
 * One product below its minimum at To (INV-07-17); ``qty`` is capped at From's stock.
 */
export interface FillFromMinimumRowResponse {
  productId: string;
  productName: string;
  productSku: FillFromMinimumRowResponseProductSku;
  unit: string;
  minQty: number;
  onHandAtTo: number;
  inTransitTo: number;
  toSendTo: number;
  needed: number;
  availableAtFrom: number;
  qty: number;
}

export type FinanceFigureAmount = string | null;

export type FinanceFigureCount = number | null;

export type FinanceFigureDetail = string | null;

export type FinanceFigureScreen = string | null;

/**
 * One figure on E · Finance, read from the report that owns it (no new
money definition). ``amount`` is None when the OS cannot reach it (DSH-18-05).
 */
export interface FinanceFigure {
  key: string;
  label: string;
  amount?: FinanceFigureAmount;
  count?: FinanceFigureCount;
  detail?: FinanceFigureDetail;
  screen?: FinanceFigureScreen;
}

export type FinanceRuleCreateConditionsAnyOf = { [key: string]: unknown };

export type FinanceRuleCreateConditions = string | FinanceRuleCreateConditionsAnyOf | unknown[] | null;

export type FinanceRuleCreateActionAnyOf = { [key: string]: unknown };

export type FinanceRuleCreateAction = string | FinanceRuleCreateActionAnyOf;

/**
 * POST /finance/rules — author a new rule. ``conditions`` / ``action`` may be
supplied as either a JSON string or an already-parsed object (dict/list); the
service normalizes to JSON text and validates against the DSL.
 */
export interface FinanceRuleCreate {
  ruleKey: string;
  domain: string;
  description: string;
  conditions?: FinanceRuleCreateConditions;
  action: FinanceRuleCreateAction;
  priority?: number;
  isActive?: boolean;
}

/**
 * GET /finance/rules — the rule set (optionally filtered by domain).
 */
export interface FinanceRuleListResponse {
  rules?: FinanceRuleResponse[];
  total: number;
}

export type FinanceRuleResponseCreatedAt = string | null;

export type FinanceRuleResponseUpdatedAt = string | null;

/**
 * A single persisted FinanceRule config row (§5.8). ``conditions`` and
``action`` are returned as the raw JSON text stored on the column.
 */
export interface FinanceRuleResponse {
  id: string;
  ruleKey: string;
  domain: string;
  description: string;
  conditions: string;
  action: string;
  priority: number;
  isActive: boolean;
  createdAt?: FinanceRuleResponseCreatedAt;
  updatedAt?: FinanceRuleResponseUpdatedAt;
}

export type FinanceRuleUpdateDescription = string | null;

export type FinanceRuleUpdateConditionsAnyOf = { [key: string]: unknown };

export type FinanceRuleUpdateConditions = string | FinanceRuleUpdateConditionsAnyOf | unknown[] | null;

export type FinanceRuleUpdateActionAnyOf = { [key: string]: unknown };

export type FinanceRuleUpdateAction = string | FinanceRuleUpdateActionAnyOf | null;

export type FinanceRuleUpdatePriority = number | null;

export type FinanceRuleUpdateIsActive = boolean | null;

/**
 * PATCH /finance/rules/{id} — partial edit (toggle isActive / edit
conditions / action / priority / description). All fields optional.
 */
export interface FinanceRuleUpdate {
  description?: FinanceRuleUpdateDescription;
  conditions?: FinanceRuleUpdateConditions;
  action?: FinanceRuleUpdateAction;
  priority?: FinanceRuleUpdatePriority;
  isActive?: FinanceRuleUpdateIsActive;
}

/**
 * GET /finance/ihip/{packageId}/firewall — non-raising start-treatment
pre-check (§8.4). The frontend uses this to disable the Start button.
 */
export interface FirewallCheckResponse {
  allowed: boolean;
  sessionNumber: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  dueUpToSession: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  shortfall: string;
  overdue?: boolean;
}

/**
 * OPS-24-03 - the survey start, recorded once; the booking is In Progress.
 */
export interface FirstVisitSurveyStartResponse {
  appointmentId: string;
  startedAt: string;
  status: string;
  alreadyStarted: boolean;
}

export type FirstVisitSurveyStateStartedAt = string | null;

/**
 * What the Questionnaires card needs for one consultation.
 */
export interface FirstVisitSurveyState {
  appointmentId: string;
  required: boolean;
  startedAt?: FirstVisitSurveyStateStartedAt;
}

export interface FirstVisitSurveyStates {
  states?: FirstVisitSurveyState[];
}

export type FollowUpConsultationRequestConsultantId = string | null;

export type FollowUpConsultationRequestMasterId = string | null;

export type FollowUpConsultationRequestPosition = typeof FollowUpConsultationRequestPosition[keyof typeof FollowUpConsultationRequestPosition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FollowUpConsultationRequestPosition = {
  before: 'before',
  after: 'after',
} as const;

export interface FollowUpConsultationRequest {
  consultantId?: FollowUpConsultationRequestConsultantId;
  masterId?: FollowUpConsultationRequestMasterId;
  roomId: string;
  position?: FollowUpConsultationRequestPosition;
}

export type FollowUpEffectAmount = string | null;

export type FollowUpEffectAppointments = number | null;

export type FollowUpEffectUsual = number | null;

export type FollowUpEffectValuePerAppointment = string | null;

/**
 * DSH-13-08 / DSH-17-04 — the follow-up effect estimate for one outlet.
``direction``: up | down | pace | none (not enough history or data).
 */
export interface FollowUpEffect {
  direction: string;
  amount?: FollowUpEffectAmount;
  appointments?: FollowUpEffectAppointments;
  last7: number;
  usual?: FollowUpEffectUsual;
  valuePerAppointment?: FollowUpEffectValuePerAppointment;
}

export type FollowUpLockOutLockedBy = string | null;

export interface FollowUpLockOut {
  customerId: string;
  lockedBy?: FollowUpLockOutLockedBy;
  lockedMinutes?: number;
  mine?: boolean;
}

export type FollowUpQueueResponseOutletId = string | null;

export type FollowUpQueueResponseFromOutletSummary = string | null;

export interface FollowUpQueueResponse {
  asOf: string;
  outletId?: FollowUpQueueResponseOutletId;
  targets: FollowUpTargets;
  beforeClosing: BeforeClosing;
  red?: QueueEntry[];
  fromOutlet?: QueueEntry[];
  fromOutletSummary?: FollowUpQueueResponseFromOutletSummary;
  escalatedCount?: number;
  next?: QueueEntry[];
  done?: QueueEntry[];
}

/**
 * The two numbers at the top (LEA-02-09/10). Nothing done in tab 1 is in
either number (LEA-28-07).
 */
export interface FollowUpTargets {
  contactsTarget: number;
  contactsDone: number;
  appointmentsTarget: number;
  appointmentsDone: number;
  contactsReached?: boolean;
  appointmentsReached?: boolean;
}

export type FollowUpTodayLineTarget = number | null;

/**
 * One line of 'Today's follow-up' on the Outlet view (DSH-13-01/02).

``group`` is ``check`` (Appointment check: cleared or not, no target —
LEA-28-07) or ``booking`` (Booking follow-up: target · contacted ·
appointments made). ``available`` is False for a list the OS does not hold
yet (New Leads, Bal Pay): the line shows '—' and is not counted as done.
 */
export interface FollowUpTodayLine {
  key: string;
  number: number;
  group: string;
  available?: boolean;
  target?: FollowUpTodayLineTarget;
  contacted?: number;
  appointmentsMade?: number;
  redLeft?: number;
  openCount?: number;
  done?: boolean;
}

export type FollowUpTodayResponseOutletId = string | null;

export type FollowUpTodayResponseSignal = string | null;

export type FollowUpTodayResponseSignalDirection = string | null;

/**
 * GET /leads/follow-up/today — the table and its header figures, and the
follow-up signal (estimated sales, DSH-13-08) for one outlet.
 */
export interface FollowUpTodayResponse {
  asOf: string;
  outletId?: FollowUpTodayResponseOutletId;
  lines?: FollowUpTodayLine[];
  linesDone?: number;
  linesTotal?: number;
  contactsTarget?: number;
  contactsDone?: number;
  appointmentsTarget?: number;
  appointmentsDone?: number;
  redLeft?: number;
  signal?: FollowUpTodayResponseSignal;
  signalDirection?: FollowUpTodayResponseSignalDirection;
}

export type FollowUpTreatmentRequestPackageId = string | null;

export interface FollowUpTreatmentRequest {
  programId: string;
  roomId: string;
  staffAssignments?: StaffAssignmentInput[];
  packageId?: FollowUpTreatmentRequestPackageId;
}

/**
 * POST /hr/forms/upload result. ``url`` is what the caller sends straight
back as the submission's ``attachmentData``.
 */
export interface FormAttachmentUploadResponse {
  url: string;
  fileName: string;
  contentType: string;
  size: number;
}

export type FormResponseApproveReason = string | null;

/**
 * Optional body of approve — required (non-empty) for a 'VIP change'.
 */
export interface FormResponseApprove {
  reason?: FormResponseApproveReason;
}

export type FormResponseCreateCustomerId = string | null;

export type FormResponseCreateStaffId = string | null;

export type FormResponseCreateResponses = { [key: string]: unknown };

export type FormResponseCreateCustomerSignature = string | null;

export type FormResponseCreateStaffSignature = string | null;

export type FormResponseCreateOutletId = string | null;

export type FormResponseCreateSignedOn = typeof FormResponseCreateSignedOn[keyof typeof FormResponseCreateSignedOn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormResponseCreateSignedOn = {
  COMPUTER: 'COMPUTER',
  TABLET: 'TABLET',
} as const;

/**
 * The signing payload. It names the *template*, not a version: the client
renders whatever is live and the server pins the response to the version it
resolves at that moment, so a publish mid-session can never be signed
against stale content the client happened to be holding.
 */
export interface FormResponseCreate {
  formTemplateId: string;
  customerId?: FormResponseCreateCustomerId;
  staffId?: FormResponseCreateStaffId;
  responses?: FormResponseCreateResponses;
  customerSignature?: FormResponseCreateCustomerSignature;
  staffSignature?: FormResponseCreateStaffSignature;
  outletId?: FormResponseCreateOutletId;
  signedOn?: FormResponseCreateSignedOn;
}

export interface FormResponseListResponse {
  responses: FormResponseOut[];
  total: number;
}

export type FormResponseOutVersionNumber = number | null;

export type FormResponseOutFormTemplateId = string | null;

export type FormResponseOutFormTemplateName = string | null;

export type FormResponseOutFormMenu = string | null;

export type FormResponseOutFormBuiltinKey = string | null;

export type FormResponseOutCustomerId = string | null;

export type FormResponseOutCustomerName = string | null;

export type FormResponseOutCustomerPhone = string | null;

export type FormResponseOutCustomerEmail = string | null;

export type FormResponseOutStaffId = string | null;

export type FormResponseOutStaffName = string | null;

export type FormResponseOutDecidedById = string | null;

export type FormResponseOutDecidedByName = string | null;

export type FormResponseOutDecidedAt = string | null;

export type FormResponseOutHmDecidedById = string | null;

export type FormResponseOutHmDecidedByName = string | null;

export type FormResponseOutHmDecidedAt = string | null;

export type FormResponseOutDecisionReason = string | null;

export type FormResponseOutResponses = { [key: string]: unknown };

export type FormResponseOutCustomerSignature = string | null;

export type FormResponseOutStaffSignature = string | null;

export type FormResponseOutCollectedByName = string | null;

export type FormResponseOutOutletId = string | null;

export type FormResponseOutOutletCode = string | null;

export interface FormResponseOut {
  id: string;
  formVersionId: string;
  versionNumber?: FormResponseOutVersionNumber;
  formTemplateId?: FormResponseOutFormTemplateId;
  formTemplateName?: FormResponseOutFormTemplateName;
  formMenu?: FormResponseOutFormMenu;
  formBuiltinKey?: FormResponseOutFormBuiltinKey;
  needsApproval?: boolean;
  customerId?: FormResponseOutCustomerId;
  customerName?: FormResponseOutCustomerName;
  customerPhone?: FormResponseOutCustomerPhone;
  customerEmail?: FormResponseOutCustomerEmail;
  staffId?: FormResponseOutStaffId;
  staffName?: FormResponseOutStaffName;
  status?: string;
  signedOn?: string;
  decidedById?: FormResponseOutDecidedById;
  decidedByName?: FormResponseOutDecidedByName;
  decidedAt?: FormResponseOutDecidedAt;
  hmDecidedById?: FormResponseOutHmDecidedById;
  hmDecidedByName?: FormResponseOutHmDecidedByName;
  hmDecidedAt?: FormResponseOutHmDecidedAt;
  hmSkipped?: boolean;
  decisionReason?: FormResponseOutDecisionReason;
  responses: FormResponseOutResponses;
  customerSignature: FormResponseOutCustomerSignature;
  staffSignature: FormResponseOutStaffSignature;
  signedAt: string;
  collectedById: string;
  collectedByName?: FormResponseOutCollectedByName;
  outletId: FormResponseOutOutletId;
  outletCode?: FormResponseOutOutletCode;
  createdAt: string;
  creditWarnings?: string[];
}

/**
 * GEN-06-22 item 4 — the reason is required; an empty one is a 422.
 */
export interface FormResponseReject {
  reason: string;
}

export type FormSubmissionCreateFormType = typeof FormSubmissionCreateFormType[keyof typeof FormSubmissionCreateFormType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormSubmissionCreateFormType = {
  DAMAGE_REPORT: 'DAMAGE_REPORT',
  COMPLIMENT_FEEDBACK: 'COMPLIMENT_FEEDBACK',
} as const;

export type FormSubmissionCreateOutletId = string | null;

export type FormSubmissionCreateAnswers = { [key: string]: unknown };

export type FormSubmissionCreateAttachmentData = string | null;

export interface FormSubmissionCreate {
  formType: FormSubmissionCreateFormType;
  outletId?: FormSubmissionCreateOutletId;
  answers?: FormSubmissionCreateAnswers;
  attachmentData?: FormSubmissionCreateAttachmentData;
}

export type FormSubmissionListItemFormType = typeof FormSubmissionListItemFormType[keyof typeof FormSubmissionListItemFormType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormSubmissionListItemFormType = {
  DAMAGE_REPORT: 'DAMAGE_REPORT',
  COMPLIMENT_FEEDBACK: 'COMPLIMENT_FEEDBACK',
} as const;

export type FormSubmissionListItemOutletId = string | null;

export type FormSubmissionListItemOutletName = string | null;

export type FormSubmissionListItemAnswers = { [key: string]: unknown };

export type FormSubmissionListItemSubmittedById = string | null;

export type FormSubmissionListItemSubmittedByName = string | null;

/**
 * List row — omits the (large) ``attachment_data``; fetch the detail
endpoint for the photo. ``has_attachment`` tells the UI whether to offer it.
 */
export interface FormSubmissionListItem {
  id: string;
  formType: FormSubmissionListItemFormType;
  outletId?: FormSubmissionListItemOutletId;
  outletName?: FormSubmissionListItemOutletName;
  answers: FormSubmissionListItemAnswers;
  hasAttachment: boolean;
  submittedById?: FormSubmissionListItemSubmittedById;
  submittedByName?: FormSubmissionListItemSubmittedByName;
  createdAt: string;
}

export interface FormSubmissionListResponse {
  items: FormSubmissionListItem[];
  total: number;
}

export type FormSubmissionResponseFormType = typeof FormSubmissionResponseFormType[keyof typeof FormSubmissionResponseFormType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormSubmissionResponseFormType = {
  DAMAGE_REPORT: 'DAMAGE_REPORT',
  COMPLIMENT_FEEDBACK: 'COMPLIMENT_FEEDBACK',
} as const;

export type FormSubmissionResponseOutletId = string | null;

export type FormSubmissionResponseOutletName = string | null;

export type FormSubmissionResponseAnswers = { [key: string]: unknown };

export type FormSubmissionResponseAttachmentData = string | null;

export type FormSubmissionResponseSubmittedById = string | null;

export type FormSubmissionResponseSubmittedByName = string | null;

export interface FormSubmissionResponse {
  id: string;
  formType: FormSubmissionResponseFormType;
  outletId?: FormSubmissionResponseOutletId;
  outletName?: FormSubmissionResponseOutletName;
  answers: FormSubmissionResponseAnswers;
  attachmentData?: FormSubmissionResponseAttachmentData;
  submittedById?: FormSubmissionResponseSubmittedById;
  submittedByName?: FormSubmissionResponseSubmittedByName;
  createdAt: string;
}

export type FormTemplateCreateMenu = typeof FormTemplateCreateMenu[keyof typeof FormTemplateCreateMenu];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormTemplateCreateMenu = {
  CUSTOMERS: 'CUSTOMERS',
  SALES: 'SALES',
  HR: 'HR',
  MARKETING: 'MARKETING',
} as const;

export type FormTemplateCreateDescription = string | null;

export type FormTemplateCreateEffectiveDate = string | null;

export type FormTemplateCreateContent = { [key: string]: unknown };

export interface FormTemplateCreate {
  name: string;
  menu?: FormTemplateCreateMenu;
  description?: FormTemplateCreateDescription;
  needsApproval?: boolean;
  outletIds?: string[];
  outletScope?: string;
  language?: string;
  effectiveDate?: FormTemplateCreateEffectiveDate;
  content: FormTemplateCreateContent;
}

export type FormTemplateEventOutVersionNumber = number | null;

export type FormTemplateEventOutDetail = string | null;

export type FormTemplateEventOutActorId = string | null;

export type FormTemplateEventOutActorName = string | null;

/**
 * One line of the History window (GEN-06-21), newest first.
 */
export interface FormTemplateEventOut {
  id: string;
  formTemplateId: string;
  action: string;
  versionNumber?: FormTemplateEventOutVersionNumber;
  detail?: FormTemplateEventOutDetail;
  actorId?: FormTemplateEventOutActorId;
  actorName?: FormTemplateEventOutActorName;
  createdAt: string;
}

/**
 * ``published`` / ``draft`` are counted over the *unfiltered* set so the
status tiles above the table keep their totals when the table is filtered
down to one of them.
 */
export interface FormTemplateListResponse {
  templates: FormTemplateOut[];
  total: number;
  published: number;
  draft: number;
  inactive?: number;
}

export type FormTemplateOutDescription = string | null;

export type FormTemplateOutBuiltinKey = string | null;

export type FormTemplateOutCurrentVersionId = string | null;

export type FormTemplateOutCurrentVersionNumber = number | null;

export type FormTemplateOutEffectiveDate = string | null;

export type FormTemplateOutCreatedByName = string | null;

export interface FormTemplateOut {
  id: string;
  name: string;
  menu: string;
  description?: FormTemplateOutDescription;
  needsApproval?: boolean;
  builtinKey?: FormTemplateOutBuiltinKey;
  sortOrder?: number;
  status: string;
  currentVersionId: FormTemplateOutCurrentVersionId;
  currentVersionNumber?: FormTemplateOutCurrentVersionNumber;
  outletIds?: string[];
  outletScope: string;
  language: string;
  effectiveDate: FormTemplateOutEffectiveDate;
  createdById: string;
  createdByName?: FormTemplateOutCreatedByName;
  createdAt: string;
  updatedAt: string;
}

export type FormTemplateUpdateName = string | null;

export type FormTemplateUpdateDescription = string | null;

export type FormTemplateUpdateNeedsApproval = boolean | null;

export type FormTemplateUpdateOutletIds = string[] | null;

export type FormTemplateUpdateOutletScope = string | null;

export type FormTemplateUpdateLanguage = string | null;

export type FormTemplateUpdateEffectiveDate = string | null;

export type FormTemplateUpdateStatus = string | null;

/**
 * Metadata only. Content edits go through ``POST /{id}/versions`` — a
published version is immutable, so there is no field here that could touch
it.
 */
export interface FormTemplateUpdate {
  name?: FormTemplateUpdateName;
  description?: FormTemplateUpdateDescription;
  needsApproval?: FormTemplateUpdateNeedsApproval;
  outletIds?: FormTemplateUpdateOutletIds;
  outletScope?: FormTemplateUpdateOutletScope;
  language?: FormTemplateUpdateLanguage;
  effectiveDate?: FormTemplateUpdateEffectiveDate;
  status?: FormTemplateUpdateStatus;
}

export type FormVersionCreateContent = { [key: string]: unknown };

export interface FormVersionCreate {
  content: FormVersionCreateContent;
}

export type FormVersionOutContent = { [key: string]: unknown };

export type FormVersionOutPublishedAt = string | null;

export type FormVersionOutPublishedById = string | null;

export type FormVersionOutPublishedByName = string | null;

export type FormVersionOutUpdatedById = string | null;

export type FormVersionOutUpdatedByName = string | null;

export interface FormVersionOut {
  id: string;
  formTemplateId: string;
  versionNumber: number;
  content: FormVersionOutContent;
  status: string;
  publishedAt: FormVersionOutPublishedAt;
  publishedById: FormVersionOutPublishedById;
  publishedByName?: FormVersionOutPublishedByName;
  updatedById?: FormVersionOutUpdatedById;
  updatedByName?: FormVersionOutUpdatedByName;
  createdAt: string;
}

export type GroupRefundItemSessions = number | null;

/**
 * One treatment (package) of a refund of several (D23-8).
 */
export interface GroupRefundItem {
  packageId: string;
  sessions?: GroupRefundItemSessions;
}

export type GroupRefundQuoteItemProgramName = string | null;

export interface GroupRefundQuoteItem {
  packageId: string;
  programName?: GroupRefundQuoteItemProgramName;
  remainingSessions: number;
  refundSessions: number;
  usedSessions: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  computedValue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  requestedAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  adminChargeAmount: string;
}

export type GroupRefundQuoteRequestAmount = number | string | null;

/**
 * POST /finance/refunds/group/quote (D23-8, Angela 23 Oct 2026): several
treatments of ONE invoice refunded together.
 */
export interface GroupRefundQuoteRequest {
  items?: GroupRefundItem[];
  applyAdminCharge?: boolean;
  amount?: GroupRefundQuoteRequestAmount;
}

export type GroupRefundQuoteResponseSaleId = string | null;

export type GroupRefundQuoteResponseInvoiceNumber = string | null;

export type GroupRefundQuoteResponseReason = string | null;

export interface GroupRefundQuoteResponse {
  saleId?: GroupRefundQuoteResponseSaleId;
  invoiceNumber?: GroupRefundQuoteResponseInvoiceNumber;
  items?: GroupRefundQuoteItem[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  invoiceReceived?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  earlierRefunds?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cap?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  computedValue?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  requestedAmount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  adminChargeAmount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  finalAmount?: string;
  blocked?: boolean;
  reason?: GroupRefundQuoteResponseReason;
  overHalfUsed?: boolean;
}

export type GroupRefundRequestAmount = number | string | null;

export type GroupRefundRequestOutletId = string | null;

export type GroupRefundRequestCustomerSignature = string | null;

export type GroupRefundRequestStaffSignature = string | null;

export type GroupRefundRequestRefundForm = RefundAppealForm | null;

/**
 * POST /finance/refunds/group — submit the refund of several treatments
of one invoice as ONE request, for ONE approval.
 */
export interface GroupRefundRequest {
  items?: GroupRefundItem[];
  applyAdminCharge?: boolean;
  amount?: GroupRefundRequestAmount;
  reason: string;
  outletId?: GroupRefundRequestOutletId;
  customerSignature?: GroupRefundRequestCustomerSignature;
  staffSignature?: GroupRefundRequestStaffSignature;
  refundForm?: GroupRefundRequestRefundForm;
  refundAsCreditNote?: boolean;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export type HealthResponseStatus = string | null;

export type HealthResponseVersion = string | null;

export type HealthResponseUptime = number | null;

export type HealthResponseDbStatus = string | null;

export type HealthResponseTimestamp = string | null;

/**
 * Health-check response schema.
 */
export interface HealthResponse {
  status?: HealthResponseStatus;
  version?: HealthResponseVersion;
  uptime?: HealthResponseUptime;
  dbStatus?: HealthResponseDbStatus;
  timestamp?: HealthResponseTimestamp;
}

export type HeldInvoiceCreateAmount = number | string;

export type HeldInvoiceCreatePayload = { [key: string]: unknown };

/**
 * Hold — the New Invoice form as it is. Only the customer is required
(SAL-15-09); the rest is kept exactly as entered.
 */
export interface HeldInvoiceCreate {
  /** @minLength 1 */
  outletId: string;
  /** @minLength 1 */
  customerId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  customerName: string;
  /** @maxLength 500 */
  itemsSummary?: string;
  amount?: HeldInvoiceCreateAmount;
  payload: HeldInvoiceCreatePayload;
}

export type HeldInvoiceDetailPayload = { [key: string]: unknown };

export interface HeldInvoiceDetail {
  id: string;
  outletId: string;
  customerId: string;
  customerName: string;
  itemsSummary: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  heldById: string;
  heldByName: string;
  createdAt: string;
  payload: HeldInvoiceDetailPayload;
}

export interface HeldInvoiceList {
  rows: HeldInvoiceOut[];
  total: number;
}

export interface HeldInvoiceOut {
  id: string;
  outletId: string;
  customerId: string;
  customerName: string;
  itemsSummary: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  heldById: string;
  heldByName: string;
  createdAt: string;
}

export interface HistoryResponse {
  appointments?: AppointmentListItem[];
  total: number;
}

/**
 * SAL-11 — the IHIP form as the customer completed it on Create Invoice.
The amounts and dates are the invoice's, worked out by the server.
 */
export interface IHIPAgreementCreate {
  idNumberTail: string;
  acknowledged: boolean;
  signature: string;
}

export type IHIPAgreementResponseInvoiceNumber = string | null;

export type IHIPAgreementResponseIhipPlanId = string | null;

export type IHIPAgreementResponseCreatedAt = string | null;

/**
 * GET /finance/sales/{id}/ihip-agreement — the signed IHIP form.
 */
export interface IHIPAgreementResponse {
  id: string;
  saleId: string;
  invoiceNumber?: IHIPAgreementResponseInvoiceNumber;
  ihipPlanId?: IHIPAgreementResponseIhipPlanId;
  idNumberTail: string;
  acknowledged: boolean;
  signature: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  initialAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  balanceAmount: string;
  startDate: string;
  completionDate: string;
  createdAt?: IHIPAgreementResponseCreatedAt;
}

/**
 * GET /finance/ihip/alerts — plans with outstanding > 0.
 */
export interface IHIPAlertListResponse {
  alerts?: IHIPAlertResponse[];
  total: number;
}

export type IHIPAlertResponseCustomerName = string | null;

export type IHIPAlertResponseNextDueSessionNumber = number | null;

export type IHIPAlertResponseNextDueAmount = string | null;

/**
 * A single IHIP plan with an outstanding balance (FIN-C1 alerts).
 */
export interface IHIPAlertResponse {
  packageId: string;
  ihipPlanId: string;
  customerId: string;
  customerName?: IHIPAlertResponseCustomerName;
  planVariant: string;
  totalSessions: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountPaid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  status: string;
  usedSessions: number;
  overdue: boolean;
  nextDueSessionNumber?: IHIPAlertResponseNextDueSessionNumber;
  nextDueAmount?: IHIPAlertResponseNextDueAmount;
}

export type IHIPCollectRequestAmount = number | string;

/**
 * POST /finance/ihip/{packageId}/collect — record an installment payment.
 */
export interface IHIPCollectRequest {
  sessionNumber: number;
  amount: IHIPCollectRequestAmount;
  method?: string;
}

export type IHIPPlanResponseCreatedAt = string | null;

export type IHIPPlanResponseUpdatedAt = string | null;

/**
 * GET /finance/ihip/{packageId} — the plan header + its schedule items.
 */
export interface IHIPPlanResponse {
  id: string;
  packageId: string;
  customerId: string;
  planVariant: string;
  totalSessions: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountPaid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  status: string;
  schedule?: InstallmentScheduleItemResponse[];
  createdAt?: IHIPPlanResponseCreatedAt;
  updatedAt?: IHIPPlanResponseUpdatedAt;
}

/**
 * One projected per-session collection (pre-sale, not persisted).
 */
export interface IHIPSchedulePreviewItem {
  sessionNumber: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountDue: string;
}

export type IHIPSchedulePreviewResponseProgramName = string | null;

export type IHIPSchedulePreviewResponseDownPayment = string | null;

export type IHIPSchedulePreviewResponseScheduledTotal = string | null;

/**
 * GET /finance/ihip/schedule-preview — whether an IHIP plan exists for a
(program, variant, sessions) selection and, if so, the §8.3 down-payment
(session 1) + full schedule. Lets the POS show the real down-payment and
block unconfigured combos before ring-up (only a subset of §8.3 is seeded).
 */
export interface IHIPSchedulePreviewResponse {
  available: boolean;
  programId: string;
  programName?: IHIPSchedulePreviewResponseProgramName;
  variant: string;
  totalSessions: number;
  downPayment?: IHIPSchedulePreviewResponseDownPayment;
  scheduledTotal?: IHIPSchedulePreviewResponseScheduledTotal;
  schedule?: IHIPSchedulePreviewItem[];
}

export interface ImportPreview {
  tabs?: ImportTabPreview[];
  totalToImport?: number;
  wheelockPlaceTexts?: number;
  starVistaTexts?: number;
}

export interface ImportResult {
  created: number;
  preview: ImportPreview;
}

/**
 * One sheet row that will become a draft template.
 */
export interface ImportRowPreview {
  name: string;
  firstLineWp: string;
  firstLineSv: string;
}

export type ImportTabPreviewSituation = Situation | null;

export type ImportTabPreviewGender = TemplateGender | null;

/**
 * One tab of the sheet: what it maps to and what would be imported.
 */
export interface ImportTabPreview {
  tab: string;
  situation?: ImportTabPreviewSituation;
  gender?: ImportTabPreviewGender;
  toImport?: number;
  skippedEmpty?: number;
  skippedIncomplete?: number;
  skippedExisting?: number;
  skippedBad?: number;
  rows?: ImportRowPreview[];
  problems?: string[];
}

export type InsightColumnFormat = typeof InsightColumnFormat[keyof typeof InsightColumnFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsightColumnFormat = {
  text: 'text',
  money: 'money',
  number: 'number',
  percent: 'percent',
  date: 'date',
  datetime: 'datetime',
} as const;

export interface InsightColumn {
  key: string;
  label: string;
  format?: InsightColumnFormat;
}

/**
 * One entry of the 'Criteria · <name>: <value>' line (GEN-13-03).
 */
export interface InsightCriterion {
  label: string;
  value: string;
}

export interface InsightReportResponse {
  reportName: string;
  title: string;
  criteria?: InsightCriterion[];
  tiles?: InsightTile[];
  tabs?: InsightTab[];
  notes?: string[];
}

export type InsightTabRowsItem = { [key: string]: unknown };

export type InsightTabTotalsAnyOf = { [key: string]: unknown };

export type InsightTabTotals = InsightTabTotalsAnyOf | null;

export type InsightTabEmptyMessage = string | null;

export interface InsightTab {
  key: string;
  label: string;
  columns?: InsightColumn[];
  rows?: InsightTabRowsItem[];
  totals?: InsightTabTotals;
  emptyMessage?: InsightTabEmptyMessage;
}

export type InsightTileFormat = typeof InsightTileFormat[keyof typeof InsightTileFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsightTileFormat = {
  money: 'money',
  number: 'number',
  percent: 'percent',
} as const;

export type InsightTileHint = string | null;

export interface InsightTile {
  key: string;
  label: string;
  value: number;
  format?: InsightTileFormat;
  hint?: InsightTileHint;
}

export type InstallmentScheduleItemResponsePaidAt = string | null;

export type InstallmentScheduleItemResponseCreatedAt = string | null;

/**
 * A persisted per-session scheduled collection row (§5.5).
 */
export interface InstallmentScheduleItemResponse {
  id: string;
  ihipPlanId: string;
  sessionNumber: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountDue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountPaid: string;
  dueStatus: string;
  paidAt?: InstallmentScheduleItemResponsePaidAt;
  createdAt?: InstallmentScheduleItemResponseCreatedAt;
}

export interface InventoryLevelResponse {
  stockLocationId: string;
  stockLocationName: string;
  stockLocationCode: string;
  rows: InventoryLevelRowResponse[];
  total: number;
}

export type InventoryLevelRowResponseSku = string | null;

export type InventoryLevelRowResponseCategory = string | null;

export type InventoryLevelRowResponseBrand = string | null;

export type InventoryLevelRowResponseMinQty = number | null;

/**
 * One line of Inventory Level (INV-10-07): Category · Brand · Status · Name ·
SKU · Use · Unit · Min. stock lvl · On hand, for the chosen place.
 */
export interface InventoryLevelRowResponse {
  productId: string;
  name: string;
  sku: InventoryLevelRowResponseSku;
  category: InventoryLevelRowResponseCategory;
  brand: InventoryLevelRowResponseBrand;
  unit: string;
  isActive: boolean;
  isRetail: boolean;
  isBackBar: boolean;
  minQty: InventoryLevelRowResponseMinQty;
  onHand: number;
}

export type KioskClockRemark = string | null;

export interface KioskClock {
  token: string;
  staffId: string;
  /** @pattern ^\d{4}$ */
  pin: string;
  action: AttendanceAction;
  remark?: KioskClockRemark;
}

export interface KioskClockResponse {
  message: string;
  line: TodayLine;
}

export interface KioskResponse {
  outletId: string;
  outletName: string;
  deviceName: string;
  date: string;
  now: string;
  staff?: TodayLine[];
}

export type KpiCellOwner = string | null;

export type KpiCellValue = number | null;

export type KpiCellToday = number | null;

export type KpiCellTarget = number | null;

export type KpiCellExpectedToday = number | null;

export type KpiCellGap = number | null;

export type KpiCellNumerator = number | null;

export type KpiCellDenominator = number | null;

export type KpiCellDetail = string | null;

/**
 * One KPI of one outlet (DSH-16-05). ``status``: on_pace · ahead · behind ·
reached · on_target · below_target · within_limit · over_limit · left ·
no_target · no_data. ``gap`` > 0 = ahead of the pro-rated target (counts),
points above the target (rates) or room left under a maximum.
 */
export interface KpiCell {
  key: string;
  owner?: KpiCellOwner;
  value?: KpiCellValue;
  today?: KpiCellToday;
  target?: KpiCellTarget;
  expectedToday?: KpiCellExpectedToday;
  status: string;
  gap?: KpiCellGap;
  numerator?: KpiCellNumerator;
  denominator?: KpiCellDenominator;
  detail?: KpiCellDetail;
}

/**
 * GET /dashboard/kpis — the KPI table, month so far.
 */
export interface KpiTableResponse {
  monthStart: string;
  daysGone: number;
  daysInMonth: number;
  outlets: OutletKpis[];
}

export type LTVCaptureResponseMostPopularProgram = string | null;

export type LTVCaptureResponseMostPopularProgramId = string | null;

export type LTVCaptureResponseLastVisitAt = string | null;

export type LTVCaptureResponseFirstSeenAt = string | null;

export type LTVCaptureResponseReferralSource = string | null;

/**
 * GET /finance/reports/ltv — FIN-G2 (capture only; dashboards are Phase 4).

Per-customer LTV data capture: ``totalSpend`` = Σ COMPLETED ``Sale.total``
minus refunds; ``packagesPurchased`` count; ``mostPopularProgram`` (the
program with the most packages/sessions for this customer); ``lastVisitAt``
(latest appointment or sale — churn signal); ``firstSeenAt`` (earliest);
``referralSource`` (from ``Customer.referralSource`` if set).
 */
export interface LTVCaptureResponse {
  customerId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalSpend: string;
  packagesPurchased: number;
  mostPopularProgram?: LTVCaptureResponseMostPopularProgram;
  mostPopularProgramId?: LTVCaptureResponseMostPopularProgramId;
  lastVisitAt?: LTVCaptureResponseLastVisitAt;
  firstSeenAt?: LTVCaptureResponseFirstSeenAt;
  referralSource?: LTVCaptureResponseReferralSource;
}

/**
 * The four dot colours (LEA-01-01) — nothing else.
 */
export type LeadColour = typeof LeadColour[keyof typeof LeadColour];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadColour = {
  red: 'red',
  orange: 'orange',
  green: 'green',
  grey: 'grey',
} as const;

export type LeadContactCreateListKey = LeadListKey | null;

export type LeadContactCreateChannel = ContactChannel | null;

export type LeadContactCreateNote = string | null;

export type LeadContactCreateNextContactDate = string | null;

export type LeadContactCreateCloseReason = string | null;

export type LeadContactCreateAppointmentId = string | null;

export type LeadContactCreateMessageTemplateId = string | null;

/**
 * POST .../contacts — one contact, with its results in the order pressed.

Staff type nothing except an optional note (LEA-03-02). The date and time,
staff, contact number and — except for Other — the next contact date are
filled in by the OS.
 */
export interface LeadContactCreate {
  listKey?: LeadContactCreateListKey;
  channel?: LeadContactCreateChannel;
  /**
   * @minItems 1
   * @maxItems 10
   */
  steps: LeadContactStepIn[];
  note?: LeadContactCreateNote;
  nextContactDate?: LeadContactCreateNextContactDate;
  closeReason?: LeadContactCreateCloseReason;
  appointmentId?: LeadContactCreateAppointmentId;
  messageTemplateId?: LeadContactCreateMessageTemplateId;
  /** @maxItems 10 */
  messagePictureIds?: string[];
}

export type LeadContactHistoryCustomerId = string | null;

export type LeadContactHistoryLeadId = string | null;

export type LeadContactHistoryDoNotContact = DncOut | null;

export type LeadContactHistoryNextContactDate = string | null;

export type LeadContactHistoryTrialPrice = TrialPriceBadge | null;

export type LeadContactHistoryConsultNeeded = CheckConsultation | null;

export type LeadContactHistoryLastVisit = string | null;

export type LeadContactHistoryPackageSummary = string | null;

export type LeadContactHistoryNextAppointmentDate = string | null;

export type LeadContactHistoryNextAppointmentTime = string | null;

/**
 * GET .../contacts — her history plus what the panel shows at the top.
 */
export interface LeadContactHistory {
  customerId?: LeadContactHistoryCustomerId;
  leadId?: LeadContactHistoryLeadId;
  name: string;
  mobile: string;
  contactsThisMonth: number;
  contactsLastMonth: number;
  contactGoal: number;
  lists?: LeadListKey[];
  doNotContact?: LeadContactHistoryDoNotContact;
  closed?: boolean;
  nextContactDate?: LeadContactHistoryNextContactDate;
  trialPrice?: LeadContactHistoryTrialPrice;
  consultNeeded?: LeadContactHistoryConsultNeeded;
  lastVisit?: LeadContactHistoryLastVisit;
  visits?: number;
  packageSummary?: LeadContactHistoryPackageSummary;
  nextAppointmentDate?: LeadContactHistoryNextAppointmentDate;
  nextAppointmentTime?: LeadContactHistoryNextAppointmentTime;
  items?: LeadContactOut[];
}

export type LeadContactOutCustomerId = string | null;

export type LeadContactOutLeadId = string | null;

export type LeadContactOutListKey = LeadListKey | null;

export type LeadContactOutChannel = ContactChannel | null;

export type LeadContactOutContactNumber = number | null;

export type LeadContactOutNote = string | null;

export type LeadContactOutNextContactDate = string | null;

export type LeadContactOutCloseReason = string | null;

export type LeadContactOutAppointmentId = string | null;

export type LeadContactOutStaffUserId = string | null;

export type LeadContactOutStaffName = string | null;

export type LeadContactOutMessageTemplate = string | null;

/**
 * One line of her contact history.
 */
export interface LeadContactOut {
  id: string;
  customerId?: LeadContactOutCustomerId;
  leadId?: LeadContactOutLeadId;
  kind: ContactKind;
  listKey?: LeadContactOutListKey;
  channel?: LeadContactOutChannel;
  contactNumber?: LeadContactOutContactNumber;
  steps?: LeadContactStepOut[];
  note?: LeadContactOutNote;
  nextContactDate?: LeadContactOutNextContactDate;
  closesRow?: boolean;
  closeReason?: LeadContactOutCloseReason;
  appointmentId?: LeadContactOutAppointmentId;
  staffUserId?: LeadContactOutStaffUserId;
  staffName?: LeadContactOutStaffName;
  messageTemplate?: LeadContactOutMessageTemplate;
  messagePictures?: string[];
  createdAt: string;
}

export type LeadContactStepInDetail = string | null;

export interface LeadContactStepIn {
  result: ContactResult;
  detail?: LeadContactStepInDetail;
}

export type LeadContactStepOutDetail = string | null;

export interface LeadContactStepOut {
  result: ContactResult;
  detail?: LeadContactStepOutDetail;
  pressedAt: string;
}

export type LeadCreateGender = string | null;

export type LeadCreateReferringCustomerId = string | null;

export type LeadCreatePreferredDate = string | null;

export type LeadCreatePreferredTime = string | null;

export type LeadCreateNotes = string | null;

export type LeadCreateOutletId = string | null;

export type LeadCreateCustomerId = string | null;

/**
 * Add lead (LEA-07-02): walk-ins and referrals, typed by staff.
 */
export interface LeadCreate {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 3
   * @maxLength 40
   */
  phone: string;
  gender?: LeadCreateGender;
  source: LeadSource;
  referringCustomerId?: LeadCreateReferringCustomerId;
  preferredDate?: LeadCreatePreferredDate;
  preferredTime?: LeadCreatePreferredTime;
  notes?: LeadCreateNotes;
  outletId?: LeadCreateOutletId;
  customerId?: LeadCreateCustomerId;
  keepSeparate?: boolean;
}

export type LeadLinkCustomerId = string | null;

/**
 * The same-phone decision, made later from the row (LEA-07-10).
 */
export interface LeadLink {
  customerId?: LeadLinkCustomerId;
  keepSeparate?: boolean;
}

/**
 * Which Leads list. One value per tab on the Leads page.
 */
export type LeadListKey = typeof LeadListKey[keyof typeof LeadListKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadListKey = {
  new: 'new',
  existing: 'existing',
  finishing: 'finishing',
  'inactive-package': 'inactive-package',
  'inactive-no-package': 'inactive-no-package',
  vip: 'vip',
  ycp: 'ycp',
  'bal-pay': 'bal-pay',
} as const;

/**
 * GET /api/leads/lists/{list_key}.
 */
export interface LeadListResponse {
  listKey: LeadListKey;
  asOf: string;
  total: number;
  rows?: LeadRow[];
}

export type LeadMatchCustomerLastVisit = string | null;

export interface LeadMatchCustomer {
  customerId: string;
  name: string;
  mobile: string;
  lastVisit?: LeadMatchCustomerLastVisit;
}

export interface LeadMatchLead {
  leadId: string;
  name: string;
  inDate: string;
}

/**
 * Possible matches for a phone number (LEA-07-04): shown, never merged.
 */
export interface LeadMatches {
  customers?: LeadMatchCustomer[];
  leads?: LeadMatchLead[];
}

export type LeadOutOutletId = string | null;

export type LeadOutGender = string | null;

export type LeadOutReferringCustomerId = string | null;

export type LeadOutReferringCustomerName = string | null;

export type LeadOutPreferredDate = string | null;

export type LeadOutPreferredTime = string | null;

export type LeadOutNotes = string | null;

export type LeadOutCustomerId = string | null;

export type LeadOutCreatedBy = string | null;

export interface LeadOut {
  id: string;
  outletId?: LeadOutOutletId;
  name: string;
  phone: string;
  gender?: LeadOutGender;
  source: LeadSource;
  referringCustomerId?: LeadOutReferringCustomerId;
  referringCustomerName?: LeadOutReferringCustomerName;
  preferredDate?: LeadOutPreferredDate;
  preferredTime?: LeadOutPreferredTime;
  notes?: LeadOutNotes;
  customerId?: LeadOutCustomerId;
  keepSeparate?: boolean;
  createdBy?: LeadOutCreatedBy;
  createdAt: string;
  matches?: LeadMatches;
}

export interface LeadPipelineResponse {
  year: number;
  month: number;
  outlets: LeadPipelineRow[];
  total: LeadPipelineRow;
}

/**
 * D · Lead pipeline (DSH-16-08), month to date, one outlet (or the total).
Counts only: leads, saved follow-up contacts, appointments made from them,
and consultations with new customers that ended in a same-day package.
 */
export interface LeadPipelineRow {
  outletCode: string;
  newLeads?: number;
  contacts?: number;
  appointmentsMade?: number;
  consultationsNew?: number;
  consultationsConverted?: number;
}

export type LeadRowOutletCode = string | null;

export type LeadRowBand = string | null;

export type LeadRowLastVisit = string | null;

export type LeadRowDaysSince = number | null;

export type LeadRowExpiryDate = string | null;

export type LeadRowConsulted = string | null;

export type LeadRowConsultationResult = string | null;

export type LeadRowNextAppointment = string | null;

export type LeadRowItem = string | null;

export type LeadRowItemLeft = number | null;

export type LeadRowItemExpiry = string | null;

export type LeadRowItemTotal = number | null;

export type LeadRowDaysLeft = number | null;

export type LeadRowReason = string | null;

export type LeadRowRegisteringOutlet = string | null;

export type LeadRowPackageType = string | null;

export type LeadRowAwayBand = string | null;

export type LeadRowVisits = number | null;

export type LeadRowLastPurchase = string | null;

export type LeadRowLeadId = string | null;

export type LeadRowInDate = string | null;

export type LeadRowSource = LeadSource | null;

export type LeadRowPreferredDate = string | null;

export type LeadRowPreferredTime = string | null;

export type LeadRowGender = string | null;

export type LeadRowBought = string | null;

export type LeadRowCustomerKind = string | null;

export type LeadRowStatus = string | null;

export type LeadRowRemarks = string | null;

export type LeadRowNextContactDate = string | null;

export type LeadRowCloseReason = string | null;

export type LeadRowTrialPrice = TrialPriceBadge | null;

export type LeadRowInvoiceNumber = string | null;

export type LeadRowInvoiceDate = string | null;

export type LeadRowAmount = string | null;

export type LeadRowPaid = string | null;

export type LeadRowOutstanding = string | null;

export type LeadRowCompleteBy = string | null;

export type LeadRowBalGrade = string | null;

export type LeadRowBalanceOwed = string | null;

export type LeadRowBalanceDaysOverdue = number | null;

export type LeadRowVipSpent = string | null;

export type LeadRowVipLeft = string | null;

/**
 * One customer on one list. Fields a list does not use stay null.
 */
export interface LeadRow {
  customerId: string;
  name: string;
  mobile: string;
  outletCode?: LeadRowOutletCode;
  colour: LeadColour;
  band?: LeadRowBand;
  lastVisit?: LeadRowLastVisit;
  daysSince?: LeadRowDaysSince;
  sessionsLeft?: number;
  expiryDate?: LeadRowExpiryDate;
  consulted?: LeadRowConsulted;
  consultationResult?: LeadRowConsultationResult;
  nextAppointment?: LeadRowNextAppointment;
  noMarketingConsent?: boolean;
  noConsentForm?: boolean;
  tags?: LeadTag[];
  item?: LeadRowItem;
  itemLeft?: LeadRowItemLeft;
  itemExpiry?: LeadRowItemExpiry;
  itemTotal?: LeadRowItemTotal;
  daysLeft?: LeadRowDaysLeft;
  reason?: LeadRowReason;
  registeringOutlet?: LeadRowRegisteringOutlet;
  packageType?: LeadRowPackageType;
  awayBand?: LeadRowAwayBand;
  visits?: LeadRowVisits;
  lastPurchase?: LeadRowLastPurchase;
  pastConsultations?: string[];
  consultNeeded?: boolean;
  doNotContact?: boolean;
  leadId?: LeadRowLeadId;
  inDate?: LeadRowInDate;
  source?: LeadRowSource;
  preferredDate?: LeadRowPreferredDate;
  preferredTime?: LeadRowPreferredTime;
  gender?: LeadRowGender;
  bought?: LeadRowBought;
  customerKind?: LeadRowCustomerKind;
  matchCount?: number;
  contacts?: ContactBox[];
  contactGoal?: number;
  contactsLastMonth?: number;
  status?: LeadRowStatus;
  remarks?: LeadRowRemarks;
  remarksMore?: number;
  nextContactDate?: LeadRowNextContactDate;
  closed?: boolean;
  closeReason?: LeadRowCloseReason;
  trialPrice?: LeadRowTrialPrice;
  invoiceNumber?: LeadRowInvoiceNumber;
  invoiceDate?: LeadRowInvoiceDate;
  amount?: LeadRowAmount;
  paid?: LeadRowPaid;
  outstanding?: LeadRowOutstanding;
  completeBy?: LeadRowCompleteBy;
  completeByUrgent?: boolean;
  balGrade?: LeadRowBalGrade;
  alsoOn?: LeadListKey[];
  balanceOwed?: LeadRowBalanceOwed;
  balanceDaysOverdue?: LeadRowBalanceDaysOverdue;
  vipSpent?: LeadRowVipSpent;
  vipLeft?: LeadRowVipLeft;
}

/**
 * Where a New Lead came from (LEA-07-02). Staff add WALK_IN and REFERRAL;
the lead-form intake (phase 2) will write FACEBOOK / INSTAGRAM / WEBSITE.
 */
export type LeadSource = typeof LeadSource[keyof typeof LeadSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadSource = {
  WALK_IN: 'WALK_IN',
  REFERRAL: 'REFERRAL',
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  WEBSITE: 'WEBSITE',
  OTHER: 'OTHER',
} as const;

/**
 * Cross-list text tags shown after the name (LEA-27-15).
 */
export type LeadTag = typeof LeadTag[keyof typeof LeadTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadTag = {
  'also-in-finishing': 'also-in-finishing',
  'also-in-inactive': 'also-in-inactive',
} as const;

export type LeadsDailyTargetsRows = {[key: string]: {[key: string]: number}};

/**
 * LEA-16 'Daily targets' — read-only here; kept on Dashboard > Set targets.
 */
export interface LeadsDailyTargets {
  outletCode: string;
  rows: LeadsDailyTargetsRows;
  masterCoverPercent: number;
}

export type LeadsSettingChangeOutletId = string | null;

export type LeadsSettingChangeChangedBy = string | null;

/**
 * One line of the settings history: date, who, old value -> new value.
 */
export interface LeadsSettingChange {
  id: string;
  key: string;
  outletId?: LeadsSettingChangeOutletId;
  value: unknown;
  previous?: unknown;
  effectiveFrom: string;
  changedBy?: LeadsSettingChangeChangedBy;
  changedAt: string;
}

export interface LeadsSettingDef {
  key: string;
  section: string;
  label: string;
  kind: string;
}

export type LeadsSettingUpdateOutletId = string | null;

export interface LeadsSettingUpdate {
  value: unknown;
  outletId?: LeadsSettingUpdateOutletId;
}

export type LeadsSettingsScreenOutletId = string | null;

export type LeadsSettingsScreenValues = { [key: string]: unknown };

export type LeadsSettingsScreenDefaults = { [key: string]: unknown };

export type LeadsSettingsScreenDailyTargets = LeadsDailyTargets | null;

export interface LeadsSettingsScreen {
  asOf: string;
  outletId?: LeadsSettingsScreenOutletId;
  values: LeadsSettingsScreenValues;
  defaults: LeadsSettingsScreenDefaults;
  defs: LeadsSettingDef[];
  pending?: LeadsSettingChange[];
  history?: LeadsSettingChange[];
  dailyTargets?: LeadsSettingsScreenDailyTargets;
}

export interface LeaveAdjustmentListResponse {
  adjustments?: LeaveAdjustmentResponse[];
}

export type LeaveAdjustmentResponseLeaveYear = number | null;

export type LeaveAdjustmentResponseOldValue = string | null;

export type LeaveAdjustmentResponseNewValue = string | null;

export type LeaveAdjustmentResponseActorUserId = string | null;

export type LeaveAdjustmentResponseActorName = string | null;

export type LeaveAdjustmentResponseCreatedAt = string | null;

/**
 * One hand-made change to a person's leave / OT (who, when, old -> new).
 */
export interface LeaveAdjustmentResponse {
  id: string;
  staffId: string;
  kind: string;
  leaveYear?: LeaveAdjustmentResponseLeaveYear;
  oldValue?: LeaveAdjustmentResponseOldValue;
  newValue?: LeaveAdjustmentResponseNewValue;
  remark: string;
  actorUserId?: LeaveAdjustmentResponseActorUserId;
  actorName?: LeaveAdjustmentResponseActorName;
  createdAt?: LeaveAdjustmentResponseCreatedAt;
}

export type LeaveBalanceItemEntitlement = number | null;

export type LeaveBalanceItemRemaining = number | null;

export type LeaveBalanceItemLabel = string | null;

/**
 * One leave-type balance line within a year.
 */
export interface LeaveBalanceItem {
  leaveType: string;
  entitlement?: LeaveBalanceItemEntitlement;
  taken: number;
  pending: number;
  remaining?: LeaveBalanceItemRemaining;
  label?: LeaveBalanceItemLabel;
}

export type LeaveBalanceResponseCarriedDays = number | null;

export type LeaveBalanceResponseCarriedUsedDays = number | null;

export type LeaveBalanceResponseCarriedRemainingDays = number | null;

export type LeaveBalanceResponseCarriedExpiresAt = string | null;

export type LeaveBalanceResponseCarriedExpiryWarning = string | null;

export type LeaveBalanceResponseOverrideAnnualDays = number | null;

export type LeaveBalanceResponsePresetAnnualDays = number | null;

/**
 * GET /leave/balance response body (§8.3).

``hasOverride`` / ``overrideAnnualDays`` / ``presetAnnualDays`` are Spec D
additions (all defaulted → additive). When a ``StaffLeaveEntitlement`` row
exists the UI can badge "Override active" and show "preset N → override M".
 */
export interface LeaveBalanceResponse {
  staffId: string;
  year: number;
  balances?: LeaveBalanceItem[];
  carriedDays?: LeaveBalanceResponseCarriedDays;
  carriedUsedDays?: LeaveBalanceResponseCarriedUsedDays;
  carriedRemainingDays?: LeaveBalanceResponseCarriedRemainingDays;
  carriedExpiresAt?: LeaveBalanceResponseCarriedExpiresAt;
  carriedExpiryWarning?: LeaveBalanceResponseCarriedExpiryWarning;
  hasOverride?: boolean;
  overrideAnnualDays?: LeaveBalanceResponseOverrideAnnualDays;
  presetAnnualDays?: LeaveBalanceResponsePresetAnnualDays;
  otAccruedMinutes?: number;
  otUsedMinutes?: number;
  otBalanceMinutes?: number;
}

export type LeaveCalendarEntryStaffName = string | null;

export type LeaveCalendarEntryStartTime = string | null;

export type LeaveCalendarEntryEndTime = string | null;

export type LeaveCalendarEntryReason = string | null;

export type LeaveCalendarEntryApproverId = string | null;

export type LeaveCalendarEntryApproverName = string | null;

export type LeaveCalendarEntryDecision = string | null;

export type LeaveCalendarEntryDecidedAt = string | null;

export type LeaveCalendarEntryApproverNote = string | null;

export type LeaveCalendarEntryRequestedById = string | null;

export type LeaveCalendarEntryRequestedByName = string | null;

export type LeaveCalendarEntryCancelledById = string | null;

export type LeaveCalendarEntryCancelledByName = string | null;

export type LeaveCalendarEntryCancelledAt = string | null;

export type LeaveCalendarEntryCreatedAt = string | null;

export type LeaveCalendarEntryUpdatedAt = string | null;

export type LeaveCalendarEntryOutletId = string | null;

/**
 * One leave application on the Leave Calendar: the whole request (so the
details dialog needs no second call) plus the leave type's short code
(AL, MC, PH …) and the outlet the staff member belongs to.
 */
export interface LeaveCalendarEntry {
  id: string;
  staffId: string;
  staffName?: LeaveCalendarEntryStaffName;
  leaveType: string;
  startDate: string;
  endDate: string;
  dayPortion: string;
  totalDays: number;
  startTime?: LeaveCalendarEntryStartTime;
  endTime?: LeaveCalendarEntryEndTime;
  reason?: LeaveCalendarEntryReason;
  status: string;
  approverId?: LeaveCalendarEntryApproverId;
  approverName?: LeaveCalendarEntryApproverName;
  decision?: LeaveCalendarEntryDecision;
  decidedAt?: LeaveCalendarEntryDecidedAt;
  approverNote?: LeaveCalendarEntryApproverNote;
  requestedById?: LeaveCalendarEntryRequestedById;
  requestedByName?: LeaveCalendarEntryRequestedByName;
  cancelledById?: LeaveCalendarEntryCancelledById;
  cancelledByName?: LeaveCalendarEntryCancelledByName;
  cancelledAt?: LeaveCalendarEntryCancelledAt;
  createdAt?: LeaveCalendarEntryCreatedAt;
  updatedAt?: LeaveCalendarEntryUpdatedAt;
  leaveCode: string;
  outletId?: LeaveCalendarEntryOutletId;
}

export type LeaveCalendarResponseOutletId = string | null;

/**
 * GET /leave/calendar — pending and approved leave overlapping a date range.
 */
export interface LeaveCalendarResponse {
  fromDate: string;
  toDate: string;
  outletId?: LeaveCalendarResponseOutletId;
  entries?: LeaveCalendarEntry[];
}

export type LeaveCreditCreateRequestReason = string | null;

/**
 * POST /leave/credits — admin manual grant (source=MANUAL).
 */
export interface LeaveCreditCreateRequest {
  staffId: string;
  days: number;
  reason?: LeaveCreditCreateRequestReason;
  leaveYear: number;
}

/**
 * GET /leave/credits response body.
 */
export interface LeaveCreditListResponse {
  credits?: LeaveCreditResponse[];
}

export type LeaveCreditResponsePhDate = string | null;

export type LeaveCreditResponseReason = string | null;

export type LeaveCreditResponseGrantedById = string | null;

export type LeaveCreditResponseCreatedAt = string | null;

/**
 * A single leave-credit ledger row.
 */
export interface LeaveCreditResponse {
  id: string;
  staffId: string;
  creditType: string;
  source: string;
  days: number;
  phDate?: LeaveCreditResponsePhDate;
  reason?: LeaveCreditResponseReason;
  grantedById?: LeaveCreditResponseGrantedById;
  leaveYear: number;
  createdAt?: LeaveCreditResponseCreatedAt;
}

export type LeaveDecisionRequestNote = string | null;

/**
 * POST /leave/requests/{id}/approve|reject request body.
 */
export interface LeaveDecisionRequest {
  note?: LeaveDecisionRequestNote;
}

export type LeaveEntitlementCreateRequestNotes = string | null;

/**
 * POST /leave/entitlements request body.
 */
export interface LeaveEntitlementCreateRequest {
  role: string;
  employmentType: string;
  annualLeaveDays: number;
  phOffInLieuDays?: number;
  notes?: LeaveEntitlementCreateRequestNotes;
}

/**
 * GET /leave/entitlements response body.
 */
export interface LeaveEntitlementListResponse {
  entitlements?: LeaveEntitlementResponse[];
}

export type LeaveEntitlementResponseNotes = string | null;

export type LeaveEntitlementResponseCreatedAt = string | null;

export type LeaveEntitlementResponseUpdatedAt = string | null;

/**
 * A single entitlement row.
 */
export interface LeaveEntitlementResponse {
  id: string;
  role: string;
  employmentType: string;
  annualLeaveDays: number;
  phOffInLieuDays: number;
  notes?: LeaveEntitlementResponseNotes;
  createdAt?: LeaveEntitlementResponseCreatedAt;
  updatedAt?: LeaveEntitlementResponseUpdatedAt;
}

export type LeaveEntitlementUpdateRequestAnnualLeaveDays = number | null;

export type LeaveEntitlementUpdateRequestPhOffInLieuDays = number | null;

export type LeaveEntitlementUpdateRequestNotes = string | null;

/**
 * PUT /leave/entitlements/{id} request body — all fields optional.
 */
export interface LeaveEntitlementUpdateRequest {
  annualLeaveDays?: LeaveEntitlementUpdateRequestAnnualLeaveDays;
  phOffInLieuDays?: LeaveEntitlementUpdateRequestPhOffInLieuDays;
  notes?: LeaveEntitlementUpdateRequestNotes;
}

/**
 * The leave managers. ``usingDefault`` = none named yet, so the list is
the HQ staff who manage leave by default (D22-4).
 */
export interface LeaveManagerListResponse {
  items: LeaveManagerRow[];
  usingDefault: boolean;
}

export type LeaveManagerRowEmployeeId = string | null;

export type LeaveManagerRowDesignation = string | null;

/**
 * One leave manager (Leave Approval Settings, Angela 22 Oct 2026).
 */
export interface LeaveManagerRow {
  staffId: string;
  name: string;
  employeeId?: LeaveManagerRowEmployeeId;
  designation?: LeaveManagerRowDesignation;
}

/**
 * Replace the named leave managers; an empty list returns to the default.
 */
export interface LeaveManagersUpdateRequest {
  staffIds: string[];
}

export type LeaveRequestCreateRequestStaffId = string | null;

export type LeaveRequestCreateRequestStartTime = string | null;

export type LeaveRequestCreateRequestEndTime = string | null;

export type LeaveRequestCreateRequestReason = string | null;

/**
 * POST /leave/requests request body. ``staffId`` is the JWT's own staff
member; HQ / admin may name another one to apply on her behalf (Angela,
21 Oct 2026) — anyone else naming someone else is refused.
 */
export interface LeaveRequestCreateRequest {
  staffId?: LeaveRequestCreateRequestStaffId;
  leaveType: string;
  startDate: string;
  endDate: string;
  dayPortion?: string;
  startTime?: LeaveRequestCreateRequestStartTime;
  endTime?: LeaveRequestCreateRequestEndTime;
  reason?: LeaveRequestCreateRequestReason;
}

/**
 * GET /leave/requests + /leave/requests/mine response body.
 */
export interface LeaveRequestListResponse {
  requests?: LeaveRequestResponse[];
}

export type LeaveRequestResponseStaffName = string | null;

export type LeaveRequestResponseStartTime = string | null;

export type LeaveRequestResponseEndTime = string | null;

export type LeaveRequestResponseReason = string | null;

export type LeaveRequestResponseApproverId = string | null;

export type LeaveRequestResponseApproverName = string | null;

export type LeaveRequestResponseDecision = string | null;

export type LeaveRequestResponseDecidedAt = string | null;

export type LeaveRequestResponseApproverNote = string | null;

export type LeaveRequestResponseRequestedById = string | null;

export type LeaveRequestResponseRequestedByName = string | null;

export type LeaveRequestResponseCancelledById = string | null;

export type LeaveRequestResponseCancelledByName = string | null;

export type LeaveRequestResponseCancelledAt = string | null;

export type LeaveRequestResponseCreatedAt = string | null;

export type LeaveRequestResponseUpdatedAt = string | null;

/**
 * A single leave request (LEAVE-3/4).
 */
export interface LeaveRequestResponse {
  id: string;
  staffId: string;
  staffName?: LeaveRequestResponseStaffName;
  leaveType: string;
  startDate: string;
  endDate: string;
  dayPortion: string;
  totalDays: number;
  startTime?: LeaveRequestResponseStartTime;
  endTime?: LeaveRequestResponseEndTime;
  reason?: LeaveRequestResponseReason;
  status: string;
  approverId?: LeaveRequestResponseApproverId;
  approverName?: LeaveRequestResponseApproverName;
  decision?: LeaveRequestResponseDecision;
  decidedAt?: LeaveRequestResponseDecidedAt;
  approverNote?: LeaveRequestResponseApproverNote;
  requestedById?: LeaveRequestResponseRequestedById;
  requestedByName?: LeaveRequestResponseRequestedByName;
  cancelledById?: LeaveRequestResponseCancelledById;
  cancelledByName?: LeaveRequestResponseCancelledByName;
  cancelledAt?: LeaveRequestResponseCancelledAt;
  createdAt?: LeaveRequestResponseCreatedAt;
  updatedAt?: LeaveRequestResponseUpdatedAt;
}

export type LeaveRequestUpdateRequestStartDate = string | null;

export type LeaveRequestUpdateRequestEndDate = string | null;

export type LeaveRequestUpdateRequestDayPortion = string | null;

export type LeaveRequestUpdateRequestStartTime = string | null;

export type LeaveRequestUpdateRequestEndTime = string | null;

export type LeaveRequestUpdateRequestReason = string | null;

/**
 * PATCH /leave/requests/{id} (HQ) — change an AL request's dates / times.
Fields left out stay as they are.
 */
export interface LeaveRequestUpdateRequest {
  startDate?: LeaveRequestUpdateRequestStartDate;
  endDate?: LeaveRequestUpdateRequestEndDate;
  dayPortion?: LeaveRequestUpdateRequestDayPortion;
  startTime?: LeaveRequestUpdateRequestStartTime;
  endTime?: LeaveRequestUpdateRequestEndTime;
  reason?: LeaveRequestUpdateRequestReason;
}

export type LeaveTypeCreateRequestEntitlementDays = number | null;

export interface LeaveTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 80
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 12
   */
  code: string;
  entitlementMode?: string;
  entitlementDays?: LeaveTypeCreateRequestEntitlementDays;
  countedIn?: string;
  carryOver?: string;
  isPaid?: boolean;
  needsHqApproval?: boolean;
  documentRequired?: boolean;
  appliesTo?: string;
  staffIds?: string[];
}

export interface LeaveTypeListResponse {
  items?: LeaveTypeResponse[];
  total: number;
}

export type LeaveTypeResponseEntitlementDays = number | null;

export type LeaveTypeResponseCreatedById = string | null;

export type LeaveTypeResponseUpdatedById = string | null;

export interface LeaveTypeResponse {
  id: string;
  name: string;
  code: string;
  requestCode: string;
  entitlementMode: string;
  entitlementDays?: LeaveTypeResponseEntitlementDays;
  countedIn: string;
  carryOver: string;
  isPaid: boolean;
  needsHqApproval: boolean;
  documentRequired: boolean;
  appliesTo: string;
  isBuiltIn: boolean;
  isLocked: boolean;
  isActive: boolean;
  sortOrder: number;
  appliesToCount?: number;
  selectedStaff?: LeaveTypeStaffItem[];
  createdById?: LeaveTypeResponseCreatedById;
  updatedById?: LeaveTypeResponseUpdatedById;
  createdAt: string;
  updatedAt: string;
}

export type LeaveTypeStaffEntryEntitlementDays = number | null;

export interface LeaveTypeStaffEntry {
  staffId: string;
  entitlementDays?: LeaveTypeStaffEntryEntitlementDays;
}

export type LeaveTypeStaffItemEntitlementDays = number | null;

export interface LeaveTypeStaffItem {
  staffId: string;
  staffName: string;
  entitlementDays?: LeaveTypeStaffItemEntitlementDays;
}

/**
 * Replaces the 'Selected staff' list of a type (HR-07-05 'Staff' on a row).
 */
export interface LeaveTypeStaffUpdateRequest {
  staff?: LeaveTypeStaffEntry[];
}

export type LeaveTypeUpdateRequestName = string | null;

export type LeaveTypeUpdateRequestCode = string | null;

export type LeaveTypeUpdateRequestEntitlementMode = string | null;

export type LeaveTypeUpdateRequestEntitlementDays = number | null;

export type LeaveTypeUpdateRequestCountedIn = string | null;

export type LeaveTypeUpdateRequestCarryOver = string | null;

export type LeaveTypeUpdateRequestIsPaid = boolean | null;

export type LeaveTypeUpdateRequestNeedsHqApproval = boolean | null;

export type LeaveTypeUpdateRequestDocumentRequired = boolean | null;

export type LeaveTypeUpdateRequestAppliesTo = string | null;

export interface LeaveTypeUpdateRequest {
  name?: LeaveTypeUpdateRequestName;
  code?: LeaveTypeUpdateRequestCode;
  entitlementMode?: LeaveTypeUpdateRequestEntitlementMode;
  entitlementDays?: LeaveTypeUpdateRequestEntitlementDays;
  countedIn?: LeaveTypeUpdateRequestCountedIn;
  carryOver?: LeaveTypeUpdateRequestCarryOver;
  isPaid?: LeaveTypeUpdateRequestIsPaid;
  needsHqApproval?: LeaveTypeUpdateRequestNeedsHqApproval;
  documentRequired?: LeaveTypeUpdateRequestDocumentRequired;
  appliesTo?: LeaveTypeUpdateRequestAppliesTo;
}

export type LeaveYtdResponseOutletId = string | null;

/**
 * GET /leave/year-to-date — approved days per staff member and leave type.
 */
export interface LeaveYtdResponse {
  year: number;
  toDate: string;
  outletId?: LeaveYtdResponseOutletId;
  types?: LeaveYtdType[];
  rows?: LeaveYtdRow[];
}

export type LeaveYtdRowOutletId = string | null;

export type LeaveYtdRowOutletName = string | null;

export type LeaveYtdRowDays = {[key: string]: number};

export interface LeaveYtdRow {
  staffId: string;
  staffName: string;
  outletId?: LeaveYtdRowOutletId;
  outletName?: LeaveYtdRowOutletName;
  days?: LeaveYtdRowDays;
  total?: number;
}

export interface LeaveYtdType {
  code: string;
  name: string;
}

export interface LedgerResponse {
  groupBy: string;
  per: string;
  dateFrom: string;
  dateTo: string;
  rows: LedgerRowResponse[];
  total: number;
}

export type LedgerRowResponseSku = string | null;

export type LedgerRowResponseUnit = string | null;

export type LedgerRowResponseLocationId = string | null;

export type LedgerRowResponseLocationName = string | null;

/**
 * Opening + Received + Usage + Sale + Transfer + Disposed + Adjusted = Closing.

Signed as the movements are: usage, sale, disposed and transferOut are
negative or zero. ``bucket`` is the day (YYYY-MM-DD), month (YYYY-MM) or the
whole period. ``locationId`` is set when the report runs across outlets.
 */
export interface LedgerRowResponse {
  key: string;
  name: string;
  sku: LedgerRowResponseSku;
  unit: LedgerRowResponseUnit;
  locationId: LedgerRowResponseLocationId;
  locationName: LedgerRowResponseLocationName;
  bucket: string;
  opening: number;
  received: number;
  usage: number;
  sale: number;
  transferIn: number;
  transferOut: number;
  disposed: number;
  adjusted: number;
  closing: number;
}

export type ListResultLineWhyClosed = {[key: string]: number};

/**
 * One line per list per month (LEA-33-03). The contact columns arrive
with the contact log; until then they are 0 / absent.
 */
export interface ListResultLine {
  listKey: LeadListKey;
  month: string;
  outletCodes?: string[];
  onList: number;
  contacted?: number;
  first?: number;
  second?: number;
  third?: number;
  consultBooked?: number;
  apptMade?: number;
  bought?: number;
  resultRate?: number;
  closed?: number;
  whyClosed?: ListResultLineWhyClosed;
  stillOpen?: number;
}

export interface ListResultsResponse {
  start: string;
  end: string;
  lines?: ListResultLine[];
}

export type LoginIdSuggestionEmail = string | null;

export type LoginIdSuggestionSuggested = string | null;

/**
 * HR-11-03: one account with no login ID and the ID it would get.
 */
export interface LoginIdSuggestion {
  userId: string;
  name: string;
  email?: LoginIdSuggestionEmail;
  suggested?: LoginIdSuggestionSuggested;
  state: string;
}

export interface LoginIdSuggestionsResponse {
  rows: LoginIdSuggestion[];
  filled?: number;
}

/**
 * POST /api/auth/login → { accessToken, tokenType }.
 */
export interface LoginResponse {
  accessToken: string;
  tokenType?: string;
}

export type LookupOptionCreateCode = string | null;

export type LookupOptionCreateRemarks = string | null;

export interface LookupOptionCreate {
  listKey: string;
  code?: LookupOptionCreateCode;
  label: string;
  enabled?: boolean;
  remarks?: LookupOptionCreateRemarks;
}

export interface LookupOptionListResponse {
  items: LookupOptionResponse[];
}

export type LookupOptionResponseRemarks = string | null;

export interface LookupOptionResponse {
  id: string;
  listKey: string;
  code: string;
  label: string;
  sortOrder: number;
  enabled: boolean;
  isSystem: boolean;
  remarks?: LookupOptionResponseRemarks;
}

export type LookupOptionUpdateLabel = string | null;

export type LookupOptionUpdateEnabled = boolean | null;

export type LookupOptionUpdateRemarks = string | null;

/**
 * Rename / switch on-off. ``listKey`` and ``code`` are immutable — the code
is what stored records and application branches key on, so letting it move
would detach an option from its own history.
 */
export interface LookupOptionUpdate {
  label?: LookupOptionUpdateLabel;
  enabled?: LookupOptionUpdateEnabled;
  remarks?: LookupOptionUpdateRemarks;
}

/**
 * Drag-reorder within one list — ``ids`` in their new display order; each
row's ``sortOrder`` becomes its index. Every id must belong to ``listKey``.
 */
export interface LookupReorderRequest {
  listKey: string;
  ids: string[];
}

/**
 * Idempotent-seed outcome. Deliberately NOT ``SeedResultResponse`` /
``SalesConfigSeedResult`` — a duplicate model name forces FastAPI to
fully-qualify BOTH in ``openapi.json``, renaming the existing Orval types.
 */
export interface LookupSeedResult {
  created: number;
  skipped: number;
}

export type LossSummaryBiggestProductSku = string | null;

export interface LossSummaryBiggest {
  productId: string;
  productName: string;
  productSku: LossSummaryBiggestProductSku;
  reason: string;
  stockLocationName: string;
  qty: number;
}

export interface LossSummaryCell {
  reason: string;
  month: string;
  qty: number;
}

/**
 * INV-11-05: stock that left without a sale or a treatment, by reason and month.

Quantities only — value at cost needs cost prices (money track, not built).
 */
export interface LossSummaryResponse {
  dateFrom: string;
  dateTo: string;
  months: string[];
  reasons: string[];
  cells: LossSummaryCell[];
  totalQty: number;
  disposedQty: number;
  stocktakeQty: number;
  adjustedQty: number;
  biggest: LossSummaryBiggest[];
}

export interface LowStockResponse {
  rows: LowStockRow[];
  total: number;
}

export type LowStockRowProductSku = string | null;

/**
 * INV-11-02: one product x outlet at or below its minimum.
 */
export interface LowStockRow {
  productId: string;
  productName: string;
  productSku: LowStockRowProductSku;
  unit: string;
  isRetail: boolean;
  isBackBar: boolean;
  stockLocationId: string;
  stockLocationName: string;
  stockLocationKind: string;
  onHand: number;
  minQty: number;
  targetQty: number;
  inTransit: number;
  requested: number;
  suggestedOrder: number;
  status: string;
}

export type MakeUpCreateRoomId = string | null;

export type MakeUpCreateOutletId = string | null;

export type MakeUpCreateReason = string | null;

/**
 * OPS-27-03 / OPS-27-04: the small form — Date, Time, Staff, Room, Reason.
 */
export interface MakeUpCreate {
  /** @minItems 1 */
  sourceStepIds: string[];
  date: string;
  startTime: string;
  staffId: string;
  roomId?: MakeUpCreateRoomId;
  outletId?: MakeUpCreateOutletId;
  reason?: MakeUpCreateReason;
  force?: boolean;
}

export type MakeUpDetailsResponseReason = string | null;

export type MakeUpDetailsResponseBookedByName = string | null;

export type MakeUpDetailsResponseBookedAt = string | null;

export interface MakeUpDetailsResponse {
  isMakeUp: boolean;
  reason?: MakeUpDetailsResponseReason;
  bookedByName?: MakeUpDetailsResponseBookedByName;
  bookedAt?: MakeUpDetailsResponseBookedAt;
  originals?: MakeUpOriginalVisit[];
  originalSteps?: MakeUpStepState[];
}

export type MakeUpOpenStepProgrammeName = string | null;

export type MakeUpOpenStepStaffName = string | null;

export type MakeUpOpenStepNotPerformedReason = string | null;

/**
 * One step Not performed that is waiting for a make-up (OPS-27-04).
 */
export interface MakeUpOpenStep {
  appointmentStepId: string;
  stepId: string;
  stepName: string;
  minutes: number;
  appointmentId: string;
  visitDate: string;
  outletId: string;
  programmeName?: MakeUpOpenStepProgrammeName;
  staffName?: MakeUpOpenStepStaffName;
  notPerformedReason?: MakeUpOpenStepNotPerformedReason;
}

export interface MakeUpOpenStepsResponse {
  steps?: MakeUpOpenStep[];
}

export type MakeUpOriginalStepNotPerformedAt = string | null;

export type MakeUpOriginalStepStaffName = string | null;

export type MakeUpOriginalStepNotPerformedReason = string | null;

export interface MakeUpOriginalStep {
  appointmentStepId: string;
  makeUpStepId: string;
  stepName: string;
  notPerformedAt?: MakeUpOriginalStepNotPerformedAt;
  staffName?: MakeUpOriginalStepStaffName;
  notPerformedReason?: MakeUpOriginalStepNotPerformedReason;
}

export type MakeUpOriginalVisitProgrammeName = string | null;

export type MakeUpOriginalVisitRoomName = string | null;

export type MakeUpOriginalVisitSessionDeductedAt = string | null;

export interface MakeUpOriginalVisit {
  appointmentId: string;
  date: string;
  programmeName?: MakeUpOriginalVisitProgrammeName;
  roomName?: MakeUpOriginalVisitRoomName;
  sessionDeductedAt?: MakeUpOriginalVisitSessionDeductedAt;
  steps?: MakeUpOriginalStep[];
}

export type MakeUpStepStateState = typeof MakeUpStepStateState[keyof typeof MakeUpStepStateState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MakeUpStepStateState = {
  OPEN: 'OPEN',
  BOOKED: 'BOOKED',
  DONE: 'DONE',
  NOT_PERFORMED_AGAIN: 'NOT_PERFORMED_AGAIN',
} as const;

export type MakeUpStepStateMakeUpAppointmentId = string | null;

export type MakeUpStepStateMakeUpDate = string | null;

export type MakeUpStepStateStaffName = string | null;

/**
 * OPS-27-12: what became of a step Not performed on THIS visit.
 */
export interface MakeUpStepState {
  appointmentStepId: string;
  state: MakeUpStepStateState;
  makeUpAppointmentId?: MakeUpStepStateMakeUpAppointmentId;
  makeUpDate?: MakeUpStepStateMakeUpDate;
  staffName?: MakeUpStepStateStaffName;
}

/**
 * GET /dashboard/management-operations — B · Operations charts (canvas 3a):
room-hours used per outlet (last 8 weeks, by week), treatments done by
therapist this month, cancellations and no-shows by week (last 8 weeks).
 */
export interface ManagementOperationsResponse {
  utilisation: OutletUtilisationTrend[];
  therapists: TherapistTreatments[];
  therapistAverage: number;
  cancellations: WeeklyPoint[];
  cancellationRate: number;
  noShowRate: number;
}

export type ManagementOutletGoalOutletCode = string | null;

export type ManagementOutletGoalFollowUp = FollowUpEffect | null;

/**
 * DSH-16-03 — one outlet line under the Sales goal bar.
 */
export interface ManagementOutletGoal {
  outletId: string;
  outletCode?: ManagementOutletGoalOutletCode;
  outletName: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales: string;
  minimum: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  forecast: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  neededPerDay: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  lastMonth: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  lastMonthSameDays: string;
  followUp?: ManagementOutletGoalFollowUp;
}

export interface ManagementRisksResponse {
  businessDate: string;
  risks: RiskLine[];
  backlog: BacklogLine[];
  finance: FinanceFigure[];
  collectedByMethod: FinanceFigure[];
  xero: XeroBooks;
}

export type ManagementSalesQualityResponseSalesSplitAnyOfItem = {[key: string]: string};

export type ManagementSalesQualityResponseSalesSplit = ManagementSalesQualityResponseSalesSplitAnyOfItem[] | null;

/**
 * GET /dashboard/management-sales-quality — A · Sales quality.
 */
export interface ManagementSalesQualityResponse {
  conversionMonths: MonthRate[];
  sellItems: SellItemResult[];
  salesSplit?: ManagementSalesQualityResponseSalesSplit;
}

/**
 * GET /dashboard/management-summary (DSH-16).
 */
export interface ManagementSummaryResponse {
  year: number;
  month: number;
  dayOfMonth: number;
  daysInMonth: number;
  updatedAt: string;
  operations: OperationsCounts;
  outletStaff: OutletStaffMonth[];
}

export type ManagementTaskRequestDueDate = string | null;

export type ManagementTaskRequestCategory = 'HR' | 'ADMIN' | 'SALES' | 'CUSTCARE' | 'TRAINING' | 'MARKETING' | null;

/**
 * DSH-04-10 (owner 15 Oct) — a manager gives an office person a task, with
the date wanted. It lands straight on her desk as a Now card on that date.
 */
export interface ManagementTaskRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  title: string;
  dueDate?: ManagementTaskRequestDueDate;
  category?: ManagementTaskRequestCategory;
}

export type ManagementTopResponseConversionRate = number | null;

export type ManagementTopResponseConversionLastMonth = number | null;

export type ManagementTopResponseNewPackageShare = number | null;

export type ManagementTopResponseNewPackageShareLastMonth = number | null;

/**
 * GET /dashboard/management-top (DSH-16-02 / DSH-16-03): the top row and
the per-outlet sales goal lines. Sales = GEN-14 net sales.
 */
export interface ManagementTopResponse {
  daysGone: number;
  daysInMonth: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothNetSales: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothForecast: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothLastMonth: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothLastMonthSameDays: string;
  conversionRate?: ManagementTopResponseConversionRate;
  conversionNumerator?: number;
  conversionDenominator?: number;
  conversionLastMonth?: ManagementTopResponseConversionLastMonth;
  newPackageShare?: ManagementTopResponseNewPackageShare;
  newPackageShareLastMonth?: ManagementTopResponseNewPackageShareLastMonth;
  incentiveMarks: number[];
  breakEven: number;
  outlets: ManagementOutletGoal[];
}

export interface ManualGroupChoice {
  id: string;
  name: string;
}

export interface MarketingBreakdownRow {
  name: string;
  customers: number;
  invoices: number;
  amount: number;
}

export interface MatrixStaff {
  id: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
  outlet: OutletSummary;
}

export interface MatrixStaffCapability {
  staffId: string;
  capability: CapabilityLevel;
  stepsCanPerform: number;
  totalSteps: number;
}

export interface MatrixTreatment {
  id: string;
  name: string;
  category: TreatmentCategory;
  stepCount: number;
  steps?: MatrixTreatmentStep[];
}

export interface MatrixTreatmentStep {
  id: string;
  name: string;
}

export type MeResponseOutletId = string | null;

/**
 * GET /api/auth/me — byte-identical to the legacy route, which returns only
``{ outletId }`` (derived from the linked staff record; null when unlinked).
The conformance gate treats extra keys as drift, so we keep this exact. The
principal's identity (id / email / userType / staffId) is carried in the JWT
and available via ``AuthContext`` — the FE1 auth swap reads it from the token,
not from /me.
 */
export interface MeResponse {
  outletId?: MeResponseOutletId;
}

export type MeetingDocumentSummaryUploadedByName = string | null;

/**
 * Metadata-only document shape — NEVER carries the ``data`` blob.
 */
export interface MeetingDocumentSummary {
  id: string;
  meetingId: string;
  filename: string;
  contentType: string;
  fileSize: number;
  uploadedById: string;
  uploadedByName?: MeetingDocumentSummaryUploadedByName;
  createdAt: string;
}

export type MeetingFileCreateDriveUrl = string | null;

export type MeetingFileCreateMeetingId = string | null;

export interface MeetingFileCreate {
  meetingDate: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  meetingName: string;
  kind: MeetingFileKind;
  format?: MeetingFileFormat;
  driveUrl?: MeetingFileCreateDriveUrl;
  skipped?: boolean;
  meetingId?: MeetingFileCreateMeetingId;
}

export type MeetingFileFormat = typeof MeetingFileFormat[keyof typeof MeetingFileFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingFileFormat = {
  SLIDES: 'SLIDES',
  POWERPOINT: 'POWERPOINT',
  PDF: 'PDF',
  WORD: 'WORD',
  GOOGLE_DOC: 'GOOGLE_DOC',
  GEMINI_NOTES: 'GEMINI_NOTES',
  OTHER: 'OTHER',
} as const;

export type MeetingFileKind = typeof MeetingFileKind[keyof typeof MeetingFileKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingFileKind = {
  DECK: 'DECK',
  MINUTES: 'MINUTES',
} as const;

export interface MeetingFileListResponse {
  items?: MeetingFileResponse[];
  total: number;
}

export type MeetingFileResponseDriveUrl = string | null;

export type MeetingFileResponseMeetingId = string | null;

export type MeetingFileResponseCreatedById = string | null;

export type MeetingFileResponsePublishedAt = string | null;

export interface MeetingFileResponse {
  id: string;
  meetingDate: string;
  meetingName: string;
  kind: MeetingFileKind;
  format: MeetingFileFormat;
  driveUrl?: MeetingFileResponseDriveUrl;
  skipped: boolean;
  meetingId?: MeetingFileResponseMeetingId;
  createdById?: MeetingFileResponseCreatedById;
  createdAt: string;
  published?: boolean;
  publishedAt?: MeetingFileResponsePublishedAt;
}

export interface MeetingOccurrence {
  id: string;
  date: string;
}

export interface MeetingSeriesLink {
  /** @minItems 2 */
  meetingIds: string[];
}

export type MeetingSeriesResponseSeriesId = string | null;

export interface MeetingSeriesResponse {
  seriesId?: MeetingSeriesResponseSeriesId;
  occurrences?: MeetingOccurrence[];
}

export type MeetingType = typeof MeetingType[keyof typeof MeetingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingType = {
  MEETING: 'MEETING',
  TRAINING: 'TRAINING',
  COMPANY_MEETING: 'COMPANY_MEETING',
  PRACTICE: 'PRACTICE',
  BREAK: 'BREAK',
  OTHER: 'OTHER',
} as const;

export interface MinStockImportPreview {
  totalRows: number;
  newRows: number;
  changedRows: number;
  clearedRows: number;
  unchangedRows: number;
  unmatchedRows: number;
  unmatched?: MinStockImportRow[];
  rows?: MinStockImportRow[];
}

export type MinStockImportRowProductId = string | null;

export type MinStockImportRowStockLocationId = string | null;

export type MinStockImportRowMinimum = string | null;

export type MinStockImportRowBefore = string | null;

export type MinStockImportRowReason = string | null;

/**
 * One line of the minimum-stock upload as the preview shows it.
 */
export interface MinStockImportRow {
  rowNumber: number;
  product: string;
  productId?: MinStockImportRowProductId;
  outlet: string;
  stockLocationId?: MinStockImportRowStockLocationId;
  minimum?: MinStockImportRowMinimum;
  before?: MinStockImportRowBefore;
  action: string;
  reason?: MinStockImportRowReason;
}

export type MinutesActionDue = string | null;

export type MinutesActionStatusNote = string | null;

export interface MinutesAction {
  /**
   * @minLength 1
   * @maxLength 200
   */
  who: string;
  /**
   * @minLength 1
   * @maxLength 2000
   */
  what: string;
  due?: MinutesActionDue;
  status?: ActionStatus;
  statusNote?: MinutesActionStatusNote;
}

export interface MinutesCreate {
  /** @pattern ^\d{4}-\d{2}$ */
  meetingMonth: string;
}

export interface MinutesListItem {
  id: string;
  meetingMonth: string;
  title: string;
  actions: number;
  actionsOpen: number;
  updatedAt: string;
}

export interface MinutesListResponse {
  items: MinutesListItem[];
}

export type MinutesResponseHeldAt = string | null;

export type MinutesResponseLocation = string | null;

export type MinutesResponseAttendance = string | null;

export interface MinutesResponse {
  id: string;
  meetingMonth: string;
  title: string;
  heldAt?: MinutesResponseHeldAt;
  location?: MinutesResponseLocation;
  attendance?: MinutesResponseAttendance;
  sections: MinutesSection[];
  updatedAt: string;
}

export type MinutesSectionPresenter = string | null;

export type MinutesSectionSummary = string | null;

export interface MinutesSection {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  presenter?: MinutesSectionPresenter;
  summary?: MinutesSectionSummary;
  /** @maxItems 50 */
  actions?: MinutesAction[];
}

export type MinutesUpdateHeldAt = string | null;

export type MinutesUpdateLocation = string | null;

export type MinutesUpdateAttendance = string | null;

export interface MinutesUpdate {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  heldAt?: MinutesUpdateHeldAt;
  location?: MinutesUpdateLocation;
  attendance?: MinutesUpdateAttendance;
  /**
   * @minItems 1
   * @maxItems 20
   */
  sections: MinutesSection[];
}

export interface MonthGrowth {
  month: string;
  new: number;
  repeat: number;
  vip: number;
}

export type MonthRateRate = number | null;

export interface MonthRate {
  month: string;
  rate?: MonthRateRate;
  numerator?: number;
  denominator?: number;
}

export interface MonthValue {
  month: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  value: string;
}

/**
 * Paginated movement history.
 */
export interface MovementListResponse {
  movements: MovementRow[];
  total: number;
  limit: number;
  offset: number;
  canRevoke?: boolean;
}

export type MovementRowSaleLineId = string | null;

export type MovementRowAppointmentId = string | null;

export type MovementRowTransferId = string | null;

export type MovementRowStaffId = string | null;

export type MovementRowReason = string | null;

export type MovementRowDocumentId = string | null;

export type MovementRowDocumentNumber = string | null;

export type MovementRowDocumentKind = string | null;

export type MovementRowStocktakeId = string | null;

export type MovementRowDocumentSupplier = string | null;

export type MovementRowDocumentUsedFor = string | null;

export type MovementRowRevokesDocumentNumber = string | null;

export type MovementRowStaffName = string | null;

export type MovementRowProductName = string | null;

export type MovementRowProductSku = string | null;

export type MovementRowUnit = string | null;

export type MovementRowBatchCode = string | null;

export type MovementRowInvoiceNumber = string | null;

export type MovementRowCustomerName = string | null;

/**
 * One stock movement in the audit trail.
 */
export interface MovementRow {
  id: string;
  stockBatchId: string;
  productId: string;
  stockLocationId: string;
  kind: string;
  qtyDelta: number;
  saleLineId: MovementRowSaleLineId;
  appointmentId: MovementRowAppointmentId;
  transferId: MovementRowTransferId;
  staffId: MovementRowStaffId;
  reason: MovementRowReason;
  createdAt: string;
  documentId?: MovementRowDocumentId;
  documentNumber?: MovementRowDocumentNumber;
  documentKind?: MovementRowDocumentKind;
  stocktakeId?: MovementRowStocktakeId;
  documentSupplier?: MovementRowDocumentSupplier;
  documentUsedFor?: MovementRowDocumentUsedFor;
  documentRevoked?: boolean;
  revokesDocumentNumber?: MovementRowRevokesDocumentNumber;
  staffName?: MovementRowStaffName;
  productName?: MovementRowProductName;
  productSku?: MovementRowProductSku;
  unit?: MovementRowUnit;
  batchCode?: MovementRowBatchCode;
  invoiceNumber?: MovementRowInvoiceNumber;
  customerName?: MovementRowCustomerName;
}

export type MyApprovalRequestWaitingFor = typeof MyApprovalRequestWaitingFor[keyof typeof MyApprovalRequestWaitingFor];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyApprovalRequestWaitingFor = {
  HEAD_MASTER: 'HEAD_MASTER',
  HQ: 'HQ',
} as const;

export type MyApprovalRequestCustomerName = string | null;

export type MyApprovalRequestRequestedByName = string | null;

/**
 * DSH-19-05 — a request this user raised, and where it is waiting.
Deliberately carries no amount.
 */
export interface MyApprovalRequest {
  id: string;
  category: string;
  waitingFor: MyApprovalRequestWaitingFor;
  customerName?: MyApprovalRequestCustomerName;
  requestedByName?: MyApprovalRequestRequestedByName;
  raisedAt: string;
  daysWaiting: number;
  overdue: boolean;
}

export interface MyBreakdownListResponse {
  items?: MyBreakdownRow[];
}

export type MyBreakdownRowServiceComm = string | null;

export type MyBreakdownRowSalesComm = string | null;

export type MyBreakdownRowIncentive = string | null;

export type MyBreakdownRowSentAt = string | null;

export type MyBreakdownRowSentSubject = string | null;

export type MyBreakdownRowSentBody = string | null;

export type MyBreakdownRowReplyBy = string | null;

export type MyBreakdownRowQueryText = string | null;

export type MyBreakdownRowRepliedAt = string | null;

export interface MyBreakdownRow {
  id: string;
  month: string;
  status: string;
  serviceComm?: MyBreakdownRowServiceComm;
  salesComm?: MyBreakdownRowSalesComm;
  incentive?: MyBreakdownRowIncentive;
  sentAt?: MyBreakdownRowSentAt;
  sentSubject?: MyBreakdownRowSentSubject;
  sentBody?: MyBreakdownRowSentBody;
  replyBy?: MyBreakdownRowReplyBy;
  queryText?: MyBreakdownRowQueryText;
  repliedAt?: MyBreakdownRowRepliedAt;
}

export interface MyClaims {
  allowance: ClaimAllowance;
  claims: StaffClaimOut[];
  claimTypes: string[];
}

export type MyClockRemark = string | null;

/**
 * One press from My Profile > Time attendance. No staffId, no PIN: the
server uses the signed-in user's own staff record; the registered iPad's
token travels in the X-Attendance-Token header.
 */
export interface MyClock {
  action: AttendanceAction;
  remark?: MyClockRemark;
}

export type MyClockStateOutletName = string | null;

export type MyClockStateDate = string | null;

export type MyClockStateNow = string | null;

export type MyClockStateLine = TodayLine | null;

export interface MyClockState {
  staffName: string;
  onOutletIpad: boolean;
  outletName?: MyClockStateOutletName;
  date?: MyClockStateDate;
  now?: MyClockStateNow;
  line?: MyClockStateLine;
}

export interface MyColleaguesResponse {
  roundId: string;
  reviewerName: string;
  done: number;
  total: number;
  colleagues?: ColleagueItem[];
}

export type MyKpiRowOutletCode = string | null;

export interface MyKpiRow {
  outletId: string;
  outletCode?: MyKpiRowOutletCode;
  cell: KpiCell;
}

/**
 * GET /office-desk/desks/{owner}/my-kpis (DSH-08-03 / DSH-08-04).
 */
export interface MyKpisResponse {
  ownerName: string;
  monthStart: string;
  mine: number;
  behind: number;
  others: number;
  rows: MyKpiRow[];
  nextSteps: NextStep[];
}

export type MyPermissionsPermissions = {[key: string]: 'FULL' | 'OWN' | 'NONE'};

export type MyPermissionsRole = RoleSummary | null;

export interface MyPermissions {
  permissions: MyPermissionsPermissions;
  role?: MyPermissionsRole;
  isHq?: boolean;
  managesLeave?: boolean;
}

export interface NameCount {
  name: string;
  rows: number;
}

export interface NamedValue {
  name: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  value: string;
}

export type NeedsAttentionResponseOutletId = string | null;

/**
 * GET /dashboard/needs-attention — an empty ``lines`` list means 'nothing
needs attention'. Counts and names only.
 */
export interface NeedsAttentionResponse {
  asOf: string;
  outletId?: NeedsAttentionResponseOutletId;
  lines?: AttentionLine[];
}

export interface NetSalesReportDayTotal {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  collected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  refunds?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grossCollected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cardFees?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales?: string;
  paymentCount?: number;
  businessDay: string;
}

export interface NetSalesReportExcluded {
  reason: string;
  method: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  paymentCount: number;
}

export interface NetSalesReportFigures {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  collected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  refunds?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grossCollected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cardFees?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales?: string;
  paymentCount?: number;
}

/**
 * A payment method with no known fee rate: counted as collected, fee 0.
 */
export interface NetSalesReportMissingRate {
  method: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  paymentCount: number;
}

export type NetSalesReportOutletTotalOutletId = string | null;

export type NetSalesReportOutletTotalOutletName = string | null;

export interface NetSalesReportOutletTotal {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  collected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  refunds?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grossCollected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cardFees?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales?: string;
  paymentCount?: number;
  outletId?: NetSalesReportOutletTotalOutletId;
  outletName?: NetSalesReportOutletTotalOutletName;
}

export type NetSalesReportResponseOutletId = string | null;

export interface NetSalesReportResponse {
  startDay: string;
  endDay: string;
  outletId?: NetSalesReportResponseOutletId;
  formula: string;
  rows: NetSalesReportRow[];
  byDay: NetSalesReportDayTotal[];
  byOutlet: NetSalesReportOutletTotal[];
  totals: NetSalesReportFigures;
  excluded: NetSalesReportExcluded[];
  methodsWithoutFeeRate: NetSalesReportMissingRate[];
}

export type NetSalesReportRowOutletId = string | null;

export type NetSalesReportRowOutletName = string | null;

export interface NetSalesReportRow {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  collected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  refunds?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grossCollected?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gst?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  cardFees?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales?: string;
  paymentCount?: number;
  businessDay: string;
  outletId?: NetSalesReportRowOutletId;
  outletName?: NetSalesReportRowOutletName;
}

/**
 * GET /finance/net-sales — the Salary module's net-sales feed for an
outlet+period. ``outletNetSales`` is the masters' "net sales ÷ outlet staff"
pool; ``perConsultant`` feeds the consultant net-sales tiers.

⛔ §9 F is an OPEN decision: the exact consultant-vs-outlet attribution is to
be locked with the client. v1 attributes a sale to the user who rang it up
(``Sale.createdById`` → their ``Staff``) — best-effort only. "Net sales" =
``Sale.subtotal`` (before-GST), per the doc below.

⛔ ``outletProductSales`` is 0 in v1: the product catalog is deferred (§9 D),
so there are no PRODUCT lines to sum yet.
 */
export interface NetSalesResponse {
  periodYear: number;
  periodMonth: number;
  outletId: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outletNetSales: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outletProductSales: string;
  perConsultant?: ConsultantNetSales[];
  staffCount: number;
}

export type NextCustomerNewKind = string | null;

/**
 * DSH-12-07 — one of the next three customers still to come today.
 */
export interface NextCustomer {
  appointmentId: string;
  time: string;
  customerName: string;
  isNew: boolean;
  newKind?: NextCustomerNewKind;
  minutesUntil: number;
}

/**
 * DSH-08-04 — one line for a KPI of hers that is behind.
 */
export interface NextStep {
  outletCode: string;
  kpi: string;
  figure: string;
  found: string;
  step: string;
  taskTitle: string;
}

/**
 * GET /leave/ot/balance response body.
 */
export interface OTBalanceResponse {
  staffId: string;
  year: number;
  accruedMinutes: number;
  usedMinutes: number;
  convertedToPayMinutes: number;
  convertedToPayAmount: string;
  balanceMinutes: number;
}

export type OTCancelRequestReason = string | null;

/**
 * Optional free text recorded against the cancellation (spec 7.2).
 */
export interface OTCancelRequest {
  reason?: OTCancelRequestReason;
}

export type OTLedgerCreateRequestUsageKind = string | null;

export type OTLedgerCreateRequestPayAmount = string | null;

export type OTLedgerCreateRequestWorkDate = string | null;

export type OTLedgerCreateRequestReason = string | null;

/**
 * POST /leave/ot — admin manual OT entry (accrue / use / convert-to-pay).
 */
export interface OTLedgerCreateRequest {
  staffId: string;
  entryType: string;
  usageKind?: OTLedgerCreateRequestUsageKind;
  minutes: number;
  payAmount?: OTLedgerCreateRequestPayAmount;
  workDate?: OTLedgerCreateRequestWorkDate;
  reason?: OTLedgerCreateRequestReason;
  leaveYear: number;
}

export type OTLedgerEntryResponseStaffName = string | null;

export type OTLedgerEntryResponseUsageKind = string | null;

export type OTLedgerEntryResponsePayAmount = string | null;

export type OTLedgerEntryResponseWorkDate = string | null;

export type OTLedgerEntryResponseReason = string | null;

export type OTLedgerEntryResponseRecordedById = string | null;

export type OTLedgerEntryResponseRecordedByName = string | null;

export type OTLedgerEntryResponseCohortMonth = string | null;

export type OTLedgerEntryResponseExpiresAt = string | null;

export type OTLedgerEntryResponseRemainingMinutes = number | null;

export type OTLedgerEntryResponseCreatedAt = string | null;

/**
 * A single OT-ledger row (mirrors ``LeaveCreditResponse``).
 */
export interface OTLedgerEntryResponse {
  id: string;
  staffId: string;
  staffName?: OTLedgerEntryResponseStaffName;
  entryType: string;
  usageKind?: OTLedgerEntryResponseUsageKind;
  minutes: number;
  payAmount?: OTLedgerEntryResponsePayAmount;
  source: string;
  workDate?: OTLedgerEntryResponseWorkDate;
  reason?: OTLedgerEntryResponseReason;
  recordedById?: OTLedgerEntryResponseRecordedById;
  recordedByName?: OTLedgerEntryResponseRecordedByName;
  cohortMonth?: OTLedgerEntryResponseCohortMonth;
  expiresAt?: OTLedgerEntryResponseExpiresAt;
  isExpired?: boolean;
  expiredMinutes?: number;
  remainingMinutes?: OTLedgerEntryResponseRemainingMinutes;
  leaveYear: number;
  createdAt?: OTLedgerEntryResponseCreatedAt;
}

/**
 * GET /leave/ot response body.
 */
export interface OTLedgerListResponse {
  entries?: OTLedgerEntryResponse[];
  balanceMinutes?: number;
}

export type OTRequestCreateWorkDate = string | null;

export type OTRequestCreateReason = string | null;

export type OTRequestCreateLeaveYear = number | null;

/**
 * POST /leave/ot/requests — a staff member applying to use their own OT.

No ``staffId``: the server always uses the caller's own staff record, so one
person can never file against another's balance.
 */
export interface OTRequestCreate {
  minutes: number;
  workDate?: OTRequestCreateWorkDate;
  reason?: OTRequestCreateReason;
  leaveYear?: OTRequestCreateLeaveYear;
}

export interface OTRequestListResponse {
  requests?: OTRequestResponse[];
}

export type OTRequestResponseStaffName = string | null;

export type OTRequestResponseWorkDate = string | null;

export type OTRequestResponseReason = string | null;

export type OTRequestResponseReviewedById = string | null;

export type OTRequestResponseReviewedAt = string | null;

export type OTRequestResponseReviewNote = string | null;

export type OTRequestResponseCreatedAt = string | null;

export type OTRequestResponseRestoredMinutes = number | null;

export interface OTRequestResponse {
  id: string;
  staffId: string;
  staffName?: OTRequestResponseStaffName;
  minutes: number;
  usageKind: string;
  workDate?: OTRequestResponseWorkDate;
  reason?: OTRequestResponseReason;
  status: string;
  reviewedById?: OTRequestResponseReviewedById;
  reviewedAt?: OTRequestResponseReviewedAt;
  reviewNote?: OTRequestResponseReviewNote;
  leaveYear: number;
  createdAt?: OTRequestResponseCreatedAt;
  canCancel?: boolean;
  restoredMinutes?: OTRequestResponseRestoredMinutes;
}

export type OTRequestReviewNote = string | null;

/**
 * Manager approve/reject body.
 */
export interface OTRequestReview {
  note?: OTRequestReviewNote;
}

/**
 * One HQ desk (DSH-02-01 / DSH-08-01) — one per HQ staff member.
 */
export interface OfficeDesk {
  staffId: string;
  name: string;
  isMine: boolean;
}

/**
 * GET /dashboard/office-desks — the desk tabs, the caller's own desk first.
 */
export interface OfficeDesksResponse {
  desks: OfficeDesk[];
}

/**
 * GET /dashboard/old-balances-campaign — DSH-22, both outlets side by side.
 */
export interface OldBalancesCampaignResponse {
  today: string;
  outlets: OldBalancesOutlet[];
}

export type OldBalancesGradeRowPayRate = number | null;

/**
 * DSH-22-05 'Did the order rule hold?' — one grade.
 */
export interface OldBalancesGradeRow {
  grade: string;
  customers: number;
  called: number;
  paid: number;
  payRate?: OldBalancesGradeRowPayRate;
}

export type OldBalancesOutletFirstDay = string | null;

export type OldBalancesOutletLastDay = string | null;

export type OldBalancesOutletCountedTo = string | null;

/**
 * One outlet's side of the Old balances campaign report (DSH-22).
 */
export interface OldBalancesOutlet {
  outletCode: string;
  status: string;
  firstDay?: OldBalancesOutletFirstDay;
  lastDay?: OldBalancesOutletLastDay;
  countedTo?: OldBalancesOutletCountedTo;
  audience?: number;
  called?: number;
  paid?: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paidAmount?: string;
  sessionsPaidFor?: number;
  sessionsLeft?: number;
  noResult?: number;
  noResultDidntPickUp?: number;
  noResultRefused?: number;
  noResultOther?: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  noResultAmount?: string;
  noResultOverTwoYears?: number;
  handledOnOtherList?: number;
  doNotContact?: number;
  grades?: OldBalancesGradeRow[];
  unusedCustomers?: number;
  unusedPaidFor?: number;
  unusedSessions?: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unusedWorth?: string;
  customerIdsNoResult?: string[];
}

/**
 * DSH-12-08 — who is working today, in the order Master · Therapists · Consultant.
 */
export interface OnDutyLine {
  masters: string[];
  therapists: string[];
  consultants: string[];
}

/**
 * Response from ``GET /api/reports/operations``.
 */
export interface OperationsAnalyticsResponse {
  period: OperationsPeriod;
  newCustomerAppointments?: number;
  existingCustomerAppointments?: number;
  usageByDate?: OperationsUsageEntry[];
  roomUtilization?: OperationsRoomEntry[];
}

/**
 * Management view, B · Operations — month to date, both outlets. Counts
(and the room-utilisation share moved here from the Outlet view, DSH-14-08);
each opens the report it came from.
 */
export interface OperationsCounts {
  appointments: number;
  cancellations: number;
  consultationsBooked: number;
  consultationsCompleted: number;
  utilisationRate: number;
}

export type OperationsPeriodMonth = string | null;

/**
 * The resolved window, as ``_serialize_period`` emits it.
 */
export interface OperationsPeriod {
  type: string;
  startDate: string;
  endDate: string;
  month?: OperationsPeriodMonth;
}

export interface OperationsRoomEntry {
  roomId: string;
  roomName: string;
  outletCode: string;
  totalMinutes?: number;
  appointmentCount?: number;
  occupancyPct?: number;
}

export interface OperationsUsageEntry {
  date: string;
  completedCount?: number;
}

export interface OriginalStaffSummary {
  id: string;
  name: string;
}

export interface OutletAffectedAppointment {
  id: string;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  customerName: string;
}

export type OutletAuthorityChartInPackageUpgradeText = string | null;

export type OutletAuthorityChartInExpiryExtensionText = string | null;

export type OutletAuthorityChartInStaffProgramsText = string | null;

export type OutletAuthorityChartInNotes = string | null;

export interface OutletAuthorityChartIn {
  effectiveFrom: string;
  title: string;
  packageUpgradeText?: OutletAuthorityChartInPackageUpgradeText;
  expiryExtensionText?: OutletAuthorityChartInExpiryExtensionText;
  staffProgramsText?: OutletAuthorityChartInStaffProgramsText;
  notes?: OutletAuthorityChartInNotes;
  rules?: OutletAuthorityRuleIn[];
}

export interface OutletAuthorityChartListResponse {
  items: OutletAuthorityChartSummary[];
}

export type OutletAuthorityChartOutPackageUpgradeText = string | null;

export type OutletAuthorityChartOutExpiryExtensionText = string | null;

export type OutletAuthorityChartOutStaffProgramsText = string | null;

export type OutletAuthorityChartOutNotes = string | null;

export interface OutletAuthorityChartOut {
  id: string;
  effectiveFrom: string;
  title: string;
  ruleCount: number;
  current: boolean;
  packageUpgradeText: OutletAuthorityChartOutPackageUpgradeText;
  expiryExtensionText: OutletAuthorityChartOutExpiryExtensionText;
  staffProgramsText: OutletAuthorityChartOutStaffProgramsText;
  notes: OutletAuthorityChartOutNotes;
  rules: OutletAuthorityRuleOut[];
}

export interface OutletAuthorityChartSummary {
  id: string;
  effectiveFrom: string;
  title: string;
  ruleCount: number;
  current: boolean;
}

export type OutletAuthorityOptionLimitText = string | null;

/**
 * One answer to 'Which outlet authority?': the six chart rows plus Package
upgrade and One-time complimentary expiry extension. ``limits`` are the
row's cells from the chart in force; ``limitText`` the text block for the
two extra picks.
 */
export interface OutletAuthorityOption {
  key: string;
  label: string;
  limits: AuthorityLimit[];
  limitText: OutletAuthorityOptionLimitText;
}

export type OutletAuthorityOptionsResponseChartId = string | null;

export type OutletAuthorityOptionsResponseChartTitle = string | null;

export type OutletAuthorityOptionsResponseEffectiveFrom = string | null;

export interface OutletAuthorityOptionsResponse {
  chartId: OutletAuthorityOptionsResponseChartId;
  chartTitle: OutletAuthorityOptionsResponseChartTitle;
  effectiveFrom: OutletAuthorityOptionsResponseEffectiveFrom;
  options: OutletAuthorityOption[];
}

export type OutletAuthorityRuleInAllowed = boolean | null;

export type OutletAuthorityRuleInLimitText = string | null;

/**
 * One cell of the chart as HQ types it. ``allowed`` None = not filled in.
 */
export interface OutletAuthorityRuleIn {
  authorityKey: string;
  authorityLabel: string;
  sortOrder?: number;
  packageSessions: number;
  purchaseMethod: string;
  allowed?: OutletAuthorityRuleInAllowed;
  limitText?: OutletAuthorityRuleInLimitText;
}

export type OutletAuthorityRuleOutAllowed = boolean | null;

export type OutletAuthorityRuleOutLimitText = string | null;

export interface OutletAuthorityRuleOut {
  authorityKey: string;
  authorityLabel: string;
  sortOrder?: number;
  packageSessions: number;
  purchaseMethod: string;
  allowed?: OutletAuthorityRuleOutAllowed;
  limitText?: OutletAuthorityRuleOutLimitText;
  id: string;
}

export interface OutletBreakdownListResponse {
  items?: OutletBreakdownRow[];
}

export type OutletBreakdownRowServiceComm = string | null;

export type OutletBreakdownRowSalesComm = string | null;

export type OutletBreakdownRowIncentive = string | null;

export type OutletBreakdownRowSentAt = string | null;

export type OutletBreakdownRowSentSubject = string | null;

export type OutletBreakdownRowSentBody = string | null;

export type OutletBreakdownRowReplyBy = string | null;

export type OutletBreakdownRowQueryText = string | null;

export type OutletBreakdownRowRepliedAt = string | null;

export type OutletBreakdownRowRepliedByName = string | null;

/**
 * Request 117 — one staff member's sent breakdown, on the list of an outlet
manager who may answer for her outlet's staff.
 */
export interface OutletBreakdownRow {
  id: string;
  month: string;
  status: string;
  serviceComm?: OutletBreakdownRowServiceComm;
  salesComm?: OutletBreakdownRowSalesComm;
  incentive?: OutletBreakdownRowIncentive;
  sentAt?: OutletBreakdownRowSentAt;
  sentSubject?: OutletBreakdownRowSentSubject;
  sentBody?: OutletBreakdownRowSentBody;
  replyBy?: OutletBreakdownRowReplyBy;
  queryText?: OutletBreakdownRowQueryText;
  repliedAt?: OutletBreakdownRowRepliedAt;
  staffId: string;
  staffName: string;
  repliedByName?: OutletBreakdownRowRepliedByName;
}

/**
 * Minimal outlet stub embedded in the config responses (the admin table only
renders the name).
 */
export interface OutletBrief {
  id: string;
  name: string;
}

export type OutletChangeItemFromOutlet = string | null;

export type OutletChangeItemToOutlet = string | null;

export type OutletChangeItemChangedBy = string | null;

/**
 * One change of Preferred Outlet (CUS-06-05, CUS-02-13).
 */
export interface OutletChangeItem {
  id: string;
  fromOutlet?: OutletChangeItemFromOutlet;
  toOutlet?: OutletChangeItemToOutlet;
  changedBy?: OutletChangeItemChangedBy;
  changedAt: string;
}

export type OutletDayEffectiveOpenTime = string | null;

export type OutletDayEffectiveCloseTime = string | null;

export type OutletDayEffectiveReason = string | null;

/**
 * What applies on one date: the weekly hours or a special entry.
 */
export interface OutletDayEffective {
  date: string;
  operating: boolean;
  openTime?: OutletDayEffectiveOpenTime;
  closeTime?: OutletDayEffectiveCloseTime;
  source: string;
  reason?: OutletDayEffectiveReason;
}

export type OutletDayHoursOpen = string | null;

export type OutletDayHoursClose = string | null;

/**
 * One weekday of an outlet's opening hours (Settings > Outlets).
 */
export interface OutletDayHours {
  day: string;
  operating?: boolean;
  open?: OutletDayHoursOpen;
  close?: OutletDayHoursClose;
}

export type OutletDetailSummaryAddress = string | null;

export type OutletDetailSummaryPhone = string | null;

export interface OutletDetailSummary {
  id: string;
  name: string;
  code: string;
  address?: OutletDetailSummaryAddress;
  phone?: OutletDetailSummaryPhone;
}

export type OutletFiguresOutletCode = string | null;

/**
 * One outlet's figures for the period (the charts read these).
 */
export interface OutletFigures {
  outletId: string;
  outletCode?: OutletFiguresOutletCode;
  outletName: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  revenue: string;
  invoices: number;
  invoicesWithActivity: number;
  consultationsHeld: number;
  closed: number;
  packagesSigned: number;
  newCustomers: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  salesFromNew: string;
  rosteredHours: number;
  clientFacingHours: number;
}

export type OutletGoalOutletCode = string | null;

export interface OutletGoal {
  outletId: string;
  outletCode?: OutletGoalOutletCode;
  outletName: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales: string;
  minimum: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  forecast: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  lastMonth: string;
  utilisationRate: number;
}

export type OutletKpisOutletCode = string | null;

export interface OutletKpis {
  outletId: string;
  outletCode?: OutletKpisOutletCode;
  outletName: string;
  cells: KpiCell[];
  behind: number;
  judged: number;
}

/**
 * DSH-12-02 — the sales part of 'This month · sales and KPI'.
 */
export interface OutletMonthSales {
  monthStart: string;
  daysInMonth: number;
  daysGone: number;
  daysLeft: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outletNetSales: string;
  outletMinimum: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outletForecast: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  neededPerDay: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  lastMonthNetSales: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  lastMonthSameDays: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothNetSales: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  bothForecast: string;
  incentiveMarks: number[];
  byDay: OutletSalesDay[];
}

/**
 * GET /salary/monthly-outlet-targets response body.
 */
export interface OutletMonthlyTargetListResponse {
  targets?: OutletMonthlyTargetResponse[];
}

export type OutletMonthlyTargetResponseCustomersServedTarget = number | null;

export type OutletMonthlyTargetResponseSalesTarget = string | null;

export type OutletMonthlyTargetResponseUpdatedAt = string | null;

/**
 * One outlet's targets for one month (Head Master 5% → 10% step-up).
 */
export interface OutletMonthlyTargetResponse {
  id: string;
  outletId: string;
  periodYear: number;
  periodMonth: number;
  customersServedTarget?: OutletMonthlyTargetResponseCustomersServedTarget;
  salesTarget?: OutletMonthlyTargetResponseSalesTarget;
  updatedAt?: OutletMonthlyTargetResponseUpdatedAt;
}

export type OutletMonthlyTargetUpsertRequestCustomersServedTarget = number | null;

export type OutletMonthlyTargetUpsertRequestSalesTarget = number | string | null;

/**
 * PUT /salary/monthly-outlet-targets — create or replace one outlet-month.

Leaving a target empty (null) means 'not set': the Head Master then gets the
5% base for that month, never the 10% step-up.
 */
export interface OutletMonthlyTargetUpsertRequest {
  outletId: string;
  periodYear: number;
  periodMonth: number;
  customersServedTarget?: OutletMonthlyTargetUpsertRequestCustomersServedTarget;
  salesTarget?: OutletMonthlyTargetUpsertRequestSalesTarget;
}

export type OutletMonthsOutletCode = string | null;

export interface OutletMonths {
  outletCode?: OutletMonthsOutletCode;
  outletName: string;
  months: MonthValue[];
}

export type OutletNowResponseOutletCode = string | null;

export type OutletNowResponseOutletName = string | null;

export type OutletNowResponseRing = OutletNowRing | null;

export type OutletNowResponseTiles = OutletNowTiles | null;

export type OutletNowResponseCustomerCare = CustomerCareBox | null;

/**
 * GET /office-desk/desks/{owner}/outlet-now. ``outlet_code`` None = this
desk runs no outlet (Lisa) and the block is not drawn; ``hidden`` = the
outlet is closed today (public holiday, DSH-10-09).
 */
export interface OutletNowResponse {
  date: string;
  outletCode?: OutletNowResponseOutletCode;
  outletName?: OutletNowResponseOutletName;
  hidden?: boolean;
  ring?: OutletNowResponseRing;
  tiles?: OutletNowResponseTiles;
  rows?: OutletNowRow[];
  customerCare?: OutletNowResponseCustomerCare;
  notAvailable?: string[];
}

export type OutletNowRingByList = {[key: string]: number};

export type OutletNowRingGuidance = string | null;

/**
 * DSH-10-01: 'Appointments I made today' — the office person's OWN task
(3 a day), never the outlet's target. Waitlist bookings are shown for
information only and are not in the count (owner, 12 Oct).
 */
export interface OutletNowRing {
  made: number;
  target: number;
  waitlist?: number;
  byList?: OutletNowRingByList;
  guidance?: OutletNowRingGuidance;
}

/**
 * One of the 4-5 rows (DSH-10-02): WHAT (figure, red when off) · WHERE IT
STANDS (one fact) · '→ WHAT TO DO' (one instruction, editable text) · one
button to the screen. A row with no instruction that day is not sent
(DSH-10-05).
 */
export interface OutletNowRow {
  key: string;
  figure: string;
  red?: boolean;
  fact: string;
  action: string;
  screen: string;
}

export type OutletNowTilesSalesThisMonth = string | null;

export type OutletNowTilesWhatToSell = string | null;

/**
 * The three tiles. ``None`` is drawn as '—': sales this month is money and
What to sell is not built (DSH-10-09).
 */
export interface OutletNowTiles {
  salesThisMonth?: OutletNowTilesSalesThisMonth;
  redLeft?: number;
  redTarget?: number;
  whatToSell?: OutletNowTilesWhatToSell;
}

export type OutletOutPhone = string | null;

export interface OutletOut {
  name: string;
  code: string;
  address: string;
  phone?: OutletOutPhone;
  weekdayOpen: string;
  weekdayClose: string;
  weekendOpen: string;
  weekendClose: string;
  restTimeMinutes?: number;
  id: string;
  operatingHours?: OutletDayHours[];
  isEnabled?: boolean;
  invoiceExpiryMonths?: number;
  types?: string[];
  createdAt: string;
  updatedAt: string;
}

export type OutletSalesDayThisMonth = string | null;

export type OutletSalesDayLastMonth = string | null;

/**
 * One day of the running-total chart; ``None`` = not reached / no such day.
 */
export interface OutletSalesDay {
  day: number;
  thisMonth?: OutletSalesDayThisMonth;
  lastMonth?: OutletSalesDayLastMonth;
}

export type OutletSalesResponseOutletId = string | null;

/**
 * GET /dashboard/outlet-sales — the Outlet view's money figures.
 */
export interface OutletSalesResponse {
  date: string;
  outletId?: OutletSalesResponseOutletId;
  today: OutletSalesToday;
  month: OutletMonthSales;
}

export type OutletSalesTargetCreateRequestOutletId = string | null;

export type OutletSalesTargetCreateRequestSalesThreshold = number | string;

export type OutletSalesTargetCreateRequestIncentiveAmount = number | string;

/**
 * POST /salary/outlet-targets request body.
 */
export interface OutletSalesTargetCreateRequest {
  outletId?: OutletSalesTargetCreateRequestOutletId;
  salesThreshold: OutletSalesTargetCreateRequestSalesThreshold;
  incentiveAmount: OutletSalesTargetCreateRequestIncentiveAmount;
  isActive?: boolean;
}

/**
 * GET /salary/outlet-targets response body.
 */
export interface OutletSalesTargetListResponse {
  outletTargets?: OutletSalesTargetResponse[];
}

export type OutletSalesTargetResponseOutletId = string | null;

export type OutletSalesTargetResponseCreatedAt = string | null;

export type OutletSalesTargetResponseUpdatedAt = string | null;

/**
 * A single outlet-sales-target band row.
 */
export interface OutletSalesTargetResponse {
  id: string;
  outletId?: OutletSalesTargetResponseOutletId;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  salesThreshold: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  incentiveAmount: string;
  isActive: boolean;
  createdAt?: OutletSalesTargetResponseCreatedAt;
  updatedAt?: OutletSalesTargetResponseUpdatedAt;
}

export type OutletSalesTargetUpdateRequestSalesThreshold = number | string | null;

export type OutletSalesTargetUpdateRequestIncentiveAmount = number | string | null;

export type OutletSalesTargetUpdateRequestIsActive = boolean | null;

/**
 * PUT /salary/outlet-targets/{id} request body — all fields optional.
 */
export interface OutletSalesTargetUpdateRequest {
  salesThreshold?: OutletSalesTargetUpdateRequestSalesThreshold;
  incentiveAmount?: OutletSalesTargetUpdateRequestIncentiveAmount;
  isActive?: OutletSalesTargetUpdateRequestIsActive;
}

/**
 * DSH-12-06 Today's sales tile — GEN-14 net sales of today.
 */
export interface OutletSalesToday {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  netSales: string;
  packages: number;
  aLaCarte: number;
}

export type OutletSpecialHoursInDateTo = string | null;

export type OutletSpecialHoursInOpenTime = string | null;

export type OutletSpecialHoursInCloseTime = string | null;

export type OutletSpecialHoursInReason = string | null;

/**
 * Add / edit a special operating-hours entry. ``date_to`` empty = one day.
 */
export interface OutletSpecialHoursIn {
  dateFrom: string;
  dateTo?: OutletSpecialHoursInDateTo;
  isClosed?: boolean;
  openTime?: OutletSpecialHoursInOpenTime;
  closeTime?: OutletSpecialHoursInCloseTime;
  reason?: OutletSpecialHoursInReason;
}

export type OutletSpecialHoursOutOpenTime = string | null;

export type OutletSpecialHoursOutCloseTime = string | null;

export type OutletSpecialHoursOutReason = string | null;

export interface OutletSpecialHoursOut {
  id: string;
  outletId: string;
  dateFrom: string;
  dateTo: string;
  isClosed: boolean;
  openTime?: OutletSpecialHoursOutOpenTime;
  closeTime?: OutletSpecialHoursOutCloseTime;
  reason?: OutletSpecialHoursOutReason;
  createdAt: string;
  updatedAt: string;
}

/**
 * The saved entry plus bookings already on those dates that now fall outside
the outlet's hours. They are left alone; the list is a warning.
 */
export interface OutletSpecialHoursSaved {
  entry: OutletSpecialHoursOut;
  affectedAppointments?: OutletAffectedAppointment[];
}

/**
 * Management view, F · Outlet staff this month — one line per person per
outlet worked. Counts and hours only: no commission, no sales.
 */
export interface OutletStaffMonth {
  staffId: string;
  name: string;
  outletCode: string;
  role: string;
  appointmentsCompleted: number;
  scheduledHours: number;
  workedHours: number;
}

export interface OutletStaffOption {
  id: string;
  name: string;
}

export interface OutletSummary {
  id: string;
  name: string;
  code: string;
}

export type OutletTodayResponseOutletId = string | null;

/**
 * GET /dashboard/outlet-today — the top of the Outlet view (DSH-12/14).
 */
export interface OutletTodayResponse {
  date: string;
  outletId?: OutletTodayResponseOutletId;
  onDuty: OnDutyLine;
  appointmentsToday: number;
  newCustomersToday: number;
  newTriedToday?: number;
  newNeverTreatedToday?: number;
  nextCustomers: NextCustomer[];
  myApprovalRequests: MyApprovalRequest[];
  rejectedExtensions: RejectedExtension[];
}

export type OutletUpdateRestTimeMinutes = number | null;

export type OutletUpdateName = string | null;

export type OutletUpdateAddress = string | null;

export type OutletUpdatePhone = string | null;

export type OutletUpdateIsEnabled = boolean | null;

export type OutletUpdateInvoiceExpiryMonths = number | null;

export type OutletUpdateOperatingHours = OutletDayHours[] | null;

/**
 * Partial update for a single outlet.

`catalog_service.update_outlets` has always persisted name/code/address/
phone/hours, but this schema only declared `rest_time_minutes`, so
`model_dump()` silently dropped everything else and the outlet could not be
renamed through the API. Name, address and phone are now declared; the remaining
service-supported fields stay unexposed until there is a UI asking for them.

Every field but `id` is optional — send only what you are changing.
 */
export interface OutletUpdate {
  id: string;
  restTimeMinutes?: OutletUpdateRestTimeMinutes;
  name?: OutletUpdateName;
  address?: OutletUpdateAddress;
  phone?: OutletUpdatePhone;
  isEnabled?: OutletUpdateIsEnabled;
  invoiceExpiryMonths?: OutletUpdateInvoiceExpiryMonths;
  operatingHours?: OutletUpdateOperatingHours;
}

export type OutletUtilisationTrendOutletCode = string | null;

export interface OutletUtilisationTrend {
  outletId: string;
  outletCode?: OutletUtilisationTrendOutletCode;
  outletName: string;
  rate: number;
  weeks: WeeklyPoint[];
}

export type OutstandingSaleResponseInvoiceNumber = string | null;

/**
 * One invoice with money still owing on it.
 */
export interface OutstandingSaleResponse {
  id: string;
  invoiceNumber?: OutstandingSaleResponseInvoiceNumber;
  invoiceDate: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  paid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  taxable: string;
  saleType: string;
}

/**
 * GET /finance/sales/{customer_id}/outstanding.
 */
export interface OutstandingSalesListResponse {
  items?: OutstandingSaleResponse[];
}

export type OverallRating = typeof OverallRating[keyof typeof OverallRating];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OverallRating = {
  D: 'D',
  N: 'N',
  S: 'S',
  VS: 'VS',
} as const;

export type OwnerRulesOwnerUserId = string | null;

export type OwnerRulesReview = ReviewLine | null;

export interface OwnerRules {
  ownerName: string;
  ownerUserId: OwnerRulesOwnerUserId;
  isMine?: boolean;
  rules: RuleOut[];
  pendingAdds: RuleChangeOut[];
  review: OwnerRulesReview;
}

/**
 * Active-package expiry buckets.
 */
export interface PackageAnalyticsExpiryRisk {
  within30Days: number;
  within60Days: number;
  within90Days: number;
}

/**
 * Per-program analytics row.
 */
export interface PackageAnalyticsProgramItem {
  programId: string;
  programName: string;
  category: string;
  totalPackages: number;
  activePackages: number;
  expiredPackages: number;
  totalSessions: number;
  usedSessions: number;
  revenue: number;
  remainingSessions: number;
  utilization: number;
}

/**
 * Response from ``GET /api/packages/analytics``.
 */
export interface PackageAnalyticsResponse {
  summary: PackageAnalyticsSummary;
  byProgram?: PackageAnalyticsProgramItem[];
}

/**
 * Package counts by status.
 */
export interface PackageAnalyticsStatusBreakdown {
  active: number;
  expired: number;
  transferred: number;
  refunded: number;
}

/**
 * Top-level package analytics summary block.
 */
export interface PackageAnalyticsSummary {
  totalPackages: number;
  activePackages: number;
  totalSessionsSold: number;
  totalSessionsUsed: number;
  totalSessionsRemaining: number;
  overallUtilization: number;
  totalRevenue: number;
  statusBreakdown: PackageAnalyticsStatusBreakdown;
  expiryRisk: PackageAnalyticsExpiryRisk;
  lowUtilization: number;
}

/**
 * GET /finance/package-changes — the approval queue (filterable).
 */
export interface PackageChangeListResponse {
  packageChanges?: PackageChangeResponse[];
  total: number;
}

export type PackageChangeResponseCustomerId = string | null;

export type PackageChangeResponseCustomerName = string | null;

export type PackageChangeResponseFromProgramName = string | null;

export type PackageChangeResponseToProgramName = string | null;

export type PackageChangeResponseFromProgramId = string | null;

export type PackageChangeResponseToProgramId = string | null;

export type PackageChangeResponseTopUpAmount = string | null;

export type PackageChangeResponseRefundAmount = string | null;

export type PackageChangeResponseRuleId = string | null;

export type PackageChangeResponseApprovedById = string | null;

export type PackageChangeResponseApprovedAt = string | null;

export type PackageChangeResponseApprovalNote = string | null;

export type PackageChangeResponseSaleId = string | null;

export type PackageChangeResponseNewPackageId = string | null;

export type PackageChangeResponseCreatedById = string | null;

export type PackageChangeResponseCreatedAt = string | null;

export type PackageChangeResponseUpdatedAt = string | null;

export type PackageChangeResponseRequestReason = string | null;

export type PackageChangeResponseOutletId = string | null;

export type PackageChangeResponseRequestedExpiryDate = string | null;

export type PackageChangeResponseRefundSessions = number | null;

export type PackageChangeResponseRequestedAmount = string | null;

export type PackageChangeResponseAdminChargeAmount = string | null;

export type PackageChangeResponseToCustomerId = string | null;

export type PackageChangeResponseToCustomerName = string | null;

export type PackageChangeResponseRefundFormAnyOf = { [key: string]: unknown };

export type PackageChangeResponseRefundForm = PackageChangeResponseRefundFormAnyOf | null;

export type PackageChangeResponseRefundCreditNoteNumber = string | null;

/**
 * A persisted PackageChange row (§5.7) — the audited upgrade/change/refund
decision + computation trail + approval state.
 */
export interface PackageChangeResponse {
  id: string;
  packageId: string;
  customerId?: PackageChangeResponseCustomerId;
  customerName?: PackageChangeResponseCustomerName;
  fromProgramName?: PackageChangeResponseFromProgramName;
  toProgramName?: PackageChangeResponseToProgramName;
  changeType: string;
  fromProgramId?: PackageChangeResponseFromProgramId;
  toProgramId?: PackageChangeResponseToProgramId;
  usedSessions: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  computedValue: string;
  topUpAmount?: PackageChangeResponseTopUpAmount;
  refundAmount?: PackageChangeResponseRefundAmount;
  ruleId?: PackageChangeResponseRuleId;
  approvalStatus: string;
  approvedById?: PackageChangeResponseApprovedById;
  approvedAt?: PackageChangeResponseApprovedAt;
  approvalNote?: PackageChangeResponseApprovalNote;
  saleId?: PackageChangeResponseSaleId;
  newPackageId?: PackageChangeResponseNewPackageId;
  createdById?: PackageChangeResponseCreatedById;
  createdAt?: PackageChangeResponseCreatedAt;
  updatedAt?: PackageChangeResponseUpdatedAt;
  requestReason?: PackageChangeResponseRequestReason;
  outletId?: PackageChangeResponseOutletId;
  requestedExpiryDate?: PackageChangeResponseRequestedExpiryDate;
  extensionReasons?: string[];
  attachments?: string[];
  refundSessions?: PackageChangeResponseRefundSessions;
  requestedAmount?: PackageChangeResponseRequestedAmount;
  adminChargeAmount?: PackageChangeResponseAdminChargeAmount;
  signed?: boolean;
  toCustomerId?: PackageChangeResponseToCustomerId;
  toCustomerName?: PackageChangeResponseToCustomerName;
  refundForm?: PackageChangeResponseRefundForm;
  refundAsCreditNote?: boolean;
  refundCreditNoteNumber?: PackageChangeResponseRefundCreditNoteNumber;
}

export interface PackageExtendRequest {
  newExpiryDate: string;
  reason: string;
  isFreeExtension?: boolean;
}

export interface PackageExtendResponse {
  id: string;
  previousExpiryDate: string;
  newExpiryDate: string;
  freeExtensionUsed: boolean;
  reason: string;
}

/**
 * The earliest unpaid IHIP schedule item (the next collection owed).
 */
export interface PackageIHIPNextDue {
  sessionNumber: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountDue: string;
}

export type PackageIHIPSummaryNextDue = PackageIHIPNextDue | null;

/**
 * The IHIP block on the package payment history — present only when the
package carries an ``IHIPPlan``.
 */
export interface PackageIHIPSummary {
  planVariant: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountPaid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outstanding: string;
  nextDue?: PackageIHIPSummaryNextDue;
}

export type PackagePaymentEntryPaidAt = string | null;

export type PackagePaymentEntrySessionNumber = number | null;

/**
 * A single payment in a package's payment history (Docket Packages tab).
 */
export interface PackagePaymentEntry {
  paidAt?: PackagePaymentEntryPaidAt;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  method: string;
  paymentType: string;
  sessionNumber?: PackagePaymentEntrySessionNumber;
}

export type PackagePaymentHistoryResponseIhip = PackageIHIPSummary | null;

/**
 * GET /packages/{id}/payments — the Docket seam payment history + optional
IHIP summary. ``sessionNumber`` on an entry comes from the linked
``InstallmentScheduleItem`` when the payment is an IHIP installment.
 */
export interface PackagePaymentHistoryResponse {
  packageId: string;
  payments?: PackagePaymentEntry[];
  ihip?: PackagePaymentHistoryResponseIhip;
}

/**
 * P1 — an invoice a $100 extension can be sold for.
 */
export interface PaidExtensionInvoice {
  invoiceNumber: string;
  packages: PaidExtensionPackage[];
}

export interface PaidExtensionPackage {
  programName: string;
  expiryDate: string;
  expired: boolean;
  newExpiryDate: string;
}

export type PaymentCreateAmount = number | string;

export type PaymentCreateNotes = string | null;

/**
 * A tendered payment on a checkout sale request.
 */
export interface PaymentCreate {
  method: string;
  amount: PaymentCreateAmount;
  paymentType?: string;
  notes?: PaymentCreateNotes;
}

export type PaymentResponseSaleId = string | null;

export type PaymentResponsePackageId = string | null;

export type PaymentResponseCustomerId = string | null;

export type PaymentResponseOutletId = string | null;

export type PaymentResponseReceiptNumber = string | null;

export type PaymentResponsePaidAt = string | null;

export type PaymentResponseInstallmentScheduleItemId = string | null;

export type PaymentResponseReceivedById = string | null;

export type PaymentResponseNotes = string | null;

export type PaymentResponseCreatedAt = string | null;

/**
 * A persisted payment row.
 */
export interface PaymentResponse {
  id: string;
  saleId?: PaymentResponseSaleId;
  packageId?: PaymentResponsePackageId;
  customerId?: PaymentResponseCustomerId;
  outletId?: PaymentResponseOutletId;
  receiptNumber?: PaymentResponseReceiptNumber;
  method: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  paymentType: string;
  paidAt?: PaymentResponsePaidAt;
  installmentScheduleItemId?: PaymentResponseInstallmentScheduleItemId;
  receivedById?: PaymentResponseReceivedById;
  notes?: PaymentResponseNotes;
  createdAt?: PaymentResponseCreatedAt;
}

export type PaymentTypeCreateBank = string | null;

export type PaymentTypeCreateBankChargePercent = number | string | null;

export type PaymentTypeCreateRemarks = string | null;

export interface PaymentTypeCreate {
  name: string;
  code: string;
  bank?: PaymentTypeCreateBank;
  bankChargePercent?: PaymentTypeCreateBankChargePercent;
  category: string;
  allowOverPay?: boolean;
  enabled?: boolean;
  remarks?: PaymentTypeCreateRemarks;
  outletIds: string[];
}

export interface PaymentTypeListResponse {
  items: PaymentTypeResponse[];
}

export type PaymentTypeResponseBank = string | null;

export type PaymentTypeResponseBankChargePercent = string | null;

export type PaymentTypeResponseRemarks = string | null;

export interface PaymentTypeResponse {
  id: string;
  name: string;
  code: string;
  bank: PaymentTypeResponseBank;
  bankChargePercent: PaymentTypeResponseBankChargePercent;
  category: string;
  allowOverPay: boolean;
  enabled: boolean;
  remarks: PaymentTypeResponseRemarks;
  sortOrder: number;
  outlets: OutletBrief[];
}

export type PaymentTypeUpdateName = string | null;

export type PaymentTypeUpdateCode = string | null;

export type PaymentTypeUpdateBank = string | null;

export type PaymentTypeUpdateBankChargePercent = number | string | null;

export type PaymentTypeUpdateCategory = string | null;

export type PaymentTypeUpdateAllowOverPay = boolean | null;

export type PaymentTypeUpdateEnabled = boolean | null;

export type PaymentTypeUpdateRemarks = string | null;

export type PaymentTypeUpdateOutletIds = string[] | null;

export interface PaymentTypeUpdate {
  name?: PaymentTypeUpdateName;
  code?: PaymentTypeUpdateCode;
  bank?: PaymentTypeUpdateBank;
  bankChargePercent?: PaymentTypeUpdateBankChargePercent;
  category?: PaymentTypeUpdateCategory;
  allowOverPay?: PaymentTypeUpdateAllowOverPay;
  enabled?: PaymentTypeUpdateEnabled;
  remarks?: PaymentTypeUpdateRemarks;
  outletIds?: PaymentTypeUpdateOutletIds;
}

export type PayrollUnlockRequestScreen = typeof PayrollUnlockRequestScreen[keyof typeof PayrollUnlockRequestScreen];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayrollUnlockRequestScreen = {
  salary: 'salary',
  'my-pay': 'my-pay',
  commission: 'commission',
  mediation: 'mediation',
} as const;

/**
 * POST /api/auth/payroll-unlock — the signed-in user's own password.
 */
export interface PayrollUnlockRequest {
  /** @minLength 1 */
  password: string;
  screen: PayrollUnlockRequestScreen;
}

export interface PayrollUnlockResponse {
  unlocked: boolean;
  triesLeft: number;
  signedOut: boolean;
}

export type PayslipDetailResponseStaffName = string | null;

export type PayslipDetailResponseStructureId = string | null;

export type PayslipDetailResponseConfirmedAt = string | null;

export type PayslipDetailResponseDisputeReason = string | null;

export type PayslipDetailResponseCreatedAt = string | null;

export type PayslipDetailResponseUpdatedAt = string | null;

export type PayslipDetailResponseBreakdownJson = string | null;

/**
 * GET /salary/payslips/{id} — adds the full line-item breakdown JSON.
 */
export interface PayslipDetailResponse {
  id: string;
  salaryRunId: string;
  staffId: string;
  staffName?: PayslipDetailResponseStaffName;
  structureId?: PayslipDetailResponseStructureId;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  baseSalary: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  fixedOtPay: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  serviceCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  salesCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  productCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  guaranteeCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outletTargetIncentive: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  benefitsTotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unpaidLeaveDeduction?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grossTotal: string;
  confirmStatus: string;
  confirmedAt?: PayslipDetailResponseConfirmedAt;
  disputeReason?: PayslipDetailResponseDisputeReason;
  createdAt?: PayslipDetailResponseCreatedAt;
  updatedAt?: PayslipDetailResponseUpdatedAt;
  breakdownJson?: PayslipDetailResponseBreakdownJson;
}

/**
 * POST /salary/payslips/{id}/dispute request body.
 */
export interface PayslipDisputeRequest {
  reason: string;
}

export type PayslipHistoryItemCreatedAt = string | null;

/**
 * Read-through summary of a Payslip (period + gross + confirm state).
 */
export interface PayslipHistoryItem {
  id: string;
  periodYear: number;
  periodMonth: number;
  grossTotal: number;
  confirmStatus: string;
  createdAt?: PayslipHistoryItemCreatedAt;
}

/**
 * GET /salary/runs/{id}/payslips + /salary/me/payslips response body.
 */
export interface PayslipListResponse {
  payslips?: PayslipResponse[];
  warnings?: string[];
}

export type PayslipResponseStaffName = string | null;

export type PayslipResponseStructureId = string | null;

export type PayslipResponseConfirmedAt = string | null;

export type PayslipResponseDisputeReason = string | null;

export type PayslipResponseCreatedAt = string | null;

export type PayslipResponseUpdatedAt = string | null;

/**
 * A single payslip row (list/summary shape).
 */
export interface PayslipResponse {
  id: string;
  salaryRunId: string;
  staffId: string;
  staffName?: PayslipResponseStaffName;
  structureId?: PayslipResponseStructureId;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  baseSalary: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  fixedOtPay: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  serviceCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  salesCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  productCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  guaranteeCommission: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  outletTargetIncentive: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  benefitsTotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unpaidLeaveDeduction?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grossTotal: string;
  confirmStatus: string;
  confirmedAt?: PayslipResponseConfirmedAt;
  disputeReason?: PayslipResponseDisputeReason;
  createdAt?: PayslipResponseCreatedAt;
  updatedAt?: PayslipResponseUpdatedAt;
}

export type PendingRatingItemCustomerId = string | null;

export type PendingRatingItemCustomerName = string | null;

export type PendingRatingItemProgramId = string | null;

export type PendingRatingItemProgramName = string | null;

export interface PendingRatingItem {
  appointmentId: string;
  date: string;
  startTime: string;
  status: string;
  customerId?: PendingRatingItemCustomerId;
  customerName?: PendingRatingItemCustomerName;
  programId?: PendingRatingItemProgramId;
  programName?: PendingRatingItemProgramName;
  outletId: string;
  outletName: string;
  staffNames: string[];
}

export interface PendingRatingListResponse {
  items: PendingRatingItem[];
  total: number;
}

export interface PermissionCategory {
  key: string;
  label: string;
  group: string;
  perms: PermissionNode[];
}

export type PermissionGrantLevel = typeof PermissionGrantLevel[keyof typeof PermissionGrantLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionGrantLevel = {
  FULL: 'FULL',
  OWN: 'OWN',
  NONE: 'NONE',
} as const;

export interface PermissionGrant {
  permissionKey: string;
  level: PermissionGrantLevel;
}

export type PermissionNodeLevel = typeof PermissionNodeLevel[keyof typeof PermissionNodeLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionNodeLevel = {
  FULL: 'FULL',
  OWN: 'OWN',
  NONE: 'NONE',
} as const;

export interface PermissionNode {
  key: string;
  label: string;
  ownCapable: boolean;
  level: PermissionNodeLevel;
}

/**
 * The templates the OS picks for her list, best first (LEA-23-04).
 */
export interface PickedForHer {
  templateIds?: string[];
  otherTemplateIds?: string[];
}

/**
 * LEA-22-06 4: trial · programme cards · before & after · this month.
 */
export type PictureGroup = typeof PictureGroup[keyof typeof PictureGroup];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PictureGroup = {
  trial: 'trial',
  'programme-cards': 'programme-cards',
  'before-after': 'before-after',
  'this-month': 'this-month',
} as const;

export interface PictureListResponse {
  items?: PictureOut[];
}

export type PictureOutUploadedBy = string | null;

export interface PictureOut {
  id: string;
  name: string;
  group: PictureGroup;
  contentType: string;
  fileSize: number;
  uploadedBy?: PictureOutUploadedBy;
  createdAt: string;
  retired?: boolean;
}

export type PictureUpdateName = string | null;

export type PictureUpdateGroup = PictureGroup | null;

export interface PictureUpdate {
  name?: PictureUpdateName;
  group?: PictureUpdateGroup;
}

export interface PinSet {
  /** @pattern ^\d{4}$ */
  pin: string;
}

/**
 * DSH-17-06 — approved leave still to come this month, with its dates.
 */
export interface PlannedLeave {
  staffId: string;
  name: string;
  outletCode: string;
  role: string;
  startDate: string;
  endDate: string;
}

export type PreferredLanguage = typeof PreferredLanguage[keyof typeof PreferredLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreferredLanguage = {
  EN: 'EN',
  KO: 'KO',
  VI: 'VI',
  ZH: 'ZH',
} as const;

/**
 * GET /finance/pricing — pricing rows (filtered by programId when given).
 */
export interface PricingResponse {
  programs?: ProgramPricing[];
}

export type ProbationEndingItemOutletName = string | null;

/**
 * GET /staff/probation-ending item.
 */
export interface ProbationEndingItem {
  staffId: string;
  name: string;
  outletName?: ProbationEndingItemOutletName;
  probationEndDate: string;
  daysRemaining: number;
}

export type ProductCostPriceCostPrice = string | null;

/**
 * INV-11-08 — one product's cost price (SGD). HQ only; null = none yet.
 */
export interface ProductCostPrice {
  productId: string;
  costPrice?: ProductCostPriceCostPrice;
}

export type ProductCostPriceUpdateCostPrice = number | string | null;

/**
 * HQ sets or clears a product's cost price (null = clear).
 */
export interface ProductCostPriceUpdate {
  costPrice?: ProductCostPriceUpdateCostPrice;
}

export type ProductCreateSku = string | null;

export type ProductCreateBrand = string | null;

export type ProductCreateCategory = string | null;

export type ProductCreateRetailPrice = number | string | null;

export type ProductCreateMinSellingPrice = number | string | null;

export type ProductCreateShelfLifeDays = number | null;

export type ProductCreateShelfLifeMonths = number | null;

export type ProductCreateMinStock = ProductMinStockEntry[] | null;

/**
 * Create payload.

``isRetail`` and ``isBackBar`` are independent, not a two-valued enum — C1
established that a product can be both sold and consumed, and in a salon the
same SKU routinely is. At least one must be true; the service enforces that.
 */
export interface ProductCreate {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 32
   */
  unit: string;
  sku?: ProductCreateSku;
  brand?: ProductCreateBrand;
  category?: ProductCreateCategory;
  retailPrice?: ProductCreateRetailPrice;
  minSellingPrice?: ProductCreateMinSellingPrice;
  isRetail?: boolean;
  isBackBar?: boolean;
  shelfLifeDays?: ProductCreateShelfLifeDays;
  shelfLifeMonths?: ProductCreateShelfLifeMonths;
  minStock?: ProductCreateMinStock;
}

export interface ProductMasterImportPreview {
  activeRows: number;
  inactiveRows: number;
  newProducts: number;
  costChanges: number;
  priceChanges: number;
  unchangedRows: number;
  skippedRows: number;
  noCostRows: number;
  pricesUpdated?: boolean;
  skipped?: ProductMasterImportRow[];
  rows?: ProductMasterImportRow[];
}

export type ProductMasterImportRowProductId = string | null;

export type ProductMasterImportRowOsName = string | null;

export type ProductMasterImportRowCostPrice = string | null;

export type ProductMasterImportRowCostBefore = string | null;

export type ProductMasterImportRowPrice = string | null;

export type ProductMasterImportRowPriceBefore = string | null;

export type ProductMasterImportRowReason = string | null;

/**
 * One ACTIVE line of the product master list as the preview shows it.
 */
export interface ProductMasterImportRow {
  rowNumber: number;
  sku: string;
  name: string;
  productId?: ProductMasterImportRowProductId;
  osName?: ProductMasterImportRowOsName;
  costPrice?: ProductMasterImportRowCostPrice;
  costBefore?: ProductMasterImportRowCostBefore;
  price?: ProductMasterImportRowPrice;
  priceBefore?: ProductMasterImportRowPriceBefore;
  priceDiffers?: boolean;
  action: string;
  reason?: ProductMasterImportRowReason;
}

export type ProductMinStockEntryMinQty = number | null;

export type ProductMinStockEntryTargetQty = number | null;

/**
 * One location's minimum stock level (INV-04-15).

On a write, ``minQty`` null means "no minimum at this location" and removes
any stored value; a location left out of the list is left unchanged. On a
read only locations that HAVE a minimum are listed.
 */
export interface ProductMinStockEntry {
  /** @minLength 1 */
  stockLocationId: string;
  minQty?: ProductMinStockEntryMinQty;
  targetQty?: ProductMinStockEntryTargetQty;
}

export type ProductMinStockResponseTargetQty = number | null;

/**
 * A stored minimum: always a number (no row = no minimum).
 */
export interface ProductMinStockResponse {
  stockLocationId: string;
  minQty: number;
  targetQty?: ProductMinStockResponseTargetQty;
}

export type ProductResponseSku = string | null;

export type ProductResponseBrand = string | null;

export type ProductResponseCategory = string | null;

export type ProductResponseRetailPrice = string | null;

export type ProductResponseMinSellingPrice = string | null;

export type ProductResponseShelfLifeDays = number | null;

export type ProductResponseShelfLifeMonths = number | null;

/**
 * Read shape. Mirrors the column set exactly — no computed fields yet.

Stock is deliberately absent: it does not exist until P2, and once it does it
is a set of batch rows per location rather than a number on the product
(C3). Adding a convenience `qtyOnHand` here later would flatten away the
location and batch dimensions the whole module exists to track.
 */
export interface ProductResponse {
  id: string;
  sku: ProductResponseSku;
  name: string;
  brand: ProductResponseBrand;
  category: ProductResponseCategory;
  unit: string;
  retailPrice: ProductResponseRetailPrice;
  minSellingPrice?: ProductResponseMinSellingPrice;
  isRetail: boolean;
  isBackBar: boolean;
  shelfLifeDays: ProductResponseShelfLifeDays;
  shelfLifeMonths?: ProductResponseShelfLifeMonths;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  minStock: ProductMinStockResponse[];
}

export type ProductReturnCreateOutletId = string | null;

/**
 * POST /finance/product-returns — ask HQ to take products back.
 */
export interface ProductReturnCreate {
  saleId: string;
  lines: ProductReturnLineCreate[];
  reason: string;
  settlement: string;
  outletId?: ProductReturnCreateOutletId;
}

export interface ProductReturnLineCreate {
  saleLineId: string;
  quantity: number;
}

export type ProductReturnLineResponseProductName = string | null;

export type ProductReturnLineResponseRestock = boolean | null;

export interface ProductReturnLineResponse {
  id: string;
  saleLineId: string;
  productId: string;
  productName?: ProductReturnLineResponseProductName;
  quantity: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unitAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  restock?: ProductReturnLineResponseRestock;
}

export type ProductReturnResponseInvoiceNumber = string | null;

export type ProductReturnResponseCustomerId = string | null;

export type ProductReturnResponseCustomerName = string | null;

export type ProductReturnResponseOutletId = string | null;

export type ProductReturnResponseApprovalRequestId = string | null;

export type ProductReturnResponseRefundSaleId = string | null;

export type ProductReturnResponseRefundInvoiceNumber = string | null;

export type ProductReturnResponseCreditLedgerId = string | null;

export type ProductReturnResponseCreatedAt = string | null;

export interface ProductReturnResponse {
  id: string;
  saleId: string;
  invoiceNumber?: ProductReturnResponseInvoiceNumber;
  customerId?: ProductReturnResponseCustomerId;
  customerName?: ProductReturnResponseCustomerName;
  outletId?: ProductReturnResponseOutletId;
  settlement: string;
  reason: string;
  status: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  approvalRequestId?: ProductReturnResponseApprovalRequestId;
  refundSaleId?: ProductReturnResponseRefundSaleId;
  refundInvoiceNumber?: ProductReturnResponseRefundInvoiceNumber;
  creditLedgerId?: ProductReturnResponseCreditLedgerId;
  lines?: ProductReturnLineResponse[];
  createdAt?: ProductReturnResponseCreatedAt;
}

export type ProductUpdateName = string | null;

export type ProductUpdateUnit = string | null;

export type ProductUpdateSku = string | null;

export type ProductUpdateBrand = string | null;

export type ProductUpdateCategory = string | null;

export type ProductUpdateRetailPrice = number | string | null;

export type ProductUpdateMinSellingPrice = number | string | null;

export type ProductUpdateIsRetail = boolean | null;

export type ProductUpdateIsBackBar = boolean | null;

export type ProductUpdateShelfLifeDays = number | null;

export type ProductUpdateShelfLifeMonths = number | null;

export type ProductUpdateIsActive = boolean | null;

export type ProductUpdateMinStock = ProductMinStockEntry[] | null;

/**
 * Partial update.

⚠ Every field is optional AND nullable, which makes "clear this field"
indistinguishable from "leave it alone" for the nullable ones. The service
uses ``model_dump(exclude_unset=True)`` so only keys the client actually sent
are applied — that is what keeps a PATCH of `{name}` from wiping `brand`.
This repo has been bitten before by *Update schemas silently dropping fields
the service persists, so the field list here is deliberately the full
editable set, not a subset.
 */
export interface ProductUpdate {
  name?: ProductUpdateName;
  unit?: ProductUpdateUnit;
  sku?: ProductUpdateSku;
  brand?: ProductUpdateBrand;
  category?: ProductUpdateCategory;
  retailPrice?: ProductUpdateRetailPrice;
  minSellingPrice?: ProductUpdateMinSellingPrice;
  isRetail?: ProductUpdateIsRetail;
  isBackBar?: ProductUpdateIsBackBar;
  shelfLifeDays?: ProductUpdateShelfLifeDays;
  shelfLifeMonths?: ProductUpdateShelfLifeMonths;
  isActive?: ProductUpdateIsActive;
  minStock?: ProductUpdateMinStock;
}

export type ProgramPricingCategory = string | null;

export type ProgramPricingAlaCarteAfter = string | null;

export type ProgramPricingAlaCarteBefore = string | null;

export type ProgramPricingOneForOne = string | null;

export type ProgramPricingPrice5After = string | null;

export type ProgramPricingPrice5Before = string | null;

export type ProgramPricingPrice10After = string | null;

export type ProgramPricingPrice10Before = string | null;

export type ProgramPricingPrice20After = string | null;

export type ProgramPricingPrice20Before = string | null;

export type ProgramPricingMinAlaCarteAfter = string | null;

export type ProgramPricingMin5After = string | null;

export type ProgramPricingMin10After = string | null;

export type ProgramPricingMin20After = string | null;

export type ProgramPricingTrialAfter = string | null;

export type ProgramPricingTrialBefore = string | null;

export type ProgramPricingMinTrialAfter = string | null;

/**
 * Per-program pricing — before + after GST (GST = 9%). 1-for-1 is §9-open,
exposed as null for now.
 */
export interface ProgramPricing {
  programId: string;
  programName: string;
  category?: ProgramPricingCategory;
  alaCarteAfter?: ProgramPricingAlaCarteAfter;
  alaCarteBefore?: ProgramPricingAlaCarteBefore;
  oneForOne?: ProgramPricingOneForOne;
  price5After?: ProgramPricingPrice5After;
  price5Before?: ProgramPricingPrice5Before;
  price10After?: ProgramPricingPrice10After;
  price10Before?: ProgramPricingPrice10Before;
  price20After?: ProgramPricingPrice20After;
  price20Before?: ProgramPricingPrice20Before;
  minAlaCarteAfter?: ProgramPricingMinAlaCarteAfter;
  min5After?: ProgramPricingMin5After;
  min10After?: ProgramPricingMin10After;
  min20After?: ProgramPricingMin20After;
  trialAfter?: ProgramPricingTrialAfter;
  trialBefore?: ProgramPricingTrialBefore;
  minTrialAfter?: ProgramPricingMinTrialAfter;
}

/**
 * GET /api/admin/program-step-mapping response body.
 */
export interface ProgramStepMappingListResponse {
  programs?: ProgramStepMappingResponse[];
  treatments?: ProgramStepMappingTreatmentResponse[];
}

export type ProgramStepMappingResponseNameKo = string | null;

export type ProgramStepMappingResponseNameZh = string | null;

export type ProgramStepMappingResponseNameVi = string | null;

export type ProgramStepMappingResponsePriceAlaCarte = number | number | null;

export type ProgramStepMappingResponsePrice5Sessions = number | number | null;

export type ProgramStepMappingResponsePrice10Sessions = number | number | null;

export type ProgramStepMappingResponsePrice20Sessions = number | number | null;

/**
 * Single treatment program returned by program-step mapping.
 */
export interface ProgramStepMappingResponse {
  id: string;
  name: string;
  nameKo?: ProgramStepMappingResponseNameKo;
  nameZh?: ProgramStepMappingResponseNameZh;
  nameVi?: ProgramStepMappingResponseNameVi;
  category: TreatmentCategory;
  totalDuration: number;
  priceAlaCarte?: ProgramStepMappingResponsePriceAlaCarte;
  price5Sessions?: ProgramStepMappingResponsePrice5Sessions;
  price10Sessions?: ProgramStepMappingResponsePrice10Sessions;
  price20Sessions?: ProgramStepMappingResponsePrice20Sessions;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  steps?: ProgramStepMappingStepResponse[];
}

export type ProgramStepMappingStepResponseCanonicalTreatmentId = string | null;

/**
 * Treatment-program step row with its canonical treatment link.
 */
export interface ProgramStepMappingStepResponse {
  id: string;
  name: string;
  sequence: number;
  duration: number;
  minSkillLevel: number;
  canonicalTreatmentId?: ProgramStepMappingStepResponseCanonicalTreatmentId;
}

/**
 * Treatment option returned for canonical step selection.
 */
export interface ProgramStepMappingTreatmentResponse {
  id: string;
  name: string;
  category: TreatmentCategory;
}

export type ProgramStepResponseNameKo = string | null;

export type ProgramStepResponseNameZh = string | null;

export type ProgramStepResponseNameVi = string | null;

export type ProgramStepResponseRequiredRole = string | null;

export type ProgramStepResponseCanonicalTreatmentId = string | null;

export interface ProgramStepResponse {
  id: string;
  programId: string;
  sequence: number;
  name: string;
  nameKo?: ProgramStepResponseNameKo;
  nameZh?: ProgramStepResponseNameZh;
  nameVi?: ProgramStepResponseNameVi;
  duration: number;
  minSkillLevel: number;
  requiredRole?: ProgramStepResponseRequiredRole;
  canonicalTreatmentId?: ProgramStepResponseCanonicalTreatmentId;
}

/**
 * Per-program utilization row (FIN-G1): sessions consumed vs purchased,
served-from-packages only.
 */
export interface ProgramUtilization {
  programId: string;
  programName: string;
  purchased: number;
  consumed: number;
  utilizationRate: number;
}

export interface ProgressResponse {
  completed: number;
  total: number;
}

export type PromoteRequestNote = string | null;

export interface PromoteRequest {
  staffId: string;
  effectiveDate: string;
  note?: PromoteRequestNote;
}

export type PromotionCreateCode = string | null;

export type PromotionCreateStartDate = string | null;

export type PromotionCreateEndDate = string | null;

export type PromotionCreateCost = number | string | null;

export type PromotionCreateRemarks = string | null;

export interface PromotionCreate {
  code?: PromotionCreateCode;
  startDate?: PromotionCreateStartDate;
  endDate?: PromotionCreateEndDate;
  cost?: PromotionCreateCost;
  applyToAppointment?: boolean;
  applyToItem?: boolean;
  applyToInvoice?: boolean;
  staffIds?: string[];
  outletIds?: string[];
  remarks?: PromotionCreateRemarks;
  enabled?: boolean;
  name: string;
}

export type PromotionCriterionInMonthsMax = number | null;

export type PromotionCriterionInTreatmentsRequired = number | null;

export type PromotionCriterionInReviewMinPct = number | null;

export interface PromotionCriterionIn {
  role: string;
  /**
   * @minLength 1
   * @maxLength 20
   */
  tierLabel: string;
  /**
   * @minimum 0
   * @maximum 600
   */
  monthsMin: number;
  monthsMax?: PromotionCriterionInMonthsMax;
  /**
   * @minimum 0
   * @maximum 500
   */
  sopsRequired: number;
  treatmentsRequired?: PromotionCriterionInTreatmentsRequired;
  reviewRequired?: boolean;
  reviewMinPct?: PromotionCriterionInReviewMinPct;
}

export type PromotionCriterionOutMonthsMax = number | null;

export type PromotionCriterionOutTreatmentsRequired = number | null;

export type PromotionCriterionOutReviewMinPct = number | null;

/**
 * One level of the template — what a staff member must have to BE at it.
 */
export interface PromotionCriterionOut {
  role: string;
  tierLabel: string;
  monthsMin: number;
  monthsMax?: PromotionCriterionOutMonthsMax;
  sopsRequired: number;
  treatmentsRequired?: PromotionCriterionOutTreatmentsRequired;
  reviewRequired?: boolean;
  reviewMinPct?: PromotionCriterionOutReviewMinPct;
}

export interface PromotionEnrollmentDetailGroup {
  promotion: string;
  rows: EnrollmentDetailRow[];
}

export interface PromotionEnrollmentSummaryRow {
  promotion: string;
  customers: number;
}

export interface PromotionHistoryResponse {
  items?: StaffPromotionOut[];
  total?: number;
}

export interface PromotionListResponse {
  items: PromotionResponse[];
}

export interface PromotionOutletRef {
  id: string;
  name: string;
}

export type PromotionResponseCode = string | null;

export type PromotionResponseStartDate = string | null;

export type PromotionResponseEndDate = string | null;

export type PromotionResponseCost = string | null;

export type PromotionResponseRemarks = string | null;

/**
 * One row of Marketing > Promotion. ``id`` is the MARKETING_ACTIVITY
``LookupOption.id`` — the stable handle for Edit / Archive / Delete whether
or not a details row exists yet.
 */
export interface PromotionResponse {
  id: string;
  name: string;
  code: PromotionResponseCode;
  startDate: PromotionResponseStartDate;
  endDate: PromotionResponseEndDate;
  cost: PromotionResponseCost;
  applyToAppointment: boolean;
  applyToItem: boolean;
  applyToInvoice: boolean;
  enabled: boolean;
  sortOrder: number;
  staff: PromotionStaffRef[];
  outlets: PromotionOutletRef[];
  remarks: PromotionResponseRemarks;
  archived: boolean;
  isSystem: boolean;
}

export interface PromotionStaffRef {
  id: string;
  name: string;
}

export interface PromotionStatusResponse {
  asAt: string;
  rows?: PromotionStatusRow[];
  eligibleCount?: number;
}

export type PromotionStatusRowNextRole = string | null;

export type PromotionStatusRowJoinedOn = string | null;

export type PromotionStatusRowMonths = CriterionCheck | null;

export type PromotionStatusRowSops = CriterionCheck | null;

export type PromotionStatusRowTreatments = CriterionCheck | null;

export type PromotionStatusRowReview = CriterionCheck | null;

export type PromotionStatusRowPendingPromotionId = string | null;

export type PromotionStatusRowPendingEffectiveDate = string | null;

export interface PromotionStatusRow {
  staffId: string;
  staffName: string;
  outletId: string;
  outletName: string;
  role: string;
  track: string;
  nextRole?: PromotionStatusRowNextRole;
  topOfTrack?: boolean;
  joinedOn?: PromotionStatusRowJoinedOn;
  months?: PromotionStatusRowMonths;
  sops?: PromotionStatusRowSops;
  treatments?: PromotionStatusRowTreatments;
  review?: PromotionStatusRowReview;
  eligible?: boolean;
  pendingPromotionId?: PromotionStatusRowPendingPromotionId;
  pendingEffectiveDate?: PromotionStatusRowPendingEffectiveDate;
}

export interface PromotionTemplateResponse {
  criteria?: PromotionCriterionOut[];
  notCounted?: string[];
  versions?: PromotionTemplateVersionOut[];
}

export type PromotionTemplateSaveNote = string | null;

export interface PromotionTemplateSave {
  effectiveFrom: string;
  note?: PromotionTemplateSaveNote;
  criteria: PromotionCriterionIn[];
}

export type PromotionTemplateVersionOutNote = string | null;

export type PromotionTemplateVersionOutCreatedById = string | null;

export type PromotionTemplateVersionOutCreatedByName = string | null;

export interface PromotionTemplateVersionOut {
  id: string;
  effectiveFrom: string;
  note?: PromotionTemplateVersionOutNote;
  createdById?: PromotionTemplateVersionOutCreatedById;
  createdByName?: PromotionTemplateVersionOutCreatedByName;
  createdAt: string;
}

export type PromotionUpdateName = string | null;

export type PromotionUpdateCode = string | null;

export type PromotionUpdateStartDate = string | null;

export type PromotionUpdateEndDate = string | null;

export type PromotionUpdateCost = number | string | null;

export type PromotionUpdateApplyToAppointment = boolean | null;

export type PromotionUpdateApplyToItem = boolean | null;

export type PromotionUpdateApplyToInvoice = boolean | null;

export type PromotionUpdateStaffIds = string[] | null;

export type PromotionUpdateOutletIds = string[] | null;

export type PromotionUpdateRemarks = string | null;

export type PromotionUpdateEnabled = boolean | null;

/**
 * Every field optional; only the ones sent change. Lists replace whole.
 */
export interface PromotionUpdate {
  name?: PromotionUpdateName;
  code?: PromotionUpdateCode;
  startDate?: PromotionUpdateStartDate;
  endDate?: PromotionUpdateEndDate;
  cost?: PromotionUpdateCost;
  applyToAppointment?: PromotionUpdateApplyToAppointment;
  applyToItem?: PromotionUpdateApplyToItem;
  applyToInvoice?: PromotionUpdateApplyToInvoice;
  staffIds?: PromotionUpdateStaffIds;
  outletIds?: PromotionUpdateOutletIds;
  remarks?: PromotionUpdateRemarks;
  enabled?: PromotionUpdateEnabled;
}

/**
 * POST /leave/public-holidays request body.
 */
export interface PublicHolidayCreateRequest {
  date: string;
  name: string;
}

/**
 * GET /leave/public-holidays response body.
 */
export interface PublicHolidayListResponse {
  holidays?: PublicHolidayResponse[];
}

export type PublicHolidayResponseCreatedAt = string | null;

/**
 * A single public-holiday row.
 */
export interface PublicHolidayResponse {
  id: string;
  date: string;
  name: string;
  createdAt?: PublicHolidayResponseCreatedAt;
}

export type QuestionScorePct = number | null;

export interface QuestionScore {
  question: string;
  yes: number;
  sometimes: number;
  no: number;
  pct?: QuestionScorePct;
}

export type QuestionnaireListItemCustomerId = string | null;

export type QuestionnaireListItemCustomerName = string | null;

export type QuestionnaireListItemProgramId = string | null;

export type QuestionnaireListItemProgramName = string | null;

export type QuestionnaireListItemOverallRating = string | null;

export type QuestionnaireListItemComments = string | null;

export type QuestionnaireListItemFollowUp = string | null;

export interface QuestionnaireListItem {
  appointmentId: string;
  ratedAt: string;
  date: string;
  customerId?: QuestionnaireListItemCustomerId;
  customerName?: QuestionnaireListItemCustomerName;
  programId?: QuestionnaireListItemProgramId;
  programName?: QuestionnaireListItemProgramName;
  outletId: string;
  outletName: string;
  overallRating?: QuestionnaireListItemOverallRating;
  comments?: QuestionnaireListItemComments;
  followUp?: QuestionnaireListItemFollowUp;
  staffNames: string[];
  stepRatings: QuestionnaireStepRating[];
}

export interface QuestionnaireListResponse {
  items: QuestionnaireListItem[];
  total: number;
}

export type QuestionnaireStepRatingStaffId = string | null;

export type QuestionnaireStepRatingStaffName = string | null;

export type QuestionnaireStepRatingComments = string | null;

/**
 * One step's rating, inlined into its list row so the detail drawer needs
no second round-trip.
 */
export interface QuestionnaireStepRating {
  appointmentStepId: string;
  stepName: string;
  staffId?: QuestionnaireStepRatingStaffId;
  staffName?: QuestionnaireStepRatingStaffName;
  rating: string;
  comments?: QuestionnaireStepRatingComments;
}

/**
 * Questionnaire Report - questionnaires per overall rating (one per visit).
 */
export interface QuestionnaireSummaryResponse {
  verySatisfied: number;
  satisfied: number;
  neutral: number;
  dissatisfied: number;
  notRated: number;
  total: number;
  customers: number;
}

/**
 * The three list views of Questionnaires; each count is ``len(list)``.
 */
export interface QuestionnaireViewsResponse {
  date: string;
  current: QuestionnaireVisitCard[];
  needsAttention: QuestionnaireVisitCard[];
  completed: QuestionnaireVisitCard[];
}

export type QuestionnaireVisitCardCustomerId = string | null;

export type QuestionnaireVisitCardCustomerName = string | null;

export type QuestionnaireVisitCardRoomName = string | null;

export type QuestionnaireVisitCardAttention = string | null;

/**
 * OPS-28 - one visit (booking) on the Questionnaires list.

A visit is the booking group (every programme booked together) or a single
booking, never a customer: two visits of one customer are two cards.
 */
export interface QuestionnaireVisitCard {
  key: string;
  appointmentId: string;
  appointmentIds: string[];
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  customerId?: QuestionnaireVisitCardCustomerId;
  customerName?: QuestionnaireVisitCardCustomerName;
  appointmentType: string;
  programmeNames: string[];
  roomName?: QuestionnaireVisitCardRoomName;
  outletId: string;
  outletName: string;
  stepsTotal: number;
  stepsSettled: number;
  stepsNotChecked: number;
  attention?: QuestionnaireVisitCardAttention;
}

export type QueueBadgeConsultNeeded = string | null;

export type QueueBadgeSessionsLeft = number | null;

export type QueueBadgePhoto = 'due' | 'done' | null;

/**
 * DSH-14-07 — the small badges next to one name in Today's queue. Every
value is read from the record that owns it; nothing is stored here.
 */
export interface QueueBadge {
  appointmentId: string;
  consultNeeded?: QueueBadgeConsultNeeded;
  sessionsLeft?: QueueBadgeSessionsLeft;
  hasBalance?: boolean;
  photo?: QueueBadgePhoto;
  specialRequest?: boolean;
}

export type QueueBadgesResponseOutletId = string | null;

/**
 * GET /dashboard/queue-badges — one entry per booking on today's book.
 */
export interface QueueBadgesResponse {
  date: string;
  outletId?: QueueBadgesResponseOutletId;
  badges?: QueueBadge[];
}

export type QueueEntryLeadId = string | null;

export type QueueEntryOutletCode = string | null;

export type QueueEntryStatus = string | null;

export type QueueEntryNextContactDate = string | null;

export type QueueEntryNextAppointment = string | null;

export type QueueEntryLockedBy = string | null;

export type QueueEntryLockedMinutes = number | null;

export type QueueEntryFromOutlet = string | null;

export type QueueEntryContactedAt = string | null;

/**
 * One customer in the queue — ONE entry even when she is on two lists
(LEA-02-07, LEA-26-11), under the more urgent list.
 */
export interface QueueEntry {
  customerId: string;
  leadId?: QueueEntryLeadId;
  name: string;
  mobile: string;
  outletCode?: QueueEntryOutletCode;
  listKey: LeadListKey;
  lists?: LeadListKey[];
  colour: LeadColour;
  why: string;
  contactsThisMonth?: number;
  contactGoal?: number;
  status?: QueueEntryStatus;
  nextContactDate?: QueueEntryNextContactDate;
  nextAppointment?: QueueEntryNextAppointment;
  lockedBy?: QueueEntryLockedBy;
  lockedMinutes?: QueueEntryLockedMinutes;
  fromOutlet?: QueueEntryFromOutlet;
  carriedOver?: boolean;
  escalated?: boolean;
  contactedAt?: QueueEntryContactedAt;
}

export interface ReasonRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  reason: string;
}

export type ReceiptCustomerPhone = string | null;

export interface ReceiptCustomer {
  id: string;
  name: string;
  phone?: ReceiptCustomerPhone;
}

export type ReceiptOutletCode = string | null;

export type ReceiptOutletAddress = string | null;

export type ReceiptOutletPhone = string | null;

export interface ReceiptOutlet {
  id: string;
  name: string;
  code?: ReceiptOutletCode;
  address?: ReceiptOutletAddress;
  phone?: ReceiptOutletPhone;
}

export type ReceiptResponseInvoiceNumber = string | null;

export type ReceiptResponseTimestamp = string | null;

export type ReceiptResponseOutlet = ReceiptOutlet | null;

export type ReceiptResponseCustomer = ReceiptCustomer | null;

export type ReceiptResponseContraAmount = string | null;

export type ReceiptResponseNotes = string | null;

export type ReceiptResponsePromotion = string | null;

export type ReceiptResponseMedia = string | null;

/**
 * GET /finance/sales/{id}/receipt — a printable receipt payload (FIN-A3).
 */
export interface ReceiptResponse {
  saleId: string;
  invoiceNumber?: ReceiptResponseInvoiceNumber;
  status: string;
  saleType: string;
  timestamp?: ReceiptResponseTimestamp;
  outlet?: ReceiptResponseOutlet;
  customer?: ReceiptResponseCustomer;
  lines?: SaleLineResponse[];
  payments?: PaymentResponse[];
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  subtotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gstAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  creditApplied: string;
  contraAmount?: ReceiptResponseContraAmount;
  notes?: ReceiptResponseNotes;
  promotion?: ReceiptResponsePromotion;
  media?: ReceiptResponseMedia;
}

export type RefundAppealFormDateOfRequest = string | null;

export type RefundAppealFormContact = string | null;

export type RefundAppealFormEmail = string | null;

export type RefundAppealFormBankName = string | null;

export type RefundAppealFormBankAccount = string | null;

export type RefundAppealFormNameOnAccount = string | null;

/**
 * SAL-41-05 / SAL-37-02 — the Sales Refund Appeal Form filled in with the
customer. The starred fields and the acknowledgement are required.
 */
export interface RefundAppealForm {
  dateOfRequest?: RefundAppealFormDateOfRequest;
  contact?: RefundAppealFormContact;
  email?: RefundAppealFormEmail;
  bankName?: RefundAppealFormBankName;
  bankAccount?: RefundAppealFormBankAccount;
  nameOnAccount?: RefundAppealFormNameOnAccount;
  acknowledged?: boolean;
}

export type RefundQuoteRequestSessions = number | null;

export type RefundQuoteRequestAmount = number | string | null;

/**
 * Optional body for the refund quote (R5-43/44). ``sessions`` defaults to
every remaining session; ``applyAdminCharge`` deducts the 5% admin charge.

``amount`` (client ask, 7 Oct) is the sum actually being refunded when staff
lower the quote. Omitted means "the whole quote"; supplied, it must be > 0
and ≤ the quote for ``sessions``, and the admin charge comes off IT rather
than off the quote.
 */
export interface RefundQuoteRequest {
  sessions?: RefundQuoteRequestSessions;
  applyAdminCharge?: boolean;
  amount?: RefundQuoteRequestAmount;
}

export type RefundQuoteResponseReason = string | null;

export type RefundQuoteResponseRuleId = string | null;

/**
 * POST /finance/packages/{id}/refund/quote — the §8.9-REFUND verdict (no
write). When ``blocked`` the rule's ``reason`` is set and ``computedValue``
is 0; otherwise ``computedValue`` is the refundable unutilised value for
``refundSessions`` (GST-inclusive, valued at the per-session price paid),
``requestedAmount`` is what is actually being refunded out of it, and
``finalAmount`` is that less the optional admin charge.
 */
export interface RefundQuoteResponse {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  computedValue: string;
  blocked: boolean;
  reason?: RefundQuoteResponseReason;
  usedSessions: number;
  ruleId?: RefundQuoteResponseRuleId;
  remainingSessions?: number;
  refundSessions?: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  perSessionValue?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  requestedAmount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  adminChargeAmount?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  finalAmount?: string;
  overHalfUsed?: boolean;
}

export type RefundRequestSessions = number | null;

export type RefundRequestAmount = number | string | null;

export type RefundRequestOutletId = string | null;

export type RefundRequestCustomerSignature = string | null;

export type RefundRequestStaffSignature = string | null;

export type RefundRequestRefundForm = RefundAppealForm | null;

/**
 * POST /finance/packages/{id}/refund — submit a PENDING refund (FIN-B3,
mgmt approval). Rule-gated (§8.9 REFUND); blocks raise a ValueError. The
POS Refund Request form (R5-42-45) adds the session count, the amount being
refunded, the optional 5% admin charge, the originating outlet and the dual
signature.
 */
export interface RefundRequest {
  reason: string;
  sessions?: RefundRequestSessions;
  applyAdminCharge?: boolean;
  amount?: RefundRequestAmount;
  outletId?: RefundRequestOutletId;
  customerSignature?: RefundRequestCustomerSignature;
  staffSignature?: RefundRequestStaffSignature;
  refundForm?: RefundRequestRefundForm;
  refundAsCreditNote?: boolean;
}

/**
 * PUT /customers/{id}/registered-outlet (CUS-08-10): an outlet id, or 'HQ'.
 */
export interface RegisteredOutletUpdate {
  registeredOutlet: string;
}

export type RejectedExtensionCustomerName = string | null;

export type RejectedExtensionRejectReason = string | null;

export type RejectedExtensionFollowUpStaffId = string | null;

/**
 * OPS-20 — HQ rejected the expiry extension a booking at this outlet needed.
The bookings stay; the outlet decides what to tell the customer.
 */
export interface RejectedExtension {
  id: string;
  customerName?: RejectedExtensionCustomerName;
  rejectReason?: RejectedExtensionRejectReason;
  decidedAt: string;
  followUpStaffId?: RejectedExtensionFollowUpStaffId;
  outletStaff: OutletStaffOption[];
}

export type RejectedExtensionAssignStaffId = string | null;

/**
 * PUT body: the staff member to follow up, or null for nobody.
 */
export interface RejectedExtensionAssign {
  staffId?: RejectedExtensionAssignStaffId;
}

export interface RemarkNote {
  action: AttendanceAction;
  time: string;
  remark: string;
}

export type RemarksRequestRemarks = string | null;

export interface RemarksRequest {
  remarks?: RemarksRequestRemarks;
}

/**
 * Drag-reorder payload — `ids` in their new display order; each row's
`sortOrder` is set to its index.
 */
export interface ReorderRequest {
  ids: string[];
}

/**
 * Input schema for reporting an issue.
 */
export interface ReportIssueRequest {
  title: string;
  body: string;
  labels?: string[];
  assignees?: string[];
}

export type ReportIssueResponseIssueUrl = string | null;

export type ReportIssueResponseNotionPageUrl = string | null;

export type ReportIssueResponseIssueNumber = number | null;

/**
 * Output schema after issue creation.
 */
export interface ReportIssueResponse {
  issueUrl?: ReportIssueResponseIssueUrl;
  notionPageUrl?: ReportIssueResponseNotionPageUrl;
  issueNumber?: ReportIssueResponseIssueNumber;
}

/**
 * One report on Manage Reports: its old gate in words and the roles that
may view / export it.
 */
export interface ReportRightsRow {
  id: string;
  module: string;
  name: string;
  menu: string;
  defaultGate: string;
  hasExport: boolean;
  viewRoleIds: string[];
  exportRoleIds: string[];
}

export interface ReportRightsTable {
  roles: RoleSummary[];
  reports: ReportRightsRow[];
}

export interface ReportRow {
  staffId: string;
  staffName: string;
  role: string;
  outletId: string;
  outletName: string;
  rosteredDays?: number;
  presentDays?: number;
  leaveDays?: number;
  absentDays?: number;
  lateCount?: number;
  lateMinutes?: number;
  missingClockOuts?: number;
  workedHours?: number;
  rosteredHours?: number;
  hasPin?: boolean;
  otApprovedMinutes?: number;
  days?: DayLog[];
}

export interface ReportTiles {
  rosteredStaffDays?: number;
  presentStaffDays?: number;
  presentPct?: number;
  lateCount?: number;
  lateMinutes?: number;
  missingClockOuts?: number;
  otApprovedMinutes?: number;
}

/**
 * POST /api/users/[id]/reset-password request body.
 */
export interface ResetPasswordRequest {
  password: string;
}

export interface RestockChoice {
  lineId: string;
  restock: boolean;
}

/**
 * PUT /finance/product-returns/{id}/restock — HQ's per-line stock choice.
 */
export interface RestockDecision {
  lines: RestockChoice[];
}

export type ResultRowQ1Pct = number | null;

export type ResultRowQ2Pct = number | null;

export type ResultRowQ3Pct = number | null;

export type ResultRowQ4Pct = number | null;

export type ResultRowTotalPct = number | null;

export type ResultRowBand = string | null;

export type ResultRowPromotionOk = boolean | null;

export type ResultRowAcknowledgedAt = string | null;

export interface ResultRow {
  staffId: string;
  name: string;
  role: string;
  outletId: string;
  outletCode: string;
  reviewsReceived: number;
  q1Pct?: ResultRowQ1Pct;
  q2Pct?: ResultRowQ2Pct;
  q3Pct?: ResultRowQ3Pct;
  q4Pct?: ResultRowQ4Pct;
  totalPct?: ResultRowTotalPct;
  band?: ResultRowBand;
  promotionOk?: ResultRowPromotionOk;
  actionPlanCount?: number;
  acknowledgedAt?: ResultRowAcknowledgedAt;
}

export type ResultsResponseAverageTotal = number | null;

export interface ResultsResponse {
  roundId: string;
  released: boolean;
  responsesReceived: number;
  responsesExpected: number;
  completionPct: number;
  averageTotal?: ResultsResponseAverageTotal;
  belowEighty: number;
  rows?: ResultRow[];
}

export type ReturnReceiveLineReason = string | null;

/**
 * Receive return (INV-07-14 step 2): what came back and what to do with it.
 */
export interface ReturnReceiveLine {
  /** @minLength 1 */
  lineId: string;
  /** @minimum 0 */
  qtyReceived: number;
  /**
   * @minLength 1
   * @maxLength 20
   */
  decision: string;
  reason?: ReturnReceiveLineReason;
}

export interface ReturnReceiveRequest {
  /** @minItems 1 */
  lines: ReturnReceiveLine[];
}

/**
 * One PRODUCT line of an invoice and how much of it can still come back.
 */
export interface ReturnableProductLine {
  saleLineId: string;
  productId: string;
  productName: string;
  sold: number;
  returned: number;
  returnable: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unitAmount: string;
}

export type ReturnableProductsResponseInvoiceNumber = string | null;

export type ReturnableProductsResponseCustomerId = string | null;

export type ReturnableProductsResponseCustomerName = string | null;

export interface ReturnableProductsResponse {
  saleId: string;
  invoiceNumber?: ReturnableProductsResponseInvoiceNumber;
  customerId?: ReturnableProductsResponseCustomerId;
  customerName?: ReturnableProductsResponseCustomerName;
  lines?: ReturnableProductLine[];
}

/**
 * One Outlet Authority chart row she may be offered.
 */
export interface ReturningAuthorityOption {
  key: string;
  label: string;
}

export type ReturningMessageBookingAuthorityKey = string | null;

export type ReturningMessageBookingAuthorityLabel = string | null;

export type ReturningMessageBookingAuthorityMarkedAt = string | null;

export type ReturningMessageBookingAuthorityMarkedBy = string | null;

/**
 * Her next booking — where the Authority mark goes (LEA-30-05).
 */
export interface ReturningMessageBooking {
  appointmentId: string;
  bookingDate: string;
  startTime: string;
  authorityKey?: ReturningMessageBookingAuthorityKey;
  authorityLabel?: ReturningMessageBookingAuthorityLabel;
  authorityMarkedAt?: ReturningMessageBookingAuthorityMarkedAt;
  authorityMarkedBy?: ReturningMessageBookingAuthorityMarkedBy;
}

/**
 * The text to copy, and the state after logging it.
 */
export interface ReturningMessageResult {
  text: string;
  state: ReturningMessageState;
}

export type ReturningMessageSendOutletId = string | null;

export interface ReturningMessageSend {
  outletId?: ReturningMessageSendOutletId;
  /**
   * @minLength 1
   * @maxLength 80
   */
  authorityKey: string;
}

export type ReturningMessageSentSentBy = string | null;

export type ReturningMessageSentAuthorityKey = string | null;

export type ReturningMessageSentAuthorityLabel = string | null;

export type ReturningMessageSentAppointmentId = string | null;

/**
 * The last time the message was logged as sent to her (LEA-30-07).
 */
export interface ReturningMessageSent {
  sentAt: string;
  sentBy?: ReturningMessageSentSentBy;
  authorityKey?: ReturningMessageSentAuthorityKey;
  authorityLabel?: ReturningMessageSentAuthorityLabel;
  appointmentId?: ReturningMessageSentAppointmentId;
}

export type ReturningMessageStateTemplateId = string | null;

export type ReturningMessageStateText = string | null;

export type ReturningMessageStateLastSent = ReturningMessageSent | null;

export type ReturningMessageStateBooking = ReturningMessageBooking | null;

/**
 * What the Follow-up panel shows. ``available`` is false until HQ has
picked the template (Leads > Message templates).
 */
export interface ReturningMessageState {
  available: boolean;
  templateId?: ReturningMessageStateTemplateId;
  text?: ReturningMessageStateText;
  unfilled?: string[];
  authorities?: ReturningAuthorityOption[];
  lastSent?: ReturningMessageStateLastSent;
  booking?: ReturningMessageStateBooking;
}

export type ReviewAnswer = typeof ReviewAnswer[keyof typeof ReviewAnswer];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewAnswer = {
  YES: 'YES',
  SOMETIMES: 'SOMETIMES',
  NO: 'NO',
} as const;

export type ReviewEditRequestQ1 = ReviewAnswer | null;

export type ReviewEditRequestQ2 = ReviewAnswer | null;

export type ReviewEditRequestQ3 = ReviewAnswer | null;

export type ReviewEditRequestQ4 = ReviewAnswer | null;

export type ReviewEditRequestExample = string | null;

export type ReviewEditRequestImprovements = string | null;

export type ReviewEditRequestCompliments = string | null;

export interface ReviewEditRequest {
  q1?: ReviewEditRequestQ1;
  q2?: ReviewEditRequestQ2;
  q3?: ReviewEditRequestQ3;
  q4?: ReviewEditRequestQ4;
  example?: ReviewEditRequestExample;
  improvements?: ReviewEditRequestImprovements;
  compliments?: ReviewEditRequestCompliments;
}

export interface ReviewImportPreview {
  sheet: string;
  quarter: string;
  roundName: string;
  roundExists: boolean;
  totalRows: number;
  readyRows: number;
  alreadyImported: number;
  skippedRows: number;
  unmatchedStaff?: NameCount[];
  rows?: ReviewImportRow[];
}

export interface ReviewImportResult {
  roundId: string;
  roundName: string;
  quarter: string;
  roundCreated: boolean;
  created: number;
  alreadyImported: number;
  skipped: number;
}

export type ReviewImportRowSubmittedAt = string | null;

export type ReviewImportRowReviewerId = string | null;

export type ReviewImportRowRevieweeId = string | null;

export type ReviewImportRowQ1 = string | null;

export type ReviewImportRowQ2 = string | null;

export type ReviewImportRowQ3 = string | null;

export type ReviewImportRowQ4 = string | null;

export interface ReviewImportRow {
  rowNumber: number;
  submittedAt?: ReviewImportRowSubmittedAt;
  reviewerName: string;
  reviewerId?: ReviewImportRowReviewerId;
  revieweeName: string;
  revieweeId?: ReviewImportRowRevieweeId;
  q1?: ReviewImportRowQ1;
  q2?: ReviewImportRowQ2;
  q3?: ReviewImportRowQ3;
  q4?: ReviewImportRowQ4;
  status: string;
  problems?: string[];
}

/**
 * DSH-07-08 / DSH-08-06 — the look-back card lives on My task rules.
 */
export interface ReviewLine {
  yesterdayDone: number;
  yesterdayTotal: number;
  weekDone: number;
  weekTotal: number;
  openOver3Days: number;
  takenOffThisMonth: number;
}

export type ReviewResponseOutQ4 = string | null;

export type ReviewResponseOutExample = string | null;

export interface ReviewResponseOut {
  id: string;
  roundId: string;
  reviewerId: string;
  revieweeId: string;
  q1: string;
  q2: string;
  q3: string;
  q4?: ReviewResponseOutQ4;
  example?: ReviewResponseOutExample;
  improvements: string;
  compliments: string;
  submittedAt: string;
  updatedAt: string;
}

export interface ReviewRoundCreate {
  /**
   * @minLength 1
   * @maxLength 120
   */
  name: string;
  /** @pattern ^\d{4}-Q[1-4]$ */
  quarter: string;
  opensAt: string;
  closesAt: string;
}

export interface ReviewRoundListResponse {
  items?: ReviewRoundResponse[];
}

export type ReviewRoundResponseResultsReleasedAt = string | null;

export interface ReviewRoundResponse {
  id: string;
  name: string;
  quarter: string;
  opensAt: string;
  closesAt: string;
  status: string;
  resultsReleasedAt?: ReviewRoundResponseResultsReleasedAt;
  createdAt: string;
}

export type ReviewSubmitRequestQ4 = ReviewAnswer | null;

export type ReviewSubmitRequestExample = string | null;

export interface ReviewSubmitRequest {
  revieweeId: string;
  q1: ReviewAnswer;
  q2: ReviewAnswer;
  q3: ReviewAnswer;
  q4?: ReviewSubmitRequestQ4;
  example?: ReviewSubmitRequestExample;
  /** @maxLength 3000 */
  improvements?: string;
  /** @maxLength 3000 */
  compliments?: string;
}

export type RiskLineGroup = typeof RiskLineGroup[keyof typeof RiskLineGroup];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RiskLineGroup = {
  PEOPLE: 'PEOPLE',
  CAPACITY: 'CAPACITY',
  PIPELINE: 'PIPELINE',
  CONTROLS: 'CONTROLS',
} as const;

export type RiskLineUnit = typeof RiskLineUnit[keyof typeof RiskLineUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RiskLineUnit = {
  count: 'count',
  days: 'days',
  percent: 'percent',
} as const;

export type RiskLineLevel = typeof RiskLineLevel[keyof typeof RiskLineLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RiskLineLevel = {
  ACT: 'ACT',
  WATCH: 'WATCH',
  OK: 'OK',
} as const;

export type RiskLineDetail = string | null;

export type RiskLineScreen = string | null;

/**
 * One line of C · Operating risks (DSH-18-02): a figure, Act / Watch / OK
against the threshold management set, and the screen that holds the
evidence. Never a single customer.
 */
export interface RiskLine {
  key: string;
  group: RiskLineGroup;
  label: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  value: string;
  unit: RiskLineUnit;
  level: RiskLineLevel;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  actAt: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  watchAt: string;
  lowerIsWorse: boolean;
  detail?: RiskLineDetail;
  screen?: RiskLineScreen;
}

export type RiskThresholdUpdateActAt = number | string;

export type RiskThresholdUpdateWatchAt = number | string;

/**
 * Management sets the Act and Watch figures of one risk line.
 */
export interface RiskThresholdUpdate {
  actAt: RiskThresholdUpdateActAt;
  watchAt: RiskThresholdUpdateWatchAt;
}

export type RoleCreateRequestScopeLabel = string | null;

export type RoleCreateRequestDescription = string | null;

export type RoleCreateRequestIsEnabled = boolean | null;

export interface RoleCreateRequest {
  name: string;
  scopeLabel?: RoleCreateRequestScopeLabel;
  description?: RoleCreateRequestDescription;
  isEnabled?: RoleCreateRequestIsEnabled;
}

export type RoleDetailScopeLabel = string | null;

export type RoleDetailDescription = string | null;

export interface RoleDetail {
  id: string;
  name: string;
  scopeLabel?: RoleDetailScopeLabel;
  description?: RoleDetailDescription;
  isEnabled: boolean;
  isSystem: boolean;
  userCount: number;
  permissions: PermissionGrant[];
}

export type RoleSummaryScopeLabel = string | null;

export type RoleSummaryDescription = string | null;

export interface RoleSummary {
  id: string;
  name: string;
  scopeLabel?: RoleSummaryScopeLabel;
  description?: RoleSummaryDescription;
  isEnabled: boolean;
  isSystem: boolean;
  userCount: number;
}

export type RoleUpdateRequestName = string | null;

export type RoleUpdateRequestScopeLabel = string | null;

export type RoleUpdateRequestDescription = string | null;

export type RoleUpdateRequestIsEnabled = boolean | null;

export interface RoleUpdateRequest {
  name?: RoleUpdateRequestName;
  scopeLabel?: RoleUpdateRequestScopeLabel;
  description?: RoleUpdateRequestDescription;
  isEnabled?: RoleUpdateRequestIsEnabled;
}

export interface RoomHistoryAppointment {
  id: string;
  date: string;
  startTime: string;
  endTime: string;
  status: AppointmentStatus;
  appointmentType: AppointmentType;
  customerName: string;
  treatmentName: string;
  duration: number;
  staffNames?: string[];
}

export interface RoomHistoryPeriod {
  type: RoomHistoryPeriodType;
  startDate: string;
  endDate: string;
}

export type RoomHistoryPeriodType = typeof RoomHistoryPeriodType[keyof typeof RoomHistoryPeriodType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomHistoryPeriodType = {
  today: 'today',
  week: 'week',
  month: 'month',
} as const;

export interface RoomHistoryResponse {
  room: RoomHistoryRoom;
  period: RoomHistoryPeriod;
  stats: RoomHistoryStats;
  appointments?: RoomHistoryAppointment[];
}

export interface RoomHistoryRoom {
  id: string;
  name: string;
  type: RoomType;
  bedCount: number;
  outlet: OutletSummary;
}

export interface RoomHistoryStats {
  totalAppointments: number;
  completed: number;
  cancelled: number;
  noShow: number;
  treatments: number;
  consultations: number;
}

export type RoomStatusAppointmentProgram = TreatmentNameSummary | null;

export type RoomStatusAppointmentConsultant = StaffMeetingAttendeeStaff | null;

export type RoomStatusAppointmentMaster = StaffMeetingAttendeeStaff | null;

export interface RoomStatusAppointment {
  id: string;
  startTime: string;
  endTime: string;
  status: AppointmentStatus;
  appointmentType: AppointmentType;
  customer: CustomerSummary;
  program?: RoomStatusAppointmentProgram;
  steps?: RoomStatusAppointmentStep[];
  consultant?: RoomStatusAppointmentConsultant;
  master?: RoomStatusAppointmentMaster;
}

export interface RoomStatusAppointmentStep {
  id: string;
  staffName: string;
  stepName: string;
  status: AppointmentStepStatus;
}

export type RoomStatusItemOutlet = OutletSummary | null;

export type RoomStatusItemCurrentAppointment = RoomStatusAppointment | null;

export interface RoomStatusItem {
  outletId: string;
  name: string;
  type: RoomType;
  bedCount: number;
  isActive?: boolean;
  id: string;
  createdAt: string;
  outlet?: RoomStatusItemOutlet;
  appointments?: RoomStatusAppointment[];
  currentAppointment?: RoomStatusItemCurrentAppointment;
  isOccupied: boolean;
}

export type RoomSummaryOutlet = OutletSummary | null;

export interface RoomSummary {
  outletId: string;
  name: string;
  type: RoomType;
  bedCount: number;
  isActive?: boolean;
  id: string;
  createdAt: string;
  outlet?: RoomSummaryOutlet;
}

export type RoomType = typeof RoomType[keyof typeof RoomType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomType = {
  CONSULTATION: 'CONSULTATION',
  COUPLE: 'COUPLE',
  SINGLE: 'SINGLE',
} as const;

export interface RosterChangeLogEntry {
  id: string;
  staffId: string;
  staffName: string;
  action: string;
  detail: string;
  changedById: string;
  changedByName: string;
  createdAt: string;
}

export type RuleActionRequestReason = string | null;

export interface RuleActionRequest {
  reason?: RuleActionRequestReason;
}

export type RuleChangeOutRuleId = string | null;

export type RuleChangeOutAction = typeof RuleChangeOutAction[keyof typeof RuleChangeOutAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleChangeOutAction = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
  DELETE: 'DELETE',
} as const;

export type RuleChangeOutBeforeAnyOf = { [key: string]: unknown };

export type RuleChangeOutBefore = RuleChangeOutBeforeAnyOf | null;

export type RuleChangeOutAfterAnyOf = { [key: string]: unknown };

export type RuleChangeOutAfter = RuleChangeOutAfterAnyOf | null;

export type RuleChangeOutReason = string | null;

export type RuleChangeOutStatus = typeof RuleChangeOutStatus[keyof typeof RuleChangeOutStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleChangeOutStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
} as const;

export type RuleChangeOutRequestedByName = string | null;

export type RuleChangeOutDecidedByName = string | null;

export type RuleChangeOutDecidedAt = string | null;

export type RuleChangeOutDecisionNote = string | null;

export interface RuleChangeOut {
  id: string;
  ruleId: RuleChangeOutRuleId;
  ownerName: string;
  action: RuleChangeOutAction;
  before: RuleChangeOutBefore;
  after: RuleChangeOutAfter;
  reason: RuleChangeOutReason;
  status: RuleChangeOutStatus;
  requestedByName: RuleChangeOutRequestedByName;
  requestedAt: string;
  decidedByName: RuleChangeOutDecidedByName;
  decidedAt: RuleChangeOutDecidedAt;
  decisionNote: RuleChangeOutDecisionNote;
  raisesToManagement: boolean;
}

export interface RuleChangesResponse {
  changes: RuleChangeOut[];
}

export type RuleOutOwnerUserId = string | null;

export type RuleOutFrequency = typeof RuleOutFrequency[keyof typeof RuleOutFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleOutFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ON_EVENT: 'ON_EVENT',
} as const;

export type RuleOutWeekday = number | null;

export type RuleOutMonthDay = number | null;

export type RuleOutMonths = string | null;

export type RuleOutCheckMethod = typeof RuleOutCheckMethod[keyof typeof RuleOutCheckMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleOutCheckMethod = {
  OS: 'OS',
  HAND: 'HAND',
} as const;

export type RuleOutPlannedCheckMethod = typeof RuleOutPlannedCheckMethod[keyof typeof RuleOutPlannedCheckMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleOutPlannedCheckMethod = {
  OS: 'OS',
  HAND: 'HAND',
} as const;

export type RuleOutSource = string | null;

export type RuleOutSourceLabel = string | null;

export type RuleOutKpi = string | null;

export type RuleOutStatus = typeof RuleOutStatus[keyof typeof RuleOutStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleOutStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  DELETED: 'DELETED',
} as const;

export type RuleOutLastYearDone = number | null;

export type RuleOutLastYearDays = number | null;

export type RuleOutNote = string | null;

export type RuleOutPendingChange = RuleChangeOut | null;

export interface RuleOut {
  id: string;
  ownerName: string;
  ownerUserId: RuleOutOwnerUserId;
  title: string;
  category: string;
  frequency: RuleOutFrequency;
  weekday: RuleOutWeekday;
  monthDay: RuleOutMonthDay;
  months: RuleOutMonths;
  checkMethod: RuleOutCheckMethod;
  plannedCheckMethod: RuleOutPlannedCheckMethod;
  source: RuleOutSource;
  sourceLabel: RuleOutSourceLabel;
  awaitingSource: boolean;
  kpi: RuleOutKpi;
  waitsOnOthers: boolean;
  status: RuleOutStatus;
  lastYearDone: RuleOutLastYearDone;
  lastYearDays: RuleOutLastYearDays;
  note: RuleOutNote;
  pendingChange: RuleOutPendingChange;
}

export interface RulesResponse {
  owners: OwnerRules[];
  unmatchedOwners: string[];
  canConfirm: boolean;
  canManage: boolean;
  pendingCount: number;
}

export type SalaryHistoryItemTotalSalary = number | null;

export type SalaryHistoryItemBasicSalary = number | null;

export type SalaryHistoryItemFixedOtPay = number | null;

/**
 * Read-through summary of a per-staff SalaryStructure row.
 */
export interface SalaryHistoryItem {
  id: string;
  position: string;
  employmentType: string;
  scheme: string;
  isActiveScheme?: boolean;
  totalSalary?: SalaryHistoryItemTotalSalary;
  basicSalary?: SalaryHistoryItemBasicSalary;
  fixedOtPay?: SalaryHistoryItemFixedOtPay;
}

export type SalaryRunCreateRequestOutletId = string | null;

/**
 * POST /salary/runs request body.
 */
export interface SalaryRunCreateRequest {
  periodYear: number;
  periodMonth: number;
  outletId?: SalaryRunCreateRequestOutletId;
  financeDataAvailable?: boolean;
}

/**
 * GET /salary/runs response body.
 */
export interface SalaryRunListResponse {
  runs?: SalaryRunResponse[];
}

export type SalaryRunResponseOutletId = string | null;

export type SalaryRunResponseComputedAt = string | null;

export type SalaryRunResponseCreatedAt = string | null;

export type SalaryRunResponseUpdatedAt = string | null;

/**
 * A single salary-run row.
 */
export interface SalaryRunResponse {
  id: string;
  periodYear: number;
  periodMonth: number;
  outletId?: SalaryRunResponseOutletId;
  status: string;
  computedAt?: SalaryRunResponseComputedAt;
  financeDataAvailable: boolean;
  createdBy: string;
  createdAt?: SalaryRunResponseCreatedAt;
  updatedAt?: SalaryRunResponseUpdatedAt;
  payslipCount?: number;
}

export type SalaryStructureCreateRequestStaffId = string | null;

export type SalaryStructureCreateRequestTotalSalary = number | string | null;

export type SalaryStructureCreateRequestBasicSalary = number | string | null;

export type SalaryStructureCreateRequestFixedOtPay = number | string | null;

export type SalaryStructureCreateRequestIncrementNote = string | null;

export type SalaryStructureCreateRequestAlDays = number | null;

export type SalaryStructureCreateRequestPhOffInLieuDays = number | null;

export type SalaryStructureCreateRequestMedicalPerVisit = number | string | null;

export type SalaryStructureCreateRequestMedicalAnnualCap = number | string | null;

export type SalaryStructureCreateRequestSelfDevIncentive = number | string | null;

export type SalaryStructureCreateRequestCnyIncentive = number | string | null;

export type SalaryStructureCreateRequestBirthdayIncentive = number | string | null;

export type SalaryStructureCreateRequestNotes = string | null;

/**
 * POST /salary/structures request body.
 */
export interface SalaryStructureCreateRequest {
  position: string;
  staffId?: SalaryStructureCreateRequestStaffId;
  employmentType: string;
  scheme: string;
  isActiveScheme?: boolean;
  totalSalary?: SalaryStructureCreateRequestTotalSalary;
  basicSalary?: SalaryStructureCreateRequestBasicSalary;
  fixedOtPay?: SalaryStructureCreateRequestFixedOtPay;
  incrementNote?: SalaryStructureCreateRequestIncrementNote;
  eligService?: boolean;
  eligSales?: boolean;
  eligProduct?: boolean;
  eligGuarantee?: boolean;
  eligOutletTarget?: boolean;
  outletTargetWeight?: number;
  alDays?: SalaryStructureCreateRequestAlDays;
  phOffInLieuDays?: SalaryStructureCreateRequestPhOffInLieuDays;
  medicalPerVisit?: SalaryStructureCreateRequestMedicalPerVisit;
  medicalAnnualCap?: SalaryStructureCreateRequestMedicalAnnualCap;
  selfDevIncentive?: SalaryStructureCreateRequestSelfDevIncentive;
  cnyIncentive?: SalaryStructureCreateRequestCnyIncentive;
  birthdayIncentive?: SalaryStructureCreateRequestBirthdayIncentive;
  notes?: SalaryStructureCreateRequestNotes;
}

/**
 * GET /salary/structures response body.
 */
export interface SalaryStructureListResponse {
  structures?: SalaryStructureResponse[];
}

export type SalaryStructureResponseStaffId = string | null;

export type SalaryStructureResponseTotalSalary = string | null;

export type SalaryStructureResponseBasicSalary = string | null;

export type SalaryStructureResponseFixedOtPay = string | null;

export type SalaryStructureResponseIncrementNote = string | null;

export type SalaryStructureResponseAlDays = number | null;

export type SalaryStructureResponsePhOffInLieuDays = number | null;

export type SalaryStructureResponseMedicalPerVisit = string | null;

export type SalaryStructureResponseMedicalAnnualCap = string | null;

export type SalaryStructureResponseSelfDevIncentive = string | null;

export type SalaryStructureResponseCnyIncentive = string | null;

export type SalaryStructureResponseBirthdayIncentive = string | null;

export type SalaryStructureResponseNotes = string | null;

export type SalaryStructureResponseCreatedAt = string | null;

export type SalaryStructureResponseUpdatedAt = string | null;

/**
 * A single salary-structure row.
 */
export interface SalaryStructureResponse {
  id: string;
  position: string;
  staffId?: SalaryStructureResponseStaffId;
  employmentType: string;
  scheme: string;
  isActiveScheme: boolean;
  totalSalary?: SalaryStructureResponseTotalSalary;
  basicSalary?: SalaryStructureResponseBasicSalary;
  fixedOtPay?: SalaryStructureResponseFixedOtPay;
  incrementNote?: SalaryStructureResponseIncrementNote;
  eligService: boolean;
  eligSales: boolean;
  eligProduct: boolean;
  eligGuarantee: boolean;
  eligOutletTarget: boolean;
  outletTargetWeight: number;
  alDays?: SalaryStructureResponseAlDays;
  phOffInLieuDays?: SalaryStructureResponsePhOffInLieuDays;
  medicalPerVisit?: SalaryStructureResponseMedicalPerVisit;
  medicalAnnualCap?: SalaryStructureResponseMedicalAnnualCap;
  selfDevIncentive?: SalaryStructureResponseSelfDevIncentive;
  cnyIncentive?: SalaryStructureResponseCnyIncentive;
  birthdayIncentive?: SalaryStructureResponseBirthdayIncentive;
  notes?: SalaryStructureResponseNotes;
  createdAt?: SalaryStructureResponseCreatedAt;
  updatedAt?: SalaryStructureResponseUpdatedAt;
}

export type SalaryStructureUpdateRequestIsActiveScheme = boolean | null;

export type SalaryStructureUpdateRequestTotalSalary = number | string | null;

export type SalaryStructureUpdateRequestBasicSalary = number | string | null;

export type SalaryStructureUpdateRequestFixedOtPay = number | string | null;

export type SalaryStructureUpdateRequestIncrementNote = string | null;

export type SalaryStructureUpdateRequestEligService = boolean | null;

export type SalaryStructureUpdateRequestEligSales = boolean | null;

export type SalaryStructureUpdateRequestEligProduct = boolean | null;

export type SalaryStructureUpdateRequestEligGuarantee = boolean | null;

export type SalaryStructureUpdateRequestEligOutletTarget = boolean | null;

export type SalaryStructureUpdateRequestOutletTargetWeight = number | null;

export type SalaryStructureUpdateRequestAlDays = number | null;

export type SalaryStructureUpdateRequestPhOffInLieuDays = number | null;

export type SalaryStructureUpdateRequestMedicalPerVisit = number | string | null;

export type SalaryStructureUpdateRequestMedicalAnnualCap = number | string | null;

export type SalaryStructureUpdateRequestSelfDevIncentive = number | string | null;

export type SalaryStructureUpdateRequestCnyIncentive = number | string | null;

export type SalaryStructureUpdateRequestBirthdayIncentive = number | string | null;

export type SalaryStructureUpdateRequestNotes = string | null;

/**
 * PUT /salary/structures/{id} request body — all fields optional.
 */
export interface SalaryStructureUpdateRequest {
  isActiveScheme?: SalaryStructureUpdateRequestIsActiveScheme;
  totalSalary?: SalaryStructureUpdateRequestTotalSalary;
  basicSalary?: SalaryStructureUpdateRequestBasicSalary;
  fixedOtPay?: SalaryStructureUpdateRequestFixedOtPay;
  incrementNote?: SalaryStructureUpdateRequestIncrementNote;
  eligService?: SalaryStructureUpdateRequestEligService;
  eligSales?: SalaryStructureUpdateRequestEligSales;
  eligProduct?: SalaryStructureUpdateRequestEligProduct;
  eligGuarantee?: SalaryStructureUpdateRequestEligGuarantee;
  eligOutletTarget?: SalaryStructureUpdateRequestEligOutletTarget;
  outletTargetWeight?: SalaryStructureUpdateRequestOutletTargetWeight;
  alDays?: SalaryStructureUpdateRequestAlDays;
  phOffInLieuDays?: SalaryStructureUpdateRequestPhOffInLieuDays;
  medicalPerVisit?: SalaryStructureUpdateRequestMedicalPerVisit;
  medicalAnnualCap?: SalaryStructureUpdateRequestMedicalAnnualCap;
  selfDevIncentive?: SalaryStructureUpdateRequestSelfDevIncentive;
  cnyIncentive?: SalaryStructureUpdateRequestCnyIncentive;
  birthdayIncentive?: SalaryStructureUpdateRequestBirthdayIncentive;
  notes?: SalaryStructureUpdateRequestNotes;
}

export type SaleCreateCustomerId = string | null;

export type SaleCreateCreditApplied = number | string;

export type SaleCreateIhipPlanVariant = string | null;

export type SaleCreateIhipAgreement = IHIPAgreementCreate | null;

export type SaleCreateAppointmentId = string | null;

export type SaleCreateNotes = string | null;

export type SaleCreateBelowMinimumReason = string | null;

export type SaleCreateCustomerSignature = string | null;

export type SaleCreateStaffSignature = string | null;

export type SaleCreateDiscountType = string | null;

export type SaleCreateDiscountValue = number | string | null;

export type SaleCreateDiscountReason = string | null;

export type SaleCreateDiscountNote = string | null;

export type SaleCreateFreeReason = string | null;

export type SaleCreateFreeNote = string | null;

export type SaleCreateGstAmountOverride = number | string | null;

export type SaleCreateSaleDate = string | null;

export type SaleCreatePackageExpiryDate = string | null;

export type SaleCreatePromotion = string | null;

export type SaleCreateMedia = string | null;

/**
 * POST /finance/sales request body — a single checkout transaction.
 */
export interface SaleCreate {
  customerId?: SaleCreateCustomerId;
  outletId: string;
  saleType: string;
  lines?: SaleLineCreate[];
  payments?: PaymentCreate[];
  creditApplied?: SaleCreateCreditApplied;
  ihipPlanVariant?: SaleCreateIhipPlanVariant;
  paymentKind?: string;
  ihipAgreement?: SaleCreateIhipAgreement;
  appointmentId?: SaleCreateAppointmentId;
  notes?: SaleCreateNotes;
  belowMinimumReason?: SaleCreateBelowMinimumReason;
  customerSignature?: SaleCreateCustomerSignature;
  staffSignature?: SaleCreateStaffSignature;
  discountType?: SaleCreateDiscountType;
  discountValue?: SaleCreateDiscountValue;
  discountReason?: SaleCreateDiscountReason;
  discountNote?: SaleCreateDiscountNote;
  freeReason?: SaleCreateFreeReason;
  freeNote?: SaleCreateFreeNote;
  gstAmountOverride?: SaleCreateGstAmountOverride;
  saleDate?: SaleCreateSaleDate;
  packageExpiryDate?: SaleCreatePackageExpiryDate;
  servedBy?: ServedByCreate[];
  promotion?: SaleCreatePromotion;
  media?: SaleCreateMedia;
}

export type SaleDetailResponseCustomerId = string | null;

export type SaleDetailResponseCustomerName = string | null;

export type SaleDetailResponseInvoiceNumber = string | null;

export type SaleDetailResponsePresalesNumber = string | null;

export type SaleDetailResponseAcknowledgedById = string | null;

export type SaleDetailResponseAcknowledgedAt = string | null;

export type SaleDetailResponseContraAmount = string | null;

export type SaleDetailResponseRelatedSaleId = string | null;

export type SaleDetailResponseCreatedById = string | null;

export type SaleDetailResponseNotes = string | null;

export type SaleDetailResponseCustomerSignature = string | null;

export type SaleDetailResponseStaffSignature = string | null;

export type SaleDetailResponseCreatedAt = string | null;

export type SaleDetailResponseUpdatedAt = string | null;

export type SaleDetailResponseDiscountType = string | null;

export type SaleDetailResponseDiscountValue = string | null;

export type SaleDetailResponseDiscountReason = string | null;

export type SaleDetailResponseDiscountNote = string | null;

export type SaleDetailResponseDiscountById = string | null;

export type SaleDetailResponseFreeReason = string | null;

export type SaleDetailResponseFreeNote = string | null;

export type SaleDetailResponseSaleTypeAmendedFrom = string | null;

export type SaleDetailResponseSaleTypeAmendedById = string | null;

export type SaleDetailResponseSaleTypeAmendedAt = string | null;

export type SaleDetailResponseSaleTypeAmendReason = string | null;

export type SaleDetailResponsePromotion = string | null;

export type SaleDetailResponseMedia = string | null;

/**
 * GET /finance/sales/{id} — the sale header plus its lines + payments.
 */
export interface SaleDetailResponse {
  id: string;
  customerId?: SaleDetailResponseCustomerId;
  customerName?: SaleDetailResponseCustomerName;
  outletId: string;
  saleType: string;
  invoiceNumber?: SaleDetailResponseInvoiceNumber;
  presalesNumber?: SaleDetailResponsePresalesNumber;
  acknowledgedById?: SaleDetailResponseAcknowledgedById;
  acknowledgedAt?: SaleDetailResponseAcknowledgedAt;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  subtotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gstAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  creditApplied: string;
  contraAmount?: SaleDetailResponseContraAmount;
  status: string;
  paymentKind?: string;
  relatedSaleId?: SaleDetailResponseRelatedSaleId;
  createdById?: SaleDetailResponseCreatedById;
  notes?: SaleDetailResponseNotes;
  customerSignature?: SaleDetailResponseCustomerSignature;
  staffSignature?: SaleDetailResponseStaffSignature;
  createdAt?: SaleDetailResponseCreatedAt;
  updatedAt?: SaleDetailResponseUpdatedAt;
  discountType?: SaleDetailResponseDiscountType;
  discountValue?: SaleDetailResponseDiscountValue;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  discountAmount?: string;
  discountReason?: SaleDetailResponseDiscountReason;
  discountNote?: SaleDetailResponseDiscountNote;
  discountById?: SaleDetailResponseDiscountById;
  freeReason?: SaleDetailResponseFreeReason;
  freeNote?: SaleDetailResponseFreeNote;
  gstOverridden?: boolean;
  saleTypeAmendedFrom?: SaleDetailResponseSaleTypeAmendedFrom;
  saleTypeAmendedById?: SaleDetailResponseSaleTypeAmendedById;
  saleTypeAmendedAt?: SaleDetailResponseSaleTypeAmendedAt;
  saleTypeAmendReason?: SaleDetailResponseSaleTypeAmendReason;
  promotion?: SaleDetailResponsePromotion;
  media?: SaleDetailResponseMedia;
  lines?: SaleLineResponse[];
  payments?: PaymentResponse[];
  servedBy?: ServedByResponse[];
}

export type SaleLineCreateProgramId = string | null;

export type SaleLineCreateProductId = string | null;

export type SaleLineCreateSessions = number | null;

export type SaleLineCreateUnitPrice = number | string;

export type SaleLineCreateLineTotal = number | string;

export type SaleLineCreateSessionCount = number | null;

export type SaleLineCreateFocSessions = number | null;

export type SaleLineCreateFocQuantity = number | null;

export type SaleLineCreateExtendsInvoiceNumber = string | null;

/**
 * A line item on a checkout sale request.
 */
export interface SaleLineCreate {
  lineType: string;
  programId?: SaleLineCreateProgramId;
  productId?: SaleLineCreateProductId;
  description: string;
  sessions?: SaleLineCreateSessions;
  unitPrice: SaleLineCreateUnitPrice;
  quantity?: number;
  lineTotal: SaleLineCreateLineTotal;
  sessionCount?: SaleLineCreateSessionCount;
  focSessions?: SaleLineCreateFocSessions;
  focQuantity?: SaleLineCreateFocQuantity;
  isTrial?: boolean;
  extendsInvoiceNumber?: SaleLineCreateExtendsInvoiceNumber;
}

export type SaleLineResponseProgramId = string | null;

export type SaleLineResponseProductId = string | null;

export type SaleLineResponsePackageId = string | null;

export type SaleLineResponseSessions = number | null;

export type SaleLineResponseCreatedAt = string | null;

/**
 * A persisted sale line row.
 */
export interface SaleLineResponse {
  id: string;
  saleId: string;
  lineType: string;
  programId?: SaleLineResponseProgramId;
  productId?: SaleLineResponseProductId;
  packageId?: SaleLineResponsePackageId;
  description: string;
  sessions?: SaleLineResponseSessions;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unitPrice: string;
  quantity: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  lineTotal: string;
  createdAt?: SaleLineResponseCreatedAt;
}

/**
 * GET /finance/sales — paginated ledger (mirrors CustomerListResponse).
 */
export interface SaleListResponse {
  sales?: SaleResponse[];
  total: number;
  limit: number;
  offset: number;
}

export type SaleResponseCustomerId = string | null;

export type SaleResponseCustomerName = string | null;

export type SaleResponseInvoiceNumber = string | null;

export type SaleResponsePresalesNumber = string | null;

export type SaleResponseAcknowledgedById = string | null;

export type SaleResponseAcknowledgedAt = string | null;

export type SaleResponseContraAmount = string | null;

export type SaleResponseRelatedSaleId = string | null;

export type SaleResponseCreatedById = string | null;

export type SaleResponseNotes = string | null;

export type SaleResponseCustomerSignature = string | null;

export type SaleResponseStaffSignature = string | null;

export type SaleResponseCreatedAt = string | null;

export type SaleResponseUpdatedAt = string | null;

export type SaleResponseDiscountType = string | null;

export type SaleResponseDiscountValue = string | null;

export type SaleResponseDiscountReason = string | null;

export type SaleResponseDiscountNote = string | null;

export type SaleResponseDiscountById = string | null;

export type SaleResponseFreeReason = string | null;

export type SaleResponseFreeNote = string | null;

export type SaleResponseSaleTypeAmendedFrom = string | null;

export type SaleResponseSaleTypeAmendedById = string | null;

export type SaleResponseSaleTypeAmendedAt = string | null;

export type SaleResponseSaleTypeAmendReason = string | null;

export type SaleResponsePromotion = string | null;

export type SaleResponseMedia = string | null;

/**
 * A persisted sale header row.
 */
export interface SaleResponse {
  id: string;
  customerId?: SaleResponseCustomerId;
  customerName?: SaleResponseCustomerName;
  outletId: string;
  saleType: string;
  invoiceNumber?: SaleResponseInvoiceNumber;
  presalesNumber?: SaleResponsePresalesNumber;
  acknowledgedById?: SaleResponseAcknowledgedById;
  acknowledgedAt?: SaleResponseAcknowledgedAt;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  subtotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gstAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  creditApplied: string;
  contraAmount?: SaleResponseContraAmount;
  status: string;
  paymentKind?: string;
  relatedSaleId?: SaleResponseRelatedSaleId;
  createdById?: SaleResponseCreatedById;
  notes?: SaleResponseNotes;
  customerSignature?: SaleResponseCustomerSignature;
  staffSignature?: SaleResponseStaffSignature;
  createdAt?: SaleResponseCreatedAt;
  updatedAt?: SaleResponseUpdatedAt;
  discountType?: SaleResponseDiscountType;
  discountValue?: SaleResponseDiscountValue;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  discountAmount?: string;
  discountReason?: SaleResponseDiscountReason;
  discountNote?: SaleResponseDiscountNote;
  discountById?: SaleResponseDiscountById;
  freeReason?: SaleResponseFreeReason;
  freeNote?: SaleResponseFreeNote;
  gstOverridden?: boolean;
  saleTypeAmendedFrom?: SaleResponseSaleTypeAmendedFrom;
  saleTypeAmendedById?: SaleResponseSaleTypeAmendedById;
  saleTypeAmendedAt?: SaleResponseSaleTypeAmendedAt;
  saleTypeAmendReason?: SaleResponseSaleTypeAmendReason;
  promotion?: SaleResponsePromotion;
  media?: SaleResponseMedia;
}

export type SaleTypeAmendRequestReason = string | null;

/**
 * PATCH /finance/sales/{id}/sale-type — BUG-867.

Reclassifies a sale (Lisa: *"currently need to change '1 for 1 promo' to
'trial'"*). Deliberately carries no money fields: sales type is a
classification, and re-pricing a completed transaction as a side effect of a
reclassification would be a serious finance bug.
 */
export interface SaleTypeAmendRequest {
  saleType: string;
  reason?: SaleTypeAmendRequestReason;
}

/**
 * POST /finance/sales/{id}/void request body.
 */
export interface SaleVoidRequest {
  reason: string;
}

export interface SalesAlaCarteOutletEntry {
  outletCode: string;
  count?: number;
  revenue?: number;
}

export interface SalesAlaCarteStaffEntry {
  staffName: string;
  count?: number;
  revenue?: number;
}

/**
 * Ala-carte revenue credited to whoever *performed* the treatment.

Resolved through ``Sale.appointmentId`` → ``AppointmentStep.staffId`` (R10),
which is why this list is not simply a relabelling of
``SalesAlaCarteStaffEntry``: that one counts sales, this one counts the
therapists behind them. Sales with no linked appointment — every sale
predating the FK — are absent entirely rather than bucketed as unknown.
 */
export interface SalesAlaCarteTherapistEntry {
  staffName: string;
  count?: number;
  revenue?: number;
}

export type SalesAnalyticsResponseByMonth = {[key: string]: number};

export type SalesAnalyticsResponseByOutlet = {[key: string]: number};

export type SalesAnalyticsResponseBySaleType = {[key: string]: number};

/**
 * Response from ``GET /api/reports/sales-analytics``.

Money is ``Decimal`` on the headline figures and ``float`` inside the maps
and lists: the four KPIs are the numbers finance reconciles against, and the
rest feed charts.
 */
export interface SalesAnalyticsResponse {
  period: OperationsPeriod;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalRevenue?: string;
  totalTransactions?: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  avgTransactionValue?: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  unearnedRevenue?: string;
  byMonth?: SalesAnalyticsResponseByMonth;
  byOutlet?: SalesAnalyticsResponseByOutlet;
  bySaleType?: SalesAnalyticsResponseBySaleType;
  topTreatments?: SalesTopTreatmentEntry[];
  topCustomers?: SalesTopCustomerEntry[];
  alaCarteByOutlet?: SalesAlaCarteOutletEntry[];
  alaCarteByStaff?: SalesAlaCarteStaffEntry[];
  alaCarteByTherapist?: SalesAlaCarteTherapistEntry[];
}

/**
 * Idempotent-seed outcome. NOT named `SeedResultResponse`: that name is
already taken by `app.schemas.salary` and a second model of the same name
would force FastAPI to fully-qualify BOTH in `openapi.json`, renaming the
existing Orval-generated FE type.
 */
export interface SalesConfigSeedResult {
  created: number;
  skipped: number;
}

export type SalesReportResponseRowsItem = { [key: string]: unknown };

export type SalesReportResponseTotalsAnyOf = { [key: string]: unknown };

export type SalesReportResponseTotals = SalesReportResponseTotalsAnyOf | null;

export interface SalesReportResponse {
  reportName: string;
  columns?: string[];
  rows?: SalesReportResponseRowsItem[];
  totals?: SalesReportResponseTotals;
}

export interface SalesTopCustomerEntry {
  name: string;
  totalSpend?: number;
  transactionCount?: number;
}

/**
 * A programme's sales across the window.

Named ``Sales*`` to sit beside the dashboard's ``TopTreatmentEntry``, which
counts appointments rather than sale lines and is a different number.
 */
export interface SalesTopTreatmentEntry {
  name: string;
  count?: number;
  revenue?: number;
}

export type ScheduleAppointmentProgramId = string | null;

export type ScheduleAppointmentPackageId = string | null;

export type ScheduleAppointmentRoomId = string | null;

export type ScheduleAppointmentLinkedAppointmentId = string | null;

export type ScheduleAppointmentBookingGroupId = string | null;

export type ScheduleAppointmentConsultantId = string | null;

export type ScheduleAppointmentMasterId = string | null;

export type ScheduleAppointmentConsultant = ScheduleAssignedStaff | null;

export type ScheduleAppointmentMaster = ScheduleAssignedStaff | null;

export type ScheduleAppointmentNotes = string | null;

export type ScheduleAppointmentWaitlistFrom = string | null;

export type ScheduleAppointmentWaitlistUntil = string | null;

export type ScheduleAppointmentConsultNeeded = string | null;

export type ScheduleAppointmentExtensionPending = string | null;

export type ScheduleAppointmentConsultationTargetPackageId = string | null;

export type ScheduleAppointmentConsultationType = string | null;

export type ScheduleAppointmentConsultationReason = string | null;

export type ScheduleAppointmentConsultationStartedAt = string | null;

export type ScheduleAppointmentCreatedById = string | null;

export type ScheduleAppointmentConfirmedByStaffId = string | null;

export type ScheduleAppointmentConfirmedAt = string | null;

export type ScheduleAppointmentActualStartTime = string | null;

export type ScheduleAppointmentActualStartLockedAt = string | null;

export type ScheduleAppointmentProgram = ScheduleProgram | null;

export type ScheduleAppointmentPackage = SchedulePackage | null;

export type ScheduleAppointmentRoom = ScheduleRoomSummary | null;

export interface ScheduleAppointment {
  id: string;
  customerId: string;
  outletId: string;
  programId?: ScheduleAppointmentProgramId;
  packageId?: ScheduleAppointmentPackageId;
  roomId?: ScheduleAppointmentRoomId;
  date: string;
  startTime: string;
  endTime: string;
  status: string;
  appointmentType: string;
  linkedAppointmentId?: ScheduleAppointmentLinkedAppointmentId;
  bookingGroupId?: ScheduleAppointmentBookingGroupId;
  consultantId?: ScheduleAppointmentConsultantId;
  masterId?: ScheduleAppointmentMasterId;
  consultant?: ScheduleAppointmentConsultant;
  master?: ScheduleAppointmentMaster;
  notes?: ScheduleAppointmentNotes;
  isFirstVisit?: boolean;
  photosSaved?: boolean;
  isWaitlist?: boolean;
  waitlistFrom?: ScheduleAppointmentWaitlistFrom;
  waitlistUntil?: ScheduleAppointmentWaitlistUntil;
  addOnOnly?: boolean;
  consultNeeded?: ScheduleAppointmentConsultNeeded;
  extensionPending?: ScheduleAppointmentExtensionPending;
  consultationTargetPackageId?: ScheduleAppointmentConsultationTargetPackageId;
  consultationType?: ScheduleAppointmentConsultationType;
  consultationReason?: ScheduleAppointmentConsultationReason;
  consultationStartedAt?: ScheduleAppointmentConsultationStartedAt;
  createdById?: ScheduleAppointmentCreatedById;
  confirmedByStaffId?: ScheduleAppointmentConfirmedByStaffId;
  confirmedAt?: ScheduleAppointmentConfirmedAt;
  actualStartTime?: ScheduleAppointmentActualStartTime;
  actualStartLockedAt?: ScheduleAppointmentActualStartLockedAt;
  createdAt: string;
  updatedAt: string;
  customer: ScheduleCustomer;
  program?: ScheduleAppointmentProgram;
  package?: ScheduleAppointmentPackage;
  room?: ScheduleAppointmentRoom;
  outlet: ScheduleOutletSummary;
  steps: ScheduleAppointmentStep[];
  [key: string]: unknown;
 }

export type ScheduleAppointmentStepStaffId = string | null;

export type ScheduleAppointmentStepCompletedAt = string | null;

export type ScheduleAppointmentStepCompletedBy = string | null;

export type ScheduleAppointmentStepActualStartTime = string | null;

export type ScheduleAppointmentStepActualEndTime = string | null;

export type ScheduleAppointmentStepStartedBy = string | null;

export type ScheduleAppointmentStepOriginalStaffId = string | null;

export type ScheduleAppointmentStepStaff = ScheduleAssignedStaff | null;

export interface ScheduleAppointmentStep {
  id: string;
  appointmentId: string;
  stepId: string;
  staffId?: ScheduleAppointmentStepStaffId;
  startTime: string;
  endTime: string;
  status: string;
  completedAt?: ScheduleAppointmentStepCompletedAt;
  completedBy?: ScheduleAppointmentStepCompletedBy;
  actualStartTime?: ScheduleAppointmentStepActualStartTime;
  actualEndTime?: ScheduleAppointmentStepActualEndTime;
  startedBy?: ScheduleAppointmentStepStartedBy;
  originalStaffId?: ScheduleAppointmentStepOriginalStaffId;
  step: ScheduleStepDefinition;
  staff?: ScheduleAppointmentStepStaff;
  [key: string]: unknown;
 }

export interface ScheduleAssignedStaff {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  [key: string]: unknown;
 }

export type ScheduleCustomerDob = string | null;

export type ScheduleCustomerCautionNotes = string | null;

export type ScheduleCustomerNotes = string | null;

export type ScheduleCustomerSpecialRequests = string | null;

export type ScheduleCustomerPreferredTherapistNames = string | null;

/**
 * Customer summary carried by a calendar block.

Angela R3 #5 — the SM calendar shows the whole front-desk picture on the
block itself (phone, birthday, money owed, notes, caution). Everything past
``phone`` exists to drive one of those badges, so a receptionist never has to
open the drawer to learn something that changes how they greet the customer.
 */
export interface ScheduleCustomer {
  id: string;
  name: string;
  phone: string;
  dob?: ScheduleCustomerDob;
  cautionNotes?: ScheduleCustomerCautionNotes;
  notes?: ScheduleCustomerNotes;
  specialRequests?: ScheduleCustomerSpecialRequests;
  hasPreferredTherapist?: boolean;
  preferredTherapistNames?: ScheduleCustomerPreferredTherapistNames;
  outstandingIhipBalance?: number;
  outstandingBalance?: number;
  [key: string]: unknown;
 }

export interface ScheduleOutletSummary {
  id: string;
  code: string;
  [key: string]: unknown;
 }

export interface SchedulePackage {
  id: string;
  totalSessions: number;
  usedSessions: number;
  [key: string]: unknown;
 }

export type ScheduleProgramNameKo = string | null;

export type ScheduleProgramNameZh = string | null;

export type ScheduleProgramNameVi = string | null;

export interface ScheduleProgram {
  id: string;
  name: string;
  nameKo?: ScheduleProgramNameKo;
  nameZh?: ScheduleProgramNameZh;
  nameVi?: ScheduleProgramNameVi;
  totalDuration: number;
  category: string;
  [key: string]: unknown;
 }

export interface ScheduleRoomSummary {
  id: string;
  name: string;
  [key: string]: unknown;
 }

export type ScheduleShiftSummaryShiftTypeName = string | null;

export type ScheduleShiftSummaryCategory = string | null;

export type ScheduleShiftSummaryLeaveType = string | null;

export interface ScheduleShiftSummary {
  startTime: string;
  endTime: string;
  isOff: boolean;
  portion?: string;
  shiftTypeName?: ScheduleShiftSummaryShiftTypeName;
  category?: ScheduleShiftSummaryCategory;
  leaveType?: ScheduleShiftSummaryLeaveType;
  [key: string]: unknown;
 }

export type ScheduleStaffSummaryShift = ScheduleShiftSummary | null;

export interface ScheduleStaffSummary {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  outlet: ScheduleOutletSummary;
  shift?: ScheduleStaffSummaryShift;
  [key: string]: unknown;
 }

export interface ScheduleStepDefinition {
  id: string;
  sequence: number;
  name: string;
  duration: number;
  minSkillLevel?: number;
  [key: string]: unknown;
 }

export type SchedulingResultOption = typeof SchedulingResultOption[keyof typeof SchedulingResultOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SchedulingResultOption = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export type SchedulingResultMasterAssigned = string | null;

export type SchedulingResultBeauticianAssigned = string[] | null;

export interface SchedulingResult {
  success: boolean;
  option: SchedulingResultOption;
  optionName: string;
  staffCount: number;
  assignments: StaffAssignmentOutput[];
  reason: string;
  masterAssigned?: SchedulingResultMasterAssigned;
  beauticianAssigned?: SchedulingResultBeauticianAssigned;
  usedPreferredStaff: boolean;
  preferredStaffNames: string[];
}

export interface SchedulingStaffResponse {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  availableFrom: string;
  availableTo: string;
  conflicts?: AvailabilityConflict[];
}

export type ScoreCardResponseAveragePct = number | null;

export type ScoreCardResponseBand = string | null;

export type ScoreCardResponsePromotionOk = boolean | null;

export type ScoreCardResponseFeedback = string | null;

export type ScoreCardResponseAcknowledgedAt = string | null;

export interface ScoreCardResponse {
  roundId: string;
  roundName: string;
  staffId: string;
  name: string;
  role: string;
  outletCode: string;
  reviewsReceived: number;
  questions?: QuestionScore[];
  averagePct?: ScoreCardResponseAveragePct;
  band?: ScoreCardResponseBand;
  promotionOk?: ScoreCardResponsePromotionOk;
  feedback?: ScoreCardResponseFeedback;
  actionPlans?: ActionPlanItem[];
  improvements?: StaffComment[];
  compliments?: StaffComment[];
  acknowledgedAt?: ScoreCardResponseAcknowledgedAt;
  canEdit: boolean;
}

export type ScoreCardUpdateFeedback = string | null;

export interface ScoreCardUpdate {
  feedback?: ScoreCardUpdateFeedback;
  /** @maxItems 3 */
  actionPlans?: ActionPlanItem[];
}

/**
 * Paginated unified search response.
 */
export interface SearchResponse {
  items?: SearchResultItem[];
  total?: number;
  page?: number;
  pageSize?: number;
  totalPages?: number;
  query?: string;
}

/**
 * Entity-specific metadata
 */
export type SearchResultItemMetadata = { [key: string]: unknown };

/**
 * Normalized single search result item.
 */
export interface SearchResultItem {
  /** Entity type label */
  type: string;
  /** Display title */
  title: string;
  /** Frontend navigation URL */
  url: string;
  /** Relevance score */
  score?: number;
  /** Highlighted snippet */
  highlights?: string;
  /** Entity-specific metadata */
  metadata?: SearchResultItemMetadata;
}

/**
 * POST /salary/structures/seed result envelope (idempotent reseed).
 */
export interface SeedResultResponse {
  inserted: number;
}

/**
 * What to sell success this month for one item (DSH-17-05).
 */
export interface SellItemResult {
  key: string;
  picked: number;
  done: number;
  declined: number;
  notOffered: number;
}

/**
 * SAL-24-18 — one 'Served by' row on an invoice: a staff member and their
whole-number share (1-100). The rows of one invoice must add up to 100
(SAL-24-19). Sales commission is attributed by these rows (Angela, 14 Oct
2026), not by who rang the sale up.
 */
export interface ServedByCreate {
  staffId: string;
  percent: number;
}

export type ServedByResponseStaffName = string | null;

/**
 * A persisted 'Served by' row of a sale.
 */
export interface ServedByResponse {
  staffId: string;
  staffName?: ServedByResponseStaffName;
  percent: number;
}

/**
 * Bulk upsert of role grants; ``level="NONE"`` deletes the row.
 */
export interface SetRolePermissionsRequest {
  grants: PermissionGrant[];
}

export type SetUserOutletAccessRequestOutletIds = string[] | null;

/**
 * The outlets she may see; ``None`` puts her back on the default.
 */
export interface SetUserOutletAccessRequest {
  outletIds?: SetUserOutletAccessRequestOutletIds;
}

/**
 * Bulk upsert of per-user overrides; ``level="INHERIT"`` **deletes** the row
(revert to the role grant). ``FULL``/``OWN``/``NONE`` upsert an explicit
override that wins over the role.
 */
export interface SetUserOverridesRequest {
  grants: UserOverrideGrant[];
}

export type ShiftTypeCreateRequestBand = string | null;

export type ShiftTypeCreateRequestStartTime = string | null;

export type ShiftTypeCreateRequestEndTime = string | null;

export type ShiftTypeCreateRequestDurationHrs = number | null;

export type ShiftTypeCreateRequestLeaveType = string | null;

export interface ShiftTypeCreateRequest {
  name: string;
  category: string;
  band?: ShiftTypeCreateRequestBand;
  startTime?: ShiftTypeCreateRequestStartTime;
  endTime?: ShiftTypeCreateRequestEndTime;
  durationHrs?: ShiftTypeCreateRequestDurationHrs;
  isOff?: boolean;
  leaveType?: ShiftTypeCreateRequestLeaveType;
  sortOrder: number;
  isActive?: boolean;
}

export type ShiftTypeHistoryEntryShiftTypeId = string | null;

export type ShiftTypeHistoryEntryShiftTypeName = string | null;

export type ShiftTypeHistoryEntryField = string | null;

export type ShiftTypeHistoryEntryOldValue = string | null;

export type ShiftTypeHistoryEntryNewValue = string | null;

export type ShiftTypeHistoryEntryChangedById = string | null;

export type ShiftTypeHistoryEntryChangedByName = string | null;

export interface ShiftTypeHistoryEntry {
  id: string;
  shiftTypeId?: ShiftTypeHistoryEntryShiftTypeId;
  shiftTypeName?: ShiftTypeHistoryEntryShiftTypeName;
  action: string;
  field?: ShiftTypeHistoryEntryField;
  oldValue?: ShiftTypeHistoryEntryOldValue;
  newValue?: ShiftTypeHistoryEntryNewValue;
  changedById?: ShiftTypeHistoryEntryChangedById;
  changedByName?: ShiftTypeHistoryEntryChangedByName;
  changedAt: string;
}

export type ShiftTypeHistoryResponseRecordedSince = string | null;

export interface ShiftTypeHistoryResponse {
  recordedSince?: ShiftTypeHistoryResponseRecordedSince;
  entries: ShiftTypeHistoryEntry[];
}

export type ShiftTypeResponseBand = string | null;

export type ShiftTypeResponseStartTime = string | null;

export type ShiftTypeResponseEndTime = string | null;

export type ShiftTypeResponseDurationHrs = number | null;

export type ShiftTypeResponseLeaveType = string | null;

export type ShiftTypeResponseDeletedAt = string | null;

export interface ShiftTypeResponse {
  id: string;
  name: string;
  category: string;
  band?: ShiftTypeResponseBand;
  startTime?: ShiftTypeResponseStartTime;
  endTime?: ShiftTypeResponseEndTime;
  durationHrs?: ShiftTypeResponseDurationHrs;
  isOff: boolean;
  leaveType?: ShiftTypeResponseLeaveType;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: ShiftTypeResponseDeletedAt;
}

export type ShiftTypeUpdateRequestName = string | null;

export type ShiftTypeUpdateRequestCategory = string | null;

export type ShiftTypeUpdateRequestBand = string | null;

export type ShiftTypeUpdateRequestStartTime = string | null;

export type ShiftTypeUpdateRequestEndTime = string | null;

export type ShiftTypeUpdateRequestDurationHrs = number | null;

export type ShiftTypeUpdateRequestIsOff = boolean | null;

export type ShiftTypeUpdateRequestLeaveType = string | null;

export type ShiftTypeUpdateRequestSortOrder = number | null;

export type ShiftTypeUpdateRequestIsActive = boolean | null;

export interface ShiftTypeUpdateRequest {
  name?: ShiftTypeUpdateRequestName;
  category?: ShiftTypeUpdateRequestCategory;
  band?: ShiftTypeUpdateRequestBand;
  startTime?: ShiftTypeUpdateRequestStartTime;
  endTime?: ShiftTypeUpdateRequestEndTime;
  durationHrs?: ShiftTypeUpdateRequestDurationHrs;
  isOff?: ShiftTypeUpdateRequestIsOff;
  leaveType?: ShiftTypeUpdateRequestLeaveType;
  sortOrder?: ShiftTypeUpdateRequestSortOrder;
  isActive?: ShiftTypeUpdateRequestIsActive;
}

/**
 * The sheet's own tabs (LEA-21-02 1).
 */
export type Situation = typeof Situation[keyof typeof Situation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Situation = {
  NEW_LEADS: 'NEW_LEADS',
  APPOINTMENT_CONFIRMATION: 'APPOINTMENT_CONFIRMATION',
  EXISTING: 'EXISTING',
  ENQUIRY: 'ENQUIRY',
  PROMOTION: 'PROMOTION',
  PACKAGE_CREDIT: 'PACKAGE_CREDIT',
  FACE_PROGRAM: 'FACE_PROGRAM',
  AUTO_REPLY: 'AUTO_REPLY',
  GST: 'GST',
  CUSTOMER_CARE: 'CUSTOMER_CARE',
} as const;

export interface SkillMatrixResponse {
  treatments?: MatrixTreatment[];
  staff?: MatrixStaff[];
  matrix?: SkillMatrixRow[];
  exclusions?: StaffStepExclusion[];
}

export interface SkillMatrixRow {
  treatmentId: string;
  treatmentName: string;
  category: TreatmentCategory;
  totalSteps: number;
  staffCapability?: MatrixStaffCapability[];
}

export type SnapshotRowOutletCode = string | null;

export type SnapshotRowNextAppointment = string | null;

/**
 * Open snapshot (LEA-33-06): one customer as she stood that month.
 */
export interface SnapshotRow {
  customerId: string;
  name: string;
  outletCode?: SnapshotRowOutletCode;
  firstSeenOn: string;
  lastSeenOn: string;
  colour: string;
  nextAppointment?: SnapshotRowNextAppointment;
  apptMade?: boolean;
  bought?: boolean;
}

export interface SnapshotRowsResponse {
  month: string;
  listKey: LeadListKey;
  rows?: SnapshotRow[];
}

export interface SopDocumentListResponse {
  items?: SopDocumentOut[];
  total: number;
  areas?: string[];
}

export type SopDocumentOutEffectiveFrom = string | null;

export type SopDocumentOutLastChangedBy = string | null;

export type SopDocumentOutTrainingSop = TrainingSopRef | null;

export interface SopDocumentOut {
  id: string;
  name: string;
  area: string;
  versionLabel: string;
  versionNo: number;
  effectiveFrom?: SopDocumentOutEffectiveFrom;
  fileName: string;
  fileKind: string;
  fileSize: number;
  currentVersionId: string;
  lastChangedBy?: SopDocumentOutLastChangedBy;
  lastChangedAt: string;
  trainingSop?: SopDocumentOutTrainingSop;
  knowledgeStatus: DocStatus;
  knowledgeWhoCanAsk: WhoCanAsk;
}

export type SopDocumentUpdateName = string | null;

export type SopDocumentUpdateArea = string | null;

export type SopDocumentUpdateTrainingSopId = string | null;

export type SopDocumentUpdateVersionLabel = string | null;

export type SopDocumentUpdateEffectiveFrom = string | null;

export interface SopDocumentUpdate {
  name?: SopDocumentUpdateName;
  area?: SopDocumentUpdateArea;
  trainingSopId?: SopDocumentUpdateTrainingSopId;
  versionLabel?: SopDocumentUpdateVersionLabel;
  effectiveFrom?: SopDocumentUpdateEffectiveFrom;
}

export interface SopTextPreview {
  fileKind: string;
  fileName: string;
  chunks?: AiChunkOut[];
}

export interface SopVersionListResponse {
  items?: SopVersionOut[];
}

export type SopVersionOutEffectiveFrom = string | null;

export type SopVersionOutNote = string | null;

export type SopVersionOutCreatedBy = string | null;

export interface SopVersionOut {
  id: string;
  versionNo: number;
  versionLabel: string;
  effectiveFrom?: SopVersionOutEffectiveFrom;
  fileName: string;
  fileKind: string;
  fileSize: number;
  note?: SopVersionOutNote;
  createdBy?: SopVersionOutCreatedBy;
  createdAt: string;
  isCurrent: boolean;
}

/**
 * One 'How did you find us' answer, customers registered in the last 6 months.
 */
export interface SourceRow {
  source: string;
  customers: number;
  returned: number;
  returnRate: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  valuePerCustomer: string;
}

export interface SpecialRequestTherapist {
  id: string;
  name: string;
}

export type StaffAssignmentInputStaffId = string | null;

export interface StaffAssignmentInput {
  stepId: string;
  staffId?: StaffAssignmentInputStaffId;
}

export interface StaffAssignmentOutput {
  stepId: string;
  staffId: string;
  staffName: string;
}

export type StaffAttendanceDayShiftStart = string | null;

export type StaffAttendanceDayShiftEnd = string | null;

export type StaffAttendanceDayClockIn = string | null;

export type StaffAttendanceDayBreakStart = string | null;

export type StaffAttendanceDayBreakEnd = string | null;

export type StaffAttendanceDayClockOut = string | null;

export type StaffAttendanceDayLeaveType = string | null;

export type StaffAttendanceDayOutletName = string | null;

export type StaffAttendanceDayDeviceName = string | null;

/**
 * One day of one staff member's month: the roster and the presses.
 */
export interface StaffAttendanceDay {
  date: string;
  weekday: string;
  shiftStart?: StaffAttendanceDayShiftStart;
  shiftEnd?: StaffAttendanceDayShiftEnd;
  clockIn?: StaffAttendanceDayClockIn;
  breakStart?: StaffAttendanceDayBreakStart;
  breakEnd?: StaffAttendanceDayBreakEnd;
  clockOut?: StaffAttendanceDayClockOut;
  lateMinutes?: number;
  earlyLeaveMinutes?: number;
  workedMinutes?: number;
  status: string;
  leaveType?: StaffAttendanceDayLeaveType;
  outletName?: StaffAttendanceDayOutletName;
  deviceName?: StaffAttendanceDayDeviceName;
}

/**
 * GET /attendance/staff/{id}/month — HR > Staff Details > Time attendance.
 */
export interface StaffAttendanceMonth {
  staffId: string;
  staffName: string;
  month: string;
  days?: StaffAttendanceDay[];
  presentDays?: number;
  lateCount?: number;
  lateMinutes?: number;
  earlyLeaveCount?: number;
  earlyLeaveMinutes?: number;
  workedHours?: number;
}

export type StaffBirthdayItemDob = string | null;

export interface StaffBirthdayItem {
  id: string;
  name: string;
  role: StaffRole;
  dob?: StaffBirthdayItemDob;
  outlet: OutletSummary;
}

export interface StaffCertification {
  id: string;
  certDate: string;
  program: CertifiedTreatmentProgram;
}

export type StaffClaimCreateAmount = number | string;

export type StaffClaimCreatePeriod = string | null;

export interface StaffClaimCreate {
  claimType: string;
  receiptDate: string;
  amount: StaffClaimCreateAmount;
  item: string;
  paidBy: string;
  receiptUrl: string;
  period?: StaffClaimCreatePeriod;
}

export type StaffClaimOutOutletName = string | null;

export type StaffClaimOutStaffName = string | null;

export type StaffClaimOutRejectReason = string | null;

export type StaffClaimOutDecidedByName = string | null;

export type StaffClaimOutDecidedAt = string | null;

export interface StaffClaimOut {
  id: string;
  outletId: string;
  outletName?: StaffClaimOutOutletName;
  staffId: string;
  staffName?: StaffClaimOutStaffName;
  period: string;
  claimType: string;
  receiptDate: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  item: string;
  paidBy: string;
  receiptUrl: string;
  receiptName: string;
  status: string;
  rejectReason?: StaffClaimOutRejectReason;
  decidedByName?: StaffClaimOutDecidedByName;
  decidedAt?: StaffClaimOutDecidedAt;
  createdAt: string;
}

export interface StaffClaimReject {
  reason: string;
}

export interface StaffClaimSaved {
  claim: StaffClaimOut;
  overAllowance?: boolean;
}

export type StaffCommentReviewerName = string | null;

export interface StaffComment {
  n: number;
  text: string;
  reviewerName?: StaffCommentReviewerName;
}

export type StaffCommissionSummaryResponseStatus = CommissionStatusResponse | null;

/**
 * Full commission summary for a single staff member.
 */
export interface StaffCommissionSummaryResponse {
  staffId: string;
  staffName: string;
  role: string;
  rates: CommissionRateResponse[];
  earnings: CommissionEarningResponse[];
  status?: StaffCommissionSummaryResponseStatus;
}

export interface StaffConflict {
  startTime: string;
  endTime: string;
}

export type StaffConsultRowOutletCode = string | null;

export type StaffConsultRowEmployment = string | null;

export type StaffConsultRowTenureYears = number | null;

export type StaffConsultRowCloseRate = number | null;

export type StaffConsultRowPackageRate = number | null;

export interface StaffConsultRow {
  staffId: string;
  name: string;
  position: string;
  outletCode?: StaffConsultRowOutletCode;
  employment?: StaffConsultRowEmployment;
  tenureYears?: StaffConsultRowTenureYears;
  held: number;
  closed: number;
  packages: number;
  closeRate?: StaffConsultRowCloseRate;
  packageRate?: StaffConsultRowPackageRate;
}

/**
 * A staff member whose home outlet is NOT the one being rostered, and who
can therefore be pulled in as temporary cover (Angela, 31 Aug). Deliberately
thin — the "Add Staff" picker needs a label and a home-outlet tag, nothing
from the HR profile.
 */
export interface StaffCoveringCandidate {
  id: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
  outlet: OutletSummary;
}

export type StaffCreateFullName = string | null;

export type StaffCreateSkillLevel = number | null;

export type StaffCreateEmploymentType = EmploymentType | null;

export type StaffCreateDob = string | null;

export type StaffCreateIsProbation = boolean | null;

export type StaffCreatePreferredLang = PreferredLanguage | null;

export interface StaffCreate {
  name: string;
  fullName?: StaffCreateFullName;
  role: StaffRole;
  skillLevel?: StaffCreateSkillLevel;
  employmentType?: StaffCreateEmploymentType;
  outletId: string;
  startDate: string;
  dob?: StaffCreateDob;
  isProbation?: StaffCreateIsProbation;
  preferredLang?: StaffCreatePreferredLang;
  additionalOutletIds?: string[];
}

export type StaffDetailDob = string | null;

export type StaffDetailProbationEndDate = string | null;

export type StaffDetailPhone = string | null;

export type StaffDetailPhotoUrl = string | null;

export type StaffDetailFullName = string | null;

export type StaffDetailGender = string | null;

export type StaffDetailNationality = string | null;

export type StaffDetailResidencyStatus = string | null;

export type StaffDetailIdType = string | null;

export type StaffDetailIdNumber = string | null;

export type StaffDetailRace = string | null;

export type StaffDetailReligion = string | null;

export type StaffDetailHomeAddress = string | null;

export type StaffDetailProbationStartDate = string | null;

export type StaffDetailConfirmationDate = string | null;

export type StaffDetailResignationDate = string | null;

export type StaffDetailDepartment = string | null;

export type StaffDetailPosition = string | null;

export type StaffDetailWorkScheduleDays = string | null;

export type StaffDetailEmployeeId = string | null;

export interface StaffDetail {
  outletId: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
  employmentType: EmploymentType;
  startDate: string;
  dob?: StaffDetailDob;
  isProbation?: boolean;
  probationEndDate?: StaffDetailProbationEndDate;
  phone?: StaffDetailPhone;
  photoUrl?: StaffDetailPhotoUrl;
  preferredLang?: PreferredLanguage;
  isActive?: boolean;
  detailsNeeded?: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
  outlet: OutletDetailSummary;
  additionalOutlets?: StaffOutletAssignment[];
  certifiedTreatments?: StaffCertification[];
  fullName?: StaffDetailFullName;
  gender?: StaffDetailGender;
  nationality?: StaffDetailNationality;
  residencyStatus?: StaffDetailResidencyStatus;
  idType?: StaffDetailIdType;
  idNumber?: StaffDetailIdNumber;
  race?: StaffDetailRace;
  religion?: StaffDetailReligion;
  homeAddress?: StaffDetailHomeAddress;
  probationStartDate?: StaffDetailProbationStartDate;
  confirmationDate?: StaffDetailConfirmationDate;
  resignationDate?: StaffDetailResignationDate;
  department?: StaffDetailDepartment;
  position?: StaffDetailPosition;
  workScheduleDays?: StaffDetailWorkScheduleDays;
  employeeId?: StaffDetailEmployeeId;
}

export type StaffDocumentCreateRequestDocType = typeof StaffDocumentCreateRequestDocType[keyof typeof StaffDocumentCreateRequestDocType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffDocumentCreateRequestDocType = {
  EMPLOYMENT_CONTRACT: 'EMPLOYMENT_CONTRACT',
  WORK_PASS: 'WORK_PASS',
  PASSPORT: 'PASSPORT',
  CERTIFICATE: 'CERTIFICATE',
  SOP_ACKNOWLEDGEMENT: 'SOP_ACKNOWLEDGEMENT',
  OTHER: 'OTHER',
} as const;

export type StaffDocumentCreateRequestNotes = string | null;

/**
 * POST /staff/{id}/documents body — base64 data URL upload (JSON, not
multipart). ``file_size`` is computed server-side from the decoded bytes.
 */
export interface StaffDocumentCreateRequest {
  docType: StaffDocumentCreateRequestDocType;
  fileName: string;
  mimeType: string;
  fileData: string;
  notes?: StaffDocumentCreateRequestNotes;
}

export type StaffDocumentSummaryDocType = typeof StaffDocumentSummaryDocType[keyof typeof StaffDocumentSummaryDocType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffDocumentSummaryDocType = {
  EMPLOYMENT_CONTRACT: 'EMPLOYMENT_CONTRACT',
  WORK_PASS: 'WORK_PASS',
  PASSPORT: 'PASSPORT',
  CERTIFICATE: 'CERTIFICATE',
  SOP_ACKNOWLEDGEMENT: 'SOP_ACKNOWLEDGEMENT',
  OTHER: 'OTHER',
} as const;

export type StaffDocumentSummaryFileSize = number | null;

export type StaffDocumentSummaryNotes = string | null;

export type StaffDocumentSummaryUploadedByName = string | null;

/**
 * Metadata-only document shape — NEVER carries ``fileData`` (§6.3).
 */
export interface StaffDocumentSummary {
  id: string;
  docType: StaffDocumentSummaryDocType;
  fileName: string;
  mimeType: string;
  fileSize?: StaffDocumentSummaryFileSize;
  notes?: StaffDocumentSummaryNotes;
  uploadedByName?: StaffDocumentSummaryUploadedByName;
  uploadedAt: string;
}

/**
 * One row in the commission page's per-staff overview table.
 */
export interface StaffEarningEntry {
  staff: StaffEarningStaff;
  summary: StaffEarningSummary;
}

export type StaffEarningStaffOutletId = string | null;

/**
 * The staff identity carried on a per-staff earnings row.
 */
export interface StaffEarningStaff {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  outletId?: StaffEarningStaffOutletId;
  isActive: boolean;
}

/**
 * Per-staff commission totals (amounts by status + minutes/count). Amounts are
floats (JSON numbers) — the commission page renders them with numeric helpers
(formatCurrency/formatHours), not strings.
 */
export interface StaffEarningSummary {
  totalEarnings: number;
  pendingAmount: number;
  approvedAmount: number;
  paidAmount: number;
  totalMinutes: number;
  appointmentCount: number;
  changedAfterApprovalCount?: number;
}

export type StaffEmploymentProbationStartDate = string | null;

export type StaffEmploymentProbationEndDate = string | null;

export type StaffEmploymentConfirmationDate = string | null;

export type StaffEmploymentResignationDate = string | null;

export type StaffEmploymentDepartment = string | null;

export type StaffEmploymentPosition = string | null;

export type StaffEmploymentWorkScheduleDays = '5' | '5_5' | '6' | null;

export type StaffEmploymentWorkingHoursPerDay = number | null;

export type StaffEmploymentEmployeeId = string | null;

export type StaffEmploymentBasicSalary = number | null;

export type StaffEmploymentFixedOtPay = number | null;

export type StaffEmploymentCommissionTier = string | null;

/**
 * Read shape for the Employment section. Salary fields are read-through
from the Salary module (never mirrored onto Staff).
 */
export interface StaffEmployment {
  employmentType: string;
  startDate: string;
  isProbation?: boolean;
  probationStartDate?: StaffEmploymentProbationStartDate;
  probationEndDate?: StaffEmploymentProbationEndDate;
  confirmationDate?: StaffEmploymentConfirmationDate;
  resignationDate?: StaffEmploymentResignationDate;
  department?: StaffEmploymentDepartment;
  position?: StaffEmploymentPosition;
  workScheduleDays?: StaffEmploymentWorkScheduleDays;
  workingHoursPerDay?: StaffEmploymentWorkingHoursPerDay;
  employeeId?: StaffEmploymentEmployeeId;
  basicSalary?: StaffEmploymentBasicSalary;
  fixedOtPay?: StaffEmploymentFixedOtPay;
  commissionTier?: StaffEmploymentCommissionTier;
}

export type StaffEmploymentChangeRequestOutletId = string | null;

export type StaffEmploymentChangeRequestEmploymentType = string | null;

export type StaffEmploymentChangeRequestNotes = string | null;

/**
 * POST /staff/{id}/employment-history/change — record a change that CLOSES
the current record and OPENS its successor in one step.

This is Angela's "Promotion" button generalised: "When the Promotion button
is used, the system could automatically close the current position record
and create a new current position record." Doing it as one endpoint keeps
the two writes atomic — a half-applied change would leave a staff member
with two current positions or none.
 */
export interface StaffEmploymentChangeRequest {
  changeType: string;
  effectiveDate: string;
  title: string;
  outletId?: StaffEmploymentChangeRequestOutletId;
  employmentType?: StaffEmploymentChangeRequestEmploymentType;
  notes?: StaffEmploymentChangeRequestNotes;
}

export type StaffEmploymentHistoryItemEmployerName = string | null;

export type StaffEmploymentHistoryItemOutletId = string | null;

export type StaffEmploymentHistoryItemOutletName = string | null;

export type StaffEmploymentHistoryItemEndDate = string | null;

export type StaffEmploymentHistoryItemChangeType = string | null;

export type StaffEmploymentHistoryItemEmploymentType = string | null;

export type StaffEmploymentHistoryItemNotes = string | null;

/**
 * Read shape for one employment-timeline row. ``is_current`` is derived
server-side from ``end_date is None`` (§8.5).
 */
export interface StaffEmploymentHistoryItem {
  id: string;
  title: string;
  employerName?: StaffEmploymentHistoryItemEmployerName;
  outletId?: StaffEmploymentHistoryItemOutletId;
  outletName?: StaffEmploymentHistoryItemOutletName;
  startDate: string;
  endDate?: StaffEmploymentHistoryItemEndDate;
  isCurrent?: boolean;
  changeType?: StaffEmploymentHistoryItemChangeType;
  employmentType?: StaffEmploymentHistoryItemEmploymentType;
  notes?: StaffEmploymentHistoryItemNotes;
}

export type StaffEmploymentHistoryUpsertEmployerName = string | null;

export type StaffEmploymentHistoryUpsertOutletId = string | null;

export type StaffEmploymentHistoryUpsertEndDate = string | null;

export type StaffEmploymentHistoryUpsertChangeType = string | null;

export type StaffEmploymentHistoryUpsertEmploymentType = string | null;

export type StaffEmploymentHistoryUpsertNotes = string | null;

/**
 * POST/PUT /staff/{id}/employment-history body. ``is_current`` is NOT sent —
it is derived from ``end_date`` server-side (§8.5).
 */
export interface StaffEmploymentHistoryUpsert {
  title: string;
  employerName?: StaffEmploymentHistoryUpsertEmployerName;
  outletId?: StaffEmploymentHistoryUpsertOutletId;
  startDate: string;
  endDate?: StaffEmploymentHistoryUpsertEndDate;
  changeType?: StaffEmploymentHistoryUpsertChangeType;
  employmentType?: StaffEmploymentHistoryUpsertEmploymentType;
  notes?: StaffEmploymentHistoryUpsertNotes;
}

export type StaffEmploymentUpdateProbationStartDate = string | null;

export type StaffEmploymentUpdateProbationEndDate = string | null;

export type StaffEmploymentUpdateConfirmationDate = string | null;

export type StaffEmploymentUpdateResignationDate = string | null;

export type StaffEmploymentUpdateDepartment = string | null;

export type StaffEmploymentUpdatePosition = string | null;

export type StaffEmploymentUpdateWorkScheduleDays = '5' | '5_5' | '6' | null;

export type StaffEmploymentUpdateWorkingHoursPerDay = number | null;

/**
 * PUT /staff/{id}/employment body — all fields optional.
 */
export interface StaffEmploymentUpdate {
  probationStartDate?: StaffEmploymentUpdateProbationStartDate;
  probationEndDate?: StaffEmploymentUpdateProbationEndDate;
  confirmationDate?: StaffEmploymentUpdateConfirmationDate;
  resignationDate?: StaffEmploymentUpdateResignationDate;
  department?: StaffEmploymentUpdateDepartment;
  position?: StaffEmploymentUpdatePosition;
  workScheduleDays?: StaffEmploymentUpdateWorkScheduleDays;
  workingHoursPerDay?: StaffEmploymentUpdateWorkingHoursPerDay;
}

export type StaffHoursRowOutletCode = string | null;

export type StaffHoursRowUtilisation = number | null;

export interface StaffHoursRow {
  staffId: string;
  name: string;
  position: string;
  outletCode?: StaffHoursRowOutletCode;
  rosteredHours: number;
  treatmentHours: number;
  utilisation?: StaffHoursRowUtilisation;
}

export type StaffHrInfoGender = 'MALE' | 'FEMALE' | 'OTHER' | null;

export type StaffHrInfoDob = string | null;

export type StaffHrInfoNationality = string | null;

export type StaffHrInfoResidencyStatus = 'CITIZEN' | 'PR' | 'FOREIGNER' | 'WORK_PASS' | 'OTHER' | null;

export type StaffHrInfoIdType = 'NRIC' | 'FIN' | 'PASSPORT' | null;

export type StaffHrInfoIdNumber = string | null;

export type StaffHrInfoIdNumberMasked = string | null;

export type StaffHrInfoRace = string | null;

export type StaffHrInfoReligion = string | null;

export type StaffHrInfoHomeAddress = string | null;

export type StaffHrInfoPassType = 'S_PASS' | 'EP' | 'PEP' | 'WORK_PERMIT' | null;

export type StaffHrInfoPostalCode = string | null;

export type StaffHrInfoName = string | null;

export type StaffHrInfoFullName = string | null;

export type StaffHrInfoNickName = string | null;

export type StaffHrInfoEmail = string | null;

export type StaffHrInfoPhone = string | null;

export type StaffHrInfoCountryCode = string | null;

export type StaffHrInfoRaceOther = string | null;

export type StaffHrInfoDrawsSalary = boolean | null;

export type StaffHrInfoAddressLine2 = string | null;

export type StaffHrInfoEmergencyContactName = string | null;

export type StaffHrInfoEmergencyContactRelationship = string | null;

export type StaffHrInfoEmergencyContactPhone = string | null;

/**
 * Read shape for the HR Information section. ``id_number`` is populated for
HR callers; ``id_number_masked`` for non-HR self-viewers (§8.5).
 */
export interface StaffHrInfo {
  gender?: StaffHrInfoGender;
  dob?: StaffHrInfoDob;
  nationality?: StaffHrInfoNationality;
  residencyStatus?: StaffHrInfoResidencyStatus;
  idType?: StaffHrInfoIdType;
  idNumber?: StaffHrInfoIdNumber;
  idNumberMasked?: StaffHrInfoIdNumberMasked;
  race?: StaffHrInfoRace;
  religion?: StaffHrInfoReligion;
  homeAddress?: StaffHrInfoHomeAddress;
  passType?: StaffHrInfoPassType;
  postalCode?: StaffHrInfoPostalCode;
  name?: StaffHrInfoName;
  fullName?: StaffHrInfoFullName;
  nickName?: StaffHrInfoNickName;
  email?: StaffHrInfoEmail;
  phone?: StaffHrInfoPhone;
  countryCode?: StaffHrInfoCountryCode;
  raceOther?: StaffHrInfoRaceOther;
  drawsSalary?: StaffHrInfoDrawsSalary;
  addressLine2?: StaffHrInfoAddressLine2;
  emergencyContactName?: StaffHrInfoEmergencyContactName;
  emergencyContactRelationship?: StaffHrInfoEmergencyContactRelationship;
  emergencyContactPhone?: StaffHrInfoEmergencyContactPhone;
}

export type StaffHrInfoUpdateGender = 'MALE' | 'FEMALE' | 'OTHER' | null;

export type StaffHrInfoUpdateDob = string | null;

export type StaffHrInfoUpdateNationality = string | null;

export type StaffHrInfoUpdateResidencyStatus = 'CITIZEN' | 'PR' | 'FOREIGNER' | 'WORK_PASS' | 'OTHER' | null;

export type StaffHrInfoUpdateIdType = 'NRIC' | 'FIN' | 'PASSPORT' | null;

export type StaffHrInfoUpdateIdNumber = string | null;

export type StaffHrInfoUpdateRace = string | null;

export type StaffHrInfoUpdateReligion = string | null;

export type StaffHrInfoUpdateHomeAddress = string | null;

export type StaffHrInfoUpdatePassType = 'S_PASS' | 'EP' | 'PEP' | 'WORK_PERMIT' | null;

export type StaffHrInfoUpdatePostalCode = string | null;

export type StaffHrInfoUpdateName = string | null;

export type StaffHrInfoUpdateFullName = string | null;

export type StaffHrInfoUpdateNickName = string | null;

export type StaffHrInfoUpdateEmail = string | null;

export type StaffHrInfoUpdatePhone = string | null;

export type StaffHrInfoUpdateCountryCode = string | null;

export type StaffHrInfoUpdateRaceOther = string | null;

export type StaffHrInfoUpdateDrawsSalary = boolean | null;

export type StaffHrInfoUpdateAddressLine2 = string | null;

export type StaffHrInfoUpdateEmergencyContactName = string | null;

export type StaffHrInfoUpdateEmergencyContactRelationship = string | null;

export type StaffHrInfoUpdateEmergencyContactPhone = string | null;

/**
 * PUT /staff/{id}/hr-info body — all fields optional (partial update).
 */
export interface StaffHrInfoUpdate {
  gender?: StaffHrInfoUpdateGender;
  dob?: StaffHrInfoUpdateDob;
  nationality?: StaffHrInfoUpdateNationality;
  residencyStatus?: StaffHrInfoUpdateResidencyStatus;
  idType?: StaffHrInfoUpdateIdType;
  idNumber?: StaffHrInfoUpdateIdNumber;
  race?: StaffHrInfoUpdateRace;
  religion?: StaffHrInfoUpdateReligion;
  homeAddress?: StaffHrInfoUpdateHomeAddress;
  passType?: StaffHrInfoUpdatePassType;
  postalCode?: StaffHrInfoUpdatePostalCode;
  name?: StaffHrInfoUpdateName;
  fullName?: StaffHrInfoUpdateFullName;
  nickName?: StaffHrInfoUpdateNickName;
  email?: StaffHrInfoUpdateEmail;
  phone?: StaffHrInfoUpdatePhone;
  countryCode?: StaffHrInfoUpdateCountryCode;
  raceOther?: StaffHrInfoUpdateRaceOther;
  drawsSalary?: StaffHrInfoUpdateDrawsSalary;
  addressLine2?: StaffHrInfoUpdateAddressLine2;
  emergencyContactName?: StaffHrInfoUpdateEmergencyContactName;
  emergencyContactRelationship?: StaffHrInfoUpdateEmergencyContactRelationship;
  emergencyContactPhone?: StaffHrInfoUpdateEmergencyContactPhone;
}

export type StaffInsuranceItemStartDate = string | null;

export type StaffInsuranceItemEndDate = string | null;

export type StaffInsuranceItemReference = string | null;

export type StaffInsuranceItemDaysLeft = number | null;

export type StaffInsuranceItemWarning = string | null;

/**
 * HR-11 Insurance: one of MI · WIC · BOND.
 */
export interface StaffInsuranceItem {
  kind: string;
  startDate?: StaffInsuranceItemStartDate;
  endDate?: StaffInsuranceItemEndDate;
  reference?: StaffInsuranceItemReference;
  daysLeft?: StaffInsuranceItemDaysLeft;
  warning?: StaffInsuranceItemWarning;
}

export type StaffLeaveCalendarEntryOutletId = string | null;

/**
 * One range of approved leave on the staff-facing calendar. Carries the leave
type's short code (Angela, 24 Oct 2026: staff may see AL / MC …) but NO
reason, notes, attachments or status.
 */
export interface StaffLeaveCalendarEntry {
  id: string;
  staffId: string;
  staffName: string;
  outletId?: StaffLeaveCalendarEntryOutletId;
  leaveCode: string;
  startDate: string;
  endDate: string;
  dayPortion: string;
}

export type StaffLeaveCalendarResponseOutletId = string | null;

export interface StaffLeaveCalendarResponse {
  fromDate: string;
  toDate: string;
  outletId?: StaffLeaveCalendarResponseOutletId;
  entries?: StaffLeaveCalendarEntry[];
}

/**
 * GET /leave/overrides response body.
 */
export interface StaffLeaveEntitlementListResponse {
  overrides?: StaffLeaveEntitlementResponse[];
}

export type StaffLeaveEntitlementResponseStaffName = string | null;

export type StaffLeaveEntitlementResponseAnnualLeaveDaysOverride = number | null;

export type StaffLeaveEntitlementResponsePhOffInLieuDaysOverride = number | null;

export type StaffLeaveEntitlementResponseExtraAnnualDays = number | null;

export type StaffLeaveEntitlementResponseExtraOtHours = number | null;

export type StaffLeaveEntitlementResponseEffectiveLeaveYear = number | null;

export type StaffLeaveEntitlementResponseNotes = string | null;

export type StaffLeaveEntitlementResponseUpdatedById = string | null;

export type StaffLeaveEntitlementResponseCreatedAt = string | null;

export type StaffLeaveEntitlementResponseUpdatedAt = string | null;

/**
 * A single per-staff override row (Spec D).
 */
export interface StaffLeaveEntitlementResponse {
  id: string;
  staffId: string;
  staffName?: StaffLeaveEntitlementResponseStaffName;
  annualLeaveDaysOverride?: StaffLeaveEntitlementResponseAnnualLeaveDaysOverride;
  phOffInLieuDaysOverride?: StaffLeaveEntitlementResponsePhOffInLieuDaysOverride;
  extraAnnualDays?: StaffLeaveEntitlementResponseExtraAnnualDays;
  extraOtHours?: StaffLeaveEntitlementResponseExtraOtHours;
  effectiveLeaveYear?: StaffLeaveEntitlementResponseEffectiveLeaveYear;
  notes?: StaffLeaveEntitlementResponseNotes;
  updatedById?: StaffLeaveEntitlementResponseUpdatedById;
  createdAt?: StaffLeaveEntitlementResponseCreatedAt;
  updatedAt?: StaffLeaveEntitlementResponseUpdatedAt;
}

export type StaffLeaveEntitlementUpsertRequestAnnualLeaveDaysOverride = number | null;

export type StaffLeaveEntitlementUpsertRequestPhOffInLieuDaysOverride = number | null;

export type StaffLeaveEntitlementUpsertRequestExtraAnnualDays = number | null;

export type StaffLeaveEntitlementUpsertRequestExtraOtHours = number | null;

export type StaffLeaveEntitlementUpsertRequestEffectiveLeaveYear = number | null;

export type StaffLeaveEntitlementUpsertRequestNotes = string | null;

export type StaffLeaveEntitlementUpsertRequestRemark = string | null;

/**
 * PUT /leave/overrides/{staffId} — full-state upsert.

All fields optional; ``null`` means "no override for this field" (the drawer
always sends the complete override state, so upsert = replace all fields).
 */
export interface StaffLeaveEntitlementUpsertRequest {
  annualLeaveDaysOverride?: StaffLeaveEntitlementUpsertRequestAnnualLeaveDaysOverride;
  phOffInLieuDaysOverride?: StaffLeaveEntitlementUpsertRequestPhOffInLieuDaysOverride;
  extraAnnualDays?: StaffLeaveEntitlementUpsertRequestExtraAnnualDays;
  extraOtHours?: StaffLeaveEntitlementUpsertRequestExtraOtHours;
  effectiveLeaveYear?: StaffLeaveEntitlementUpsertRequestEffectiveLeaveYear;
  notes?: StaffLeaveEntitlementUpsertRequestNotes;
  remark?: StaffLeaveEntitlementUpsertRequestRemark;
}

export type StaffLeaveSummaryItemEntitled = number | null;

export type StaffLeaveSummaryItemTaken = number | null;

export type StaffLeaveSummaryItemBalance = number | null;

/**
 * Read-through leave-balance line (§7.1 section 4).
 */
export interface StaffLeaveSummaryItem {
  leaveType: string;
  entitled?: StaffLeaveSummaryItemEntitled;
  taken?: StaffLeaveSummaryItemTaken;
  balance?: StaffLeaveSummaryItemBalance;
}

export type StaffMeetingDescription = string | null;

export type StaffMeetingRoomId = string | null;

export type StaffMeetingTrainerId = string | null;

export type StaffMeetingTrainer = StaffMeetingAttendeeStaff | null;

export type StaffMeetingRoomProperty = StaffMeetingRoom | null;

export interface StaffMeeting {
  id: string;
  outletId: string;
  title: string;
  description?: StaffMeetingDescription;
  date: string;
  startTime: string;
  endTime: string;
  roomId?: StaffMeetingRoomId;
  meetingType: string;
  trainerId?: StaffMeetingTrainerId;
  trainer?: StaffMeetingTrainer;
  createdById: string;
  createdAt: string;
  updatedAt: string;
  attendees?: StaffMeetingAttendee[];
  room?: StaffMeetingRoomProperty;
  outlet: StaffMeetingOutlet;
  documentCount?: number;
}

export interface StaffMeetingAttendee {
  id: string;
  staffId: string;
  staff: StaffMeetingAttendeeStaff;
}

export interface StaffMeetingAttendeeStaff {
  id: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
}

export type StaffMeetingCreateDescription = string | null;

export type StaffMeetingCreateRoomId = string | null;

export type StaffMeetingCreateTrainerId = string | null;

export interface StaffMeetingCreate {
  outletId: string;
  title: string;
  description?: StaffMeetingCreateDescription;
  date: string;
  startTime: string;
  endTime: string;
  roomId?: StaffMeetingCreateRoomId;
  meetingType?: MeetingType;
  trainerId?: StaffMeetingCreateTrainerId;
  attendeeIds: string[];
}

export interface StaffMeetingDeleteResponse {
  ok: boolean;
}

export interface StaffMeetingOutlet {
  id: string;
  code: string;
}

export interface StaffMeetingRoom {
  id: string;
  name: string;
}

export type StaffMeetingUpdateTitle = string | null;

export type StaffMeetingUpdateDescription = string | null;

export type StaffMeetingUpdateStartTime = string | null;

export type StaffMeetingUpdateEndTime = string | null;

export type StaffMeetingUpdateRoomId = string | null;

export type StaffMeetingUpdateMeetingType = MeetingType | null;

export type StaffMeetingUpdateTrainerId = string | null;

export type StaffMeetingUpdateAttendeeIds = string[] | null;

export interface StaffMeetingUpdate {
  title?: StaffMeetingUpdateTitle;
  description?: StaffMeetingUpdateDescription;
  date?: null;
  startTime?: StaffMeetingUpdateStartTime;
  endTime?: StaffMeetingUpdateEndTime;
  roomId?: StaffMeetingUpdateRoomId;
  meetingType?: StaffMeetingUpdateMeetingType;
  trainerId?: StaffMeetingUpdateTrainerId;
  attendeeIds?: StaffMeetingUpdateAttendeeIds;
}

export type StaffOutletAssignmentCreatedAt = string | null;

export interface StaffOutletAssignment {
  id: string;
  outletId: string;
  createdAt?: StaffOutletAssignmentCreatedAt;
  outlet: OutletSummary;
}

export type StaffPayrollInfoResponseBankName = string | null;

export type StaffPayrollInfoResponseBankAccountNo = string | null;

export type StaffPayrollInfoResponseBankAccountNoMasked = string | null;

export type StaffPayrollInfoResponseBankAccountName = string | null;

export type StaffPayrollInfoResponsePaymentFrequency = string | null;

export type StaffPayrollInfoResponsePaymentMode = string | null;

export type StaffPayrollInfoResponseBankBranchCode = string | null;

export type StaffPayrollInfoResponseCpfStatus = string | null;

export type StaffPayrollInfoResponseCpfAccountNo = string | null;

export type StaffPayrollInfoResponseCpfAccountNoMasked = string | null;

export type StaffPayrollInfoResponseTaxRef = string | null;

export type StaffPayrollInfoResponseTaxRefMasked = string | null;

export type StaffPayrollInfoResponseTaxResidencyStatus = string | null;

export type StaffPayrollInfoResponseNotes = string | null;

/**
 * GET /staff/{id}/payroll — bank/CPF/tax + salary/payslip read-through.
Sensitive account numbers masked per §8.5 for non-HR callers.
 */
export interface StaffPayrollInfoResponse {
  bankName?: StaffPayrollInfoResponseBankName;
  bankAccountNo?: StaffPayrollInfoResponseBankAccountNo;
  bankAccountNoMasked?: StaffPayrollInfoResponseBankAccountNoMasked;
  bankAccountName?: StaffPayrollInfoResponseBankAccountName;
  paymentFrequency?: StaffPayrollInfoResponsePaymentFrequency;
  paymentMode?: StaffPayrollInfoResponsePaymentMode;
  bankBranchCode?: StaffPayrollInfoResponseBankBranchCode;
  cpfStatus?: StaffPayrollInfoResponseCpfStatus;
  cpfAccountNo?: StaffPayrollInfoResponseCpfAccountNo;
  cpfAccountNoMasked?: StaffPayrollInfoResponseCpfAccountNoMasked;
  taxRef?: StaffPayrollInfoResponseTaxRef;
  taxRefMasked?: StaffPayrollInfoResponseTaxRefMasked;
  taxResidencyStatus?: StaffPayrollInfoResponseTaxResidencyStatus;
  notes?: StaffPayrollInfoResponseNotes;
  salaryHistory?: SalaryHistoryItem[];
  payslips?: PayslipHistoryItem[];
}

export type StaffPayrollInfoUpdateBankName = string | null;

export type StaffPayrollInfoUpdateBankAccountNo = string | null;

export type StaffPayrollInfoUpdateBankAccountName = string | null;

export type StaffPayrollInfoUpdatePaymentFrequency = 'MONTHLY' | 'SEMI_MONTHLY' | 'WEEKLY' | 'DAILY' | null;

export type StaffPayrollInfoUpdatePaymentMode = 'CASH' | 'GIRO' | null;

export type StaffPayrollInfoUpdateBankBranchCode = string | null;

export type StaffPayrollInfoUpdateCpfStatus = string | null;

export type StaffPayrollInfoUpdateCpfAccountNo = string | null;

export type StaffPayrollInfoUpdateTaxRef = string | null;

export type StaffPayrollInfoUpdateTaxResidencyStatus = string | null;

export type StaffPayrollInfoUpdateNotes = string | null;

/**
 * PUT /staff/{id}/payroll-info body — upserts the 1:1 StaffPayrollInfo.
 */
export interface StaffPayrollInfoUpdate {
  bankName?: StaffPayrollInfoUpdateBankName;
  bankAccountNo?: StaffPayrollInfoUpdateBankAccountNo;
  bankAccountName?: StaffPayrollInfoUpdateBankAccountName;
  paymentFrequency?: StaffPayrollInfoUpdatePaymentFrequency;
  paymentMode?: StaffPayrollInfoUpdatePaymentMode;
  bankBranchCode?: StaffPayrollInfoUpdateBankBranchCode;
  cpfStatus?: StaffPayrollInfoUpdateCpfStatus;
  cpfAccountNo?: StaffPayrollInfoUpdateCpfAccountNo;
  taxRef?: StaffPayrollInfoUpdateTaxRef;
  taxResidencyStatus?: StaffPayrollInfoUpdateTaxResidencyStatus;
  notes?: StaffPayrollInfoUpdateNotes;
}

export type StaffProfileBasicsFullName = string | null;

export type StaffProfileBasicsOutletName = string | null;

export type StaffProfileBasicsPhone = string | null;

export type StaffProfileBasicsPhotoUrl = string | null;

export type StaffProfileBasicsEmployeeId = string | null;

export type StaffProfileBasicsUserEmail = string | null;

export type StaffProfileBasicsLoginId = string | null;

/**
 * Section 1 (Profile) block of the aggregate.
 */
export interface StaffProfileBasics {
  id: string;
  name: string;
  fullName?: StaffProfileBasicsFullName;
  role: string;
  outletId: string;
  outletName?: StaffProfileBasicsOutletName;
  phone?: StaffProfileBasicsPhone;
  photoUrl?: StaffProfileBasicsPhotoUrl;
  isActive?: boolean;
  preferredLang: string;
  employeeId?: StaffProfileBasicsEmployeeId;
  hasAccount?: boolean;
  userEmail?: StaffProfileBasicsUserEmail;
  loginId?: StaffProfileBasicsLoginId;
}

export type StaffProfileResponseHrInfo = StaffHrInfo | null;

export type StaffProfileResponseLeaveSummary = StaffLeaveSummaryItem[] | null;

export type StaffProfileResponseDocuments = StaffDocumentSummary[] | null;

export type StaffProfileResponsePayroll = StaffPayrollInfoResponse | null;

/**
 * GET /staff/{id}/profile — the six-section aggregate. Sub-blocks are
included only when the caller's resolved permissions allow (payroll,
documents); HR ID fields masked per §8.5 for non-HR callers.
 */
export interface StaffProfileResponse {
  profile: StaffProfileBasics;
  hrInfo?: StaffProfileResponseHrInfo;
  employment: StaffEmployment;
  employmentHistory?: StaffEmploymentHistoryItem[];
  leaveSummary?: StaffProfileResponseLeaveSummary;
  documents?: StaffProfileResponseDocuments;
  payroll?: StaffProfileResponsePayroll;
  canManageHr?: boolean;
  canManageDocuments?: boolean;
  canViewPayroll?: boolean;
}

export type StaffPromotionOutReason = string | null;

export type StaffPromotionOutNote = string | null;

export type StaffPromotionOutApprovedById = string | null;

export type StaffPromotionOutApprovedByName = string | null;

export type StaffPromotionOutAppliedAt = string | null;

export interface StaffPromotionOut {
  id: string;
  staffId: string;
  staffName: string;
  outletId: string;
  outletName: string;
  fromRole: string;
  toRole: string;
  effectiveDate: string;
  reason?: StaffPromotionOutReason;
  note?: StaffPromotionOutNote;
  approvedById?: StaffPromotionOutApprovedById;
  approvedByName?: StaffPromotionOutApprovedByName;
  approvedAt: string;
  appliedAt?: StaffPromotionOutAppliedAt;
}

export type StaffPromotionReadinessCurrentTier = StaffPromotionTier | null;

export type StaffPromotionReadinessNextTier = StaffPromotionTier | null;

export interface StaffPromotionReadiness {
  currentTier?: StaffPromotionReadinessCurrentTier;
  nextTier?: StaffPromotionReadinessNextTier;
  monthsTenure: number;
  status: StaffPromotionReadinessStatus;
  gaps: StaffPromotionReadinessGaps;
  isTopTier: boolean;
}

export interface StaffPromotionReadinessGaps {
  monthsToMinDuration: number;
  sopsNeeded: number;
  treatmentsNeeded: number;
}

export interface StaffPromotionReadinessStatus {
  durationMet: boolean;
  sopMet: boolean;
  treatmentMet: boolean;
  readyForPromotion: boolean;
}

export type StaffPromotionTierDurationMonthsMax = number | null;

export type StaffPromotionTierTreatmentRequired = number | null;

export type StaffPromotionTierPerformanceReviewMinPct = number | null;

export type StaffPromotionTierPerformanceReviewQuarters = number | null;

export type StaffPromotionTierNotes = string | null;

/**
 * One row of `PromotionCriteria`, as `_serialize_promotion_criteria` emits it.
 */
export interface StaffPromotionTier {
  role: string;
  tierLabel: string;
  durationMonthsMin: number;
  durationMonthsMax?: StaffPromotionTierDurationMonthsMax;
  sopRequired: number;
  treatmentRequired?: StaffPromotionTierTreatmentRequired;
  performanceReviewRequired?: boolean;
  performanceReviewMinPct?: StaffPromotionTierPerformanceReviewMinPct;
  performanceReviewQuarters?: StaffPromotionTierPerformanceReviewQuarters;
  notes?: StaffPromotionTierNotes;
}

export type StaffQuickCreatePassword = string | null;

/**
 * HR-02-21 (Angela, 24 / 26 Oct 2026) — Add Staff: the User information only.
 */
export interface StaffQuickCreate {
  /**
   * @minLength 1
   * @maxLength 120
   */
  name: string;
  outletId: string;
  onlineAccess?: boolean;
  password?: StaffQuickCreatePassword;
}

export type StaffReassignmentFromStaffId = string | null;

/**
 * SPEC-R3-08 — move one staff member's steps of a booking to another.

Narrower than ``staffAssignments``, and deliberately so: the calendar's
cross-staff drag knows only which column it left and which it landed in, not
the whole step→staff map. Every step currently held by ``fromStaffId`` moves;
steps held by anyone else (the other leg of a split treatment) do not.
``fromStaffId`` empty = the steps with no staff yet: a waitlist entry
dragged onto a staff column (OPS-09-04).
 */
export interface StaffReassignment {
  fromStaffId?: StaffReassignmentFromStaffId;
  toStaffId: string;
}

export type StaffReviewReviewedBy = string | null;

export type StaffReviewNotes = string | null;

export interface StaffReview {
  id: string;
  staffId: string;
  quarter: string;
  scorePct: number;
  reviewedAt: string;
  reviewedBy?: StaffReviewReviewedBy;
  notes?: StaffReviewNotes;
  createdAt: string;
  updatedAt: string;
}

export type StaffReviewCreateNotes = string | null;

export interface StaffReviewCreate {
  quarter: string;
  scorePct: number;
  notes?: StaffReviewCreateNotes;
}

export type StaffRole = typeof StaffRole[keyof typeof StaffRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffRole = {
  TRAINEE: 'TRAINEE',
  BEAUTICIAN_1: 'BEAUTICIAN_1',
  BEAUTICIAN_2: 'BEAUTICIAN_2',
  BEAUTICIAN_3: 'BEAUTICIAN_3',
  BEAUTICIAN_4: 'BEAUTICIAN_4',
  BEAUTICIAN_5: 'BEAUTICIAN_5',
  BEAUTICIAN_6: 'BEAUTICIAN_6',
  JUNIOR_MASTER: 'JUNIOR_MASTER',
  SENIOR_MASTER: 'SENIOR_MASTER',
  HEAD_MASTER: 'HEAD_MASTER',
  GOLKI_MASTER: 'GOLKI_MASTER',
  CONSULTANT: 'CONSULTANT',
  JUNIOR_CONSULTANT: 'JUNIOR_CONSULTANT',
  SENIOR_CONSULTANT: 'SENIOR_CONSULTANT',
  HEAD_CONSULTANT: 'HEAD_CONSULTANT',
  RECEPTIONIST: 'RECEPTIONIST',
  TRAINER: 'TRAINER',
  OFFICER: 'OFFICER',
} as const;

export type StaffSOPTrainingRecordPassedAt = string | null;

export type StaffSOPTrainingRecordNotes = string | null;

export type StaffSOPTrainingRecordUpdatedAt = string | null;

export interface StaffSOPTrainingRecord {
  id: string;
  number: number;
  name: string;
  appliesTo: string;
  testable: boolean;
  status: TrainingStatus;
  passedAt?: StaffSOPTrainingRecordPassedAt;
  notes?: StaffSOPTrainingRecordNotes;
  updatedAt?: StaffSOPTrainingRecordUpdatedAt;
  tracked: boolean;
}

export type StaffShiftNotes = string | null;

export type StaffShiftShiftTypeId = string | null;

export type StaffShiftShiftTypeName = string | null;

export type StaffShiftCategory = string | null;

export type StaffShiftLeaveType = string | null;

export type StaffShiftOutletId = string | null;

export interface StaffShift {
  id: string;
  staffId: string;
  date: string;
  startTime: string;
  endTime: string;
  isOff: boolean;
  notes?: StaffShiftNotes;
  shiftTypeId?: StaffShiftShiftTypeId;
  portion?: string;
  sequence?: number;
  shiftTypeName?: StaffShiftShiftTypeName;
  category?: StaffShiftCategory;
  leaveType?: StaffShiftLeaveType;
  outletId?: StaffShiftOutletId;
}

export type StaffShiftApplyShiftTypeId = string | null;

export type StaffShiftApplyStartTime = string | null;

export type StaffShiftApplyEndTime = string | null;

export type StaffShiftApplyIsOff = boolean | null;

export type StaffShiftApplyNotes = string | null;

export type StaffShiftApplyPortion = string | null;

export type StaffShiftApplyOutletId = string | null;

export interface StaffShiftApply {
  /** @minItems 1 */
  dates: string[];
  shiftTypeId?: StaffShiftApplyShiftTypeId;
  startTime?: StaffShiftApplyStartTime;
  endTime?: StaffShiftApplyEndTime;
  isOff?: StaffShiftApplyIsOff;
  notes?: StaffShiftApplyNotes;
  portion?: StaffShiftApplyPortion;
  outletId?: StaffShiftApplyOutletId;
}

export interface StaffShiftApplyDateResult {
  date: string;
  shift: StaffShift;
}

export interface StaffShiftBulkDeleteResponse {
  deletedCount: number;
}

export interface StaffShiftCopyMonth {
  /** @pattern ^\d{4}-(0[1-9]|1[0-2])$ */
  sourceMonth: string;
  /** @pattern ^\d{4}-(0[1-9]|1[0-2])$ */
  targetMonth: string;
}

export interface StaffShiftCopyToStaff {
  /** @minLength 1 */
  targetStaffId: string;
  /** @pattern ^\d{4}-(0[1-9]|1[0-2])$ */
  sourceMonth: string;
}

export type StaffShiftUpsertStartTime = string | null;

export type StaffShiftUpsertEndTime = string | null;

export type StaffShiftUpsertPortion = string | null;

export type StaffShiftUpsertOutletId = string | null;

export interface StaffShiftUpsert {
  date: string;
  startTime?: StaffShiftUpsertStartTime;
  endTime?: StaffShiftUpsertEndTime;
  isOff: boolean;
  applyToFutureWeeks?: boolean;
  portion?: StaffShiftUpsertPortion;
  outletId?: StaffShiftUpsertOutletId;
}

export interface StaffShiftUpsertResponse {
  shift: StaffShift;
  propagatedCount: number;
}

export interface StaffStepExclusion {
  staffId: string;
  stepId: string;
}

export type StaffStepExclusionRequestAction = typeof StaffStepExclusionRequestAction[keyof typeof StaffStepExclusionRequestAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffStepExclusionRequestAction = {
  exclude: 'exclude',
  include: 'include',
} as const;

export interface StaffStepExclusionRequest {
  staffId: string;
  stepId: string;
  action: StaffStepExclusionRequestAction;
}

export type StaffSummaryDob = string | null;

export type StaffSummaryProbationEndDate = string | null;

export type StaffSummaryPhone = string | null;

export type StaffSummaryPhotoUrl = string | null;

export type StaffSummaryDepartment = string | null;

export type StaffSummaryUser = UserSummary | null;

export type StaffSummaryUserEmail = string | null;

export interface StaffSummary {
  outletId: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
  employmentType: EmploymentType;
  startDate: string;
  dob?: StaffSummaryDob;
  isProbation?: boolean;
  probationEndDate?: StaffSummaryProbationEndDate;
  phone?: StaffSummaryPhone;
  photoUrl?: StaffSummaryPhotoUrl;
  preferredLang?: PreferredLanguage;
  isActive?: boolean;
  detailsNeeded?: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
  outlet: OutletSummary;
  department?: StaffSummaryDepartment;
  additionalOutlets?: StaffOutletAssignment[];
  certifiedTreatments?: StaffCertification[];
  user?: StaffSummaryUser;
  hasAccount: boolean;
  userEmail?: StaffSummaryUserEmail;
}

export interface StaffTrainingCounts {
  treatmentPassed: number;
  treatmentTotal: number;
  sopPassed: number;
  sopTotal: number;
  sopTestableTotal: number;
}

export type StaffTrainingMutationResponseTreatmentId = string | null;

export type StaffTrainingMutationResponseSopId = string | null;

export type StaffTrainingMutationResponsePassedAt = string | null;

export type StaffTrainingMutationResponseNotes = string | null;

export type StaffTrainingMutationResponseUpdatedBy = string | null;

export interface StaffTrainingMutationResponse {
  id: string;
  staffId: string;
  treatmentId?: StaffTrainingMutationResponseTreatmentId;
  sopId?: StaffTrainingMutationResponseSopId;
  status: TrainingStatus;
  passedAt?: StaffTrainingMutationResponsePassedAt;
  notes?: StaffTrainingMutationResponseNotes;
  updatedAt: string;
  updatedBy?: StaffTrainingMutationResponseUpdatedBy;
}

export interface StaffTrainingResponse {
  staff: StaffTrainingSubject;
  treatments?: StaffTreatmentTrainingRecord[];
  sops?: StaffSOPTrainingRecord[];
  counts: StaffTrainingCounts;
  promotionReadiness: StaffPromotionReadiness;
}

export interface StaffTrainingSubject {
  id: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
  startDate: string;
}

export type StaffTrainingUpdateKind = typeof StaffTrainingUpdateKind[keyof typeof StaffTrainingUpdateKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffTrainingUpdateKind = {
  treatment: 'treatment',
  sop: 'sop',
} as const;

export type StaffTrainingUpdateNotes = string | null;

export interface StaffTrainingUpdate {
  kind: StaffTrainingUpdateKind;
  targetId: string;
  status: TrainingStatus;
  notes?: StaffTrainingUpdateNotes;
}

export type StaffTreatmentTrainingRecordPassedAt = string | null;

export type StaffTreatmentTrainingRecordNotes = string | null;

export type StaffTreatmentTrainingRecordUpdatedAt = string | null;

export interface StaffTreatmentTrainingRecord {
  id: string;
  name: string;
  category: string;
  requiredRole: string;
  sequenceOrder: number;
  status: TrainingStatus;
  passedAt?: StaffTreatmentTrainingRecordPassedAt;
  notes?: StaffTreatmentTrainingRecordNotes;
  updatedAt?: StaffTreatmentTrainingRecordUpdatedAt;
  tracked: boolean;
}

export type StaffUpdateName = string | null;

export type StaffUpdateFullName = string | null;

export type StaffUpdateRole = StaffRole | null;

export type StaffUpdateSkillLevel = number | null;

export type StaffUpdateEmploymentType = EmploymentType | null;

export type StaffUpdateOutletId = string | null;

export type StaffUpdateOutletEffectiveDate = string | null;

export type StaffUpdateStartDate = string | null;

export type StaffUpdateDob = string | null;

export type StaffUpdateIsProbation = boolean | null;

export type StaffUpdateIsActive = boolean | null;

export type StaffUpdatePreferredLang = PreferredLanguage | null;

export type StaffUpdateAdditionalOutletIds = string[] | null;

export type StaffUpdatePhone = string | null;

export type StaffUpdatePhotoUrl = string | null;

export type StaffUpdateEmployeeId = string | null;

export interface StaffUpdate {
  name?: StaffUpdateName;
  fullName?: StaffUpdateFullName;
  role?: StaffUpdateRole;
  skillLevel?: StaffUpdateSkillLevel;
  employmentType?: StaffUpdateEmploymentType;
  outletId?: StaffUpdateOutletId;
  outletEffectiveDate?: StaffUpdateOutletEffectiveDate;
  startDate?: StaffUpdateStartDate;
  dob?: StaffUpdateDob;
  isProbation?: StaffUpdateIsProbation;
  isActive?: StaffUpdateIsActive;
  preferredLang?: StaffUpdatePreferredLang;
  additionalOutletIds?: StaffUpdateAdditionalOutletIds;
  phone?: StaffUpdatePhone;
  photoUrl?: StaffUpdatePhotoUrl;
  employeeId?: StaffUpdateEmployeeId;
}

export type StatusChangeCreateFromDate = string | null;

export type StatusChangeCreateReason = string | null;

/**
 * Make a treatment or a product Active / Inactive (INV-02-03, INV-12-05).
 */
export interface StatusChangeCreate {
  /** @pattern ^(TREATMENT|PRODUCT)$ */
  itemType: string;
  /** @minLength 1 */
  itemId: string;
  isActive: boolean;
  fromDate?: StatusChangeCreateFromDate;
  reason?: StatusChangeCreateReason;
}

export type StatusChangeResponseReason = string | null;

export type StatusChangeResponseChangedByName = string | null;

/**
 * One row of the status history (INV-02-08).
 */
export interface StatusChangeResponse {
  id: string;
  itemType: string;
  itemId: string;
  itemName: string;
  isActive: boolean;
  fromDate: string;
  reason: StatusChangeResponseReason;
  changedByName: StatusChangeResponseChangedByName;
  createdAt: string;
}

export type StatusHistoryEntryOldStatus = string | null;

export type StatusHistoryEntryChangedBy = string | null;

export type StatusHistoryEntryReason = string | null;

export interface StatusHistoryEntry {
  id: string;
  appointmentId: string;
  oldStatus?: StatusHistoryEntryOldStatus;
  newStatus: string;
  changedAt: string;
  changedBy?: StatusHistoryEntryChangedBy;
  reason?: StatusHistoryEntryReason;
}

export type StatusReportChangeRowSku = string | null;

export type StatusReportChangeRowReason = string | null;

export type StatusReportChangeRowChangedByName = string | null;

/**
 * One status change in the period (INV-12-09, 'Status changes').
 */
export interface StatusReportChangeRow {
  id: string;
  itemType: string;
  itemId: string;
  name: string;
  sku: StatusReportChangeRowSku;
  fromDate: string;
  isActive: boolean;
  reason: StatusReportChangeRowReason;
  changedByName: StatusReportChangeRowChangedByName;
}

export type StatusReportCurrentRowSku = string | null;

export type StatusReportCurrentRowCategory = string | null;

export type StatusReportCurrentRowReason = string | null;

export type StatusReportCurrentRowChangedByName = string | null;

/**
 * One treatment or product with its status right now (INV-12-09, 'Current status').
 */
export interface StatusReportCurrentRow {
  itemType: string;
  itemId: string;
  name: string;
  sku: StatusReportCurrentRowSku;
  category: StatusReportCurrentRowCategory;
  isActive: boolean;
  since: string;
  daysInStatus: number;
  reason: StatusReportCurrentRowReason;
  changedByName: StatusReportCurrentRowChangedByName;
}

export interface StatusReportResponse {
  activeCount: number;
  inactiveCount: number;
  changeCount: number;
  current: StatusReportCurrentRow[];
  changes: StatusReportChangeRow[];
}

/**
 * GET /dashboard/status-strip — the one-line HQ strip (DSH-02-03 / DSH-08-02 /
DSH-10-06). Every item is a count; 0 is shown as 0.
 */
export interface StatusStripResponse {
  mcToday: number;
  onLeaveToday: number;
  approvalsWaitingHq: number;
  dailyCloseYesterday: DailyCloseStatus;
  openComplaintsRequests: number;
  xeroSyncWaiting: number;
}

/**
 * SAL-16-12 / OPS-27-08 — one of the staff who performed a step together.
The first (``position`` 0) is the step's ``staffId``.
 */
export interface StepPerformerSummary {
  staffId: string;
  name: string;
  position?: number;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StepRatingInputRating = {...OverallRating,  DISSATISFIED: 'DISSATISFIED',
  NEUTRAL: 'NEUTRAL',
  SATISFIED: 'SATISFIED',
  VERY_SATISFIED: 'VERY_SATISFIED',
} as const
export type StepRatingInputComments = string | null;

export interface StepRatingInput {
  appointmentStepId: string;
  rating: typeof StepRatingInputRating[keyof typeof StepRatingInputRating] ;
  comments?: StepRatingInputComments;
}

export type StepRatingResponseComments = string | null;

export type StepRatingResponseId = string | null;

export type StepRatingResponseAppointmentStepId = string | null;

export type StepRatingResponseRatedAt = string | null;

export interface StepRatingResponse {
  rating: string;
  comments?: StepRatingResponseComments;
  id?: StepRatingResponseId;
  appointmentStepId?: StepRatingResponseAppointmentStepId;
  ratedAt?: StepRatingResponseRatedAt;
}

export type StepResponseStaffId = string | null;

export type StepResponseCompletedAt = string | null;

export type StepResponseCompletedBy = string | null;

export type StepResponseActualStartTime = string | null;

export type StepResponseActualEndTime = string | null;

export type StepResponseStartedBy = string | null;

export type StepResponseNotPerformedAt = string | null;

export type StepResponseNotPerformedBy = string | null;

export type StepResponseNotPerformedReason = string | null;

export type StepResponseOriginalStaffId = string | null;

export type StepResponseStep = ProgramStepResponse | null;

export type StepResponseStaff = AppointmentStepStaffSummary | null;

export type StepResponseOriginalStaff = OriginalStaffSummary | null;

export type StepResponseStepRating = StepRatingResponse | null;

export interface StepResponse {
  id: string;
  appointmentId: string;
  stepId: string;
  staffId?: StepResponseStaffId;
  startTime: string;
  endTime: string;
  status: string;
  completedAt?: StepResponseCompletedAt;
  completedBy?: StepResponseCompletedBy;
  actualStartTime?: StepResponseActualStartTime;
  actualEndTime?: StepResponseActualEndTime;
  startedBy?: StepResponseStartedBy;
  notPerformedAt?: StepResponseNotPerformedAt;
  notPerformedBy?: StepResponseNotPerformedBy;
  notPerformedReason?: StepResponseNotPerformedReason;
  originalStaffId?: StepResponseOriginalStaffId;
  step?: StepResponseStep;
  staff?: StepResponseStaff;
  performers?: StepPerformerSummary[];
  originalStaff?: StepResponseOriginalStaff;
  stepRating?: StepResponseStepRating;
}

export type StepStaffSwapStaffId = string | null;

export type StepStaffSwapStaffIds = string[] | null;

/**
 * Who performs a step: ``staffIds`` (one or more — the first is the primary)
or, as before, a single ``staffId``.
 */
export interface StepStaffSwap {
  staffId?: StepStaffSwapStaffId;
  staffIds?: StepStaffSwapStaffIds;
}

export interface StepStaffSwapResponse {
  step: StepResponse;
}

export type StepStatus = typeof StepStatus[keyof typeof StepStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StepStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
} as const;

export type StepStatusUpdateCompletedBy = string | null;

export type StepStatusUpdateStartedBy = string | null;

export type StepStatusUpdateReason = string | null;

export type StepStatusUpdateHistoryNote = string | null;

export type StepStatusUpdateStaffIds = string[] | null;

export interface StepStatusUpdate {
  status: StepStatus;
  completedBy?: StepStatusUpdateCompletedBy;
  startedBy?: StepStatusUpdateStartedBy;
  reason?: StepStatusUpdateReason;
  historyNote?: StepStatusUpdateHistoryNote;
  staffIds?: StepStatusUpdateStaffIds;
}

export interface StepStatusUpdateResponse {
  step: StepResponse;
  progress: ProgressResponse;
  appointmentStatus: string;
}

export type StockAdjustRequestReason = string | null;

export type StockAdjustRequestReference = string | null;

/**
 * Correct a batch's quantity — spec §7.2.

``reason`` is typed as optional here and required by the service, which is
not an oversight: enforcing it in ``InventoryService`` yields the readable
``{"error": "..."}`` 422 the frontend already renders, and puts the rule in
the one place that also covers ``WRITE_OFF`` movements written by later
slices. An unexplained stock correction is exactly what an audit trail exists
to prevent, so it is refused rather than defaulted.
 */
export interface StockAdjustRequest {
  /** @minLength 1 */
  batchId: string;
  qtyDelta: number;
  reason?: StockAdjustRequestReason;
  reference?: StockAdjustRequestReference;
}

export type StockBatchResponseBatchCode = string | null;

export type StockBatchResponseExpiryDate = string | null;

export type StockBatchResponseUnitCost = string | null;

export type StockBatchResponseDocumentNumber = string | null;

/**
 * One delivery of one product at one location.

``expiryDate`` is nullable and will be null for every row on day one — per
C4 Studio Manager has no expiry field, so the import brings no dates and they
are hand-typed afterwards through ``PATCH /inventory/batches/{id}``. Any
surface reading this field must handle null as *unknown*, never as *fine*.

⛔ ``unitCost`` is the **supplier purchase price**, not a customer-facing
figure, and it is REDACTED (sent as null) inside ``GET /inventory/stock`` for
callers without ``inventory.manage`` — see ``_batch_response`` in
``app/api/inventory/router.py`` for why that read is otherwise open to every
logged-in user including THERAPIST. The three write endpoints echo the real
value because they are gated on ``inventory.manage`` already. So a null here
means *"no cost recorded, or not yours to see"*; do not render it as a
positive statement about the batch.
 */
export interface StockBatchResponse {
  id: string;
  productId: string;
  stockLocationId: string;
  batchCode: StockBatchResponseBatchCode;
  expiryDate: StockBatchResponseExpiryDate;
  receivedDate: string;
  qtyOnHand: number;
  unitCost: StockBatchResponseUnitCost;
  createdAt: string;
  updatedAt: string;
  documentNumber?: StockBatchResponseDocumentNumber;
}

export type StockBatchUpdateBatchCode = string | null;

export type StockBatchUpdateExpiryDate = string | null;

/**
 * ⚠ The hand-typing path (C4) — spec §7.2.

This is how every expiry date in the system gets there. Studio Manager has
none, so after the catalogue import Angela and Lisa type them in one batch at
a time. It must therefore accept setting ``expiryDate`` on a batch that
currently holds NULL, which is the normal case rather than the edge case.

Both fields are optional AND nullable, so the service applies
``exclude_unset``: an omitted key means "leave alone" and an explicit null
means "clear". Sending only ``expiryDate`` must not wipe ``batchCode``.

⛔ Quantity is deliberately absent. Editing ``qtyOnHand`` here would mutate
stock with no ``StockMovement`` behind it and break the module's core
invariant — quantity changes go through
``POST /inventory/stock/adjust``, which requires a reason.
 */
export interface StockBatchUpdate {
  batchCode?: StockBatchUpdateBatchCode;
  expiryDate?: StockBatchUpdateExpiryDate;
}

/**
 * Live stock availability check for the POS product picker.

Non-locking: calls ``pick_fefo`` without ``FOR UPDATE`` so a checkout form
can poll without holding rows open.
 */
export interface StockCheckRequest {
  /** @minLength 1 */
  locationId: string;
  /** @minLength 1 */
  productId: string;
  /** */
  qty: number;
}

/**
 * Whether FEFO can cover the requested quantity at the location.
 */
export interface StockCheckResponse {
  available: boolean;
  productId: string;
  locationId: string;
  qty: number;
}

export type StockDisposeRequestRemarks = string | null;

/**
 * Ask to dispose several products at once — one PENDING DSP- document (INV-06-12/13).

Nothing leaves stock until HQ confirms the request.
 */
export interface StockDisposeRequest {
  /** @minLength 1 */
  locationId: string;
  documentDate: string;
  /** @minItems 1 */
  lines: DisposeLineCreate[];
  remarks?: StockDisposeRequestRemarks;
}

export type StockDocumentLineResponseMovementId = string | null;

export type StockDocumentLineResponseProductSku = string | null;

export type StockDocumentLineResponseStockBatchId = string | null;

export type StockDocumentLineResponseBatchCode = string | null;

export type StockDocumentLineResponseExpiryDate = string | null;

export type StockDocumentLineResponseReason = string | null;

/**
 * One line of a document, with product and batch resolved.

A confirmed document's lines are its movements (``movementId`` set). A
Dispose still PENDING (or REJECTED) shows the rows as asked: ``movementId``
null, ``stockBatchId`` null when 'earliest expiry first' was chosen, and
``qtyDelta`` already negative (what WOULD leave).
 */
export interface StockDocumentLineResponse {
  movementId: StockDocumentLineResponseMovementId;
  productId: string;
  productName: string;
  productSku: StockDocumentLineResponseProductSku;
  unit: string;
  stockBatchId: StockDocumentLineResponseStockBatchId;
  batchCode: StockDocumentLineResponseBatchCode;
  expiryDate: StockDocumentLineResponseExpiryDate;
  qtyDelta: number;
  reason: StockDocumentLineResponseReason;
  createdAt: string;
}

/**
 * Documents of one kind / status (the pending Dispose requests), newest first.

``canDecide`` says whether the caller (HQ) may Confirm / Reject them.
 */
export interface StockDocumentListResponse {
  documents: StockDocumentResponse[];
  total: number;
  canDecide: boolean;
}

/**
 * HQ rejects a Dispose request — the reason is required.
 */
export interface StockDocumentRejectRequest {
  /**
   * @minLength 1
   * @maxLength 500
   */
  reason: string;
}

export type StockDocumentResponseStaffId = string | null;

export type StockDocumentResponseStaffName = string | null;

export type StockDocumentResponseSupplier = string | null;

export type StockDocumentResponseReference = string | null;

export type StockDocumentResponseUsedFor = string | null;

export type StockDocumentResponseRemarks = string | null;

export type StockDocumentResponseRevokedAt = string | null;

export type StockDocumentResponseRevokesDocumentId = string | null;

export type StockDocumentResponseRevokesDocumentNumber = string | null;

export type StockDocumentResponseStatus = string | null;

export type StockDocumentResponseDecidedAt = string | null;

export type StockDocumentResponseDecidedByName = string | null;

export type StockDocumentResponseRejectReason = string | null;

/**
 * A numbered stock document (RCV- / USG- / DSP- / ADJ-) with its lines.

``kind`` is 'RECEIVE' | 'USAGE' | 'DISPOSE' | 'ADJUST'. For a Usage,
``revokedAt`` / ``revokedDocumentNumber`` are set on the ORIGINAL once it has
been revoked, and ``revokesDocumentNumber`` on the revoking document.
 */
export interface StockDocumentResponse {
  id: string;
  number: string;
  kind: string;
  stockLocationId: string;
  stockLocationName: string;
  documentDate: string;
  staffId: StockDocumentResponseStaffId;
  staffName: StockDocumentResponseStaffName;
  supplier: StockDocumentResponseSupplier;
  reference: StockDocumentResponseReference;
  usedFor: StockDocumentResponseUsedFor;
  remarks: StockDocumentResponseRemarks;
  revokedAt: StockDocumentResponseRevokedAt;
  revokesDocumentId: StockDocumentResponseRevokesDocumentId;
  revokesDocumentNumber: StockDocumentResponseRevokesDocumentNumber;
  status: StockDocumentResponseStatus;
  decidedAt: StockDocumentResponseDecidedAt;
  decidedByName: StockDocumentResponseDecidedByName;
  rejectReason: StockDocumentResponseRejectReason;
  lines: StockDocumentLineResponse[];
  createdAt: string;
}

export type StockLocationResponseOutletId = string | null;

/**
 * A place that holds stock. Read-only for P2.

There is deliberately no create/update payload: locations are seeded
(`backend/scripts/seed_stock_locations.py`) rather than user-managed. Adding
an outlet's stock location is a data operation done once, and an editable
`code` would let someone rename OFFICE out from under the seed's idempotency
check.
 */
export interface StockLocationResponse {
  id: string;
  name: string;
  code: string;
  kind: string;
  outletId: StockLocationResponseOutletId;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export type StockOnHandResponseProductSku = string | null;

export type StockOnHandResponseEarliestExpiryDate = string | null;

export type StockOnHandResponseMinQty = number | null;

/**
 * One (product x location) rollup **plus the batch rows behind the number**.

The batches are not an optional expansion — they are shipped with every row
on purpose. Stock is a set of batch rows, not a number on a product (C3), so
a rollup without its breakdown is a figure nobody can check. The stock page
(§8.2) expands a row without a second request, and a discrepancy between
``qtyOnHand`` and ``sum(batches[].qtyOnHand)`` is visible in the response
itself rather than requiring two calls to detect.

``earliestExpiryDate`` is the earliest **non-null** expiry among the batches,
or null when nothing in the row is dated. It is a display convenience for
§8.2's row indicator; the alert thresholds that consume it are P3.
 */
export interface StockOnHandResponse {
  productId: string;
  productName: string;
  productSku: StockOnHandResponseProductSku;
  unit: string;
  stockLocationId: string;
  stockLocationName: string;
  stockLocationCode: string;
  qtyOnHand: number;
  batchCount: number;
  earliestExpiryDate: StockOnHandResponseEarliestExpiryDate;
  batches: StockBatchResponse[];
  minQty: StockOnHandResponseMinQty;
  qtyInTransit?: number;
}

export type StockReceiveRequestBatchCode = string | null;

export type StockReceiveRequestExpiryDate = string | null;

export type StockReceiveRequestUnitCost = number | string | null;

export type StockReceiveRequestSupplier = string | null;

export type StockReceiveRequestDeliveryRef = string | null;

/**
 * Receive a delivery — spec §7.2.

⛔ Every receive creates a **new** ``StockBatch`` row. It never merges into an
existing batch, not even when productId + locationId + expiryDate all match.
Two deliveries are two batches: that is the whole point of C3, and merging
would collapse the ``receivedDate`` granularity that FEFO's tie-break (§5)
depends on.

``expiryDate`` is optional because the day-one reality is that nobody knows
it yet (C4). A receive with no date is a legitimate, expected write.
 */
export interface StockReceiveRequest {
  /** @minLength 1 */
  locationId: string;
  /** @minLength 1 */
  productId: string;
  /** */
  qty: number;
  batchCode?: StockReceiveRequestBatchCode;
  expiryDate?: StockReceiveRequestExpiryDate;
  receivedDate: string;
  unitCost?: StockReceiveRequestUnitCost;
  supplier?: StockReceiveRequestSupplier;
  deliveryRef?: StockReceiveRequestDeliveryRef;
  supplierDeliveryConfirmed?: boolean;
}

export type StockRequestCreateRemarks = string | null;

/**
 * Request Stock (INV-07-03): For (receiving outlet) · From · items · Remarks.
 */
export interface StockRequestCreate {
  /** @minLength 1 */
  forLocationId: string;
  /** @minLength 1 */
  fromLocationId: string;
  /** @minItems 1 */
  lines: StockRequestLineCreate[];
  remarks?: StockRequestCreateRemarks;
}

export interface StockRequestLineCreate {
  /** @minLength 1 */
  productId: string;
  /** */
  qty: number;
}

export type StockRequestLineResponseProductSku = string | null;

export interface StockRequestLineResponse {
  id: string;
  productId: string;
  productName: string;
  productSku: StockRequestLineResponseProductSku;
  unit: string;
  qty: number;
}

export interface StockRequestListResponse {
  requests: StockRequestResponse[];
  total: number;
}

export type StockRequestResponseRequestedById = string | null;

export type StockRequestResponseRequestedByName = string | null;

export type StockRequestResponseRemarks = string | null;

export type StockRequestResponseDecidedAt = string | null;

export type StockRequestResponseRejectReason = string | null;

export type StockRequestResponseTransferId = string | null;

export type StockRequestResponseTransferNumber = string | null;

export type StockRequestResponseTransferStatus = string | null;

/**
 * RQ-<outlet>-xxxxxx. 'REQUESTED' | 'APPROVED' | 'REJECTED'; the transfer
status (when approved) tells the rest of the story (INV-07-03 step 5).
 */
export interface StockRequestResponse {
  id: string;
  number: string;
  status: string;
  forLocationId: string;
  forLocationName: string;
  fromLocationId: string;
  fromLocationName: string;
  requestedById: StockRequestResponseRequestedById;
  requestedByName: StockRequestResponseRequestedByName;
  remarks: StockRequestResponseRemarks;
  decidedAt: StockRequestResponseDecidedAt;
  rejectReason: StockRequestResponseRejectReason;
  transferId: StockRequestResponseTransferId;
  transferNumber: StockRequestResponseTransferNumber;
  transferStatus: StockRequestResponseTransferStatus;
  lines: StockRequestLineResponse[];
  createdAt: string;
}

/**
 * INV-11-04: stock at the end of a day, at cost and at selling price before GST.

HQ only (cost prices, INV-11-08). Rows without a price are listed and left
out of that total.
 */
export interface StockValueResponse {
  asAt: string;
  rows: StockValueRow[];
  totals: StockValueTotal[];
}

export type StockValueRowProductSku = string | null;

export type StockValueRowCostPrice = string | null;

export type StockValueRowCostValue = string | null;

export type StockValueRowSellingPrice = string | null;

export type StockValueRowSellingValue = string | null;

/**
 * INV-11-04: one product at one outlet at the end of the chosen day.
 */
export interface StockValueRow {
  productId: string;
  productName: string;
  productSku: StockValueRowProductSku;
  unit: string;
  stockLocationId: string;
  stockLocationName: string;
  qty: number;
  qtyInTransit: number;
  costPrice: StockValueRowCostPrice;
  costValue: StockValueRowCostValue;
  sellingPrice: StockValueRowSellingPrice;
  sellingValue: StockValueRowSellingValue;
}

export type StockValueTotalStockLocationId = string | null;

export type StockValueTotalStockLocationName = string | null;

/**
 * Totals of one outlet, or of every outlet (stockLocationId null).
 */
export interface StockValueTotal {
  stockLocationId: StockValueTotalStockLocationId;
  stockLocationName: StockValueTotalStockLocationName;
  productCount: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  costValue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  sellingValue: string;
  noCostCount: number;
  noPriceCount: number;
}

export type StocktakeCountLineCountedQty = number | null;

export type StocktakeCountLineReason = string | null;

export interface StocktakeCountLine {
  /** @minLength 1 */
  lineId: string;
  countedQty?: StocktakeCountLineCountedQty;
  reason?: StocktakeCountLineReason;
}

export interface StocktakeCountsRequest {
  /** @minItems 1 */
  lines: StocktakeCountLine[];
}

export type StocktakeCreateCategory = string | null;

/**
 * Start a stocktake (INV-09-03): Outlet · Count date · Products (All, or one category).
 */
export interface StocktakeCreate {
  /** @minLength 1 */
  locationId: string;
  countDate: string;
  category?: StocktakeCreateCategory;
}

export type StocktakeLineResponseProductSku = string | null;

export type StocktakeLineResponseCountedQty = number | null;

export type StocktakeLineResponseDifference = number | null;

export type StocktakeLineResponseReason = string | null;

/**
 * Product · System qty · Moved since start · Expected · Counted · Difference · Reason.
 */
export interface StocktakeLineResponse {
  id: string;
  productId: string;
  productName: string;
  productSku: StocktakeLineResponseProductSku;
  unit: string;
  systemQty: number;
  movedSinceStart: number;
  expected: number;
  countedQty: StocktakeLineResponseCountedQty;
  difference: StocktakeLineResponseDifference;
  reason: StocktakeLineResponseReason;
}

export interface StocktakeListResponse {
  stocktakes: StocktakeResponse[];
  total: number;
}

export type StocktakeResponseCategory = string | null;

export type StocktakeResponseStartedById = string | null;

export type StocktakeResponseStartedByName = string | null;

export type StocktakeResponsePostedAt = string | null;

export type StocktakeResponsePostedByName = string | null;

export type StocktakeResponseCancelledAt = string | null;

/**
 * ST-xxxxxx. 'COUNTING' | 'COMPLETED' | 'CANCELLED'.
 */
export interface StocktakeResponse {
  id: string;
  number: string;
  status: string;
  stockLocationId: string;
  stockLocationName: string;
  countDate: string;
  category: StocktakeResponseCategory;
  startedById: StocktakeResponseStartedById;
  startedByName: StocktakeResponseStartedByName;
  startedAt: string;
  postedAt: StocktakeResponsePostedAt;
  postedByName: StocktakeResponsePostedByName;
  cancelledAt: StocktakeResponseCancelledAt;
  productCount: number;
  countedCount: number;
  differenceCount: number;
  netDifference: number;
  lines: StocktakeLineResponse[];
}

export interface SuccessResponse {
  success: boolean;
}

export type SurveyChangeBefore = string | boolean | null;

export type SurveyChangeAfter = string | boolean | null;

export interface SurveyChange {
  field: string;
  before?: SurveyChangeBefore;
  after?: SurveyChangeAfter;
}

export type SurveyHistoryEntryEditedByName = string | null;

/**
 * One saved change of the survey (CUS-12-12): who, when, from where.
 */
export interface SurveyHistoryEntry {
  editedAt: string;
  editedByName?: SurveyHistoryEntryEditedByName;
  source: string;
  changes?: SurveyChange[];
}

export interface SurveyHistoryResponse {
  items: SurveyHistoryEntry[];
}

export type TabletDeviceSessionOutOutletName = string | null;

export type TabletDeviceSessionOutSessionAnyOf = { [key: string]: unknown };

export type TabletDeviceSessionOutSession = TabletDeviceSessionOutSessionAnyOf | null;

/**
 * What the tablet may know: its own name, its outlet, and the one form
sent to it (published content + the customer's name, contact number and
under-18 flag — never the date of birth or anything else on the record).
 */
export interface TabletDeviceSessionOut {
  tabletName: string;
  outletName?: TabletDeviceSessionOutOutletName;
  session?: TabletDeviceSessionOutSession;
}

export type TabletFormSessionOutTabletName = string | null;

export type TabletFormSessionOutFormTemplateName = string | null;

export type TabletFormSessionOutCustomerId = string | null;

export type TabletFormSessionOutCustomerName = string | null;

export type TabletFormSessionOutStaffId = string | null;

export type TabletFormSessionOutOutletId = string | null;

export type TabletFormSessionOutOutletName = string | null;

export type TabletFormSessionOutFormResponseId = string | null;

export interface TabletFormSessionOut {
  id: string;
  tabletId: string;
  tabletName?: TabletFormSessionOutTabletName;
  formTemplateId: string;
  formTemplateName?: TabletFormSessionOutFormTemplateName;
  customerId?: TabletFormSessionOutCustomerId;
  customerName?: TabletFormSessionOutCustomerName;
  staffId?: TabletFormSessionOutStaffId;
  outletId?: TabletFormSessionOutOutletId;
  outletName?: TabletFormSessionOutOutletName;
  sentById: string;
  status: string;
  formResponseId?: TabletFormSessionOutFormResponseId;
  expiresAt: string;
  createdAt: string;
}

export type TabletOutOutletName = string | null;

export type TabletOutPairedAt = string | null;

export type TabletOutLastSeenAt = string | null;

export type TabletOutRevokedAt = string | null;

export type TabletOutPairingExpiresAt = string | null;

export interface TabletOut {
  id: string;
  outletId: string;
  outletName?: TabletOutOutletName;
  name: string;
  state: string;
  pairedAt?: TabletOutPairedAt;
  lastSeenAt?: TabletOutLastSeenAt;
  revokedAt?: TabletOutRevokedAt;
  pairingExpiresAt?: TabletOutPairingExpiresAt;
  createdAt: string;
}

export interface TabletPairRequest {
  code: string;
}

export type TabletPairResultOutletName = string | null;

/**
 * The device token, shown once. The device keeps it; the server keeps a hash.
 */
export interface TabletPairResult {
  token: string;
  tabletId: string;
  tabletName: string;
  outletId: string;
  outletName?: TabletPairResultOutletName;
}

export interface TabletRegister {
  outletId: string;
  name: string;
}

/**
 * The one response that carries the pairing code — shown to HQ once; only
its hash is stored.
 */
export interface TabletRegistered {
  tablet: TabletOut;
  pairingCode: string;
  pairingExpiresAt: string;
}

export type TabletSendFormCustomerId = string | null;

export type TabletSendFormStaffId = string | null;

export interface TabletSendForm {
  formTemplateId: string;
  outletId: string;
  customerId?: TabletSendFormCustomerId;
  staffId?: TabletSendFormStaffId;
}

export type TabletStatusOutOutletName = string | null;

export type TabletStatusOutTabletName = string | null;

/**
 * GEN-06-13 — is a tablet connected at this outlet right now?
 */
export interface TabletStatusOut {
  outletId: string;
  outletName?: TabletStatusOutOutletName;
  connected: boolean;
  tabletName?: TabletStatusOutTabletName;
}

export type TabletSubmitResponses = { [key: string]: unknown };

export type TabletSubmitCustomerSignature = string | null;

export type TabletSubmitStaffSignature = string | null;

export interface TabletSubmit {
  responses?: TabletSubmitResponses;
  customerSignature?: TabletSubmitCustomerSignature;
  staffSignature?: TabletSubmitStaffSignature;
}

/**
 * DSH-09-01 tab 3 — Completed: history by day.
 */
export interface TaskHistoryResponse {
  tasks: DeskTask[];
}

export type TaxCreateRatePercent = number | string | null;

export interface TaxCreate {
  name: string;
  ratePercent?: TaxCreateRatePercent;
  enabled?: boolean;
  taxType?: string;
  outletIds: string[];
  newRates?: TaxRateIn[];
}

export interface TaxListResponse {
  items: TaxResponse[];
}

export type TaxRateInEffectiveFrom = string | null;

export type TaxRateInRatePercent = number | string | null;

/**
 * One 'New tax rates' row of the Edit / New Tax window (SAL-39-03). Both
empty = an empty row, ignored; one of the two = refused (SAL-39-05).
 */
export interface TaxRateIn {
  effectiveFrom?: TaxRateInEffectiveFrom;
  ratePercent?: TaxRateInRatePercent;
}

export interface TaxRateOut {
  effectiveFrom: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  ratePercent: string;
}

export interface TaxResponse {
  id: string;
  name: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  ratePercent: string;
  enabled: boolean;
  taxType: string;
  sortOrder: number;
  outlets: OutletBrief[];
  rates?: TaxRateOut[];
  onSavedInvoices?: boolean;
}

export type TaxUpdateName = string | null;

export type TaxUpdateRatePercent = number | string | null;

export type TaxUpdateEnabled = boolean | null;

export type TaxUpdateTaxType = string | null;

export type TaxUpdateOutletIds = string[] | null;

export interface TaxUpdate {
  name?: TaxUpdateName;
  ratePercent?: TaxUpdateRatePercent;
  enabled?: TaxUpdateEnabled;
  taxType?: TaxUpdateTaxType;
  outletIds?: TaxUpdateOutletIds;
  newRates?: TaxRateIn[];
  replaceFutureRates?: boolean;
}

export type TemplateCreateSuggestedFor = LeadListKey | null;

export type TemplateCreateValidMonth = string | null;

export type TemplateCreateNote = string | null;

export interface TemplateCreate {
  /**
   * @minLength 1
   * @maxLength 160
   */
  name: string;
  situation: Situation;
  gender?: TemplateGender;
  includesDate?: boolean;
  suggestedFor?: TemplateCreateSuggestedFor;
  suggestedOrder?: number;
  validMonth?: TemplateCreateValidMonth;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  textWp: string;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  textSv: string;
  /** @maxItems 10 */
  pictureIds?: string[];
  note?: TemplateCreateNote;
}

export type TemplateGender = typeof TemplateGender[keyof typeof TemplateGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateGender = {
  F: 'F',
  M: 'M',
  ANY: 'ANY',
} as const;

export interface TemplateListResponse {
  items?: TemplateOut[];
  placeholders?: string[];
}

export type TemplateMetaUpdateName = string | null;

export type TemplateMetaUpdateSituation = Situation | null;

export type TemplateMetaUpdateGender = TemplateGender | null;

export type TemplateMetaUpdateIncludesDate = boolean | null;

export type TemplateMetaUpdateSuggestedFor = LeadListKey | null;

export type TemplateMetaUpdateSuggestedOrder = number | null;

export type TemplateMetaUpdateValidMonth = string | null;

export type TemplateMetaUpdatePurpose = TemplatePurpose | null;

export type TemplateMetaUpdateInUse = boolean | null;

/**
 * The switches that need no new version: name, situation, gender,
suggested list and order, month tag, In use.
 */
export interface TemplateMetaUpdate {
  name?: TemplateMetaUpdateName;
  situation?: TemplateMetaUpdateSituation;
  gender?: TemplateMetaUpdateGender;
  includesDate?: TemplateMetaUpdateIncludesDate;
  suggestedFor?: TemplateMetaUpdateSuggestedFor;
  clearSuggestedFor?: boolean;
  suggestedOrder?: TemplateMetaUpdateSuggestedOrder;
  validMonth?: TemplateMetaUpdateValidMonth;
  clearValidMonth?: boolean;
  purpose?: TemplateMetaUpdatePurpose;
  clearPurpose?: boolean;
  inUse?: TemplateMetaUpdateInUse;
}

export type TemplateOutSuggestedFor = LeadListKey | null;

export type TemplateOutValidMonth = string | null;

export type TemplateOutPurpose = TemplatePurpose | null;

export type TemplateOutCurrent = TemplateVersionOut | null;

export type TemplateOutDraft = TemplateVersionOut | null;

export interface TemplateOut {
  id: string;
  name: string;
  situation: Situation;
  gender: TemplateGender;
  includesDate?: boolean;
  suggestedFor?: TemplateOutSuggestedFor;
  suggestedOrder?: number;
  validMonth?: TemplateOutValidMonth;
  purpose?: TemplateOutPurpose;
  inUse?: boolean;
  retired?: boolean;
  offered?: boolean;
  current?: TemplateOutCurrent;
  draft?: TemplateOutDraft;
  versions?: TemplateVersionOut[];
  createdAt: string;
  updatedAt: string;
}

export type TemplatePreviewOutletCode = string | null;

/**
 * The finished message against a real customer (LEA-22-08).
 */
export interface TemplatePreview {
  text: string;
  outletCode?: TemplatePreviewOutletCode;
  unfilled?: string[];
  pictures?: PictureOut[];
}

/**
 * A special use HQ picks one template for (LEA-30-02).
 */
export type TemplatePurpose = typeof TemplatePurpose[keyof typeof TemplatePurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplatePurpose = {
  RETURNING_CUSTOMER: 'RETURNING_CUSTOMER',
} as const;

export type TemplateVersionCreateNote = string | null;

/**
 * A new draft: the text and pictures (LEA-22-04, LEA-22-09).
 */
export interface TemplateVersionCreate {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  textWp: string;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  textSv: string;
  /** @maxItems 10 */
  pictureIds?: string[];
  note?: TemplateVersionCreateNote;
}

export type TemplateVersionOutWrittenBy = string | null;

export type TemplateVersionOutWrittenByUserId = string | null;

export type TemplateVersionOutConfirmedBy = string | null;

export type TemplateVersionOutConfirmedAt = string | null;

export type TemplateVersionOutNote = string | null;

export interface TemplateVersionOut {
  id: string;
  textWp: string;
  textSv: string;
  pictureIds?: string[];
  status: VersionStatus;
  writtenBy?: TemplateVersionOutWrittenBy;
  writtenByUserId?: TemplateVersionOutWrittenByUserId;
  writtenAt: string;
  confirmedBy?: TemplateVersionOutConfirmedBy;
  confirmedAt?: TemplateVersionOutConfirmedAt;
  note?: TemplateVersionOutNote;
  missingPictures?: string[];
}

export type TherapistTreatmentsOutletCode = string | null;

export interface TherapistTreatments {
  staffId: string;
  name: string;
  outletCode?: TherapistTreatmentsOutletCode;
  treatments: number;
}

export type TicketChangeById = string | null;

export type TicketChangeByName = string | null;

export type TicketChangeOld = string | null;

export type TicketChangeNew = string | null;

/**
 * One line of the change log (HR-15-08): who changed Resolution or Status,
when, from what to what.
 */
export interface TicketChange {
  at: string;
  byId?: TicketChangeById;
  byName?: TicketChangeByName;
  field: string;
  old?: TicketChangeOld;
  new?: TicketChangeNew;
}

export type TicketCustomerRefPhone = string | null;

/**
 * Minimal linked-customer stub. Deliberately not the full customer payload —
the list renders a name and the drawer needs an id to re-select.
 */
export interface TicketCustomerRef {
  id: string;
  name: string;
  phone?: TicketCustomerRefPhone;
}

/**
 * Minimal staff stub, used for both `staff` and `resolvedBy`.
 */
export interface TicketStaffRef {
  id: string;
  name: string;
}

export type TicketStatus = typeof TicketStatus[keyof typeof TicketStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export interface TicketSummaryResponse {
  year: number;
  rows?: TicketSummaryRow[];
  grandTotal: number;
}

/**
 * One (type, category) pair across the year.

``months`` is a fixed-length 12-element array, Jan..Dec, rather than a
sparse map: it makes the FE grid a direct index and it matches how the
spreadsheet tab reads. A category with no tickets in March gets a 0, not a
missing key the grid has to defend against.
 */
export interface TicketSummaryRow {
  type: string;
  category: string;
  /**
   * @minItems 12
   * @maxItems 12
   */
  months: number[];
  total: number;
}

export type TicketType = typeof TicketType[keyof typeof TicketType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketType = {
  REQUEST: 'REQUEST',
  COMPLAINT: 'COMPLAINT',
} as const;

export interface TimeslotResponse {
  busySlots?: string[];
}

export type ToCheckItemShiftStart = string | null;

export type ToCheckItemShiftEnd = string | null;

export type ToCheckItemClockIn = string | null;

export type ToCheckItemClockOut = string | null;

export type ToCheckItemDecision = CheckDecision | null;

export type ToCheckItemNote = string | null;

export type ToCheckItemFixedTime = string | null;

export type ToCheckItemOtMinutes = number | null;

export type ToCheckItemDecidedByName = string | null;

export type ToCheckItemDecidedAt = string | null;

/**
 * HR-21-05 — one exception of a finished day, and HQ's decision if made.
 */
export interface ToCheckItem {
  staffId: string;
  staffName: string;
  outletName: string;
  date: string;
  kind: CheckKind;
  shiftStart?: ToCheckItemShiftStart;
  shiftEnd?: ToCheckItemShiftEnd;
  clockIn?: ToCheckItemClockIn;
  clockOut?: ToCheckItemClockOut;
  minutes?: number;
  decision?: ToCheckItemDecision;
  note?: ToCheckItemNote;
  fixedTime?: ToCheckItemFixedTime;
  otMinutes?: ToCheckItemOtMinutes;
  decidedByName?: ToCheckItemDecidedByName;
  decidedAt?: ToCheckItemDecidedAt;
}

export type TodayLineShiftStart = string | null;

export type TodayLineShiftEnd = string | null;

export type TodayLineClockIn = string | null;

export type TodayLineBreakStart = string | null;

export type TodayLineBreakEnd = string | null;

export type TodayLineClockOut = string | null;

export interface TodayLine {
  staffId: string;
  staffName: string;
  role: string;
  shiftStart?: TodayLineShiftStart;
  shiftEnd?: TodayLineShiftEnd;
  clockIn?: TodayLineClockIn;
  breakStart?: TodayLineBreakStart;
  breakEnd?: TodayLineBreakEnd;
  clockOut?: TodayLineClockOut;
  status: string;
  lateMinutes?: number;
  hasPin?: boolean;
}

export type TodayPicksResponseConfirmedBy = string | null;

export type TodayPicksResponseConfirmedAt = string | null;

/**
 * GET /dashboard/what-to-sell/today-picks — OPS-34, for booking screens.
 */
export interface TodayPicksResponse {
  confirmed: boolean;
  confirmedBy?: TodayPicksResponseConfirmedBy;
  confirmedAt?: TodayPicksResponseConfirmedAt;
  customers: CustomerPicks[];
}

export type TopicMapEntryTreatmentId = string | null;

export type TopicMapEntrySopId = string | null;

/**
 * A sheet Topic and the treatment step / SOP it stands for (at most one).
 */
export interface TopicMapEntry {
  topic: string;
  treatmentId?: TopicMapEntryTreatmentId;
  sopId?: TopicMapEntrySopId;
}

export interface TopicMapOptions {
  treatments?: TopicOption[];
  sops?: TopicOption[];
}

export type TopicMapRowTreatmentId = string | null;

export type TopicMapRowSopId = string | null;

export type TopicMapRowMappedName = string | null;

/**
 * One distinct Topic of the uploaded sheet, with its saved mapping.
 */
export interface TopicMapRow {
  topic: string;
  treatmentId?: TopicMapRowTreatmentId;
  sopId?: TopicMapRowSopId;
  rows: number;
  passRows: number;
  mappedName?: TopicMapRowMappedName;
}

export interface TopicMapSave {
  items?: TopicMapEntry[];
}

export interface TopicOption {
  id: string;
  name: string;
}

export interface TrainingBatchUpdateItem {
  staffId: string;
  itemType: TrainingItemType;
  itemId: string;
  status: TrainingStatus;
}

export interface TrainingBatchUpdateRequest {
  /**
   * @minItems 1
   * @maxItems 500
   */
  updates: TrainingBatchUpdateItem[];
}

export interface TrainingBatchUpdateResponse {
  updated: number;
}

export interface TrainingImportPreview {
  sheet: string;
  totalRows: number;
  readyRows: number;
  alreadyImported: number;
  skippedRows: number;
  unmatchedStaff?: NameCount[];
  unmatchedOutlets?: NameCount[];
  topics?: TopicMapRow[];
  rows?: TrainingImportRow[];
}

export type TrainingImportResultFirstDate = string | null;

export type TrainingImportResultLastDate = string | null;

export interface TrainingImportResult {
  created: number;
  alreadyImported: number;
  skipped: number;
  ticked?: number;
  firstDate?: TrainingImportResultFirstDate;
  lastDate?: TrainingImportResultLastDate;
}

export type TrainingImportRowDate = string | null;

export type TrainingImportRowStartTime = string | null;

export type TrainingImportRowEndTime = string | null;

export type TrainingImportRowType = TrainingSessionType | null;

export type TrainingImportRowResult = TrainingSessionResult | null;

export type TrainingImportRowTrainerId = string | null;

export type TrainingImportRowTraineeId = string | null;

export type TrainingImportRowOutletName = string | null;

export type TrainingImportRowOutletId = string | null;

/**
 * One sheet row as the preview shows it.
 */
export interface TrainingImportRow {
  rowNumber: number;
  date?: TrainingImportRowDate;
  startTime?: TrainingImportRowStartTime;
  endTime?: TrainingImportRowEndTime;
  type?: TrainingImportRowType;
  result?: TrainingImportRowResult;
  topic: string;
  trainerName: string;
  trainerId?: TrainingImportRowTrainerId;
  traineeName: string;
  traineeId?: TrainingImportRowTraineeId;
  outletName?: TrainingImportRowOutletName;
  outletId?: TrainingImportRowOutletId;
  status: string;
  problems?: string[];
}

export type TrainingItemSummarySequenceOrder = number | null;

export type TrainingItemSummaryNumber = number | null;

export type TrainingItemSummaryRequiredRole = string | null;

export type TrainingItemSummaryMinSkillLevel = number | null;

export type TrainingItemSummaryAppliesTo = string | null;

/**
 * A column of the grid. Serves both catalogues: `Treatment` carries
`sequenceOrder`/`requiredRole`, `SOP` carries `number`/`appliesTo`, so the
fields that belong to only one of them are optional.
 */
export interface TrainingItemSummary {
  id: string;
  name: string;
  sequenceOrder?: TrainingItemSummarySequenceOrder;
  number?: TrainingItemSummaryNumber;
  requiredRole?: TrainingItemSummaryRequiredRole;
  minSkillLevel?: TrainingItemSummaryMinSkillLevel;
  appliesTo?: TrainingItemSummaryAppliesTo;
  testable?: boolean;
}

export type TrainingItemType = typeof TrainingItemType[keyof typeof TrainingItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrainingItemType = {
  TREATMENT: 'TREATMENT',
  SOP: 'SOP',
} as const;

export interface TrainingMatrixResponse {
  treatments?: TrainingItemSummary[];
  sops?: TrainingItemSummary[];
  staff?: TrainingMatrixStaff[];
}

export type TrainingMatrixStaffTreatmentStatuses = {[key: string]: string};

export type TrainingMatrixStaffSopStatuses = {[key: string]: string};

export interface TrainingMatrixStaff {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  outletId: string;
  outletName: string;
  isActive: boolean;
  treatmentStatuses?: TrainingMatrixStaffTreatmentStatuses;
  sopStatuses?: TrainingMatrixStaffSopStatuses;
}

export type TrainingSessionCreateStartTime = string | null;

export type TrainingSessionCreateEndTime = string | null;

export type TrainingSessionCreateTrainerId = string | null;

export type TrainingSessionCreateTrainerName = string | null;

export type TrainingSessionCreateOutletId = string | null;

export type TrainingSessionCreateNotes = string | null;

export interface TrainingSessionCreate {
  date: string;
  startTime?: TrainingSessionCreateStartTime;
  endTime?: TrainingSessionCreateEndTime;
  type: TrainingSessionType;
  /**
   * @minLength 1
   * @maxLength 300
   */
  topic: string;
  staffIds?: string[];
  trainerId?: TrainingSessionCreateTrainerId;
  trainerName?: TrainingSessionCreateTrainerName;
  outletId?: TrainingSessionCreateOutletId;
  notes?: TrainingSessionCreateNotes;
}

export interface TrainingSessionListResponse {
  items?: TrainingSessionResponse[];
  total: number;
}

export type TrainingSessionResponseStartTime = string | null;

export type TrainingSessionResponseEndTime = string | null;

export type TrainingSessionResponseTrainerId = string | null;

export type TrainingSessionResponseTrainerName = string | null;

export type TrainingSessionResponseOutletId = string | null;

export type TrainingSessionResponseOutletName = string | null;

export type TrainingSessionResponseResult = TrainingSessionResult | null;

export type TrainingSessionResponseRequestedById = string | null;

export type TrainingSessionResponseDecidedById = string | null;

export type TrainingSessionResponseDecidedAt = string | null;

export type TrainingSessionResponseNotes = string | null;

export type TrainingSessionResponseCreatedById = string | null;

export interface TrainingSessionResponse {
  id: string;
  date: string;
  startTime?: TrainingSessionResponseStartTime;
  endTime?: TrainingSessionResponseEndTime;
  type: TrainingSessionType;
  topic: string;
  trainerId?: TrainingSessionResponseTrainerId;
  trainerName?: TrainingSessionResponseTrainerName;
  outletId?: TrainingSessionResponseOutletId;
  outletName?: TrainingSessionResponseOutletName;
  result?: TrainingSessionResponseResult;
  status?: TrainingSessionStatus;
  requestedById?: TrainingSessionResponseRequestedById;
  decidedById?: TrainingSessionResponseDecidedById;
  decidedAt?: TrainingSessionResponseDecidedAt;
  notes?: TrainingSessionResponseNotes;
  trainees?: TrainingSessionTraineeOut[];
  createdById?: TrainingSessionResponseCreatedById;
  createdAt: string;
  updatedAt: string;
}

export type TrainingSessionResult = typeof TrainingSessionResult[keyof typeof TrainingSessionResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrainingSessionResult = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  POSTPONED: 'POSTPONED',
} as const;

/**
 * SCHEDULED: on the calendar. REQUESTED: the Head Master asked for it and
HQ has not decided yet (shown dashed). DECLINED: HQ said no (kept, hidden).
 */
export type TrainingSessionStatus = typeof TrainingSessionStatus[keyof typeof TrainingSessionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrainingSessionStatus = {
  SCHEDULED: 'SCHEDULED',
  REQUESTED: 'REQUESTED',
  DECLINED: 'DECLINED',
} as const;

export interface TrainingSessionTraineeOut {
  staffId: string;
  staffName: string;
}

export type TrainingSessionType = typeof TrainingSessionType[keyof typeof TrainingSessionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrainingSessionType = {
  TRAINING: 'TRAINING',
  RE_TRAINING: 'RE_TRAINING',
  TEST: 'TEST',
  RETEST: 'RETEST',
  ROLE_PLAY: 'ROLE_PLAY',
  ORIENTATION: 'ORIENTATION',
  HOLIDAY: 'HOLIDAY',
  NOTE: 'NOTE',
} as const;

export type TrainingSessionUpdateStartTime = string | null;

export type TrainingSessionUpdateEndTime = string | null;

export type TrainingSessionUpdateType = TrainingSessionType | null;

export type TrainingSessionUpdateTopic = string | null;

export type TrainingSessionUpdateStaffIds = string[] | null;

export type TrainingSessionUpdateTrainerId = string | null;

export type TrainingSessionUpdateTrainerName = string | null;

export type TrainingSessionUpdateOutletId = string | null;

export type TrainingSessionUpdateResult = TrainingSessionResult | null;

export type TrainingSessionUpdateNotes = string | null;

export interface TrainingSessionUpdate {
  date?: null;
  startTime?: TrainingSessionUpdateStartTime;
  endTime?: TrainingSessionUpdateEndTime;
  type?: TrainingSessionUpdateType;
  topic?: TrainingSessionUpdateTopic;
  staffIds?: TrainingSessionUpdateStaffIds;
  trainerId?: TrainingSessionUpdateTrainerId;
  trainerName?: TrainingSessionUpdateTrainerName;
  outletId?: TrainingSessionUpdateOutletId;
  result?: TrainingSessionUpdateResult;
  notes?: TrainingSessionUpdateNotes;
}

export type TrainingSopOptionLinkedSopId = string | null;

export interface TrainingSopOption {
  id: string;
  number: number;
  name: string;
  linkedSopId?: TrainingSopOptionLinkedSopId;
}

export interface TrainingSopOptionsResponse {
  items?: TrainingSopOption[];
}

export interface TrainingSopRef {
  id: string;
  number: number;
  name: string;
}

export type TrainingStatus = typeof TrainingStatus[keyof typeof TrainingStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrainingStatus = {
  TRAINING: 'TRAINING',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  NA: 'NA',
  ON_HOLD: 'ON_HOLD',
} as const;

/**
 * HR-01a — 'Treatments n/N · SOPs n/M' on the staff list. The totals are
the active catalogue counts (never hard-coded); `passed` counts PASSED
records against active items only, so it can never exceed the total.
 */
export interface TrainingSummaryResponse {
  treatmentsTotal: number;
  sopsTotal: number;
  staff?: TrainingSummaryStaff[];
}

export interface TrainingSummaryStaff {
  staffId: string;
  treatmentsPassed?: number;
  sopsPassed?: number;
}

export type TransferCreateNotes = string | null;

/**
 * Create a transfer — spec §7.3. Lands in DRAFT; moves no stock.

Creating is not dispatching. Stock leaves the source only on
`POST /inventory/transfers/{id}/send`, which is what makes a DRAFT freely
cancellable and what keeps the FEFO pick anchored to the moment the goods
physically move rather than to whenever the form was filled in.

``lines`` requires at least one entry: a transfer of nothing is a document
with no meaning that would still occupy the in-transit list.

The directional rule (from must be OFFICE, to must be OUTLET) is enforced in
``InventoryService.create_transfer``, not here — same reasoning as the rest
of this module, so it surfaces as a readable 422 rather than pydantic noise.
 */
export interface TransferCreate {
  /** @minLength 1 */
  fromLocationId: string;
  /** @minLength 1 */
  toLocationId: string;
  /** @minItems 1 */
  lines: TransferLineCreate[];
  notes?: TransferCreateNotes;
  sendNow?: boolean;
}

/**
 * One requested product + quantity on a new transfer.

⛔ There is deliberately no batch field, and adding one would be a design
error rather than a feature. Which batches leave is decided by FEFO at send
time (§5), not by whoever fills in the form — that is the whole reason the
picking rule lives in one function. A caller-chosen batch would let someone
ship the freshest stock and strand the expiring goods, which is the exact
inverse of the rule Angela asked for.
 */
export interface TransferLineCreate {
  /** @minLength 1 */
  productId: string;
  /** */
  qty: number;
}

export type TransferLineResponseProductSku = string | null;

export type TransferLineResponseUnit = string | null;

export type TransferLineResponseQtyRequested = number | null;

export type TransferLineResponseQtySent = number | null;

export type TransferLineResponseQtyReceived = number | null;

export type TransferLineResponseReturnDecision = string | null;

/**
 * A requested line, with its product name resolved.

``productName`` is flattened onto the row rather than nested for the same
reason as the expiry feed: the transfer drawer wants "20 x Hydrating
Cleanser", and a nested product object would make every surface unpack it
differently.

⛔ This is what was ASKED FOR, not what shipped. After a send, the authoritative
record of which batches left — and therefore of the expiry dates now sitting at
the outlet — is the `TRANSFER_OUT` StockMovement set, not this line. Rendering
a line as proof of receipt would be wrong whenever a pick spanned batches.
 */
export interface TransferLineResponse {
  id: string;
  transferId: string;
  productId: string;
  productName: string;
  productSku?: TransferLineResponseProductSku;
  unit?: TransferLineResponseUnit;
  qty: number;
  createdAt: string;
  qtyRequested?: TransferLineResponseQtyRequested;
  qtySent?: TransferLineResponseQtySent;
  qtyReceived?: TransferLineResponseQtyReceived;
  returnDecision?: TransferLineResponseReturnDecision;
}

/**
 * The transfer list plus its count.

``total`` is the number of transfers in ``transfers`` — this endpoint does
not paginate, so the two always agree. It is sent explicitly rather than left
to the client's `.length` so adding pagination later is a non-breaking change
to the same shape.
 */
export interface TransferListResponse {
  transfers: TransferResponse[];
  total: number;
}

export type TransferReasonRequestReason = string | null;

/**
 * Cancel (required when in transit) or Reject (always required).
 */
export interface TransferReasonRequest {
  reason?: TransferReasonRequestReason;
}

/**
 * What the receiving outlet counted for one line (INV-07-10).
 */
export interface TransferReceiveLine {
  /** @minLength 1 */
  lineId: string;
  /** @minimum 0 */
  qtyReceived: number;
}

export type TransferReceiveRequestLines = TransferReceiveLine[] | null;

export type TransferReceiveRequestDifferenceReason = string | null;

export type TransferReceiveRequestRemarks = string | null;

/**
 * Confirm receipt. Omitted lines count as received in full.

``differenceReason`` is required by the service when any line differs:
SHORT_DELIVERED · DAMAGED_IN_TRANSIT · COUNTED_WRONGLY · MORE_THAN_SENT · OTHER.
 */
export interface TransferReceiveRequest {
  lines?: TransferReceiveRequestLines;
  differenceReason?: TransferReceiveRequestDifferenceReason;
  remarks?: TransferReceiveRequestRemarks;
}

export type TransferRequestRemarks = string | null;

export type TransferRequestOutletId = string | null;

/**
 * POST /finance/packages/{id}/transfer — SAL-28 Package Holder Transfer.
The whole package (all remaining sessions) moves on HQ approval.
 */
export interface TransferRequest {
  toCustomerId: string;
  reason: string;
  remarks?: TransferRequestRemarks;
  attachments?: string[];
  outletId?: TransferRequestOutletId;
}

export type TransferResponseCreatedById = string | null;

export type TransferResponseSentAt = string | null;

export type TransferResponseReceivedAt = string | null;

export type TransferResponseNotes = string | null;

export type TransferResponseNumber = string | null;

export type TransferResponseRequestId = string | null;

export type TransferResponseRequestNumber = string | null;

export type TransferResponseReturnOfTransferId = string | null;

export type TransferResponseReturnOfTransferNumber = string | null;

export type TransferResponseReturnTransferId = string | null;

export type TransferResponseReturnTransferNumber = string | null;

export type TransferResponseCreatedByName = string | null;

export type TransferResponseSentByName = string | null;

export type TransferResponseReceivedByName = string | null;

export type TransferResponseCancelledAt = string | null;

export type TransferResponseCancelReason = string | null;

export type TransferResponseDifferenceReason = string | null;

export type TransferResponseDifferenceRemarks = string | null;

export type TransferResponseDifferenceReturnedAt = string | null;

export type TransferResponseExtraConfirmedAt = string | null;

/**
 * A transfer with its lines and both location names — spec §7.3.

Location names are flattened alongside the ids so the transfer list renders
"Office → Wisma Pacific" without a second request or a client-side join
against `GET /inventory/locations`.

``status`` is 'DRAFT' | 'SENT' | 'RECEIVED' | 'CANCELLED'. ``sentAt`` and
``receivedAt`` are null until the matching step happens, so a client can
render the timeline from the timestamps rather than inferring it from the
status string alone.
 */
export interface TransferResponse {
  id: string;
  fromLocationId: string;
  fromLocationName: string;
  toLocationId: string;
  toLocationName: string;
  status: string;
  createdById: TransferResponseCreatedById;
  sentAt: TransferResponseSentAt;
  receivedAt: TransferResponseReceivedAt;
  notes: TransferResponseNotes;
  lines: TransferLineResponse[];
  createdAt: string;
  updatedAt: string;
  number?: TransferResponseNumber;
  kind?: string;
  requestId?: TransferResponseRequestId;
  requestNumber?: TransferResponseRequestNumber;
  returnOfTransferId?: TransferResponseReturnOfTransferId;
  returnOfTransferNumber?: TransferResponseReturnOfTransferNumber;
  returnTransferId?: TransferResponseReturnTransferId;
  returnTransferNumber?: TransferResponseReturnTransferNumber;
  createdByName?: TransferResponseCreatedByName;
  sentByName?: TransferResponseSentByName;
  receivedByName?: TransferResponseReceivedByName;
  cancelledAt?: TransferResponseCancelledAt;
  cancelReason?: TransferResponseCancelReason;
  differenceReason?: TransferResponseDifferenceReason;
  differenceRemarks?: TransferResponseDifferenceRemarks;
  differenceReturnedAt?: TransferResponseDifferenceReturnedAt;
  extraConfirmedAt?: TransferResponseExtraConfirmedAt;
  shortPending?: boolean;
  extraPending?: boolean;
  isPending?: boolean;
}

/**
 * A line's quantity to send; may only be lowered (0 = not sent) — INV-07-03 step 4.
 */
export interface TransferSendLine {
  /** @minLength 1 */
  lineId: string;
  /** @minimum 0 */
  qty: number;
}

export type TransferSendRequestLines = TransferSendLine[] | null;

export interface TransferSendRequest {
  lines?: TransferSendRequestLines;
}

export type TreatmentCategory = typeof TreatmentCategory[keyof typeof TreatmentCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentCategory = {
  AESTHETIC: 'AESTHETIC',
  SKIN: 'SKIN',
} as const;

export type TreatmentCreateNameKo = string | null;

export type TreatmentCreateNameZh = string | null;

export type TreatmentCreateNameVi = string | null;

export type TreatmentCreatePriceAlaCarte = number | string | null;

export type TreatmentCreatePrice5Sessions = number | string | null;

export type TreatmentCreatePrice10Sessions = number | string | null;

export type TreatmentCreatePrice20Sessions = number | string | null;

export type TreatmentCreateMinPriceAlaCarte = number | string | null;

export type TreatmentCreateMinPrice5Sessions = number | string | null;

export type TreatmentCreateMinPrice10Sessions = number | string | null;

export type TreatmentCreateMinPrice20Sessions = number | string | null;

export type TreatmentCreatePriceTrial = number | string | null;

export type TreatmentCreateMinPriceTrial = number | string | null;

export interface TreatmentCreate {
  name: string;
  nameKo?: TreatmentCreateNameKo;
  nameZh?: TreatmentCreateNameZh;
  nameVi?: TreatmentCreateNameVi;
  category: TreatmentCategory;
  priceAlaCarte?: TreatmentCreatePriceAlaCarte;
  price5Sessions?: TreatmentCreatePrice5Sessions;
  price10Sessions?: TreatmentCreatePrice10Sessions;
  price20Sessions?: TreatmentCreatePrice20Sessions;
  minPriceAlaCarte?: TreatmentCreateMinPriceAlaCarte;
  minPrice5Sessions?: TreatmentCreateMinPrice5Sessions;
  minPrice10Sessions?: TreatmentCreateMinPrice10Sessions;
  minPrice20Sessions?: TreatmentCreateMinPrice20Sessions;
  priceTrial?: TreatmentCreatePriceTrial;
  minPriceTrial?: TreatmentCreateMinPriceTrial;
  steps?: TreatmentStepCreate[];
}

export type TreatmentDetailNameKo = string | null;

export type TreatmentDetailNameZh = string | null;

export type TreatmentDetailNameVi = string | null;

export type TreatmentDetailPriceAlaCarte = string | null;

export type TreatmentDetailPrice5Sessions = string | null;

export type TreatmentDetailPrice10Sessions = string | null;

export type TreatmentDetailPrice20Sessions = string | null;

export type TreatmentDetailMinPriceAlaCarte = string | null;

export type TreatmentDetailMinPrice5Sessions = string | null;

export type TreatmentDetailMinPrice10Sessions = string | null;

export type TreatmentDetailMinPrice20Sessions = string | null;

export type TreatmentDetailPriceTrial = string | null;

export type TreatmentDetailMinPriceTrial = string | null;

export interface TreatmentDetail {
  name: string;
  nameKo?: TreatmentDetailNameKo;
  nameZh?: TreatmentDetailNameZh;
  nameVi?: TreatmentDetailNameVi;
  category: TreatmentCategory;
  totalDuration: number;
  priceAlaCarte?: TreatmentDetailPriceAlaCarte;
  price5Sessions?: TreatmentDetailPrice5Sessions;
  price10Sessions?: TreatmentDetailPrice10Sessions;
  price20Sessions?: TreatmentDetailPrice20Sessions;
  minPriceAlaCarte?: TreatmentDetailMinPriceAlaCarte;
  minPrice5Sessions?: TreatmentDetailMinPrice5Sessions;
  minPrice10Sessions?: TreatmentDetailMinPrice10Sessions;
  minPrice20Sessions?: TreatmentDetailMinPrice20Sessions;
  priceTrial?: TreatmentDetailPriceTrial;
  minPriceTrial?: TreatmentDetailMinPriceTrial;
  isActive?: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
  steps?: TreatmentStepDetail[];
}

export type TreatmentNameSummaryNameKo = string | null;

export type TreatmentNameSummaryNameZh = string | null;

export type TreatmentNameSummaryNameVi = string | null;

export interface TreatmentNameSummary {
  id: string;
  name: string;
  nameKo?: TreatmentNameSummaryNameKo;
  nameZh?: TreatmentNameSummaryNameZh;
  nameVi?: TreatmentNameSummaryNameVi;
}

export interface TreatmentStep {
  id: string;
  sequence: number;
  name: string;
  duration: number;
  minSkillLevel: number;
}

export type TreatmentStepCreateRequiredRole = string | null;

export type TreatmentStepCreateProductId = string | null;

export type TreatmentStepCreateProductAmount = number | string | null;

export type TreatmentStepCreateProductUnit = string | null;

export interface TreatmentStepCreate {
  name: string;
  sequence: number;
  duration: number;
  minSkillLevel: number;
  requiredRole?: TreatmentStepCreateRequiredRole;
  productId?: TreatmentStepCreateProductId;
  productAmount?: TreatmentStepCreateProductAmount;
  productUnit?: TreatmentStepCreateProductUnit;
}

export type TreatmentStepDetailCommissionMinutes = number | null;

export type TreatmentStepDetailNameKo = string | null;

export type TreatmentStepDetailNameZh = string | null;

export type TreatmentStepDetailNameVi = string | null;

export type TreatmentStepDetailRequiredRole = string | null;

export type TreatmentStepDetailCanonicalTreatmentId = string | null;

export type TreatmentStepDetailProductId = string | null;

export type TreatmentStepDetailProductAmount = string | null;

export type TreatmentStepDetailProductUnit = string | null;

export interface TreatmentStepDetail {
  id: string;
  sequence: number;
  name: string;
  duration: number;
  commissionMinutes?: TreatmentStepDetailCommissionMinutes;
  minSkillLevel: number;
  programId: string;
  nameKo?: TreatmentStepDetailNameKo;
  nameZh?: TreatmentStepDetailNameZh;
  nameVi?: TreatmentStepDetailNameVi;
  requiredRole?: TreatmentStepDetailRequiredRole;
  canonicalTreatmentId?: TreatmentStepDetailCanonicalTreatmentId;
  productId?: TreatmentStepDetailProductId;
  productAmount?: TreatmentStepDetailProductAmount;
  productUnit?: TreatmentStepDetailProductUnit;
  qualifiedStaff?: TreatmentStepQualifiedStaff[];
  qualifiedCount: number;
}

/**
 * SAL-16-04 — one step of the package's treatment, in order.
 */
export interface TreatmentStepOption {
  id: string;
  name: string;
  duration: number;
}

export interface TreatmentStepQualifiedStaff {
  id: string;
  name: string;
  role: StaffRole;
  skillLevel: number;
  outlet: OutletSummary;
}

export type TreatmentStepSummaryCommissionMinutes = number | null;

export interface TreatmentStepSummary {
  id: string;
  sequence: number;
  name: string;
  duration: number;
  commissionMinutes?: TreatmentStepSummaryCommissionMinutes;
  minSkillLevel: number;
}

export type TreatmentStepUpdateName = string | null;

export type TreatmentStepUpdateNameKo = string | null;

export type TreatmentStepUpdateNameZh = string | null;

export type TreatmentStepUpdateNameVi = string | null;

export type TreatmentStepUpdateSequence = number | null;

export type TreatmentStepUpdateDuration = number | null;

export type TreatmentStepUpdateCommissionMinutes = number | null;

export type TreatmentStepUpdateMinSkillLevel = number | null;

export type TreatmentStepUpdateRequiredRole = string | null;

export type TreatmentStepUpdateCanonicalTreatmentId = string | null;

export type TreatmentStepUpdateProductId = string | null;

export type TreatmentStepUpdateProductAmount = number | string | null;

export type TreatmentStepUpdateProductUnit = string | null;

/**
 * Partial update for a single programme step. Send only what you change.

`canonical_treatment_id` is the step's reporting label (Settings → Program
Step Mapping). It is the only nullable-on-the-column field here: an explicit
`null` unmaps the step, so the router dumps with `exclude_unset` rather than
`exclude_none` — otherwise unmapping is a silent no-op. It was persisted by
`catalog_service.update_program_step` but never declared here, so every save
from that page 200'd and wrote nothing (same defect class as #329).
 */
export interface TreatmentStepUpdate {
  name?: TreatmentStepUpdateName;
  nameKo?: TreatmentStepUpdateNameKo;
  nameZh?: TreatmentStepUpdateNameZh;
  nameVi?: TreatmentStepUpdateNameVi;
  sequence?: TreatmentStepUpdateSequence;
  duration?: TreatmentStepUpdateDuration;
  commissionMinutes?: TreatmentStepUpdateCommissionMinutes;
  minSkillLevel?: TreatmentStepUpdateMinSkillLevel;
  requiredRole?: TreatmentStepUpdateRequiredRole;
  canonicalTreatmentId?: TreatmentStepUpdateCanonicalTreatmentId;
  productId?: TreatmentStepUpdateProductId;
  productAmount?: TreatmentStepUpdateProductAmount;
  productUnit?: TreatmentStepUpdateProductUnit;
}

export type TreatmentSummaryNameKo = string | null;

export type TreatmentSummaryNameZh = string | null;

export type TreatmentSummaryNameVi = string | null;

export type TreatmentSummaryPriceAlaCarte = string | null;

export type TreatmentSummaryPrice5Sessions = string | null;

export type TreatmentSummaryPrice10Sessions = string | null;

export type TreatmentSummaryPrice20Sessions = string | null;

export type TreatmentSummaryMinPriceAlaCarte = string | null;

export type TreatmentSummaryMinPrice5Sessions = string | null;

export type TreatmentSummaryMinPrice10Sessions = string | null;

export type TreatmentSummaryMinPrice20Sessions = string | null;

export type TreatmentSummaryPriceTrial = string | null;

export type TreatmentSummaryMinPriceTrial = string | null;

export interface TreatmentSummary {
  name: string;
  nameKo?: TreatmentSummaryNameKo;
  nameZh?: TreatmentSummaryNameZh;
  nameVi?: TreatmentSummaryNameVi;
  category: TreatmentCategory;
  totalDuration: number;
  priceAlaCarte?: TreatmentSummaryPriceAlaCarte;
  price5Sessions?: TreatmentSummaryPrice5Sessions;
  price10Sessions?: TreatmentSummaryPrice10Sessions;
  price20Sessions?: TreatmentSummaryPrice20Sessions;
  minPriceAlaCarte?: TreatmentSummaryMinPriceAlaCarte;
  minPrice5Sessions?: TreatmentSummaryMinPrice5Sessions;
  minPrice10Sessions?: TreatmentSummaryMinPrice10Sessions;
  minPrice20Sessions?: TreatmentSummaryMinPrice20Sessions;
  priceTrial?: TreatmentSummaryPriceTrial;
  minPriceTrial?: TreatmentSummaryMinPriceTrial;
  isActive?: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
  steps?: TreatmentStepSummary[];
  stepCount: number;
}

export type TreatmentUpdateName = string | null;

export type TreatmentUpdateNameKo = string | null;

export type TreatmentUpdateNameZh = string | null;

export type TreatmentUpdateNameVi = string | null;

export type TreatmentUpdateCategory = TreatmentCategory | null;

export type TreatmentUpdatePriceAlaCarte = number | string | null;

export type TreatmentUpdatePrice5Sessions = number | string | null;

export type TreatmentUpdatePrice10Sessions = number | string | null;

export type TreatmentUpdatePrice20Sessions = number | string | null;

export type TreatmentUpdateMinPriceAlaCarte = number | string | null;

export type TreatmentUpdateMinPrice5Sessions = number | string | null;

export type TreatmentUpdateMinPrice10Sessions = number | string | null;

export type TreatmentUpdateMinPrice20Sessions = number | string | null;

export type TreatmentUpdatePriceTrial = number | string | null;

export type TreatmentUpdateMinPriceTrial = number | string | null;

export type TreatmentUpdateIsActive = boolean | null;

export interface TreatmentUpdate {
  name?: TreatmentUpdateName;
  nameKo?: TreatmentUpdateNameKo;
  nameZh?: TreatmentUpdateNameZh;
  nameVi?: TreatmentUpdateNameVi;
  category?: TreatmentUpdateCategory;
  priceAlaCarte?: TreatmentUpdatePriceAlaCarte;
  price5Sessions?: TreatmentUpdatePrice5Sessions;
  price10Sessions?: TreatmentUpdatePrice10Sessions;
  price20Sessions?: TreatmentUpdatePrice20Sessions;
  minPriceAlaCarte?: TreatmentUpdateMinPriceAlaCarte;
  minPrice5Sessions?: TreatmentUpdateMinPrice5Sessions;
  minPrice10Sessions?: TreatmentUpdateMinPrice10Sessions;
  minPrice20Sessions?: TreatmentUpdateMinPrice20Sessions;
  priceTrial?: TreatmentUpdatePriceTrial;
  minPriceTrial?: TreatmentUpdateMinPriceTrial;
  isActive?: TreatmentUpdateIsActive;
}

export interface TrialImportPreview {
  totalRows: number;
  readyRows: number;
  skippedRows: number;
  rows: TrialImportRow[];
}

export interface TrialImportResult {
  updated: number;
  updatedNames: string[];
  belowMinimumImported?: number;
  skippedRows: number;
  skipped: TrialImportRow[];
}

export type TrialImportRowOriginalPrice = string | null;

export type TrialImportRowTrialPrice = string | null;

export type TrialImportRowNote = string | null;

export type TrialImportRowMatchedProgramme = string | null;

export type TrialImportRowCurrentTrialPrice = string | null;

/**
 * One '(New Trial) …' row of the trial price sheet, as the preview sees it.
Prices are before GST (decision I1).
 */
export interface TrialImportRow {
  rowNumber: number;
  name: string;
  originalPrice?: TrialImportRowOriginalPrice;
  trialPrice?: TrialImportRowTrialPrice;
  status: string;
  note?: TrialImportRowNote;
  matchedProgramme?: TrialImportRowMatchedProgramme;
  currentTrialPrice?: TrialImportRowCurrentTrialPrice;
}

export type TrialPriceBadgeLastVisit = string | null;

export type TrialPriceBadgeLastVisitOutlet = string | null;

export type TrialPriceBadgeFirstAsked = string | null;

/**
 * The trial-price badge worked out from her own history (LEA-29-04).
Nobody types it.
 */
export interface TrialPriceBadge {
  state: TrialPriceState;
  lastVisit?: TrialPriceBadgeLastVisit;
  lastVisitOutlet?: TrialPriceBadgeLastVisitOutlet;
  firstAsked?: TrialPriceBadgeFirstAsked;
}

/**
 * LEA-29-04: red wins over blue, blue over amber.
 */
export type TrialPriceState = typeof TrialPriceState[keyof typeof TrialPriceState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrialPriceState = {
  RED: 'RED',
  BLUE: 'BLUE',
  AMBER: 'AMBER',
} as const;

export type TrialStatusResponseLastVisit = string | null;

export type TrialStatusResponseTrialBoughtAt = string | null;

export type TrialStatusResponseTrialBoughtItem = string | null;

/**
 * GET /finance/customers/{id}/trial-status — GEN-03 / LEA-29 / INV-03-09.
``status``: NO_TRIAL_PRICE (last visit under 12 months) · PAST_CUSTOMER ·
NEW. The till warns; it does not block.
 */
export interface TrialStatusResponse {
  customerId: string;
  status: string;
  lastVisit?: TrialStatusResponseLastVisit;
  trialBoughtAt?: TrialStatusResponseTrialBoughtAt;
  trialBoughtItem?: TrialStatusResponseTrialBoughtItem;
}

export type UpgradeEligiblePackageProgramName = string | null;

export type UpgradeEligiblePackageInvoiceNumber = string | null;

export type UpgradeEligiblePackageSaleId = string | null;

export type UpgradeEligiblePackagePurchaseDate = string | null;

export type UpgradeEligiblePackageExpiryDate = string | null;

export type UpgradeEligiblePackageBlockedReason = string | null;

export type UpgradeEligiblePackageIhipBlockedReason = string | null;

/**
 * One ACTIVE package with sessions left, offered as an upgrade source.

``perSessionValue`` is the unit the offset is computed in (``amountPaid /
totalSessions``) and ``remainingValue`` is the most that can be carried over
— the frontend shows both so the cashier can see the arithmetic before
committing. ``saleId`` / ``invoiceNumber`` resolve the originating invoice so
the form's "Invoice" dropdown can group packages by the sale that sold them.
 */
export interface UpgradeEligiblePackage {
  packageId: string;
  programId: string;
  programName?: UpgradeEligiblePackageProgramName;
  invoiceNumber?: UpgradeEligiblePackageInvoiceNumber;
  saleId?: UpgradeEligiblePackageSaleId;
  totalSessions: number;
  usedSessions: number;
  remainingSessions: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amountPaid: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  perSessionValue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  remainingValue: string;
  purchaseDate?: UpgradeEligiblePackagePurchaseDate;
  expiryDate?: UpgradeEligiblePackageExpiryDate;
  status: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  upgradeValue?: string;
  blockedReason?: UpgradeEligiblePackageBlockedReason;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  invoiceOwing?: string;
  ihipBlockedReason?: UpgradeEligiblePackageIhipBlockedReason;
}

/**
 * GET /finance/packages/{customerId}/upgrade-eligible.
 */
export interface UpgradeEligiblePackageListResponse {
  packages?: UpgradeEligiblePackage[];
}

export type UpgradeInvoiceCreateCreditApplied = number | string;

export type UpgradeInvoiceCreateDiscountType = string | null;

export type UpgradeInvoiceCreateDiscountValue = number | string | null;

export type UpgradeInvoiceCreateDiscountReason = string | null;

export type UpgradeInvoiceCreateDiscountNote = string | null;

export type UpgradeInvoiceCreateNotes = string | null;

export type UpgradeInvoiceCreateBelowMinimumReason = string | null;

export type UpgradeInvoiceCreateCustomerSignature = string | null;

export type UpgradeInvoiceCreateStaffSignature = string | null;

export type UpgradeInvoiceCreatePromotion = string | null;

export type UpgradeInvoiceCreateMedia = string | null;

export type UpgradeInvoiceCreateIhipAgreement = IHIPAgreementCreate | null;

/**
 * POST /finance/sales/upgrade-invoice — the SM Upgrade Invoice form.

``payments`` and the discount block mirror ``SaleCreate``; ``upgradeItems``
are the packages of ONE invoice being upgraded (each to more sessions of the
same treatment) and become the invoice's lines. The
resulting sale is always ``saleType="UPGRADE"`` — the caller does not pick it,
because an upgrade invoice that rang up as anything else would silently escape
the upgrade reporting cut.
 */
export interface UpgradeInvoiceCreate {
  customerId: string;
  outletId: string;
  payments?: PaymentCreate[];
  creditApplied?: UpgradeInvoiceCreateCreditApplied;
  discountType?: UpgradeInvoiceCreateDiscountType;
  discountValue?: UpgradeInvoiceCreateDiscountValue;
  discountReason?: UpgradeInvoiceCreateDiscountReason;
  discountNote?: UpgradeInvoiceCreateDiscountNote;
  notes?: UpgradeInvoiceCreateNotes;
  belowMinimumReason?: UpgradeInvoiceCreateBelowMinimumReason;
  customerSignature?: UpgradeInvoiceCreateCustomerSignature;
  staffSignature?: UpgradeInvoiceCreateStaffSignature;
  servedBy?: ServedByCreate[];
  upgradeItems?: UpgradeItemCreate[];
  promotion?: UpgradeInvoiceCreatePromotion;
  media?: UpgradeInvoiceCreateMedia;
  paymentKind?: string;
  ihipAgreement?: UpgradeInvoiceCreateIhipAgreement;
}

export type UpgradeInvoiceResponseCustomerId = string | null;

export type UpgradeInvoiceResponseCustomerName = string | null;

export type UpgradeInvoiceResponseInvoiceNumber = string | null;

export type UpgradeInvoiceResponsePresalesNumber = string | null;

export type UpgradeInvoiceResponseAcknowledgedById = string | null;

export type UpgradeInvoiceResponseAcknowledgedAt = string | null;

export type UpgradeInvoiceResponseContraAmount = string | null;

export type UpgradeInvoiceResponseRelatedSaleId = string | null;

export type UpgradeInvoiceResponseCreatedById = string | null;

export type UpgradeInvoiceResponseNotes = string | null;

export type UpgradeInvoiceResponseCustomerSignature = string | null;

export type UpgradeInvoiceResponseStaffSignature = string | null;

export type UpgradeInvoiceResponseCreatedAt = string | null;

export type UpgradeInvoiceResponseUpdatedAt = string | null;

export type UpgradeInvoiceResponseDiscountType = string | null;

export type UpgradeInvoiceResponseDiscountValue = string | null;

export type UpgradeInvoiceResponseDiscountReason = string | null;

export type UpgradeInvoiceResponseDiscountNote = string | null;

export type UpgradeInvoiceResponseDiscountById = string | null;

export type UpgradeInvoiceResponseFreeReason = string | null;

export type UpgradeInvoiceResponseFreeNote = string | null;

export type UpgradeInvoiceResponseSaleTypeAmendedFrom = string | null;

export type UpgradeInvoiceResponseSaleTypeAmendedById = string | null;

export type UpgradeInvoiceResponseSaleTypeAmendedAt = string | null;

export type UpgradeInvoiceResponseSaleTypeAmendReason = string | null;

export type UpgradeInvoiceResponsePromotion = string | null;

export type UpgradeInvoiceResponseMedia = string | null;

export type UpgradeInvoiceResponseUpgradeAmount = string | null;

/**
 * The persisted upgrade sale. Extends ``SaleResponse`` with the offset that
is unique to this invoice kind, so the caller can show "Subtotal (After
upgrade)" back from the server rather than trusting its own arithmetic.
 */
export interface UpgradeInvoiceResponse {
  id: string;
  customerId?: UpgradeInvoiceResponseCustomerId;
  customerName?: UpgradeInvoiceResponseCustomerName;
  outletId: string;
  saleType: string;
  invoiceNumber?: UpgradeInvoiceResponseInvoiceNumber;
  presalesNumber?: UpgradeInvoiceResponsePresalesNumber;
  acknowledgedById?: UpgradeInvoiceResponseAcknowledgedById;
  acknowledgedAt?: UpgradeInvoiceResponseAcknowledgedAt;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  subtotal: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  gstAmount: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  total: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  creditApplied: string;
  contraAmount?: UpgradeInvoiceResponseContraAmount;
  status: string;
  paymentKind?: string;
  relatedSaleId?: UpgradeInvoiceResponseRelatedSaleId;
  createdById?: UpgradeInvoiceResponseCreatedById;
  notes?: UpgradeInvoiceResponseNotes;
  customerSignature?: UpgradeInvoiceResponseCustomerSignature;
  staffSignature?: UpgradeInvoiceResponseStaffSignature;
  createdAt?: UpgradeInvoiceResponseCreatedAt;
  updatedAt?: UpgradeInvoiceResponseUpdatedAt;
  discountType?: UpgradeInvoiceResponseDiscountType;
  discountValue?: UpgradeInvoiceResponseDiscountValue;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  discountAmount?: string;
  discountReason?: UpgradeInvoiceResponseDiscountReason;
  discountNote?: UpgradeInvoiceResponseDiscountNote;
  discountById?: UpgradeInvoiceResponseDiscountById;
  freeReason?: UpgradeInvoiceResponseFreeReason;
  freeNote?: UpgradeInvoiceResponseFreeNote;
  gstOverridden?: boolean;
  saleTypeAmendedFrom?: UpgradeInvoiceResponseSaleTypeAmendedFrom;
  saleTypeAmendedById?: UpgradeInvoiceResponseSaleTypeAmendedById;
  saleTypeAmendedAt?: UpgradeInvoiceResponseSaleTypeAmendedAt;
  saleTypeAmendReason?: UpgradeInvoiceResponseSaleTypeAmendReason;
  promotion?: UpgradeInvoiceResponsePromotion;
  media?: UpgradeInvoiceResponseMedia;
  upgradeAmount?: UpgradeInvoiceResponseUpgradeAmount;
}

export type UpgradeItemCreateUnitPrice = number | string;

export type UpgradeItemCreateLineTotal = number | string;

export type UpgradeItemCreateDescription = string | null;

/**
 * SAL-10-14 (D23-2) — one package of the chosen invoice and the number of
sessions it is upgraded to. The treatment is the package's own; the new
price is the line staff confirm (GST-inclusive, as every invoice line).
 */
export interface UpgradeItemCreate {
  packageId: string;
  sessions: number;
  unitPrice: UpgradeItemCreateUnitPrice;
  lineTotal: UpgradeItemCreateLineTotal;
  description?: UpgradeItemCreateDescription;
}

/**
 * POST /finance/packages/{id}/upgrade/quote — the no-write auto-calc input
(§8.5). ``sessions`` is the target package's session count (5 | 10 | 20).
 */
export interface UpgradeQuoteRequest {
  toProgramId: string;
  sessions: number;
}

export type UpgradeQuoteResponseRuleId = string | null;

/**
 * The §8.5 upgrade auto-calc result (no write). ``remainingCredit`` is the
pro-rated value carried from the old package; ``topUpAmount`` is the
GST-inclusive difference owed on the new package.
 */
export interface UpgradeQuoteResponse {
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  computedValue: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  remainingCredit: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  newPrice: string;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  topUpAmount: string;
  usedSessions: number;
  ruleId?: UpgradeQuoteResponseRuleId;
}

/**
 * POST /finance/packages/{id}/upgrade — commit the upgrade (immediate, no
approval). ``paymentMethod`` tenders the ``topUpAmount`` (§8.5 step 5).
 */
export interface UpgradeRequest {
  toProgramId: string;
  sessions: number;
  paymentMethod?: string;
}

export type UsageCreateUtilisationTime = string | null;

export type UsageCreateRemarks = string | null;

export interface UsageCreate {
  customerId: string;
  outletId: string;
  utilisationTime?: UsageCreateUtilisationTime;
  /** @minItems 1 */
  lines: UsageLineCreate[];
  remarks?: UsageCreateRemarks;
}

export type UsageEditUtilisationDate = string | null;

export type UsageEditRemarks = string | null;

export type UsageEditSteps = UsageStepStaffEdit[] | null;

/**
 * CUS-12-10 / OPS-12-08 Edit — the date (Singapore day), the remarks and,
on a usage from a booking, the therapist of each step. Nothing else.
 */
export interface UsageEdit {
  utilisationDate?: UsageEditUtilisationDate;
  remarks?: UsageEditRemarks;
  steps?: UsageEditSteps;
}

export type UsageEditChangeBefore = string | null;

export type UsageEditChangeAfter = string | null;

export interface UsageEditChange {
  field: string;
  before?: UsageEditChangeBefore;
  after?: UsageEditChangeAfter;
}

export type UsageEditLogEntryEditedByName = string | null;

export interface UsageEditLogEntry {
  editedAt: string;
  editedByName?: UsageEditLogEntryEditedByName;
  changes?: UsageEditChange[];
}

export interface UsageLineCreate {
  packageId: string;
  /** @minimum 1 */
  quantity: number;
  steps?: UsageStepStaffCreate[];
}

export type UsageLineResponseInvoiceNumber = string | null;

export type UsageLineResponseSaleId = string | null;

export type UsageLineResponseUnitValue = string | null;

export interface UsageLineResponse {
  id: string;
  packageId: string;
  programName: string;
  quantity: number;
  steps?: UsageLineStep[];
  invoiceNumber?: UsageLineResponseInvoiceNumber;
  saleId?: UsageLineResponseSaleId;
  unitValue?: UsageLineResponseUnitValue;
}

export type UsageLineStepStaffId = string | null;

export type UsageLineStepStaffName = string | null;

/**
 * SAL-16-05 — a step of a usage made without a booking, with who did it.
 */
export interface UsageLineStep {
  sessionNumber: number;
  stepName: string;
  staffId?: UsageLineStepStaffId;
  staffName?: UsageLineStepStaffName;
  performers?: UsagePerformer[];
}

export interface UsageListResponse {
  items: UsageResponse[];
}

/**
 * SAL-16-12 — one of the staff who did a step together; the first is the
step's ``staff_id`` and all of them share its commission equally.
 */
export interface UsagePerformer {
  staffId: string;
  staffName: string;
}

export type UsageResponseRemarks = string | null;

export type UsageResponseVoidReason = string | null;

export type UsageResponseVoidRequestedAt = string | null;

export type UsageResponseVoidNumber = string | null;

export type UsageResponseVoidedAt = string | null;

export type UsageResponseCreatedByName = string | null;

export type UsageResponseOutletName = string | null;

export type UsageResponseAppointmentId = string | null;

export type UsageResponseSurvey = UsageSurvey | null;

export interface UsageResponse {
  id: string;
  usageNumber: string;
  customerId: string;
  customerName: string;
  outletId: string;
  utilisationTime: string;
  status: string;
  remarks: UsageResponseRemarks;
  lines: UsageLineResponse[];
  createdAt: string;
  voidReason?: UsageResponseVoidReason;
  voidRequestedAt?: UsageResponseVoidRequestedAt;
  voidNumber?: UsageResponseVoidNumber;
  voidedAt?: UsageResponseVoidedAt;
  createdByName?: UsageResponseCreatedByName;
  outletName?: UsageResponseOutletName;
  appointmentId?: UsageResponseAppointmentId;
  survey?: UsageResponseSurvey;
  steps?: UsageStep[];
  editLog?: UsageEditLogEntry[];
}

export type UsageStepStaffId = string | null;

export type UsageStepStaffName = string | null;

/**
 * A step of the booking behind the usage, with who did it.
 */
export interface UsageStep {
  appointmentStepId: string;
  stepName: string;
  staffId?: UsageStepStaffId;
  staffName?: UsageStepStaffName;
  performers?: UsagePerformer[];
  status: string;
}

export type UsageStepStaffCreateTreatmentStepId = string | null;

export type UsageStepStaffCreateStaffId = string | null;

export type UsageStepStaffCreateStaffIds = string[] | null;

/**
 * SAL-16 / D23-9 — who did one step of one session (empty = nobody). One
staff member as ``staff_id``, or several as ``staff_ids`` (the first is the
primary); both given = ``staff_ids`` wins.
 */
export interface UsageStepStaffCreate {
  /** @minimum 1 */
  sessionNumber: number;
  treatmentStepId?: UsageStepStaffCreateTreatmentStepId;
  staffId?: UsageStepStaffCreateStaffId;
  staffIds?: UsageStepStaffCreateStaffIds;
}

export type UsageStepStaffEditStaffId = string | null;

export type UsageStepStaffEditStaffIds = string[] | null;

export interface UsageStepStaffEdit {
  appointmentStepId: string;
  staffId?: UsageStepStaffEditStaffId;
  staffIds?: UsageStepStaffEditStaffIds;
}

export type UsageSurveyRating = string | null;

export type UsageSurveyComments = string | null;

export type UsageSurveyRatedAt = string | null;

/**
 * CUS-12-10 — the post-treatment survey of the booking behind a usage.
 */
export interface UsageSurvey {
  rating?: UsageSurveyRating;
  comments?: UsageSurveyComments;
  ratedAt?: UsageSurveyRatedAt;
  steps?: UsageSurveyStep[];
}

export type UsageSurveyStepStaffName = string | null;

export interface UsageSurveyStep {
  stepName: string;
  staffName?: UsageSurveyStepStaffName;
  rating: string;
}

export interface UsageVoidReasons {
  reasons: string[];
}

export type UsageVoidRequestOtherReason = string | null;

/**
 * POST /finance/usages/{id}/void-request — SAL-12-04 step 3.
 */
export interface UsageVoidRequest {
  reason: string;
  otherReason?: UsageVoidRequestOtherReason;
}

export interface UsageVsTreatmentsResponse {
  month: string;
  rows: UsageVsTreatmentsRow[];
  noStandardCount: number;
  noStandardNames: string[];
  total: number;
}

export type UsageVsTreatmentsRowProductSku = string | null;

export type UsageVsTreatmentsRowStockLocationId = string | null;

export type UsageVsTreatmentsRowStockLocationName = string | null;

export type UsageVsTreatmentsRowPercentVsExpected = string | null;

/**
 * INV-11-03: one in-house product with a standard use, for the month.
 */
export interface UsageVsTreatmentsRow {
  productId: string;
  productName: string;
  productSku: UsageVsTreatmentsRowProductSku;
  unit: string;
  stockLocationId: UsageVsTreatmentsRowStockLocationId;
  stockLocationName: UsageVsTreatmentsRowStockLocationName;
  treatmentsDone: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  expectedUse: string;
  actualUse: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  difference: string;
  percentVsExpected: UsageVsTreatmentsRowPercentVsExpected;
  standards: string[];
}

export type UserCreateRequestEmail = string | null;

export type UserCreateRequestUserType = string | null;

export type UserCreateRequestStaffId = string | null;

export type UserCreateRequestLoginId = string | null;

export type UserCreateRequestDisplayName = string | null;

/**
 * POST /api/users request body.

Spec B §7.1: ``email`` is now optional; ``loginId`` (staff/account handle)
is new. The service requires at least one of ``{email, loginId}``.
 */
export interface UserCreateRequest {
  email?: UserCreateRequestEmail;
  password: string;
  userType?: UserCreateRequestUserType;
  staffId?: UserCreateRequestStaffId;
  loginId?: UserCreateRequestLoginId;
  displayName?: UserCreateRequestDisplayName;
}

/**
 * PUT /api/users/[id]/user-id request body — the text typed as the User ID
(it becomes the Display name; the login ID is its lower-case form).
 */
export interface UserIdRequest {
  userId: string;
}

export type UserListResponseItem = { [key: string]: unknown };

export type UserListResponse = UserListResponseItem[];

/**
 * 'Outlets this person can see' (owner, 24 Oct 2026). ``custom`` False = never
set, so ``outletIds`` is the default (home outlet + extra outlets).
 */
export interface UserOutletAccess {
  outletIds: string[];
  custom: boolean;
  defaultOutletIds: string[];
}

export type UserOverrideGrantLevel = typeof UserOverrideGrantLevel[keyof typeof UserOverrideGrantLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserOverrideGrantLevel = {
  FULL: 'FULL',
  OWN: 'OWN',
  NONE: 'NONE',
  INHERIT: 'INHERIT',
} as const;

/**
 * A single per-user override grant. ``level="INHERIT"`` is the sentinel that
**deletes** the override row (fall back to the role grant); ``NONE`` is a real
explicit deny that wins over the role (A5 §7).
 */
export interface UserOverrideGrant {
  permissionKey: string;
  level: UserOverrideGrantLevel;
}

export interface UserPermissionCategory {
  key: string;
  label: string;
  perms: UserPermissionNode[];
}

export type UserPermissionNodeInheritedLevel = typeof UserPermissionNodeInheritedLevel[keyof typeof UserPermissionNodeInheritedLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPermissionNodeInheritedLevel = {
  FULL: 'FULL',
  OWN: 'OWN',
  NONE: 'NONE',
} as const;

export type UserPermissionNodeOverrideLevel = 'FULL' | 'OWN' | 'NONE' | null;

export type UserPermissionNodeEffectiveLevel = typeof UserPermissionNodeEffectiveLevel[keyof typeof UserPermissionNodeEffectiveLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPermissionNodeEffectiveLevel = {
  FULL: 'FULL',
  OWN: 'OWN',
  NONE: 'NONE',
} as const;

/**
 * One permission row in a user's effective grid (A5 §7 / A9 FE). Carries all
three layers so the Rights editor can render inherited-vs-overridden:
``inheritedLevel`` (the user's role grant, default ``NONE``),
``overrideLevel`` (the ``UserPermissionOverride`` row, or ``None`` = inherit),
and ``effectiveLevel`` (the resolved level = ``resolve()``).
 */
export interface UserPermissionNode {
  key: string;
  label: string;
  ownCapable: boolean;
  inheritedLevel: UserPermissionNodeInheritedLevel;
  overrideLevel: UserPermissionNodeOverrideLevel;
  effectiveLevel: UserPermissionNodeEffectiveLevel;
}

export type UserPermissionsGridRoleId = string | null;

export type UserPermissionsGridRole = RoleSummary | null;

/**
 * A user's effective permission grid = role grants + overrides, both shown
(A5 §7). Powers the per-user Rights editor (A9).
 */
export interface UserPermissionsGrid {
  userId: string;
  roleId?: UserPermissionsGridRoleId;
  role?: UserPermissionsGridRole;
  categories: UserPermissionCategory[];
}

export type UserResponseEmail = string | null;

export type UserResponseLoginId = string | null;

export type UserResponseLastLogin = string | null;

export type UserResponseCreatedAt = string | null;

export type UserResponseStaff = UserStaffResponse | null;

export type UserResponseDisplayName = string | null;

export type UserResponseName = string | null;

/**
 * Single user response from the legacy admin users endpoints.
 */
export interface UserResponse {
  id: string;
  email?: UserResponseEmail;
  loginId?: UserResponseLoginId;
  userType: string;
  isActive: boolean;
  lastLogin?: UserResponseLastLogin;
  createdAt?: UserResponseCreatedAt;
  staff?: UserResponseStaff;
  displayName?: UserResponseDisplayName;
  name?: UserResponseName;
}

/**
 * Staff summary embedded in user responses.
 */
export interface UserStaffResponse {
  id: string;
  name: string;
  role: string;
  outlet: OutletSummary;
}

export type UserSummaryEmail = string | null;

export interface UserSummary {
  id: string;
  email?: UserSummaryEmail;
}

export type UserUpdateRequestEmail = string | null;

export type UserUpdateRequestPassword = string | null;

export type UserUpdateRequestUserType = string | null;

export type UserUpdateRequestStaffId = string | null;

export type UserUpdateRequestIsActive = boolean | null;

export type UserUpdateRequestLoginId = string | null;

export type UserUpdateRequestDisplayName = string | null;

/**
 * PUT /api/users/[id] request body.
 */
export interface UserUpdateRequest {
  email?: UserUpdateRequestEmail;
  password?: UserUpdateRequestPassword;
  userType?: UserUpdateRequestUserType;
  staffId?: UserUpdateRequestStaffId;
  isActive?: UserUpdateRequestIsActive;
  loginId?: UserUpdateRequestLoginId;
  displayName?: UserUpdateRequestDisplayName;
}

/**
 * GET /finance/reports/utilization — FIN-G1 (served-from-packages only).

Aggregates ``Package`` rows: ``purchased`` = Σ ``totalSessions``,
``consumed`` = Σ ``usedSessions``, ``utilizationRate`` = consumed/purchased.
``byProgram`` groups by the package's program; the top-level totals are the
overall rollup. Filters: program/outlet/purchase-date window. The outlet
filter is best-effort — ``Package`` has no ``outletId`` so it is attributed
via the package's originating ``Sale`` (``SaleLine.packageId`` → ``Sale.outletId``).
 */
export interface UtilizationReportResponse {
  totalSessionsPurchased: number;
  sessionsConsumed: number;
  utilizationRate: number;
  byProgram?: ProgramUtilization[];
}

export type ValidationErrorLocItem = string | number;

export type ValidationErrorCtx = { [key: string]: unknown };

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
  input?: unknown;
  ctx?: ValidationErrorCtx;
}

/**
 * Stock valuation report with a grand total.
 */
export interface ValuationResponse {
  rows: ValuationRow[];
  grandTotalQty: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  grandTotalValue: string;
  total: number;
}

export type ValuationRowProductSku = string | null;

/**
 * One product x location valuation row.
 */
export interface ValuationRow {
  productId: string;
  productName: string;
  productSku: ValuationRowProductSku;
  stockLocationId: string;
  locationName: string;
  locationCode: string;
  totalQty: number;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  totalValue: string;
  hasUncostedStock: boolean;
}

export type VersionStatus = typeof VersionStatus[keyof typeof VersionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VersionStatus = {
  DRAFT: 'DRAFT',
  CONFIRMED: 'CONFIRMED',
  SUPERSEDED: 'SUPERSEDED',
  REJECTED: 'REJECTED',
} as const;

export type VipCheckRequestCustomerId = string | null;

/**
 * POST /form-templates/vip-changes/check — one customer, or all if empty.
 */
export interface VipCheckRequest {
  customerId?: VipCheckRequestCustomerId;
}

export interface VipCheckResponse {
  created: number;
  responseIds: string[];
}

export type VisitAvailabilityItemStartTime = string | null;

export type VisitAvailabilityItemEndTime = string | null;

export interface VisitAvailabilityItem {
  key: string;
  staffIds?: string[];
  startTime?: VisitAvailabilityItemStartTime;
  endTime?: VisitAvailabilityItemEndTime;
}

export type VisitAvailabilityLineStaffId = string | null;

export type VisitAvailabilityLineStaffName = string | null;

export type VisitAvailabilityLineState = typeof VisitAvailabilityLineState[keyof typeof VisitAvailabilityLineState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisitAvailabilityLineState = {
  FREE: 'FREE',
  OVERLAP: 'OVERLAP',
  PAST_SHIFT_END: 'PAST_SHIFT_END',
  START_OUTSIDE_SHIFT: 'START_OUTSIDE_SHIFT',
  STAFF_ACTIVITY: 'STAFF_ACTIVITY',
  NO_TIME: 'NO_TIME',
  NO_STAFF: 'NO_STAFF',
  NOT_CHECKED: 'NOT_CHECKED',
} as const;

export type VisitAvailabilityLineDetail = string | null;

export interface VisitAvailabilityLine {
  staffId?: VisitAvailabilityLineStaffId;
  staffName?: VisitAvailabilityLineStaffName;
  state: VisitAvailabilityLineState;
  detail?: VisitAvailabilityLineDetail;
}

export type VisitAvailabilityRequestRoomId = string | null;

export interface VisitAvailabilityRequest {
  outletId: string;
  date: string;
  roomId?: VisitAvailabilityRequestRoomId;
  items?: VisitAvailabilityItem[];
}

export interface VisitAvailabilityResponse {
  results?: VisitAvailabilityResult[];
}

export type VisitAvailabilityResultRoomWarning = string | null;

export interface VisitAvailabilityResult {
  key: string;
  lines?: VisitAvailabilityLine[];
  blocking?: boolean;
  roomWarning?: VisitAvailabilityResultRoomWarning;
}

export type VisitCreateCustomerId = string | null;

export type VisitCreateNewCustomer = CustomerCreate | null;

export type VisitCreateRoomId = string | null;

export type VisitCreateNotes = string | null;

export type VisitCreateWaitlistFrom = string | null;

export type VisitCreateWaitlistUntil = string | null;

export interface VisitCreate {
  customerId?: VisitCreateCustomerId;
  newCustomer?: VisitCreateNewCustomer;
  outletId: string;
  roomId?: VisitCreateRoomId;
  date: string;
  /** @minItems 1 */
  items: VisitItemCreate[];
  notes?: VisitCreateNotes;
  isWaitlist?: boolean;
  waitlistFrom?: VisitCreateWaitlistFrom;
  waitlistUntil?: VisitCreateWaitlistUntil;
  addOnOnlyConfirmed?: boolean;
}

export interface VisitCreateResponse {
  bookingGroupId: string;
  customerId: string;
  appointments?: AppointmentResponse[];
}

export type VisitItemCreateKind = typeof VisitItemCreateKind[keyof typeof VisitItemCreateKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisitItemCreateKind = {
  TREATMENT: 'TREATMENT',
  CONSULTATION: 'CONSULTATION',
  MANUAL: 'MANUAL',
} as const;

export type VisitItemCreateProgramId = string | null;

export type VisitItemCreatePackageId = string | null;

export type VisitItemCreateStaffId = string | null;

export type VisitItemCreateConsultantId = string | null;

export type VisitItemCreateBeauticianId = string | null;

export type VisitItemCreateTargetPackageId = string | null;

export type VisitItemCreatePurpose = 'PACKAGE' | 'SINGLE' | 'PRODUCT' | 'MIXED' | null;

export type VisitItemCreateReason = string | null;

/**
 * One card of the booking page.
 */
export interface VisitItemCreate {
  kind?: VisitItemCreateKind;
  programId?: VisitItemCreateProgramId;
  packageId?: VisitItemCreatePackageId;
  staffId?: VisitItemCreateStaffId;
  consultantId?: VisitItemCreateConsultantId;
  beauticianId?: VisitItemCreateBeauticianId;
  targetPackageId?: VisitItemCreateTargetPackageId;
  purpose?: VisitItemCreatePurpose;
  reason?: VisitItemCreateReason;
  startTime: string;
  endTime: string;
}

export type VoidPayNoticeTreatmentDate = string | null;

/**
 * D22-10 — one commission line on a voided invoice's completed treatments.
 */
export interface VoidPayNotice {
  staffName: string;
  treatmentDate?: VoidPayNoticeTreatmentDate;
  /** @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$ */
  amount: string;
  status: string;
  action: string;
}

/**
 * POST /finance/sales/{id}/void-request — ask HQ to void an invoice.
 */
export interface VoidRequestCreate {
  reason: string;
}

export type VoidSettlementRequestRefundAmount = number | string;

export type VoidSettlementRequestCreditNoteAmount = number | string;

export type VoidSettlementRequestReason = string | null;

/**
 * POST /finance/approval-requests/{id}/void-settlement — SAL-13-04 step 6:
what HQ does with the money paid on the voided invoice. Either part may be
0 (SAL-13-11: part refund, part credit note).
 */
export interface VoidSettlementRequest {
  refundAmount?: VoidSettlementRequestRefundAmount;
  creditNoteAmount?: VoidSettlementRequestCreditNoteAmount;
  reason?: VoidSettlementRequestReason;
  forfeit?: boolean;
}

export type VoidUsageRowVoidedDate = string | null;

export interface VoidUsageRow {
  voidedDate: VoidUsageRowVoidedDate;
  voidNumber: string;
  usageNumber: string;
  invoiceNumber: string;
  customerId: string;
  customerName: string;
  item: string;
  quantity: number;
  outlet: string;
  requestedBy: string;
  voidedBy: string;
  therapists: string;
  remark: string;
}

export interface VoidUsagesByOutlet {
  outlet: string;
  voids: number;
  sessions: number;
}

export interface VoidUsagesByUser {
  requestedBy: string;
  outlet: string;
  voids: number;
  sessions: number;
}

export interface VoidUsagesReport {
  dateFrom: string;
  dateTo: string;
  voidedUsages: number;
  sessionsReturned: number;
  waitingForHq: number;
  byOutlet: VoidUsagesByOutlet[];
  byUser: VoidUsagesByUser[];
  rows: VoidUsageRow[];
}

export interface WaitingRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  waitingOn: string;
}

export interface WeekDay {
  date: string;
  isToday: boolean;
  isPast: boolean;
  items: DayItem[];
}

export interface WeekTrend {
  weekStart: string;
  leads: number;
  appointments: number;
  consultations: number;
  closed: number;
  packages: number;
}

export interface WeeklyPoint {
  weekStart: string;
  value: number;
}

export type WeeklyRosterDayShiftTypeName = string | null;

export type WeeklyRosterDayCategory = string | null;

export type WeeklyRosterDayLeaveType = string | null;

export type WeeklyRosterDayOutletId = string | null;

export interface WeeklyRosterDay {
  startTime: string;
  endTime: string;
  isOff: boolean;
  portion?: string;
  shiftTypeName?: WeeklyRosterDayShiftTypeName;
  category?: WeeklyRosterDayCategory;
  leaveType?: WeeklyRosterDayLeaveType;
  outletId?: WeeklyRosterDayOutletId;
  [key: string]: unknown;
 }

export type WeeklyRosterEntryDays = {[key: string]: WeeklyRosterDay[] | null};

export interface WeeklyRosterEntry {
  id: string;
  name: string;
  role: string;
  skillLevel: number;
  outlet: ScheduleOutletSummary;
  days: WeeklyRosterEntryDays;
  [key: string]: unknown;
 }

export interface WeeklyScheduleResponse {
  weekStart: string;
  weekDays: string[];
  roster: WeeklyRosterEntry[];
  [key: string]: unknown;
 }

export interface WhatToSellAdd {
  appointmentId: string;
}

/**
 * One of today's bookings whose customer is not on the list yet.
 */
export interface WhatToSellBooking {
  appointmentId: string;
  customerName: string;
  time: string;
}

export type WhatToSellItemOutAppointmentId = string | null;

export type WhatToSellItemOutFound = string | null;

export type WhatToSellItemOutOutcomes = {[key: string]: string};

export interface WhatToSellItemOut {
  id: string;
  appointmentId?: WhatToSellItemOutAppointmentId;
  customerId: string;
  customerName: string;
  time: string;
  found?: WhatToSellItemOutFound;
  suggested?: string[];
  picks?: string[];
  outcomes?: WhatToSellItemOutOutcomes;
  addedByHand?: boolean;
}

export type WhatToSellMarkOutcome = string | null;

export interface WhatToSellMark {
  key: string;
  outcome?: WhatToSellMarkOutcome;
}

export interface WhatToSellPicks {
  picks: string[];
}

export type WhatToSellResponseSentBy = string | null;

export type WhatToSellResponseSentAt = string | null;

export type WhatToSellResponseConfirmedBy = string | null;

export type WhatToSellResponseConfirmedAt = string | null;

export interface WhatToSellResponse {
  id: string;
  outletId: string;
  businessDate: string;
  status: string;
  sentBy?: WhatToSellResponseSentBy;
  sentAt?: WhatToSellResponseSentAt;
  confirmedBy?: WhatToSellResponseConfirmedBy;
  confirmedAt?: WhatToSellResponseConfirmedAt;
  items: WhatToSellItemOut[];
  pickedCount: number;
  bookingsNotOnList?: WhatToSellBooking[];
}

export type WhoCanAsk = typeof WhoCanAsk[keyof typeof WhoCanAsk];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WhoCanAsk = {
  ALL: 'ALL',
  HQ: 'HQ',
} as const;

export type XeroBooksLastSyncAt = string | null;

/**
 * DSH-18-04 'Books from Xero': read access to Xero reports does not exist
yet, so every figure is '—' with the time of the last good sync.
 */
export interface XeroBooks {
  connected: boolean;
  lastSyncAt: XeroBooksLastSyncAt;
  note: string;
}

/**
 * GET /finance/xero/outbox — the accounting hand-off outbox (FIN-F1).
 */
export interface XeroOutboxListResponse {
  outbox?: XeroOutboxResponse[];
  total: number;
}

export type XeroOutboxResponseSaleId = string | null;

export type XeroOutboxResponseXeroId = string | null;

export type XeroOutboxResponseLastError = string | null;

export type XeroOutboxResponseCreatedAt = string | null;

/**
 * A single ``XeroSyncOutbox`` row (§5.10) — what would be / was pushed to
Xero. The actual push is FIN-F1, blocked on the Xero API (§9 A).
 */
export interface XeroOutboxResponse {
  id: string;
  entityType: string;
  saleId?: XeroOutboxResponseSaleId;
  status: string;
  xeroId?: XeroOutboxResponseXeroId;
  attempts: number;
  lastError?: XeroOutboxResponseLastError;
  createdAt?: XeroOutboxResponseCreatedAt;
}

export type XeroSyncRequestOutboxIds = string[] | null;

/**
 * POST /finance/xero/sync request (FIN-F1 — BLOCKED on the Xero API, §9 A).
``outboxIds`` optionally narrows the push to specific outbox rows.
 */
export interface XeroSyncRequest {
  outboxIds?: XeroSyncRequestOutboxIds;
}

export interface YearMonths {
  year: number;
  months: MonthValue[];
}

export type ListAuditTrailApiAuditTrailGetParams = {
from?: string | null;
to?: string | null;
userId?: string | null;
module?: string | null;
event?: string | null;
q?: string | null;
sort?: ListAuditTrailApiAuditTrailGetSort;
dir?: ListAuditTrailApiAuditTrailGetDir;
/**
 * @minimum 1
 */
page?: number;
};

export type ListAuditTrailApiAuditTrailGetSort = typeof ListAuditTrailApiAuditTrailGetSort[keyof typeof ListAuditTrailApiAuditTrailGetSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListAuditTrailApiAuditTrailGetSort = {
  time: 'time',
  ip: 'ip',
  user: 'user',
  module: 'module',
  event: 'event',
  detail: 'detail',
} as const;

export type ListAuditTrailApiAuditTrailGetDir = typeof ListAuditTrailApiAuditTrailGetDir[keyof typeof ListAuditTrailApiAuditTrailGetDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListAuditTrailApiAuditTrailGetDir = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ExportAuditTrailApiAuditTrailExportGetParams = {
format?: ExportAuditTrailApiAuditTrailExportGetFormat;
from?: string | null;
to?: string | null;
userId?: string | null;
module?: string | null;
event?: string | null;
q?: string | null;
sort?: ExportAuditTrailApiAuditTrailExportGetSort;
dir?: ExportAuditTrailApiAuditTrailExportGetDir;
};

export type ExportAuditTrailApiAuditTrailExportGetFormat = typeof ExportAuditTrailApiAuditTrailExportGetFormat[keyof typeof ExportAuditTrailApiAuditTrailExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportAuditTrailApiAuditTrailExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ExportAuditTrailApiAuditTrailExportGetSort = typeof ExportAuditTrailApiAuditTrailExportGetSort[keyof typeof ExportAuditTrailApiAuditTrailExportGetSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportAuditTrailApiAuditTrailExportGetSort = {
  time: 'time',
  ip: 'ip',
  user: 'user',
  module: 'module',
  event: 'event',
  detail: 'detail',
} as const;

export type ExportAuditTrailApiAuditTrailExportGetDir = typeof ExportAuditTrailApiAuditTrailExportGetDir[keyof typeof ExportAuditTrailApiAuditTrailExportGetDir];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportAuditTrailApiAuditTrailExportGetDir = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ListAppointmentsApiAppointmentsGetParams = {
date?: string | null;
outletId?: string | null;
customerId?: string | null;
status?: string | null;
};

export type CreateAppointmentApiAppointmentsPost201 = AppointmentResponse | AppointmentComboResponse;

export type GetActiveAppointmentsApiAppointmentsActiveGetParams = {
outletId?: string | null;
staffId?: string | null;
};

export type GetBookingOptionsApiAppointmentsBookingOptionsGetParams = {
outletId: string;
date: string;
customerId?: string | null;
};

export type GetAvailabilityApiAppointmentsAvailabilityGetParams = {
date: string;
outletId: string;
startTime: string;
programId?: string | null;
appointmentType?: string | null;
excludeAppointmentId?: string | null;
};

export type GetTimeslotsApiAppointmentsTimeslotsGetParams = {
date: string;
outletId?: string | null;
};

export type GetAppointmentHistoryApiAppointmentsHistoryGetParams = {
outletId?: string | null;
search?: string | null;
status?: string | null;
dateFrom?: string | null;
dateTo?: string | null;
customerId?: string | null;
/**
 * @minimum 1
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ExportAppointmentsApiAppointmentsExportGetParams = {
outletId?: string | null;
status?: string | null;
format?: ExportAppointmentsApiAppointmentsExportGetFormat;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
};

export type ExportAppointmentsApiAppointmentsExportGetFormat = typeof ExportAppointmentsApiAppointmentsExportGetFormat[keyof typeof ExportAppointmentsApiAppointmentsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportAppointmentsApiAppointmentsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListMakeUpOpenStepsApiAppointmentsMakeUpOpenStepsGetParams = {
customerId: string;
};

export type CompleteAppointmentApiAppointmentsAppointmentIdCompletePostBody = AppointmentCompleteRequest | null;

export type ListProbationEndingApiStaffProbationEndingGetParams = {
/**
 * @minimum 0
 * @maximum 365
 */
withinDays?: number;
};

export type DownloadStaffDetailsReportApiStaffDetailsReportGetParams = {
outletId?: string | null;
viewBy?: DownloadStaffDetailsReportApiStaffDetailsReportGetViewBy;
};

export type DownloadStaffDetailsReportApiStaffDetailsReportGetViewBy = typeof DownloadStaffDetailsReportApiStaffDetailsReportGetViewBy[keyof typeof DownloadStaffDetailsReportApiStaffDetailsReportGetViewBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DownloadStaffDetailsReportApiStaffDetailsReportGetViewBy = {
  active: 'active',
  inactive: 'inactive',
  all: 'all',
} as const;

export type ListStaffDocumentsApiStaffStaffIdDocumentsGetParams = {
docType?: string | null;
};

export type OutletStatusApiTabletsStatusGetParams = {
outletId: string;
};

export type ListTreatmentsApiTreatmentsGetParams = {
search?: string | null;
category?: string | null;
includeArchived?: boolean;
bookableOnly?: boolean;
};

export type GetTreatmentMatrixApiTreatmentsMatrixGetParams = {
outletId?: string | null;
};

export type GetTreatmentApiTreatmentsTreatmentIdGetParams = {
outletId?: string | null;
};

export type ReorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPostBody = {[key: string]: string[]};

export type ListStaffApiStaffGetParams = {
outletId?: string | null;
role?: string | null;
includeInactive?: boolean;
byDepartment?: boolean;
includeDetailsNeeded?: boolean;
};

export type StaffBirthdaysTodayApiStaffBirthdaysTodayGetParams = {
outletId?: string | null;
month?: number | null;
day?: number | null;
};

export type StaffCoveringCandidatesApiStaffCoveringCandidatesGetParams = {
outletId: string;
};

export type GetStaffShiftsApiStaffStaffIdShiftsGetParams = {
startDate?: string | null;
endDate?: string | null;
};

export type BulkDeleteStaffShiftsApiStaffStaffIdShiftsBulkDeleteParams = {
/**
 * YYYY-MM
 */
month?: string | null;
from?: string | null;
to?: string | null;
};

export type ListRosterChangeLogApiRosterChangeLogGetParams = {
from?: string | null;
to?: string | null;
staffId?: string | null;
};

export type GetTrainingMatrixApiTrainingMatrixGetParams = {
outletId?: string | null;
role?: string | null;
includeInactive?: boolean;
};

export type ListStaffMeetingsApiStaffMeetingsGetParams = {
date?: string | null;
weekStart?: string | null;
outletId?: string | null;
meetingType?: string | null;
dateFrom?: string | null;
dateTo?: string | null;
staffId?: string | null;
};

export type ExportStaffMeetingsApiStaffMeetingsExportGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string | null;
meetingType?: string | null;
format?: ExportStaffMeetingsApiStaffMeetingsExportGetFormat;
};

export type ExportStaffMeetingsApiStaffMeetingsExportGetFormat = typeof ExportStaffMeetingsApiStaffMeetingsExportGetFormat[keyof typeof ExportStaffMeetingsApiStaffMeetingsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportStaffMeetingsApiStaffMeetingsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListRoomsApiRoomsGetParams = {
outletId?: string | null;
includeInactive?: boolean;
};

export type GetRoomAvailabilityApiRoomsAvailabilityGetParams = {
outletId: string;
date: string;
startTime: string;
endTime: string;
};

export type GetRoomStatusApiRoomsStatusGetParams = {
outletId?: string | null;
date?: string | null;
};

export type GetRoomHistoryApiRoomsRoomIdHistoryGetParams = {
period?: RoomHistoryPeriodType;
date?: string | null;
};

export type OutletHoursForDatesApiOutletsOutletIdHoursGetParams = {
from: string;
to: string;
};

export type ListShiftTypesApiShiftTypesGetParams = {
includeInactive?: boolean;
};

export type GetEarningsApiCommissionEarningsGetParams = {
outletId?: string | null;
month?: string | null;
mine?: boolean;
};

export type GetStaffSummaryApiCommissionStaffStaffIdGetParams = {
month?: string | null;
};

export type ListBreakdownApiCommissionBreakdownGetParams = {
month: string;
};

export type ExportCustomersApiCustomersExportGetParams = {
outletId?: string | null;
format?: ExportCustomersApiCustomersExportGetFormat;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
};

export type ExportCustomersApiCustomersExportGetFormat = typeof ExportCustomersApiCustomersExportGetFormat[keyof typeof ExportCustomersApiCustomersExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportCustomersApiCustomersExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListCustomersApiCustomersGetParams = {
search?: string | null;
outletId?: string | null;
includeInactive?: boolean;
ageBand?: string | null;
ageAsOf?: string | null;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type PreviewMergeApiCustomersMergePreviewGetParams = {
sourceId: string;
targetId: string;
};

export type ListGroupsApiCustomerGroupsGetParams = {
type?: string | null;
status?: string | null;
};

export type ListTicketsApiCustomerTicketsGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string | null;
type?: TicketType | null;
category?: string | null;
status?: TicketStatus | null;
staffId?: string | null;
search?: string | null;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type GetTicketSummaryApiCustomerTicketsSummaryGetParams = {
/**
 * @minimum 2000
 * @maximum 2100
 */
year: number;
outletId?: string | null;
};

export type GetDailyReportApiDailyReportGetParams = {
staffId?: string | null;
date?: string | null;
};

export type ListDisputesApiDailyReportDisputesGetParams = {
status?: string | null;
staffId?: string | null;
};

export type OutletTodayApiDashboardOutletTodayGetParams = {
outletId?: string | null;
};

export type OutletSalesApiDashboardOutletSalesGetParams = {
outletId?: string | null;
};

export type KpisApiDashboardKpisGetParams = {
outletId?: string | null;
};

export type NeedsAttentionApiDashboardNeedsAttentionGetParams = {
outletId?: string | null;
};

export type QueueBadgesApiDashboardQueueBadgesGetParams = {
outletId?: string | null;
};

export type WhatToSellApiDashboardWhatToSellGetParams = {
outletId: string;
};

export type BusinessSummaryApiDashboardBusinessSummaryGetParams = {
/**
 * @pattern ^(month|last_month|quarter)$
 */
period?: string;
outlet?: string | null;
};

export type BusinessStaffApiDashboardBusinessStaffGetParams = {
/**
 * @pattern ^(month|last_month|quarter)$
 */
period?: string;
outlet?: string | null;
};

export type BusinessCustomersApiDashboardBusinessCustomersGetParams = {
/**
 * @pattern ^(month|last_month|quarter)$
 */
period?: string;
outlet?: string | null;
};

export type BusinessMarketingApiDashboardBusinessMarketingGetParams = {
/**
 * @pattern ^(month|last_month|quarter)$
 */
period?: string;
outlet?: string | null;
};

export type BusinessSalesApiDashboardBusinessSalesGetParams = {
/**
 * @pattern ^(month|last_month|quarter)$
 */
period?: string;
outlet?: string | null;
};

export type BusinessYoyApiDashboardBusinessYoyGetParams = {
years: number[];
outlet?: string | null;
};

export type WhatToSellTodayPicksApiDashboardWhatToSellTodayPicksGetParams = {
outletId: string;
};

export type DeskHistoryApiOfficeDeskDesksOwnerUserIdHistoryGetParams = {
from?: string | null;
to?: string | null;
};

export type ListRulesApiOfficeDeskRulesGetParams = {
owner?: string | null;
};

export type ListDraftsApiFinanceSalesDraftsGetParams = {
outletId?: string | null;
createdById?: string | null;
};

export type CountDraftsApiFinanceSalesDraftsCountGetParams = {
outletId?: string | null;
createdById?: string | null;
};

export type ListHeldApiFinanceHeldInvoicesGetParams = {
outletId?: string | null;
};

export type ListSalesApiFinanceSalesGetParams = {
customerId?: string | null;
outletId?: string | null;
outletIds?: string | null;
from?: string | null;
to?: string | null;
status?: string | null;
saleType?: string | null;
search?: string | null;
invoiceNumber?: string | null;
customerName?: string | null;
includeVoided?: boolean;
freeReason?: string | null;
limit?: number;
offset?: number;
};

export type ExportSalesApiFinanceSalesExportGetParams = {
outletId?: string | null;
outletIds?: string | null;
customerId?: string | null;
from?: string | null;
to?: string | null;
status?: string | null;
saleType?: string | null;
search?: string | null;
invoiceNumber?: string | null;
customerName?: string | null;
includeVoided?: boolean;
freeReason?: string | null;
format?: ExportSalesApiFinanceSalesExportGetFormat;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
};

export type ExportSalesApiFinanceSalesExportGetFormat = typeof ExportSalesApiFinanceSalesExportGetFormat[keyof typeof ExportSalesApiFinanceSalesExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportSalesApiFinanceSalesExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetPricingApiFinancePricingGetParams = {
programId?: string | null;
};

export type ListIhipAlertsApiFinanceIhipAlertsGetParams = {
outletId?: string | null;
};

export type PreviewIhipScheduleApiFinanceIhipSchedulePreviewGetParams = {
programId: string;
variant: string;
sessions: number;
};

export type CheckFirewallApiFinanceIhipPackageIdFirewallGetParams = {
sessionNumber?: number | null;
};

export type RefundQuoteApiFinancePackagesPackageIdRefundQuotePostBody = RefundQuoteRequest | null;

export type ListPackageChangesApiFinancePackageChangesGetParams = {
approvalStatus?: string | null;
outletId?: string | null;
};

export type GetDailyCloseApiFinanceDailyCloseGetParams = {
outletId: string;
date: string;
};

export type GetNetSalesApiFinanceNetSalesGetParams = {
outletId: string;
periodYear: number;
periodMonth: number;
staffId?: string | null;
};

export type ListRulesApiFinanceRulesGetParams = {
domain?: string | null;
};

export type ListXeroOutboxApiFinanceXeroOutboxGetParams = {
status?: string | null;
};

export type UtilizationReportApiFinanceReportsUtilizationGetParams = {
from?: string | null;
to?: string | null;
programId?: string | null;
outletId?: string | null;
};

export type LtvCaptureApiFinanceReportsLtvGetParams = {
customerId?: string | null;
};

export type ListUsagesApiFinanceUsagesGetParams = {
customerId?: string | null;
outletId?: string | null;
dateFrom?: string | null;
dateTo?: string | null;
showVoided?: boolean;
usageNumber?: string | null;
customer?: string | null;
limit?: number;
offset?: number;
};

export type ListCreditNotesApiFinanceCreditNotesGetParams = {
customerId?: string | null;
type?: string | null;
startDate?: string | null;
endDate?: string | null;
number?: string | null;
customer?: string | null;
outletId?: string | null;
creditType?: string | null;
noteStatus?: string | null;
};

export type ExportCreditNotesApiFinanceCreditNotesExportGetParams = {
format?: ExportCreditNotesApiFinanceCreditNotesExportGetFormat;
customerId?: string | null;
type?: string | null;
startDate?: string | null;
endDate?: string | null;
number?: string | null;
customer?: string | null;
outletId?: string | null;
creditType?: string | null;
noteStatus?: string | null;
};

export type ExportCreditNotesApiFinanceCreditNotesExportGetFormat = typeof ExportCreditNotesApiFinanceCreditNotesExportGetFormat[keyof typeof ExportCreditNotesApiFinanceCreditNotesExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportCreditNotesApiFinanceCreditNotesExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type CustomerCreditNoteBalancesApiFinanceCreditNotesBalancesGetParams = {
customerId: string;
};

export type ListApprovalRequestsApiFinanceApprovalRequestsGetParams = {
view?: string;
category?: string | null;
start?: string | null;
end?: string | null;
outletId?: string | null;
};

export type GetReturnableProductsApiFinanceProductReturnsReturnableGetParams = {
saleId: string;
};

export type GetSalesByCustomerApiFinanceReportsSalesByCustomerGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetSalesByCustomerApiFinanceReportsSalesByCustomerGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetSalesByCustomerApiFinanceReportsSalesByCustomerGetFormat = typeof GetSalesByCustomerApiFinanceReportsSalesByCustomerGetFormat[keyof typeof GetSalesByCustomerApiFinanceReportsSalesByCustomerGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSalesByCustomerApiFinanceReportsSalesByCustomerGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetFormat = typeof GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetFormat[keyof typeof GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetFormat = typeof GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetFormat[keyof typeof GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetFormat = typeof GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetFormat[keyof typeof GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetConversionApiFinanceReportsConversionGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetConversionApiFinanceReportsConversionGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetConversionApiFinanceReportsConversionGetFormat = typeof GetConversionApiFinanceReportsConversionGetFormat[keyof typeof GetConversionApiFinanceReportsConversionGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetConversionApiFinanceReportsConversionGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetFormat = typeof GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetFormat[keyof typeof GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetItemSoldByDateApiFinanceReportsItemSoldByDateGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetItemSoldByDateApiFinanceReportsItemSoldByDateGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetItemSoldByDateApiFinanceReportsItemSoldByDateGetFormat = typeof GetItemSoldByDateApiFinanceReportsItemSoldByDateGetFormat[keyof typeof GetItemSoldByDateApiFinanceReportsItemSoldByDateGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetItemSoldByDateApiFinanceReportsItemSoldByDateGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetFormat = typeof GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetFormat[keyof typeof GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetFormat = typeof GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetFormat[keyof typeof GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetFormat = typeof GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetFormat[keyof typeof GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetFormat = typeof GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetFormat[keyof typeof GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string[] | null;
displayDetails?: boolean;
format?: GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetFormat;
customerType?: string | null;
category?: string | null;
};

export type GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetFormat = typeof GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetFormat[keyof typeof GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetNetSalesReportApiFinanceReportsNetSalesGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string | null;
};

export type GetVoidUsagesReportApiFinanceReportsVoidUsagesGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
requestedBy?: string | null;
};

export type GetCollectionReportApiFinanceReportsCollectionGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetCollectionReportApiFinanceReportsCollectionGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetCollectionReportApiFinanceReportsCollectionGetFormat = typeof GetCollectionReportApiFinanceReportsCollectionGetFormat[keyof typeof GetCollectionReportApiFinanceReportsCollectionGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollectionReportApiFinanceReportsCollectionGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetGstReportApiFinanceReportsGstGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetGstReportApiFinanceReportsGstGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetGstReportApiFinanceReportsGstGetFormat = typeof GetGstReportApiFinanceReportsGstGetFormat[keyof typeof GetGstReportApiFinanceReportsGstGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetGstReportApiFinanceReportsGstGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetCreditNotesReportApiFinanceReportsCreditNotesGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetCreditNotesReportApiFinanceReportsCreditNotesGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetCreditNotesReportApiFinanceReportsCreditNotesGetFormat = typeof GetCreditNotesReportApiFinanceReportsCreditNotesGetFormat[keyof typeof GetCreditNotesReportApiFinanceReportsCreditNotesGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCreditNotesReportApiFinanceReportsCreditNotesGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetFormat = typeof GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetFormat[keyof typeof GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetTopSellersReportApiFinanceReportsTopSellersGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetTopSellersReportApiFinanceReportsTopSellersGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetTopSellersReportApiFinanceReportsTopSellersGetFormat = typeof GetTopSellersReportApiFinanceReportsTopSellersGetFormat[keyof typeof GetTopSellersReportApiFinanceReportsTopSellersGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTopSellersReportApiFinanceReportsTopSellersGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetFormat = typeof GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetFormat[keyof typeof GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetFormat = typeof GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetFormat[keyof typeof GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetConsultationResultsReportApiFinanceReportsConsultationResultsGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetConsultationResultsReportApiFinanceReportsConsultationResultsGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetConsultationResultsReportApiFinanceReportsConsultationResultsGetFormat = typeof GetConsultationResultsReportApiFinanceReportsConsultationResultsGetFormat[keyof typeof GetConsultationResultsReportApiFinanceReportsConsultationResultsGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetConsultationResultsReportApiFinanceReportsConsultationResultsGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetSalesByStaffReportApiFinanceReportsSalesByStaffGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string[] | null;
groupBy?: string | null;
format?: GetSalesByStaffReportApiFinanceReportsSalesByStaffGetFormat;
tab?: string | null;
expiringWithin?: number | null;
balancesBy?: string | null;
aboveLimitOnly?: boolean | null;
show?: number | null;
fields?: string | null;
};

export type GetSalesByStaffReportApiFinanceReportsSalesByStaffGetFormat = typeof GetSalesByStaffReportApiFinanceReportsSalesByStaffGetFormat[keyof typeof GetSalesByStaffReportApiFinanceReportsSalesByStaffGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSalesByStaffReportApiFinanceReportsSalesByStaffGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListResponsesApiFormTemplatesResponsesGetParams = {
formTemplateId?: string | null;
search?: string | null;
outletId?: string | null;
menu?: string | null;
status?: string | null;
from?: string | null;
to?: string | null;
dateFrom?: string | null;
dateTo?: string | null;
customerId?: string | null;
};

export type ExportResponsesApiFormTemplatesResponsesExportGetParams = {
formTemplateId?: string | null;
search?: string | null;
outletId?: string | null;
menu?: string | null;
status?: string | null;
from?: string | null;
to?: string | null;
format?: ExportResponsesApiFormTemplatesResponsesExportGetFormat;
};

export type ExportResponsesApiFormTemplatesResponsesExportGetFormat = typeof ExportResponsesApiFormTemplatesResponsesExportGetFormat[keyof typeof ExportResponsesApiFormTemplatesResponsesExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportResponsesApiFormTemplatesResponsesExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ApproveResponseApiFormTemplatesResponsesResponseIdApprovePostParams = {
overrideCreditCap?: boolean;
};

export type ApproveResponseApiFormTemplatesResponsesResponseIdApprovePostBody = FormResponseApprove | null;

export type ListTemplatesApiFormTemplatesGetParams = {
status?: string | null;
search?: string | null;
outletId?: string | null;
menu?: string | null;
};

export type ListPublishedApiFormTemplatesPublishedGetParams = {
menu: string;
search?: string | null;
outletId?: string | null;
};

export type ListSubmissionsApiHrFormsSubmissionsGetParams = {
formType?: string | null;
outletId?: string | null;
limit?: number;
offset?: number;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
};

export type ExportSubmissionsApiHrFormsSubmissionsExportGetParams = {
formType: string;
outletId?: string | null;
format?: ExportSubmissionsApiHrFormsSubmissionsExportGetFormat;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
};

export type ExportSubmissionsApiHrFormsSubmissionsExportGetFormat = typeof ExportSubmissionsApiHrFormsSubmissionsExportGetFormat[keyof typeof ExportSubmissionsApiHrFormsSubmissionsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportSubmissionsApiHrFormsSubmissionsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListProductsApiInventoryProductsGetParams = {
includeInactive?: boolean;
category?: string | null;
isRetail?: boolean | null;
search?: string | null;
};

export type PreviewProductMasterImportApiInventoryProductsMasterImportPreviewPostParams = {
updatePrices?: boolean;
};

export type RunProductMasterImportApiInventoryProductsMasterImportPostParams = {
updatePrices?: boolean;
};

export type ListStockLocationsApiInventoryLocationsGetParams = {
includeInactive?: boolean;
};

export type GetStockOnHandApiInventoryStockGetParams = {
locationId?: string | null;
productId?: string | null;
includeDepleted?: boolean;
};

export type GetExpiringStockApiInventoryExpiringGetParams = {
/**
 * @minimum 0
 * @maximum 10000
 */
withinDays?: number;
locationId?: string | null;
productId?: string | null;
};

export type ListStockDocumentsApiInventoryDocumentsGetParams = {
kind?: string | null;
status?: string | null;
};

export type ListTransfersApiInventoryTransfersGetParams = {
status?: string | null;
fromLocationId?: string | null;
toLocationId?: string | null;
locationId?: string | null;
};

export type FillFromMinimumApiInventoryTransfersFillFromMinimumGetParams = {
fromLocationId: string;
toLocationId: string;
};

export type SendTransferApiInventoryTransfersTransferIdSendPostBody = TransferSendRequest | null;

export type ReceiveTransferApiInventoryTransfersTransferIdReceivePostBody = TransferReceiveRequest | null;

export type CancelTransferApiInventoryTransfersTransferIdCancelPostBody = TransferReasonRequest | null;

export type ListRequestsApiInventoryRequestsGetParams = {
status?: string | null;
locationId?: string | null;
};

export type ListStocktakesApiInventoryStocktakesGetParams = {
status?: string | null;
locationId?: string | null;
};

export type InventoryLevelApiInventoryLevelGetParams = {
locationId: string;
status?: string;
};

export type ExportInventoryLevelApiInventoryLevelExportGetParams = {
locationId: string;
status?: string;
format?: ExportInventoryLevelApiInventoryLevelExportGetFormat;
};

export type ExportInventoryLevelApiInventoryLevelExportGetFormat = typeof ExportInventoryLevelApiInventoryLevelExportGetFormat[keyof typeof ExportInventoryLevelApiInventoryLevelExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportInventoryLevelApiInventoryLevelExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type StockLedgerApiInventoryLedgerGetParams = {
dateFrom: string;
dateTo: string;
locationId?: string | null;
productId?: string | null;
groupBy?: string;
per?: string;
};

export type ExportStockLedgerApiInventoryLedgerExportGetParams = {
dateFrom: string;
dateTo: string;
locationId?: string | null;
productId?: string | null;
groupBy?: string;
per?: string;
format?: ExportStockLedgerApiInventoryLedgerExportGetFormat;
};

export type ExportStockLedgerApiInventoryLedgerExportGetFormat = typeof ExportStockLedgerApiInventoryLedgerExportGetFormat[keyof typeof ExportStockLedgerApiInventoryLedgerExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportStockLedgerApiInventoryLedgerExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ExportMovementsApiInventoryMovementsExportGetParams = {
productId?: string | null;
locationId?: string | null;
kind?: string[] | null;
dateFrom?: string | null;
dateTo?: string | null;
format?: ExportMovementsApiInventoryMovementsExportGetFormat;
};

export type ExportMovementsApiInventoryMovementsExportGetFormat = typeof ExportMovementsApiInventoryMovementsExportGetFormat[keyof typeof ExportMovementsApiInventoryMovementsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportMovementsApiInventoryMovementsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type LowStockReportApiInventoryReportsLowStockGetParams = {
locationId?: string | null;
onlyOut?: boolean;
use?: string;
};

export type ExportLowStockApiInventoryReportsLowStockExportGetParams = {
locationId?: string | null;
onlyOut?: boolean;
use?: string;
format?: ExportLowStockApiInventoryReportsLowStockExportGetFormat;
};

export type ExportLowStockApiInventoryReportsLowStockExportGetFormat = typeof ExportLowStockApiInventoryReportsLowStockExportGetFormat[keyof typeof ExportLowStockApiInventoryReportsLowStockExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportLowStockApiInventoryReportsLowStockExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type UsageVsTreatmentsReportApiInventoryReportsUsageVsTreatmentsGetParams = {
/**
 * @pattern ^\d{4}-\d{2}$
 */
month: string;
locationId?: string | null;
};

export type ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetParams = {
/**
 * @pattern ^\d{4}-\d{2}$
 */
month: string;
locationId?: string | null;
format?: ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetFormat;
};

export type ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetFormat = typeof ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetFormat[keyof typeof ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type LossSummaryReportApiInventoryReportsLossSummaryGetParams = {
dateFrom: string;
dateTo: string;
locationId?: string | null;
};

export type ExportLossSummaryApiInventoryReportsLossSummaryExportGetParams = {
dateFrom: string;
dateTo: string;
locationId?: string | null;
format?: ExportLossSummaryApiInventoryReportsLossSummaryExportGetFormat;
};

export type ExportLossSummaryApiInventoryReportsLossSummaryExportGetFormat = typeof ExportLossSummaryApiInventoryReportsLossSummaryExportGetFormat[keyof typeof ExportLossSummaryApiInventoryReportsLossSummaryExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportLossSummaryApiInventoryReportsLossSummaryExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type StockValueReportApiInventoryReportsStockValueGetParams = {
asAt: string;
locationId?: string | null;
};

export type ExportStockValueApiInventoryReportsStockValueExportGetParams = {
asAt: string;
locationId?: string | null;
format?: ExportStockValueApiInventoryReportsStockValueExportGetFormat;
};

export type ExportStockValueApiInventoryReportsStockValueExportGetFormat = typeof ExportStockValueApiInventoryReportsStockValueExportGetFormat[keyof typeof ExportStockValueApiInventoryReportsStockValueExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportStockValueApiInventoryReportsStockValueExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetValuationApiInventoryValuationGetParams = {
locationId?: string | null;
productId?: string | null;
};

export type ListMovementsApiInventoryMovementsGetParams = {
productId?: string | null;
locationId?: string | null;
kind?: string | null;
dateFrom?: string | null;
dateTo?: string | null;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type ListStatusChangesApiInventoryStatusChangesGetParams = {
/**
 * @pattern ^(TREATMENT|PRODUCT)$
 */
itemType: string;
/**
 * @minLength 1
 */
itemId: string;
};

export type GetStatusReportApiInventoryStatusReportGetParams = {
itemType?: string | null;
status?: string | null;
category?: string | null;
changedFrom?: string | null;
changedTo?: string | null;
search?: string | null;
};

export type ExportStatusReportApiInventoryStatusReportExportGetParams = {
itemType?: string | null;
status?: string | null;
category?: string | null;
changedFrom?: string | null;
changedTo?: string | null;
search?: string | null;
format?: ExportStatusReportApiInventoryStatusReportExportGetFormat;
};

export type ExportStatusReportApiInventoryStatusReportExportGetFormat = typeof ExportStatusReportApiInventoryStatusReportExportGetFormat[keyof typeof ExportStatusReportApiInventoryStatusReportExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportStatusReportApiInventoryStatusReportExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetLeadListApiLeadsListsListKeyGetParams = {
outletId?: string | null;
almostVip?: boolean;
};

export type ExportLeadListApiLeadsListsListKeyExportGetParams = {
outletId?: string | null;
format?: ExportLeadListApiLeadsListsListKeyExportGetFormat;
almostVip?: boolean;
};

export type ExportLeadListApiLeadsListsListKeyExportGetFormat = typeof ExportLeadListApiLeadsListsListKeyExportGetFormat[keyof typeof ExportLeadListApiLeadsListsListKeyExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportLeadListApiLeadsListsListKeyExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetLeadsSettingsApiLeadsSettingsGetParams = {
outletId?: string | null;
};

export type GetCloseReasonsApiLeadsCloseReasonsGetParams = {
outletId?: string | null;
};

export type GetReturningMessageApiLeadsCustomersCustomerIdReturningMessageGetParams = {
outletId?: string | null;
appointmentId?: string | null;
};

export type GetDncListApiLeadsDncGetParams = {
outletId?: string | null;
};

export type GetDncReasonsApiLeadsDncReasonsGetParams = {
outletId?: string | null;
};

export type GetLeadMatchesApiLeadsNewMatchesGetParams = {
/**
 * @minLength 3
 */
phone: string;
};

export type GetFollowUpQueueApiLeadsFollowUpQueueGetParams = {
outletId?: string | null;
};

export type GetClosingReportApiLeadsFollowUpClosingReportGetParams = {
start: string;
end: string;
outletId?: string | null;
};

export type ExportClosingReportApiLeadsFollowUpClosingReportExportGetParams = {
start: string;
end: string;
format?: ExportClosingReportApiLeadsFollowUpClosingReportExportGetFormat;
outletId?: string | null;
};

export type ExportClosingReportApiLeadsFollowUpClosingReportExportGetFormat = typeof ExportClosingReportApiLeadsFollowUpClosingReportExportGetFormat[keyof typeof ExportClosingReportApiLeadsFollowUpClosingReportExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportClosingReportApiLeadsFollowUpClosingReportExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetListResultsApiLeadsReportsListResultsGetParams = {
start: string;
end: string;
outletId?: string | null;
listKey?: LeadListKey | null;
};

export type ExportListResultsApiLeadsReportsListResultsExportGetParams = {
start: string;
end: string;
format?: ExportListResultsApiLeadsReportsListResultsExportGetFormat;
outletId?: string | null;
listKey?: LeadListKey | null;
};

export type ExportListResultsApiLeadsReportsListResultsExportGetFormat = typeof ExportListResultsApiLeadsReportsListResultsExportGetFormat[keyof typeof ExportListResultsApiLeadsReportsListResultsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportListResultsApiLeadsReportsListResultsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetListSnapshotApiLeadsReportsListResultsSnapshotGetParams = {
month: string;
listKey: LeadListKey;
outletId?: string | null;
};

export type GetFollowUpTodayApiLeadsFollowUpTodayGetParams = {
outletId?: string | null;
};

export type GetAppointmentCheckApiLeadsFollowUpCheckGetParams = {
outletId?: string | null;
};

export type ListTemplatesApiLeadsTemplatesGetParams = {
includeRetired?: boolean;
};

export type PickedForHerApiLeadsTemplatesPickedForHerGetParams = {
listKey: LeadListKey;
customerId?: string | null;
leadId?: string | null;
};

export type RejectVersionApiLeadsTemplatesTemplateIdVersionsVersionIdRejectPostParams = {
note?: string | null;
};

export type PreviewTemplateApiLeadsTemplatesTemplateIdPreviewGetParams = {
customerId: string;
outletId?: string | null;
versionId?: string | null;
};

export type ListPicturesApiLeadsTemplatesPicturesGetParams = {
includeRetired?: boolean;
};

export type ListEntitlementsApiLeaveEntitlementsGetParams = {
role?: string | null;
employmentType?: string | null;
};

export type ListRequestsApiLeaveRequestsGetParams = {
status?: string | null;
staffId?: string | null;
from?: string | null;
to?: string | null;
};

export type ListMyRequestsApiLeaveRequestsMineGetParams = {
status?: string | null;
};

export type LeaveCalendarApiLeaveCalendarGetParams = {
from: string;
to: string;
outletId?: string | null;
};

export type StaffLeaveCalendarApiLeaveStaffCalendarGetParams = {
from: string;
to: string;
outletId?: string | null;
};

export type LeaveYearToDateApiLeaveYearToDateGetParams = {
year?: number | null;
outletId?: string | null;
format?: 'csv' | 'xlsx' | null;
};

export type GetEntitlementSummaryApiLeaveEntitlementsSummaryGetParams = {
year?: number | null;
};

export type GetBalanceApiLeaveBalanceGetParams = {
staffId?: string | null;
year?: number | null;
};

export type ListCreditsApiLeaveCreditsGetParams = {
staffId?: string | null;
year?: number | null;
};

export type ListOtEntriesApiLeaveOtGetParams = {
staffId?: string | null;
month?: string | null;
};

export type GetOtBalanceApiLeaveOtBalanceGetParams = {
staffId?: string | null;
year?: number | null;
};

export type ListOtRequestsApiLeaveOtRequestsGetParams = {
staffId?: string | null;
status?: string | null;
};

export type ListOverridesApiLeaveOverridesGetParams = {
staffId?: string | null;
};

export type DeleteOverrideApiLeaveOverridesStaffIdDeleteParams = {
remark?: string | null;
};

export type GetCarryForwardApiLeaveCarryForwardStaffIdGetParams = {
year: number;
};

export type ListAdjustmentsApiLeaveAdjustmentsGetParams = {
staffId: string;
};

export type ListPublicHolidaysApiLeavePublicHolidaysGetParams = {
year?: number | null;
};

export type ListLookupOptionsApiSettingsLookupListsGetParams = {
listKey?: string | null;
enabled?: boolean | null;
inForceOn?: string | null;
};

export type PreviewAudienceApiMarketingPromotionsAudiencePreviewGetParams = {
audience?: string[] | null;
};

export type ReportBreakdownApiMarketingReportsBreakdownGetParams = {
kind: string;
dateFrom: string;
dateTo: string;
outletId?: string | null;
};

export type CustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaGetParams = {
dateFrom: string;
dateTo: string;
media: string[];
fields?: string[] | null;
};

export type ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetParams = {
dateFrom: string;
dateTo: string;
media: string[];
fields?: string[] | null;
format?: ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetFormat;
};

export type ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetFormat = typeof ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetFormat[keyof typeof ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type CustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionGetParams = {
dateFrom: string;
dateTo: string;
promotions: string[];
fields?: string[] | null;
};

export type ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetParams = {
dateFrom: string;
dateTo: string;
promotions: string[];
fields?: string[] | null;
format?: ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetFormat;
};

export type ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetFormat = typeof ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetFormat[keyof typeof ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type OutletAuthorityOptionsApiMarketingOutletAuthorityOptionsGetParams = {
on?: string | null;
};

export type CurrentChartApiMarketingOutletAuthorityChartsCurrentGetParams = {
on?: string | null;
};

export type CurrentChartApiMarketingOutletAuthorityChartsCurrentGet200 = OutletAuthorityChartOut | null;

export type SearchApiSearchGetParams = {
/**
 * @minLength 1
 */
q: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
type?: string | null;
};

export type GetAnalyticsApiPackagesAnalyticsGetParams = {
outletId?: string | null;
};

export type ExportAnalyticsApiPackagesAnalyticsExportGetParams = {
outletId?: string | null;
format?: ExportAnalyticsApiPackagesAnalyticsExportGetFormat;
};

export type ExportAnalyticsApiPackagesAnalyticsExportGetFormat = typeof ExportAnalyticsApiPackagesAnalyticsExportGetFormat[keyof typeof ExportAnalyticsApiPackagesAnalyticsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportAnalyticsApiPackagesAnalyticsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetExpiringApiPackagesExpiringGetParams = {
outletId?: string | null;
/**
 * @minimum 1
 * @maximum 365
 */
days?: number;
};

export type ListQuestionnairesApiQuestionnairesGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string | null;
staffId?: string | null;
rating?: string | null;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
customerId?: string | null;
};

export type QuestionnaireSummaryApiQuestionnairesSummaryGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string | null;
customerId?: string | null;
};

export type GetQuestionnaireViewsApiQuestionnairesViewsGetParams = {
date?: string | null;
outletId?: string | null;
};

export type ListPendingRatingsApiQuestionnairesPendingGetParams = {
dateFrom?: string | null;
dateTo?: string | null;
outletId?: string | null;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * @minimum 0
 */
offset?: number;
};

export type GetFirstVisitSurveyStatesApiQuestionnairesFirstVisitSurveyGetParams = {
appointmentIds?: string[] | null;
};

export type GetDashboardApiReportsDashboardGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
format?: GetDashboardApiReportsDashboardGetFormat;
};

export type GetDashboardApiReportsDashboardGetFormat = typeof GetDashboardApiReportsDashboardGetFormat[keyof typeof GetDashboardApiReportsDashboardGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDashboardApiReportsDashboardGetFormat = {
  json: 'json',
  csv: 'csv',
  pdf: 'pdf',
  xlsx: 'xlsx',
} as const;

export type GetCapacityApiReportsCapacityGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
format?: GetCapacityApiReportsCapacityGetFormat;
};

export type GetCapacityApiReportsCapacityGetFormat = typeof GetCapacityApiReportsCapacityGetFormat[keyof typeof GetCapacityApiReportsCapacityGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCapacityApiReportsCapacityGetFormat = {
  json: 'json',
  csv: 'csv',
  pdf: 'pdf',
  xlsx: 'xlsx',
} as const;

export type GetStaffPerformanceApiReportsStaffPerformanceGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
format?: GetStaffPerformanceApiReportsStaffPerformanceGetFormat;
};

export type GetStaffPerformanceApiReportsStaffPerformanceGetFormat = typeof GetStaffPerformanceApiReportsStaffPerformanceGetFormat[keyof typeof GetStaffPerformanceApiReportsStaffPerformanceGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStaffPerformanceApiReportsStaffPerformanceGetFormat = {
  json: 'json',
  csv: 'csv',
  pdf: 'pdf',
  xlsx: 'xlsx',
} as const;

export type GetOperationsApiReportsOperationsGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
format?: GetOperationsApiReportsOperationsGetFormat;
};

export type GetOperationsApiReportsOperationsGetFormat = typeof GetOperationsApiReportsOperationsGetFormat[keyof typeof GetOperationsApiReportsOperationsGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOperationsApiReportsOperationsGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetCustomersApiReportsCustomersGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
format?: GetCustomersApiReportsCustomersGetFormat;
};

export type GetCustomersApiReportsCustomersGetFormat = typeof GetCustomersApiReportsCustomersGetFormat[keyof typeof GetCustomersApiReportsCustomersGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCustomersApiReportsCustomersGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetSalesAnalyticsApiReportsSalesAnalyticsGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
format?: GetSalesAnalyticsApiReportsSalesAnalyticsGetFormat;
};

export type GetSalesAnalyticsApiReportsSalesAnalyticsGetFormat = typeof GetSalesAnalyticsApiReportsSalesAnalyticsGetFormat[keyof typeof GetSalesAnalyticsApiReportsSalesAnalyticsGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSalesAnalyticsApiReportsSalesAnalyticsGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetCancellationsApiReportsCancellationsGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
reason?: string | null;
timing?: 'WITHIN_24H' | 'MORE_THAN_24H' | 'UNKNOWN' | 'SAME_DAY' | 'IN_ADVANCE' | null;
};

export type GetConsultationsApiReportsConsultationsGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
consultantId?: string | null;
};

export type GetConsultationResultsApiReportsConsultationsResultsGetParams = {
outletId?: string | null;
month?: string | null;
consultantId?: string | null;
consultationType?: string | null;
source?: string | null;
};

export type ExportConsultationResultsApiReportsConsultationsResultsExportGetParams = {
format?: ExportConsultationResultsApiReportsConsultationsResultsExportGetFormat;
outletId?: string | null;
month?: string | null;
consultantId?: string | null;
consultationType?: string | null;
source?: string | null;
};

export type ExportConsultationResultsApiReportsConsultationsResultsExportGetFormat = typeof ExportConsultationResultsApiReportsConsultationsResultsExportGetFormat[keyof typeof ExportConsultationResultsApiReportsConsultationsResultsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportConsultationResultsApiReportsConsultationsResultsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type GetConsultationTodayApiReportsConsultationsTodayGetParams = {
customerId: string;
};

export type GetAppointmentsApiReportsAppointmentsGetParams = {
outletId?: string | null;
period?: string | null;
month?: string | null;
date?: string | null;
start?: string | null;
end?: string | null;
customerType?: 'NEW' | 'NEW_NEVER_TREATED' | 'NEW_TRIED' | 'EXISTING' | null;
};

export type GetDutyRosterStaffApiReportsDutyRosterStaffGetParams = {
outletId: string;
/**
 * YYYY-MM
 */
month: string;
};

export type GetDutyRosterApiReportsDutyRosterGetParams = {
outletId: string;
/**
 * YYYY-MM
 */
month: string;
staffIds?: string[] | null;
format?: GetDutyRosterApiReportsDutyRosterGetFormat;
};

export type GetDutyRosterApiReportsDutyRosterGetFormat = typeof GetDutyRosterApiReportsDutyRosterGetFormat[keyof typeof GetDutyRosterApiReportsDutyRosterGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDutyRosterApiReportsDutyRosterGetFormat = {
  json: 'json',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListOutletTargetsApiSalaryOutletTargetsGetParams = {
outletId?: string | null;
};

export type ListMonthlyOutletTargetsApiSalaryMonthlyOutletTargetsGetParams = {
year?: number | null;
outletId?: string | null;
};

export type ListRunsApiSalaryRunsGetParams = {
year?: number | null;
month?: number | null;
};

export type ListMyPayslipsApiSalaryPayslipsMineGetParams = {
year?: number | null;
month?: number | null;
};

export type ListBenefitUsageApiSalaryBenefitUsageGetParams = {
staffId: string;
year?: number | null;
};

export type ListPaymentTypesApiFinancePaymentTypesGetParams = {
enabled?: boolean | null;
outletId?: string | null;
};

export type ListTaxesApiFinanceTaxesGetParams = {
enabled?: boolean | null;
outletId?: string | null;
};

export type ScheduleDailyApiScheduleGetParams = {
date?: string | null;
outletId?: string | null;
includeCancelled?: boolean;
};

export type ScheduleWeeklyApiScheduleWeeklyGetParams = {
weekStart?: string | null;
outletId?: string | null;
};

export type ListUsersApiUsersGetParams = {
userType?: string | null;
isActive?: boolean | null;
};

export type ListMeetingLogMeetingsApiMeetingFilesMeetingsGetParams = {
dateFrom: string;
dateTo: string;
outletId?: string | null;
meetingType?: string | null;
};

export type ListMeetingFilesApiMeetingFilesGetParams = {
kind: MeetingFileKind;
year?: number | null;
};

export type DownloadMeetingDeckApiMeetingFilesDeckGetParams = {
/**
 * @pattern ^\d{4}-\d{2}$
 */
month: string;
};

export type ListMeetingMinutesApiMeetingMinutesGetParams = {
year?: number | null;
};

export type DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetParams = {
format?: DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetFormat;
};

export type DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetFormat = typeof DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetFormat[keyof typeof DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetFormat = {
  docx: 'docx',
  pdf: 'pdf',
} as const;

export type ListDocumentsApiAiKnowledgeDocumentsGetParams = {
area?: string | null;
status?: DocStatus | null;
};

export type SearchApiAiKnowledgeSearchGetParams = {
/**
 * @minLength 1
 * @maxLength 500
 */
q: string;
/**
 * @minimum 1
 * @maximum 10
 */
limit?: number;
};

export type ListDocumentsApiHrSopLibraryDocumentsGetParams = {
area?: string | null;
q?: string | null;
};

export type VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetParams = {
disposition?: VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetDisposition;
};

export type VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetDisposition = typeof VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetDisposition[keyof typeof VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetDisposition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetDisposition = {
  inline: 'inline',
  attachment: 'attachment',
} as const;

export type HistoryApiAiHistoryGetParams = {
result?: AiResult | null;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
outletId?: string | null;
role?: string | null;
from?: string | null;
to?: string | null;
search?: string | null;
};

export type ExportHistoryApiAiHistoryExportGetParams = {
format?: ExportHistoryApiAiHistoryExportGetFormat;
result?: AiResult | null;
outletId?: string | null;
role?: string | null;
from?: string | null;
to?: string | null;
search?: string | null;
};

export type ExportHistoryApiAiHistoryExportGetFormat = typeof ExportHistoryApiAiHistoryExportGetFormat[keyof typeof ExportHistoryApiAiHistoryExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportHistoryApiAiHistoryExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListUnansweredApiAiUnansweredGetParams = {
status?: AiFollowUp | null;
outletId?: string | null;
role?: string | null;
from?: string | null;
to?: string | null;
search?: string | null;
};

export type GetPromotionStatusApiPromotionStatusGetParams = {
asAt?: string | null;
outletId?: string | null;
track?: string | null;
format?: 'csv' | 'xlsx' | null;
};

export type GetPromotionHistoryApiPromotionHistoryGetParams = {
year?: number | null;
outletId?: string | null;
staffId?: string | null;
format?: 'csv' | 'xlsx' | null;
};

export type MyClaimsApiStaffClaimsMeGetParams = {
/**
 * YYYY-MM; default this month
 */
period?: string | null;
};

export type ClaimResponsesApiStaffClaimsResponsesGetParams = {
/**
 * YYYY-MM; default this month
 */
period?: string | null;
outletId?: string | null;
status?: string | null;
};

export type ListTrainingSessionsApiTrainingSessionsGetParams = {
dateFrom: string;
dateTo: string;
staffId?: string | null;
type?: TrainingSessionType | null;
outletId?: string | null;
};

export type ResultsApiPerformanceReviewRoundsRoundIdResultsGetParams = {
outletId?: string | null;
};

export type ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetParams = {
format?: ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetFormat;
outletId?: string | null;
};

export type ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetFormat = typeof ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetFormat[keyof typeof ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetFormat = {
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export type ListFieldsApiCustomerFieldsGetParams = {
includeArchived?: boolean;
};

export type BulkValuesApiCustomerFieldsValuesGetParams = {
customerIds?: string;
};

export type AttendanceReportApiAttendanceReportGetParams = {
from: string;
to: string;
outletId?: string | null;
staffId?: string | null;
format?: 'csv' | 'xlsx' | null;
};

export type StaffAttendanceMonthApiAttendanceStaffStaffIdMonthGetParams = {
/**
 * @pattern ^\d{4}-\d{2}$
 */
month: string;
format?: 'csv' | 'xlsx' | null;
};

/**
 * Liveness + DB ping. No auth. Mirrors `/api/health`; same contract.
 * @summary Health
 */
export const getHealthHealthGetUrl = () => {


  

  return `/health`
}

export const healthHealthGet = async ( options?: RequestInit): Promise<HealthResponse> => {
  
  return apiFetch<HealthResponse>(getHealthHealthGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The static ``PERMISSION_TREE`` (categories + perms + ownCapable) — powers
the Rights editor.
 * @summary Get Permission Tree
 */
export const getGetPermissionTreeApiAccessPermissionTreeGetUrl = () => {


  

  return `/api/access/permission-tree`
}

export const getPermissionTreeApiAccessPermissionTreeGet = async ( options?: RequestInit): Promise<PermissionCategory[]> => {
  
  return apiFetch<PermissionCategory[]>(getGetPermissionTreeApiAccessPermissionTreeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Every report with the roles that may view / export it (Manage Reports).
Saving uses ``PUT /roles/{id}/permissions`` with ``report.<id>.view|export``.
 * @summary Get Report Rights
 */
export const getGetReportRightsApiAccessReportRightsGetUrl = () => {


  

  return `/api/access/report-rights`
}

export const getReportRightsApiAccessReportRightsGet = async ( options?: RequestInit): Promise<ReportRightsTable> => {
  
  return apiFetch<ReportRightsTable>(getGetReportRightsApiAccessReportRightsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Roles
 */
export const getListRolesApiAccessRolesGetUrl = () => {


  

  return `/api/access/roles`
}

export const listRolesApiAccessRolesGet = async ( options?: RequestInit): Promise<RoleSummary[]> => {
  
  return apiFetch<RoleSummary[]>(getListRolesApiAccessRolesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Role
 */
export const getCreateRoleApiAccessRolesPostUrl = () => {


  

  return `/api/access/roles`
}

export const createRoleApiAccessRolesPost = async (roleCreateRequest: RoleCreateRequest, options?: RequestInit): Promise<RoleSummary> => {
  
  return apiFetch<RoleSummary>(getCreateRoleApiAccessRolesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleCreateRequest,)
  }
);}



/**
 * @summary Get Role
 */
export const getGetRoleApiAccessRolesRoleIdGetUrl = (roleId: string,) => {


  

  return `/api/access/roles/${roleId}`
}

export const getRoleApiAccessRolesRoleIdGet = async (roleId: string, options?: RequestInit): Promise<RoleDetail> => {
  
  return apiFetch<RoleDetail>(getGetRoleApiAccessRolesRoleIdGetUrl(roleId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Role
 */
export const getUpdateRoleApiAccessRolesRoleIdPutUrl = (roleId: string,) => {


  

  return `/api/access/roles/${roleId}`
}

export const updateRoleApiAccessRolesRoleIdPut = async (roleId: string,
    roleUpdateRequest: RoleUpdateRequest, options?: RequestInit): Promise<RoleSummary> => {
  
  return apiFetch<RoleSummary>(getUpdateRoleApiAccessRolesRoleIdPutUrl(roleId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleUpdateRequest,)
  }
);}



/**
 * @summary Delete Role
 */
export const getDeleteRoleApiAccessRolesRoleIdDeleteUrl = (roleId: string,) => {


  

  return `/api/access/roles/${roleId}`
}

export const deleteRoleApiAccessRolesRoleIdDelete = async (roleId: string, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getDeleteRoleApiAccessRolesRoleIdDeleteUrl(roleId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Bulk upsert grants; ``level="NONE"`` deletes the row. Flushes cache.
 * @summary Set Role Permissions
 */
export const getSetRolePermissionsApiAccessRolesRoleIdPermissionsPutUrl = (roleId: string,) => {


  

  return `/api/access/roles/${roleId}/permissions`
}

export const setRolePermissionsApiAccessRolesRoleIdPermissionsPut = async (roleId: string,
    setRolePermissionsRequest: SetRolePermissionsRequest, options?: RequestInit): Promise<RoleDetail> => {
  
  return apiFetch<RoleDetail>(getSetRolePermissionsApiAccessRolesRoleIdPermissionsPutUrl(roleId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setRolePermissionsRequest,)
  }
);}



/**
 * The user's effective grid: inherited (role) + override + effective per key.
 * @summary Get User Permissions
 */
export const getGetUserPermissionsApiAccessUsersUserIdPermissionsGetUrl = (userId: string,) => {


  

  return `/api/access/users/${userId}/permissions`
}

export const getUserPermissionsApiAccessUsersUserIdPermissionsGet = async (userId: string, options?: RequestInit): Promise<UserPermissionsGrid> => {
  
  return apiFetch<UserPermissionsGrid>(getGetUserPermissionsApiAccessUsersUserIdPermissionsGetUrl(userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Bulk upsert overrides; ``level="INHERIT"`` deletes the row (revert to role
grant). Flushes cache.
 * @summary Set User Overrides
 */
export const getSetUserOverridesApiAccessUsersUserIdOverridesPutUrl = (userId: string,) => {


  

  return `/api/access/users/${userId}/overrides`
}

export const setUserOverridesApiAccessUsersUserIdOverridesPut = async (userId: string,
    setUserOverridesRequest: SetUserOverridesRequest, options?: RequestInit): Promise<UserPermissionsGrid> => {
  
  return apiFetch<UserPermissionsGrid>(getSetUserOverridesApiAccessUsersUserIdOverridesPutUrl(userId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setUserOverridesRequest,)
  }
);}



/**
 * Assign/replace the user's role. Flushes cache.
 * @summary Assign User Role
 */
export const getAssignUserRoleApiAccessUsersUserIdRolePutUrl = (userId: string,) => {


  

  return `/api/access/users/${userId}/role`
}

export const assignUserRoleApiAccessUsersUserIdRolePut = async (userId: string,
    assignRoleRequest: AssignRoleRequest, options?: RequestInit): Promise<UserPermissionsGrid> => {
  
  return apiFetch<UserPermissionsGrid>(getAssignUserRoleApiAccessUsersUserIdRolePutUrl(userId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assignRoleRequest,)
  }
);}



/**
 * @summary Get User Outlet Access
 */
export const getGetUserOutletAccessApiAccessUsersUserIdOutletAccessGetUrl = (userId: string,) => {


  

  return `/api/access/users/${userId}/outlet-access`
}

export const getUserOutletAccessApiAccessUsersUserIdOutletAccessGet = async (userId: string, options?: RequestInit): Promise<UserOutletAccess> => {
  
  return apiFetch<UserOutletAccess>(getGetUserOutletAccessApiAccessUsersUserIdOutletAccessGetUrl(userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Set User Outlet Access
 */
export const getSetUserOutletAccessApiAccessUsersUserIdOutletAccessPutUrl = (userId: string,) => {


  

  return `/api/access/users/${userId}/outlet-access`
}

export const setUserOutletAccessApiAccessUsersUserIdOutletAccessPut = async (userId: string,
    setUserOutletAccessRequest: SetUserOutletAccessRequest, options?: RequestInit): Promise<UserOutletAccess> => {
  
  return apiFetch<UserOutletAccess>(getSetUserOutletAccessApiAccessUsersUserIdOutletAccessPutUrl(userId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setUserOutletAccessRequest,)
  }
);}



/**
 * Idempotent seed of the 4 system roles from ``ACCESS_MATRIX`` + live
``AccessRule`` overrides, plus a ``User.roleId`` backfill (ADR §7 steps 2-3).
Safe to re-run — returns the count of rows newly written (0 once seeded).
 * @summary Seed Roles
 */
export const getSeedRolesApiAccessRolesSeedPostUrl = () => {


  

  return `/api/access/roles/seed`
}

export const seedRolesApiAccessRolesSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedRolesApiAccessRolesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * One page (50) of events, newest first. Dates are Singapore days; with no
date the range is today.
 * @summary List Audit Trail
 */
export const getListAuditTrailApiAuditTrailGetUrl = (params?: ListAuditTrailApiAuditTrailGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-trail?${stringifiedParams}` : `/api/audit-trail`
}

export const listAuditTrailApiAuditTrailGet = async (params?: ListAuditTrailApiAuditTrailGetParams, options?: RequestInit): Promise<AuditListResponse> => {
  
  return apiFetch<AuditListResponse>(getListAuditTrailApiAuditTrailGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The Module / Event / User choices for the filter drop-downs.
 * @summary Audit Trail Options
 */
export const getAuditTrailOptionsApiAuditTrailOptionsGetUrl = () => {


  

  return `/api/audit-trail/options`
}

export const auditTrailOptionsApiAuditTrailOptionsGet = async ( options?: RequestInit): Promise<AuditOptionsResponse> => {
  
  return apiFetch<AuditOptionsResponse>(getAuditTrailOptionsApiAuditTrailOptionsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The same filtered list as Excel (up to 50,000 rows). The download is itself
written to the trail by the shared export helper.
 * @summary Export Audit Trail
 */
export const getExportAuditTrailApiAuditTrailExportGetUrl = (params?: ExportAuditTrailApiAuditTrailExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-trail/export?${stringifiedParams}` : `/api/audit-trail/export`
}

export const exportAuditTrailApiAuditTrailExportGet = async (params?: ExportAuditTrailApiAuditTrailExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportAuditTrailApiAuditTrailExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Access Rules
 */
export const getListAccessRulesApiAdminAccessRulesGetUrl = () => {


  

  return `/api/admin/access-rules`
}

export const listAccessRulesApiAdminAccessRulesGet = async ( options?: RequestInit): Promise<AccessRuleListResponse> => {
  
  return apiFetch<AccessRuleListResponse>(getListAccessRulesApiAdminAccessRulesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Access Rule
 */
export const getUpdateAccessRuleApiAdminAccessRulesPatchUrl = () => {


  

  return `/api/admin/access-rules`
}

export const updateAccessRuleApiAdminAccessRulesPatch = async (accessRuleUpsertRequest: AccessRuleUpsertRequest, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getUpdateAccessRuleApiAdminAccessRulesPatchUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accessRuleUpsertRequest,)
  }
);}



/**
 * @summary List Program Step Mappings
 */
export const getListProgramStepMappingsApiAdminProgramStepMappingGetUrl = () => {


  

  return `/api/admin/program-step-mapping`
}

export const listProgramStepMappingsApiAdminProgramStepMappingGet = async ( options?: RequestInit): Promise<ProgramStepMappingListResponse> => {
  
  return apiFetch<ProgramStepMappingListResponse>(getListProgramStepMappingsApiAdminProgramStepMappingGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OAuth2 password flow. ``username`` carries **either** the loginId (staff
ID) or the email (OAuth2 spec field name). Spec B §6.1: we resolve loginId
first (lowercased to match the normalize-on-write rule §7.3), then fall back
to email using the *unmodified* username so existing email logins are
byte-for-byte unchanged. Verifies against the existing bcryptjs
``passwordHash`` and issues a FastAPI JWT. Invalid credentials / inactive
user → **401** (flat envelope).

Mirrors the NextAuth Credentials ``authorize`` behavior: unknown user,
inactive user, and wrong password are all indistinguishable 401s; last login
is stamped on success.
 * @summary Login
 */
export const getLoginApiAuthLoginPostUrl = () => {


  

  return `/api/auth/login`
}

export const loginApiAuthLoginPost = async (bodyLoginApiAuthLoginPost: BodyLoginApiAuthLoginPost, options?: RequestInit): Promise<LoginResponse> => {
    const formUrlEncoded = new URLSearchParams();
if(bodyLoginApiAuthLoginPost.grant_type !== undefined && bodyLoginApiAuthLoginPost.grant_type !== null) {
 formUrlEncoded.append(`grant_type`, bodyLoginApiAuthLoginPost.grant_type)
 }
formUrlEncoded.append(`username`, bodyLoginApiAuthLoginPost.username)
formUrlEncoded.append(`password`, bodyLoginApiAuthLoginPost.password)
if(bodyLoginApiAuthLoginPost.scope !== undefined) {
 formUrlEncoded.append(`scope`, bodyLoginApiAuthLoginPost.scope)
 }
if(bodyLoginApiAuthLoginPost.client_id !== undefined && bodyLoginApiAuthLoginPost.client_id !== null) {
 formUrlEncoded.append(`client_id`, bodyLoginApiAuthLoginPost.client_id)
 }
if(bodyLoginApiAuthLoginPost.client_secret !== undefined && bodyLoginApiAuthLoginPost.client_secret !== null) {
 formUrlEncoded.append(`client_secret`, bodyLoginApiAuthLoginPost.client_secret)
 }

  return apiFetch<LoginResponse>(getLoginApiAuthLoginPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...options?.headers },
    body: 
      formUrlEncoded,
  }
);}



/**
 * GEN-15 - the client calls this just before it forgets the token, so the
Audit trail shows the sign-out. Tokens are stateless; this revokes nothing.
 * @summary Logout
 */
export const getLogoutApiAuthLogoutPostUrl = () => {


  

  return `/api/auth/logout`
}

export const logoutApiAuthLogoutPost = async ( options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getLogoutApiAuthLogoutPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HR-03 — re-check the signed-in user's password before a Payroll screen
opens, and record the attempt (who, when, which screen, outcome).

A second check only: it grants nothing. Which roles may open Payroll is
unchanged and still enforced by the existing page and API guards. A wrong
password is a 200 with ``unlocked: false`` (not a 401, which the client
would treat as an expired session); the fifth wrong try in a row answers
``signedOut: true`` and the client signs the user out.
 * @summary Payroll Unlock
 */
export const getPayrollUnlockApiAuthPayrollUnlockPostUrl = () => {


  

  return `/api/auth/payroll-unlock`
}

export const payrollUnlockApiAuthPayrollUnlockPost = async (payrollUnlockRequest: PayrollUnlockRequest, options?: RequestInit): Promise<PayrollUnlockResponse> => {
  
  return apiFetch<PayrollUnlockResponse>(getPayrollUnlockApiAuthPayrollUnlockPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      payrollUnlockRequest,)
  }
);}



/**
 * Derived home ``outletId`` (from the linked staff record; null when the
user has no staff link — e.g. a system admin). Byte-identical to legacy /me.
 * @summary Me
 */
export const getMeApiAuthMeGetUrl = () => {


  

  return `/api/auth/me`
}

export const meApiAuthMeGet = async ( options?: RequestInit): Promise<MeResponse> => {
  
  return apiFetch<MeResponse>(getMeApiAuthMeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The current user's resolved permission map + role summary (Spec A §7) —
the FE gates menus/routes on this. NOT admin-gated: any authenticated user
gets **their own** resolved permissions.
 * @summary My Permissions
 */
export const getMyPermissionsApiAuthMyPermissionsGetUrl = () => {


  

  return `/api/auth/my-permissions`
}

export const myPermissionsApiAuthMyPermissionsGet = async ( options?: RequestInit): Promise<MyPermissions> => {
  
  return apiFetch<MyPermissions>(getMyPermissionsApiAuthMyPermissionsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Whether the user can create appointments (canBook feature in the matrix).
 * @summary Can Book
 */
export const getCanBookApiAuthCanBookGetUrl = () => {


  

  return `/api/auth/can-book`
}

export const canBookApiAuthCanBookGet = async ( options?: RequestInit): Promise<CanBookResponse> => {
  
  return apiFetch<CanBookResponse>(getCanBookApiAuthCanBookGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Y-014: ADMIN or a HEAD_MASTER (Staff.role) can resolve disputes.
 * @summary Can Mediate
 */
export const getCanMediateApiAuthCanMediateGetUrl = () => {


  

  return `/api/auth/can-mediate`
}

export const canMediateApiAuthCanMediateGet = async ( options?: RequestInit): Promise<CanMediateResponse> => {
  
  return apiFetch<CanMediateResponse>(getCanMediateApiAuthCanMediateGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Y-004: ADMIN or a HEAD_MASTER (Staff.role) can create/delete meetings.
 * @summary Can Create Meetings
 */
export const getCanCreateMeetingsApiAuthCanCreateMeetingsGetUrl = () => {


  

  return `/api/auth/can-create-meetings`
}

export const canCreateMeetingsApiAuthCanCreateMeetingsGet = async ( options?: RequestInit): Promise<CanCreateMeetingsResponse> => {
  
  return apiFetch<CanCreateMeetingsResponse>(getCanCreateMeetingsApiAuthCanCreateMeetingsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Y-028 POC: ADMIN or any master role (Staff.role) may save face-chart
drawings. Mirrors lib/auth/face-chart.ts.
 * @summary Can Edit Face Chart
 */
export const getCanEditFaceChartApiAuthCanEditFaceChartGetUrl = () => {


  

  return `/api/auth/can-edit-face-chart`
}

export const canEditFaceChartApiAuthCanEditFaceChartGet = async ( options?: RequestInit): Promise<CanEditFaceChartResponse> => {
  
  return apiFetch<CanEditFaceChartResponse>(getCanEditFaceChartApiAuthCanEditFaceChartGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Appointments
 */
export const getListAppointmentsApiAppointmentsGetUrl = (params?: ListAppointmentsApiAppointmentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments?${stringifiedParams}` : `/api/appointments`
}

export const listAppointmentsApiAppointmentsGet = async (params?: ListAppointmentsApiAppointmentsGetParams, options?: RequestInit): Promise<AppointmentListItem[]> => {
  
  return apiFetch<AppointmentListItem[]>(getListAppointmentsApiAppointmentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Appointment
 */
export const getCreateAppointmentApiAppointmentsPostUrl = () => {


  

  return `/api/appointments`
}

export const createAppointmentApiAppointmentsPost = async (appointmentCreate: AppointmentCreate, options?: RequestInit): Promise<CreateAppointmentApiAppointmentsPost201> => {
  
  return apiFetch<CreateAppointmentApiAppointmentsPost201>(getCreateAppointmentApiAppointmentsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentCreate,)
  }
);}



/**
 * @summary Get Active Appointments
 */
export const getGetActiveAppointmentsApiAppointmentsActiveGetUrl = (params?: GetActiveAppointmentsApiAppointmentsActiveGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/active?${stringifiedParams}` : `/api/appointments/active`
}

export const getActiveAppointmentsApiAppointmentsActiveGet = async (params?: GetActiveAppointmentsApiAppointmentsActiveGetParams, options?: RequestInit): Promise<ActiveAppointmentResponse[]> => {
  
  return apiFetch<ActiveAppointmentResponse[]>(getGetActiveAppointmentsApiAppointmentsActiveGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-02 / OPS-19 — what the one-page New Appointment needs: the catalogue
(main / add-on), the outlet's staff with their shift on the date, and the
customer's packages with remaining, booked ahead and validity on the
BOOKING date.
 * @summary Get Booking Options
 */
export const getGetBookingOptionsApiAppointmentsBookingOptionsGetUrl = (params: GetBookingOptionsApiAppointmentsBookingOptionsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/booking-options?${stringifiedParams}` : `/api/appointments/booking-options`
}

export const getBookingOptionsApiAppointmentsBookingOptionsGet = async (params: GetBookingOptionsApiAppointmentsBookingOptionsGetParams, options?: RequestInit): Promise<BookingOptionsResponse> => {
  
  return apiFetch<BookingOptionsResponse>(getGetBookingOptionsApiAppointmentsBookingOptionsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-19-09 — the availability line of every card, worked out at every
change. Read-only.
 * @summary Check Visit Availability
 */
export const getCheckVisitAvailabilityApiAppointmentsVisitAvailabilityPostUrl = () => {


  

  return `/api/appointments/visit/availability`
}

export const checkVisitAvailabilityApiAppointmentsVisitAvailabilityPost = async (visitAvailabilityRequest: VisitAvailabilityRequest, options?: RequestInit): Promise<VisitAvailabilityResponse> => {
  
  return apiFetch<VisitAvailabilityResponse>(getCheckVisitAvailabilityApiAppointmentsVisitAvailabilityPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      visitAvailabilityRequest,)
  }
);}



/**
 * OPS-02-07 — Confirm Booking: the whole visit (every card) in one request,
all-or-nothing. Status Booked; nothing deducted (OPS-19-12).
 * @summary Create Visit
 */
export const getCreateVisitApiAppointmentsVisitPostUrl = () => {


  

  return `/api/appointments/visit`
}

export const createVisitApiAppointmentsVisitPost = async (visitCreate: VisitCreate, options?: RequestInit): Promise<VisitCreateResponse> => {
  
  return apiFetch<VisitCreateResponse>(getCreateVisitApiAppointmentsVisitPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      visitCreate,)
  }
);}



/**
 * @summary Get Availability
 */
export const getGetAvailabilityApiAppointmentsAvailabilityGetUrl = (params: GetAvailabilityApiAppointmentsAvailabilityGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/availability?${stringifiedParams}` : `/api/appointments/availability`
}

export const getAvailabilityApiAppointmentsAvailabilityGet = async (params: GetAvailabilityApiAppointmentsAvailabilityGetParams, options?: RequestInit): Promise<AvailabilityResponse> => {
  
  return apiFetch<AvailabilityResponse>(getGetAvailabilityApiAppointmentsAvailabilityGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Timeslots
 */
export const getGetTimeslotsApiAppointmentsTimeslotsGetUrl = (params: GetTimeslotsApiAppointmentsTimeslotsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/timeslots?${stringifiedParams}` : `/api/appointments/timeslots`
}

export const getTimeslotsApiAppointmentsTimeslotsGet = async (params: GetTimeslotsApiAppointmentsTimeslotsGetParams, options?: RequestInit): Promise<TimeslotResponse> => {
  
  return apiFetch<TimeslotResponse>(getGetTimeslotsApiAppointmentsTimeslotsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Appointment History
 */
export const getGetAppointmentHistoryApiAppointmentsHistoryGetUrl = (params?: GetAppointmentHistoryApiAppointmentsHistoryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/history?${stringifiedParams}` : `/api/appointments/history`
}

export const getAppointmentHistoryApiAppointmentsHistoryGet = async (params?: GetAppointmentHistoryApiAppointmentsHistoryGetParams, options?: RequestInit): Promise<HistoryResponse> => {
  
  return apiFetch<HistoryResponse>(getGetAppointmentHistoryApiAppointmentsHistoryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Admin export of the appointment book (Studio-Manager parity), Excel by
default and CSV on ``?format=csv``. The third surface on the shared window
contract alongside the customers and sales exports. Declared before
``/{appointment_id}`` so the literal wins.

Sending no window params means every appointment, the same "don't silently
narrow an admin's full dump" rule the other two exports follow.

DELETED rows are soft-deleted appointments and are hidden, matching
``HIDDEN_STATUSES`` on the schedule screen. CANCELLED and NO_SHOW stay in -
they are real outcomes an admin reports on, not dead rows. Asking for a
status explicitly overrides this, so ``?status=DELETED`` is still reachable.
 * @summary Export Appointments
 */
export const getExportAppointmentsApiAppointmentsExportGetUrl = (params?: ExportAppointmentsApiAppointmentsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/export?${stringifiedParams}` : `/api/appointments/export`
}

export const exportAppointmentsApiAppointmentsExportGet = async (params?: ExportAppointmentsApiAppointmentsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportAppointmentsApiAppointmentsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-27-04: the customer's steps Not performed that wait for a make-up.
 * @summary List Make Up Open Steps
 */
export const getListMakeUpOpenStepsApiAppointmentsMakeUpOpenStepsGetUrl = (params: ListMakeUpOpenStepsApiAppointmentsMakeUpOpenStepsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/appointments/make-up/open-steps?${stringifiedParams}` : `/api/appointments/make-up/open-steps`
}

export const listMakeUpOpenStepsApiAppointmentsMakeUpOpenStepsGet = async (params: ListMakeUpOpenStepsApiAppointmentsMakeUpOpenStepsGetParams, options?: RequestInit): Promise<MakeUpOpenStepsResponse> => {
  
  return apiFetch<MakeUpOpenStepsResponse>(getListMakeUpOpenStepsApiAppointmentsMakeUpOpenStepsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-27-03 / OPS-27-04: ONE make-up booking for the ticked steps.
 * @summary Create Make Up Appointment
 */
export const getCreateMakeUpAppointmentApiAppointmentsMakeUpPostUrl = () => {


  

  return `/api/appointments/make-up`
}

export const createMakeUpAppointmentApiAppointmentsMakeUpPost = async (makeUpCreate: MakeUpCreate, options?: RequestInit): Promise<AppointmentResponse> => {
  
  return apiFetch<AppointmentResponse>(getCreateMakeUpAppointmentApiAppointmentsMakeUpPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      makeUpCreate,)
  }
);}



/**
 * OPS-27-07 / OPS-27-12: the make-up's own details and what became of the
steps Not performed on this visit.
 * @summary Get Make Up Details
 */
export const getGetMakeUpDetailsApiAppointmentsAppointmentIdMakeUpGetUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/make-up`
}

export const getMakeUpDetailsApiAppointmentsAppointmentIdMakeUpGet = async (appointmentId: string, options?: RequestInit): Promise<MakeUpDetailsResponse> => {
  
  return apiFetch<MakeUpDetailsResponse>(getGetMakeUpDetailsApiAppointmentsAppointmentIdMakeUpGetUrl(appointmentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Appointment
 */
export const getGetAppointmentApiAppointmentsAppointmentIdGetUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}`
}

export const getAppointmentApiAppointmentsAppointmentIdGet = async (appointmentId: string, options?: RequestInit): Promise<AppointmentResponse> => {
  
  return apiFetch<AppointmentResponse>(getGetAppointmentApiAppointmentsAppointmentIdGetUrl(appointmentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Appointment
 */
export const getUpdateAppointmentApiAppointmentsAppointmentIdPutUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}`
}

export const updateAppointmentApiAppointmentsAppointmentIdPut = async (appointmentId: string,
    appointmentUpdate: AppointmentUpdate, options?: RequestInit): Promise<AppointmentResponse> => {
  
  return apiFetch<AppointmentResponse>(getUpdateAppointmentApiAppointmentsAppointmentIdPutUrl(appointmentId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentUpdate,)
  }
);}



/**
 * @summary Delete Appointment
 */
export const getDeleteAppointmentApiAppointmentsAppointmentIdDeleteUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}`
}

export const deleteAppointmentApiAppointmentsAppointmentIdDelete = async (appointmentId: string,
    appointmentDeleteRequest: AppointmentDeleteRequest, options?: RequestInit): Promise<AppointmentResponse> => {
  
  return apiFetch<AppointmentResponse>(getDeleteAppointmentApiAppointmentsAppointmentIdDeleteUrl(appointmentId),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentDeleteRequest,)
  }
);}



/**
 * Spec appointment-programme-editing §3.2 — add a programme to a booked visit.

Same ``canBook`` gate as create/update: this creates an appointment, and the
permission key named in the spec's decision 3 (``appointments.update``) does
not exist in the registry — see the PR's Spec Drift Callouts.
 * @summary Append Appointment Leg
 */
export const getAppendAppointmentLegApiAppointmentsAppointmentIdLegsPostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/legs`
}

export const appendAppointmentLegApiAppointmentsAppointmentIdLegsPost = async (appointmentId: string,
    appointmentLegCreate: AppointmentLegCreate, options?: RequestInit): Promise<AppointmentResponse> => {
  
  return apiFetch<AppointmentResponse>(getAppendAppointmentLegApiAppointmentsAppointmentIdLegsPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentLegCreate,)
  }
);}



/**
 * SPEC-R5-01 — add a 30-minute consultation to an already-booked appointment.

Same ``canBook`` gate as create/update: this creates an appointment. A 409
carries the reason — the slot clashes, the visit already has a consultation
(``CONSULTATION_EXISTS``), or it is too far along (``VISIT_LOCKED``).
 * @summary Add Appointment Consultation
 */
export const getAddAppointmentConsultationApiAppointmentsAppointmentIdConsultationPostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/consultation`
}

export const addAppointmentConsultationApiAppointmentsAppointmentIdConsultationPost = async (appointmentId: string,
    appointmentConsultationAddRequest: AppointmentConsultationAddRequest, options?: RequestInit): Promise<AppointmentComboResponse> => {
  
  return apiFetch<AppointmentComboResponse>(getAddAppointmentConsultationApiAppointmentsAppointmentIdConsultationPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentConsultationAddRequest,)
  }
);}



/**
 * SPEC-R5-03 — move a whole visit (every linked leg) in one atomic request.

One request, not N: the legs are validated at their new spans together and
written together, so a drag can never leave a visit half-moved. The 409 body
lists every clash found across the visit.
 * @summary Move Appointment Group
 */
export const getMoveAppointmentGroupApiAppointmentsAppointmentIdMoveGroupPostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/move-group`
}

export const moveAppointmentGroupApiAppointmentsAppointmentIdMoveGroupPost = async (appointmentId: string,
    appointmentGroupMoveRequest: AppointmentGroupMoveRequest, options?: RequestInit): Promise<AppointmentGroupMoveResponse> => {
  
  return apiFetch<AppointmentGroupMoveResponse>(getMoveAppointmentGroupApiAppointmentsAppointmentIdMoveGroupPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentGroupMoveRequest,)
  }
);}



/**
 * Undo a soft-delete (BUG-889 §B4). ADMIN ONLY — enforced in the service.

The route keeps the same coarse ``canBook`` gate as delete; the admin check
and the conflict re-validation live in the service so they cannot be
bypassed by another caller.
 * @summary Restore Appointment
 */
export const getRestoreAppointmentApiAppointmentsAppointmentIdRestorePostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/restore`
}

export const restoreAppointmentApiAppointmentsAppointmentIdRestorePost = async (appointmentId: string, options?: RequestInit): Promise<AppointmentResponse> => {
  
  return apiFetch<AppointmentResponse>(getRestoreAppointmentApiAppointmentsAppointmentIdRestorePostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Appointment Details
 */
export const getGetAppointmentDetailsApiAppointmentsAppointmentIdDetailsGetUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/details`
}

export const getAppointmentDetailsApiAppointmentsAppointmentIdDetailsGet = async (appointmentId: string, options?: RequestInit): Promise<AppointmentDetailsResponse> => {
  
  return apiFetch<AppointmentDetailsResponse>(getGetAppointmentDetailsApiAppointmentsAppointmentIdDetailsGetUrl(appointmentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Appointment Steps
 */
export const getGetAppointmentStepsApiAppointmentsAppointmentIdStepsGetUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/steps`
}

export const getAppointmentStepsApiAppointmentsAppointmentIdStepsGet = async (appointmentId: string, options?: RequestInit): Promise<AppointmentStepsResponse> => {
  
  return apiFetch<AppointmentStepsResponse>(getGetAppointmentStepsApiAppointmentsAppointmentIdStepsGetUrl(appointmentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Step Status
 */
export const getUpdateStepStatusApiAppointmentsAppointmentIdStepsStepIdStatusPutUrl = (appointmentId: string,
    stepId: string,) => {


  

  return `/api/appointments/${appointmentId}/steps/${stepId}/status`
}

export const updateStepStatusApiAppointmentsAppointmentIdStepsStepIdStatusPut = async (appointmentId: string,
    stepId: string,
    stepStatusUpdate: StepStatusUpdate, options?: RequestInit): Promise<StepStatusUpdateResponse> => {
  
  return apiFetch<StepStatusUpdateResponse>(getUpdateStepStatusApiAppointmentsAppointmentIdStepsStepIdStatusPutUrl(appointmentId,stepId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stepStatusUpdate,)
  }
);}



/**
 * @summary Update Step Staff
 */
export const getUpdateStepStaffApiAppointmentsAppointmentIdStepsStepIdStaffPatchUrl = (appointmentId: string,
    stepId: string,) => {


  

  return `/api/appointments/${appointmentId}/steps/${stepId}/staff`
}

export const updateStepStaffApiAppointmentsAppointmentIdStepsStepIdStaffPatch = async (appointmentId: string,
    stepId: string,
    stepStaffSwap: StepStaffSwap, options?: RequestInit): Promise<StepStaffSwapResponse> => {
  
  return apiFetch<StepStaffSwapResponse>(getUpdateStepStaffApiAppointmentsAppointmentIdStepsStepIdStaffPatchUrl(appointmentId,stepId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stepStaffSwap,)
  }
);}



/**
 * @summary Start Appointment
 */
export const getStartAppointmentApiAppointmentsAppointmentIdStartPostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/start`
}

export const startAppointmentApiAppointmentsAppointmentIdStartPost = async (appointmentId: string, options?: RequestInit): Promise<AppointmentStartResponse> => {
  
  return apiFetch<AppointmentStartResponse>(getStartAppointmentApiAppointmentsAppointmentIdStartPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * OPS-24-07 / 24-08 — 'Start consultation' on the Questionnaires card: the
consultation's own actual start is recorded (her remaining sessions and
package state stored at that moment, OPS-21-13) and the booking goes In
Progress by itself.
 * @summary Start Consultation
 */
export const getStartConsultationApiAppointmentsAppointmentIdConsultationStartPostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/consultation/start`
}

export const startConsultationApiAppointmentsAppointmentIdConsultationStartPost = async (appointmentId: string, options?: RequestInit): Promise<ConsultationStartResponse> => {
  
  return apiFetch<ConsultationStartResponse>(getStartConsultationApiAppointmentsAppointmentIdConsultationStartPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Update Appointment Status
 */
export const getUpdateAppointmentStatusApiAppointmentsAppointmentIdStatusPutUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/status`
}

export const updateAppointmentStatusApiAppointmentsAppointmentIdStatusPut = async (appointmentId: string,
    appointmentStatusUpdate: AppointmentStatusUpdate, options?: RequestInit): Promise<AppointmentStatusUpdateResponse> => {
  
  return apiFetch<AppointmentStatusUpdateResponse>(getUpdateAppointmentStatusApiAppointmentsAppointmentIdStatusPutUrl(appointmentId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentStatusUpdate,)
  }
);}



/**
 * @summary Complete Appointment
 */
export const getCompleteAppointmentApiAppointmentsAppointmentIdCompletePostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/complete`
}

export const completeAppointmentApiAppointmentsAppointmentIdCompletePost = async (appointmentId: string,
    completeAppointmentApiAppointmentsAppointmentIdCompletePostBody: CompleteAppointmentApiAppointmentsAppointmentIdCompletePostBody, options?: RequestInit): Promise<AppointmentCompleteResponse> => {
  
  return apiFetch<AppointmentCompleteResponse>(getCompleteAppointmentApiAppointmentsAppointmentIdCompletePostUrl(appointmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      completeAppointmentApiAppointmentsAppointmentIdCompletePostBody,)
  }
);}



/**
 * @summary Get Appointment Rating
 */
export const getGetAppointmentRatingApiAppointmentsAppointmentIdRatingGetUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/rating`
}

export const getAppointmentRatingApiAppointmentsAppointmentIdRatingGet = async (appointmentId: string, options?: RequestInit): Promise<AppointmentRatingResponse> => {
  
  return apiFetch<AppointmentRatingResponse>(getGetAppointmentRatingApiAppointmentsAppointmentIdRatingGetUrl(appointmentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Submit Appointment Rating
 */
export const getSubmitAppointmentRatingApiAppointmentsAppointmentIdRatingPostUrl = (appointmentId: string,) => {


  

  return `/api/appointments/${appointmentId}/rating`
}

export const submitAppointmentRatingApiAppointmentsAppointmentIdRatingPost = async (appointmentId: string,
    appointmentRatingRequest: AppointmentRatingRequest, options?: RequestInit): Promise<AppointmentRatingSubmitResponse> => {
  
  return apiFetch<AppointmentRatingSubmitResponse>(getSubmitAppointmentRatingApiAppointmentsAppointmentIdRatingPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      appointmentRatingRequest,)
  }
);}



/**
 * @summary List Probation Ending
 */
export const getListProbationEndingApiStaffProbationEndingGetUrl = (params?: ListProbationEndingApiStaffProbationEndingGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/probation-ending?${stringifiedParams}` : `/api/staff/probation-ending`
}

export const listProbationEndingApiStaffProbationEndingGet = async (params?: ListProbationEndingApiStaffProbationEndingGetParams, options?: RequestInit): Promise<ProbationEndingItem[]> => {
  
  return apiFetch<ProbationEndingItem[]>(getListProbationEndingApiStaffProbationEndingGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * One .xlsx of the staff the HR > Staff list shows for this Outlet and View by.
The key alone is not enough: the caller must also be HQ staff (or ADMIN).
 * @summary Download Staff Details Report
 */
export const getDownloadStaffDetailsReportApiStaffDetailsReportGetUrl = (params?: DownloadStaffDetailsReportApiStaffDetailsReportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/details-report?${stringifiedParams}` : `/api/staff/details-report`
}

export const downloadStaffDetailsReportApiStaffDetailsReportGet = async (params?: DownloadStaffDetailsReportApiStaffDetailsReportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getDownloadStaffDetailsReportApiStaffDetailsReportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Staff Profile
 */
export const getGetStaffProfileApiStaffStaffIdProfileGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/profile`
}

export const getStaffProfileApiStaffStaffIdProfileGet = async (staffId: string, options?: RequestInit): Promise<StaffProfileResponse> => {
  
  return apiFetch<StaffProfileResponse>(getGetStaffProfileApiStaffStaffIdProfileGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Staff Hr Info
 */
export const getUpdateStaffHrInfoApiStaffStaffIdHrInfoPutUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/hr-info`
}

export const updateStaffHrInfoApiStaffStaffIdHrInfoPut = async (staffId: string,
    staffHrInfoUpdate: StaffHrInfoUpdate, options?: RequestInit): Promise<StaffHrInfo> => {
  
  return apiFetch<StaffHrInfo>(getUpdateStaffHrInfoApiStaffStaffIdHrInfoPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffHrInfoUpdate,)
  }
);}



/**
 * @summary Update Staff Employment
 */
export const getUpdateStaffEmploymentApiStaffStaffIdEmploymentPutUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/employment`
}

export const updateStaffEmploymentApiStaffStaffIdEmploymentPut = async (staffId: string,
    staffEmploymentUpdate: StaffEmploymentUpdate, options?: RequestInit): Promise<StaffEmployment> => {
  
  return apiFetch<StaffEmployment>(getUpdateStaffEmploymentApiStaffStaffIdEmploymentPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffEmploymentUpdate,)
  }
);}



/**
 * @summary List Staff Employment History
 */
export const getListStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/employment-history`
}

export const listStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryGet = async (staffId: string, options?: RequestInit): Promise<StaffEmploymentHistoryItem[]> => {
  
  return apiFetch<StaffEmploymentHistoryItem[]>(getListStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Staff Employment History
 */
export const getCreateStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryPostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/employment-history`
}

export const createStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryPost = async (staffId: string,
    staffEmploymentHistoryUpsert: StaffEmploymentHistoryUpsert, options?: RequestInit): Promise<StaffEmploymentHistoryItem> => {
  
  return apiFetch<StaffEmploymentHistoryItem>(getCreateStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryPostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffEmploymentHistoryUpsert,)
  }
);}



/**
 * BUG-885 — record an employment change (promotion, outlet transfer,
department change, employment-type change, …).

Closes the current record and opens its successor in ONE transaction, and
returns the whole refreshed timeline so the client re-renders from a single
authoritative response instead of stitching two writes together.
 * @summary Record Staff Employment Change
 */
export const getRecordStaffEmploymentChangeApiStaffStaffIdEmploymentHistoryChangePostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/employment-history/change`
}

export const recordStaffEmploymentChangeApiStaffStaffIdEmploymentHistoryChangePost = async (staffId: string,
    staffEmploymentChangeRequest: StaffEmploymentChangeRequest, options?: RequestInit): Promise<StaffEmploymentHistoryItem[]> => {
  
  return apiFetch<StaffEmploymentHistoryItem[]>(getRecordStaffEmploymentChangeApiStaffStaffIdEmploymentHistoryChangePostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffEmploymentChangeRequest,)
  }
);}



/**
 * @summary Update Staff Employment History
 */
export const getUpdateStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryHistIdPutUrl = (staffId: string,
    histId: string,) => {


  

  return `/api/staff/${staffId}/employment-history/${histId}`
}

export const updateStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryHistIdPut = async (staffId: string,
    histId: string,
    staffEmploymentHistoryUpsert: StaffEmploymentHistoryUpsert, options?: RequestInit): Promise<StaffEmploymentHistoryItem> => {
  
  return apiFetch<StaffEmploymentHistoryItem>(getUpdateStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryHistIdPutUrl(staffId,histId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffEmploymentHistoryUpsert,)
  }
);}



/**
 * @summary Delete Staff Employment History
 */
export const getDeleteStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryHistIdDeleteUrl = (staffId: string,
    histId: string,) => {


  

  return `/api/staff/${staffId}/employment-history/${histId}`
}

export const deleteStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryHistIdDelete = async (staffId: string,
    histId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteStaffEmploymentHistoryApiStaffStaffIdEmploymentHistoryHistIdDeleteUrl(staffId,histId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Update Staff Payroll Info
 */
export const getUpdateStaffPayrollInfoApiStaffStaffIdPayrollInfoPutUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/payroll-info`
}

export const updateStaffPayrollInfoApiStaffStaffIdPayrollInfoPut = async (staffId: string,
    staffPayrollInfoUpdate: StaffPayrollInfoUpdate, options?: RequestInit): Promise<StaffPayrollInfoResponse> => {
  
  return apiFetch<StaffPayrollInfoResponse>(getUpdateStaffPayrollInfoApiStaffStaffIdPayrollInfoPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffPayrollInfoUpdate,)
  }
);}



/**
 * @summary Get Staff Payroll
 */
export const getGetStaffPayrollApiStaffStaffIdPayrollGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/payroll`
}

export const getStaffPayrollApiStaffStaffIdPayrollGet = async (staffId: string, options?: RequestInit): Promise<StaffPayrollInfoResponse> => {
  
  return apiFetch<StaffPayrollInfoResponse>(getGetStaffPayrollApiStaffStaffIdPayrollGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Staff Details > Insurance (Angela, 21 Oct 2026): MI, WIC and Bond with
their dates and the 2-month / 1-month expiry warning.
 * @summary List Staff Insurance
 */
export const getListStaffInsuranceApiStaffStaffIdInsuranceGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/insurance`
}

export const listStaffInsuranceApiStaffStaffIdInsuranceGet = async (staffId: string, options?: RequestInit): Promise<StaffInsuranceItem[]> => {
  
  return apiFetch<StaffInsuranceItem[]>(getListStaffInsuranceApiStaffStaffIdInsuranceGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Save Staff Insurance
 */
export const getSaveStaffInsuranceApiStaffStaffIdInsurancePutUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/insurance`
}

export const saveStaffInsuranceApiStaffStaffIdInsurancePut = async (staffId: string,
    staffInsuranceItem: StaffInsuranceItem[], options?: RequestInit): Promise<StaffInsuranceItem[]> => {
  
  return apiFetch<StaffInsuranceItem[]>(getSaveStaffInsuranceApiStaffStaffIdInsurancePutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffInsuranceItem,)
  }
);}



/**
 * @summary List Staff Documents
 */
export const getListStaffDocumentsApiStaffStaffIdDocumentsGetUrl = (staffId: string,
    params?: ListStaffDocumentsApiStaffStaffIdDocumentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/${staffId}/documents?${stringifiedParams}` : `/api/staff/${staffId}/documents`
}

export const listStaffDocumentsApiStaffStaffIdDocumentsGet = async (staffId: string,
    params?: ListStaffDocumentsApiStaffStaffIdDocumentsGetParams, options?: RequestInit): Promise<StaffDocumentSummary[]> => {
  
  return apiFetch<StaffDocumentSummary[]>(getListStaffDocumentsApiStaffStaffIdDocumentsGetUrl(staffId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Staff Document
 */
export const getCreateStaffDocumentApiStaffStaffIdDocumentsPostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/documents`
}

export const createStaffDocumentApiStaffStaffIdDocumentsPost = async (staffId: string,
    staffDocumentCreateRequest: StaffDocumentCreateRequest, options?: RequestInit): Promise<StaffDocumentSummary> => {
  
  return apiFetch<StaffDocumentSummary>(getCreateStaffDocumentApiStaffStaffIdDocumentsPostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffDocumentCreateRequest,)
  }
);}



/**
 * @summary Download Staff Document
 */
export const getDownloadStaffDocumentApiStaffStaffIdDocumentsDocIdDownloadGetUrl = (staffId: string,
    docId: string,) => {


  

  return `/api/staff/${staffId}/documents/${docId}/download`
}

export const downloadStaffDocumentApiStaffStaffIdDocumentsDocIdDownloadGet = async (staffId: string,
    docId: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getDownloadStaffDocumentApiStaffStaffIdDocumentsDocIdDownloadGetUrl(staffId,docId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Delete Staff Document
 */
export const getDeleteStaffDocumentApiStaffStaffIdDocumentsDocIdDeleteUrl = (staffId: string,
    docId: string,) => {


  

  return `/api/staff/${staffId}/documents/${docId}`
}

export const deleteStaffDocumentApiStaffStaffIdDocumentsDocIdDelete = async (staffId: string,
    docId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteStaffDocumentApiStaffStaffIdDocumentsDocIdDeleteUrl(staffId,docId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Settings > Tablets — every registered tablet with its state.
 * @summary List Tablets
 */
export const getListTabletsApiTabletsGetUrl = () => {


  

  return `/api/tablets`
}

export const listTabletsApiTabletsGet = async ( options?: RequestInit): Promise<TabletOut[]> => {
  
  return apiFetch<TabletOut[]>(getListTabletsApiTabletsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ registers an outlet's tablet once and gets its pairing code (shown
once, valid 10 minutes).
 * @summary Register Tablet
 */
export const getRegisterTabletApiTabletsPostUrl = () => {


  

  return `/api/tablets`
}

export const registerTabletApiTabletsPost = async (tabletRegister: TabletRegister, options?: RequestInit): Promise<TabletRegistered> => {
  
  return apiFetch<TabletRegistered>(getRegisterTabletApiTabletsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tabletRegister,)
  }
);}



/**
 * A fresh code for a replacement iPad. The old device token stops working.
 * @summary New Pairing Code
 */
export const getNewPairingCodeApiTabletsTabletIdPairingCodePostUrl = (tabletId: string,) => {


  

  return `/api/tablets/${tabletId}/pairing-code`
}

export const newPairingCodeApiTabletsTabletIdPairingCodePost = async (tabletId: string, options?: RequestInit): Promise<TabletRegistered> => {
  
  return apiFetch<TabletRegistered>(getNewPairingCodeApiTabletsTabletIdPairingCodePostUrl(tabletId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Lost or retired iPad: its token stops working at once.
 * @summary Revoke Tablet
 */
export const getRevokeTabletApiTabletsTabletIdRevokePostUrl = (tabletId: string,) => {


  

  return `/api/tablets/${tabletId}/revoke`
}

export const revokeTabletApiTabletsTabletIdRevokePost = async (tabletId: string, options?: RequestInit): Promise<TabletOut> => {
  
  return apiFetch<TabletOut>(getRevokeTabletApiTabletsTabletIdRevokePostUrl(tabletId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * GEN-06-13 — whether Open tablet has somewhere to send to.
 * @summary Outlet Status
 */
export const getOutletStatusApiTabletsStatusGetUrl = (params: OutletStatusApiTabletsStatusGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tablets/status?${stringifiedParams}` : `/api/tablets/status`
}

export const outletStatusApiTabletsStatusGet = async (params: OutletStatusApiTabletsStatusGetParams, options?: RequestInit): Promise<TabletStatusOut> => {
  
  return apiFetch<TabletStatusOut>(getOutletStatusApiTabletsStatusGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Open tablet — send the form for the chosen customer to the outlet's tablet.
 * @summary Send Form
 */
export const getSendFormApiTabletsSessionsPostUrl = () => {


  

  return `/api/tablets/sessions`
}

export const sendFormApiTabletsSessionsPost = async (tabletSendForm: TabletSendForm, options?: RequestInit): Promise<TabletFormSessionOut> => {
  
  return apiFetch<TabletFormSessionOut>(getSendFormApiTabletsSessionsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tabletSendForm,)
  }
);}



/**
 * The staff page polls this: Sent → Signed, or Closed ('Not signed yet').
 * @summary Get Session
 */
export const getGetSessionApiTabletsSessionsSessionIdGetUrl = (sessionId: string,) => {


  

  return `/api/tablets/sessions/${sessionId}`
}

export const getSessionApiTabletsSessionsSessionIdGet = async (sessionId: string, options?: RequestInit): Promise<TabletFormSessionOut> => {
  
  return apiFetch<TabletFormSessionOut>(getGetSessionApiTabletsSessionsSessionIdGetUrl(sessionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Staff take the form back before it is signed. Nothing is saved.
 * @summary Cancel Session
 */
export const getCancelSessionApiTabletsSessionsSessionIdCancelPostUrl = (sessionId: string,) => {


  

  return `/api/tablets/sessions/${sessionId}/cancel`
}

export const cancelSessionApiTabletsSessionsSessionIdCancelPost = async (sessionId: string, options?: RequestInit): Promise<TabletFormSessionOut> => {
  
  return apiFetch<TabletFormSessionOut>(getCancelSessionApiTabletsSessionsSessionIdCancelPostUrl(sessionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The iPad types the 6-digit code once and gets its device token.
 * @summary Pair
 */
export const getPairApiTabletDevicePairPostUrl = () => {


  

  return `/api/tablet-device/pair`
}

export const pairApiTabletDevicePairPost = async (tabletPairRequest: TabletPairRequest, options?: RequestInit): Promise<TabletPairResult> => {
  
  return apiFetch<TabletPairResult>(getPairApiTabletDevicePairPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tabletPairRequest,)
  }
);}



/**
 * 'I'm here — what should I show?' Polled every few seconds by the tablet.
 * @summary Heartbeat
 */
export const getHeartbeatApiTabletDeviceSessionGetUrl = () => {


  

  return `/api/tablet-device/session`
}

export const heartbeatApiTabletDeviceSessionGet = async ( options?: RequestInit): Promise<TabletDeviceSessionOut> => {
  
  return apiFetch<TabletDeviceSessionOut>(getHeartbeatApiTabletDeviceSessionGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Submit on the tablet → the response lands in Form Responses, 'Signed on:
tablet', as the staff member who sent it.
 * @summary Submit
 */
export const getSubmitApiTabletDeviceSessionSessionIdSubmitPostUrl = (sessionId: string,) => {


  

  return `/api/tablet-device/session/${sessionId}/submit`
}

export const submitApiTabletDeviceSessionSessionIdSubmitPost = async (sessionId: string,
    tabletSubmit: TabletSubmit, options?: RequestInit): Promise<TabletFormSessionOut> => {
  
  return apiFetch<TabletFormSessionOut>(getSubmitApiTabletDeviceSessionSessionIdSubmitPostUrl(sessionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tabletSubmit,)
  }
);}



/**
 * Closed on the tablet without Submit — nothing is saved.
 * @summary Close
 */
export const getCloseApiTabletDeviceSessionSessionIdClosePostUrl = (sessionId: string,) => {


  

  return `/api/tablet-device/session/${sessionId}/close`
}

export const closeApiTabletDeviceSessionSessionIdClosePost = async (sessionId: string, options?: RequestInit): Promise<TabletFormSessionOut> => {
  
  return apiFetch<TabletFormSessionOut>(getCloseApiTabletDeviceSessionSessionIdClosePostUrl(sessionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Seed the full treatment catalog (programs + steps, §8.1 prices, AESTHETIC/
SKIN categories). For a fresh/half-migrated env so Treatments / skill-matrix /
POS / IHIP work. Idempotent — programs upsert by name, steps by id.
 * @summary Seed Treatment Catalog
 */
export const getSeedTreatmentCatalogApiTreatmentsSeedPostUrl = () => {


  

  return `/api/treatments/seed`
}

export const seedTreatmentCatalogApiTreatmentsSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedTreatmentCatalogApiTreatmentsSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HQ uploads the '(New Trial)' price sheet and sees which programmes'
'1 Trial' price would be filled and which rows are skipped. Nothing is saved.
 * @summary Preview Trial Import
 */
export const getPreviewTrialImportApiTreatmentsTrialImportPreviewPostUrl = () => {


  

  return `/api/treatments/trial-import/preview`
}

export const previewTrialImportApiTreatmentsTrialImportPreviewPost = async (bodyPreviewTrialImportApiTreatmentsTrialImportPreviewPost: BodyPreviewTrialImportApiTreatmentsTrialImportPreviewPost, options?: RequestInit): Promise<TrialImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyPreviewTrialImportApiTreatmentsTrialImportPreviewPost.file)

  return apiFetch<TrialImportPreview>(getPreviewTrialImportApiTreatmentsTrialImportPreviewPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * Fill the '1 Trial' price of the programme of every READY row (decision I2),
and of every row below its trial minimum when HQ gives a reason (T4).
 * @summary Run Trial Import
 */
export const getRunTrialImportApiTreatmentsTrialImportPostUrl = () => {


  

  return `/api/treatments/trial-import`
}

export const runTrialImportApiTreatmentsTrialImportPost = async (bodyRunTrialImportApiTreatmentsTrialImportPost: BodyRunTrialImportApiTreatmentsTrialImportPost, options?: RequestInit): Promise<TrialImportResult> => {
    const formData = new FormData();
formData.append(`file`, bodyRunTrialImportApiTreatmentsTrialImportPost.file)
if(bodyRunTrialImportApiTreatmentsTrialImportPost.belowMinimumReason !== undefined && bodyRunTrialImportApiTreatmentsTrialImportPost.belowMinimumReason !== null) {
 formData.append(`belowMinimumReason`, bodyRunTrialImportApiTreatmentsTrialImportPost.belowMinimumReason)
 }

  return apiFetch<TrialImportResult>(getRunTrialImportApiTreatmentsTrialImportPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary List Treatments
 */
export const getListTreatmentsApiTreatmentsGetUrl = (params?: ListTreatmentsApiTreatmentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/treatments?${stringifiedParams}` : `/api/treatments`
}

export const listTreatmentsApiTreatmentsGet = async (params?: ListTreatmentsApiTreatmentsGetParams, options?: RequestInit): Promise<TreatmentSummary[]> => {
  
  return apiFetch<TreatmentSummary[]>(getListTreatmentsApiTreatmentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Treatment
 */
export const getCreateTreatmentApiTreatmentsPostUrl = () => {


  

  return `/api/treatments`
}

export const createTreatmentApiTreatmentsPost = async (treatmentCreate: TreatmentCreate, options?: RequestInit): Promise<TreatmentDetail> => {
  
  return apiFetch<TreatmentDetail>(getCreateTreatmentApiTreatmentsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      treatmentCreate,)
  }
);}



/**
 * @summary Get Treatment Matrix
 */
export const getGetTreatmentMatrixApiTreatmentsMatrixGetUrl = (params?: GetTreatmentMatrixApiTreatmentsMatrixGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/treatments/matrix?${stringifiedParams}` : `/api/treatments/matrix`
}

export const getTreatmentMatrixApiTreatmentsMatrixGet = async (params?: GetTreatmentMatrixApiTreatmentsMatrixGetParams, options?: RequestInit): Promise<SkillMatrixResponse> => {
  
  return apiFetch<SkillMatrixResponse>(getGetTreatmentMatrixApiTreatmentsMatrixGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Treatment
 */
export const getGetTreatmentApiTreatmentsTreatmentIdGetUrl = (treatmentId: string,
    params?: GetTreatmentApiTreatmentsTreatmentIdGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/treatments/${treatmentId}?${stringifiedParams}` : `/api/treatments/${treatmentId}`
}

export const getTreatmentApiTreatmentsTreatmentIdGet = async (treatmentId: string,
    params?: GetTreatmentApiTreatmentsTreatmentIdGetParams, options?: RequestInit): Promise<TreatmentDetail> => {
  
  return apiFetch<TreatmentDetail>(getGetTreatmentApiTreatmentsTreatmentIdGetUrl(treatmentId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Treatment
 */
export const getUpdateTreatmentApiTreatmentsTreatmentIdPatchUrl = (treatmentId: string,) => {


  

  return `/api/treatments/${treatmentId}`
}

export const updateTreatmentApiTreatmentsTreatmentIdPatch = async (treatmentId: string,
    treatmentUpdate: TreatmentUpdate, options?: RequestInit): Promise<TreatmentDetail> => {
  
  return apiFetch<TreatmentDetail>(getUpdateTreatmentApiTreatmentsTreatmentIdPatchUrl(treatmentId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      treatmentUpdate,)
  }
);}



/**
 * @summary Create Treatment Step
 */
export const getCreateTreatmentStepApiTreatmentsTreatmentIdStepsPostUrl = (treatmentId: string,) => {


  

  return `/api/treatments/${treatmentId}/steps`
}

export const createTreatmentStepApiTreatmentsTreatmentIdStepsPost = async (treatmentId: string,
    treatmentStepCreate: TreatmentStepCreate, options?: RequestInit): Promise<TreatmentStepDetail> => {
  
  return apiFetch<TreatmentStepDetail>(getCreateTreatmentStepApiTreatmentsTreatmentIdStepsPostUrl(treatmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      treatmentStepCreate,)
  }
);}



/**
 * @summary Reorder Treatment Steps
 */
export const getReorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPostUrl = (treatmentId: string,) => {


  

  return `/api/treatments/${treatmentId}/steps/reorder`
}

export const reorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPost = async (treatmentId: string,
    reorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPostBody: ReorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPostBody, options?: RequestInit): Promise<TreatmentStepDetail[]> => {
  
  return apiFetch<TreatmentStepDetail[]>(getReorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPostUrl(treatmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderTreatmentStepsApiTreatmentsTreatmentIdStepsReorderPostBody,)
  }
);}



/**
 * @summary Update Program Step
 */
export const getUpdateProgramStepApiTreatmentsProgramStepsStepIdPatchUrl = (stepId: string,) => {


  

  return `/api/treatments/program-steps/${stepId}`
}

export const updateProgramStepApiTreatmentsProgramStepsStepIdPatch = async (stepId: string,
    treatmentStepUpdate: TreatmentStepUpdate, options?: RequestInit): Promise<TreatmentStepDetail> => {
  
  return apiFetch<TreatmentStepDetail>(getUpdateProgramStepApiTreatmentsProgramStepsStepIdPatchUrl(stepId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      treatmentStepUpdate,)
  }
);}



/**
 * @summary Delete Program Step
 */
export const getDeleteProgramStepApiTreatmentsProgramStepsStepIdDeleteUrl = (stepId: string,) => {


  

  return `/api/treatments/program-steps/${stepId}`
}

export const deleteProgramStepApiTreatmentsProgramStepsStepIdDelete = async (stepId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteProgramStepApiTreatmentsProgramStepsStepIdDeleteUrl(stepId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Set Matrix Exclusions
 */
export const getSetMatrixExclusionsApiTreatmentsMatrixExclusionsPostUrl = () => {


  

  return `/api/treatments/matrix/exclusions`
}

export const setMatrixExclusionsApiTreatmentsMatrixExclusionsPost = async (staffStepExclusionRequest: StaffStepExclusionRequest, options?: RequestInit): Promise<StaffStepExclusion[]> => {
  
  return apiFetch<StaffStepExclusion[]>(getSetMatrixExclusionsApiTreatmentsMatrixExclusionsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffStepExclusionRequest,)
  }
);}



/**
 * ``byDepartment`` (Staff Directory, HR-02-19): the outlet filter matches
the Department instead of where the staff member works.
``includeDetailsNeeded`` (HR > Staff only, HR-02-21): also list staff added
with their User information only.
 * @summary List Staff
 */
export const getListStaffApiStaffGetUrl = (params?: ListStaffApiStaffGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff?${stringifiedParams}` : `/api/staff`
}

export const listStaffApiStaffGet = async (params?: ListStaffApiStaffGetParams, options?: RequestInit): Promise<StaffSummary[]> => {
  
  return apiFetch<StaffSummary[]>(getListStaffApiStaffGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Staff
 */
export const getCreateStaffApiStaffPostUrl = () => {


  

  return `/api/staff`
}

export const createStaffApiStaffPost = async (staffCreate: StaffCreate, options?: RequestInit): Promise<StaffDetail> => {
  
  return apiFetch<StaffDetail>(getCreateStaffApiStaffPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffCreate,)
  }
);}



/**
 * HR-02-21 (Angela, 24 / 26 Oct 2026) — Add Staff, HQ only: Display name,
outlet, online access and a password. The record is 'Details needed' until
Basic is filled in; with online access her login is made in the same step
(User ID = Display name, HR-11-03).
 * @summary Create Staff Quick
 */
export const getCreateStaffQuickApiStaffQuickPostUrl = () => {


  

  return `/api/staff/quick`
}

export const createStaffQuickApiStaffQuickPost = async (staffQuickCreate: StaffQuickCreate, options?: RequestInit): Promise<StaffDetail> => {
  
  return apiFetch<StaffDetail>(getCreateStaffQuickApiStaffQuickPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffQuickCreate,)
  }
);}



/**
 * @summary Staff Birthdays Today
 */
export const getStaffBirthdaysTodayApiStaffBirthdaysTodayGetUrl = (params?: StaffBirthdaysTodayApiStaffBirthdaysTodayGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/birthdays-today?${stringifiedParams}` : `/api/staff/birthdays-today`
}

export const staffBirthdaysTodayApiStaffBirthdaysTodayGet = async (params?: StaffBirthdaysTodayApiStaffBirthdaysTodayGetParams, options?: RequestInit): Promise<StaffBirthdayItem[]> => {
  
  return apiFetch<StaffBirthdayItem[]>(getStaffBirthdaysTodayApiStaffBirthdaysTodayGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Staff from other outlets who can be pulled in to cover at this one.
 * @summary Staff Covering Candidates
 */
export const getStaffCoveringCandidatesApiStaffCoveringCandidatesGetUrl = (params: StaffCoveringCandidatesApiStaffCoveringCandidatesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/covering-candidates?${stringifiedParams}` : `/api/staff/covering-candidates`
}

export const staffCoveringCandidatesApiStaffCoveringCandidatesGet = async (params: StaffCoveringCandidatesApiStaffCoveringCandidatesGetParams, options?: RequestInit): Promise<StaffCoveringCandidate[]> => {
  
  return apiFetch<StaffCoveringCandidate[]>(getStaffCoveringCandidatesApiStaffCoveringCandidatesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Staff
 */
export const getGetStaffApiStaffStaffIdGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}`
}

export const getStaffApiStaffStaffIdGet = async (staffId: string, options?: RequestInit): Promise<StaffDetail> => {
  
  return apiFetch<StaffDetail>(getGetStaffApiStaffStaffIdGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Staff
 */
export const getUpdateStaffApiStaffStaffIdPutUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}`
}

export const updateStaffApiStaffStaffIdPut = async (staffId: string,
    staffUpdate: StaffUpdate, options?: RequestInit): Promise<StaffDetail> => {
  
  return apiFetch<StaffDetail>(getUpdateStaffApiStaffStaffIdPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffUpdate,)
  }
);}



/**
 * @summary Delete Staff
 */
export const getDeleteStaffApiStaffStaffIdDeleteUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}`
}

export const deleteStaffApiStaffStaffIdDelete = async (staffId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteStaffApiStaffStaffIdDeleteUrl(staffId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Undo a soft-delete.

API-only on purpose: there is no screen listing deleted accounts, so this is
the recovery path for a mis-click rather than a routine action. The account
comes back INACTIVE — restoring says "this should exist after all", not
"this person is back on the rota".
 * @summary Restore Staff
 */
export const getRestoreStaffApiStaffStaffIdRestorePostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/restore`
}

export const restoreStaffApiStaffStaffIdRestorePost = async (staffId: string, options?: RequestInit): Promise<StaffDetail> => {
  
  return apiFetch<StaffDetail>(getRestoreStaffApiStaffStaffIdRestorePostUrl(staffId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Staff Shifts
 */
export const getGetStaffShiftsApiStaffStaffIdShiftsGetUrl = (staffId: string,
    params?: GetStaffShiftsApiStaffStaffIdShiftsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/${staffId}/shifts?${stringifiedParams}` : `/api/staff/${staffId}/shifts`
}

export const getStaffShiftsApiStaffStaffIdShiftsGet = async (staffId: string,
    params?: GetStaffShiftsApiStaffStaffIdShiftsGetParams, options?: RequestInit): Promise<StaffShift[]> => {
  
  return apiFetch<StaffShift[]>(getGetStaffShiftsApiStaffStaffIdShiftsGetUrl(staffId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Staff Shift
 */
export const getUpsertStaffShiftApiStaffStaffIdShiftsPutUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/shifts`
}

export const upsertStaffShiftApiStaffStaffIdShiftsPut = async (staffId: string,
    staffShiftUpsert: StaffShiftUpsert, options?: RequestInit): Promise<StaffShiftUpsertResponse> => {
  
  return apiFetch<StaffShiftUpsertResponse>(getUpsertStaffShiftApiStaffStaffIdShiftsPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffShiftUpsert,)
  }
);}



/**
 * Clear a month (``month=YYYY-MM``) or an explicit range (``from``+``to``) of
a staff member's roster. Days blocked by approved leave are preserved.
 * @summary Bulk Delete Staff Shifts
 */
export const getBulkDeleteStaffShiftsApiStaffStaffIdShiftsBulkDeleteUrl = (staffId: string,
    params?: BulkDeleteStaffShiftsApiStaffStaffIdShiftsBulkDeleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff/${staffId}/shifts/bulk?${stringifiedParams}` : `/api/staff/${staffId}/shifts/bulk`
}

export const bulkDeleteStaffShiftsApiStaffStaffIdShiftsBulkDelete = async (staffId: string,
    params?: BulkDeleteStaffShiftsApiStaffStaffIdShiftsBulkDeleteParams, options?: RequestInit): Promise<StaffShiftBulkDeleteResponse> => {
  
  return apiFetch<StaffShiftBulkDeleteResponse>(getBulkDeleteStaffShiftsApiStaffStaffIdShiftsBulkDeleteUrl(staffId,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Copy one month of this staff member's roster onto another month.
 * @summary Copy Staff Month Shifts
 */
export const getCopyStaffMonthShiftsApiStaffStaffIdShiftsCopyMonthPostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/shifts/copy-month`
}

export const copyStaffMonthShiftsApiStaffStaffIdShiftsCopyMonthPost = async (staffId: string,
    staffShiftCopyMonth: StaffShiftCopyMonth, options?: RequestInit): Promise<StaffShiftApplyDateResult[]> => {
  
  return apiFetch<StaffShiftApplyDateResult[]>(getCopyStaffMonthShiftsApiStaffStaffIdShiftsCopyMonthPostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffShiftCopyMonth,)
  }
);}



/**
 * Copy a month of this staff member's roster onto another staff member.
 * @summary Copy Staff Shifts To Staff
 */
export const getCopyStaffShiftsToStaffApiStaffStaffIdShiftsCopyToPostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/shifts/copy-to`
}

export const copyStaffShiftsToStaffApiStaffStaffIdShiftsCopyToPost = async (staffId: string,
    staffShiftCopyToStaff: StaffShiftCopyToStaff, options?: RequestInit): Promise<StaffShiftApplyDateResult[]> => {
  
  return apiFetch<StaffShiftApplyDateResult[]>(getCopyStaffShiftsToStaffApiStaffStaffIdShiftsCopyToPostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffShiftCopyToStaff,)
  }
);}



/**
 * Delete a staff member's shift for a given day (returns the cell to blank).
 * @summary Delete Staff Shift
 */
export const getDeleteStaffShiftApiStaffStaffIdShiftsShiftDateDeleteUrl = (staffId: string,
    shiftDate: string,) => {


  

  return `/api/staff/${staffId}/shifts/${shiftDate}`
}

export const deleteStaffShiftApiStaffStaffIdShiftsShiftDateDelete = async (staffId: string,
    shiftDate: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteStaffShiftApiStaffStaffIdShiftsShiftDateDeleteUrl(staffId,shiftDate),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Write a shift onto one or more days.

Not `require_admin` — outlet staff still roster working shifts and Off. Only
the *leave* categories are admin-gated, and that check lives in the service
because it depends on the resolved ShiftType and on what is already on the day.
 * @summary Apply Staff Shifts
 */
export const getApplyStaffShiftsApiStaffStaffIdShiftsApplyPostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/shifts/apply`
}

export const applyStaffShiftsApiStaffStaffIdShiftsApplyPost = async (staffId: string,
    staffShiftApply: StaffShiftApply, options?: RequestInit): Promise<StaffShiftApplyDateResult[]> => {
  
  return apiFetch<StaffShiftApplyDateResult[]>(getApplyStaffShiftsApiStaffStaffIdShiftsApplyPostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffShiftApply,)
  }
);}



/**
 * OPS-14-09 — Operations > Staff Roster > Change Log: who changed whose
roster, what and when, newest first (500 rows at most).
 * @summary List Roster Change Log
 */
export const getListRosterChangeLogApiRosterChangeLogGetUrl = (params?: ListRosterChangeLogApiRosterChangeLogGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/roster/change-log?${stringifiedParams}` : `/api/roster/change-log`
}

export const listRosterChangeLogApiRosterChangeLogGet = async (params?: ListRosterChangeLogApiRosterChangeLogGetParams, options?: RequestInit): Promise<RosterChangeLogEntry[]> => {
  
  return apiFetch<RosterChangeLogEntry[]>(getListRosterChangeLogApiRosterChangeLogGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Staff Training
 */
export const getGetStaffTrainingApiStaffStaffIdTrainingGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/training`
}

export const getStaffTrainingApiStaffStaffIdTrainingGet = async (staffId: string, options?: RequestInit): Promise<StaffTrainingResponse> => {
  
  return apiFetch<StaffTrainingResponse>(getGetStaffTrainingApiStaffStaffIdTrainingGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Staff Training
 */
export const getUpdateStaffTrainingApiStaffStaffIdTrainingPatchUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/training`
}

export const updateStaffTrainingApiStaffStaffIdTrainingPatch = async (staffId: string,
    staffTrainingUpdate: StaffTrainingUpdate, options?: RequestInit): Promise<StaffTrainingMutationResponse> => {
  
  return apiFetch<StaffTrainingMutationResponse>(getUpdateStaffTrainingApiStaffStaffIdTrainingPatchUrl(staffId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffTrainingUpdate,)
  }
);}



/**
 * The whole staff x training-item grid in one request.

`require_auth` rather than `require_admin`: staff should be able to read the
training landscape. Writing it is admin-only — see the PATCH below, matching
`PATCH /staff/{id}/training`.
 * @summary Get Training Matrix
 */
export const getGetTrainingMatrixApiTrainingMatrixGetUrl = (params?: GetTrainingMatrixApiTrainingMatrixGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/training/matrix?${stringifiedParams}` : `/api/training/matrix`
}

export const getTrainingMatrixApiTrainingMatrixGet = async (params?: GetTrainingMatrixApiTrainingMatrixGetParams, options?: RequestInit): Promise<TrainingMatrixResponse> => {
  
  return apiFetch<TrainingMatrixResponse>(getGetTrainingMatrixApiTrainingMatrixGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-01a — passed counts per staff member plus the catalogue totals, for
the staff list's Training column. Same audience as the matrix (read-only,
`require_auth`); staff with no PASSED record are simply absent.
 * @summary Get Training Summary
 */
export const getGetTrainingSummaryApiTrainingSummaryGetUrl = () => {


  

  return `/api/training/summary`
}

export const getTrainingSummaryApiTrainingSummaryGet = async ( options?: RequestInit): Promise<TrainingSummaryResponse> => {
  
  return apiFetch<TrainingSummaryResponse>(getGetTrainingSummaryApiTrainingSummaryGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Batch Update Training Records
 */
export const getBatchUpdateTrainingRecordsApiTrainingRecordsPatchUrl = () => {


  

  return `/api/training/records`
}

export const batchUpdateTrainingRecordsApiTrainingRecordsPatch = async (trainingBatchUpdateRequest: TrainingBatchUpdateRequest, options?: RequestInit): Promise<TrainingBatchUpdateResponse> => {
  
  return apiFetch<TrainingBatchUpdateResponse>(getBatchUpdateTrainingRecordsApiTrainingRecordsPatchUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingBatchUpdateRequest,)
  }
);}



/**
 * @summary Get Staff Reviews
 */
export const getGetStaffReviewsApiStaffStaffIdReviewsGetUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/reviews`
}

export const getStaffReviewsApiStaffStaffIdReviewsGet = async (staffId: string, options?: RequestInit): Promise<StaffReview[]> => {
  
  return apiFetch<StaffReview[]>(getGetStaffReviewsApiStaffStaffIdReviewsGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Staff Review
 */
export const getUpsertStaffReviewApiStaffStaffIdReviewsPostUrl = (staffId: string,) => {


  

  return `/api/staff/${staffId}/reviews`
}

export const upsertStaffReviewApiStaffStaffIdReviewsPost = async (staffId: string,
    staffReviewCreate: StaffReviewCreate, options?: RequestInit): Promise<StaffReview> => {
  
  return apiFetch<StaffReview>(getUpsertStaffReviewApiStaffStaffIdReviewsPostUrl(staffId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffReviewCreate,)
  }
);}



/**
 * @summary Delete Staff Review
 */
export const getDeleteStaffReviewApiStaffStaffIdReviewsReviewIdDeleteUrl = (staffId: string,
    reviewId: string,) => {


  

  return `/api/staff/${staffId}/reviews/${reviewId}`
}

export const deleteStaffReviewApiStaffStaffIdReviewsReviewIdDelete = async (staffId: string,
    reviewId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteStaffReviewApiStaffStaffIdReviewsReviewIdDeleteUrl(staffId,reviewId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Staff Meetings
 */
export const getListStaffMeetingsApiStaffMeetingsGetUrl = (params?: ListStaffMeetingsApiStaffMeetingsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff-meetings?${stringifiedParams}` : `/api/staff-meetings`
}

export const listStaffMeetingsApiStaffMeetingsGet = async (params?: ListStaffMeetingsApiStaffMeetingsGetParams, options?: RequestInit): Promise<StaffMeeting[]> => {
  
  return apiFetch<StaffMeeting[]>(getListStaffMeetingsApiStaffMeetingsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Staff Meeting
 */
export const getCreateStaffMeetingApiStaffMeetingsPostUrl = () => {


  

  return `/api/staff-meetings`
}

export const createStaffMeetingApiStaffMeetingsPost = async (staffMeetingCreate: StaffMeetingCreate, options?: RequestInit): Promise<StaffMeeting> => {
  
  return apiFetch<StaffMeeting>(getCreateStaffMeetingApiStaffMeetingsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffMeetingCreate,)
  }
);}



/**
 * OPS-30-04 - an activity saved on Multiple dates / a Date range: the
per-date occurrences just created are linked, so Edit and Delete can offer
This date only / This and later dates / All dates (OPS-30-07).
 * @summary Link Staff Meeting Series
 */
export const getLinkStaffMeetingSeriesApiStaffMeetingsSeriesPostUrl = () => {


  

  return `/api/staff-meetings/series`
}

export const linkStaffMeetingSeriesApiStaffMeetingsSeriesPost = async (meetingSeriesLink: MeetingSeriesLink, options?: RequestInit): Promise<MeetingSeriesResponse> => {
  
  return apiFetch<MeetingSeriesResponse>(getLinkStaffMeetingSeriesApiStaffMeetingsSeriesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      meetingSeriesLink,)
  }
);}



/**
 * OPS-30-07 - the dates the activity is on ('This activity is on n dates').
 * @summary Get Staff Meeting Series
 */
export const getGetStaffMeetingSeriesApiStaffMeetingsMeetingIdSeriesGetUrl = (meetingId: string,) => {


  

  return `/api/staff-meetings/${meetingId}/series`
}

export const getStaffMeetingSeriesApiStaffMeetingsMeetingIdSeriesGet = async (meetingId: string, options?: RequestInit): Promise<MeetingSeriesResponse> => {
  
  return apiFetch<MeetingSeriesResponse>(getGetStaffMeetingSeriesApiStaffMeetingsMeetingIdSeriesGetUrl(meetingId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Delete Staff Meeting
 */
export const getDeleteStaffMeetingApiStaffMeetingsMeetingIdDeleteUrl = (meetingId: string,) => {


  

  return `/api/staff-meetings/${meetingId}`
}

export const deleteStaffMeetingApiStaffMeetingsMeetingIdDelete = async (meetingId: string, options?: RequestInit): Promise<StaffMeetingDeleteResponse> => {
  
  return apiFetch<StaffMeetingDeleteResponse>(getDeleteStaffMeetingApiStaffMeetingsMeetingIdDeleteUrl(meetingId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Update Staff Meeting
 */
export const getUpdateStaffMeetingApiStaffMeetingsMeetingIdPatchUrl = (meetingId: string,) => {


  

  return `/api/staff-meetings/${meetingId}`
}

export const updateStaffMeetingApiStaffMeetingsMeetingIdPatch = async (meetingId: string,
    staffMeetingUpdate: StaffMeetingUpdate, options?: RequestInit): Promise<StaffMeeting> => {
  
  return apiFetch<StaffMeeting>(getUpdateStaffMeetingApiStaffMeetingsMeetingIdPatchUrl(meetingId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffMeetingUpdate,)
  }
);}



/**
 * The Meeting Minutes list as a file, same filters as the screen.

Declared before ``/staff-meetings/{meeting_id}/...`` so the literal path
wins over the parameterised ones.
 * @summary Export Staff Meetings
 */
export const getExportStaffMeetingsApiStaffMeetingsExportGetUrl = (params?: ExportStaffMeetingsApiStaffMeetingsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff-meetings/export?${stringifiedParams}` : `/api/staff-meetings/export`
}

export const exportStaffMeetingsApiStaffMeetingsExportGet = async (params?: ExportStaffMeetingsApiStaffMeetingsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportStaffMeetingsApiStaffMeetingsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Meeting Documents
 */
export const getListMeetingDocumentsApiStaffMeetingsMeetingIdDocumentsGetUrl = (meetingId: string,) => {


  

  return `/api/staff-meetings/${meetingId}/documents`
}

export const listMeetingDocumentsApiStaffMeetingsMeetingIdDocumentsGet = async (meetingId: string, options?: RequestInit): Promise<MeetingDocumentSummary[]> => {
  
  return apiFetch<MeetingDocumentSummary[]>(getListMeetingDocumentsApiStaffMeetingsMeetingIdDocumentsGetUrl(meetingId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Attach one minutes document. Any authenticated staff may upload — the
person who took the minutes is rarely the person who booked the meeting, and
a Head-Master-only gate would just push the file back into WhatsApp.

Note for deploys: nginx caps request bodies at 1 MB by default, so the host
needs `client_max_body_size` raised past the 10 MB limit enforced here or a
large scan 413s before FastAPI ever sees it.
 * @summary Upload Meeting Document
 */
export const getUploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPostUrl = (meetingId: string,) => {


  

  return `/api/staff-meetings/${meetingId}/documents`
}

export const uploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPost = async (meetingId: string,
    bodyUploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPost: BodyUploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPost, options?: RequestInit): Promise<MeetingDocumentSummary> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPost.file)

  return apiFetch<MeetingDocumentSummary>(getUploadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsPostUrl(meetingId),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary Download Meeting Document
 */
export const getDownloadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsDocumentIdGetUrl = (meetingId: string,
    documentId: string,) => {


  

  return `/api/staff-meetings/${meetingId}/documents/${documentId}`
}

export const downloadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsDocumentIdGet = async (meetingId: string,
    documentId: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getDownloadMeetingDocumentApiStaffMeetingsMeetingIdDocumentsDocumentIdGetUrl(meetingId,documentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Delete Meeting Document
 */
export const getDeleteMeetingDocumentApiStaffMeetingsMeetingIdDocumentsDocumentIdDeleteUrl = (meetingId: string,
    documentId: string,) => {


  

  return `/api/staff-meetings/${meetingId}/documents/${documentId}`
}

export const deleteMeetingDocumentApiStaffMeetingsMeetingIdDocumentsDocumentIdDelete = async (meetingId: string,
    documentId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteMeetingDocumentApiStaffMeetingsMeetingIdDocumentsDocumentIdDeleteUrl(meetingId,documentId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Rooms
 */
export const getListRoomsApiRoomsGetUrl = (params?: ListRoomsApiRoomsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/rooms?${stringifiedParams}` : `/api/rooms`
}

export const listRoomsApiRoomsGet = async (params?: ListRoomsApiRoomsGetParams, options?: RequestInit): Promise<RoomSummary[]> => {
  
  return apiFetch<RoomSummary[]>(getListRoomsApiRoomsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Room Availability
 */
export const getGetRoomAvailabilityApiRoomsAvailabilityGetUrl = (params: GetRoomAvailabilityApiRoomsAvailabilityGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/rooms/availability?${stringifiedParams}` : `/api/rooms/availability`
}

export const getRoomAvailabilityApiRoomsAvailabilityGet = async (params: GetRoomAvailabilityApiRoomsAvailabilityGetParams, options?: RequestInit): Promise<RoomSummary[]> => {
  
  return apiFetch<RoomSummary[]>(getGetRoomAvailabilityApiRoomsAvailabilityGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Room Status
 */
export const getGetRoomStatusApiRoomsStatusGetUrl = (params?: GetRoomStatusApiRoomsStatusGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/rooms/status?${stringifiedParams}` : `/api/rooms/status`
}

export const getRoomStatusApiRoomsStatusGet = async (params?: GetRoomStatusApiRoomsStatusGetParams, options?: RequestInit): Promise<RoomStatusItem[]> => {
  
  return apiFetch<RoomStatusItem[]>(getGetRoomStatusApiRoomsStatusGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Room History
 */
export const getGetRoomHistoryApiRoomsRoomIdHistoryGetUrl = (roomId: string,
    params?: GetRoomHistoryApiRoomsRoomIdHistoryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/rooms/${roomId}/history?${stringifiedParams}` : `/api/rooms/${roomId}/history`
}

export const getRoomHistoryApiRoomsRoomIdHistoryGet = async (roomId: string,
    params?: GetRoomHistoryApiRoomsRoomIdHistoryGetParams, options?: RequestInit): Promise<RoomHistoryResponse> => {
  
  return apiFetch<RoomHistoryResponse>(getGetRoomHistoryApiRoomsRoomIdHistoryGetUrl(roomId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Every outlet for HQ / admin. Outlet staff do not see a closed outlet —
one with no active staff (HarbourFront, Angela 21 Oct 2026); its records
stay and HQ still see it. HQ itself is always listed.
 * @summary List Outlets
 */
export const getListOutletsApiOutletsGetUrl = () => {


  

  return `/api/outlets`
}

export const listOutletsApiOutletsGet = async ( options?: RequestInit): Promise<OutletOut[]> => {
  
  return apiFetch<OutletOut[]>(getListOutletsApiOutletsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Outlet
 */
export const getUpdateOutletApiOutletsPatchUrl = () => {


  

  return `/api/outlets`
}

export const updateOutletApiOutletsPatch = async (outletUpdate: OutletUpdate, options?: RequestInit): Promise<OutletOut> => {
  
  return apiFetch<OutletOut>(getUpdateOutletApiOutletsPatchUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletUpdate,)
  }
);}



/**
 * Every special-hours entry of one outlet, newest first. Past dates stay.
 * @summary List Outlet Special Hours
 */
export const getListOutletSpecialHoursApiOutletsOutletIdSpecialHoursGetUrl = (outletId: string,) => {


  

  return `/api/outlets/${outletId}/special-hours`
}

export const listOutletSpecialHoursApiOutletsOutletIdSpecialHoursGet = async (outletId: string, options?: RequestInit): Promise<OutletSpecialHoursOut[]> => {
  
  return apiFetch<OutletSpecialHoursOut[]>(getListOutletSpecialHoursApiOutletsOutletIdSpecialHoursGetUrl(outletId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Outlet Special Hours
 */
export const getCreateOutletSpecialHoursApiOutletsOutletIdSpecialHoursPostUrl = (outletId: string,) => {


  

  return `/api/outlets/${outletId}/special-hours`
}

export const createOutletSpecialHoursApiOutletsOutletIdSpecialHoursPost = async (outletId: string,
    outletSpecialHoursIn: OutletSpecialHoursIn, options?: RequestInit): Promise<OutletSpecialHoursSaved> => {
  
  return apiFetch<OutletSpecialHoursSaved>(getCreateOutletSpecialHoursApiOutletsOutletIdSpecialHoursPostUrl(outletId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletSpecialHoursIn,)
  }
);}



/**
 * @summary Update Outlet Special Hours
 */
export const getUpdateOutletSpecialHoursApiOutletsOutletIdSpecialHoursSpecialIdPatchUrl = (outletId: string,
    specialId: string,) => {


  

  return `/api/outlets/${outletId}/special-hours/${specialId}`
}

export const updateOutletSpecialHoursApiOutletsOutletIdSpecialHoursSpecialIdPatch = async (outletId: string,
    specialId: string,
    outletSpecialHoursIn: OutletSpecialHoursIn, options?: RequestInit): Promise<OutletSpecialHoursSaved> => {
  
  return apiFetch<OutletSpecialHoursSaved>(getUpdateOutletSpecialHoursApiOutletsOutletIdSpecialHoursSpecialIdPatchUrl(outletId,specialId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletSpecialHoursIn,)
  }
);}



/**
 * @summary Delete Outlet Special Hours
 */
export const getDeleteOutletSpecialHoursApiOutletsOutletIdSpecialHoursSpecialIdDeleteUrl = (outletId: string,
    specialId: string,) => {


  

  return `/api/outlets/${outletId}/special-hours/${specialId}`
}

export const deleteOutletSpecialHoursApiOutletsOutletIdSpecialHoursSpecialIdDelete = async (outletId: string,
    specialId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteOutletSpecialHoursApiOutletsOutletIdSpecialHoursSpecialIdDeleteUrl(outletId,specialId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * The hours that apply on each date from..to (max 62 days): the weekly
pattern with special entries applied. The calendars read this.
 * @summary Outlet Hours For Dates
 */
export const getOutletHoursForDatesApiOutletsOutletIdHoursGetUrl = (outletId: string,
    params: OutletHoursForDatesApiOutletsOutletIdHoursGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/outlets/${outletId}/hours?${stringifiedParams}` : `/api/outlets/${outletId}/hours`
}

export const outletHoursForDatesApiOutletsOutletIdHoursGet = async (outletId: string,
    params: OutletHoursForDatesApiOutletsOutletIdHoursGetParams, options?: RequestInit): Promise<OutletDayEffective[]> => {
  
  return apiFetch<OutletDayEffective[]>(getOutletHoursForDatesApiOutletsOutletIdHoursGetUrl(outletId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Idempotent seed for the 31 built-in ShiftType presets (§2.1).
 * @summary Seed Shift Types
 */
export const getSeedShiftTypesApiShiftTypesSeedPostUrl = () => {


  

  return `/api/shift-types/seed`
}

export const seedShiftTypesApiShiftTypesSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedShiftTypesApiShiftTypesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * OPS-36-05 — what was added, changed, deleted or restored on Shift Types,
newest first (500 lines at most). Admin only, like the edits themselves.
 * @summary Shift Type History
 */
export const getShiftTypeHistoryApiShiftTypesHistoryGetUrl = () => {


  

  return `/api/shift-types/history`
}

export const shiftTypeHistoryApiShiftTypesHistoryGet = async ( options?: RequestInit): Promise<ShiftTypeHistoryResponse> => {
  
  return apiFetch<ShiftTypeHistoryResponse>(getShiftTypeHistoryApiShiftTypesHistoryGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-36-07: rename a band; its shift types move to the new name.
 * @summary Rename Shift Band
 */
export const getRenameShiftBandApiShiftTypesBandsRenamePostUrl = () => {


  

  return `/api/shift-types/bands/rename`
}

export const renameShiftBandApiShiftTypesBandsRenamePost = async (bandRenameRequest: BandRenameRequest, options?: RequestInit): Promise<BandChangeResponse> => {
  
  return apiFetch<BandChangeResponse>(getRenameShiftBandApiShiftTypesBandsRenamePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bandRenameRequest,)
  }
);}



/**
 * OPS-36-07: remove a band; its shift types are kept and move to Other.
 * @summary Remove Shift Band
 */
export const getRemoveShiftBandApiShiftTypesBandsRemovePostUrl = () => {


  

  return `/api/shift-types/bands/remove`
}

export const removeShiftBandApiShiftTypesBandsRemovePost = async (bandRemoveRequest: BandRemoveRequest, options?: RequestInit): Promise<BandChangeResponse> => {
  
  return apiFetch<BandChangeResponse>(getRemoveShiftBandApiShiftTypesBandsRemovePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bandRemoveRequest,)
  }
);}



/**
 * Return active shift-type presets ordered by sortOrder.
 * @summary List Shift Types
 */
export const getListShiftTypesApiShiftTypesGetUrl = (params?: ListShiftTypesApiShiftTypesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/shift-types?${stringifiedParams}` : `/api/shift-types`
}

export const listShiftTypesApiShiftTypesGet = async (params?: ListShiftTypesApiShiftTypesGetParams, options?: RequestInit): Promise<ShiftTypeResponse[]> => {
  
  return apiFetch<ShiftTypeResponse[]>(getListShiftTypesApiShiftTypesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Shift Type
 */
export const getCreateShiftTypeApiShiftTypesPostUrl = () => {


  

  return `/api/shift-types`
}

export const createShiftTypeApiShiftTypesPost = async (shiftTypeCreateRequest: ShiftTypeCreateRequest, options?: RequestInit): Promise<ShiftTypeResponse> => {
  
  return apiFetch<ShiftTypeResponse>(getCreateShiftTypeApiShiftTypesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      shiftTypeCreateRequest,)
  }
);}



/**
 * @summary Update Shift Type
 */
export const getUpdateShiftTypeApiShiftTypesShiftTypeIdPutUrl = (shiftTypeId: string,) => {


  

  return `/api/shift-types/${shiftTypeId}`
}

export const updateShiftTypeApiShiftTypesShiftTypeIdPut = async (shiftTypeId: string,
    shiftTypeUpdateRequest: ShiftTypeUpdateRequest, options?: RequestInit): Promise<ShiftTypeResponse> => {
  
  return apiFetch<ShiftTypeResponse>(getUpdateShiftTypeApiShiftTypesShiftTypeIdPutUrl(shiftTypeId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      shiftTypeUpdateRequest,)
  }
);}



/**
 * @summary Delete Shift Type
 */
export const getDeleteShiftTypeApiShiftTypesShiftTypeIdDeleteUrl = (shiftTypeId: string,) => {


  

  return `/api/shift-types/${shiftTypeId}`
}

export const deleteShiftTypeApiShiftTypesShiftTypeIdDelete = async (shiftTypeId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteShiftTypeApiShiftTypesShiftTypeIdDeleteUrl(shiftTypeId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Get Rates
 */
export const getGetRatesApiCommissionRatesGetUrl = () => {


  

  return `/api/commission/rates`
}

export const getRatesApiCommissionRatesGet = async ( options?: RequestInit): Promise<CommissionRateResponse[]> => {
  
  return apiFetch<CommissionRateResponse[]>(getGetRatesApiCommissionRatesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Per-staff commission overview + totals for the commission page table.
``month`` (YYYY-MM) limits it to that month; omitted = all time.

A6 self-scope enforcement (Spec A §6.2 / ADR §5). Commission earnings is one
of the salary reads ``finance.view_own_salary`` grants self-access to:

* Full company-wide view — ``finance.view_all`` = FULL, or ``commission.view``
  = FULL (the legacy commission-full users: ADMIN / CONSULTANT / RECEPTIONIST,
  and any role granting either). Behavior unchanged.
* Self-only view — ``finance.view_own_salary`` = FULL (the Beautician
  self-salary capability) **or** ``commission.view`` = OWN (legacy THERAPIST
  'own'): only the caller's own staff rows. A user with no linked Staff sees
  an empty set, not everyone's (§10) — never a 403.
* Otherwise 403.
 * @summary Get Earnings
 */
export const getGetEarningsApiCommissionEarningsGetUrl = (params?: GetEarningsApiCommissionEarningsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/commission/earnings?${stringifiedParams}` : `/api/commission/earnings`
}

export const getEarningsApiCommissionEarningsGet = async (params?: GetEarningsApiCommissionEarningsGetParams, options?: RequestInit): Promise<EarningsByStaffResponse> => {
  
  return apiFetch<EarningsByStaffResponse>(getGetEarningsApiCommissionEarningsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Status
 */
export const getGetStatusApiCommissionStatusGetUrl = () => {


  

  return `/api/commission/status`
}

export const getStatusApiCommissionStatusGet = async ( options?: RequestInit): Promise<CommissionStatusResponse> => {
  
  return apiFetch<CommissionStatusResponse>(getGetStatusApiCommissionStatusGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Commission Status
 */
export const getUpdateCommissionStatusApiCommissionStatusPutUrl = () => {


  

  return `/api/commission/status`
}

export const updateCommissionStatusApiCommissionStatusPut = async (commissionStatusUpdateRequest: CommissionStatusUpdateRequest, options?: RequestInit): Promise<CommissionStatusUpdateResponse> => {
  
  return apiFetch<CommissionStatusUpdateResponse>(getUpdateCommissionStatusApiCommissionStatusPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commissionStatusUpdateRequest,)
  }
);}



/**
 * One staff member's commission. ``month`` (YYYY-MM) limits the earnings
to that month, as on the page table; omitted = the 20 most recent.
 * @summary Get Staff Summary
 */
export const getGetStaffSummaryApiCommissionStaffStaffIdGetUrl = (staffId: string,
    params?: GetStaffSummaryApiCommissionStaffStaffIdGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/commission/staff/${staffId}?${stringifiedParams}` : `/api/commission/staff/${staffId}`
}

export const getStaffSummaryApiCommissionStaffStaffIdGet = async (staffId: string,
    params?: GetStaffSummaryApiCommissionStaffStaffIdGetParams, options?: RequestInit): Promise<StaffCommissionSummaryResponse> => {
  
  return apiFetch<StaffCommissionSummaryResponse>(getGetStaffSummaryApiCommissionStaffStaffIdGetUrl(staffId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-24-02 — every staff member's commission for the month and its status.
 * @summary List Breakdown
 */
export const getListBreakdownApiCommissionBreakdownGetUrl = (params: ListBreakdownApiCommissionBreakdownGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/commission/breakdown?${stringifiedParams}` : `/api/commission/breakdown`
}

export const listBreakdownApiCommissionBreakdownGet = async (params: ListBreakdownApiCommissionBreakdownGetParams, options?: RequestInit): Promise<BreakdownListResponse> => {
  
  return apiFetch<BreakdownListResponse>(getListBreakdownApiCommissionBreakdownGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-24-03 — Confirm (staffIds) or Confirm all (staffIds omitted).
 * @summary Confirm Breakdown
 */
export const getConfirmBreakdownApiCommissionBreakdownConfirmPostUrl = () => {


  

  return `/api/commission/breakdown/confirm`
}

export const confirmBreakdownApiCommissionBreakdownConfirmPost = async (breakdownConfirmRequest: BreakdownConfirmRequest, options?: RequestInit): Promise<BreakdownListResponse> => {
  
  return apiFetch<BreakdownListResponse>(getConfirmBreakdownApiCommissionBreakdownConfirmPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownConfirmRequest,)
  }
);}



/**
 * @summary Reopen Breakdown
 */
export const getReopenBreakdownApiCommissionBreakdownReopenPostUrl = () => {


  

  return `/api/commission/breakdown/reopen`
}

export const reopenBreakdownApiCommissionBreakdownReopenPost = async (breakdownReopenRequest: BreakdownReopenRequest, options?: RequestInit): Promise<BreakdownListResponse> => {
  
  return apiFetch<BreakdownListResponse>(getReopenBreakdownApiCommissionBreakdownReopenPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownReopenRequest,)
  }
);}



/**
 * HR-24-04 — what 'Send all' would send. Nothing changes.
 * @summary Preview Breakdown
 */
export const getPreviewBreakdownApiCommissionBreakdownPreviewPostUrl = () => {


  

  return `/api/commission/breakdown/preview`
}

export const previewBreakdownApiCommissionBreakdownPreviewPost = async (breakdownMonthRequest: BreakdownMonthRequest, options?: RequestInit): Promise<BreakdownPreviewResponse> => {
  
  return apiFetch<BreakdownPreviewResponse>(getPreviewBreakdownApiCommissionBreakdownPreviewPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownMonthRequest,)
  }
);}



/**
 * HR-24-04/07 — record every Confirmed breakdown as sent (no mail provider
is connected yet: staff read and answer it in My Pay).
 * @summary Send Breakdown
 */
export const getSendBreakdownApiCommissionBreakdownSendPostUrl = () => {


  

  return `/api/commission/breakdown/send`
}

export const sendBreakdownApiCommissionBreakdownSendPost = async (breakdownMonthRequest: BreakdownMonthRequest, options?: RequestInit): Promise<BreakdownSendResponse> => {
  
  return apiFetch<BreakdownSendResponse>(getSendBreakdownApiCommissionBreakdownSendPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownMonthRequest,)
  }
);}



/**
 * HR-24-10 — Send from, the month's reply-by date, Subject and Message.
 * @summary Update Breakdown Settings
 */
export const getUpdateBreakdownSettingsApiCommissionBreakdownSettingsPutUrl = () => {


  

  return `/api/commission/breakdown/settings`
}

export const updateBreakdownSettingsApiCommissionBreakdownSettingsPut = async (breakdownSettingsUpdate: BreakdownSettingsUpdate, options?: RequestInit): Promise<BreakdownSettings> => {
  
  return apiFetch<BreakdownSettings>(getUpdateBreakdownSettingsApiCommissionBreakdownSettingsPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownSettingsUpdate,)
  }
);}



/**
 * HR-24-08 — the signed-in staff member's sent breakdowns, newest first.
 * @summary My Breakdowns
 */
export const getMyBreakdownsApiCommissionBreakdownMeGetUrl = () => {


  

  return `/api/commission/breakdown/me`
}

export const myBreakdownsApiCommissionBreakdownMeGet = async ( options?: RequestInit): Promise<MyBreakdownListResponse> => {
  
  return apiFetch<MyBreakdownListResponse>(getMyBreakdownsApiCommissionBreakdownMeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-24-08 — Accept, or 'I have a question' with the question.
 * @summary Reply Breakdown
 */
export const getReplyBreakdownApiCommissionBreakdownMeStatementIdReplyPostUrl = (statementId: string,) => {


  

  return `/api/commission/breakdown/me/${statementId}/reply`
}

export const replyBreakdownApiCommissionBreakdownMeStatementIdReplyPost = async (statementId: string,
    breakdownReplyRequest: BreakdownReplyRequest, options?: RequestInit): Promise<MyBreakdownRow> => {
  
  return apiFetch<MyBreakdownRow>(getReplyBreakdownApiCommissionBreakdownMeStatementIdReplyPostUrl(statementId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownReplyRequest,)
  }
);}



/**
 * The sent breakdowns of the staff of the caller's own outlet(s).
 * @summary Outlet Breakdowns
 */
export const getOutletBreakdownsApiCommissionBreakdownOutletGetUrl = () => {


  

  return `/api/commission/breakdown/outlet`
}

export const outletBreakdownsApiCommissionBreakdownOutletGet = async ( options?: RequestInit): Promise<OutletBreakdownListResponse> => {
  
  return apiFetch<OutletBreakdownListResponse>(getOutletBreakdownsApiCommissionBreakdownOutletGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Accept, or 'I have a question', for a staff member of the caller's outlet.
 * @summary Reply Breakdown For Staff
 */
export const getReplyBreakdownForStaffApiCommissionBreakdownOutletStatementIdReplyPostUrl = (statementId: string,) => {


  

  return `/api/commission/breakdown/outlet/${statementId}/reply`
}

export const replyBreakdownForStaffApiCommissionBreakdownOutletStatementIdReplyPost = async (statementId: string,
    breakdownReplyRequest: BreakdownReplyRequest, options?: RequestInit): Promise<OutletBreakdownRow> => {
  
  return apiFetch<OutletBreakdownRow>(getReplyBreakdownForStaffApiCommissionBreakdownOutletStatementIdReplyPostUrl(statementId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      breakdownReplyRequest,)
  }
);}



/**
 * Admin export of the customer book (Studio-Manager parity), Excel by default
and CSV on ``?format=csv``. Optionally filtered by preferred outlet. Declared
before ``/{customer_id}`` so the literal path wins.

The window filters ``createdAt`` - "customers added in this period", which is a
different question from the customer book as a whole, so it stays optional and
unset by default. No window params means every customer, as before.

``packages`` and ``totalSpend`` are correlated subqueries rather than joins so
the customer rows are not multiplied, and they use the same rules as
``FinanceService.ltv_capture`` - package COUNT, and COMPLETED sales netted
down by REFUNDED ones. The two must not drift: an admin comparing this export
against a customer's LTV panel has to see the same number.
 * @summary Export Customers
 */
export const getExportCustomersApiCustomersExportGetUrl = (params?: ExportCustomersApiCustomersExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/export?${stringifiedParams}` : `/api/customers/export`
}

export const exportCustomersApiCustomersExportGet = async (params?: ExportCustomersApiCustomersExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportCustomersApiCustomersExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Customers
 */
export const getListCustomersApiCustomersGetUrl = (params?: ListCustomersApiCustomersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers?${stringifiedParams}` : `/api/customers`
}

export const listCustomersApiCustomersGet = async (params?: ListCustomersApiCustomersGetParams, options?: RequestInit): Promise<CustomerListResponse> => {
  
  return apiFetch<CustomerListResponse>(getListCustomersApiCustomersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Customer
 */
export const getCreateCustomerApiCustomersPostUrl = () => {


  

  return `/api/customers`
}

export const createCustomerApiCustomersPost = async (customerCreate: CustomerCreate, options?: RequestInit): Promise<CustomerMutationResponse> => {
  
  return apiFetch<CustomerMutationResponse>(getCreateCustomerApiCustomersPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerCreate,)
  }
);}



/**
 * Row counts the merge would move, for the confirmation screen.

Read-only. Exists because no other endpoint can answer the question
honestly — customer detail caps appointments at 20 and carries no sales — and
a confirmation for an operation with no undo must not show a made-up number.
 * @summary Preview Merge
 */
export const getPreviewMergeApiCustomersMergePreviewGetUrl = (params: PreviewMergeApiCustomersMergePreviewGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers/merge/preview?${stringifiedParams}` : `/api/customers/merge/preview`
}

export const previewMergeApiCustomersMergePreviewGet = async (params: PreviewMergeApiCustomersMergePreviewGetParams, options?: RequestInit): Promise<CustomerMergeCounts> => {
  
  return apiFetch<CustomerMergeCounts>(getPreviewMergeApiCustomersMergePreviewGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Fold a duplicate customer into a surviving one (admin only).

Declared before the ``/{customer_id}`` routes so the literal path wins, the
same reason ``/export`` sits at the top of this module.

The rollback is explicit rather than left to session teardown: the service
emits bulk DML across a dozen tables, and a half-applied merge is the one
failure mode there is no undo for.
 * @summary Merge Customers
 */
export const getMergeCustomersApiCustomersMergePostUrl = () => {


  

  return `/api/customers/merge`
}

export const mergeCustomersApiCustomersMergePost = async (customerMergeRequest: CustomerMergeRequest, options?: RequestInit): Promise<CustomerMergeResponse> => {
  
  return apiFetch<CustomerMergeResponse>(getMergeCustomersApiCustomersMergePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerMergeRequest,)
  }
);}



/**
 * @summary Get Customer
 */
export const getGetCustomerApiCustomersCustomerIdGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}`
}

export const getCustomerApiCustomersCustomerIdGet = async (customerId: string, options?: RequestInit): Promise<CustomerDetailResponse> => {
  
  return apiFetch<CustomerDetailResponse>(getGetCustomerApiCustomersCustomerIdGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Customer
 */
export const getUpdateCustomerApiCustomersCustomerIdPutUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}`
}

export const updateCustomerApiCustomersCustomerIdPut = async (customerId: string,
    customerUpdate: CustomerUpdate, options?: RequestInit): Promise<CustomerMutationResponse> => {
  
  return apiFetch<CustomerMutationResponse>(getUpdateCustomerApiCustomersCustomerIdPutUrl(customerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerUpdate,)
  }
);}



/**
 * CUS-08-10 — change the Registered Outlet (an outlet, or HQ). Anyone who
can open the customer may; who and when are kept in its change log.
 * @summary Update Registered Outlet
 */
export const getUpdateRegisteredOutletApiCustomersCustomerIdRegisteredOutletPutUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/registered-outlet`
}

export const updateRegisteredOutletApiCustomersCustomerIdRegisteredOutletPut = async (customerId: string,
    registeredOutletUpdate: RegisteredOutletUpdate, options?: RequestInit): Promise<CustomerOutletInfoResponse> => {
  
  return apiFetch<CustomerOutletInfoResponse>(getUpdateRegisteredOutletApiCustomersCustomerIdRegisteredOutletPutUrl(customerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registeredOutletUpdate,)
  }
);}



/**
 * Preferred Outlet change log and the 'also has sessions at' hint (CUS-06).
 * @summary Get Outlet Info
 */
export const getGetOutletInfoApiCustomersCustomerIdOutletInfoGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/outlet-info`
}

export const getOutletInfoApiCustomersCustomerIdOutletInfoGet = async (customerId: string, options?: RequestInit): Promise<CustomerOutletInfoResponse> => {
  
  return apiFetch<CustomerOutletInfoResponse>(getGetOutletInfoApiCustomersCustomerIdOutletInfoGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Survey
 */
export const getGetSurveyApiCustomersCustomerIdSurveyGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/survey`
}

export const getSurveyApiCustomersCustomerIdSurveyGet = async (customerId: string, options?: RequestInit): Promise<CustomerSurveyResponse> => {
  
  return apiFetch<CustomerSurveyResponse>(getGetSurveyApiCustomersCustomerIdSurveyGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Survey
 */
export const getUpsertSurveyApiCustomersCustomerIdSurveyPutUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/survey`
}

export const upsertSurveyApiCustomersCustomerIdSurveyPut = async (customerId: string,
    customerSurveyUpsert: CustomerSurveyUpsert, options?: RequestInit): Promise<CustomerSurveyResponse> => {
  
  return apiFetch<CustomerSurveyResponse>(getUpsertSurveyApiCustomersCustomerIdSurveyPutUrl(customerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerSurveyUpsert,)
  }
);}



/**
 * CUS-12-12 — the survey's edit history, newest first.
 * @summary Survey History
 */
export const getSurveyHistoryApiCustomersCustomerIdSurveyHistoryGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/survey/history`
}

export const surveyHistoryApiCustomersCustomerIdSurveyHistoryGet = async (customerId: string, options?: RequestInit): Promise<SurveyHistoryResponse> => {
  
  return apiFetch<SurveyHistoryResponse>(getSurveyHistoryApiCustomersCustomerIdSurveyHistoryGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Preferences
 */
export const getUpdatePreferencesApiCustomersCustomerIdPreferencesPutUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/preferences`
}

export const updatePreferencesApiCustomersCustomerIdPreferencesPut = async (customerId: string,
    customerPreferencesUpdate: CustomerPreferencesUpdate, options?: RequestInit): Promise<CustomerPreferencesResponse> => {
  
  return apiFetch<CustomerPreferencesResponse>(getUpdatePreferencesApiCustomersCustomerIdPreferencesPutUrl(customerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerPreferencesUpdate,)
  }
);}



/**
 * R5 N-09 — the "drawn by" dropdown: masters, consultants and the office
accounts. Declared before ``/{customer_id}/...`` so the literal path wins.
 * @summary List Face Chart Authors
 */
export const getListFaceChartAuthorsApiCustomersFaceChartAuthorsGetUrl = () => {


  

  return `/api/customers/face-chart/authors`
}

export const listFaceChartAuthorsApiCustomersFaceChartAuthorsGet = async ( options?: RequestInit): Promise<FaceChartAuthorOption[]> => {
  
  return apiFetch<FaceChartAuthorOption[]>(getListFaceChartAuthorsApiCustomersFaceChartAuthorsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Face Chart
 */
export const getListFaceChartApiCustomersCustomerIdFaceChartGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/face-chart`
}

export const listFaceChartApiCustomersCustomerIdFaceChartGet = async (customerId: string, options?: RequestInit): Promise<FaceChartDrawingResponse[]> => {
  
  return apiFetch<FaceChartDrawingResponse[]>(getListFaceChartApiCustomersCustomerIdFaceChartGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Face Chart
 */
export const getCreateFaceChartApiCustomersCustomerIdFaceChartPostUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/face-chart`
}

export const createFaceChartApiCustomersCustomerIdFaceChartPost = async (customerId: string,
    faceChartCreate: FaceChartCreate, options?: RequestInit): Promise<FaceChartDrawingResponse> => {
  
  return apiFetch<FaceChartDrawingResponse>(getCreateFaceChartApiCustomersCustomerIdFaceChartPostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      faceChartCreate,)
  }
);}



/**
 * @summary List Photos
 */
export const getListPhotosApiCustomersCustomerIdPhotosGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/photos`
}

export const listPhotosApiCustomersCustomerIdPhotosGet = async (customerId: string, options?: RequestInit): Promise<CustomerPhotoResponse[]> => {
  
  return apiFetch<CustomerPhotoResponse[]>(getListPhotosApiCustomersCustomerIdPhotosGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Photo
 */
export const getCreatePhotoApiCustomersCustomerIdPhotosPostUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/photos`
}

export const createPhotoApiCustomersCustomerIdPhotosPost = async (customerId: string,
    customerPhotoCreate: CustomerPhotoCreate, options?: RequestInit): Promise<CustomerPhotoResponse> => {
  
  return apiFetch<CustomerPhotoResponse>(getCreatePhotoApiCustomersCustomerIdPhotosPostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerPhotoCreate,)
  }
);}



/**
 * @summary Delete Photo
 */
export const getDeletePhotoApiCustomersCustomerIdPhotosPhotoIdDeleteUrl = (customerId: string,
    photoId: string,) => {


  

  return `/api/customers/${customerId}/photos/${photoId}`
}

export const deletePhotoApiCustomersCustomerIdPhotosPhotoIdDelete = async (customerId: string,
    photoId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeletePhotoApiCustomersCustomerIdPhotosPhotoIdDeleteUrl(customerId,photoId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Get Consent
 */
export const getGetConsentApiCustomersCustomerIdConsentGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/consent`
}

export const getConsentApiCustomersCustomerIdConsentGet = async (customerId: string, options?: RequestInit): Promise<CustomerConsentResponse> => {
  
  return apiFetch<CustomerConsentResponse>(getGetConsentApiCustomersCustomerIdConsentGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Consent
 */
export const getUpsertConsentApiCustomersCustomerIdConsentPutUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/consent`
}

export const upsertConsentApiCustomersCustomerIdConsentPut = async (customerId: string,
    customerConsentUpsert: CustomerConsentUpsert, options?: RequestInit): Promise<CustomerConsentResponse> => {
  
  return apiFetch<CustomerConsentResponse>(getUpsertConsentApiCustomersCustomerIdConsentPutUrl(customerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerConsentUpsert,)
  }
);}



/**
 * @summary Get Reminders
 */
export const getGetRemindersApiCustomersCustomerIdRemindersGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/reminders`
}

export const getRemindersApiCustomersCustomerIdRemindersGet = async (customerId: string, options?: RequestInit): Promise<CustomerRemindersResponse> => {
  
  return apiFetch<CustomerRemindersResponse>(getGetRemindersApiCustomersCustomerIdRemindersGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * What the customer still owes, for the red chip and card on her page.

Reads the Balance Payment rule and the IHIP plans; stores nothing. Open to
everyone who can open Customers (CUS-07-01: it is information for whoever
is with her).
 * @summary Get Balance Mark
 */
export const getGetBalanceMarkApiCustomersCustomerIdBalanceMarkGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/balance-mark`
}

export const getBalanceMarkApiCustomersCustomerIdBalanceMarkGet = async (customerId: string, options?: RequestInit): Promise<CustomerBalanceMarkResponse> => {
  
  return apiFetch<CustomerBalanceMarkResponse>(getGetBalanceMarkApiCustomersCustomerIdBalanceMarkGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Preferred therapist, special request, caution notes and allergies for the
banner shown at booking, in the customer drawer and before treatment start.
Any signed-in user: the therapist starting the treatment has no customers
feature but is the person the banner is for.
 * @summary Get Special Requests
 */
export const getGetSpecialRequestsApiCustomersCustomerIdSpecialRequestsGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/special-requests`
}

export const getSpecialRequestsApiCustomersCustomerIdSpecialRequestsGet = async (customerId: string, options?: RequestInit): Promise<CustomerSpecialRequestsResponse> => {
  
  return apiFetch<CustomerSpecialRequestsResponse>(getGetSpecialRequestsApiCustomersCustomerIdSpecialRequestsGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Groups
 */
export const getListGroupsApiCustomerGroupsGetUrl = (params?: ListGroupsApiCustomerGroupsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-groups?${stringifiedParams}` : `/api/customer-groups`
}

export const listGroupsApiCustomerGroupsGet = async (params?: ListGroupsApiCustomerGroupsGetParams, options?: RequestInit): Promise<CustomerGroupListResponse> => {
  
  return apiFetch<CustomerGroupListResponse>(getListGroupsApiCustomerGroupsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Group
 */
export const getCreateGroupApiCustomerGroupsPostUrl = () => {


  

  return `/api/customer-groups`
}

export const createGroupApiCustomerGroupsPost = async (customerGroupCreate: CustomerGroupCreate, options?: RequestInit): Promise<CustomerGroupRecheckResult> => {
  
  return apiFetch<CustomerGroupRecheckResult>(getCreateGroupApiCustomerGroupsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerGroupCreate,)
  }
);}



/**
 * @summary Update Group
 */
export const getUpdateGroupApiCustomerGroupsGroupIdPutUrl = (groupId: string,) => {


  

  return `/api/customer-groups/${groupId}`
}

export const updateGroupApiCustomerGroupsGroupIdPut = async (groupId: string,
    customerGroupUpdate: CustomerGroupUpdate, options?: RequestInit): Promise<CustomerGroupRecheckResult> => {
  
  return apiFetch<CustomerGroupRecheckResult>(getUpdateGroupApiCustomerGroupsGroupIdPutUrl(groupId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerGroupUpdate,)
  }
);}



/**
 * @summary Delete Group
 */
export const getDeleteGroupApiCustomerGroupsGroupIdDeleteUrl = (groupId: string,) => {


  

  return `/api/customer-groups/${groupId}`
}

export const deleteGroupApiCustomerGroupsGroupIdDelete = async (groupId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteGroupApiCustomerGroupsGroupIdDeleteUrl(groupId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Set Group Status
 */
export const getSetGroupStatusApiCustomerGroupsGroupIdStatusPostUrl = (groupId: string,) => {


  

  return `/api/customer-groups/${groupId}/status`
}

export const setGroupStatusApiCustomerGroupsGroupIdStatusPost = async (groupId: string,
    customerGroupStatusUpdate: CustomerGroupStatusUpdate, options?: RequestInit): Promise<CustomerGroupRecheckResult> => {
  
  return apiFetch<CustomerGroupRecheckResult>(getSetGroupStatusApiCustomerGroupsGroupIdStatusPostUrl(groupId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerGroupStatusUpdate,)
  }
);}



/**
 * Re-check every customer against this group now.
 * @summary Recheck Group
 */
export const getRecheckGroupApiCustomerGroupsGroupIdRecheckPostUrl = (groupId: string,) => {


  

  return `/api/customer-groups/${groupId}/recheck`
}

export const recheckGroupApiCustomerGroupsGroupIdRecheckPost = async (groupId: string, options?: RequestInit): Promise<CustomerGroupRecheckResult> => {
  
  return apiFetch<CustomerGroupRecheckResult>(getRecheckGroupApiCustomerGroupsGroupIdRecheckPostUrl(groupId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Group History
 */
export const getGroupHistoryApiCustomerGroupsGroupIdHistoryGetUrl = (groupId: string,) => {


  

  return `/api/customer-groups/${groupId}/history`
}

export const groupHistoryApiCustomerGroupsGroupIdHistoryGet = async (groupId: string, options?: RequestInit): Promise<CustomerGroupEventOut[]> => {
  
  return apiFetch<CustomerGroupEventOut[]>(getGroupHistoryApiCustomerGroupsGroupIdHistoryGetUrl(groupId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Add Member
 */
export const getAddMemberApiCustomerGroupsGroupIdMembersPostUrl = (groupId: string,) => {


  

  return `/api/customer-groups/${groupId}/members`
}

export const addMemberApiCustomerGroupsGroupIdMembersPost = async (groupId: string,
    customerGroupMemberRequest: CustomerGroupMemberRequest, options?: RequestInit): Promise<CustomerGroupsResponse> => {
  
  return apiFetch<CustomerGroupsResponse>(getAddMemberApiCustomerGroupsGroupIdMembersPostUrl(groupId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerGroupMemberRequest,)
  }
);}



/**
 * @summary Remove Member
 */
export const getRemoveMemberApiCustomerGroupsGroupIdMembersCustomerIdDeleteUrl = (groupId: string,
    customerId: string,) => {


  

  return `/api/customer-groups/${groupId}/members/${customerId}`
}

export const removeMemberApiCustomerGroupsGroupIdMembersCustomerIdDelete = async (groupId: string,
    customerId: string, options?: RequestInit): Promise<CustomerGroupsResponse> => {
  
  return apiFetch<CustomerGroupsResponse>(getRemoveMemberApiCustomerGroupsGroupIdMembersCustomerIdDeleteUrl(groupId,customerId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Her chips (CUS-09-10), her past stays and the manual groups she can
still be added to.
 * @summary Customer Groups
 */
export const getCustomerGroupsApiCustomerGroupsOfCustomerIdGetUrl = (customerId: string,) => {


  

  return `/api/customer-groups/of/${customerId}`
}

export const customerGroupsApiCustomerGroupsOfCustomerIdGet = async (customerId: string, options?: RequestInit): Promise<CustomerGroupsResponse> => {
  
  return apiFetch<CustomerGroupsResponse>(getCustomerGroupsApiCustomerGroupsOfCustomerIdGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Tickets
 */
export const getListTicketsApiCustomerTicketsGetUrl = (params?: ListTicketsApiCustomerTicketsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-tickets?${stringifiedParams}` : `/api/customer-tickets`
}

export const listTicketsApiCustomerTicketsGet = async (params?: ListTicketsApiCustomerTicketsGetParams, options?: RequestInit): Promise<CustomerTicketListResponse> => {
  
  return apiFetch<CustomerTicketListResponse>(getListTicketsApiCustomerTicketsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Ticket
 */
export const getCreateTicketApiCustomerTicketsPostUrl = () => {


  

  return `/api/customer-tickets`
}

export const createTicketApiCustomerTicketsPost = async (customerTicketCreate: CustomerTicketCreate, options?: RequestInit): Promise<CustomerTicketResponse> => {
  
  return apiFetch<CustomerTicketResponse>(getCreateTicketApiCustomerTicketsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerTicketCreate,)
  }
);}



/**
 * @summary Get Ticket Summary
 */
export const getGetTicketSummaryApiCustomerTicketsSummaryGetUrl = (params: GetTicketSummaryApiCustomerTicketsSummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-tickets/summary?${stringifiedParams}` : `/api/customer-tickets/summary`
}

export const getTicketSummaryApiCustomerTicketsSummaryGet = async (params: GetTicketSummaryApiCustomerTicketsSummaryGetParams, options?: RequestInit): Promise<TicketSummaryResponse> => {
  
  return apiFetch<TicketSummaryResponse>(getGetTicketSummaryApiCustomerTicketsSummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Ticket
 */
export const getGetTicketApiCustomerTicketsTicketIdGetUrl = (ticketId: string,) => {


  

  return `/api/customer-tickets/${ticketId}`
}

export const getTicketApiCustomerTicketsTicketIdGet = async (ticketId: string, options?: RequestInit): Promise<CustomerTicketResponse> => {
  
  return apiFetch<CustomerTicketResponse>(getGetTicketApiCustomerTicketsTicketIdGetUrl(ticketId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Ticket
 */
export const getUpdateTicketApiCustomerTicketsTicketIdPatchUrl = (ticketId: string,) => {


  

  return `/api/customer-tickets/${ticketId}`
}

export const updateTicketApiCustomerTicketsTicketIdPatch = async (ticketId: string,
    customerTicketUpdate: CustomerTicketUpdate, options?: RequestInit): Promise<CustomerTicketResponse> => {
  
  return apiFetch<CustomerTicketResponse>(getUpdateTicketApiCustomerTicketsTicketIdPatchUrl(ticketId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerTicketUpdate,)
  }
);}



/**
 * @summary Delete Ticket
 */
export const getDeleteTicketApiCustomerTicketsTicketIdDeleteUrl = (ticketId: string,) => {


  

  return `/api/customer-tickets/${ticketId}`
}

export const deleteTicketApiCustomerTicketsTicketIdDelete = async (ticketId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteTicketApiCustomerTicketsTicketIdDeleteUrl(ticketId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Customer Tickets
 */
export const getListCustomerTicketsApiCustomersCustomerIdTicketsGetUrl = (customerId: string,) => {


  

  return `/api/customers/${customerId}/tickets`
}

export const listCustomerTicketsApiCustomersCustomerIdTicketsGet = async (customerId: string, options?: RequestInit): Promise<CustomerTicketListResponse> => {
  
  return apiFetch<CustomerTicketListResponse>(getListCustomerTicketsApiCustomersCustomerIdTicketsGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Daily Report
 */
export const getGetDailyReportApiDailyReportGetUrl = (params?: GetDailyReportApiDailyReportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/daily-report?${stringifiedParams}` : `/api/daily-report`
}

export const getDailyReportApiDailyReportGet = async (params?: GetDailyReportApiDailyReportGetParams, options?: RequestInit): Promise<DailyReportResponse> => {
  
  return apiFetch<DailyReportResponse>(getGetDailyReportApiDailyReportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Confirm Daily Report
 */
export const getConfirmDailyReportApiDailyReportConfirmPostUrl = () => {


  

  return `/api/daily-report/confirm`
}

export const confirmDailyReportApiDailyReportConfirmPost = async (dailyReportConfirmRequest: DailyReportConfirmRequest, options?: RequestInit): Promise<DailyReportConfirmationResponse> => {
  
  return apiFetch<DailyReportConfirmationResponse>(getConfirmDailyReportApiDailyReportConfirmPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dailyReportConfirmRequest,)
  }
);}



/**
 * @summary List Disputes
 */
export const getListDisputesApiDailyReportDisputesGetUrl = (params?: ListDisputesApiDailyReportDisputesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/daily-report/disputes?${stringifiedParams}` : `/api/daily-report/disputes`
}

export const listDisputesApiDailyReportDisputesGet = async (params?: ListDisputesApiDailyReportDisputesGetParams, options?: RequestInit): Promise<DisputeListResponse> => {
  
  return apiFetch<DisputeListResponse>(getListDisputesApiDailyReportDisputesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Dispute
 */
export const getCreateDisputeApiDailyReportDisputesPostUrl = () => {


  

  return `/api/daily-report/disputes`
}

export const createDisputeApiDailyReportDisputesPost = async (disputeCreateRequest: DisputeCreateRequest, options?: RequestInit): Promise<DisputeWithStaffResponse> => {
  
  return apiFetch<DisputeWithStaffResponse>(getCreateDisputeApiDailyReportDisputesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disputeCreateRequest,)
  }
);}



/**
 * @summary Resolve Dispute
 */
export const getResolveDisputeApiDailyReportDisputesDisputeIdResolvePostUrl = (disputeId: string,) => {


  

  return `/api/daily-report/disputes/${disputeId}/resolve`
}

export const resolveDisputeApiDailyReportDisputesDisputeIdResolvePost = async (disputeId: string,
    disputeResolveRequest: DisputeResolveRequest, options?: RequestInit): Promise<DisputeWithStaffResponse> => {
  
  return apiFetch<DisputeWithStaffResponse>(getResolveDisputeApiDailyReportDisputesDisputeIdResolvePostUrl(disputeId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disputeResolveRequest,)
  }
);}



/**
 * @summary Withdraw Dispute
 */
export const getWithdrawDisputeApiDailyReportDisputesDisputeIdWithdrawPostUrl = (disputeId: string,) => {


  

  return `/api/daily-report/disputes/${disputeId}/withdraw`
}

export const withdrawDisputeApiDailyReportDisputesDisputeIdWithdrawPost = async (disputeId: string,
    disputeWithdrawRequest: DisputeWithdrawRequest, options?: RequestInit): Promise<DisputeResponse> => {
  
  return apiFetch<DisputeResponse>(getWithdrawDisputeApiDailyReportDisputesDisputeIdWithdrawPostUrl(disputeId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disputeWithdrawRequest,)
  }
);}



/**
 * Outlet view, top block (DSH-12-06/07/08, DSH-19-05): on-duty line, today's
appointments and new customers, the next three customers, my approval
requests. Counts and names only — no sales figures.
 * @summary Outlet Today
 */
export const getOutletTodayApiDashboardOutletTodayGetUrl = (params?: OutletTodayApiDashboardOutletTodayGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/outlet-today?${stringifiedParams}` : `/api/dashboard/outlet-today`
}

export const outletTodayApiDashboardOutletTodayGet = async (params?: OutletTodayApiDashboardOutletTodayGetParams, options?: RequestInit): Promise<OutletTodayResponse> => {
  
  return apiFetch<OutletTodayResponse>(getOutletTodayApiDashboardOutletTodayGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Outlet view money figures (DSH-12-02 / DSH-12-06): Today's sales and this
month's sales against the outlet minimum and the incentive marks — GEN-14 net
sales, read-only. The both-outlets break-even is not included.
 * @summary Outlet Sales
 */
export const getOutletSalesApiDashboardOutletSalesGetUrl = (params?: OutletSalesApiDashboardOutletSalesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/outlet-sales?${stringifiedParams}` : `/api/dashboard/outlet-sales`
}

export const outletSalesApiDashboardOutletSalesGet = async (params?: OutletSalesApiDashboardOutletSalesGetParams, options?: RequestInit): Promise<OutletSalesResponse> => {
  
  return apiFetch<OutletSalesResponse>(getOutletSalesApiDashboardOutletSalesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-12-04 / DSH-16-05 — the KPI table, month so far against Set targets,
one block per outlet (or the one asked for). Read-only, counted from the
records.
 * @summary Kpis
 */
export const getKpisApiDashboardKpisGetUrl = (params?: KpisApiDashboardKpisGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/kpis?${stringifiedParams}` : `/api/dashboard/kpis`
}

export const kpisApiDashboardKpisGet = async (params?: KpisApiDashboardKpisGetParams, options?: RequestInit): Promise<KpiTableResponse> => {
  
  return apiFetch<KpiTableResponse>(getKpisApiDashboardKpisGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Outlet view 'Needs attention now' (DSH-19-02): red customers left, and
tomorrow's unanswered reminders from 2 hours before closing. Read-only.
 * @summary Needs Attention
 */
export const getNeedsAttentionApiDashboardNeedsAttentionGetUrl = (params?: NeedsAttentionApiDashboardNeedsAttentionGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/needs-attention?${stringifiedParams}` : `/api/dashboard/needs-attention`
}

export const needsAttentionApiDashboardNeedsAttentionGet = async (params?: NeedsAttentionApiDashboardNeedsAttentionGetParams, options?: RequestInit): Promise<NeedsAttentionResponse> => {
  
  return apiFetch<NeedsAttentionResponse>(getNeedsAttentionApiDashboardNeedsAttentionGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Today's queue badges (DSH-14-07): Consult needed, sessions left (5 or
fewer), balance, photo day, special request — one entry per booking.
Read-only; each badge reuses the rule of the screen that owns it.
 * @summary Queue Badges
 */
export const getQueueBadgesApiDashboardQueueBadgesGetUrl = (params?: QueueBadgesApiDashboardQueueBadgesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/queue-badges?${stringifiedParams}` : `/api/dashboard/queue-badges`
}

export const queueBadgesApiDashboardQueueBadgesGet = async (params?: QueueBadgesApiDashboardQueueBadgesGetParams, options?: RequestInit): Promise<QueueBadgesResponse> => {
  
  return apiFetch<QueueBadgesResponse>(getQueueBadgesApiDashboardQueueBadgesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-20 — optionally pick the staff member who follows up a rejected
extension (can be left empty or cleared).
 * @summary Assign Rejected Extension
 */
export const getAssignRejectedExtensionApiDashboardRejectedExtensionsNeedIdAssigneePutUrl = (needId: string,) => {


  

  return `/api/dashboard/rejected-extensions/${needId}/assignee`
}

export const assignRejectedExtensionApiDashboardRejectedExtensionsNeedIdAssigneePut = async (needId: string,
    rejectedExtensionAssign: RejectedExtensionAssign, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getAssignRejectedExtensionApiDashboardRejectedExtensionsNeedIdAssigneePutUrl(needId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectedExtensionAssign,)
  }
);}



/**
 * Office / Management views: MC today · on leave today · approvals waiting
for HQ · yesterday's daily close · open complaints and requests · Xero sync
waiting (DSH-02-03). Counts only.
 * @summary Status Strip
 */
export const getStatusStripApiDashboardStatusStripGetUrl = () => {


  

  return `/api/dashboard/status-strip`
}

export const statusStripApiDashboardStatusStripGet = async ( options?: RequestInit): Promise<StatusStripResponse> => {
  
  return apiFetch<StatusStripResponse>(getStatusStripApiDashboardStatusStripGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * 'Away today' (DSH-00-10, Office and Management views) and 'Leave planned
this month' (DSH-17-06, Management view only — left out unless the caller
holds dashboard.management). Names, outlet and role only; never a reason.
 * @summary Away
 */
export const getAwayApiDashboardAwayGetUrl = () => {


  

  return `/api/dashboard/away`
}

export const awayApiDashboardAwayGet = async ( options?: RequestInit): Promise<AwayResponse> => {
  
  return apiFetch<AwayResponse>(getAwayApiDashboardAwayGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Office view desk tabs (DSH-08-01): one per HQ staff member, in the order
management set (Desk order setting). An office person's own desk comes
first; management sees the set order as it is. Names only.
 * @summary Office Desks
 */
export const getOfficeDesksApiDashboardOfficeDesksGetUrl = () => {


  

  return `/api/dashboard/office-desks`
}

export const officeDesksApiDashboardOfficeDesksGet = async ( options?: RequestInit): Promise<OfficeDesksResponse> => {
  
  return apiFetch<OfficeDesksResponse>(getOfficeDesksApiDashboardOfficeDesksGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Management view (DSH-16): month header, B · Operations counts and
F · Outlet staff this month. Counts and hours only — no money.
 * @summary Management Summary
 */
export const getManagementSummaryApiDashboardManagementSummaryGetUrl = () => {


  

  return `/api/dashboard/management-summary`
}

export const managementSummaryApiDashboardManagementSummaryGet = async ( options?: RequestInit): Promise<ManagementSummaryResponse> => {
  
  return apiFetch<ManagementSummaryResponse>(getManagementSummaryApiDashboardManagementSummaryGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Management view, D · Lead pipeline (DSH-16-08): month-to-date counts from
the Leads module and the Consultation Report. Counts only; nothing is typed.
 * @summary Lead Pipeline
 */
export const getLeadPipelineApiDashboardLeadPipelineGetUrl = () => {


  

  return `/api/dashboard/lead-pipeline`
}

export const leadPipelineApiDashboardLeadPipelineGet = async ( options?: RequestInit): Promise<LeadPipelineResponse> => {
  
  return apiFetch<LeadPipelineResponse>(getLeadPipelineApiDashboardLeadPipelineGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-18: C · Operating risks (Act / Watch against management's thresholds),
the one-line customer backlog and E · Finance, every figure read from the
screen or report that owns it. No new money definition.
 * @summary Management Risks
 */
export const getManagementRisksApiDashboardManagementRisksGetUrl = () => {


  

  return `/api/dashboard/management-risks`
}

export const managementRisksApiDashboardManagementRisksGet = async ( options?: RequestInit): Promise<ManagementRisksResponse> => {
  
  return apiFetch<ManagementRisksResponse>(getManagementRisksApiDashboardManagementRisksGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Management sets the Act / Watch figures of one risk line (DSH-18-02).
 * @summary Set Risk Threshold
 */
export const getSetRiskThresholdApiDashboardManagementRisksThresholdsRiskKeyPutUrl = (riskKey: string,) => {


  

  return `/api/dashboard/management-risks/thresholds/${riskKey}`
}

export const setRiskThresholdApiDashboardManagementRisksThresholdsRiskKeyPut = async (riskKey: string,
    riskThresholdUpdate: RiskThresholdUpdate, options?: RequestInit): Promise<RiskLine> => {
  
  return apiFetch<RiskLine>(getSetRiskThresholdApiDashboardManagementRisksThresholdsRiskKeyPutUrl(riskKey),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      riskThresholdUpdate,)
  }
);}



/**
 * Management > Set targets (3c, DSH-17-03): management only.
 * @summary Get Targets
 */
export const getGetTargetsApiDashboardTargetsGetUrl = () => {


  

  return `/api/dashboard/targets`
}

export const getTargetsApiDashboardTargetsGet = async ( options?: RequestInit): Promise<DashboardTargetsScreen> => {
  
  return apiFetch<DashboardTargetsScreen>(getGetTargetsApiDashboardTargetsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Save one target, effective tomorrow; kept with old value, who and when.
 * @summary Set Target
 */
export const getSetTargetApiDashboardTargetsKeyPutUrl = (key: string,) => {


  

  return `/api/dashboard/targets/${key}`
}

export const setTargetApiDashboardTargetsKeyPut = async (key: string,
    dashboardTargetUpdate: DashboardTargetUpdate, options?: RequestInit): Promise<DashboardTargetsScreen> => {
  
  return apiFetch<DashboardTargetsScreen>(getSetTargetApiDashboardTargetsKeyPutUrl(key),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dashboardTargetUpdate,)
  }
);}



/**
 * Today's What to sell list of one outlet; the OS draft is written on the
first open of the day.
 * @summary What To Sell
 */
export const getWhatToSellApiDashboardWhatToSellGetUrl = (params: WhatToSellApiDashboardWhatToSellGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/what-to-sell?${stringifiedParams}` : `/api/dashboard/what-to-sell`
}

export const whatToSellApiDashboardWhatToSellGet = async (params: WhatToSellApiDashboardWhatToSellGetParams, options?: RequestInit): Promise<WhatToSellResponse> => {
  
  return apiFetch<WhatToSellResponse>(getWhatToSellApiDashboardWhatToSellGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Step 2 — the office person picks the items for one customer.
 * @summary What To Sell Picks
 */
export const getWhatToSellPicksApiDashboardWhatToSellListIdItemsItemIdPicksPutUrl = (listId: string,
    itemId: string,) => {


  

  return `/api/dashboard/what-to-sell/${listId}/items/${itemId}/picks`
}

export const whatToSellPicksApiDashboardWhatToSellListIdItemsItemIdPicksPut = async (listId: string,
    itemId: string,
    whatToSellPicks: WhatToSellPicks, options?: RequestInit): Promise<WhatToSellResponse> => {
  
  return apiFetch<WhatToSellResponse>(getWhatToSellPicksApiDashboardWhatToSellListIdItemsItemIdPicksPutUrl(listId,itemId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      whatToSellPicks,)
  }
);}



/**
 * '+ Add a customer from today's appointments'.
 * @summary What To Sell Add
 */
export const getWhatToSellAddApiDashboardWhatToSellListIdCustomersPostUrl = (listId: string,) => {


  

  return `/api/dashboard/what-to-sell/${listId}/customers`
}

export const whatToSellAddApiDashboardWhatToSellListIdCustomersPost = async (listId: string,
    whatToSellAdd: WhatToSellAdd, options?: RequestInit): Promise<WhatToSellResponse> => {
  
  return apiFetch<WhatToSellResponse>(getWhatToSellAddApiDashboardWhatToSellListIdCustomersPostUrl(listId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      whatToSellAdd,)
  }
);}



/**
 * 'Send to Angela'.
 * @summary What To Sell Send
 */
export const getWhatToSellSendApiDashboardWhatToSellListIdSendPostUrl = (listId: string,) => {


  

  return `/api/dashboard/what-to-sell/${listId}/send`
}

export const whatToSellSendApiDashboardWhatToSellListIdSendPost = async (listId: string, options?: RequestInit): Promise<WhatToSellResponse> => {
  
  return apiFetch<WhatToSellResponse>(getWhatToSellSendApiDashboardWhatToSellListIdSendPostUrl(listId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Angela confirms (Jii on her day off) — management only.
 * @summary What To Sell Confirm
 */
export const getWhatToSellConfirmApiDashboardWhatToSellListIdConfirmPostUrl = (listId: string,) => {


  

  return `/api/dashboard/what-to-sell/${listId}/confirm`
}

export const whatToSellConfirmApiDashboardWhatToSellListIdConfirmPost = async (listId: string, options?: RequestInit): Promise<WhatToSellResponse> => {
  
  return apiFetch<WhatToSellResponse>(getWhatToSellConfirmApiDashboardWhatToSellListIdConfirmPostUrl(listId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The outlet marks a picked item Done / Declined / Not offered.
 * @summary What To Sell Mark
 */
export const getWhatToSellMarkApiDashboardWhatToSellListIdItemsItemIdOutcomePutUrl = (listId: string,
    itemId: string,) => {


  

  return `/api/dashboard/what-to-sell/${listId}/items/${itemId}/outcome`
}

export const whatToSellMarkApiDashboardWhatToSellListIdItemsItemIdOutcomePut = async (listId: string,
    itemId: string,
    whatToSellMark: WhatToSellMark, options?: RequestInit): Promise<WhatToSellResponse> => {
  
  return apiFetch<WhatToSellResponse>(getWhatToSellMarkApiDashboardWhatToSellListIdItemsItemIdOutcomePutUrl(listId,itemId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      whatToSellMark,)
  }
);}



/**
 * DSH-16-02 / DSH-16-03 — top row and per-outlet sales goal lines.
 * @summary Management Top
 */
export const getManagementTopApiDashboardManagementTopGetUrl = () => {


  

  return `/api/dashboard/management-top`
}

export const managementTopApiDashboardManagementTopGet = async ( options?: RequestInit): Promise<ManagementTopResponse> => {
  
  return apiFetch<ManagementTopResponse>(getManagementTopApiDashboardManagementTopGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * B · Operations charts — utilization by week, treatments by therapist,
cancellations and no-shows by week.
 * @summary Management Operations
 */
export const getManagementOperationsApiDashboardManagementOperationsGetUrl = () => {


  

  return `/api/dashboard/management-operations`
}

export const managementOperationsApiDashboardManagementOperationsGet = async ( options?: RequestInit): Promise<ManagementOperationsResponse> => {
  
  return apiFetch<ManagementOperationsResponse>(getManagementOperationsApiDashboardManagementOperationsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * A · Sales quality — conversion by month and What to sell success.
 * @summary Management Sales Quality
 */
export const getManagementSalesQualityApiDashboardManagementSalesQualityGetUrl = () => {


  

  return `/api/dashboard/management-sales-quality`
}

export const managementSalesQualityApiDashboardManagementSalesQualityGet = async ( options?: RequestInit): Promise<ManagementSalesQualityResponse> => {
  
  return apiFetch<ManagementSalesQualityResponse>(getManagementSalesQualityApiDashboardManagementSalesQualityGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-22 — Old balances: the one-month Bal Pay campaign report, both outlets.
 * @summary Old Balances Campaign
 */
export const getOldBalancesCampaignApiDashboardOldBalancesCampaignGetUrl = () => {


  

  return `/api/dashboard/old-balances-campaign`
}

export const oldBalancesCampaignApiDashboardOldBalancesCampaignGet = async ( options?: RequestInit): Promise<OldBalancesCampaignResponse> => {
  
  return apiFetch<OldBalancesCampaignResponse>(getOldBalancesCampaignApiDashboardOldBalancesCampaignGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Business overview > Summary (DSH-01, management only, DSH-00-03).
 * @summary Business Summary
 */
export const getBusinessSummaryApiDashboardBusinessSummaryGetUrl = (params?: BusinessSummaryApiDashboardBusinessSummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/business/summary?${stringifiedParams}` : `/api/dashboard/business/summary`
}

export const businessSummaryApiDashboardBusinessSummaryGet = async (params?: BusinessSummaryApiDashboardBusinessSummaryGetParams, options?: RequestInit): Promise<BusinessSummaryResponse> => {
  
  return apiFetch<BusinessSummaryResponse>(getBusinessSummaryApiDashboardBusinessSummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Business overview > Staff (DSH-01-12).
 * @summary Business Staff
 */
export const getBusinessStaffApiDashboardBusinessStaffGetUrl = (params?: BusinessStaffApiDashboardBusinessStaffGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/business/staff?${stringifiedParams}` : `/api/dashboard/business/staff`
}

export const businessStaffApiDashboardBusinessStaffGet = async (params?: BusinessStaffApiDashboardBusinessStaffGetParams, options?: RequestInit): Promise<BusinessStaffResponse> => {
  
  return apiFetch<BusinessStaffResponse>(getBusinessStaffApiDashboardBusinessStaffGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Business overview > Customers (DSH-01).
 * @summary Business Customers
 */
export const getBusinessCustomersApiDashboardBusinessCustomersGetUrl = (params?: BusinessCustomersApiDashboardBusinessCustomersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/business/customers?${stringifiedParams}` : `/api/dashboard/business/customers`
}

export const businessCustomersApiDashboardBusinessCustomersGet = async (params?: BusinessCustomersApiDashboardBusinessCustomersGetParams, options?: RequestInit): Promise<BusinessCustomersResponse> => {
  
  return apiFetch<BusinessCustomersResponse>(getBusinessCustomersApiDashboardBusinessCustomersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Business overview > Marketing (DSH-01).
 * @summary Business Marketing
 */
export const getBusinessMarketingApiDashboardBusinessMarketingGetUrl = (params?: BusinessMarketingApiDashboardBusinessMarketingGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/business/marketing?${stringifiedParams}` : `/api/dashboard/business/marketing`
}

export const businessMarketingApiDashboardBusinessMarketingGet = async (params?: BusinessMarketingApiDashboardBusinessMarketingGetParams, options?: RequestInit): Promise<BusinessMarketingResponse> => {
  
  return apiFetch<BusinessMarketingResponse>(getBusinessMarketingApiDashboardBusinessMarketingGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Business overview > Sales (DSH-01).
 * @summary Business Sales
 */
export const getBusinessSalesApiDashboardBusinessSalesGetUrl = (params?: BusinessSalesApiDashboardBusinessSalesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/business/sales?${stringifiedParams}` : `/api/dashboard/business/sales`
}

export const businessSalesApiDashboardBusinessSalesGet = async (params?: BusinessSalesApiDashboardBusinessSalesGetParams, options?: RequestInit): Promise<BusinessSalesResponse> => {
  
  return apiFetch<BusinessSalesResponse>(getBusinessSalesApiDashboardBusinessSalesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Business overview > Year on Year (DSH-01-10).
 * @summary Business Yoy
 */
export const getBusinessYoyApiDashboardBusinessYoyGetUrl = (params: BusinessYoyApiDashboardBusinessYoyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["years"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/business/yoy?${stringifiedParams}` : `/api/dashboard/business/yoy`
}

export const businessYoyApiDashboardBusinessYoyGet = async (params: BusinessYoyApiDashboardBusinessYoyGetParams, options?: RequestInit): Promise<BusinessYoyResponse> => {
  
  return apiFetch<BusinessYoyResponse>(getBusinessYoyApiDashboardBusinessYoyGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-34 — today's confirmed picks per customer for Appointment Details and
the Active cards; empty until Angela confirms. Read-only.
 * @summary What To Sell Today Picks
 */
export const getWhatToSellTodayPicksApiDashboardWhatToSellTodayPicksGetUrl = (params: WhatToSellTodayPicksApiDashboardWhatToSellTodayPicksGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/what-to-sell/today-picks?${stringifiedParams}` : `/api/dashboard/what-to-sell/today-picks`
}

export const whatToSellTodayPicksApiDashboardWhatToSellTodayPicksGet = async (params: WhatToSellTodayPicksApiDashboardWhatToSellTodayPicksGetParams, options?: RequestInit): Promise<TodayPicksResponse> => {
  
  return apiFetch<TodayPicksResponse>(getWhatToSellTodayPicksApiDashboardWhatToSellTodayPicksGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-08-01: the desk tabs this user may open. An office person sees her
own desk first, then the others in the order management set (by default
Lisa · Adeline · Jessica; read only for her). Management sees the set order
as it is, every desk read-write.
 * @summary List Desks
 */
export const getListDesksApiOfficeDeskDesksGetUrl = () => {


  

  return `/api/office-desk/desks`
}

export const listDesksApiOfficeDeskDesksGet = async ( options?: RequestInit): Promise<DeskTabsResponse> => {
  
  return apiFetch<DeskTabsResponse>(getListDesksApiOfficeDeskDesksGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Management view, F - People, Office desks today (DSH-17-02): one card per
office person — tasks done of planned, carried over, this week's completion
and the given tasks still open. Management only; read-only for the viewer
(opening a card's desk is a separate screen).
 * @summary Desks Today
 */
export const getDesksTodayApiOfficeDeskDesksTodayGetUrl = () => {


  

  return `/api/office-desk/desks-today`
}

export const desksTodayApiOfficeDeskDesksTodayGet = async ( options?: RequestInit): Promise<DeskDaysResponse> => {
  
  return apiFetch<DeskDaysResponse>(getDesksTodayApiOfficeDeskDesksTodayGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The desk tab order (DSH-08-01, owner 15 Oct): every desk in the current
order, the saved order and the default. Anyone who can open a desk may read it.
 * @summary Get Desk Order
 */
export const getGetDeskOrderApiOfficeDeskDeskOrderGetUrl = () => {


  

  return `/api/office-desk/desk-order`
}

export const getDeskOrderApiOfficeDeskDeskOrderGet = async ( options?: RequestInit): Promise<DeskOrderResponse> => {
  
  return apiFetch<DeskOrderResponse>(getGetDeskOrderApiOfficeDeskDeskOrderGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Management sets the desk tab order; [] puts the starting order back.
Applies everywhere desks are listed (Office view tabs, Task sheet, pickers).
 * @summary Set Desk Order
 */
export const getSetDeskOrderApiOfficeDeskDeskOrderPutUrl = () => {


  

  return `/api/office-desk/desk-order`
}

export const setDeskOrderApiOfficeDeskDeskOrderPut = async (deskOrderUpdate: DeskOrderUpdate, options?: RequestInit): Promise<DeskOrderResponse> => {
  
  return apiFetch<DeskOrderResponse>(getSetDeskOrderApiOfficeDeskDeskOrderPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deskOrderUpdate,)
  }
);}



/**
 * The day's desk (DSH-02, DSH-03): Now, Done today, Waiting, This week and
Coming up. Built the first time it is opened each day (lazy, DSH-05-01).
 * @summary Desk Today
 */
export const getDeskTodayApiOfficeDeskDesksOwnerUserIdTodayGetUrl = (ownerUserId: string,) => {


  

  return `/api/office-desk/desks/${ownerUserId}/today`
}

export const deskTodayApiOfficeDeskDesksOwnerUserIdTodayGet = async (ownerUserId: string, options?: RequestInit): Promise<DeskTodayResponse> => {
  
  return apiFetch<DeskTodayResponse>(getDeskTodayApiOfficeDeskDesksOwnerUserIdTodayGetUrl(ownerUserId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * '<Outlet> right now' (DSH-10/11): the ring, the three tiles, the rows
with one instruction each and the right-column counts for a desk that runs
an outlet. Read-only; no money (sales and What to sell come back as '—').
 * @summary Outlet Now
 */
export const getOutletNowApiOfficeDeskDesksOwnerUserIdOutletNowGetUrl = (ownerUserId: string,) => {


  

  return `/api/office-desk/desks/${ownerUserId}/outlet-now`
}

export const outletNowApiOfficeDeskDesksOwnerUserIdOutletNowGet = async (ownerUserId: string, options?: RequestInit): Promise<OutletNowResponse> => {
  
  return apiFetch<OutletNowResponse>(getOutletNowApiOfficeDeskDesksOwnerUserIdOutletNowGetUrl(ownerUserId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-09-01 tab 3 — Completed: done, carried over, taken off, by day.
 * @summary Desk History
 */
export const getDeskHistoryApiOfficeDeskDesksOwnerUserIdHistoryGetUrl = (ownerUserId: string,
    params?: DeskHistoryApiOfficeDeskDesksOwnerUserIdHistoryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/office-desk/desks/${ownerUserId}/history?${stringifiedParams}` : `/api/office-desk/desks/${ownerUserId}/history`
}

export const deskHistoryApiOfficeDeskDesksOwnerUserIdHistoryGet = async (ownerUserId: string,
    params?: DeskHistoryApiOfficeDeskDesksOwnerUserIdHistoryGetParams, options?: RequestInit): Promise<TaskHistoryResponse> => {
  
  return apiFetch<TaskHistoryResponse>(getDeskHistoryApiOfficeDeskDesksOwnerUserIdHistoryGetUrl(ownerUserId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-04-03: the add row — a card for today only.
 * @summary Add Task
 */
export const getAddTaskApiOfficeDeskDesksOwnerUserIdTasksPostUrl = (ownerUserId: string,) => {


  

  return `/api/office-desk/desks/${ownerUserId}/tasks`
}

export const addTaskApiOfficeDeskDesksOwnerUserIdTasksPost = async (ownerUserId: string,
    addTaskRequest: AddTaskRequest, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getAddTaskApiOfficeDeskDesksOwnerUserIdTasksPostUrl(ownerUserId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addTaskRequest,)
  }
);}



/**
 * A manager gives an office person a task. It goes straight onto her desk
as a normal Now card on the date wanted (DSH-04-10, owner 15 Oct).
 * @summary Give Management Task
 */
export const getGiveManagementTaskApiOfficeDeskDesksOwnerUserIdManagementTasksPostUrl = (ownerUserId: string,) => {


  

  return `/api/office-desk/desks/${ownerUserId}/management-tasks`
}

export const giveManagementTaskApiOfficeDeskDesksOwnerUserIdManagementTasksPost = async (ownerUserId: string,
    managementTaskRequest: ManagementTaskRequest, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getGiveManagementTaskApiOfficeDeskDesksOwnerUserIdManagementTasksPostUrl(ownerUserId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      managementTaskRequest,)
  }
);}



/**
 * @summary Tick
 */
export const getTickApiOfficeDeskTasksTaskIdTickPostUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/tick`
}

export const tickApiOfficeDeskTasksTaskIdTickPost = async (taskId: string, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getTickApiOfficeDeskTasksTaskIdTickPostUrl(taskId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Untick
 */
export const getUntickApiOfficeDeskTasksTaskIdUntickPostUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/untick`
}

export const untickApiOfficeDeskTasksTaskIdUntickPost = async (taskId: string, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getUntickApiOfficeDeskTasksTaskIdUntickPostUrl(taskId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Not Today
 */
export const getNotTodayApiOfficeDeskTasksTaskIdNotTodayPostUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/not-today`
}

export const notTodayApiOfficeDeskTasksTaskIdNotTodayPost = async (taskId: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getNotTodayApiOfficeDeskTasksTaskIdNotTodayPostUrl(taskId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reasonRequest,)
  }
);}



/**
 * @summary Tomorrow
 */
export const getTomorrowApiOfficeDeskTasksTaskIdTomorrowPostUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/tomorrow`
}

export const tomorrowApiOfficeDeskTasksTaskIdTomorrowPost = async (taskId: string, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getTomorrowApiOfficeDeskTasksTaskIdTomorrowPostUrl(taskId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Waiting
 */
export const getWaitingApiOfficeDeskTasksTaskIdWaitingPostUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/waiting`
}

export const waitingApiOfficeDeskTasksTaskIdWaitingPost = async (taskId: string,
    waitingRequest: WaitingRequest, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getWaitingApiOfficeDeskTasksTaskIdWaitingPostUrl(taskId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      waitingRequest,)
  }
);}



/**
 * @summary Answered
 */
export const getAnsweredApiOfficeDeskTasksTaskIdAnsweredPostUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/answered`
}

export const answeredApiOfficeDeskTasksTaskIdAnsweredPost = async (taskId: string, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getAnsweredApiOfficeDeskTasksTaskIdAnsweredPostUrl(taskId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Remarks
 */
export const getRemarksApiOfficeDeskTasksTaskIdRemarksPutUrl = (taskId: string,) => {


  

  return `/api/office-desk/tasks/${taskId}/remarks`
}

export const remarksApiOfficeDeskTasksTaskIdRemarksPut = async (taskId: string,
    remarksRequest: RemarksRequest, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getRemarksApiOfficeDeskTasksTaskIdRemarksPutUrl(taskId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      remarksRequest,)
  }
);}



/**
 * Screen 2c: each person's rules, split OS-counted / ticked by hand, with
how often, where the number comes from, last year, and any change waiting
for Angela. Everyone at HQ sees every card and may propose a change to any of
them (owner, 15 Oct); an office person's own card comes first.
 * @summary List Rules
 */
export const getListRulesApiOfficeDeskRulesGetUrl = (params?: ListRulesApiOfficeDeskRulesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/office-desk/rules?${stringifiedParams}` : `/api/office-desk/rules`
}

export const listRulesApiOfficeDeskRulesGet = async (params?: ListRulesApiOfficeDeskRulesGetParams, options?: RequestInit): Promise<RulesResponse> => {
  
  return apiFetch<RulesResponse>(getListRulesApiOfficeDeskRulesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Add Rule
 */
export const getAddRuleApiOfficeDeskRulesPostUrl = () => {


  

  return `/api/office-desk/rules`
}

export const addRuleApiOfficeDeskRulesPost = async (addRuleRequest: AddRuleRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getAddRuleApiOfficeDeskRulesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addRuleRequest,)
  }
);}



/**
 * @summary Edit Rule
 */
export const getEditRuleApiOfficeDeskRulesRuleIdPutUrl = (ruleId: string,) => {


  

  return `/api/office-desk/rules/${ruleId}`
}

export const editRuleApiOfficeDeskRulesRuleIdPut = async (ruleId: string,
    editRuleRequest: EditRuleRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getEditRuleApiOfficeDeskRulesRuleIdPutUrl(ruleId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editRuleRequest,)
  }
);}



/**
 * @summary Pause Rule
 */
export const getPauseRuleApiOfficeDeskRulesRuleIdPausePostUrl = (ruleId: string,) => {


  

  return `/api/office-desk/rules/${ruleId}/pause`
}

export const pauseRuleApiOfficeDeskRulesRuleIdPausePost = async (ruleId: string,
    ruleActionRequest: RuleActionRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getPauseRuleApiOfficeDeskRulesRuleIdPausePostUrl(ruleId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ruleActionRequest,)
  }
);}



/**
 * @summary Resume Rule
 */
export const getResumeRuleApiOfficeDeskRulesRuleIdResumePostUrl = (ruleId: string,) => {


  

  return `/api/office-desk/rules/${ruleId}/resume`
}

export const resumeRuleApiOfficeDeskRulesRuleIdResumePost = async (ruleId: string,
    ruleActionRequest: RuleActionRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getResumeRuleApiOfficeDeskRulesRuleIdResumePostUrl(ruleId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ruleActionRequest,)
  }
);}



/**
 * DSH-09-01: deleting asks for a reason; management is told.
 * @summary Delete Rule
 */
export const getDeleteRuleApiOfficeDeskRulesRuleIdDeletePostUrl = (ruleId: string,) => {


  

  return `/api/office-desk/rules/${ruleId}/delete`
}

export const deleteRuleApiOfficeDeskRulesRuleIdDeletePost = async (ruleId: string,
    ruleActionRequest: RuleActionRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getDeleteRuleApiOfficeDeskRulesRuleIdDeletePostUrl(ruleId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ruleActionRequest,)
  }
);}



/**
 * A 'when it comes up' job the OS cannot see: put it on today's desk.
 * @summary Add Rule To Today
 */
export const getAddRuleToTodayApiOfficeDeskRulesRuleIdAddToTodayPostUrl = (ruleId: string,) => {


  

  return `/api/office-desk/rules/${ruleId}/add-to-today`
}

export const addRuleToTodayApiOfficeDeskRulesRuleIdAddToTodayPost = async (ruleId: string, options?: RequestInit): Promise<DeskTask> => {
  
  return apiFetch<DeskTask>(getAddRuleToTodayApiOfficeDeskRulesRuleIdAddToTodayPostUrl(ruleId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The change log (DSH-21-02: who, when, old → new) — for management.
 * @summary Rule Changes
 */
export const getRuleChangesApiOfficeDeskRuleChangesGetUrl = () => {


  

  return `/api/office-desk/rule-changes`
}

export const ruleChangesApiOfficeDeskRuleChangesGet = async ( options?: RequestInit): Promise<RuleChangesResponse> => {
  
  return apiFetch<RuleChangesResponse>(getRuleChangesApiOfficeDeskRuleChangesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Angela (or Jii) confirms — the change takes effect from now.
 * @summary Confirm Change
 */
export const getConfirmChangeApiOfficeDeskRuleChangesChangeIdConfirmPostUrl = (changeId: string,) => {


  

  return `/api/office-desk/rule-changes/${changeId}/confirm`
}

export const confirmChangeApiOfficeDeskRuleChangesChangeIdConfirmPost = async (changeId: string,
    decisionRequest: DecisionRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getConfirmChangeApiOfficeDeskRuleChangesChangeIdConfirmPostUrl(changeId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      decisionRequest,)
  }
);}



/**
 * Angela (or Jii) declines — the old rule keeps running.
 * @summary Reject Change
 */
export const getRejectChangeApiOfficeDeskRuleChangesChangeIdRejectPostUrl = (changeId: string,) => {


  

  return `/api/office-desk/rule-changes/${changeId}/reject`
}

export const rejectChangeApiOfficeDeskRuleChangesChangeIdRejectPost = async (changeId: string,
    decisionRequest: DecisionRequest, options?: RequestInit): Promise<RuleChangeOut> => {
  
  return apiFetch<RuleChangeOut>(getRejectChangeApiOfficeDeskRuleChangesChangeIdRejectPostUrl(changeId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      decisionRequest,)
  }
);}



/**
 * DSH-08-03 / DSH-08-04 — the KPI rows this desk's owner owns, and the
next steps (at most three) for the ones that are behind.
 * @summary My Kpis
 */
export const getMyKpisApiOfficeDeskDesksOwnerUserIdMyKpisGetUrl = (ownerUserId: string,) => {


  

  return `/api/office-desk/desks/${ownerUserId}/my-kpis`
}

export const myKpisApiOfficeDeskDesksOwnerUserIdMyKpisGet = async (ownerUserId: string, options?: RequestInit): Promise<MyKpisResponse> => {
  
  return apiFetch<MyKpisResponse>(getMyKpisApiOfficeDeskDesksOwnerUserIdMyKpisGetUrl(ownerUserId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DSH-08-08 — three cards for the person's area, then sales goal and
utilization per outlet. Read-only.
 * @summary Area Cards
 */
export const getAreaCardsApiOfficeDeskDesksOwnerUserIdAreaCardsGetUrl = (ownerUserId: string,) => {


  

  return `/api/office-desk/desks/${ownerUserId}/area-cards`
}

export const areaCardsApiOfficeDeskDesksOwnerUserIdAreaCardsGet = async (ownerUserId: string, options?: RequestInit): Promise<AreaCardsResponse> => {
  
  return apiFetch<AreaCardsResponse>(getAreaCardsApiOfficeDeskDesksOwnerUserIdAreaCardsGetUrl(ownerUserId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Park a rung-up basket as a DRAFT instead of completing it.

Same payload and same validation as ``POST /finance/sales`` — the difference
is entirely in what does NOT happen: no invoice number, no Package, no stock
movement, no credit burn, no Xero row, no commission. The draft comes back
carrying a presales number (``PS-YYYYMMDD-NNN``).
 * @summary Hold Sale
 */
export const getHoldSaleApiFinanceSalesHoldPostUrl = () => {


  

  return `/api/finance/sales/hold`
}

export const holdSaleApiFinanceSalesHoldPost = async (saleCreate: SaleCreate, options?: RequestInit): Promise<SaleResponse> => {
  
  return apiFetch<SaleResponse>(getHoldSaleApiFinanceSalesHoldPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saleCreate,)
  }
);}



/**
 * The `Manage Preview Invoice` queue — every held invoice, newest first.
 * @summary List Drafts
 */
export const getListDraftsApiFinanceSalesDraftsGetUrl = (params?: ListDraftsApiFinanceSalesDraftsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/sales/drafts?${stringifiedParams}` : `/api/finance/sales/drafts`
}

export const listDraftsApiFinanceSalesDraftsGet = async (params?: ListDraftsApiFinanceSalesDraftsGetParams, options?: RequestInit): Promise<DraftSaleListResponse> => {
  
  return apiFetch<DraftSaleListResponse>(getListDraftsApiFinanceSalesDraftsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Backs the `Invoice on hold (N)` badge without shipping the whole list.
 * @summary Count Drafts
 */
export const getCountDraftsApiFinanceSalesDraftsCountGetUrl = (params?: CountDraftsApiFinanceSalesDraftsCountGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/sales/drafts/count?${stringifiedParams}` : `/api/finance/sales/drafts/count`
}

export const countDraftsApiFinanceSalesDraftsCountGet = async (params?: CountDraftsApiFinanceSalesDraftsCountGetParams, options?: RequestInit): Promise<DraftCountResponse> => {
  
  return apiFetch<DraftCountResponse>(getCountDraftsApiFinanceSalesDraftsCountGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * DRAFT → COMPLETED: mint the invoice number and apply every effect that
was deferred at hold time. 409 when a product line can no longer be filled —
the draft survives, because nothing is committed on failure.
 * @summary Finalize Draft
 */
export const getFinalizeDraftApiFinanceSalesSaleIdFinalizePostUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/finalize`
}

export const finalizeDraftApiFinanceSalesSaleIdFinalizePost = async (saleId: string, options?: RequestInit): Promise<SaleResponse> => {
  
  return apiFetch<SaleResponse>(getFinalizeDraftApiFinanceSalesSaleIdFinalizePostUrl(saleId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Discard a held invoice. DRAFT only — a COMPLETED sale is voided, never
deleted, and asking to delete one is a 400.
 * @summary Delete Draft
 */
export const getDeleteDraftApiFinanceSalesSaleIdDraftDeleteUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/draft`
}

export const deleteDraftApiFinanceSalesSaleIdDraftDelete = async (saleId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteDraftApiFinanceSalesSaleIdDraftDeleteUrl(saleId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Manager sign-off on a parked draft (the SM `Ack` column).
 * @summary Acknowledge Draft
 */
export const getAcknowledgeDraftApiFinanceSalesSaleIdAcknowledgePatchUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/acknowledge`
}

export const acknowledgeDraftApiFinanceSalesSaleIdAcknowledgePatch = async (saleId: string, options?: RequestInit): Promise<SaleResponse> => {
  
  return apiFetch<SaleResponse>(getAcknowledgeDraftApiFinanceSalesSaleIdAcknowledgePatchUrl(saleId),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}



/**
 * @summary List Held
 */
export const getListHeldApiFinanceHeldInvoicesGetUrl = (params?: ListHeldApiFinanceHeldInvoicesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/held-invoices?${stringifiedParams}` : `/api/finance/held-invoices`
}

export const listHeldApiFinanceHeldInvoicesGet = async (params?: ListHeldApiFinanceHeldInvoicesGetParams, options?: RequestInit): Promise<HeldInvoiceList> => {
  
  return apiFetch<HeldInvoiceList>(getListHeldApiFinanceHeldInvoicesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Hold
 */
export const getHoldApiFinanceHeldInvoicesPostUrl = () => {


  

  return `/api/finance/held-invoices`
}

export const holdApiFinanceHeldInvoicesPost = async (heldInvoiceCreate: HeldInvoiceCreate, options?: RequestInit): Promise<HeldInvoiceOut> => {
  
  return apiFetch<HeldInvoiceOut>(getHoldApiFinanceHeldInvoicesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      heldInvoiceCreate,)
  }
);}



/**
 * @summary Get Held
 */
export const getGetHeldApiFinanceHeldInvoicesHeldIdGetUrl = (heldId: string,) => {


  

  return `/api/finance/held-invoices/${heldId}`
}

export const getHeldApiFinanceHeldInvoicesHeldIdGet = async (heldId: string, options?: RequestInit): Promise<HeldInvoiceDetail> => {
  
  return apiFetch<HeldInvoiceDetail>(getGetHeldApiFinanceHeldInvoicesHeldIdGetUrl(heldId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Remove Held
 */
export const getRemoveHeldApiFinanceHeldInvoicesHeldIdDeleteUrl = (heldId: string,) => {


  

  return `/api/finance/held-invoices/${heldId}`
}

export const removeHeldApiFinanceHeldInvoicesHeldIdDelete = async (heldId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getRemoveHeldApiFinanceHeldInvoicesHeldIdDeleteUrl(heldId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Seed the §8.9 default finance rules (UPGRADE/REFUND/CHANGE) so FIN-6
upgrade & refund quotes resolve. Idempotent — upserts by ``ruleKey``.
 * @summary Seed Rules
 */
export const getSeedRulesApiFinanceRulesSeedPostUrl = () => {


  

  return `/api/finance/rules/seed`
}

export const seedRulesApiFinanceRulesSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedRulesApiFinanceRulesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The admin-editable §8.6 credit earn-value catalog.
 * @summary Get Credit Rates
 */
export const getGetCreditRatesApiFinanceCreditRatesGetUrl = () => {


  

  return `/api/finance/credit-rates`
}

export const getCreditRatesApiFinanceCreditRatesGet = async ( options?: RequestInit): Promise<CreditRateListResponse> => {
  
  return apiFetch<CreditRateListResponse>(getGetCreditRatesApiFinanceCreditRatesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Seed the §8.6 default credit earn-values. Idempotent — inserts only pairs
not already present; never overwrites an admin edit.
 * @summary Seed Credit Rates Endpoint
 */
export const getSeedCreditRatesEndpointApiFinanceCreditRatesSeedPostUrl = () => {


  

  return `/api/finance/credit-rates/seed`
}

export const seedCreditRatesEndpointApiFinanceCreditRatesSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedCreditRatesEndpointApiFinanceCreditRatesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Set a new earn amount on a credit rate.
 * @summary Patch Credit Rate
 */
export const getPatchCreditRateApiFinanceCreditRatesRateIdPatchUrl = (rateId: string,) => {


  

  return `/api/finance/credit-rates/${rateId}`
}

export const patchCreditRateApiFinanceCreditRatesRateIdPatch = async (rateId: string,
    creditRateUpdate: CreditRateUpdate, options?: RequestInit): Promise<CreditRateResponse> => {
  
  return apiFetch<CreditRateResponse>(getPatchCreditRateApiFinanceCreditRatesRateIdPatchUrl(rateId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      creditRateUpdate,)
  }
);}



/**
 * P1 — her invoices a $100 extension can be sold for (New Invoice).
 * @summary List Paid Extension Invoices
 */
export const getListPaidExtensionInvoicesApiFinanceCustomersCustomerIdPaidExtensionInvoicesGetUrl = (customerId: string,) => {


  

  return `/api/finance/customers/${customerId}/paid-extension-invoices`
}

export const listPaidExtensionInvoicesApiFinanceCustomersCustomerIdPaidExtensionInvoicesGet = async (customerId: string, options?: RequestInit): Promise<PaidExtensionInvoice[]> => {
  
  return apiFetch<PaidExtensionInvoice[]>(getListPaidExtensionInvoicesApiFinanceCustomersCustomerIdPaidExtensionInvoicesGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Sale
 */
export const getCreateSaleApiFinanceSalesPostUrl = () => {


  

  return `/api/finance/sales`
}

export const createSaleApiFinanceSalesPost = async (saleCreate: SaleCreate, options?: RequestInit): Promise<SaleResponse> => {
  
  return apiFetch<SaleResponse>(getCreateSaleApiFinanceSalesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saleCreate,)
  }
);}



/**
 * Sales list. Two filter vocabularies, deliberately.

``search`` is one box matching invoice OR buyer, which the transactions
screen uses. Search Invoices (Studio-Manager parity) has a separate box for
each, so ``invoiceNumber`` / ``customerName`` narrow independently and AND
together. ``outletIds`` is that screen's multi-select; ``outletId`` stays
for the single-outlet callers. ``includeVoided=false`` backs its "Show
voided invoices" checkbox — the default stays ``true`` so no existing
caller silently loses rows.

``outletIds`` is a COMMA-SEPARATED string, not a repeated param: the Orval
client serializes an array by ``toString()``-ing it into one comma-joined
value, so a ``list[str]`` here would receive ``["a,b"]`` and match nothing.
 * @summary List Sales
 */
export const getListSalesApiFinanceSalesGetUrl = (params?: ListSalesApiFinanceSalesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/sales?${stringifiedParams}` : `/api/finance/sales`
}

export const listSalesApiFinanceSalesGet = async (params?: ListSalesApiFinanceSalesGetParams, options?: RequestInit): Promise<SaleListResponse> => {
  
  return apiFetch<SaleListResponse>(getListSalesApiFinanceSalesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Admin export of sales/invoices (Studio-Manager parity), Excel by default and
CSV on ``?format=csv``. Takes the same filters as ``GET /sales`` so the file
matches the screen, plus the shared window params. Declared before
``/sales/{sale_id}`` so the literal wins.

Supplying no window params returns every sale, exactly as before this
endpoint learned about dates - an admin's existing full dump must not
silently narrow to a month (spec section 3.3).

Two ways to express a date range, deliberately. ``period``/``month``/
``start``/``end`` is the shared contract, for callers that think in periods.
``from``/``to`` mirrors ``GET /sales`` because the sales screen has two
independent date inputs, and the shared contract rejects half a range - so
without these, a user who filled in only "From" would get a 400 on export
while the list beside it worked fine. The window wins when both are given.

``outletIds`` / ``invoiceNumber`` / ``customerName`` / ``includeVoided``
exist here for the same reason: Search Invoices puts an Export beside those
filters, and an export that ignored half of them would hand the user a file
that disagrees with the table it came from.
 * @summary Export Sales
 */
export const getExportSalesApiFinanceSalesExportGetUrl = (params?: ExportSalesApiFinanceSalesExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/sales/export?${stringifiedParams}` : `/api/finance/sales/export`
}

export const exportSalesApiFinanceSalesExportGet = async (params?: ExportSalesApiFinanceSalesExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportSalesApiFinanceSalesExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Sale
 */
export const getGetSaleApiFinanceSalesSaleIdGetUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}`
}

export const getSaleApiFinanceSalesSaleIdGet = async (saleId: string, options?: RequestInit): Promise<SaleDetailResponse> => {
  
  return apiFetch<SaleDetailResponse>(getGetSaleApiFinanceSalesSaleIdGetUrl(saleId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-11-15 — the IHIP form the customer signed for this invoice.
 * @summary Get Ihip Agreement
 */
export const getGetIhipAgreementApiFinanceSalesSaleIdIhipAgreementGetUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/ihip-agreement`
}

export const getIhipAgreementApiFinanceSalesSaleIdIhipAgreementGet = async (saleId: string, options?: RequestInit): Promise<IHIPAgreementResponse> => {
  
  return apiFetch<IHIPAgreementResponse>(getGetIhipAgreementApiFinanceSalesSaleIdIhipAgreementGetUrl(saleId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Receipt
 */
export const getGetReceiptApiFinanceSalesSaleIdReceiptGetUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/receipt`
}

export const getReceiptApiFinanceSalesSaleIdReceiptGet = async (saleId: string, options?: RequestInit): Promise<ReceiptResponse> => {
  
  return apiFetch<ReceiptResponse>(getGetReceiptApiFinanceSalesSaleIdReceiptGetUrl(saleId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The printable A4 tax invoice for a sale, as a PDF download.

Same read gate as the receipt (``finance`` feature) — it is the same
document in a different wrapper, so anyone who may view the receipt may
download it.
 * @summary Get Invoice Pdf
 */
export const getGetInvoicePdfApiFinanceSalesSaleIdInvoiceGetUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/invoice`
}

export const getInvoicePdfApiFinanceSalesSaleIdInvoiceGet = async (saleId: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getGetInvoicePdfApiFinanceSalesSaleIdInvoiceGetUrl(saleId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * BUG-867 — reclassify a sale (Lisa: *"currently need to change '1 for 1
promo' to 'trial'"*).

A route dependency is right here (unlike the GST override on POST /sales),
because this endpoint exists only to do the gated thing. No money is
recomputed — see ``FinanceService.amend_sale_type``.
 * @summary Amend Sale Type
 */
export const getAmendSaleTypeApiFinanceSalesSaleIdSaleTypePatchUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/sale-type`
}

export const amendSaleTypeApiFinanceSalesSaleIdSaleTypePatch = async (saleId: string,
    saleTypeAmendRequest: SaleTypeAmendRequest, options?: RequestInit): Promise<SaleResponse> => {
  
  return apiFetch<SaleResponse>(getAmendSaleTypeApiFinanceSalesSaleIdSaleTypePatchUrl(saleId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saleTypeAmendRequest,)
  }
);}



/**
 * N-02 — the customer drawer's Invoices tab: every sale for the customer,
with whether each can be voided (R5-27) and whether a void is pending.
 * @summary List Customer Invoices
 */
export const getListCustomerInvoicesApiFinanceCustomersCustomerIdInvoicesGetUrl = (customerId: string,) => {


  

  return `/api/finance/customers/${customerId}/invoices`
}

export const listCustomerInvoicesApiFinanceCustomersCustomerIdInvoicesGet = async (customerId: string, options?: RequestInit): Promise<CustomerInvoiceListResponse> => {
  
  return apiFetch<CustomerInvoiceListResponse>(getListCustomerInvoicesApiFinanceCustomersCustomerIdInvoicesGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Void Sale
 */
export const getVoidSaleApiFinanceSalesSaleIdVoidPostUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/void`
}

export const voidSaleApiFinanceSalesSaleIdVoidPost = async (saleId: string,
    saleVoidRequest: SaleVoidRequest, options?: RequestInit): Promise<SaleResponse> => {
  
  return apiFetch<SaleResponse>(getVoidSaleApiFinanceSalesSaleIdVoidPostUrl(saleId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saleVoidRequest,)
  }
);}



/**
 * @summary Get Pricing
 */
export const getGetPricingApiFinancePricingGetUrl = (params?: GetPricingApiFinancePricingGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/pricing?${stringifiedParams}` : `/api/finance/pricing`
}

export const getPricingApiFinancePricingGet = async (params?: GetPricingApiFinancePricingGetParams, options?: RequestInit): Promise<PricingResponse> => {
  
  return apiFetch<PricingResponse>(getGetPricingApiFinancePricingGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Ihip Alerts
 */
export const getListIhipAlertsApiFinanceIhipAlertsGetUrl = (params?: ListIhipAlertsApiFinanceIhipAlertsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/ihip/alerts?${stringifiedParams}` : `/api/finance/ihip/alerts`
}

export const listIhipAlertsApiFinanceIhipAlertsGet = async (params?: ListIhipAlertsApiFinanceIhipAlertsGetParams, options?: RequestInit): Promise<IHIPAlertListResponse> => {
  
  return apiFetch<IHIPAlertListResponse>(getListIhipAlertsApiFinanceIhipAlertsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Preview Ihip Schedule
 */
export const getPreviewIhipScheduleApiFinanceIhipSchedulePreviewGetUrl = (params: PreviewIhipScheduleApiFinanceIhipSchedulePreviewGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/ihip/schedule-preview?${stringifiedParams}` : `/api/finance/ihip/schedule-preview`
}

export const previewIhipScheduleApiFinanceIhipSchedulePreviewGet = async (params: PreviewIhipScheduleApiFinanceIhipSchedulePreviewGetParams, options?: RequestInit): Promise<IHIPSchedulePreviewResponse> => {
  
  return apiFetch<IHIPSchedulePreviewResponse>(getPreviewIhipScheduleApiFinanceIhipSchedulePreviewGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Ihip Plan
 */
export const getGetIhipPlanApiFinanceIhipPackageIdGetUrl = (packageId: string,) => {


  

  return `/api/finance/ihip/${packageId}`
}

export const getIhipPlanApiFinanceIhipPackageIdGet = async (packageId: string, options?: RequestInit): Promise<IHIPPlanResponse> => {
  
  return apiFetch<IHIPPlanResponse>(getGetIhipPlanApiFinanceIhipPackageIdGetUrl(packageId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Collect Installment
 */
export const getCollectInstallmentApiFinanceIhipPackageIdCollectPostUrl = (packageId: string,) => {


  

  return `/api/finance/ihip/${packageId}/collect`
}

export const collectInstallmentApiFinanceIhipPackageIdCollectPost = async (packageId: string,
    iHIPCollectRequest: IHIPCollectRequest, options?: RequestInit): Promise<PaymentResponse> => {
  
  return apiFetch<PaymentResponse>(getCollectInstallmentApiFinanceIhipPackageIdCollectPostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      iHIPCollectRequest,)
  }
);}



/**
 * @summary Check Firewall
 */
export const getCheckFirewallApiFinanceIhipPackageIdFirewallGetUrl = (packageId: string,
    params?: CheckFirewallApiFinanceIhipPackageIdFirewallGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/ihip/${packageId}/firewall?${stringifiedParams}` : `/api/finance/ihip/${packageId}/firewall`
}

export const checkFirewallApiFinanceIhipPackageIdFirewallGet = async (packageId: string,
    params?: CheckFirewallApiFinanceIhipPackageIdFirewallGetParams, options?: RequestInit): Promise<FirewallCheckResponse> => {
  
  return apiFetch<FirewallCheckResponse>(getCheckFirewallApiFinanceIhipPackageIdFirewallGetUrl(packageId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Credit Balance
 */
export const getGetCreditBalanceApiFinanceCreditsCustomerIdGetUrl = (customerId: string,) => {


  

  return `/api/finance/credits/${customerId}`
}

export const getCreditBalanceApiFinanceCreditsCustomerIdGet = async (customerId: string, options?: RequestInit): Promise<CreditBalanceResponse> => {
  
  return apiFetch<CreditBalanceResponse>(getGetCreditBalanceApiFinanceCreditsCustomerIdGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Earn Credit
 */
export const getEarnCreditApiFinanceCreditsCustomerIdEarnPostUrl = (customerId: string,) => {


  

  return `/api/finance/credits/${customerId}/earn`
}

export const earnCreditApiFinanceCreditsCustomerIdEarnPost = async (customerId: string,
    creditEarnCreate: CreditEarnCreate, options?: RequestInit): Promise<CreditLedgerResponse> => {
  
  return apiFetch<CreditLedgerResponse>(getEarnCreditApiFinanceCreditsCustomerIdEarnPostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      creditEarnCreate,)
  }
);}



/**
 * @summary Validate Redemption
 */
export const getValidateRedemptionApiFinanceCreditsCustomerIdRedeemValidatePostUrl = (customerId: string,) => {


  

  return `/api/finance/credits/${customerId}/redeem/validate`
}

export const validateRedemptionApiFinanceCreditsCustomerIdRedeemValidatePost = async (customerId: string,
    creditRedeemDraft: CreditRedeemDraft, options?: RequestInit): Promise<CreditRedeemValidationResponse> => {
  
  return apiFetch<CreditRedeemValidationResponse>(getValidateRedemptionApiFinanceCreditsCustomerIdRedeemValidatePostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      creditRedeemDraft,)
  }
);}



/**
 * @summary Upgrade Quote
 */
export const getUpgradeQuoteApiFinancePackagesPackageIdUpgradeQuotePostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/upgrade/quote`
}

export const upgradeQuoteApiFinancePackagesPackageIdUpgradeQuotePost = async (packageId: string,
    upgradeQuoteRequest: UpgradeQuoteRequest, options?: RequestInit): Promise<UpgradeQuoteResponse> => {
  
  return apiFetch<UpgradeQuoteResponse>(getUpgradeQuoteApiFinancePackagesPackageIdUpgradeQuotePostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upgradeQuoteRequest,)
  }
);}



/**
 * @summary Upgrade Package
 */
export const getUpgradePackageApiFinancePackagesPackageIdUpgradePostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/upgrade`
}

export const upgradePackageApiFinancePackagesPackageIdUpgradePost = async (packageId: string,
    upgradeRequest: UpgradeRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getUpgradePackageApiFinancePackagesPackageIdUpgradePostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upgradeRequest,)
  }
);}



/**
 * @summary Submit Change
 */
export const getSubmitChangeApiFinancePackagesPackageIdChangePostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/change`
}

export const submitChangeApiFinancePackagesPackageIdChangePost = async (packageId: string,
    changeRequest: ChangeRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getSubmitChangeApiFinancePackagesPackageIdChangePostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changeRequest,)
  }
);}



/**
 * @summary Refund Quote
 */
export const getRefundQuoteApiFinancePackagesPackageIdRefundQuotePostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/refund/quote`
}

export const refundQuoteApiFinancePackagesPackageIdRefundQuotePost = async (packageId: string,
    refundQuoteApiFinancePackagesPackageIdRefundQuotePostBody: RefundQuoteApiFinancePackagesPackageIdRefundQuotePostBody, options?: RequestInit): Promise<RefundQuoteResponse> => {
  
  return apiFetch<RefundQuoteResponse>(getRefundQuoteApiFinancePackagesPackageIdRefundQuotePostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refundQuoteApiFinancePackagesPackageIdRefundQuotePostBody,)
  }
);}



/**
 * @summary Submit Refund
 */
export const getSubmitRefundApiFinancePackagesPackageIdRefundPostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/refund`
}

export const submitRefundApiFinancePackagesPackageIdRefundPost = async (packageId: string,
    refundRequest: RefundRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getSubmitRefundApiFinancePackagesPackageIdRefundPostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refundRequest,)
  }
);}



/**
 * D23-8 — the quote for refunding several treatments of one invoice.
 * @summary Group Refund Quote
 */
export const getGroupRefundQuoteApiFinanceRefundsGroupQuotePostUrl = () => {


  

  return `/api/finance/refunds/group/quote`
}

export const groupRefundQuoteApiFinanceRefundsGroupQuotePost = async (groupRefundQuoteRequest: GroupRefundQuoteRequest, options?: RequestInit): Promise<GroupRefundQuoteResponse> => {
  
  return apiFetch<GroupRefundQuoteResponse>(getGroupRefundQuoteApiFinanceRefundsGroupQuotePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      groupRefundQuoteRequest,)
  }
);}



/**
 * D23-8 — submit the refund of several treatments of one invoice as one
request for one approval (same permission as a single refund).
 * @summary Submit Group Refund
 */
export const getSubmitGroupRefundApiFinanceRefundsGroupPostUrl = () => {


  

  return `/api/finance/refunds/group`
}

export const submitGroupRefundApiFinanceRefundsGroupPost = async (groupRefundRequest: GroupRefundRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getSubmitGroupRefundApiFinanceRefundsGroupPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      groupRefundRequest,)
  }
);}



/**
 * R5-37 — current expiry + the one-time free extension tier. No write.
 * @summary Extension Quote
 */
export const getExtensionQuoteApiFinancePackagesPackageIdExtensionQuoteGetUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/extension/quote`
}

export const extensionQuoteApiFinancePackagesPackageIdExtensionQuoteGet = async (packageId: string, options?: RequestInit): Promise<ExtensionQuoteResponse> => {
  
  return apiFetch<ExtensionQuoteResponse>(getExtensionQuoteApiFinancePackagesPackageIdExtensionQuoteGetUrl(packageId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * R5-37-41 — submit a PENDING Expiry Extension (applied on approval).
 * @summary Submit Extension
 */
export const getSubmitExtensionApiFinancePackagesPackageIdExtensionPostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/extension`
}

export const submitExtensionApiFinancePackagesPackageIdExtensionPost = async (packageId: string,
    extensionRequest: ExtensionRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getSubmitExtensionApiFinancePackagesPackageIdExtensionPostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extensionRequest,)
  }
);}



/**
 * GEN-03 / LEA-29 — may she have the trial price, and did she buy one before?
 * @summary Get Trial Status
 */
export const getGetTrialStatusApiFinanceCustomersCustomerIdTrialStatusGetUrl = (customerId: string,) => {


  

  return `/api/finance/customers/${customerId}/trial-status`
}

export const getTrialStatusApiFinanceCustomersCustomerIdTrialStatusGet = async (customerId: string, options?: RequestInit): Promise<TrialStatusResponse> => {
  
  return apiFetch<TrialStatusResponse>(getGetTrialStatusApiFinanceCustomersCustomerIdTrialStatusGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-28 — Package Holder Transfer request, straight to HQ (moved on approval).
 * @summary Submit Transfer
 */
export const getSubmitTransferApiFinancePackagesPackageIdTransferPostUrl = (packageId: string,) => {


  

  return `/api/finance/packages/${packageId}/transfer`
}

export const submitTransferApiFinancePackagesPackageIdTransferPost = async (packageId: string,
    transferRequest: TransferRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getSubmitTransferApiFinancePackagesPackageIdTransferPostUrl(packageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transferRequest,)
  }
);}



/**
 * R5-38 — store one supporting document (photo/PDF) for a POS request
form and return the URL the form submits with.
 * @summary Upload Finance Attachment
 */
export const getUploadFinanceAttachmentApiFinanceAttachmentsPostUrl = () => {


  

  return `/api/finance/attachments`
}

export const uploadFinanceAttachmentApiFinanceAttachmentsPost = async (bodyUploadFinanceAttachmentApiFinanceAttachmentsPost: BodyUploadFinanceAttachmentApiFinanceAttachmentsPost, options?: RequestInit): Promise<AttachmentUploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadFinanceAttachmentApiFinanceAttachmentsPost.file)

  return apiFetch<AttachmentUploadResponse>(getUploadFinanceAttachmentApiFinanceAttachmentsPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary Get Finance Attachment
 */
export const getGetFinanceAttachmentApiFinanceAttachmentsFilenameGetUrl = (filename: string,) => {


  

  return `/api/finance/attachments/${filename}`
}

export const getFinanceAttachmentApiFinanceAttachmentsFilenameGet = async (filename: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getGetFinanceAttachmentApiFinanceAttachmentsFilenameGetUrl(filename),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Package Changes
 */
export const getListPackageChangesApiFinancePackageChangesGetUrl = (params?: ListPackageChangesApiFinancePackageChangesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/package-changes?${stringifiedParams}` : `/api/finance/package-changes`
}

export const listPackageChangesApiFinancePackageChangesGet = async (params?: ListPackageChangesApiFinancePackageChangesGetParams, options?: RequestInit): Promise<PackageChangeListResponse> => {
  
  return apiFetch<PackageChangeListResponse>(getListPackageChangesApiFinancePackageChangesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Approve Package Change
 */
export const getApprovePackageChangeApiFinancePackageChangesChangeIdApprovePostUrl = (changeId: string,) => {


  

  return `/api/finance/package-changes/${changeId}/approve`
}

export const approvePackageChangeApiFinancePackageChangesChangeIdApprovePost = async (changeId: string,
    approvalRequest: ApprovalRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getApprovePackageChangeApiFinancePackageChangesChangeIdApprovePostUrl(changeId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvalRequest,)
  }
);}



/**
 * @summary Reject Package Change
 */
export const getRejectPackageChangeApiFinancePackageChangesChangeIdRejectPostUrl = (changeId: string,) => {


  

  return `/api/finance/package-changes/${changeId}/reject`
}

export const rejectPackageChangeApiFinancePackageChangesChangeIdRejectPost = async (changeId: string,
    approvalRequest: ApprovalRequest, options?: RequestInit): Promise<PackageChangeResponse> => {
  
  return apiFetch<PackageChangeResponse>(getRejectPackageChangeApiFinancePackageChangesChangeIdRejectPostUrl(changeId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvalRequest,)
  }
);}



/**
 * @summary Get Daily Close
 */
export const getGetDailyCloseApiFinanceDailyCloseGetUrl = (params: GetDailyCloseApiFinanceDailyCloseGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/daily-close?${stringifiedParams}` : `/api/finance/daily-close`
}

export const getDailyCloseApiFinanceDailyCloseGet = async (params: GetDailyCloseApiFinanceDailyCloseGetParams, options?: RequestInit): Promise<DailyCloseResponse> => {
  
  return apiFetch<DailyCloseResponse>(getGetDailyCloseApiFinanceDailyCloseGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Daily Close
 */
export const getUpsertDailyCloseApiFinanceDailyClosePostUrl = () => {


  

  return `/api/finance/daily-close`
}

export const upsertDailyCloseApiFinanceDailyClosePost = async (dailyCloseCreate: DailyCloseCreate, options?: RequestInit): Promise<DailyCloseResponse> => {
  
  return apiFetch<DailyCloseResponse>(getUpsertDailyCloseApiFinanceDailyClosePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dailyCloseCreate,)
  }
);}



/**
 * @summary Get Net Sales
 */
export const getGetNetSalesApiFinanceNetSalesGetUrl = (params: GetNetSalesApiFinanceNetSalesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/net-sales?${stringifiedParams}` : `/api/finance/net-sales`
}

export const getNetSalesApiFinanceNetSalesGet = async (params: GetNetSalesApiFinanceNetSalesGetParams, options?: RequestInit): Promise<NetSalesResponse> => {
  
  return apiFetch<NetSalesResponse>(getGetNetSalesApiFinanceNetSalesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Rules
 */
export const getListRulesApiFinanceRulesGetUrl = (params?: ListRulesApiFinanceRulesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/rules?${stringifiedParams}` : `/api/finance/rules`
}

export const listRulesApiFinanceRulesGet = async (params?: ListRulesApiFinanceRulesGetParams, options?: RequestInit): Promise<FinanceRuleListResponse> => {
  
  return apiFetch<FinanceRuleListResponse>(getListRulesApiFinanceRulesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Rule
 */
export const getCreateRuleApiFinanceRulesPostUrl = () => {


  

  return `/api/finance/rules`
}

export const createRuleApiFinanceRulesPost = async (financeRuleCreate: FinanceRuleCreate, options?: RequestInit): Promise<FinanceRuleResponse> => {
  
  return apiFetch<FinanceRuleResponse>(getCreateRuleApiFinanceRulesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      financeRuleCreate,)
  }
);}



/**
 * @summary Update Rule
 */
export const getUpdateRuleApiFinanceRulesRuleIdPatchUrl = (ruleId: string,) => {


  

  return `/api/finance/rules/${ruleId}`
}

export const updateRuleApiFinanceRulesRuleIdPatch = async (ruleId: string,
    financeRuleUpdate: FinanceRuleUpdate, options?: RequestInit): Promise<FinanceRuleResponse> => {
  
  return apiFetch<FinanceRuleResponse>(getUpdateRuleApiFinanceRulesRuleIdPatchUrl(ruleId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      financeRuleUpdate,)
  }
);}



/**
 * @summary Pull Cashier
 */
export const getPullCashierApiFinanceDailyCloseCloseIdPullCashierPostUrl = (closeId: string,) => {


  

  return `/api/finance/daily-close/${closeId}/pull-cashier`
}

export const pullCashierApiFinanceDailyCloseCloseIdPullCashierPost = async (closeId: string, options?: RequestInit): Promise<DailyCloseResponse> => {
  
  return apiFetch<DailyCloseResponse>(getPullCashierApiFinanceDailyCloseCloseIdPullCashierPostUrl(closeId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Xero Outbox
 */
export const getListXeroOutboxApiFinanceXeroOutboxGetUrl = (params?: ListXeroOutboxApiFinanceXeroOutboxGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/xero/outbox?${stringifiedParams}` : `/api/finance/xero/outbox`
}

export const listXeroOutboxApiFinanceXeroOutboxGet = async (params?: ListXeroOutboxApiFinanceXeroOutboxGetParams, options?: RequestInit): Promise<XeroOutboxListResponse> => {
  
  return apiFetch<XeroOutboxListResponse>(getListXeroOutboxApiFinanceXeroOutboxGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Sync Xero
 */
export const getSyncXeroApiFinanceXeroSyncPostUrl = () => {


  

  return `/api/finance/xero/sync`
}

export const syncXeroApiFinanceXeroSyncPost = async (xeroSyncRequest: XeroSyncRequest, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getSyncXeroApiFinanceXeroSyncPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      xeroSyncRequest,)
  }
);}



/**
 * @summary Utilization Report
 */
export const getUtilizationReportApiFinanceReportsUtilizationGetUrl = (params?: UtilizationReportApiFinanceReportsUtilizationGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/utilization?${stringifiedParams}` : `/api/finance/reports/utilization`
}

export const utilizationReportApiFinanceReportsUtilizationGet = async (params?: UtilizationReportApiFinanceReportsUtilizationGetParams, options?: RequestInit): Promise<UtilizationReportResponse> => {
  
  return apiFetch<UtilizationReportResponse>(getUtilizationReportApiFinanceReportsUtilizationGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Ltv Capture
 */
export const getLtvCaptureApiFinanceReportsLtvGetUrl = (params?: LtvCaptureApiFinanceReportsLtvGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/ltv?${stringifiedParams}` : `/api/finance/reports/ltv`
}

export const ltvCaptureApiFinanceReportsLtvGet = async (params?: LtvCaptureApiFinanceReportsLtvGetParams, options?: RequestInit): Promise<LTVCaptureResponse> => {
  
  return apiFetch<LTVCaptureResponse>(getLtvCaptureApiFinanceReportsLtvGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The customer's ACTIVE packages that still have sessions left — what the
Create Usage picker can deduct from.
 * @summary Get Customer Balances
 */
export const getGetCustomerBalancesApiFinancePackagesCustomerIdBalancesGetUrl = (customerId: string,) => {


  

  return `/api/finance/packages/${customerId}/balances`
}

export const getCustomerBalancesApiFinancePackagesCustomerIdBalancesGet = async (customerId: string, options?: RequestInit): Promise<CustomerBalancesResponse> => {
  
  return apiFetch<CustomerBalancesResponse>(getGetCustomerBalancesApiFinancePackagesCustomerIdBalancesGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Record a manual utilisation and deduct the sessions. Atomic: any invalid
line aborts the whole usage, so a partial deduction can't be committed.
 * @summary Create Usage
 */
export const getCreateUsageApiFinanceUsagesPostUrl = () => {


  

  return `/api/finance/usages`
}

export const createUsageApiFinanceUsagesPost = async (usageCreate: UsageCreate, options?: RequestInit): Promise<UsageResponse> => {
  
  return apiFetch<UsageResponse>(getCreateUsageApiFinanceUsagesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      usageCreate,)
  }
);}



/**
 * @summary List Usages
 */
export const getListUsagesApiFinanceUsagesGetUrl = (params?: ListUsagesApiFinanceUsagesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/usages?${stringifiedParams}` : `/api/finance/usages`
}

export const listUsagesApiFinanceUsagesGet = async (params?: ListUsagesApiFinanceUsagesGetParams, options?: RequestInit): Promise<UsageListResponse> => {
  
  return apiFetch<UsageListResponse>(getListUsagesApiFinanceUsagesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-12-04 — the Remarks list for voiding a usage.
 * @summary Usage Void Reasons
 */
export const getUsageVoidReasonsApiFinanceUsagesVoidReasonsGetUrl = () => {


  

  return `/api/finance/usages/void-reasons`
}

export const usageVoidReasonsApiFinanceUsagesVoidReasonsGet = async ( options?: RequestInit): Promise<UsageVoidReasons> => {
  
  return apiFetch<UsageVoidReasons>(getUsageVoidReasonsApiFinanceUsagesVoidReasonsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-12 — send a usage void to HQ (Sales > Approvals, type Void Usage).
 * @summary Request Usage Void
 */
export const getRequestUsageVoidApiFinanceUsagesUsageIdVoidRequestPostUrl = (usageId: string,) => {


  

  return `/api/finance/usages/${usageId}/void-request`
}

export const requestUsageVoidApiFinanceUsagesUsageIdVoidRequestPost = async (usageId: string,
    usageVoidRequest: UsageVoidRequest, options?: RequestInit): Promise<UsageResponse> => {
  
  return apiFetch<UsageResponse>(getRequestUsageVoidApiFinanceUsagesUsageIdVoidRequestPostUrl(usageId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      usageVoidRequest,)
  }
);}



/**
 * OPS-12-08 — change a usage's date, remarks and step therapists. A step's
therapist (and so its commission) is changed by HQ or an admin only.
 * @summary Edit Usage
 */
export const getEditUsageApiFinanceUsagesUsageIdPatchUrl = (usageId: string,) => {


  

  return `/api/finance/usages/${usageId}`
}

export const editUsageApiFinanceUsagesUsageIdPatch = async (usageId: string,
    usageEdit: UsageEdit, options?: RequestInit): Promise<UsageResponse> => {
  
  return apiFetch<UsageResponse>(getEditUsageApiFinanceUsagesUsageIdPatchUrl(usageId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      usageEdit,)
  }
);}



/**
 * @summary Get Usage
 */
export const getGetUsageApiFinanceUsagesUsageIdGetUrl = (usageId: string,) => {


  

  return `/api/finance/usages/${usageId}`
}

export const getUsageApiFinanceUsagesUsageIdGet = async (usageId: string, options?: RequestInit): Promise<UsageResponse> => {
  
  return apiFetch<UsageResponse>(getGetUsageApiFinanceUsagesUsageIdGetUrl(usageId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Every COMPLETED invoice of this customer with money still owing.
 * @summary Get Outstanding Sales
 */
export const getGetOutstandingSalesApiFinanceSalesCustomerIdOutstandingGetUrl = (customerId: string,) => {


  

  return `/api/finance/sales/${customerId}/outstanding`
}

export const getOutstandingSalesApiFinanceSalesCustomerIdOutstandingGet = async (customerId: string, options?: RequestInit): Promise<OutstandingSalesListResponse> => {
  
  return apiFetch<OutstandingSalesListResponse>(getGetOutstandingSalesApiFinanceSalesCustomerIdOutstandingGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Post Balance Payment
 */
export const getPostBalancePaymentApiFinanceBalancePaymentsPostUrl = () => {


  

  return `/api/finance/balance-payments`
}

export const postBalancePaymentApiFinanceBalancePaymentsPost = async (balancePaymentCreate: BalancePaymentCreate, options?: RequestInit): Promise<BalancePaymentResponse> => {
  
  return apiFetch<BalancePaymentResponse>(getPostBalancePaymentApiFinanceBalancePaymentsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      balancePaymentCreate,)
  }
);}



/**
 * Issue or redeem store credit as a numbered ``CN-YYYYMMDD-NNN`` document.
 * @summary Create Credit Note
 */
export const getCreateCreditNoteApiFinanceCreditNotesPostUrl = () => {


  

  return `/api/finance/credit-notes`
}

export const createCreditNoteApiFinanceCreditNotesPost = async (creditNoteCreate: CreditNoteCreate, options?: RequestInit): Promise<CreditNoteResponse> => {
  
  return apiFetch<CreditNoteResponse>(getCreateCreditNoteApiFinanceCreditNotesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      creditNoteCreate,)
  }
);}



/**
 * Newest-first, optionally narrowed by customer, type (ISSUE / REVOKE /
REDEEM), issued-date window (``endDate`` inclusive of the whole day),
credit note number and customer name (any part), outlet, credit note type
and status AVAILABLE / USED_UP / EXPIRED / REVOKED (SAL-40-02). An outlet
sign-in only ever sees its own outlet on the search (SAL-40-01).
 * @summary List Credit Notes
 */
export const getListCreditNotesApiFinanceCreditNotesGetUrl = (params?: ListCreditNotesApiFinanceCreditNotesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/credit-notes?${stringifiedParams}` : `/api/finance/credit-notes`
}

export const listCreditNotesApiFinanceCreditNotesGet = async (params?: ListCreditNotesApiFinanceCreditNotesGetParams, options?: RequestInit): Promise<CreditNoteListResponse> => {
  
  return apiFetch<CreditNoteListResponse>(getListCreditNotesApiFinanceCreditNotesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-40-07 - Export Excel of exactly the rows the search shows (same
filters, same outlet scoping). Read only; no phone numbers.
 * @summary Export Credit Notes
 */
export const getExportCreditNotesApiFinanceCreditNotesExportGetUrl = (params?: ExportCreditNotesApiFinanceCreditNotesExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/credit-notes/export?${stringifiedParams}` : `/api/finance/credit-notes/export`
}

export const exportCreditNotesApiFinanceCreditNotesExportGet = async (params?: ExportCreditNotesApiFinanceCreditNotesExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportCreditNotesApiFinanceCreditNotesExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-17-11 / SAL-38-03 — the customer's credit notes with money left,
oldest expiry first, and their total ('Available Credit Notes').
 * @summary Customer Credit Note Balances
 */
export const getCustomerCreditNoteBalancesApiFinanceCreditNotesBalancesGetUrl = (params: CustomerCreditNoteBalancesApiFinanceCreditNotesBalancesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/credit-notes/balances?${stringifiedParams}` : `/api/finance/credit-notes/balances`
}

export const customerCreditNoteBalancesApiFinanceCreditNotesBalancesGet = async (params: CustomerCreditNoteBalancesApiFinanceCreditNotesBalancesGetParams, options?: RequestInit): Promise<CustomerCreditNoteBalanceList> => {
  
  return apiFetch<CustomerCreditNoteBalanceList>(getCustomerCreditNoteBalancesApiFinanceCreditNotesBalancesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Credit Note
 */
export const getGetCreditNoteApiFinanceCreditNotesCreditNoteIdGetUrl = (creditNoteId: string,) => {


  

  return `/api/finance/credit-notes/${creditNoteId}`
}

export const getCreditNoteApiFinanceCreditNotesCreditNoteIdGet = async (creditNoteId: string, options?: RequestInit): Promise<CreditNoteResponse> => {
  
  return apiFetch<CreditNoteResponse>(getGetCreditNoteApiFinanceCreditNotesCreditNoteIdGetUrl(creditNoteId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * R5-48/49/50 — pending (oldest first) or completed history (newest
first), filterable by category, raised-date window and outlet.
 * @summary List Approval Requests
 */
export const getListApprovalRequestsApiFinanceApprovalRequestsGetUrl = (params?: ListApprovalRequestsApiFinanceApprovalRequestsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/approval-requests?${stringifiedParams}` : `/api/finance/approval-requests`
}

export const listApprovalRequestsApiFinanceApprovalRequestsGet = async (params?: ListApprovalRequestsApiFinanceApprovalRequestsGetParams, options?: RequestInit): Promise<ApprovalRequestListResponse> => {
  
  return apiFetch<ApprovalRequestListResponse>(getListApprovalRequestsApiFinanceApprovalRequestsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * R5-51 — the dashboard box: raised this week + awaiting the caller.
 * @summary Approval Summary
 */
export const getApprovalSummaryApiFinanceApprovalRequestsSummaryGetUrl = () => {


  

  return `/api/finance/approval-requests/summary`
}

export const approvalSummaryApiFinanceApprovalRequestsSummaryGet = async ( options?: RequestInit): Promise<ApprovalSummaryResponse> => {
  
  return apiFetch<ApprovalSummaryResponse>(getApprovalSummaryApiFinanceApprovalRequestsSummaryGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Approve Request
 */
export const getApproveRequestApiFinanceApprovalRequestsRequestIdApprovePostUrl = (requestId: string,) => {


  

  return `/api/finance/approval-requests/${requestId}/approve`
}

export const approveRequestApiFinanceApprovalRequestsRequestIdApprovePost = async (requestId: string,
    approvalDecision: ApprovalDecision, options?: RequestInit): Promise<ApprovalRequestResponse> => {
  
  return apiFetch<ApprovalRequestResponse>(getApproveRequestApiFinanceApprovalRequestsRequestIdApprovePostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvalDecision,)
  }
);}



/**
 * @summary Reject Request
 */
export const getRejectRequestApiFinanceApprovalRequestsRequestIdRejectPostUrl = (requestId: string,) => {


  

  return `/api/finance/approval-requests/${requestId}/reject`
}

export const rejectRequestApiFinanceApprovalRequestsRequestIdRejectPost = async (requestId: string,
    approvalDecision: ApprovalDecision, options?: RequestInit): Promise<ApprovalRequestResponse> => {
  
  return apiFetch<ApprovalRequestResponse>(getRejectRequestApiFinanceApprovalRequestsRequestIdRejectPostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approvalDecision,)
  }
);}



/**
 * SAL-13-04 step 6 — HQ hands back the money paid on a voided invoice as a
refund (recorded), a credit note (issued at once), or both.
 * @summary Settle Void
 */
export const getSettleVoidApiFinanceApprovalRequestsRequestIdVoidSettlementPostUrl = (requestId: string,) => {


  

  return `/api/finance/approval-requests/${requestId}/void-settlement`
}

export const settleVoidApiFinanceApprovalRequestsRequestIdVoidSettlementPost = async (requestId: string,
    voidSettlementRequest: VoidSettlementRequest, options?: RequestInit): Promise<ApprovalRequestResponse> => {
  
  return apiFetch<ApprovalRequestResponse>(getSettleVoidApiFinanceApprovalRequestsRequestIdVoidSettlementPostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidSettlementRequest,)
  }
);}



/**
 * R5-47 — ask HQ to void an invoice (void is HQ-only).
 * @summary Request Void
 */
export const getRequestVoidApiFinanceSalesSaleIdVoidRequestPostUrl = (saleId: string,) => {


  

  return `/api/finance/sales/${saleId}/void-request`
}

export const requestVoidApiFinanceSalesSaleIdVoidRequestPost = async (saleId: string,
    voidRequestCreate: VoidRequestCreate, options?: RequestInit): Promise<ApprovalRequestResponse> => {
  
  return apiFetch<ApprovalRequestResponse>(getRequestVoidApiFinanceSalesSaleIdVoidRequestPostUrl(saleId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidRequestCreate,)
  }
);}



/**
 * The customer's ACTIVE packages with sessions (and value) left to trade.
 * @summary List Contra Eligible Packages
 */
export const getListContraEligiblePackagesApiFinancePackagesCustomerIdContraEligibleGetUrl = (customerId: string,) => {


  

  return `/api/finance/packages/${customerId}/contra-eligible`
}

export const listContraEligiblePackagesApiFinancePackagesCustomerIdContraEligibleGet = async (customerId: string, options?: RequestInit): Promise<ContraEligiblePackageListResponse> => {
  
  return apiFetch<ContraEligiblePackageListResponse>(getListContraEligiblePackagesApiFinancePackagesCustomerIdContraEligibleGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Contra Sale
 */
export const getCreateContraSaleApiFinanceSalesContraPostUrl = () => {


  

  return `/api/finance/sales/contra`
}

export const createContraSaleApiFinanceSalesContraPost = async (contraSaleCreate: ContraSaleCreate, options?: RequestInit): Promise<ContraSaleResponse> => {
  
  return apiFetch<ContraSaleResponse>(getCreateContraSaleApiFinanceSalesContraPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contraSaleCreate,)
  }
);}



/**
 * The customer's ACTIVE packages that still have sessions left, each priced
per session so the form can show the carry-over value before it is chosen.
 * @summary List Upgrade Eligible
 */
export const getListUpgradeEligibleApiFinancePackagesCustomerIdUpgradeEligibleGetUrl = (customerId: string,) => {


  

  return `/api/finance/packages/${customerId}/upgrade-eligible`
}

export const listUpgradeEligibleApiFinancePackagesCustomerIdUpgradeEligibleGet = async (customerId: string, options?: RequestInit): Promise<UpgradeEligiblePackageListResponse> => {
  
  return apiFetch<UpgradeEligiblePackageListResponse>(getListUpgradeEligibleApiFinancePackagesCustomerIdUpgradeEligibleGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Ring up a new invoice that credits unused value from an existing package.
 * @summary Create Upgrade Invoice
 */
export const getCreateUpgradeInvoiceApiFinanceSalesUpgradeInvoicePostUrl = () => {


  

  return `/api/finance/sales/upgrade-invoice`
}

export const createUpgradeInvoiceApiFinanceSalesUpgradeInvoicePost = async (upgradeInvoiceCreate: UpgradeInvoiceCreate, options?: RequestInit): Promise<UpgradeInvoiceResponse> => {
  
  return apiFetch<UpgradeInvoiceResponse>(getCreateUpgradeInvoiceApiFinanceSalesUpgradeInvoicePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upgradeInvoiceCreate,)
  }
);}



/**
 * @summary Get Returnable Products
 */
export const getGetReturnableProductsApiFinanceProductReturnsReturnableGetUrl = (params: GetReturnableProductsApiFinanceProductReturnsReturnableGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/product-returns/returnable?${stringifiedParams}` : `/api/finance/product-returns/returnable`
}

export const getReturnableProductsApiFinanceProductReturnsReturnableGet = async (params: GetReturnableProductsApiFinanceProductReturnsReturnableGetParams, options?: RequestInit): Promise<ReturnableProductsResponse> => {
  
  return apiFetch<ReturnableProductsResponse>(getGetReturnableProductsApiFinanceProductReturnsReturnableGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Product Return
 */
export const getCreateProductReturnApiFinanceProductReturnsPostUrl = () => {


  

  return `/api/finance/product-returns`
}

export const createProductReturnApiFinanceProductReturnsPost = async (productReturnCreate: ProductReturnCreate, options?: RequestInit): Promise<ProductReturnResponse> => {
  
  return apiFetch<ProductReturnResponse>(getCreateProductReturnApiFinanceProductReturnsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productReturnCreate,)
  }
);}



/**
 * @summary Get Product Return For Approval
 */
export const getGetProductReturnForApprovalApiFinanceProductReturnsByApprovalApprovalRequestIdGetUrl = (approvalRequestId: string,) => {


  

  return `/api/finance/product-returns/by-approval/${approvalRequestId}`
}

export const getProductReturnForApprovalApiFinanceProductReturnsByApprovalApprovalRequestIdGet = async (approvalRequestId: string, options?: RequestInit): Promise<ProductReturnResponse> => {
  
  return apiFetch<ProductReturnResponse>(getGetProductReturnForApprovalApiFinanceProductReturnsByApprovalApprovalRequestIdGetUrl(approvalRequestId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Set Product Return Restock
 */
export const getSetProductReturnRestockApiFinanceProductReturnsReturnIdRestockPutUrl = (returnId: string,) => {


  

  return `/api/finance/product-returns/${returnId}/restock`
}

export const setProductReturnRestockApiFinanceProductReturnsReturnIdRestockPut = async (returnId: string,
    restockDecision: RestockDecision, options?: RequestInit): Promise<ProductReturnResponse> => {
  
  return apiFetch<ProductReturnResponse>(getSetProductReturnRestockApiFinanceProductReturnsReturnIdRestockPutUrl(returnId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      restockDecision,)
  }
);}



/**
 * @summary Get Sales By Customer
 */
export const getGetSalesByCustomerApiFinanceReportsSalesByCustomerGetUrl = (params?: GetSalesByCustomerApiFinanceReportsSalesByCustomerGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/sales-by-customer?${stringifiedParams}` : `/api/finance/reports/sales-by-customer`
}

export const getSalesByCustomerApiFinanceReportsSalesByCustomerGet = async (params?: GetSalesByCustomerApiFinanceReportsSalesByCustomerGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetSalesByCustomerApiFinanceReportsSalesByCustomerGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Collection By Payment Types
 */
export const getGetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetUrl = (params?: GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/collection-by-payment-types?${stringifiedParams}` : `/api/finance/reports/collection-by-payment-types`
}

export const getCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGet = async (params?: GetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetCollectionByPaymentTypesApiFinanceReportsCollectionByPaymentTypesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Collection By Customer
 */
export const getGetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetUrl = (params?: GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/collection-by-customer?${stringifiedParams}` : `/api/finance/reports/collection-by-customer`
}

export const getCollectionByCustomerApiFinanceReportsCollectionByCustomerGet = async (params?: GetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetCollectionByCustomerApiFinanceReportsCollectionByCustomerGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Treatment Done By Outlets
 */
export const getGetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetUrl = (params?: GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/treatment-done-by-outlets?${stringifiedParams}` : `/api/finance/reports/treatment-done-by-outlets`
}

export const getTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGet = async (params?: GetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetTreatmentDoneByOutletsApiFinanceReportsTreatmentDoneByOutletsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Conversion
 */
export const getGetConversionApiFinanceReportsConversionGetUrl = (params?: GetConversionApiFinanceReportsConversionGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/conversion?${stringifiedParams}` : `/api/finance/reports/conversion`
}

export const getConversionApiFinanceReportsConversionGet = async (params?: GetConversionApiFinanceReportsConversionGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetConversionApiFinanceReportsConversionGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Item Sold By Outlet
 */
export const getGetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetUrl = (params?: GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/item-sold-by-outlet?${stringifiedParams}` : `/api/finance/reports/item-sold-by-outlet`
}

export const getItemSoldByOutletApiFinanceReportsItemSoldByOutletGet = async (params?: GetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetItemSoldByOutletApiFinanceReportsItemSoldByOutletGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Item Sold By Date
 */
export const getGetItemSoldByDateApiFinanceReportsItemSoldByDateGetUrl = (params?: GetItemSoldByDateApiFinanceReportsItemSoldByDateGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/item-sold-by-date?${stringifiedParams}` : `/api/finance/reports/item-sold-by-date`
}

export const getItemSoldByDateApiFinanceReportsItemSoldByDateGet = async (params?: GetItemSoldByDateApiFinanceReportsItemSoldByDateGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetItemSoldByDateApiFinanceReportsItemSoldByDateGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Ala Carte By Outlet
 */
export const getGetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetUrl = (params?: GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/ala-carte-by-outlet?${stringifiedParams}` : `/api/finance/reports/ala-carte-by-outlet`
}

export const getAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGet = async (params?: GetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetAlaCarteByOutletApiFinanceReportsAlaCarteByOutletGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Ala Carte By Beautician
 */
export const getGetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetUrl = (params?: GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/ala-carte-by-beautician?${stringifiedParams}` : `/api/finance/reports/ala-carte-by-beautician`
}

export const getAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGet = async (params?: GetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetAlaCarteByBeauticianApiFinanceReportsAlaCarteByBeauticianGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Unearned Revenue
 */
export const getGetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetUrl = (params?: GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/unearned-revenue?${stringifiedParams}` : `/api/finance/reports/unearned-revenue`
}

export const getUnearnedRevenueApiFinanceReportsUnearnedRevenueGet = async (params?: GetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetUnearnedRevenueApiFinanceReportsUnearnedRevenueGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Expired Invoices
 */
export const getGetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetUrl = (params?: GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/expired-invoices?${stringifiedParams}` : `/api/finance/reports/expired-invoices`
}

export const getExpiredInvoicesApiFinanceReportsExpiredInvoicesGet = async (params?: GetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetExpiredInvoicesApiFinanceReportsExpiredInvoicesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Items Sold Outlet Collection
 */
export const getGetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetUrl = (params?: GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/items-sold-outlet-collection?${stringifiedParams}` : `/api/finance/reports/items-sold-outlet-collection`
}

export const getItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGet = async (params?: GetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetParams, options?: RequestInit): Promise<SalesReportResponse> => {
  
  return apiFetch<SalesReportResponse>(getGetItemsSoldOutletCollectionApiFinanceReportsItemsSoldOutletCollectionGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * GEN-14 net sales — payments collected less GST and card fees, per
Singapore business day and per outlet that received the money. Read-only;
the rule lives in ``net_sales_service``.
 * @summary Get Net Sales Report
 */
export const getGetNetSalesReportApiFinanceReportsNetSalesGetUrl = (params: GetNetSalesReportApiFinanceReportsNetSalesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/net-sales?${stringifiedParams}` : `/api/finance/reports/net-sales`
}

export const getNetSalesReportApiFinanceReportsNetSalesGet = async (params: GetNetSalesReportApiFinanceReportsNetSalesGetParams, options?: RequestInit): Promise<NetSalesReportResponse> => {
  
  return apiFetch<NetSalesReportResponse>(getGetNetSalesReportApiFinanceReportsNetSalesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-12-11 — usages HQ voided in the period (by the day HQ approved), the
sessions they gave back and the voids still waiting for HQ. Read only; no
amounts — a void moves no money.
 * @summary Get Void Usages Report
 */
export const getGetVoidUsagesReportApiFinanceReportsVoidUsagesGetUrl = (params: GetVoidUsagesReportApiFinanceReportsVoidUsagesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/void-usages?${stringifiedParams}` : `/api/finance/reports/void-usages`
}

export const getVoidUsagesReportApiFinanceReportsVoidUsagesGet = async (params: GetVoidUsagesReportApiFinanceReportsVoidUsagesGetParams, options?: RequestInit): Promise<VoidUsagesReport> => {
  
  return apiFetch<VoidUsagesReport>(getGetVoidUsagesReportApiFinanceReportsVoidUsagesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-32 Collection — money received, by consultant / customer / outlet /
payment type. Figures follow GEN-14 (``net_sales_service``).
 * @summary Get Collection Report
 */
export const getGetCollectionReportApiFinanceReportsCollectionGetUrl = (params: GetCollectionReportApiFinanceReportsCollectionGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/collection?${stringifiedParams}` : `/api/finance/reports/collection`
}

export const getCollectionReportApiFinanceReportsCollectionGet = async (params: GetCollectionReportApiFinanceReportsCollectionGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetCollectionReportApiFinanceReportsCollectionGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-35 GST - output GST for the quarterly return, by month or outlet, with
every invoice, refund and credit note.
 * @summary Get Gst Report
 */
export const getGetGstReportApiFinanceReportsGstGetUrl = (params: GetGstReportApiFinanceReportsGstGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/gst?${stringifiedParams}` : `/api/finance/reports/gst`
}

export const getGstReportApiFinanceReportsGstGet = async (params: GetGstReportApiFinanceReportsGstGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetGstReportApiFinanceReportsGstGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-33 Credit Notes - issued, revoked and outstanding, each credit note or by
customer / outlet.
 * @summary Get Credit Notes Report
 */
export const getGetCreditNotesReportApiFinanceReportsCreditNotesGetUrl = (params: GetCreditNotesReportApiFinanceReportsCreditNotesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/credit-notes?${stringifiedParams}` : `/api/finance/reports/credit-notes`
}

export const getCreditNotesReportApiFinanceReportsCreditNotesGet = async (params: GetCreditNotesReportApiFinanceReportsCreditNotesGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetCreditNotesReportApiFinanceReportsCreditNotesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-31 Discounts, Refunds & Voids - every discount, refund, void, credit note,
transfer and upgrade in one list, with a Grouped tab and an Above-limit-only
tick.
 * @summary Get Discounts Refunds Voids Report
 */
export const getGetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetUrl = (params: GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/discounts-refunds-voids?${stringifiedParams}` : `/api/finance/reports/discounts-refunds-voids`
}

export const getDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGet = async (params: GetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetDiscountsRefundsVoidsReportApiFinanceReportsDiscountsRefundsVoidsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-34 Top Sellers - top customers, products and treatments ranked by sales
before GST; Show = top 10 / 20 / 50.
 * @summary Get Top Sellers Report
 */
export const getGetTopSellersReportApiFinanceReportsTopSellersGetUrl = (params: GetTopSellersReportApiFinanceReportsTopSellersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/top-sellers?${stringifiedParams}` : `/api/finance/reports/top-sellers`
}

export const getTopSellersReportApiFinanceReportsTopSellersGet = async (params: GetTopSellersReportApiFinanceReportsTopSellersGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetTopSellersReportApiFinanceReportsTopSellersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-43 Top Customers By Limit - the top N customers by sales before GST
(ranked as Top Sellers), with the customer details chosen under fields.
 * @summary Get Top Customers By Limit Report
 */
export const getGetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetUrl = (params: GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/top-customers-by-limit?${stringifiedParams}` : `/api/finance/reports/top-customers-by-limit`
}

export const getTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGet = async (params: GetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetTopCustomersByLimitReportApiFinanceReportsTopCustomersByLimitGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-29 Money Due & Risk - balances to collect, IHIP instalments overdue,
unearned revenue and packages expiring within 30 / 60 / 90 days.
 * @summary Get Money Due Risk Report
 */
export const getGetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetUrl = (params: GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/money-due-risk?${stringifiedParams}` : `/api/finance/reports/money-due-risk`
}

export const getMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGet = async (params: GetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetMoneyDueRiskReportApiFinanceReportsMoneyDueRiskGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-30 Consultation Results - how consultations turn into packages, by
consultant, and why not. Conversion is the shared same-day rule
(consultation_conversion).
 * @summary Get Consultation Results Report
 */
export const getGetConsultationResultsReportApiFinanceReportsConsultationResultsGetUrl = (params: GetConsultationResultsReportApiFinanceReportsConsultationResultsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/consultation-results?${stringifiedParams}` : `/api/finance/reports/consultation-results`
}

export const getConsultationResultsReportApiFinanceReportsConsultationResultsGet = async (params: GetConsultationResultsReportApiFinanceReportsConsultationResultsGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetConsultationResultsReportApiFinanceReportsConsultationResultsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-36 Sales by Staff - what each staff member sold and did, from the Served by
line on each invoice and completed treatment sessions.
 * @summary Get Sales By Staff Report
 */
export const getGetSalesByStaffReportApiFinanceReportsSalesByStaffGetUrl = (params: GetSalesByStaffReportApiFinanceReportsSalesByStaffGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/reports/sales-by-staff?${stringifiedParams}` : `/api/finance/reports/sales-by-staff`
}

export const getSalesByStaffReportApiFinanceReportsSalesByStaffGet = async (params: GetSalesByStaffReportApiFinanceReportsSalesByStaffGetParams, options?: RequestInit): Promise<InsightReportResponse> => {
  
  return apiFetch<InsightReportResponse>(getGetSalesByStaffReportApiFinanceReportsSalesByStaffGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * GEN-06-17 — the Form Responses filter box: Form, Outlet, Status, From,
To (both days included; To before From is a 422), Search; ``menu`` scopes
the list to one Forms menu; ``customerId`` (CUS-01-05) scopes it to one
customer's own responses, for her consent cards.

``dateFrom`` / ``dateTo`` are the CUS-04 spelling the Customers > Form
Responses screen shipped with. They mean the same business days; the one
difference CUS-04 locked down is that To before From **lists nothing**
instead of being refused, so that is kept for this spelling only. ``from`` /
``to`` win when both spellings are sent.
 * @summary List Responses
 */
export const getListResponsesApiFormTemplatesResponsesGetUrl = (params?: ListResponsesApiFormTemplatesResponsesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/form-templates/responses?${stringifiedParams}` : `/api/form-templates/responses`
}

export const listResponsesApiFormTemplatesResponsesGet = async (params?: ListResponsesApiFormTemplatesResponsesGetParams, options?: RequestInit): Promise<FormResponseListResponse> => {
  
  return apiFetch<FormResponseListResponse>(getListResponsesApiFormTemplatesResponsesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Record a signed form. The version is resolved server-side from the
template's current publication — the body names the template, never a
version (see ``form_templates_service.create_response``).
 * @summary Create Response
 */
export const getCreateResponseApiFormTemplatesResponsesPostUrl = () => {


  

  return `/api/form-templates/responses`
}

export const createResponseApiFormTemplatesResponsesPost = async (formResponseCreate: FormResponseCreate, options?: RequestInit): Promise<FormResponseOut> => {
  
  return apiFetch<FormResponseOut>(getCreateResponseApiFormTemplatesResponsesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      formResponseCreate,)
  }
);}



/**
 * GEN-06-17 Export Excel — the rows shown, with the same filters. Declared
before ``/responses/{response_id}`` so the literal path wins.
 * @summary Export Responses
 */
export const getExportResponsesApiFormTemplatesResponsesExportGetUrl = (params?: ExportResponsesApiFormTemplatesResponsesExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/form-templates/responses/export?${stringifiedParams}` : `/api/form-templates/responses/export`
}

export const exportResponsesApiFormTemplatesResponsesExportGet = async (params?: ExportResponsesApiFormTemplatesResponsesExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportResponsesApiFormTemplatesResponsesExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Response
 */
export const getGetResponseApiFormTemplatesResponsesResponseIdGetUrl = (responseId: string,) => {


  

  return `/api/form-templates/responses/${responseId}`
}

export const getResponseApiFormTemplatesResponsesResponseIdGet = async (responseId: string, options?: RequestInit): Promise<FormResponseOut> => {
  
  return apiFetch<FormResponseOut>(getGetResponseApiFormTemplatesResponsesResponseIdGetUrl(responseId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * GEN-06-22 — HQ approves a pending form. The Package Location Transfer
and Customer Credit forms are processed on approval (``form_actions``);
answers that do not match the records → 422 and nothing changes. A credit
above its reason's cap → 409 unless ``overrideCreditCap=true`` (V3). A
Package Holder Transfer form is record-only (T5). A 'VIP change' form
(M4) needs a reason in the body and changes the customer's VIP.
 * @summary Approve Response
 */
export const getApproveResponseApiFormTemplatesResponsesResponseIdApprovePostUrl = (responseId: string,
    params?: ApproveResponseApiFormTemplatesResponsesResponseIdApprovePostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/form-templates/responses/${responseId}/approve?${stringifiedParams}` : `/api/form-templates/responses/${responseId}/approve`
}

export const approveResponseApiFormTemplatesResponsesResponseIdApprovePost = async (responseId: string,
    approveResponseApiFormTemplatesResponsesResponseIdApprovePostBody: ApproveResponseApiFormTemplatesResponsesResponseIdApprovePostBody,
    params?: ApproveResponseApiFormTemplatesResponsesResponseIdApprovePostParams, options?: RequestInit): Promise<FormResponseOut> => {
  
  return apiFetch<FormResponseOut>(getApproveResponseApiFormTemplatesResponsesResponseIdApprovePostUrl(responseId,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      approveResponseApiFormTemplatesResponsesResponseIdApprovePostBody,)
  }
);}



/**
 * V3 — the Customer Credit form's reasons with their caps. HQ only.
 * @summary Get Credit Reasons
 */
export const getGetCreditReasonsApiFormTemplatesCreditReasonsGetUrl = () => {


  

  return `/api/form-templates/credit-reasons`
}

export const getCreditReasonsApiFormTemplatesCreditReasonsGet = async ( options?: RequestInit): Promise<CreditReasonList> => {
  
  return apiFetch<CreditReasonList>(getGetCreditReasonsApiFormTemplatesCreditReasonsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * V3 — HQ replaces the list (rename, cap, add, hide); the form's
'Reason for credit' options follow.
 * @summary Put Credit Reasons
 */
export const getPutCreditReasonsApiFormTemplatesCreditReasonsPutUrl = () => {


  

  return `/api/form-templates/credit-reasons`
}

export const putCreditReasonsApiFormTemplatesCreditReasonsPut = async (creditReasonUpdate: CreditReasonUpdate, options?: RequestInit): Promise<CreditReasonList> => {
  
  return apiFetch<CreditReasonList>(getPutCreditReasonsApiFormTemplatesCreditReasonsPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      creditReasonUpdate,)
  }
);}



/**
 * M4 — look at the money actually received and file a 'VIP change' form
for every customer whose VIP should change. Nothing changes until HQ
approves the form in Forms > Approvals.
 * @summary Check Vip Changes
 */
export const getCheckVipChangesApiFormTemplatesVipChangesCheckPostUrl = () => {


  

  return `/api/form-templates/vip-changes/check`
}

export const checkVipChangesApiFormTemplatesVipChangesCheckPost = async (vipCheckRequest: VipCheckRequest, options?: RequestInit): Promise<VipCheckResponse> => {
  
  return apiFetch<VipCheckResponse>(getCheckVipChangesApiFormTemplatesVipChangesCheckPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vipCheckRequest,)
  }
);}



/**
 * GEN-06-22 — HQ rejects a pending form with a reason (required).
 * @summary Reject Response
 */
export const getRejectResponseApiFormTemplatesResponsesResponseIdRejectPostUrl = (responseId: string,) => {


  

  return `/api/form-templates/responses/${responseId}/reject`
}

export const rejectResponseApiFormTemplatesResponsesResponseIdRejectPost = async (responseId: string,
    formResponseReject: FormResponseReject, options?: RequestInit): Promise<FormResponseOut> => {
  
  return apiFetch<FormResponseOut>(getRejectResponseApiFormTemplatesResponsesResponseIdRejectPostUrl(responseId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      formResponseReject,)
  }
);}



/**
 * GEN-06-05 — Form Templates of one menu (``menu``), or every form when
omitted. Reading a menu seeds its starting forms the first time.
 * @summary List Templates
 */
export const getListTemplatesApiFormTemplatesGetUrl = (params?: ListTemplatesApiFormTemplatesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/form-templates?${stringifiedParams}` : `/api/form-templates`
}

export const listTemplatesApiFormTemplatesGet = async (params?: ListTemplatesApiFormTemplatesGetParams, options?: RequestInit): Promise<FormTemplateListResponse> => {
  
  return apiFetch<FormTemplateListResponse>(getListTemplatesApiFormTemplatesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create a template plus its v1 DRAFT. Nothing is live until a version is
published.
 * @summary Create Template
 */
export const getCreateTemplateApiFormTemplatesPostUrl = () => {


  

  return `/api/form-templates`
}

export const createTemplateApiFormTemplatesPost = async (formTemplateCreate: FormTemplateCreate, options?: RequestInit): Promise<FormTemplateOut> => {
  
  return apiFetch<FormTemplateOut>(getCreateTemplateApiFormTemplatesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      formTemplateCreate,)
  }
);}



/**
 * GEN-06-03 Fill a form — one card per published form of the menu. All
staff, not admin: outlet staff are the ones filling forms in. Declared
before ``/{template_id}`` so the literal path wins.
 * @summary List Published
 */
export const getListPublishedApiFormTemplatesPublishedGetUrl = (params: ListPublishedApiFormTemplatesPublishedGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/form-templates/published?${stringifiedParams}` : `/api/form-templates/published`
}

export const listPublishedApiFormTemplatesPublishedGet = async (params: ListPublishedApiFormTemplatesPublishedGetParams, options?: RequestInit): Promise<FormTemplateListResponse> => {
  
  return apiFetch<FormTemplateListResponse>(getListPublishedApiFormTemplatesPublishedGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * All-staff, not admin: the desk needs to read the form it is about to
collect. The payload is metadata only — content comes from the versions
endpoint.
 * @summary Get Template
 */
export const getGetTemplateApiFormTemplatesTemplateIdGetUrl = (templateId: string,) => {


  

  return `/api/form-templates/${templateId}`
}

export const getTemplateApiFormTemplatesTemplateIdGet = async (templateId: string, options?: RequestInit): Promise<FormTemplateOut> => {
  
  return apiFetch<FormTemplateOut>(getGetTemplateApiFormTemplatesTemplateIdGetUrl(templateId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Metadata + lifecycle status (deactivate / archive). Content edits go
through ``POST /{id}/versions``.
 * @summary Update Template
 */
export const getUpdateTemplateApiFormTemplatesTemplateIdPutUrl = (templateId: string,) => {


  

  return `/api/form-templates/${templateId}`
}

export const updateTemplateApiFormTemplatesTemplateIdPut = async (templateId: string,
    formTemplateUpdate: FormTemplateUpdate, options?: RequestInit): Promise<FormTemplateOut> => {
  
  return apiFetch<FormTemplateOut>(getUpdateTemplateApiFormTemplatesTemplateIdPutUrl(templateId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      formTemplateUpdate,)
  }
);}



/**
 * @summary Duplicate Template
 */
export const getDuplicateTemplateApiFormTemplatesTemplateIdDuplicatePostUrl = (templateId: string,) => {


  

  return `/api/form-templates/${templateId}/duplicate`
}

export const duplicateTemplateApiFormTemplatesTemplateIdDuplicatePost = async (templateId: string, options?: RequestInit): Promise<FormTemplateOut> => {
  
  return apiFetch<FormTemplateOut>(getDuplicateTemplateApiFormTemplatesTemplateIdDuplicatePostUrl(templateId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Newest first. All-staff for the same reason as the template read: this is
where the renderable ``content`` lives.
 * @summary List Versions
 */
export const getListVersionsApiFormTemplatesTemplateIdVersionsGetUrl = (templateId: string,) => {


  

  return `/api/form-templates/${templateId}/versions`
}

export const listVersionsApiFormTemplatesTemplateIdVersionsGet = async (templateId: string, options?: RequestInit): Promise<FormVersionOut[]> => {
  
  return apiFetch<FormVersionOut[]>(getListVersionsApiFormTemplatesTemplateIdVersionsGetUrl(templateId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The edit path for a published form: a new DRAFT, leaving the live version
(and every signature against it) untouched.
 * @summary Create Version
 */
export const getCreateVersionApiFormTemplatesTemplateIdVersionsPostUrl = (templateId: string,) => {


  

  return `/api/form-templates/${templateId}/versions`
}

export const createVersionApiFormTemplatesTemplateIdVersionsPost = async (templateId: string,
    formVersionCreate: FormVersionCreate, options?: RequestInit): Promise<FormVersionOut> => {
  
  return apiFetch<FormVersionOut>(getCreateVersionApiFormTemplatesTemplateIdVersionsPostUrl(templateId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      formVersionCreate,)
  }
);}



/**
 * GEN-06-21 History — Created / Saved draft / Published / Deactivated /
Activated, newest first, with who and when.
 * @summary List History
 */
export const getListHistoryApiFormTemplatesTemplateIdHistoryGetUrl = (templateId: string,) => {


  

  return `/api/form-templates/${templateId}/history`
}

export const listHistoryApiFormTemplatesTemplateIdHistoryGet = async (templateId: string, options?: RequestInit): Promise<FormTemplateEventOut[]> => {
  
  return apiFetch<FormTemplateEventOut[]>(getListHistoryApiFormTemplatesTemplateIdHistoryGetUrl(templateId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Make this DRAFT live: it becomes PUBLISHED, the previous live version
becomes SUPERSEDED, and the template points here.
 * @summary Publish Version
 */
export const getPublishVersionApiFormTemplatesTemplateIdVersionsVersionIdPublishPostUrl = (templateId: string,
    versionId: string,) => {


  

  return `/api/form-templates/${templateId}/versions/${versionId}/publish`
}

export const publishVersionApiFormTemplatesTemplateIdVersionsVersionIdPublishPost = async (templateId: string,
    versionId: string, options?: RequestInit): Promise<FormVersionOut> => {
  
  return apiFetch<FormVersionOut>(getPublishVersionApiFormTemplatesTemplateIdVersionsVersionIdPublishPostUrl(templateId,versionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Create Submission
 */
export const getCreateSubmissionApiHrFormsSubmissionsPostUrl = () => {


  

  return `/api/hr/forms/submissions`
}

export const createSubmissionApiHrFormsSubmissionsPost = async (formSubmissionCreate: FormSubmissionCreate, options?: RequestInit): Promise<FormSubmissionResponse> => {
  
  return apiFetch<FormSubmissionResponse>(getCreateSubmissionApiHrFormsSubmissionsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      formSubmissionCreate,)
  }
);}



/**
 * @summary List Submissions
 */
export const getListSubmissionsApiHrFormsSubmissionsGetUrl = (params?: ListSubmissionsApiHrFormsSubmissionsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/forms/submissions?${stringifiedParams}` : `/api/hr/forms/submissions`
}

export const listSubmissionsApiHrFormsSubmissionsGet = async (params?: ListSubmissionsApiHrFormsSubmissionsGetParams, options?: RequestInit): Promise<FormSubmissionListResponse> => {
  
  return apiFetch<FormSubmissionListResponse>(getListSubmissionsApiHrFormsSubmissionsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Store one form attachment and hand back the URL to submit with the form.

Same guard as the submission itself (any authenticated staff): the person
filing a damage report is the person with the photo. Videos are why this
exists — 100 MB of base64 in a JSON body is not a workable upload path, so
anything that big comes through multipart and the submission carries only
the URL.

Note for deploys: nginx caps request bodies at 1 MB by default, so the host
needs `client_max_body_size` raised to 100M or every real video 413s before
FastAPI ever sees it.
 * @summary Upload Attachment
 */
export const getUploadAttachmentApiHrFormsUploadPostUrl = () => {


  

  return `/api/hr/forms/upload`
}

export const uploadAttachmentApiHrFormsUploadPost = async (bodyUploadAttachmentApiHrFormsUploadPost: BodyUploadAttachmentApiHrFormsUploadPost, options?: RequestInit): Promise<FormAttachmentUploadResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadAttachmentApiHrFormsUploadPost.file)

  return apiFetch<FormAttachmentUploadResponse>(getUploadAttachmentApiHrFormsUploadPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * Serve a stored attachment. HR-only, matching the submission detail.

The UUID filename is unguessable but that is not the control — the guard is.
A missing file is a 404 rather than a 500: an upload directory that is not a
mounted volume loses its contents on redeploy, and the review screen should
say "gone", not fall over.
 * @summary Get Attachment File
 */
export const getGetAttachmentFileApiHrFormsFilesFilenameGetUrl = (filename: string,) => {


  

  return `/api/hr/forms/files/${filename}`
}

export const getAttachmentFileApiHrFormsFilesFilenameGet = async (filename: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getGetAttachmentFileApiHrFormsFilesFilenameGetUrl(filename),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The submissions list as a file, same permission and same filters. Excel by
default, CSV on ``?format=csv``.

``formType`` is required: the two forms share almost no answer keys, so a
mixed export would be a ragged sheet with every damage column blank on
every compliment row. One file per form type is the usable answer, and the
list UI is already filtered by form type so it costs the user nothing.

Declared before ``/submissions/{submission_id}`` so the literal path wins.
 * @summary Export Submissions
 */
export const getExportSubmissionsApiHrFormsSubmissionsExportGetUrl = (params: ExportSubmissionsApiHrFormsSubmissionsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/forms/submissions/export?${stringifiedParams}` : `/api/hr/forms/submissions/export`
}

export const exportSubmissionsApiHrFormsSubmissionsExportGet = async (params: ExportSubmissionsApiHrFormsSubmissionsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportSubmissionsApiHrFormsSubmissionsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Submission
 */
export const getGetSubmissionApiHrFormsSubmissionsSubmissionIdGetUrl = (submissionId: string,) => {


  

  return `/api/hr/forms/submissions/${submissionId}`
}

export const getSubmissionApiHrFormsSubmissionsSubmissionIdGet = async (submissionId: string, options?: RequestInit): Promise<FormSubmissionResponse> => {
  
  return apiFetch<FormSubmissionResponse>(getGetSubmissionApiHrFormsSubmissionsSubmissionIdGetUrl(submissionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Products
 */
export const getListProductsApiInventoryProductsGetUrl = (params?: ListProductsApiInventoryProductsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/products?${stringifiedParams}` : `/api/inventory/products`
}

export const listProductsApiInventoryProductsGet = async (params?: ListProductsApiInventoryProductsGetParams, options?: RequestInit): Promise<ProductResponse[]> => {
  
  return apiFetch<ProductResponse[]>(getListProductsApiInventoryProductsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Product
 */
export const getCreateProductApiInventoryProductsPostUrl = () => {


  

  return `/api/inventory/products`
}

export const createProductApiInventoryProductsPost = async (productCreate: ProductCreate, options?: RequestInit): Promise<ProductResponse> => {
  
  return apiFetch<ProductResponse>(getCreateProductApiInventoryProductsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productCreate,)
  }
);}



/**
 * HQ only (INV-04-15). Reads an .xlsx / .csv of product, outlet, minimum and
says what would change and which rows could not be matched. Saves nothing.
 * @summary Preview Min Stock Import
 */
export const getPreviewMinStockImportApiInventoryMinStockImportPreviewPostUrl = () => {


  

  return `/api/inventory/min-stock/import/preview`
}

export const previewMinStockImportApiInventoryMinStockImportPreviewPost = async (bodyPreviewMinStockImportApiInventoryMinStockImportPreviewPost: BodyPreviewMinStockImportApiInventoryMinStockImportPreviewPost, options?: RequestInit): Promise<MinStockImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyPreviewMinStockImportApiInventoryMinStockImportPreviewPost.file)

  return apiFetch<MinStockImportPreview>(getPreviewMinStockImportApiInventoryMinStockImportPreviewPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * HQ only. Applies the same file: new / changed / cleared minimums are
written, unmatched rows are skipped. Only minimums — never stock or prices.
 * @summary Run Min Stock Import
 */
export const getRunMinStockImportApiInventoryMinStockImportPostUrl = () => {


  

  return `/api/inventory/min-stock/import`
}

export const runMinStockImportApiInventoryMinStockImportPost = async (bodyRunMinStockImportApiInventoryMinStockImportPost: BodyRunMinStockImportApiInventoryMinStockImportPost, options?: RequestInit): Promise<MinStockImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyRunMinStockImportApiInventoryMinStockImportPost.file)

  return apiFetch<MinStockImportPreview>(getRunMinStockImportApiInventoryMinStockImportPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * HQ only (INV-11-08). Reads the product master list (.xlsx) and says which
ACTIVE products would be created, which cost prices would change and which
selling prices differ. Saves nothing.
 * @summary Preview Product Master Import
 */
export const getPreviewProductMasterImportApiInventoryProductsMasterImportPreviewPostUrl = (params?: PreviewProductMasterImportApiInventoryProductsMasterImportPreviewPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/products/master-import/preview?${stringifiedParams}` : `/api/inventory/products/master-import/preview`
}

export const previewProductMasterImportApiInventoryProductsMasterImportPreviewPost = async (bodyPreviewProductMasterImportApiInventoryProductsMasterImportPreviewPost: BodyPreviewProductMasterImportApiInventoryProductsMasterImportPreviewPost,
    params?: PreviewProductMasterImportApiInventoryProductsMasterImportPreviewPostParams, options?: RequestInit): Promise<ProductMasterImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyPreviewProductMasterImportApiInventoryProductsMasterImportPreviewPost.file)

  return apiFetch<ProductMasterImportPreview>(getPreviewProductMasterImportApiInventoryProductsMasterImportPreviewPostUrl(params),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * HQ only. Applies the same file: new products, cost prices, and — only with
updatePrices — selling prices. Never stock, minimums, names or status.
 * @summary Run Product Master Import
 */
export const getRunProductMasterImportApiInventoryProductsMasterImportPostUrl = (params?: RunProductMasterImportApiInventoryProductsMasterImportPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/products/master-import?${stringifiedParams}` : `/api/inventory/products/master-import`
}

export const runProductMasterImportApiInventoryProductsMasterImportPost = async (bodyRunProductMasterImportApiInventoryProductsMasterImportPost: BodyRunProductMasterImportApiInventoryProductsMasterImportPost,
    params?: RunProductMasterImportApiInventoryProductsMasterImportPostParams, options?: RequestInit): Promise<ProductMasterImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyRunProductMasterImportApiInventoryProductsMasterImportPost.file)

  return apiFetch<ProductMasterImportPreview>(getRunProductMasterImportApiInventoryProductsMasterImportPostUrl(params),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * HQ only (INV-11-08): every product's cost price. Kept off ProductResponse
so no other role ever receives it, in the list or in an export.
 * @summary List Product Cost Prices
 */
export const getListProductCostPricesApiInventoryProductsCostPricesGetUrl = () => {


  

  return `/api/inventory/products/cost-prices`
}

export const listProductCostPricesApiInventoryProductsCostPricesGet = async ( options?: RequestInit): Promise<ProductCostPrice[]> => {
  
  return apiFetch<ProductCostPrice[]>(getListProductCostPricesApiInventoryProductsCostPricesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ only: set or clear (null) one product's cost price.
 * @summary Set Product Cost Price
 */
export const getSetProductCostPriceApiInventoryProductsProductIdCostPricePutUrl = (productId: string,) => {


  

  return `/api/inventory/products/${productId}/cost-price`
}

export const setProductCostPriceApiInventoryProductsProductIdCostPricePut = async (productId: string,
    productCostPriceUpdate: ProductCostPriceUpdate, options?: RequestInit): Promise<ProductCostPrice> => {
  
  return apiFetch<ProductCostPrice>(getSetProductCostPriceApiInventoryProductsProductIdCostPricePutUrl(productId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productCostPriceUpdate,)
  }
);}



/**
 * @summary Get Product
 */
export const getGetProductApiInventoryProductsProductIdGetUrl = (productId: string,) => {


  

  return `/api/inventory/products/${productId}`
}

export const getProductApiInventoryProductsProductIdGet = async (productId: string, options?: RequestInit): Promise<ProductResponse> => {
  
  return apiFetch<ProductResponse>(getGetProductApiInventoryProductsProductIdGetUrl(productId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Product
 */
export const getUpdateProductApiInventoryProductsProductIdPatchUrl = (productId: string,) => {


  

  return `/api/inventory/products/${productId}`
}

export const updateProductApiInventoryProductsProductIdPatch = async (productId: string,
    productUpdate: ProductUpdate, options?: RequestInit): Promise<ProductResponse> => {
  
  return apiFetch<ProductResponse>(getUpdateProductApiInventoryProductsProductIdPatchUrl(productId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productUpdate,)
  }
);}



/**
 * Soft delete. Returns the deactivated row rather than 204.

The row is still fetchable by id afterwards, on purpose: sale history and
(from P2) stock movements reference it, and a receipt for a discontinued
product must still render.
 * @summary Deactivate Product
 */
export const getDeactivateProductApiInventoryProductsProductIdDeleteUrl = (productId: string,) => {


  

  return `/api/inventory/products/${productId}`
}

export const deactivateProductApiInventoryProductsProductIdDelete = async (productId: string, options?: RequestInit): Promise<ProductResponse> => {
  
  return apiFetch<ProductResponse>(getDeactivateProductApiInventoryProductsProductIdDeleteUrl(productId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * List stock locations, Office first. 200.

Read-only: there is no POST/PATCH. Locations are seeded
(`backend/scripts/seed_stock_locations.py`), because adding one is a one-off
data operation and an editable `code` would break that script's idempotency
key.
 * @summary List Stock Locations
 */
export const getListStockLocationsApiInventoryLocationsGetUrl = (params?: ListStockLocationsApiInventoryLocationsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/locations?${stringifiedParams}` : `/api/inventory/locations`
}

export const listStockLocationsApiInventoryLocationsGet = async (params?: ListStockLocationsApiInventoryLocationsGetParams, options?: RequestInit): Promise<StockLocationResponse[]> => {
  
  return apiFetch<StockLocationResponse[]>(getListStockLocationsApiInventoryLocationsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * On-hand per (product x location), **each row carrying its batches**. 200.

The batch breakdown ships with every row rather than behind a second request:
stock is a set of batch rows, not a number on a product (C3), so a total
without its decomposition is a figure nobody can check — and checking it is
what BUG-868 asks for. `qtyOnHand` is summed FROM the returned batches, so
the rollup and the breakdown cannot disagree.

Empty result with a 200 is the honest day-one answer: no batches have been
received yet. Callers must render that as "no stock recorded", never as zero.

⛔ `batches[].unitCost` is null for callers without `inventory.manage` — see
`_batch_response`. Quantities and expiry dates are for everyone who can see
the stock screen; what we paid the supplier is not.
 * @summary Get Stock On Hand
 */
export const getGetStockOnHandApiInventoryStockGetUrl = (params?: GetStockOnHandApiInventoryStockGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/stock?${stringifiedParams}` : `/api/inventory/stock`
}

export const getStockOnHandApiInventoryStockGet = async (params?: GetStockOnHandApiInventoryStockGetParams, options?: RequestInit): Promise<StockOnHandResponse[]> => {
  
  return apiFetch<StockOnHandResponse[]>(getGetStockOnHandApiInventoryStockGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Receive a delivery. **201** — every receive creates a new batch.

201 rather than 200 is the contract, not a detail: the response body is a
freshly minted `StockBatch`, and it is minted even when an identical
product + location + expiry batch already exists. Two deliveries are two
batches (C3); merging would destroy the `receivedDate` granularity FEFO's
tie-break needs (§5).

404 unknown product/location, 422 discontinued product or inactive location
or qty <= 0.
 * @summary Receive Stock
 */
export const getReceiveStockApiInventoryStockReceivePostUrl = () => {


  

  return `/api/inventory/stock/receive`
}

export const receiveStockApiInventoryStockReceivePost = async (stockReceiveRequest: StockReceiveRequest, options?: RequestInit): Promise<StockBatchResponse> => {
  
  return apiFetch<StockBatchResponse>(getReceiveStockApiInventoryStockReceivePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockReceiveRequest,)
  }
);}



/**
 * ⚠ Edit `batchCode` / `expiryDate`. 200.

**This is the endpoint every expiry date in the system arrives through.**
Studio Manager has no expiry field (C4), so the catalogue import brings zero
dates and Angela and Lisa type them in afterwards, batch by batch. Setting
`expiryDate` on a batch that currently holds NULL is therefore the primary
case, not an edge case, and clearing it again must stay possible because a
mistyped year has to be undoable.

`exclude_unset` is load-bearing: an absent key means "leave alone", an
explicit null means "clear". Without it, a PATCH sending only `expiryDate`
would blank `batchCode`.

404 unknown batch. Quantity is not editable here — see
`POST /inventory/stock/adjust`, which demands a reason.
 * @summary Update Stock Batch
 */
export const getUpdateStockBatchApiInventoryBatchesBatchIdPatchUrl = (batchId: string,) => {


  

  return `/api/inventory/batches/${batchId}`
}

export const updateStockBatchApiInventoryBatchesBatchIdPatch = async (batchId: string,
    stockBatchUpdate: StockBatchUpdate, options?: RequestInit): Promise<StockBatchResponse> => {
  
  return apiFetch<StockBatchResponse>(getUpdateStockBatchApiInventoryBatchesBatchIdPatchUrl(batchId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockBatchUpdate,)
  }
);}



/**
 * ⚠ The expiry alert feed — spec §8.3. **This is what satisfies BUG-868.**

Batches expiring within the window, soonest first, already-expired ones
first of all. Defaults to 365 days: Angela's widest reminder (1 yr / 6 mo /
30 d), so a caller asking for nothing in particular gets everything she
asked to be reminded about, tiered.

⛔ THE RESPONSE IS NOT A BARE LIST, and that is the whole design. It carries
`totalBatches` and `totalWithExpiry` because an empty `items` has two
completely different meanings that the UI must not conflate:

  `totalWithExpiry == 0` -> nothing has been RECORDED. Say so, and link to
                            the Stock page so the dates can be typed in.
  `totalWithExpiry > 0`  -> nothing is DUE. "Nothing expiring in N days."

Per C4 Studio Manager has no expiry field, so the import brings zero dates
and every one is hand-typed afterwards. The first case is the NORMAL state on
launch day and stays normal for an unbounded period. An endpoint returning
only a list would force every caller to render the second message over the
first situation — a false clean bill of health on the one feature built to
catch expiring stock.

Undated batches are excluded from `items` (NULL expiry means *unknown*, not
*imminent* — §5's NULLS LAST reasoning) but counted in `totalBatches`, which
is what makes the two cases separable at all.

⛔ No `unitCost` redaction branch here, unlike `GET /inventory/stock`:
`ExpiringBatchItem` carries no supplier cost at all. `inventory.view` falls
through to the legacy `treatments` cell and so resolves FULL for every
logged-in user including THERAPIST — a shape that simply never holds the
purchase price cannot leak it if a future edit forgets the branch.

200 always. An empty result is an answer, not an error.
 * @summary Get Expiring Stock
 */
export const getGetExpiringStockApiInventoryExpiringGetUrl = (params?: GetExpiringStockApiInventoryExpiringGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/expiring?${stringifiedParams}` : `/api/inventory/expiring`
}

export const getExpiringStockApiInventoryExpiringGet = async (params?: GetExpiringStockApiInventoryExpiringGetParams, options?: RequestInit): Promise<ExpiringStockResponse> => {
  
  return apiFetch<ExpiringStockResponse>(getGetExpiringStockApiInventoryExpiringGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Correct a batch's quantity, with a reason. 200.

200 rather than 201: this mutates an existing batch and mints no new
resource. The signed ADJUSTMENT movement it writes is an audit record, not
the endpoint's subject — the response is the corrected batch.

- 404 unknown batch.
- **422 when `reason` is missing or blank**, and when `qtyDelta` is zero. An
  unexplained stock correction is precisely what the audit trail exists to
  prevent, so it is refused rather than defaulted to something bland.
- **409 when the result would be negative**, with a message naming both
  numbers — not the DB CHECK constraint leaking out as a 500.
 * @summary Adjust Stock
 */
export const getAdjustStockApiInventoryStockAdjustPostUrl = () => {


  

  return `/api/inventory/stock/adjust`
}

export const adjustStockApiInventoryStockAdjustPost = async (stockAdjustRequest: StockAdjustRequest, options?: RequestInit): Promise<StockBatchResponse> => {
  
  return apiFetch<StockBatchResponse>(getAdjustStockApiInventoryStockAdjustPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockAdjustRequest,)
  }
);}



/**
 * Record back-bar product consumption via FEFO deduction. 200.

INV-06-09/10: the batches that moved, each carrying the USG- number of the
usage document that was written.
 * @summary Record Usage
 */
export const getRecordUsageApiInventoryUsagePostUrl = () => {


  

  return `/api/inventory/usage`
}

export const recordUsageApiInventoryUsagePost = async (backBarUsageRequest: BackBarUsageRequest, options?: RequestInit): Promise<StockBatchResponse[]> => {
  
  return apiFetch<StockBatchResponse[]>(getRecordUsageApiInventoryUsagePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      backBarUsageRequest,)
  }
);}



/**
 * Ask to dispose several products at once — ONE PENDING DSP- document. **201.**

INV-06-12/13 with the owner's rule (15 Oct 2026): nothing leaves stock until
HQ confirms the request. Every row is checked first (rows of one product /
batch are added up); any failure saves nothing. 404 unknown outlet / product
/ batch, 409 not enough stock, 422 bad reason or missing remarks for Other.
 * @summary Dispose Stock
 */
export const getDisposeStockApiInventoryStockDisposePostUrl = () => {


  

  return `/api/inventory/stock/dispose`
}

export const disposeStockApiInventoryStockDisposePost = async (stockDisposeRequest: StockDisposeRequest, options?: RequestInit): Promise<StockDocumentResponse> => {
  
  return apiFetch<StockDocumentResponse>(getDisposeStockApiInventoryStockDisposePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockDisposeRequest,)
  }
);}



/**
 * Documents newest first — `kind=DISPOSE&status=PENDING` is HQ's to-do list.

``canDecide`` is true for HQ (catalogue key), who may Confirm or Reject.
 * @summary List Stock Documents
 */
export const getListStockDocumentsApiInventoryDocumentsGetUrl = (params?: ListStockDocumentsApiInventoryDocumentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/documents?${stringifiedParams}` : `/api/inventory/documents`
}

export const listStockDocumentsApiInventoryDocumentsGet = async (params?: ListStockDocumentsApiInventoryDocumentsGetParams, options?: RequestInit): Promise<StockDocumentListResponse> => {
  
  return apiFetch<StockDocumentListResponse>(getListStockDocumentsApiInventoryDocumentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ confirms a Dispose request: stock leaves now, all or nothing. 200.

403 for anyone but HQ; 409 when the outlet no longer holds a row's quantity
(nothing is written); 422 when the document is not a pending dispose.
 * @summary Confirm Dispose Document
 */
export const getConfirmDisposeDocumentApiInventoryDocumentsDocumentIdConfirmDisposePostUrl = (documentId: string,) => {


  

  return `/api/inventory/documents/${documentId}/confirm-dispose`
}

export const confirmDisposeDocumentApiInventoryDocumentsDocumentIdConfirmDisposePost = async (documentId: string, options?: RequestInit): Promise<StockDocumentResponse> => {
  
  return apiFetch<StockDocumentResponse>(getConfirmDisposeDocumentApiInventoryDocumentsDocumentIdConfirmDisposePostUrl(documentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HQ rejects a Dispose request with a reason: nothing moves, the request is kept. 200.
 * @summary Reject Dispose Document
 */
export const getRejectDisposeDocumentApiInventoryDocumentsDocumentIdRejectDisposePostUrl = (documentId: string,) => {


  

  return `/api/inventory/documents/${documentId}/reject-dispose`
}

export const rejectDisposeDocumentApiInventoryDocumentsDocumentIdRejectDisposePost = async (documentId: string,
    stockDocumentRejectRequest: StockDocumentRejectRequest, options?: RequestInit): Promise<StockDocumentResponse> => {
  
  return apiFetch<StockDocumentResponse>(getRejectDisposeDocumentApiInventoryDocumentsDocumentIdRejectDisposePostUrl(documentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockDocumentRejectRequest,)
  }
);}



/**
 * One RCV- / USG- / DSP- / ADJ- document with its lines. 404 if unknown.
 * @summary Get Stock Document
 */
export const getGetStockDocumentApiInventoryDocumentsDocumentIdGetUrl = (documentId: string,) => {


  

  return `/api/inventory/documents/${documentId}`
}

export const getStockDocumentApiInventoryDocumentsDocumentIdGet = async (documentId: string, options?: RequestInit): Promise<StockDocumentResponse> => {
  
  return apiFetch<StockDocumentResponse>(getGetStockDocumentApiInventoryDocumentsDocumentIdGetUrl(documentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Revoke a Usage (INV-06-28): a new Usage (+) document puts the quantity back. 200.

HQ or the Head Master only (403 otherwise). 422 when the document is not a
usage, is itself a revoke, or was already revoked.
 * @summary Revoke Usage Document
 */
export const getRevokeUsageDocumentApiInventoryDocumentsDocumentIdRevokePostUrl = (documentId: string,) => {


  

  return `/api/inventory/documents/${documentId}/revoke`
}

export const revokeUsageDocumentApiInventoryDocumentsDocumentIdRevokePost = async (documentId: string, options?: RequestInit): Promise<StockDocumentResponse> => {
  
  return apiFetch<StockDocumentResponse>(getRevokeUsageDocumentApiInventoryDocumentsDocumentIdRevokePostUrl(documentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Non-locking stock availability check for the POS product picker.
 * @summary Check Stock
 */
export const getCheckStockApiInventoryStockCheckPostUrl = () => {


  

  return `/api/inventory/stock-check`
}

export const checkStockApiInventoryStockCheckPost = async (stockCheckRequest: StockCheckRequest, options?: RequestInit): Promise<StockCheckResponse> => {
  
  return apiFetch<StockCheckResponse>(getCheckStockApiInventoryStockCheckPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockCheckRequest,)
  }
);}



/**
 * Draft a transfer. **201** — and it moves no stock.

The transfer lands in `DRAFT`. Nothing leaves the source location until
`POST /inventory/transfers/{id}/send`, which is what makes a draft freely
cancellable and anchors the FEFO pick to the moment the goods actually move.

- 404 unknown location or product.
- 422 wrong direction (from must be the Office, to must be an outlet), same
  location twice, an inactive location, a discontinued product, or the same
  product on two lines.
 * @summary Create Transfer
 */
export const getCreateTransferApiInventoryTransfersPostUrl = () => {


  

  return `/api/inventory/transfers`
}

export const createTransferApiInventoryTransfersPost = async (transferCreate: TransferCreate, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getCreateTransferApiInventoryTransfersPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transferCreate,)
  }
);}



/**
 * List transfers, newest first, each with its lines. 200.

The list is a worklist — what was just sent, and what is waiting to be
received — so it is ordered newest first and filterable by `status`.

An unknown `status` is a 422 rather than an empty list: an empty list would
read as "no transfers are in that state", which is a different and wrong
answer to a typo.
 * @summary List Transfers
 */
export const getListTransfersApiInventoryTransfersGetUrl = (params?: ListTransfersApiInventoryTransfersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/transfers?${stringifiedParams}` : `/api/inventory/transfers`
}

export const listTransfersApiInventoryTransfersGet = async (params?: ListTransfersApiInventoryTransfersGetParams, options?: RequestInit): Promise<TransferListResponse> => {
  
  return apiFetch<TransferListResponse>(getListTransfersApiInventoryTransfersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * INV-07-17 'Fill from minimum': what To needs to be back at its minimums. Saves nothing.
 * @summary Fill From Minimum
 */
export const getFillFromMinimumApiInventoryTransfersFillFromMinimumGetUrl = (params: FillFromMinimumApiInventoryTransfersFillFromMinimumGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/transfers/fill-from-minimum?${stringifiedParams}` : `/api/inventory/transfers/fill-from-minimum`
}

export const fillFromMinimumApiInventoryTransfersFillFromMinimumGet = async (params: FillFromMinimumApiInventoryTransfersFillFromMinimumGetParams, options?: RequestInit): Promise<FillFromMinimumResponse> => {
  
  return apiFetch<FillFromMinimumResponse>(getFillFromMinimumApiInventoryTransfersFillFromMinimumGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * One transfer with its lines and both location names. 200. 404 if unknown.
 * @summary Get Transfer
 */
export const getGetTransferApiInventoryTransfersTransferIdGetUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}`
}

export const getTransferApiInventoryTransfersTransferIdGet = async (transferId: string, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getGetTransferApiInventoryTransfersTransferIdGetUrl(transferId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Dispatch a DRAFT transfer — FEFO-pick each line and write TRANSFER_OUT. 200.

**This is where stock actually leaves the Office.** Each line is picked
earliest-expiry-first (§5); one line routinely becomes several movements,
and that movement set — not the line — is the authoritative record of what
left and with which expiry dates.

200 rather than 201: this advances an existing document. The movements it
writes are the audit record, not the endpoint's subject.

- 404 unknown transfer.
- 422 when the transfer is not `DRAFT` (already sent, received or cancelled).
- **409 when the source cannot cover a line**, naming both numbers. Nothing
  is committed in that case — the movements already applied for earlier lines
  are discarded with the transaction and the transfer stays `DRAFT`, so a
  transfer is never half-sent.
 * @summary Send Transfer
 */
export const getSendTransferApiInventoryTransfersTransferIdSendPostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/send`
}

export const sendTransferApiInventoryTransfersTransferIdSendPost = async (transferId: string,
    sendTransferApiInventoryTransfersTransferIdSendPostBody: SendTransferApiInventoryTransfersTransferIdSendPostBody, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getSendTransferApiInventoryTransfersTransferIdSendPostUrl(transferId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendTransferApiInventoryTransfersTransferIdSendPostBody,)
  }
);}



/**
 * Receive a SENT transfer — land each source batch as its own new batch. 200.

⛔ **Each source batch spawns a separate destination batch, carrying that
batch's `batchCode` and `expiryDate`. Batches are never merged.** A pick that
spanned a batch expiring next month and one expiring next year arrives as two
batches with those two dates. Merging them would put 20 units under a single
expiry, one of which is a fabrication, and the outlet's own FEFO would then
order against it — the expiry data the module exists to preserve, destroyed
by the act of moving the goods.

What shipped is read from the `TRANSFER_OUT` movements, not from the lines:
the lines record what was asked for, the movements record which batches FEFO
actually drew from, and only they know the dates to carry across.

- 404 unknown transfer.
- 422 when the transfer is not `SENT` (still a draft, or already received).
 * @summary Receive Transfer
 */
export const getReceiveTransferApiInventoryTransfersTransferIdReceivePostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/receive`
}

export const receiveTransferApiInventoryTransfersTransferIdReceivePost = async (transferId: string,
    receiveTransferApiInventoryTransfersTransferIdReceivePostBody: ReceiveTransferApiInventoryTransfersTransferIdReceivePostBody, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getReceiveTransferApiInventoryTransfersTransferIdReceivePostUrl(transferId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      receiveTransferApiInventoryTransfersTransferIdReceivePostBody,)
  }
);}



/**
 * Cancel a DRAFT transfer. 200.

⛔ **Draft only**, and the reason is physical rather than bookkeeping. Once a
transfer is `SENT` the goods have left the Office and `TRANSFER_OUT`
movements exist; cancelling would have to invent a reverse movement for stock
that is genuinely in a van. The honest correction is to receive it and then
adjust with a reason, which leaves both facts in the audit trail.

- 404 unknown transfer.
- 422 when the transfer is not `DRAFT`.
 * @summary Cancel Transfer
 */
export const getCancelTransferApiInventoryTransfersTransferIdCancelPostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/cancel`
}

export const cancelTransferApiInventoryTransfersTransferIdCancelPost = async (transferId: string,
    cancelTransferApiInventoryTransfersTransferIdCancelPostBody: CancelTransferApiInventoryTransfersTransferIdCancelPostBody, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getCancelTransferApiInventoryTransfersTransferIdCancelPostUrl(transferId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      cancelTransferApiInventoryTransfersTransferIdCancelPostBody,)
  }
);}



/**
 * The receiving outlet refuses an in-transit transfer (INV-07-20). 200.

Reason required (422 without). The products go back to the sender's stock on
the same batches; nothing is added at the receiver; status REJECTED.
 * @summary Reject Transfer
 */
export const getRejectTransferApiInventoryTransfersTransferIdRejectPostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/reject`
}

export const rejectTransferApiInventoryTransfersTransferIdRejectPost = async (transferId: string,
    transferReasonRequest: TransferReasonRequest, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getRejectTransferApiInventoryTransfersTransferIdRejectPostUrl(transferId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transferReasonRequest,)
  }
);}



/**
 * Return difference (INV-07-14 step 1): a return transfer TRF-… for the short lines. **201.**

Receiving outlet → sending outlet, In transit, linked both ways. Moves no
stock. 422 when nothing is short or it was already sent back.
 * @summary Return Difference
 */
export const getReturnDifferenceApiInventoryTransfersTransferIdReturnDifferencePostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/return-difference`
}

export const returnDifferenceApiInventoryTransfersTransferIdReturnDifferencePost = async (transferId: string, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getReturnDifferenceApiInventoryTransfersTransferIdReturnDifferencePostUrl(transferId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Receive return (INV-07-14 step 2 / INV-07-15). 200.

Per line: received back (0 … returned) and Back to stock / Dispose. What
did not come back is written off 'Lost in transit'; disposals and losses go
on ONE DSP- document (its number is echoed in ``differenceRemarks``).
 * @summary Receive Return
 */
export const getReceiveReturnApiInventoryTransfersTransferIdReceiveReturnPostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/receive-return`
}

export const receiveReturnApiInventoryTransfersTransferIdReceiveReturnPost = async (transferId: string,
    returnReceiveRequest: ReturnReceiveRequest, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getReceiveReturnApiInventoryTransfersTransferIdReceiveReturnPostUrl(transferId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      returnReceiveRequest,)
  }
);}



/**
 * Confirm extra (HQ) — INV-07-16 step 4. 200; 403 for non-HQ.

The extra leaves the sender's stock as Transfer (-) lines. 409 when the
sender does not hold it (correct the receiver with Adjust instead).
 * @summary Confirm Extra
 */
export const getConfirmExtraApiInventoryTransfersTransferIdConfirmExtraPostUrl = (transferId: string,) => {


  

  return `/api/inventory/transfers/${transferId}/confirm-extra`
}

export const confirmExtraApiInventoryTransfersTransferIdConfirmExtraPost = async (transferId: string, options?: RequestInit): Promise<TransferResponse> => {
  
  return apiFetch<TransferResponse>(getConfirmExtraApiInventoryTransfersTransferIdConfirmExtraPostUrl(transferId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Request Stock: RQ-<outlet>-xxxxxx, status Requested. Nothing moves. **201.**
 * @summary Create Request
 */
export const getCreateRequestApiInventoryRequestsPostUrl = () => {


  

  return `/api/inventory/requests`
}

export const createRequestApiInventoryRequestsPost = async (stockRequestCreate: StockRequestCreate, options?: RequestInit): Promise<StockRequestResponse> => {
  
  return apiFetch<StockRequestResponse>(getCreateRequestApiInventoryRequestsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stockRequestCreate,)
  }
);}



/**
 * Requests, newest first (also the 'Past Stock Request' report, INV-10-05).
 * @summary List Requests
 */
export const getListRequestsApiInventoryRequestsGetUrl = (params?: ListRequestsApiInventoryRequestsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/requests?${stringifiedParams}` : `/api/inventory/requests`
}

export const listRequestsApiInventoryRequestsGet = async (params?: ListRequestsApiInventoryRequestsGetParams, options?: RequestInit): Promise<StockRequestListResponse> => {
  
  return apiFetch<StockRequestListResponse>(getListRequestsApiInventoryRequestsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Approve (HQ) — INV-07-03 step 3: one transfer 'To send'. Moves nothing. 403 for non-HQ.
 * @summary Approve Request
 */
export const getApproveRequestApiInventoryRequestsRequestIdApprovePostUrl = (requestId: string,) => {


  

  return `/api/inventory/requests/${requestId}/approve`
}

export const approveRequestApiInventoryRequestsRequestIdApprovePost = async (requestId: string, options?: RequestInit): Promise<StockRequestResponse> => {
  
  return apiFetch<StockRequestResponse>(getApproveRequestApiInventoryRequestsRequestIdApprovePostUrl(requestId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Reject (HQ) — reason required; nothing moves. 403 for non-HQ.
 * @summary Reject Request
 */
export const getRejectRequestApiInventoryRequestsRequestIdRejectPostUrl = (requestId: string,) => {


  

  return `/api/inventory/requests/${requestId}/reject`
}

export const rejectRequestApiInventoryRequestsRequestIdRejectPost = async (requestId: string,
    transferReasonRequest: TransferReasonRequest, options?: RequestInit): Promise<StockRequestResponse> => {
  
  return apiFetch<StockRequestResponse>(getRejectRequestApiInventoryRequestsRequestIdRejectPostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transferReasonRequest,)
  }
);}



/**
 * Start a stocktake (INV-09-03/04): ST-xxxxxx, System qty taken now, status Counting. **201.**

409 when one is still counting these products at that place (INV-09-10).
 * @summary Start Stocktake
 */
export const getStartStocktakeApiInventoryStocktakesPostUrl = () => {


  

  return `/api/inventory/stocktakes`
}

export const startStocktakeApiInventoryStocktakesPost = async (stocktakeCreate: StocktakeCreate, options?: RequestInit): Promise<StocktakeResponse> => {
  
  return apiFetch<StocktakeResponse>(getStartStocktakeApiInventoryStocktakesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stocktakeCreate,)
  }
);}



/**
 * In progress and Completed (posted and cancelled) stocktakes, newest first.
 * @summary List Stocktakes
 */
export const getListStocktakesApiInventoryStocktakesGetUrl = (params?: ListStocktakesApiInventoryStocktakesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/stocktakes?${stringifiedParams}` : `/api/inventory/stocktakes`
}

export const listStocktakesApiInventoryStocktakesGet = async (params?: ListStocktakesApiInventoryStocktakesGetParams, options?: RequestInit): Promise<StocktakeListResponse> => {
  
  return apiFetch<StocktakeListResponse>(getListStocktakesApiInventoryStocktakesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The count sheet (INV-09-05) with Moved since start and Expected worked out.
 * @summary Get Stocktake
 */
export const getGetStocktakeApiInventoryStocktakesStocktakeIdGetUrl = (stocktakeId: string,) => {


  

  return `/api/inventory/stocktakes/${stocktakeId}`
}

export const getStocktakeApiInventoryStocktakesStocktakeIdGet = async (stocktakeId: string, options?: RequestInit): Promise<StocktakeResponse> => {
  
  return apiFetch<StocktakeResponse>(getGetStocktakeApiInventoryStocktakesStocktakeIdGetUrl(stocktakeId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Save count (INV-09-06): keeps what was typed; stock does not change. 200.
 * @summary Save Stocktake Counts
 */
export const getSaveStocktakeCountsApiInventoryStocktakesStocktakeIdCountsPutUrl = (stocktakeId: string,) => {


  

  return `/api/inventory/stocktakes/${stocktakeId}/counts`
}

export const saveStocktakeCountsApiInventoryStocktakesStocktakeIdCountsPut = async (stocktakeId: string,
    stocktakeCountsRequest: StocktakeCountsRequest, options?: RequestInit): Promise<StocktakeResponse> => {
  
  return apiFetch<StocktakeResponse>(getSaveStocktakeCountsApiInventoryStocktakesStocktakeIdCountsPutUrl(stocktakeId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stocktakeCountsRequest,)
  }
);}



/**
 * Post to stock (INV-09-07): every difference becomes an Adjust line linked to ST-. 200.

Head Master or HQ only (403). 422 names the products not counted or without a reason.
 * @summary Post Stocktake
 */
export const getPostStocktakeApiInventoryStocktakesStocktakeIdPostPostUrl = (stocktakeId: string,) => {


  

  return `/api/inventory/stocktakes/${stocktakeId}/post`
}

export const postStocktakeApiInventoryStocktakesStocktakeIdPostPost = async (stocktakeId: string, options?: RequestInit): Promise<StocktakeResponse> => {
  
  return apiFetch<StocktakeResponse>(getPostStocktakeApiInventoryStocktakesStocktakeIdPostPostUrl(stocktakeId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Cancel while counting (INV-09-08): nothing in stock changes. 200.
 * @summary Cancel Stocktake
 */
export const getCancelStocktakeApiInventoryStocktakesStocktakeIdCancelPostUrl = (stocktakeId: string,) => {


  

  return `/api/inventory/stocktakes/${stocktakeId}/cancel`
}

export const cancelStocktakeApiInventoryStocktakesStocktakeIdCancelPost = async (stocktakeId: string, options?: RequestInit): Promise<StocktakeResponse> => {
  
  return apiFetch<StocktakeResponse>(getCancelStocktakeApiInventoryStocktakesStocktakeIdCancelPostUrl(stocktakeId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Inventory Level (INV-10-07): on hand per product at one place. Read only.

Every product is listed (0 = red chip); in transit is not counted until
Confirm receipt. ``status`` = active (default) · inactive · all. Open to
`inventory.view` like the stock screen — it carries no cost.
 * @summary Inventory Level
 */
export const getInventoryLevelApiInventoryLevelGetUrl = (params: InventoryLevelApiInventoryLevelGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/level?${stringifiedParams}` : `/api/inventory/level`
}

export const inventoryLevelApiInventoryLevelGet = async (params: InventoryLevelApiInventoryLevelGetParams, options?: RequestInit): Promise<InventoryLevelResponse> => {
  
  return apiFetch<InventoryLevelResponse>(getInventoryLevelApiInventoryLevelGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Inventory Level as Excel (INV-10-07): the rows shown, for the place that is on.
 * @summary Export Inventory Level
 */
export const getExportInventoryLevelApiInventoryLevelExportGetUrl = (params: ExportInventoryLevelApiInventoryLevelExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/level/export?${stringifiedParams}` : `/api/inventory/level/export`
}

export const exportInventoryLevelApiInventoryLevelExportGet = async (params: ExportInventoryLevelApiInventoryLevelExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportInventoryLevelApiInventoryLevelExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Product / Category Stock Ledger and Inventory Level Trend (INV-10-05/11).

Opening (From) · Received · Usage · Sale · Transfer · Disposed · Adjusted ·
Closing (To), per product or category, split by period · day · month.
Dates are Singapore business days.
 * @summary Stock Ledger
 */
export const getStockLedgerApiInventoryLedgerGetUrl = (params: StockLedgerApiInventoryLedgerGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/ledger?${stringifiedParams}` : `/api/inventory/ledger`
}

export const stockLedgerApiInventoryLedgerGet = async (params: StockLedgerApiInventoryLedgerGetParams, options?: RequestInit): Promise<LedgerResponse> => {
  
  return apiFetch<LedgerResponse>(getStockLedgerApiInventoryLedgerGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The ledger as Excel (INV-10-06).
 * @summary Export Stock Ledger
 */
export const getExportStockLedgerApiInventoryLedgerExportGetUrl = (params: ExportStockLedgerApiInventoryLedgerExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/ledger/export?${stringifiedParams}` : `/api/inventory/ledger/export`
}

export const exportStockLedgerApiInventoryLedgerExportGet = async (params: ExportStockLedgerApiInventoryLedgerExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportStockLedgerApiInventoryLedgerExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Stock Movements as Excel (INV-10-06): the rows the screen shows, Singapore days.
 * @summary Export Movements
 */
export const getExportMovementsApiInventoryMovementsExportGetUrl = (params?: ExportMovementsApiInventoryMovementsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/movements/export?${stringifiedParams}` : `/api/inventory/movements/export`
}

export const exportMovementsApiInventoryMovementsExportGet = async (params?: ExportMovementsApiInventoryMovementsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportMovementsApiInventoryMovementsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Low Stock Reorder (INV-11-02): product x outlet at or below Min., with the suggested order.

Suggested order = Target - On hand - In transit - Requested.
 * @summary Low Stock Report
 */
export const getLowStockReportApiInventoryReportsLowStockGetUrl = (params?: LowStockReportApiInventoryReportsLowStockGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/low-stock?${stringifiedParams}` : `/api/inventory/reports/low-stock`
}

export const lowStockReportApiInventoryReportsLowStockGet = async (params?: LowStockReportApiInventoryReportsLowStockGetParams, options?: RequestInit): Promise<LowStockResponse> => {
  
  return apiFetch<LowStockResponse>(getLowStockReportApiInventoryReportsLowStockGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Export Low Stock
 */
export const getExportLowStockApiInventoryReportsLowStockExportGetUrl = (params?: ExportLowStockApiInventoryReportsLowStockExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/low-stock/export?${stringifiedParams}` : `/api/inventory/reports/low-stock/export`
}

export const exportLowStockApiInventoryReportsLowStockExportGet = async (params?: ExportLowStockApiInventoryReportsLowStockExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportLowStockApiInventoryReportsLowStockExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Usage vs Treatments Done (INV-11-03), per month.

Expected use (standard x treatments done) against Record Usage.
 * @summary Usage Vs Treatments Report
 */
export const getUsageVsTreatmentsReportApiInventoryReportsUsageVsTreatmentsGetUrl = (params: UsageVsTreatmentsReportApiInventoryReportsUsageVsTreatmentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/usage-vs-treatments?${stringifiedParams}` : `/api/inventory/reports/usage-vs-treatments`
}

export const usageVsTreatmentsReportApiInventoryReportsUsageVsTreatmentsGet = async (params: UsageVsTreatmentsReportApiInventoryReportsUsageVsTreatmentsGetParams, options?: RequestInit): Promise<UsageVsTreatmentsResponse> => {
  
  return apiFetch<UsageVsTreatmentsResponse>(getUsageVsTreatmentsReportApiInventoryReportsUsageVsTreatmentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Export Usage Vs Treatments
 */
export const getExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetUrl = (params: ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/usage-vs-treatments/export?${stringifiedParams}` : `/api/inventory/reports/usage-vs-treatments/export`
}

export const exportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGet = async (params: ExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportUsageVsTreatmentsApiInventoryReportsUsageVsTreatmentsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Loss Summary (INV-11-05): Dispose, Adjust taken off and stocktake differences.

By reason and month, quantities only (value at cost is the money track).
 * @summary Loss Summary Report
 */
export const getLossSummaryReportApiInventoryReportsLossSummaryGetUrl = (params: LossSummaryReportApiInventoryReportsLossSummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/loss-summary?${stringifiedParams}` : `/api/inventory/reports/loss-summary`
}

export const lossSummaryReportApiInventoryReportsLossSummaryGet = async (params: LossSummaryReportApiInventoryReportsLossSummaryGetParams, options?: RequestInit): Promise<LossSummaryResponse> => {
  
  return apiFetch<LossSummaryResponse>(getLossSummaryReportApiInventoryReportsLossSummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Export Loss Summary
 */
export const getExportLossSummaryApiInventoryReportsLossSummaryExportGetUrl = (params: ExportLossSummaryApiInventoryReportsLossSummaryExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/loss-summary/export?${stringifiedParams}` : `/api/inventory/reports/loss-summary/export`
}

export const exportLossSummaryApiInventoryReportsLossSummaryExportGet = async (params: ExportLossSummaryApiInventoryReportsLossSummaryExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportLossSummaryApiInventoryReportsLossSummaryExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Stock Value (INV-11-04), HQ only: quantity at the end of ``asAt`` per product
and outlet, valued at cost and at selling price before GST, side by side.
 * @summary Stock Value Report
 */
export const getStockValueReportApiInventoryReportsStockValueGetUrl = (params: StockValueReportApiInventoryReportsStockValueGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/stock-value?${stringifiedParams}` : `/api/inventory/reports/stock-value`
}

export const stockValueReportApiInventoryReportsStockValueGet = async (params: StockValueReportApiInventoryReportsStockValueGetParams, options?: RequestInit): Promise<StockValueResponse> => {
  
  return apiFetch<StockValueResponse>(getStockValueReportApiInventoryReportsStockValueGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Export Stock Value
 */
export const getExportStockValueApiInventoryReportsStockValueExportGetUrl = (params: ExportStockValueApiInventoryReportsStockValueExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/reports/stock-value/export?${stringifiedParams}` : `/api/inventory/reports/stock-value/export`
}

export const exportStockValueApiInventoryReportsStockValueExportGet = async (params: ExportStockValueApiInventoryReportsStockValueExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportStockValueApiInventoryReportsStockValueExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Stock valuation report: qty x unitCost per product x location.
 * @summary Get Valuation
 */
export const getGetValuationApiInventoryValuationGetUrl = (params?: GetValuationApiInventoryValuationGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/valuation?${stringifiedParams}` : `/api/inventory/valuation`
}

export const getValuationApiInventoryValuationGet = async (params?: GetValuationApiInventoryValuationGetParams, options?: RequestInit): Promise<ValuationResponse> => {
  
  return apiFetch<ValuationResponse>(getGetValuationApiInventoryValuationGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Paginated movement history -- the audit trail.
 * @summary List Movements
 */
export const getListMovementsApiInventoryMovementsGetUrl = (params?: ListMovementsApiInventoryMovementsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/movements?${stringifiedParams}` : `/api/inventory/movements`
}

export const listMovementsApiInventoryMovementsGet = async (params?: ListMovementsApiInventoryMovementsGetParams, options?: RequestInit): Promise<MovementListResponse> => {
  
  return apiFetch<MovementListResponse>(getListMovementsApiInventoryMovementsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ makes a treatment or product Active / Inactive; the change is kept in the history.
 * @summary Create Status Change
 */
export const getCreateStatusChangeApiInventoryStatusChangesPostUrl = () => {


  

  return `/api/inventory/status-changes`
}

export const createStatusChangeApiInventoryStatusChangesPost = async (statusChangeCreate: StatusChangeCreate, options?: RequestInit): Promise<StatusChangeResponse> => {
  
  return apiFetch<StatusChangeResponse>(getCreateStatusChangeApiInventoryStatusChangesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      statusChangeCreate,)
  }
);}



/**
 * The status history of one treatment or product, newest first.
 * @summary List Status Changes
 */
export const getListStatusChangesApiInventoryStatusChangesGetUrl = (params: ListStatusChangesApiInventoryStatusChangesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/status-changes?${stringifiedParams}` : `/api/inventory/status-changes`
}

export const listStatusChangesApiInventoryStatusChangesGet = async (params: ListStatusChangesApiInventoryStatusChangesGetParams, options?: RequestInit): Promise<StatusChangeResponse[]> => {
  
  return apiFetch<StatusChangeResponse[]>(getListStatusChangesApiInventoryStatusChangesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Treatment & Product Status (INV-12-09): current status, and the changes in a period.
 * @summary Get Status Report
 */
export const getGetStatusReportApiInventoryStatusReportGetUrl = (params?: GetStatusReportApiInventoryStatusReportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/status-report?${stringifiedParams}` : `/api/inventory/status-report`
}

export const getStatusReportApiInventoryStatusReportGet = async (params?: GetStatusReportApiInventoryStatusReportGetParams, options?: RequestInit): Promise<StatusReportResponse> => {
  
  return apiFetch<StatusReportResponse>(getGetStatusReportApiInventoryStatusReportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Both tables of the report as one Excel sheet (a 'Table' column tells them apart).
 * @summary Export Status Report
 */
export const getExportStatusReportApiInventoryStatusReportExportGetUrl = (params?: ExportStatusReportApiInventoryStatusReportExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/status-report/export?${stringifiedParams}` : `/api/inventory/status-report/export`
}

export const exportStatusReportApiInventoryStatusReportExportGet = async (params?: ExportStatusReportApiInventoryStatusReportExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportStatusReportApiInventoryStatusReportExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * ``almostVip`` (VIP only, LEA-19-06): the Almost VIP tab.
 * @summary Get Lead List
 */
export const getGetLeadListApiLeadsListsListKeyGetUrl = (listKey: LeadListKey,
    params?: GetLeadListApiLeadsListsListKeyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/lists/${listKey}?${stringifiedParams}` : `/api/leads/lists/${listKey}`
}

export const getLeadListApiLeadsListsListKeyGet = async (listKey: LeadListKey,
    params?: GetLeadListApiLeadsListsListKeyGetParams, options?: RequestInit): Promise<LeadListResponse> => {
  
  return apiFetch<LeadListResponse>(getGetLeadListApiLeadsListsListKeyGetUrl(listKey,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Export Excel for one list: the screen's columns in the same order,
WITHOUT the Mobile column (LEA-01-09, LEA-27-19, LEA-00-23).
 * @summary Export Lead List
 */
export const getExportLeadListApiLeadsListsListKeyExportGetUrl = (listKey: LeadListKey,
    params?: ExportLeadListApiLeadsListsListKeyExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/lists/${listKey}/export?${stringifiedParams}` : `/api/leads/lists/${listKey}/export`
}

export const exportLeadListApiLeadsListsListKeyExportGet = async (listKey: LeadListKey,
    params?: ExportLeadListApiLeadsListsListKeyExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportLeadListApiLeadsListsListKeyExportGetUrl(listKey,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The rules in force for an outlet (or every outlet), what is pending
from tomorrow, and the full change history. Office staff can view.
 * @summary Get Leads Settings
 */
export const getGetLeadsSettingsApiLeadsSettingsGetUrl = (params?: GetLeadsSettingsApiLeadsSettingsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/settings?${stringifiedParams}` : `/api/leads/settings`
}

export const getLeadsSettingsApiLeadsSettingsGet = async (params?: GetLeadsSettingsApiLeadsSettingsGetParams, options?: RequestInit): Promise<LeadsSettingsScreen> => {
  
  return apiFetch<LeadsSettingsScreen>(getGetLeadsSettingsApiLeadsSettingsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Owner / management change (ADMIN): saved now, in force from tomorrow
morning (LEA-16-03); the old value is kept beside the new one.
 * @summary Put Leads Setting
 */
export const getPutLeadsSettingApiLeadsSettingsKeyPutUrl = (key: string,) => {


  

  return `/api/leads/settings/${key}`
}

export const putLeadsSettingApiLeadsSettingsKeyPut = async (key: string,
    leadsSettingUpdate: LeadsSettingUpdate, options?: RequestInit): Promise<LeadsSettingChange> => {
  
  return apiFetch<LeadsSettingChange>(getPutLeadsSettingApiLeadsSettingsKeyPutUrl(key),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadsSettingUpdate,)
  }
);}



/**
 * The Close dropdown (LEA-04-07), from Leads settings (LEA-16-08).
 * @summary Get Close Reasons
 */
export const getGetCloseReasonsApiLeadsCloseReasonsGetUrl = (params?: GetCloseReasonsApiLeadsCloseReasonsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/close-reasons?${stringifiedParams}` : `/api/leads/close-reasons`
}

export const getCloseReasonsApiLeadsCloseReasonsGet = async (params?: GetCloseReasonsApiLeadsCloseReasonsGetParams, options?: RequestInit): Promise<CloseReasonList> => {
  
  return apiFetch<CloseReasonList>(getGetCloseReasonsApiLeadsCloseReasonsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Her whole contact history, newest first, plus this month's count, last
month's, and the lists she is on now (LEA-15).
 * @summary Get Contact History
 */
export const getGetContactHistoryApiLeadsCustomersCustomerIdContactsGetUrl = (customerId: string,) => {


  

  return `/api/leads/customers/${customerId}/contacts`
}

export const getContactHistoryApiLeadsCustomersCustomerIdContactsGet = async (customerId: string, options?: RequestInit): Promise<LeadContactHistory> => {
  
  return apiFetch<LeadContactHistory>(getGetContactHistoryApiLeadsCustomersCustomerIdContactsGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * 'Save and next customer' — records ONE contact with its results in the
order pressed (LEA-04-04/05). The OS fills in date, time, staff, contact
number and next contact date; nothing here is ever edited afterwards.
 * @summary Log Contact
 */
export const getLogContactApiLeadsCustomersCustomerIdContactsPostUrl = (customerId: string,) => {


  

  return `/api/leads/customers/${customerId}/contacts`
}

export const logContactApiLeadsCustomersCustomerIdContactsPost = async (customerId: string,
    leadContactCreate: LeadContactCreate, options?: RequestInit): Promise<LeadContactOut> => {
  
  return apiFetch<LeadContactOut>(getLogContactApiLeadsCustomersCustomerIdContactsPostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadContactCreate,)
  }
);}



/**
 * The finished text, the Authority choices from the Outlet Authority
chart, and what was already logged for her (LEA-30-06).
 * @summary Get Returning Message
 */
export const getGetReturningMessageApiLeadsCustomersCustomerIdReturningMessageGetUrl = (customerId: string,
    params?: GetReturningMessageApiLeadsCustomersCustomerIdReturningMessageGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/customers/${customerId}/returning-message?${stringifiedParams}` : `/api/leads/customers/${customerId}/returning-message`
}

export const getReturningMessageApiLeadsCustomersCustomerIdReturningMessageGet = async (customerId: string,
    params?: GetReturningMessageApiLeadsCustomersCustomerIdReturningMessageGetParams, options?: RequestInit): Promise<ReturningMessageState> => {
  
  return apiFetch<ReturningMessageState>(getGetReturningMessageApiLeadsCustomersCustomerIdReturningMessageGetUrl(customerId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * 'Send': logs the message as sent and marks Authority on her next booking
(LEA-30-05). The panel copies the returned text; nothing is delivered.
 * @summary Send Returning Message
 */
export const getSendReturningMessageApiLeadsCustomersCustomerIdReturningMessagePostUrl = (customerId: string,) => {


  

  return `/api/leads/customers/${customerId}/returning-message`
}

export const sendReturningMessageApiLeadsCustomersCustomerIdReturningMessagePost = async (customerId: string,
    returningMessageSend: ReturningMessageSend, options?: RequestInit): Promise<ReturningMessageResult> => {
  
  return apiFetch<ReturningMessageResult>(getSendReturningMessageApiLeadsCustomersCustomerIdReturningMessagePostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      returningMessageSend,)
  }
);}



/**
 * One place to see everyone on hold: Temporary, Never again, Released
(LEA-13-01), plus the no-marketing-consent customers (LEA-13-02).
 * @summary Get Dnc List
 */
export const getGetDncListApiLeadsDncGetUrl = (params?: GetDncListApiLeadsDncGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/dnc?${stringifiedParams}` : `/api/leads/dnc`
}

export const getDncListApiLeadsDncGet = async (params?: GetDncListApiLeadsDncGetParams, options?: RequestInit): Promise<DncListResponse> => {
  
  return apiFetch<DncListResponse>(getGetDncListApiLeadsDncGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Dnc Reasons
 */
export const getGetDncReasonsApiLeadsDncReasonsGetUrl = (params?: GetDncReasonsApiLeadsDncReasonsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/dnc/reasons?${stringifiedParams}` : `/api/leads/dnc/reasons`
}

export const getDncReasonsApiLeadsDncReasonsGet = async (params?: GetDncReasonsApiLeadsDncReasonsGetParams, options?: RequestInit): Promise<DncReasons> => {
  
  return apiFetch<DncReasons>(getGetDncReasonsApiLeadsDncReasonsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The DNC window's Save (LEA-06): the hold and its contact line, at once.
 * @summary Set Do Not Contact
 */
export const getSetDoNotContactApiLeadsCustomersCustomerIdDncPostUrl = (customerId: string,) => {


  

  return `/api/leads/customers/${customerId}/dnc`
}

export const setDoNotContactApiLeadsCustomersCustomerIdDncPost = async (customerId: string,
    dncCreate: DncCreate, options?: RequestInit): Promise<DncOut> => {
  
  return apiFetch<DncOut>(getSetDoNotContactApiLeadsCustomersCustomerIdDncPostUrl(customerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dncCreate,)
  }
);}



/**
 * End a hold (LEA-13-03): anyone with Leads access ends a temporary one;
only an ADMIN undoes Never again.
 * @summary Release Do Not Contact
 */
export const getReleaseDoNotContactApiLeadsDncHoldIdReleasePostUrl = (holdId: string,) => {


  

  return `/api/leads/dnc/${holdId}/release`
}

export const releaseDoNotContactApiLeadsDncHoldIdReleasePost = async (holdId: string, options?: RequestInit): Promise<DncOut> => {
  
  return apiFetch<DncOut>(getReleaseDoNotContactApiLeadsDncHoldIdReleasePostUrl(holdId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Customers and older leads with the same phone number (LEA-07-04) —
shown so a person can choose; never joined by the OS.
 * @summary Get Lead Matches
 */
export const getGetLeadMatchesApiLeadsNewMatchesGetUrl = (params: GetLeadMatchesApiLeadsNewMatchesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/new/matches?${stringifiedParams}` : `/api/leads/new/matches`
}

export const getLeadMatchesApiLeadsNewMatchesGet = async (params: GetLeadMatchesApiLeadsNewMatchesGetParams, options?: RequestInit): Promise<LeadMatches> => {
  
  return apiFetch<LeadMatches>(getGetLeadMatchesApiLeadsNewMatchesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Add lead (LEA-07-02): a walk-in or a referral, typed by staff.
 * @summary Add Lead
 */
export const getAddLeadApiLeadsNewPostUrl = () => {


  

  return `/api/leads/new`
}

export const addLeadApiLeadsNewPost = async (leadCreate: LeadCreate, options?: RequestInit): Promise<LeadOut> => {
  
  return apiFetch<LeadOut>(getAddLeadApiLeadsNewPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadCreate,)
  }
);}



/**
 * @summary Get Lead
 */
export const getGetLeadApiLeadsNewLeadIdGetUrl = (leadId: string,) => {


  

  return `/api/leads/new/${leadId}`
}

export const getLeadApiLeadsNewLeadIdGet = async (leadId: string, options?: RequestInit): Promise<LeadOut> => {
  
  return apiFetch<LeadOut>(getGetLeadApiLeadsNewLeadIdGetUrl(leadId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * 'This is her' or 'Someone else — keep as new lead' (LEA-07-10).
 * @summary Link Lead
 */
export const getLinkLeadApiLeadsNewLeadIdLinkPostUrl = (leadId: string,) => {


  

  return `/api/leads/new/${leadId}/link`
}

export const linkLeadApiLeadsNewLeadIdLinkPost = async (leadId: string,
    leadLink: LeadLink, options?: RequestInit): Promise<LeadOut> => {
  
  return apiFetch<LeadOut>(getLinkLeadApiLeadsNewLeadIdLinkPostUrl(leadId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadLink,)
  }
);}



/**
 * A New Lead's history: four boxes from the day she came in (LEA-07-08).
 * @summary Get Lead Contact History
 */
export const getGetLeadContactHistoryApiLeadsNewLeadIdContactsGetUrl = (leadId: string,) => {


  

  return `/api/leads/new/${leadId}/contacts`
}

export const getLeadContactHistoryApiLeadsNewLeadIdContactsGet = async (leadId: string, options?: RequestInit): Promise<LeadContactHistory> => {
  
  return apiFetch<LeadContactHistory>(getGetLeadContactHistoryApiLeadsNewLeadIdContactsGetUrl(leadId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The same Log contact panel, saved against the lead (LEA-05-01).
 * @summary Log Lead Contact
 */
export const getLogLeadContactApiLeadsNewLeadIdContactsPostUrl = (leadId: string,) => {


  

  return `/api/leads/new/${leadId}/contacts`
}

export const logLeadContactApiLeadsNewLeadIdContactsPost = async (leadId: string,
    leadContactCreate: LeadContactCreate, options?: RequestInit): Promise<LeadContactOut> => {
  
  return apiFetch<LeadContactOut>(getLogLeadContactApiLeadsNewLeadIdContactsPostUrl(leadId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadContactCreate,)
  }
);}



/**
 * Tab 2 'Booking follow-up': Contact today · Next · Done today, the two
numbers at the top and the before-closing check. Made by the OS from the
lists; staff never add to it (LEA-02-03). Reading an outlet's queue also
moves its red customers over the day's target to the office person
(DSH-15); the caller's own 'From the outlet' group comes back with it.
 * @summary Get Follow Up Queue
 */
export const getGetFollowUpQueueApiLeadsFollowUpQueueGetUrl = (params?: GetFollowUpQueueApiLeadsFollowUpQueueGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/follow-up/queue?${stringifiedParams}` : `/api/leads/follow-up/queue`
}

export const getFollowUpQueueApiLeadsFollowUpQueueGet = async (params?: GetFollowUpQueueApiLeadsFollowUpQueueGetParams, options?: RequestInit): Promise<FollowUpQueueResponse> => {
  
  return apiFetch<FollowUpQueueResponse>(getGetFollowUpQueueApiLeadsFollowUpQueueGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * 'Hanie is contacting · n min' (LEA-05-06): mark her as open for this
account, or say who already has her.
 * @summary Open Follow Up Customer
 */
export const getOpenFollowUpCustomerApiLeadsFollowUpOpenCustomerIdPostUrl = (customerId: string,) => {


  

  return `/api/leads/follow-up/open/${customerId}`
}

export const openFollowUpCustomerApiLeadsFollowUpOpenCustomerIdPost = async (customerId: string, options?: RequestInit): Promise<FollowUpLockOut> => {
  
  return apiFetch<FollowUpLockOut>(getOpenFollowUpCustomerApiLeadsFollowUpOpenCustomerIdPostUrl(customerId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Skip / Next customer without saving: let her go for the colleagues.
 * @summary Release Follow Up Customer
 */
export const getReleaseFollowUpCustomerApiLeadsFollowUpReleaseCustomerIdPostUrl = (customerId: string,) => {


  

  return `/api/leads/follow-up/release/${customerId}`
}

export const releaseFollowUpCustomerApiLeadsFollowUpReleaseCustomerIdPost = async (customerId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getReleaseFollowUpCustomerApiLeadsFollowUpReleaseCustomerIdPostUrl(customerId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Tab 3, the Daily Closing Report (LEA-26-02): Contacted and Appointments
made per list from logged contacts; counts only, no targets, no table by
consultant.
 * @summary Get Closing Report
 */
export const getGetClosingReportApiLeadsFollowUpClosingReportGetUrl = (params: GetClosingReportApiLeadsFollowUpClosingReportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/follow-up/closing-report?${stringifiedParams}` : `/api/leads/follow-up/closing-report`
}

export const getClosingReportApiLeadsFollowUpClosingReportGet = async (params: GetClosingReportApiLeadsFollowUpClosingReportGetParams, options?: RequestInit): Promise<ClosingReportResponse> => {
  
  return apiFetch<ClosingReportResponse>(getGetClosingReportApiLeadsFollowUpClosingReportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Export Excel on the Closing report gives the lines shown (GEN-04-13).
 * @summary Export Closing Report
 */
export const getExportClosingReportApiLeadsFollowUpClosingReportExportGetUrl = (params: ExportClosingReportApiLeadsFollowUpClosingReportExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/follow-up/closing-report/export?${stringifiedParams}` : `/api/leads/follow-up/closing-report/export`
}

export const exportClosingReportApiLeadsFollowUpClosingReportExportGet = async (params: ExportClosingReportApiLeadsFollowUpClosingReportExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportClosingReportApiLeadsFollowUpClosingReportExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The month's result per list, from the snapshot (LEA-33-03/04/05).
 * @summary Get List Results
 */
export const getGetListResultsApiLeadsReportsListResultsGetUrl = (params: GetListResultsApiLeadsReportsListResultsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/reports/list-results?${stringifiedParams}` : `/api/leads/reports/list-results`
}

export const getListResultsApiLeadsReportsListResultsGet = async (params: GetListResultsApiLeadsReportsListResultsGetParams, options?: RequestInit): Promise<ListResultsResponse> => {
  
  return apiFetch<ListResultsResponse>(getGetListResultsApiLeadsReportsListResultsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Export Excel on this screen gives the lines shown (LEA-33-06).
 * @summary Export List Results
 */
export const getExportListResultsApiLeadsReportsListResultsExportGetUrl = (params: ExportListResultsApiLeadsReportsListResultsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/reports/list-results/export?${stringifiedParams}` : `/api/leads/reports/list-results/export`
}

export const exportListResultsApiLeadsReportsListResultsExportGet = async (params: ExportListResultsApiLeadsReportsListResultsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportListResultsApiLeadsReportsListResultsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Open snapshot (LEA-33-06): the list as it stood that month, read-only.
 * @summary Get List Snapshot
 */
export const getGetListSnapshotApiLeadsReportsListResultsSnapshotGetUrl = (params: GetListSnapshotApiLeadsReportsListResultsSnapshotGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/reports/list-results/snapshot?${stringifiedParams}` : `/api/leads/reports/list-results/snapshot`
}

export const getListSnapshotApiLeadsReportsListResultsSnapshotGet = async (params: GetListSnapshotApiLeadsReportsListResultsSnapshotGetParams, options?: RequestInit): Promise<SnapshotRowsResponse> => {
  
  return apiFetch<SnapshotRowsResponse>(getGetListSnapshotApiLeadsReportsListResultsSnapshotGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Outlet view 'Today's follow-up' (DSH-13): one line per Leads list in two
groups — Appointment check (cleared or not) and Booking follow-up (target,
contacted, appointments made) — plus the header figures. Read-only; the
same data as the Follow-up tabs. No money: the signal stays empty.
 * @summary Get Follow Up Today
 */
export const getGetFollowUpTodayApiLeadsFollowUpTodayGetUrl = (params?: GetFollowUpTodayApiLeadsFollowUpTodayGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/follow-up/today?${stringifiedParams}` : `/api/leads/follow-up/today`
}

export const getFollowUpTodayApiLeadsFollowUpTodayGet = async (params?: GetFollowUpTodayApiLeadsFollowUpTodayGetParams, options?: RequestInit): Promise<FollowUpTodayResponse> => {
  
  return apiFetch<FollowUpTodayResponse>(getGetFollowUpTodayApiLeadsFollowUpTodayGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The checklist (LEA-28): tomorrow's appointments to confirm, freed slots
with the waitlist customers who fit, consultation time to block, open
complaints. Nothing here counts towards the day's numbers (LEA-28-07).
 * @summary Get Appointment Check
 */
export const getGetAppointmentCheckApiLeadsFollowUpCheckGetUrl = (params?: GetAppointmentCheckApiLeadsFollowUpCheckGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/follow-up/check?${stringifiedParams}` : `/api/leads/follow-up/check`
}

export const getAppointmentCheckApiLeadsFollowUpCheckGet = async (params?: GetAppointmentCheckApiLeadsFollowUpCheckGetParams, options?: RequestInit): Promise<AppointmentCheckResponse> => {
  
  return apiFetch<AppointmentCheckResponse>(getGetAppointmentCheckApiLeadsFollowUpCheckGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Confirmed sets the booking to Confirmed (LEA-28-04 1, LEA-28-06).
 * @summary Check Confirm
 */
export const getCheckConfirmApiLeadsFollowUpCheckAppointmentIdConfirmPostUrl = (appointmentId: string,) => {


  

  return `/api/leads/follow-up/check/${appointmentId}/confirm`
}

export const checkConfirmApiLeadsFollowUpCheckAppointmentIdConfirmPost = async (appointmentId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getCheckConfirmApiLeadsFollowUpCheckAppointmentIdConfirmPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Didn't pick up: one grey line in her history, the status unchanged.
 * @summary Check Didnt Pick Up
 */
export const getCheckDidntPickUpApiLeadsFollowUpCheckAppointmentIdDidntPickUpPostUrl = (appointmentId: string,) => {


  

  return `/api/leads/follow-up/check/${appointmentId}/didnt-pick-up`
}

export const checkDidntPickUpApiLeadsFollowUpCheckAppointmentIdDidntPickUpPost = async (appointmentId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getCheckDidntPickUpApiLeadsFollowUpCheckAppointmentIdDidntPickUpPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Cancelled asks the reason (OPS-07-07) and sets the booking status.
 * @summary Check Cancel
 */
export const getCheckCancelApiLeadsFollowUpCheckAppointmentIdCancelPostUrl = (appointmentId: string,) => {


  

  return `/api/leads/follow-up/check/${appointmentId}/cancel`
}

export const checkCancelApiLeadsFollowUpCheckAppointmentIdCancelPost = async (appointmentId: string,
    checkCancelIn: CheckCancelIn, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getCheckCancelApiLeadsFollowUpCheckAppointmentIdCancelPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkCancelIn,)
  }
);}



/**
 * Not needed is remembered for that appointment (LEA-24-12).
 * @summary Check Consult Not Needed
 */
export const getCheckConsultNotNeededApiLeadsFollowUpCheckAppointmentIdConsultNotNeededPostUrl = (appointmentId: string,) => {


  

  return `/api/leads/follow-up/check/${appointmentId}/consult-not-needed`
}

export const checkConsultNotNeededApiLeadsFollowUpCheckAppointmentIdConsultNotNeededPost = async (appointmentId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getCheckConsultNotNeededApiLeadsFollowUpCheckAppointmentIdConsultNotNeededPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * [Add] on a consultation line (LEA-24-08): the 30-minute card goes onto
that booking right after the treatment, exactly as Appointment Details
adds it (OPS-21-03), and one grey line is written in her history. The
treatment is never moved; a booking that already has the card, is too far
along or falls outside opening hours answers 409 with the reason.
 * @summary Check Consult Add
 */
export const getCheckConsultAddApiLeadsFollowUpCheckAppointmentIdConsultAddPostUrl = (appointmentId: string,) => {


  

  return `/api/leads/follow-up/check/${appointmentId}/consult-add`
}

export const checkConsultAddApiLeadsFollowUpCheckAppointmentIdConsultAddPost = async (appointmentId: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getCheckConsultAddApiLeadsFollowUpCheckAppointmentIdConsultAddPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Templates
 */
export const getListTemplatesApiLeadsTemplatesGetUrl = (params?: ListTemplatesApiLeadsTemplatesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/templates?${stringifiedParams}` : `/api/leads/templates`
}

export const listTemplatesApiLeadsTemplatesGet = async (params?: ListTemplatesApiLeadsTemplatesGetParams, options?: RequestInit): Promise<TemplateListResponse> => {
  
  return apiFetch<TemplateListResponse>(getListTemplatesApiLeadsTemplatesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Add a template (LEA-22-06 2) — saved as a draft until confirmed.
 * @summary Create Template
 */
export const getCreateTemplateApiLeadsTemplatesPostUrl = () => {


  

  return `/api/leads/templates`
}

export const createTemplateApiLeadsTemplatesPost = async (templateCreate: TemplateCreate, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getCreateTemplateApiLeadsTemplatesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateCreate,)
  }
);}



/**
 * LEA-23-04: the confirmed templates suggested for her list, the best
first — by her women/men group, and on New Leads by whether she gave a date.
 * @summary Picked For Her
 */
export const getPickedForHerApiLeadsTemplatesPickedForHerGetUrl = (params: PickedForHerApiLeadsTemplatesPickedForHerGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/templates/picked-for-her?${stringifiedParams}` : `/api/leads/templates/picked-for-her`
}

export const pickedForHerApiLeadsTemplatesPickedForHerGet = async (params: PickedForHerApiLeadsTemplatesPickedForHerGetParams, options?: RequestInit): Promise<PickedForHer> => {
  
  return apiFetch<PickedForHer>(getPickedForHerApiLeadsTemplatesPickedForHerGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ only: read the sheet (one tab per customer type) and show what would
be imported. Writes nothing.
 * @summary Import Preview
 */
export const getImportPreviewApiLeadsTemplatesImportPreviewPostUrl = () => {


  

  return `/api/leads/templates/import/preview`
}

export const importPreviewApiLeadsTemplatesImportPreviewPost = async (bodyImportPreviewApiLeadsTemplatesImportPreviewPost: BodyImportPreviewApiLeadsTemplatesImportPreviewPost, options?: RequestInit): Promise<ImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyImportPreviewApiLeadsTemplatesImportPreviewPost.file)

  return apiFetch<ImportPreview>(getImportPreviewApiLeadsTemplatesImportPreviewPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * HQ only: create a DRAFT template per sheet row. The draft → confirm rule
stays (someone other than the writer confirms). Nothing is sent.
 * @summary Import Confirm
 */
export const getImportConfirmApiLeadsTemplatesImportPostUrl = () => {


  

  return `/api/leads/templates/import`
}

export const importConfirmApiLeadsTemplatesImportPost = async (bodyImportConfirmApiLeadsTemplatesImportPost: BodyImportConfirmApiLeadsTemplatesImportPost, options?: RequestInit): Promise<ImportResult> => {
    const formData = new FormData();
formData.append(`file`, bodyImportConfirmApiLeadsTemplatesImportPost.file)

  return apiFetch<ImportResult>(getImportConfirmApiLeadsTemplatesImportPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary Get Template
 */
export const getGetTemplateApiLeadsTemplatesTemplateIdGetUrl = (templateId: string,) => {


  

  return `/api/leads/templates/${templateId}`
}

export const getTemplateApiLeadsTemplatesTemplateIdGet = async (templateId: string, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getGetTemplateApiLeadsTemplatesTemplateIdGetUrl(templateId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Name, situation, women/men, suggested list and order, month tag, In use
(LEA-16-05, LEA-22-06 5). No new version is needed for these.
 * @summary Update Template Meta
 */
export const getUpdateTemplateMetaApiLeadsTemplatesTemplateIdPatchUrl = (templateId: string,) => {


  

  return `/api/leads/templates/${templateId}`
}

export const updateTemplateMetaApiLeadsTemplatesTemplateIdPatch = async (templateId: string,
    templateMetaUpdate: TemplateMetaUpdate, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getUpdateTemplateMetaApiLeadsTemplatesTemplateIdPatchUrl(templateId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateMetaUpdate,)
  }
);}



/**
 * Change the text or pictures (LEA-22-06 1, 5): a new draft, kept beside
the version in use (LEA-22-04, LEA-22-09).
 * @summary Add Version
 */
export const getAddVersionApiLeadsTemplatesTemplateIdVersionsPostUrl = (templateId: string,) => {


  

  return `/api/leads/templates/${templateId}/versions`
}

export const addVersionApiLeadsTemplatesTemplateIdVersionsPost = async (templateId: string,
    templateVersionCreate: TemplateVersionCreate, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getAddVersionApiLeadsTemplatesTemplateIdVersionsPostUrl(templateId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateVersionCreate,)
  }
);}



/**
 * Angela or Jii confirms a draft (LEA-22-04); the confirmer cannot be the
writer.
 * @summary Confirm Version
 */
export const getConfirmVersionApiLeadsTemplatesTemplateIdVersionsVersionIdConfirmPostUrl = (templateId: string,
    versionId: string,) => {


  

  return `/api/leads/templates/${templateId}/versions/${versionId}/confirm`
}

export const confirmVersionApiLeadsTemplatesTemplateIdVersionsVersionIdConfirmPost = async (templateId: string,
    versionId: string, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getConfirmVersionApiLeadsTemplatesTemplateIdVersionsVersionIdConfirmPostUrl(templateId,versionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Reject Version
 */
export const getRejectVersionApiLeadsTemplatesTemplateIdVersionsVersionIdRejectPostUrl = (templateId: string,
    versionId: string,
    params?: RejectVersionApiLeadsTemplatesTemplateIdVersionsVersionIdRejectPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/templates/${templateId}/versions/${versionId}/reject?${stringifiedParams}` : `/api/leads/templates/${templateId}/versions/${versionId}/reject`
}

export const rejectVersionApiLeadsTemplatesTemplateIdVersionsVersionIdRejectPost = async (templateId: string,
    versionId: string,
    params?: RejectVersionApiLeadsTemplatesTemplateIdVersionsVersionIdRejectPostParams, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getRejectVersionApiLeadsTemplatesTemplateIdVersionsVersionIdRejectPostUrl(templateId,versionId,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Retire, never delete (LEA-22-06 3).
 * @summary Retire Template
 */
export const getRetireTemplateApiLeadsTemplatesTemplateIdRetirePostUrl = (templateId: string,) => {


  

  return `/api/leads/templates/${templateId}/retire`
}

export const retireTemplateApiLeadsTemplatesTemplateIdRetirePost = async (templateId: string, options?: RequestInit): Promise<TemplateOut> => {
  
  return apiFetch<TemplateOut>(getRetireTemplateApiLeadsTemplatesTemplateIdRetirePostUrl(templateId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The finished message against a real customer (LEA-22-08).
 * @summary Preview Template
 */
export const getPreviewTemplateApiLeadsTemplatesTemplateIdPreviewGetUrl = (templateId: string,
    params: PreviewTemplateApiLeadsTemplatesTemplateIdPreviewGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/templates/${templateId}/preview?${stringifiedParams}` : `/api/leads/templates/${templateId}/preview`
}

export const previewTemplateApiLeadsTemplatesTemplateIdPreviewGet = async (templateId: string,
    params: PreviewTemplateApiLeadsTemplatesTemplateIdPreviewGetParams, options?: RequestInit): Promise<TemplatePreview> => {
  
  return apiFetch<TemplatePreview>(getPreviewTemplateApiLeadsTemplatesTemplateIdPreviewGetUrl(templateId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Pictures
 */
export const getListPicturesApiLeadsTemplatesPicturesGetUrl = (params?: ListPicturesApiLeadsTemplatesPicturesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leads/templates/pictures?${stringifiedParams}` : `/api/leads/templates/pictures`
}

export const listPicturesApiLeadsTemplatesPicturesGet = async (params?: ListPicturesApiLeadsTemplatesPicturesGetParams, options?: RequestInit): Promise<PictureListResponse> => {
  
  return apiFetch<PictureListResponse>(getListPicturesApiLeadsTemplatesPicturesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Upload a png or jpeg from the computer, name it, put it in a group
(LEA-22-06 4, LEA-22-10).
 * @summary Upload Picture
 */
export const getUploadPictureApiLeadsTemplatesPicturesPostUrl = () => {


  

  return `/api/leads/templates/pictures`
}

export const uploadPictureApiLeadsTemplatesPicturesPost = async (bodyUploadPictureApiLeadsTemplatesPicturesPost: BodyUploadPictureApiLeadsTemplatesPicturesPost, options?: RequestInit): Promise<PictureOut> => {
    const formData = new FormData();
formData.append(`file`, bodyUploadPictureApiLeadsTemplatesPicturesPost.file)
formData.append(`name`, bodyUploadPictureApiLeadsTemplatesPicturesPost.name)
if(bodyUploadPictureApiLeadsTemplatesPicturesPost.group !== undefined) {
 formData.append(`group`, bodyUploadPictureApiLeadsTemplatesPicturesPost.group)
 }

  return apiFetch<PictureOut>(getUploadPictureApiLeadsTemplatesPicturesPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary Update Picture
 */
export const getUpdatePictureApiLeadsTemplatesPicturesPictureIdPatchUrl = (pictureId: string,) => {


  

  return `/api/leads/templates/pictures/${pictureId}`
}

export const updatePictureApiLeadsTemplatesPicturesPictureIdPatch = async (pictureId: string,
    pictureUpdate: PictureUpdate, options?: RequestInit): Promise<PictureOut> => {
  
  return apiFetch<PictureOut>(getUpdatePictureApiLeadsTemplatesPicturesPictureIdPatchUrl(pictureId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pictureUpdate,)
  }
);}



/**
 * @summary Retire Picture
 */
export const getRetirePictureApiLeadsTemplatesPicturesPictureIdRetirePostUrl = (pictureId: string,) => {


  

  return `/api/leads/templates/pictures/${pictureId}/retire`
}

export const retirePictureApiLeadsTemplatesPicturesPictureIdRetirePost = async (pictureId: string, options?: RequestInit): Promise<PictureOut> => {
  
  return apiFetch<PictureOut>(getRetirePictureApiLeadsTemplatesPicturesPictureIdRetirePostUrl(pictureId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The picture bytes, for the thumbnail and the preview.
 * @summary Picture Data
 */
export const getPictureDataApiLeadsTemplatesPicturesPictureIdDataGetUrl = (pictureId: string,) => {


  

  return `/api/leads/templates/pictures/${pictureId}/data`
}

export const pictureDataApiLeadsTemplatesPicturesPictureIdDataGet = async (pictureId: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getPictureDataApiLeadsTemplatesPicturesPictureIdDataGetUrl(pictureId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Leave Approval Settings (Angela, 22 Oct 2026): who manages leave.
 * @summary Get Leave Managers
 */
export const getGetLeaveManagersApiLeaveManagersGetUrl = () => {


  

  return `/api/leave/managers`
}

export const getLeaveManagersApiLeaveManagersGet = async ( options?: RequestInit): Promise<LeaveManagerListResponse> => {
  
  return apiFetch<LeaveManagerListResponse>(getGetLeaveManagersApiLeaveManagersGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Replace the named leave managers (a leave manager edits the list). An
empty list returns to the default: admin logins and HQ staff.
 * @summary Put Leave Managers
 */
export const getPutLeaveManagersApiLeaveManagersPutUrl = () => {


  

  return `/api/leave/managers`
}

export const putLeaveManagersApiLeaveManagersPut = async (leaveManagersUpdateRequest: LeaveManagersUpdateRequest, options?: RequestInit): Promise<LeaveManagerListResponse> => {
  
  return apiFetch<LeaveManagerListResponse>(getPutLeaveManagersApiLeaveManagersPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveManagersUpdateRequest,)
  }
);}



/**
 * @summary List Entitlements
 */
export const getListEntitlementsApiLeaveEntitlementsGetUrl = (params?: ListEntitlementsApiLeaveEntitlementsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/entitlements?${stringifiedParams}` : `/api/leave/entitlements`
}

export const listEntitlementsApiLeaveEntitlementsGet = async (params?: ListEntitlementsApiLeaveEntitlementsGetParams, options?: RequestInit): Promise<LeaveEntitlementListResponse> => {
  
  return apiFetch<LeaveEntitlementListResponse>(getListEntitlementsApiLeaveEntitlementsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Entitlement
 */
export const getCreateEntitlementApiLeaveEntitlementsPostUrl = () => {


  

  return `/api/leave/entitlements`
}

export const createEntitlementApiLeaveEntitlementsPost = async (leaveEntitlementCreateRequest: LeaveEntitlementCreateRequest, options?: RequestInit): Promise<LeaveEntitlementResponse> => {
  
  return apiFetch<LeaveEntitlementResponse>(getCreateEntitlementApiLeaveEntitlementsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveEntitlementCreateRequest,)
  }
);}



/**
 * Materialize the default per-role x employment-type entitlement policy
(§8.1: FT 10 annual + 11 PH-off-in-lieu, PT 4 + 0). Idempotent — skips any
(role, employmentType) pair that already exists.
 * @summary Seed Entitlements
 */
export const getSeedEntitlementsApiLeaveEntitlementsSeedPostUrl = () => {


  

  return `/api/leave/entitlements/seed`
}

export const seedEntitlementsApiLeaveEntitlementsSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedEntitlementsApiLeaveEntitlementsSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Update Entitlement
 */
export const getUpdateEntitlementApiLeaveEntitlementsEntitlementIdPutUrl = (entitlementId: string,) => {


  

  return `/api/leave/entitlements/${entitlementId}`
}

export const updateEntitlementApiLeaveEntitlementsEntitlementIdPut = async (entitlementId: string,
    leaveEntitlementUpdateRequest: LeaveEntitlementUpdateRequest, options?: RequestInit): Promise<LeaveEntitlementResponse> => {
  
  return apiFetch<LeaveEntitlementResponse>(getUpdateEntitlementApiLeaveEntitlementsEntitlementIdPutUrl(entitlementId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveEntitlementUpdateRequest,)
  }
);}



/**
 * @summary Create Request
 */
export const getCreateRequestApiLeaveRequestsPostUrl = () => {


  

  return `/api/leave/requests`
}

export const createRequestApiLeaveRequestsPost = async (leaveRequestCreateRequest: LeaveRequestCreateRequest, options?: RequestInit): Promise<LeaveRequestResponse> => {
  
  return apiFetch<LeaveRequestResponse>(getCreateRequestApiLeaveRequestsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveRequestCreateRequest,)
  }
);}



/**
 * @summary List Requests
 */
export const getListRequestsApiLeaveRequestsGetUrl = (params?: ListRequestsApiLeaveRequestsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/requests?${stringifiedParams}` : `/api/leave/requests`
}

export const listRequestsApiLeaveRequestsGet = async (params?: ListRequestsApiLeaveRequestsGetParams, options?: RequestInit): Promise<LeaveRequestListResponse> => {
  
  return apiFetch<LeaveRequestListResponse>(getListRequestsApiLeaveRequestsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List My Requests
 */
export const getListMyRequestsApiLeaveRequestsMineGetUrl = (params?: ListMyRequestsApiLeaveRequestsMineGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/requests/mine?${stringifiedParams}` : `/api/leave/requests/mine`
}

export const listMyRequestsApiLeaveRequestsMineGet = async (params?: ListMyRequestsApiLeaveRequestsMineGetParams, options?: RequestInit): Promise<LeaveRequestListResponse> => {
  
  return apiFetch<LeaveRequestListResponse>(getListMyRequestsApiLeaveRequestsMineGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Request
 */
export const getGetRequestApiLeaveRequestsRequestIdGetUrl = (requestId: string,) => {


  

  return `/api/leave/requests/${requestId}`
}

export const getRequestApiLeaveRequestsRequestIdGet = async (requestId: string, options?: RequestInit): Promise<LeaveRequestResponse> => {
  
  return apiFetch<LeaveRequestResponse>(getGetRequestApiLeaveRequestsRequestIdGetUrl(requestId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-05 — HQ edits an annual-leave request (dates, part-day times).
 * @summary Update Request
 */
export const getUpdateRequestApiLeaveRequestsRequestIdPatchUrl = (requestId: string,) => {


  

  return `/api/leave/requests/${requestId}`
}

export const updateRequestApiLeaveRequestsRequestIdPatch = async (requestId: string,
    leaveRequestUpdateRequest: LeaveRequestUpdateRequest, options?: RequestInit): Promise<LeaveRequestResponse> => {
  
  return apiFetch<LeaveRequestResponse>(getUpdateRequestApiLeaveRequestsRequestIdPatchUrl(requestId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveRequestUpdateRequest,)
  }
);}



/**
 * @summary Leave Calendar
 */
export const getLeaveCalendarApiLeaveCalendarGetUrl = (params: LeaveCalendarApiLeaveCalendarGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/calendar?${stringifiedParams}` : `/api/leave/calendar`
}

export const leaveCalendarApiLeaveCalendarGet = async (params: LeaveCalendarApiLeaveCalendarGetParams, options?: RequestInit): Promise<LeaveCalendarResponse> => {
  
  return apiFetch<LeaveCalendarResponse>(getLeaveCalendarApiLeaveCalendarGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * My Profile > Leave Calendar: every signed-in staff member. Approved leave
only, of all staff; never the leave type or the reason.
 * @summary Staff Leave Calendar
 */
export const getStaffLeaveCalendarApiLeaveStaffCalendarGetUrl = (params: StaffLeaveCalendarApiLeaveStaffCalendarGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/staff-calendar?${stringifiedParams}` : `/api/leave/staff-calendar`
}

export const staffLeaveCalendarApiLeaveStaffCalendarGet = async (params: StaffLeaveCalendarApiLeaveStaffCalendarGetParams, options?: RequestInit): Promise<StaffLeaveCalendarResponse> => {
  
  return apiFetch<StaffLeaveCalendarResponse>(getStaffLeaveCalendarApiLeaveStaffCalendarGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Leave Year To Date
 */
export const getLeaveYearToDateApiLeaveYearToDateGetUrl = (params?: LeaveYearToDateApiLeaveYearToDateGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/year-to-date?${stringifiedParams}` : `/api/leave/year-to-date`
}

export const leaveYearToDateApiLeaveYearToDateGet = async (params?: LeaveYearToDateApiLeaveYearToDateGetParams, options?: RequestInit): Promise<LeaveYtdResponse> => {
  
  return apiFetch<LeaveYtdResponse>(getLeaveYearToDateApiLeaveYearToDateGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Approve Request
 */
export const getApproveRequestApiLeaveRequestsRequestIdApprovePostUrl = (requestId: string,) => {


  

  return `/api/leave/requests/${requestId}/approve`
}

export const approveRequestApiLeaveRequestsRequestIdApprovePost = async (requestId: string,
    leaveDecisionRequest: LeaveDecisionRequest, options?: RequestInit): Promise<LeaveRequestResponse> => {
  
  return apiFetch<LeaveRequestResponse>(getApproveRequestApiLeaveRequestsRequestIdApprovePostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveDecisionRequest,)
  }
);}



/**
 * @summary Reject Request
 */
export const getRejectRequestApiLeaveRequestsRequestIdRejectPostUrl = (requestId: string,) => {


  

  return `/api/leave/requests/${requestId}/reject`
}

export const rejectRequestApiLeaveRequestsRequestIdRejectPost = async (requestId: string,
    leaveDecisionRequest: LeaveDecisionRequest, options?: RequestInit): Promise<LeaveRequestResponse> => {
  
  return apiFetch<LeaveRequestResponse>(getRejectRequestApiLeaveRequestsRequestIdRejectPostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveDecisionRequest,)
  }
);}



/**
 * @summary Cancel Request
 */
export const getCancelRequestApiLeaveRequestsRequestIdCancelPostUrl = (requestId: string,) => {


  

  return `/api/leave/requests/${requestId}/cancel`
}

export const cancelRequestApiLeaveRequestsRequestIdCancelPost = async (requestId: string, options?: RequestInit): Promise<LeaveRequestResponse> => {
  
  return apiFetch<LeaveRequestResponse>(getCancelRequestApiLeaveRequestsRequestIdCancelPostUrl(requestId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HR-05-02 — AL days · used · left, PH days · used · left and OT earned ·
used · left for every active staff member (HQ). A future year is refused:
reading it would write that year's carry-forward rows for good.
 * @summary Get Entitlement Summary
 */
export const getGetEntitlementSummaryApiLeaveEntitlementsSummaryGetUrl = (params?: GetEntitlementSummaryApiLeaveEntitlementsSummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/entitlements/summary?${stringifiedParams}` : `/api/leave/entitlements/summary`
}

export const getEntitlementSummaryApiLeaveEntitlementsSummaryGet = async (params?: GetEntitlementSummaryApiLeaveEntitlementsSummaryGetParams, options?: RequestInit): Promise<EntitlementSummaryResponse> => {
  
  return apiFetch<EntitlementSummaryResponse>(getGetEntitlementSummaryApiLeaveEntitlementsSummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Balance
 */
export const getGetBalanceApiLeaveBalanceGetUrl = (params?: GetBalanceApiLeaveBalanceGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/balance?${stringifiedParams}` : `/api/leave/balance`
}

export const getBalanceApiLeaveBalanceGet = async (params?: GetBalanceApiLeaveBalanceGetParams, options?: RequestInit): Promise<LeaveBalanceResponse> => {
  
  return apiFetch<LeaveBalanceResponse>(getGetBalanceApiLeaveBalanceGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Credits
 */
export const getListCreditsApiLeaveCreditsGetUrl = (params?: ListCreditsApiLeaveCreditsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/credits?${stringifiedParams}` : `/api/leave/credits`
}

export const listCreditsApiLeaveCreditsGet = async (params?: ListCreditsApiLeaveCreditsGetParams, options?: RequestInit): Promise<LeaveCreditListResponse> => {
  
  return apiFetch<LeaveCreditListResponse>(getListCreditsApiLeaveCreditsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Credit
 */
export const getCreateCreditApiLeaveCreditsPostUrl = () => {


  

  return `/api/leave/credits`
}

export const createCreditApiLeaveCreditsPost = async (leaveCreditCreateRequest: LeaveCreditCreateRequest, options?: RequestInit): Promise<LeaveCreditResponse> => {
  
  return apiFetch<LeaveCreditResponse>(getCreateCreditApiLeaveCreditsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveCreditCreateRequest,)
  }
);}



/**
 * @summary List Ot Entries
 */
export const getListOtEntriesApiLeaveOtGetUrl = (params?: ListOtEntriesApiLeaveOtGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/ot?${stringifiedParams}` : `/api/leave/ot`
}

export const listOtEntriesApiLeaveOtGet = async (params?: ListOtEntriesApiLeaveOtGetParams, options?: RequestInit): Promise<OTLedgerListResponse> => {
  
  return apiFetch<OTLedgerListResponse>(getListOtEntriesApiLeaveOtGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Ot Entry
 */
export const getCreateOtEntryApiLeaveOtPostUrl = () => {


  

  return `/api/leave/ot`
}

export const createOtEntryApiLeaveOtPost = async (oTLedgerCreateRequest: OTLedgerCreateRequest, options?: RequestInit): Promise<OTLedgerEntryResponse> => {
  
  return apiFetch<OTLedgerEntryResponse>(getCreateOtEntryApiLeaveOtPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTLedgerCreateRequest,)
  }
);}



/**
 * @summary Get Ot Balance
 */
export const getGetOtBalanceApiLeaveOtBalanceGetUrl = (params?: GetOtBalanceApiLeaveOtBalanceGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/ot/balance?${stringifiedParams}` : `/api/leave/ot/balance`
}

export const getOtBalanceApiLeaveOtBalanceGet = async (params?: GetOtBalanceApiLeaveOtBalanceGetParams, options?: RequestInit): Promise<OTBalanceResponse> => {
  
  return apiFetch<OTBalanceResponse>(getGetOtBalanceApiLeaveOtBalanceGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * BUG-876 — a staff member applies to use their own OT.

Deliberately NOT admin-gated: this is the staff-facing half Angela asked for
("currently there's no option for her to apply"). Self-scoping is structural
— the service reads the staff id from the token, never from the body.
 * @summary Create Ot Request
 */
export const getCreateOtRequestApiLeaveOtRequestsPostUrl = () => {


  

  return `/api/leave/ot/requests`
}

export const createOtRequestApiLeaveOtRequestsPost = async (oTRequestCreate: OTRequestCreate, options?: RequestInit): Promise<OTRequestResponse> => {
  
  return apiFetch<OTRequestResponse>(getCreateOtRequestApiLeaveOtRequestsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTRequestCreate,)
  }
);}



/**
 * Own requests for staff; any for an admin (the manager approval queue).
 * @summary List Ot Requests
 */
export const getListOtRequestsApiLeaveOtRequestsGetUrl = (params?: ListOtRequestsApiLeaveOtRequestsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/ot/requests?${stringifiedParams}` : `/api/leave/ot/requests`
}

export const listOtRequestsApiLeaveOtRequestsGet = async (params?: ListOtRequestsApiLeaveOtRequestsGetParams, options?: RequestInit): Promise<OTRequestListResponse> => {
  
  return apiFetch<OTRequestListResponse>(getListOtRequestsApiLeaveOtRequestsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Lisa: "Prefer to have manager's approval too." The OT ledger is written
here, not at submission.
 * @summary Approve Ot Request
 */
export const getApproveOtRequestApiLeaveOtRequestsRequestIdApprovePostUrl = (requestId: string,) => {


  

  return `/api/leave/ot/requests/${requestId}/approve`
}

export const approveOtRequestApiLeaveOtRequestsRequestIdApprovePost = async (requestId: string,
    oTRequestReview: OTRequestReview, options?: RequestInit): Promise<OTRequestResponse> => {
  
  return apiFetch<OTRequestResponse>(getApproveOtRequestApiLeaveOtRequestsRequestIdApprovePostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTRequestReview,)
  }
);}



/**
 * @summary Reject Ot Request
 */
export const getRejectOtRequestApiLeaveOtRequestsRequestIdRejectPostUrl = (requestId: string,) => {


  

  return `/api/leave/ot/requests/${requestId}/reject`
}

export const rejectOtRequestApiLeaveOtRequestsRequestIdRejectPost = async (requestId: string,
    oTRequestReview: OTRequestReview, options?: RequestInit): Promise<OTRequestResponse> => {
  
  return apiFetch<OTRequestResponse>(getRejectOtRequestApiLeaveOtRequestsRequestIdRejectPostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTRequestReview,)
  }
);}



/**
 * Undo an approved OT request, returning its minutes to the balance.

409 rather than 400 on a status clash: the request is well-formed, it is the
server's current state that makes it impossible, and the UI distinguishes the
two (spec section 3.3). Same 409 for a request approved before
``OTLedger.otRequestId`` existed, which has no rows to reverse.
 * @summary Cancel Ot Request
 */
export const getCancelOtRequestApiLeaveOtRequestsRequestIdCancelPostUrl = (requestId: string,) => {


  

  return `/api/leave/ot/requests/${requestId}/cancel`
}

export const cancelOtRequestApiLeaveOtRequestsRequestIdCancelPost = async (requestId: string,
    oTCancelRequest: OTCancelRequest, options?: RequestInit): Promise<OTRequestResponse> => {
  
  return apiFetch<OTRequestResponse>(getCancelOtRequestApiLeaveOtRequestsRequestIdCancelPostUrl(requestId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTCancelRequest,)
  }
);}



/**
 * @summary Delete Ot Entry
 */
export const getDeleteOtEntryApiLeaveOtEntryIdDeleteUrl = (entryId: string,) => {


  

  return `/api/leave/ot/${entryId}`
}

export const deleteOtEntryApiLeaveOtEntryIdDelete = async (entryId: string, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getDeleteOtEntryApiLeaveOtEntryIdDeleteUrl(entryId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Overrides
 */
export const getListOverridesApiLeaveOverridesGetUrl = (params?: ListOverridesApiLeaveOverridesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/overrides?${stringifiedParams}` : `/api/leave/overrides`
}

export const listOverridesApiLeaveOverridesGet = async (params?: ListOverridesApiLeaveOverridesGetParams, options?: RequestInit): Promise<StaffLeaveEntitlementListResponse> => {
  
  return apiFetch<StaffLeaveEntitlementListResponse>(getListOverridesApiLeaveOverridesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Override
 */
export const getGetOverrideApiLeaveOverridesStaffIdGetUrl = (staffId: string,) => {


  

  return `/api/leave/overrides/${staffId}`
}

export const getOverrideApiLeaveOverridesStaffIdGet = async (staffId: string, options?: RequestInit): Promise<StaffLeaveEntitlementResponse> => {
  
  return apiFetch<StaffLeaveEntitlementResponse>(getGetOverrideApiLeaveOverridesStaffIdGetUrl(staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Override
 */
export const getUpsertOverrideApiLeaveOverridesStaffIdPutUrl = (staffId: string,) => {


  

  return `/api/leave/overrides/${staffId}`
}

export const upsertOverrideApiLeaveOverridesStaffIdPut = async (staffId: string,
    staffLeaveEntitlementUpsertRequest: StaffLeaveEntitlementUpsertRequest, options?: RequestInit): Promise<StaffLeaveEntitlementResponse> => {
  
  return apiFetch<StaffLeaveEntitlementResponse>(getUpsertOverrideApiLeaveOverridesStaffIdPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffLeaveEntitlementUpsertRequest,)
  }
);}



/**
 * Q41 - removing an override changes the person's AL, so it needs a remark
(400 without one) and is recorded in the adjustment history.
 * @summary Delete Override
 */
export const getDeleteOverrideApiLeaveOverridesStaffIdDeleteUrl = (staffId: string,
    params?: DeleteOverrideApiLeaveOverridesStaffIdDeleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/overrides/${staffId}?${stringifiedParams}` : `/api/leave/overrides/${staffId}`
}

export const deleteOverrideApiLeaveOverridesStaffIdDelete = async (staffId: string,
    params?: DeleteOverrideApiLeaveOverridesStaffIdDeleteParams, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getDeleteOverrideApiLeaveOverridesStaffIdDeleteUrl(staffId,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Get Carry Forward
 */
export const getGetCarryForwardApiLeaveCarryForwardStaffIdGetUrl = (staffId: string,
    params: GetCarryForwardApiLeaveCarryForwardStaffIdGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/carry-forward/${staffId}?${stringifiedParams}` : `/api/leave/carry-forward/${staffId}`
}

export const getCarryForwardApiLeaveCarryForwardStaffIdGet = async (staffId: string,
    params: GetCarryForwardApiLeaveCarryForwardStaffIdGetParams, options?: RequestInit): Promise<CarryForwardResponse> => {
  
  return apiFetch<CarryForwardResponse>(getGetCarryForwardApiLeaveCarryForwardStaffIdGetUrl(staffId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Set Carry Forward
 */
export const getSetCarryForwardApiLeaveCarryForwardStaffIdPutUrl = (staffId: string,) => {


  

  return `/api/leave/carry-forward/${staffId}`
}

export const setCarryForwardApiLeaveCarryForwardStaffIdPut = async (staffId: string,
    carryForwardUpdateRequest: CarryForwardUpdateRequest, options?: RequestInit): Promise<CarryForwardResponse> => {
  
  return apiFetch<CarryForwardResponse>(getSetCarryForwardApiLeaveCarryForwardStaffIdPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      carryForwardUpdateRequest,)
  }
);}



/**
 * @summary List Adjustments
 */
export const getListAdjustmentsApiLeaveAdjustmentsGetUrl = (params: ListAdjustmentsApiLeaveAdjustmentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/adjustments?${stringifiedParams}` : `/api/leave/adjustments`
}

export const listAdjustmentsApiLeaveAdjustmentsGet = async (params: ListAdjustmentsApiLeaveAdjustmentsGetParams, options?: RequestInit): Promise<LeaveAdjustmentListResponse> => {
  
  return apiFetch<LeaveAdjustmentListResponse>(getListAdjustmentsApiLeaveAdjustmentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Public Holidays
 */
export const getListPublicHolidaysApiLeavePublicHolidaysGetUrl = (params?: ListPublicHolidaysApiLeavePublicHolidaysGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leave/public-holidays?${stringifiedParams}` : `/api/leave/public-holidays`
}

export const listPublicHolidaysApiLeavePublicHolidaysGet = async (params?: ListPublicHolidaysApiLeavePublicHolidaysGetParams, options?: RequestInit): Promise<PublicHolidayListResponse> => {
  
  return apiFetch<PublicHolidayListResponse>(getListPublicHolidaysApiLeavePublicHolidaysGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Public Holiday
 */
export const getCreatePublicHolidayApiLeavePublicHolidaysPostUrl = () => {


  

  return `/api/leave/public-holidays`
}

export const createPublicHolidayApiLeavePublicHolidaysPost = async (publicHolidayCreateRequest: PublicHolidayCreateRequest, options?: RequestInit): Promise<PublicHolidayResponse> => {
  
  return apiFetch<PublicHolidayResponse>(getCreatePublicHolidayApiLeavePublicHolidaysPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicHolidayCreateRequest,)
  }
);}



/**
 * @summary Delete Public Holiday
 */
export const getDeletePublicHolidayApiLeavePublicHolidaysHolidayIdDeleteUrl = (holidayId: string,) => {


  

  return `/api/leave/public-holidays/${holidayId}`
}

export const deletePublicHolidayApiLeavePublicHolidaysHolidayIdDelete = async (holidayId: string, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getDeletePublicHolidayApiLeavePublicHolidaysHolidayIdDeleteUrl(holidayId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Every configured option in display order. A picker calls this with
``?listKey=X&enabled=true``; the admin page omits ``enabled`` so the
switched-off rows stay visible and re-enableable.

``inForceOn`` (MKT-01 / SAL-08-05, owner 15 Oct 2026): the invoice forms
pass the invoice date, and a Promotion (``MARKETING_ACTIVITY`` option) whose
From / To dates do not include that day is left out — after its To date a
promotion drops out of the invoice list by itself. A promotion with no
dates is always in force. Other lists ignore the parameter.

An unknown ``listKey`` returns an empty list rather than a 422 — a picker
for a list nobody has seeded yet must render empty, not error.
 * @summary List Lookup Options
 */
export const getListLookupOptionsApiSettingsLookupListsGetUrl = (params?: ListLookupOptionsApiSettingsLookupListsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/settings/lookup-lists?${stringifiedParams}` : `/api/settings/lookup-lists`
}

export const listLookupOptionsApiSettingsLookupListsGet = async (params?: ListLookupOptionsApiSettingsLookupListsGetParams, options?: RequestInit): Promise<LookupOptionListResponse> => {
  
  return apiFetch<LookupOptionListResponse>(getListLookupOptionsApiSettingsLookupListsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Add an option to the bottom of a list.

``code`` defaults to the label: the label lists (Marketing Activity, Credit
Type) snapshot the label onto the record, so for them the two are the same
string by construction and the admin form only asks for one field.
``DISCOUNT_APPROVER`` is the exception — its code is a ``Staff.id``, so it
is required and must resolve to a LIVE staff row.
 * @summary Create Lookup Option
 */
export const getCreateLookupOptionApiSettingsLookupListsPostUrl = () => {


  

  return `/api/settings/lookup-lists`
}

export const createLookupOptionApiSettingsLookupListsPost = async (lookupOptionCreate: LookupOptionCreate, options?: RequestInit): Promise<LookupOptionResponse> => {
  
  return apiFetch<LookupOptionResponse>(getCreateLookupOptionApiSettingsLookupListsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lookupOptionCreate,)
  }
);}



/**
 * Set each id's ``sortOrder`` to its index in ``ids``. Every id must exist
and belong to ``listKey``; ids omitted from the payload keep their current
order value.
 * @summary Reorder Lookup Options
 */
export const getReorderLookupOptionsApiSettingsLookupListsReorderPostUrl = () => {


  

  return `/api/settings/lookup-lists/reorder`
}

export const reorderLookupOptionsApiSettingsLookupListsReorderPost = async (lookupReorderRequest: LookupReorderRequest, options?: RequestInit): Promise<LookupOptionListResponse> => {
  
  return apiFetch<LookupOptionListResponse>(getReorderLookupOptionsApiSettingsLookupListsReorderPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lookupReorderRequest,)
  }
);}



/**
 * Seed every list with the values the hardcoded frontend arrays held.
Idempotent — an option whose ``(listKey, code)`` exists is skipped, never
overwritten, so a re-run cannot undo an admin's edits.
 * @summary Seed Lookup Lists Endpoint
 */
export const getSeedLookupListsEndpointApiSettingsLookupListsSeedPostUrl = () => {


  

  return `/api/settings/lookup-lists/seed`
}

export const seedLookupListsEndpointApiSettingsLookupListsSeedPost = async ( options?: RequestInit): Promise<LookupSeedResult> => {
  
  return apiFetch<LookupSeedResult>(getSeedLookupListsEndpointApiSettingsLookupListsSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Rename or switch an option on/off. Renaming only changes what NEW records
capture — the ones already written hold their own snapshot.

``isSystem`` rows cannot be switched off: application code branches on their
code (cancellation reason OTHER opens the free-text box), so hiding one would
silently delete a capability rather than an option. They can still be renamed.

The last enabled Promotion or Media option cannot be switched off either:
every invoice must carry one of each (SAL-08 / MKT-01-13).
 * @summary Update Lookup Option
 */
export const getUpdateLookupOptionApiSettingsLookupListsOptionIdPatchUrl = (optionId: string,) => {


  

  return `/api/settings/lookup-lists/${optionId}`
}

export const updateLookupOptionApiSettingsLookupListsOptionIdPatch = async (optionId: string,
    lookupOptionUpdate: LookupOptionUpdate, options?: RequestInit): Promise<LookupOptionResponse> => {
  
  return apiFetch<LookupOptionResponse>(getUpdateLookupOptionApiSettingsLookupListsOptionIdPatchUrl(optionId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lookupOptionUpdate,)
  }
);}



/**
 * Hard-delete, matching the Payment Types pattern. Safe for history because
no record stores the option id — switching off is still the gentler move and
what the admin page recommends. ``isSystem`` rows are refused: application
code branches on their code. The last enabled Promotion or Media option is
refused too — every invoice must carry one of each (SAL-08 / MKT-01-13).
 * @summary Delete Lookup Option
 */
export const getDeleteLookupOptionApiSettingsLookupListsOptionIdDeleteUrl = (optionId: string,) => {


  

  return `/api/settings/lookup-lists/${optionId}`
}

export const deleteLookupOptionApiSettingsLookupListsOptionIdDelete = async (optionId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteLookupOptionApiSettingsLookupListsOptionIdDeleteUrl(optionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * R5-23 — who may approve an invoice discount, resolved from the
``DISCOUNT_APPROVER`` list rather than the old "skill level 7+" filter the
invoice forms applied client-side.

Switched-off entries are excluded, and so is any entry whose staff row is no
longer live — inactive (left) or soft-deleted. An approver list is an
authority list: offering someone who no longer works here would let a
discount be attributed to a departed colleague, and the admin would have to
notice and prune the row by hand to stop it. ``name`` therefore always comes
from the live ``Staff`` row, so a renamed staff member reads correctly.
 * @summary List Discount Approvers
 */
export const getListDiscountApproversApiSettingsDiscountApproversGetUrl = () => {


  

  return `/api/settings/discount-approvers`
}

export const listDiscountApproversApiSettingsDiscountApproversGet = async ( options?: RequestInit): Promise<DiscountApproverListResponse> => {
  
  return apiFetch<DiscountApproverListResponse>(getListDiscountApproversApiSettingsDiscountApproversGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Every promotion in display order, archived rows included (``archived``
tells the screen which tab a row belongs to).
 * @summary List Promotions
 */
export const getListPromotionsApiMarketingPromotionsGetUrl = () => {


  

  return `/api/marketing/promotions`
}

export const listPromotionsApiMarketingPromotionsGet = async ( options?: RequestInit): Promise<PromotionListResponse> => {
  
  return apiFetch<PromotionListResponse>(getListPromotionsApiMarketingPromotionsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Promotion
 */
export const getCreatePromotionApiMarketingPromotionsPostUrl = () => {


  

  return `/api/marketing/promotions`
}

export const createPromotionApiMarketingPromotionsPost = async (promotionCreate: PromotionCreate, options?: RequestInit): Promise<PromotionResponse> => {
  
  return apiFetch<PromotionResponse>(getCreatePromotionApiMarketingPromotionsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      promotionCreate,)
  }
);}



/**
 * MKT-01-06 'Send to': the audiences on offer and the count per outlet of
the customers in the ticked ones (``?audience=KEY&audience=KEY``).
 * @summary Preview Audience
 */
export const getPreviewAudienceApiMarketingPromotionsAudiencePreviewGetUrl = (params?: PreviewAudienceApiMarketingPromotionsAudiencePreviewGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/promotions/audience-preview?${stringifiedParams}` : `/api/marketing/promotions/audience-preview`
}

export const previewAudienceApiMarketingPromotionsAudiencePreviewGet = async (params?: PreviewAudienceApiMarketingPromotionsAudiencePreviewGetParams, options?: RequestInit): Promise<AudiencePreviewResponse> => {
  
  return apiFetch<AudiencePreviewResponse>(getPreviewAudienceApiMarketingPromotionsAudiencePreviewGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Promotion
 */
export const getGetPromotionApiMarketingPromotionsPromotionIdGetUrl = (promotionId: string,) => {


  

  return `/api/marketing/promotions/${promotionId}`
}

export const getPromotionApiMarketingPromotionsPromotionIdGet = async (promotionId: string, options?: RequestInit): Promise<PromotionResponse> => {
  
  return apiFetch<PromotionResponse>(getGetPromotionApiMarketingPromotionsPromotionIdGetUrl(promotionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Promotion
 */
export const getUpdatePromotionApiMarketingPromotionsPromotionIdPatchUrl = (promotionId: string,) => {


  

  return `/api/marketing/promotions/${promotionId}`
}

export const updatePromotionApiMarketingPromotionsPromotionIdPatch = async (promotionId: string,
    promotionUpdate: PromotionUpdate, options?: RequestInit): Promise<PromotionResponse> => {
  
  return apiFetch<PromotionResponse>(getUpdatePromotionApiMarketingPromotionsPromotionIdPatchUrl(promotionId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      promotionUpdate,)
  }
);}



/**
 * @summary Delete Promotion
 */
export const getDeletePromotionApiMarketingPromotionsPromotionIdDeleteUrl = (promotionId: string,) => {


  

  return `/api/marketing/promotions/${promotionId}`
}

export const deletePromotionApiMarketingPromotionsPromotionIdDelete = async (promotionId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeletePromotionApiMarketingPromotionsPromotionIdDeleteUrl(promotionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Archive Promotion
 */
export const getArchivePromotionApiMarketingPromotionsPromotionIdArchivePostUrl = (promotionId: string,) => {


  

  return `/api/marketing/promotions/${promotionId}/archive`
}

export const archivePromotionApiMarketingPromotionsPromotionIdArchivePost = async (promotionId: string, options?: RequestInit): Promise<PromotionResponse> => {
  
  return apiFetch<PromotionResponse>(getArchivePromotionApiMarketingPromotionsPromotionIdArchivePostUrl(promotionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Restore Promotion
 */
export const getRestorePromotionApiMarketingPromotionsPromotionIdRestorePostUrl = (promotionId: string,) => {


  

  return `/api/marketing/promotions/${promotionId}/restore`
}

export const restorePromotionApiMarketingPromotionsPromotionIdRestorePost = async (promotionId: string, options?: RequestInit): Promise<PromotionResponse> => {
  
  return apiFetch<PromotionResponse>(getRestorePromotionApiMarketingPromotionsPromotionIdRestorePostUrl(promotionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Customers by Media / Marketing and Sales by Media / Marketing (Angela,
21 Oct 2026) — see marketing_report_service.breakdown.
 * @summary Report Breakdown
 */
export const getReportBreakdownApiMarketingReportsBreakdownGetUrl = (params: ReportBreakdownApiMarketingReportsBreakdownGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/reports/breakdown?${stringifiedParams}` : `/api/marketing/reports/breakdown`
}

export const reportBreakdownApiMarketingReportsBreakdownGet = async (params: ReportBreakdownApiMarketingReportsBreakdownGetParams, options?: RequestInit): Promise<MarketingBreakdownRow[]> => {
  
  return apiFetch<MarketingBreakdownRow[]>(getReportBreakdownApiMarketingReportsBreakdownGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * New customers between two dates, per Media (Summary and one Detail table per media).
 * @summary Customer Enrollment By Media
 */
export const getCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaGetUrl = (params: CustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["media"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/reports/customer-enrollment-by-media?${stringifiedParams}` : `/api/marketing/reports/customer-enrollment-by-media`
}

export const customerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaGet = async (params: CustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaGetParams, options?: RequestInit): Promise<CustomerEnrollmentByMediaResponse> => {
  
  return apiFetch<CustomerEnrollmentByMediaResponse>(getCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The report on screen as Excel: criteria, Summary and every Detail table (MKT-02-06).
 * @summary Export Customer Enrollment By Media
 */
export const getExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetUrl = (params: ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["media"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/reports/customer-enrollment-by-media/export?${stringifiedParams}` : `/api/marketing/reports/customer-enrollment-by-media/export`
}

export const exportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGet = async (params: ExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportCustomerEnrollmentByMediaApiMarketingReportsCustomerEnrollmentByMediaExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * New customers between two dates, per Promotion of their first invoice (MKT-02-12).
 * @summary Customer Enrollment By Promotion
 */
export const getCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionGetUrl = (params: CustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["promotions"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/reports/customer-enrollment-by-promotion?${stringifiedParams}` : `/api/marketing/reports/customer-enrollment-by-promotion`
}

export const customerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionGet = async (params: CustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionGetParams, options?: RequestInit): Promise<CustomerEnrollmentByPromotionResponse> => {
  
  return apiFetch<CustomerEnrollmentByPromotionResponse>(getCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The report on screen as Excel: criteria, Summary and every Detail table (MKT-02-06).
 * @summary Export Customer Enrollment By Promotion
 */
export const getExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetUrl = (params: ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["promotions"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/reports/customer-enrollment-by-promotion/export?${stringifiedParams}` : `/api/marketing/reports/customer-enrollment-by-promotion/export`
}

export const exportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGet = async (params: ExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportCustomerEnrollmentByPromotionApiMarketingReportsCustomerEnrollmentByPromotionExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Outlet Authority Options
 */
export const getOutletAuthorityOptionsApiMarketingOutletAuthorityOptionsGetUrl = (params?: OutletAuthorityOptionsApiMarketingOutletAuthorityOptionsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/outlet-authority/options?${stringifiedParams}` : `/api/marketing/outlet-authority/options`
}

export const outletAuthorityOptionsApiMarketingOutletAuthorityOptionsGet = async (params?: OutletAuthorityOptionsApiMarketingOutletAuthorityOptionsGetParams, options?: RequestInit): Promise<OutletAuthorityOptionsResponse> => {
  
  return apiFetch<OutletAuthorityOptionsResponse>(getOutletAuthorityOptionsApiMarketingOutletAuthorityOptionsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Charts
 */
export const getListChartsApiMarketingOutletAuthorityChartsGetUrl = () => {


  

  return `/api/marketing/outlet-authority/charts`
}

export const listChartsApiMarketingOutletAuthorityChartsGet = async ( options?: RequestInit): Promise<OutletAuthorityChartListResponse> => {
  
  return apiFetch<OutletAuthorityChartListResponse>(getListChartsApiMarketingOutletAuthorityChartsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Chart
 */
export const getCreateChartApiMarketingOutletAuthorityChartsPostUrl = () => {


  

  return `/api/marketing/outlet-authority/charts`
}

export const createChartApiMarketingOutletAuthorityChartsPost = async (outletAuthorityChartIn: OutletAuthorityChartIn, options?: RequestInit): Promise<OutletAuthorityChartOut> => {
  
  return apiFetch<OutletAuthorityChartOut>(getCreateChartApiMarketingOutletAuthorityChartsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletAuthorityChartIn,)
  }
);}



/**
 * @summary Current Chart
 */
export const getCurrentChartApiMarketingOutletAuthorityChartsCurrentGetUrl = (params?: CurrentChartApiMarketingOutletAuthorityChartsCurrentGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing/outlet-authority/charts/current?${stringifiedParams}` : `/api/marketing/outlet-authority/charts/current`
}

export const currentChartApiMarketingOutletAuthorityChartsCurrentGet = async (params?: CurrentChartApiMarketingOutletAuthorityChartsCurrentGetParams, options?: RequestInit): Promise<CurrentChartApiMarketingOutletAuthorityChartsCurrentGet200> => {
  
  return apiFetch<CurrentChartApiMarketingOutletAuthorityChartsCurrentGet200>(getCurrentChartApiMarketingOutletAuthorityChartsCurrentGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Chart
 */
export const getGetChartApiMarketingOutletAuthorityChartsChartIdGetUrl = (chartId: string,) => {


  

  return `/api/marketing/outlet-authority/charts/${chartId}`
}

export const getChartApiMarketingOutletAuthorityChartsChartIdGet = async (chartId: string, options?: RequestInit): Promise<OutletAuthorityChartOut> => {
  
  return apiFetch<OutletAuthorityChartOut>(getGetChartApiMarketingOutletAuthorityChartsChartIdGetUrl(chartId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Chart
 */
export const getUpdateChartApiMarketingOutletAuthorityChartsChartIdPutUrl = (chartId: string,) => {


  

  return `/api/marketing/outlet-authority/charts/${chartId}`
}

export const updateChartApiMarketingOutletAuthorityChartsChartIdPut = async (chartId: string,
    outletAuthorityChartIn: OutletAuthorityChartIn, options?: RequestInit): Promise<OutletAuthorityChartOut> => {
  
  return apiFetch<OutletAuthorityChartOut>(getUpdateChartApiMarketingOutletAuthorityChartsChartIdPutUrl(chartId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletAuthorityChartIn,)
  }
);}



/**
 * Full-text search across supported resources. Requires auth.
 * @summary Search
 */
export const getSearchApiSearchGetUrl = (params: SearchApiSearchGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search?${stringifiedParams}` : `/api/search`
}

export const searchApiSearchGet = async (params: SearchApiSearchGetParams, options?: RequestInit): Promise<SearchResponse> => {
  
  return apiFetch<SearchResponse>(getSearchApiSearchGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Public health check with lightweight DB ping.
 * @summary Health
 */
export const getHealthApiHealthGetUrl = () => {


  

  return `/api/health`
}

export const healthApiHealthGet = async ( options?: RequestInit): Promise<HealthResponse> => {
  
  return apiFetch<HealthResponse>(getHealthApiHealthGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Create an issue report. Requires auth.
 * @summary Report Issue
 */
export const getReportIssueApiReportIssuePostUrl = () => {


  

  return `/api/report-issue`
}

export const reportIssueApiReportIssuePost = async (reportIssueRequest: ReportIssueRequest, options?: RequestInit): Promise<ReportIssueResponse> => {
  
  return apiFetch<ReportIssueResponse>(getReportIssueApiReportIssuePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reportIssueRequest,)
  }
);}



/**
 * @summary Get Analytics
 */
export const getGetAnalyticsApiPackagesAnalyticsGetUrl = (params?: GetAnalyticsApiPackagesAnalyticsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/packages/analytics?${stringifiedParams}` : `/api/packages/analytics`
}

export const getAnalyticsApiPackagesAnalyticsGet = async (params?: GetAnalyticsApiPackagesAnalyticsGetParams, options?: RequestInit): Promise<PackageAnalyticsResponse> => {
  
  return apiFetch<PackageAnalyticsResponse>(getGetAnalyticsApiPackagesAnalyticsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The Packages tab of Productivity as Excel: one row per programme (HR-18-03).
 * @summary Export Analytics
 */
export const getExportAnalyticsApiPackagesAnalyticsExportGetUrl = (params?: ExportAnalyticsApiPackagesAnalyticsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/packages/analytics/export?${stringifiedParams}` : `/api/packages/analytics/export`
}

export const exportAnalyticsApiPackagesAnalyticsExportGet = async (params?: ExportAnalyticsApiPackagesAnalyticsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportAnalyticsApiPackagesAnalyticsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Expiring
 */
export const getGetExpiringApiPackagesExpiringGetUrl = (params?: GetExpiringApiPackagesExpiringGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/packages/expiring?${stringifiedParams}` : `/api/packages/expiring`
}

export const getExpiringApiPackagesExpiringGet = async (params?: GetExpiringApiPackagesExpiringGetParams, options?: RequestInit): Promise<ExpiringPackagesResponse> => {
  
  return apiFetch<ExpiringPackagesResponse>(getGetExpiringApiPackagesExpiringGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Extend Package
 */
export const getExtendPackageApiPackagesPackageIdExtendPatchUrl = (packageId: string,) => {


  

  return `/api/packages/${packageId}/extend`
}

export const extendPackageApiPackagesPackageIdExtendPatch = async (packageId: string,
    packageExtendRequest: PackageExtendRequest, options?: RequestInit): Promise<PackageExtendResponse> => {
  
  return apiFetch<PackageExtendResponse>(getExtendPackageApiPackagesPackageIdExtendPatchUrl(packageId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      packageExtendRequest,)
  }
);}



/**
 * Docket Packages-tab payment history (FIN-7 seam) — delegates to
``FinanceService``. Returns the per-payment trail + an optional IHIP summary
with the next-due installment.
 * @summary Get Package Payments
 */
export const getGetPackagePaymentsApiPackagesPackageIdPaymentsGetUrl = (packageId: string,) => {


  

  return `/api/packages/${packageId}/payments`
}

export const getPackagePaymentsApiPackagesPackageIdPaymentsGet = async (packageId: string, options?: RequestInit): Promise<PackagePaymentHistoryResponse> => {
  
  return apiFetch<PackagePaymentHistoryResponse>(getGetPackagePaymentsApiPackagesPackageIdPaymentsGetUrl(packageId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Questionnaires
 */
export const getListQuestionnairesApiQuestionnairesGetUrl = (params?: ListQuestionnairesApiQuestionnairesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/questionnaires?${stringifiedParams}` : `/api/questionnaires`
}

export const listQuestionnairesApiQuestionnairesGet = async (params?: ListQuestionnairesApiQuestionnairesGetParams, options?: RequestInit): Promise<QuestionnaireListResponse> => {
  
  return apiFetch<QuestionnaireListResponse>(getListQuestionnairesApiQuestionnairesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Operations > Reports > Questionnaire Report (Angela, 22 Oct 2026): how
many questionnaires gave each overall rating, with the same filters and the
same own-data scope as the list. One questionnaire per visit (OPS-28-04).
 * @summary Questionnaire Summary
 */
export const getQuestionnaireSummaryApiQuestionnairesSummaryGetUrl = (params?: QuestionnaireSummaryApiQuestionnairesSummaryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/questionnaires/summary?${stringifiedParams}` : `/api/questionnaires/summary`
}

export const questionnaireSummaryApiQuestionnairesSummaryGet = async (params?: QuestionnaireSummaryApiQuestionnairesSummaryGetParams, options?: RequestInit): Promise<QuestionnaireSummaryResponse> => {
  
  return apiFetch<QuestionnaireSummaryResponse>(getQuestionnaireSummaryApiQuestionnairesSummaryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-28 - Current / Needs attention / Completed, per visit. Read-only.

``date`` (default: today, Singapore business day) picks the day of Current and
Completed; Needs attention has no date filter.
 * @summary Get Questionnaire Views
 */
export const getGetQuestionnaireViewsApiQuestionnairesViewsGetUrl = (params?: GetQuestionnaireViewsApiQuestionnairesViewsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/questionnaires/views?${stringifiedParams}` : `/api/questionnaires/views`
}

export const getQuestionnaireViewsApiQuestionnairesViewsGet = async (params?: GetQuestionnaireViewsApiQuestionnairesViewsGetParams, options?: RequestInit): Promise<QuestionnaireViewsResponse> => {
  
  return apiFetch<QuestionnaireViewsResponse>(getGetQuestionnaireViewsApiQuestionnairesViewsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Completed appointments that have no TreatmentRating row yet.
 * @summary List Pending Ratings
 */
export const getListPendingRatingsApiQuestionnairesPendingGetUrl = (params?: ListPendingRatingsApiQuestionnairesPendingGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/questionnaires/pending?${stringifiedParams}` : `/api/questionnaires/pending`
}

export const listPendingRatingsApiQuestionnairesPendingGet = async (params?: ListPendingRatingsApiQuestionnairesPendingGetParams, options?: RequestInit): Promise<PendingRatingListResponse> => {
  
  return apiFetch<PendingRatingListResponse>(getListPendingRatingsApiQuestionnairesPendingGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-24-01 / 24-10 - which Questionnaires cards show 'Start first-visit
survey' (a new or returning customer) and when it was started.
 * @summary Get First Visit Survey States
 */
export const getGetFirstVisitSurveyStatesApiQuestionnairesFirstVisitSurveyGetUrl = (params?: GetFirstVisitSurveyStatesApiQuestionnairesFirstVisitSurveyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/questionnaires/first-visit-survey?${stringifiedParams}` : `/api/questionnaires/first-visit-survey`
}

export const getFirstVisitSurveyStatesApiQuestionnairesFirstVisitSurveyGet = async (params?: GetFirstVisitSurveyStatesApiQuestionnairesFirstVisitSurveyGetParams, options?: RequestInit): Promise<FirstVisitSurveyStates> => {
  
  return apiFetch<FirstVisitSurveyStates>(getGetFirstVisitSurveyStatesApiQuestionnairesFirstVisitSurveyGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-24-03 - 'Start first-visit survey': the survey's own start is
recorded and the booking goes In Progress by itself.
 * @summary Start First Visit Survey
 */
export const getStartFirstVisitSurveyApiQuestionnairesFirstVisitSurveyAppointmentIdStartPostUrl = (appointmentId: string,) => {


  

  return `/api/questionnaires/first-visit-survey/${appointmentId}/start`
}

export const startFirstVisitSurveyApiQuestionnairesFirstVisitSurveyAppointmentIdStartPost = async (appointmentId: string, options?: RequestInit): Promise<FirstVisitSurveyStartResponse> => {
  
  return apiFetch<FirstVisitSurveyStartResponse>(getStartFirstVisitSurveyApiQuestionnairesFirstVisitSurveyAppointmentIdStartPostUrl(appointmentId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Dashboard
 */
export const getGetDashboardApiReportsDashboardGetUrl = (params?: GetDashboardApiReportsDashboardGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/dashboard?${stringifiedParams}` : `/api/reports/dashboard`
}

export const getDashboardApiReportsDashboardGet = async (params?: GetDashboardApiReportsDashboardGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getGetDashboardApiReportsDashboardGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Capacity
 */
export const getGetCapacityApiReportsCapacityGetUrl = (params?: GetCapacityApiReportsCapacityGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/capacity?${stringifiedParams}` : `/api/reports/capacity`
}

export const getCapacityApiReportsCapacityGet = async (params?: GetCapacityApiReportsCapacityGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getGetCapacityApiReportsCapacityGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Staff Performance
 */
export const getGetStaffPerformanceApiReportsStaffPerformanceGetUrl = (params?: GetStaffPerformanceApiReportsStaffPerformanceGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/staff-performance?${stringifiedParams}` : `/api/reports/staff-performance`
}

export const getStaffPerformanceApiReportsStaffPerformanceGet = async (params?: GetStaffPerformanceApiReportsStaffPerformanceGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getGetStaffPerformanceApiReportsStaffPerformanceGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Operations
 */
export const getGetOperationsApiReportsOperationsGetUrl = (params?: GetOperationsApiReportsOperationsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/operations?${stringifiedParams}` : `/api/reports/operations`
}

export const getOperationsApiReportsOperationsGet = async (params?: GetOperationsApiReportsOperationsGetParams, options?: RequestInit): Promise<OperationsAnalyticsResponse> => {
  
  return apiFetch<OperationsAnalyticsResponse>(getGetOperationsApiReportsOperationsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Customers
 */
export const getGetCustomersApiReportsCustomersGetUrl = (params?: GetCustomersApiReportsCustomersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/customers?${stringifiedParams}` : `/api/reports/customers`
}

export const getCustomersApiReportsCustomersGet = async (params?: GetCustomersApiReportsCustomersGetParams, options?: RequestInit): Promise<CustomerAnalyticsResponse> => {
  
  return apiFetch<CustomerAnalyticsResponse>(getGetCustomersApiReportsCustomersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Sales Analytics
 */
export const getGetSalesAnalyticsApiReportsSalesAnalyticsGetUrl = (params?: GetSalesAnalyticsApiReportsSalesAnalyticsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/sales-analytics?${stringifiedParams}` : `/api/reports/sales-analytics`
}

export const getSalesAnalyticsApiReportsSalesAnalyticsGet = async (params?: GetSalesAnalyticsApiReportsSalesAnalyticsGetParams, options?: RequestInit): Promise<SalesAnalyticsResponse> => {
  
  return apiFetch<SalesAnalyticsResponse>(getGetSalesAnalyticsApiReportsSalesAnalyticsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * R5-13 — cancelled and no-show appointments, by reason and notice given.
 * @summary Get Cancellations
 */
export const getGetCancellationsApiReportsCancellationsGetUrl = (params?: GetCancellationsApiReportsCancellationsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/cancellations?${stringifiedParams}` : `/api/reports/cancellations`
}

export const getCancellationsApiReportsCancellationsGet = async (params?: GetCancellationsApiReportsCancellationsGetParams, options?: RequestInit): Promise<CancellationReportResponse> => {
  
  return apiFetch<CancellationReportResponse>(getGetCancellationsApiReportsCancellationsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * R5-64 — consultations booked against completed, cancelled and no-show.
 * @summary Get Consultations
 */
export const getGetConsultationsApiReportsConsultationsGetUrl = (params?: GetConsultationsApiReportsConsultationsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/consultations?${stringifiedParams}` : `/api/reports/consultations`
}

export const getConsultationsApiReportsConsultationsGet = async (params?: GetConsultationsApiReportsConsultationsGetParams, options?: RequestInit): Promise<ConsultationReportResponse> => {
  
  return apiFetch<ConsultationReportResponse>(getGetConsultationsApiReportsConsultationsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-22 - the same-day result of every consultation of a month.
 * @summary Get Consultation Results
 */
export const getGetConsultationResultsApiReportsConsultationsResultsGetUrl = (params?: GetConsultationResultsApiReportsConsultationsResultsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/consultations/results?${stringifiedParams}` : `/api/reports/consultations/results`
}

export const getConsultationResultsApiReportsConsultationsResultsGet = async (params?: GetConsultationResultsApiReportsConsultationsResultsGetParams, options?: RequestInit): Promise<ConsultationResultReport> => {
  
  return apiFetch<ConsultationResultReport>(getGetConsultationResultsApiReportsConsultationsResultsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * OPS-22-08 - exactly the rows of the chosen month and filters, as .xlsx.
 * @summary Export Consultation Results
 */
export const getExportConsultationResultsApiReportsConsultationsResultsExportGetUrl = (params?: ExportConsultationResultsApiReportsConsultationsResultsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/consultations/results/export?${stringifiedParams}` : `/api/reports/consultations/results/export`
}

export const exportConsultationResultsApiReportsConsultationsResultsExportGet = async (params?: ExportConsultationResultsApiReportsConsultationsResultsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportConsultationResultsApiReportsConsultationsResultsExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-20-06: the 'Why no package today?' dropdown, most common first.
 * @summary Get Consultation Outcome Reasons
 */
export const getGetConsultationOutcomeReasonsApiReportsConsultationsOutcomeReasonsGetUrl = () => {


  

  return `/api/reports/consultations/outcome-reasons`
}

export const getConsultationOutcomeReasonsApiReportsConsultationsOutcomeReasonsGet = async ( options?: RequestInit): Promise<ConsultationReasonList> => {
  
  return apiFetch<ConsultationReasonList>(getGetConsultationOutcomeReasonsApiReportsConsultationsOutcomeReasonsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * SAL-23 — 'Consultation today' on Create Invoice: her consultation on
today's Singapore date, filled by the OS (nothing to choose).
 * @summary Get Consultation Today
 */
export const getGetConsultationTodayApiReportsConsultationsTodayGetUrl = (params: GetConsultationTodayApiReportsConsultationsTodayGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/consultations/today?${stringifiedParams}` : `/api/reports/consultations/today`
}

export const getConsultationTodayApiReportsConsultationsTodayGet = async (params: GetConsultationTodayApiReportsConsultationsTodayGetParams, options?: RequestInit): Promise<ConsultationTodayResponse> => {
  
  return apiFetch<ConsultationTodayResponse>(getGetConsultationTodayApiReportsConsultationsTodayGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * LEA-14-02 / SAL-20-05: record why a completed consultation did not end
in a package — reason, the kind for 'Finish balance first', a note. The OS
adds the staff account and the time. Open to anyone who serves customers
(the outlet records it), not only to report readers.
 * @summary Put Consultation Outcome
 */
export const getPutConsultationOutcomeApiReportsConsultationsAppointmentIdOutcomePutUrl = (appointmentId: string,) => {


  

  return `/api/reports/consultations/${appointmentId}/outcome`
}

export const putConsultationOutcomeApiReportsConsultationsAppointmentIdOutcomePut = async (appointmentId: string,
    consultationOutcomeIn: ConsultationOutcomeIn, options?: RequestInit): Promise<ConsultationOutcomeOut> => {
  
  return apiFetch<ConsultationOutcomeOut>(getPutConsultationOutcomeApiReportsConsultationsAppointmentIdOutcomePutUrl(appointmentId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      consultationOutcomeIn,)
  }
);}



/**
 * N-06 — the one Appointments report that replaced three.

Leaving ``customerType`` off is the "All" case; ``NEW`` and ``EXISTING``
reproduce the two retired per-customer-type pages.
 * @summary Get Appointments
 */
export const getGetAppointmentsApiReportsAppointmentsGetUrl = (params?: GetAppointmentsApiReportsAppointmentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/appointments?${stringifiedParams}` : `/api/reports/appointments`
}

export const getAppointmentsApiReportsAppointmentsGet = async (params?: GetAppointmentsApiReportsAppointmentsGetParams, options?: RequestInit): Promise<AppointmentReportResponse> => {
  
  return apiFetch<AppointmentReportResponse>(getGetAppointmentsApiReportsAppointmentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The outlet's rostered staff for the Roster Staff picker (all ticked at first).
 * @summary Get Duty Roster Staff
 */
export const getGetDutyRosterStaffApiReportsDutyRosterStaffGetUrl = (params: GetDutyRosterStaffApiReportsDutyRosterStaffGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/duty-roster/staff?${stringifiedParams}` : `/api/reports/duty-roster/staff`
}

export const getDutyRosterStaffApiReportsDutyRosterStaffGet = async (params: GetDutyRosterStaffApiReportsDutyRosterStaffGetParams, options?: RequestInit): Promise<DutyRosterStaff[]> => {
  
  return apiFetch<DutyRosterStaff[]>(getGetDutyRosterStaffApiReportsDutyRosterStaffGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * One row per date x staff member for the month; identical rows share a line.
 * @summary Get Duty Roster
 */
export const getGetDutyRosterApiReportsDutyRosterGetUrl = (params: GetDutyRosterApiReportsDutyRosterGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/duty-roster?${stringifiedParams}` : `/api/reports/duty-roster`
}

export const getDutyRosterApiReportsDutyRosterGet = async (params: GetDutyRosterApiReportsDutyRosterGetParams, options?: RequestInit): Promise<DutyRosterReport> => {
  
  return apiFetch<DutyRosterReport>(getGetDutyRosterApiReportsDutyRosterGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * A6 self-scope enforcement (Spec A §6.2 / ADR §5). Salary structure is one
of the salary reads ``finance.view_own_salary`` grants self-access to:

* ``finance.view_all`` = FULL → every structure (unchanged for admins and any
  legacy finance holder — ADMIN resolves this to FULL via the compat spine).
* ``finance.view_own_salary`` = FULL → only the caller's own salary-structure
  rows. A user with no linked Staff sees an empty set (§10), never a 403.
* Otherwise 403.

NOTE (do not duplicate in Spec C): Spec C's HR-profile Payroll self-view reads
salary through **this same** ``finance.view_own_salary`` permission — reuse the
``get_permission_scope`` gate here, do not re-implement it there (ADR §5).
 * @summary List Structures
 */
export const getListStructuresApiSalaryStructuresGetUrl = () => {


  

  return `/api/salary/structures`
}

export const listStructuresApiSalaryStructuresGet = async ( options?: RequestInit): Promise<SalaryStructureListResponse> => {
  
  return apiFetch<SalaryStructureListResponse>(getListStructuresApiSalaryStructuresGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Structure
 */
export const getCreateStructureApiSalaryStructuresPostUrl = () => {


  

  return `/api/salary/structures`
}

export const createStructureApiSalaryStructuresPost = async (salaryStructureCreateRequest: SalaryStructureCreateRequest, options?: RequestInit): Promise<SalaryStructureResponse> => {
  
  return apiFetch<SalaryStructureResponse>(getCreateStructureApiSalaryStructuresPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryStructureCreateRequest,)
  }
);}



/**
 * @summary Update Structure
 */
export const getUpdateStructureApiSalaryStructuresStructureIdPutUrl = (structureId: string,) => {


  

  return `/api/salary/structures/${structureId}`
}

export const updateStructureApiSalaryStructuresStructureIdPut = async (structureId: string,
    salaryStructureUpdateRequest: SalaryStructureUpdateRequest, options?: RequestInit): Promise<SalaryStructureResponse> => {
  
  return apiFetch<SalaryStructureResponse>(getUpdateStructureApiSalaryStructuresStructureIdPutUrl(structureId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryStructureUpdateRequest,)
  }
);}



/**
 * @summary Seed Structures
 */
export const getSeedStructuresApiSalaryStructuresSeedPostUrl = () => {


  

  return `/api/salary/structures/seed`
}

export const seedStructuresApiSalaryStructuresSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedStructuresApiSalaryStructuresSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Commission Schemes
 */
export const getListCommissionSchemesApiSalaryCommissionSchemesGetUrl = () => {


  

  return `/api/salary/commission-schemes`
}

export const listCommissionSchemesApiSalaryCommissionSchemesGet = async ( options?: RequestInit): Promise<CommissionSchemeListResponse> => {
  
  return apiFetch<CommissionSchemeListResponse>(getListCommissionSchemesApiSalaryCommissionSchemesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Commission Scheme
 */
export const getCreateCommissionSchemeApiSalaryCommissionSchemesPostUrl = () => {


  

  return `/api/salary/commission-schemes`
}

export const createCommissionSchemeApiSalaryCommissionSchemesPost = async (commissionSchemeCreateRequest: CommissionSchemeCreateRequest, options?: RequestInit): Promise<CommissionSchemeResponse> => {
  
  return apiFetch<CommissionSchemeResponse>(getCreateCommissionSchemeApiSalaryCommissionSchemesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commissionSchemeCreateRequest,)
  }
);}



/**
 * @summary Update Commission Scheme
 */
export const getUpdateCommissionSchemeApiSalaryCommissionSchemesSchemeIdPutUrl = (schemeId: string,) => {


  

  return `/api/salary/commission-schemes/${schemeId}`
}

export const updateCommissionSchemeApiSalaryCommissionSchemesSchemeIdPut = async (schemeId: string,
    commissionSchemeUpdateRequest: CommissionSchemeUpdateRequest, options?: RequestInit): Promise<CommissionSchemeResponse> => {
  
  return apiFetch<CommissionSchemeResponse>(getUpdateCommissionSchemeApiSalaryCommissionSchemesSchemeIdPutUrl(schemeId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commissionSchemeUpdateRequest,)
  }
);}



/**
 * @summary Seed Commission Schemes
 */
export const getSeedCommissionSchemesApiSalaryCommissionSchemesSeedPostUrl = () => {


  

  return `/api/salary/commission-schemes/seed`
}

export const seedCommissionSchemesApiSalaryCommissionSchemesSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedCommissionSchemesApiSalaryCommissionSchemesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Outlet Targets
 */
export const getListOutletTargetsApiSalaryOutletTargetsGetUrl = (params?: ListOutletTargetsApiSalaryOutletTargetsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/salary/outlet-targets?${stringifiedParams}` : `/api/salary/outlet-targets`
}

export const listOutletTargetsApiSalaryOutletTargetsGet = async (params?: ListOutletTargetsApiSalaryOutletTargetsGetParams, options?: RequestInit): Promise<OutletSalesTargetListResponse> => {
  
  return apiFetch<OutletSalesTargetListResponse>(getListOutletTargetsApiSalaryOutletTargetsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Outlet Target
 */
export const getCreateOutletTargetApiSalaryOutletTargetsPostUrl = () => {


  

  return `/api/salary/outlet-targets`
}

export const createOutletTargetApiSalaryOutletTargetsPost = async (outletSalesTargetCreateRequest: OutletSalesTargetCreateRequest, options?: RequestInit): Promise<OutletSalesTargetResponse> => {
  
  return apiFetch<OutletSalesTargetResponse>(getCreateOutletTargetApiSalaryOutletTargetsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletSalesTargetCreateRequest,)
  }
);}



/**
 * @summary Update Outlet Target
 */
export const getUpdateOutletTargetApiSalaryOutletTargetsTargetIdPutUrl = (targetId: string,) => {


  

  return `/api/salary/outlet-targets/${targetId}`
}

export const updateOutletTargetApiSalaryOutletTargetsTargetIdPut = async (targetId: string,
    outletSalesTargetUpdateRequest: OutletSalesTargetUpdateRequest, options?: RequestInit): Promise<OutletSalesTargetResponse> => {
  
  return apiFetch<OutletSalesTargetResponse>(getUpdateOutletTargetApiSalaryOutletTargetsTargetIdPutUrl(targetId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletSalesTargetUpdateRequest,)
  }
);}



/**
 * @summary Seed Outlet Targets
 */
export const getSeedOutletTargetsApiSalaryOutletTargetsSeedPostUrl = () => {


  

  return `/api/salary/outlet-targets/seed`
}

export const seedOutletTargetsApiSalaryOutletTargetsSeedPost = async ( options?: RequestInit): Promise<SeedResultResponse> => {
  
  return apiFetch<SeedResultResponse>(getSeedOutletTargetsApiSalaryOutletTargetsSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Monthly Outlet Targets
 */
export const getListMonthlyOutletTargetsApiSalaryMonthlyOutletTargetsGetUrl = (params?: ListMonthlyOutletTargetsApiSalaryMonthlyOutletTargetsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/salary/monthly-outlet-targets?${stringifiedParams}` : `/api/salary/monthly-outlet-targets`
}

export const listMonthlyOutletTargetsApiSalaryMonthlyOutletTargetsGet = async (params?: ListMonthlyOutletTargetsApiSalaryMonthlyOutletTargetsGetParams, options?: RequestInit): Promise<OutletMonthlyTargetListResponse> => {
  
  return apiFetch<OutletMonthlyTargetListResponse>(getListMonthlyOutletTargetsApiSalaryMonthlyOutletTargetsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Upsert Monthly Outlet Target
 */
export const getUpsertMonthlyOutletTargetApiSalaryMonthlyOutletTargetsPutUrl = () => {


  

  return `/api/salary/monthly-outlet-targets`
}

export const upsertMonthlyOutletTargetApiSalaryMonthlyOutletTargetsPut = async (outletMonthlyTargetUpsertRequest: OutletMonthlyTargetUpsertRequest, options?: RequestInit): Promise<OutletMonthlyTargetResponse> => {
  
  return apiFetch<OutletMonthlyTargetResponse>(getUpsertMonthlyOutletTargetApiSalaryMonthlyOutletTargetsPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      outletMonthlyTargetUpsertRequest,)
  }
);}



/**
 * @summary List Runs
 */
export const getListRunsApiSalaryRunsGetUrl = (params?: ListRunsApiSalaryRunsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/salary/runs?${stringifiedParams}` : `/api/salary/runs`
}

export const listRunsApiSalaryRunsGet = async (params?: ListRunsApiSalaryRunsGetParams, options?: RequestInit): Promise<SalaryRunListResponse> => {
  
  return apiFetch<SalaryRunListResponse>(getListRunsApiSalaryRunsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Run
 */
export const getCreateRunApiSalaryRunsPostUrl = () => {


  

  return `/api/salary/runs`
}

export const createRunApiSalaryRunsPost = async (salaryRunCreateRequest: SalaryRunCreateRequest, options?: RequestInit): Promise<SalaryRunResponse> => {
  
  return apiFetch<SalaryRunResponse>(getCreateRunApiSalaryRunsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      salaryRunCreateRequest,)
  }
);}



/**
 * @summary Compute Run
 */
export const getComputeRunApiSalaryRunsRunIdComputePostUrl = (runId: string,) => {


  

  return `/api/salary/runs/${runId}/compute`
}

export const computeRunApiSalaryRunsRunIdComputePost = async (runId: string, options?: RequestInit): Promise<SalaryRunResponse> => {
  
  return apiFetch<SalaryRunResponse>(getComputeRunApiSalaryRunsRunIdComputePostUrl(runId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * C13: lock the run and mark the commission it paid as PAID. Marking
commission PAID is the F1 decision (D27-1), so finalising needs the same
HQ staff + Approve and pay commission check as the Commission page (G3).
 * @summary Finalize Run
 */
export const getFinalizeRunApiSalaryRunsRunIdFinalizePostUrl = (runId: string,) => {


  

  return `/api/salary/runs/${runId}/finalize`
}

export const finalizeRunApiSalaryRunsRunIdFinalizePost = async (runId: string, options?: RequestInit): Promise<SalaryRunResponse> => {
  
  return apiFetch<SalaryRunResponse>(getFinalizeRunApiSalaryRunsRunIdFinalizePostUrl(runId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Run Payslips
 */
export const getListRunPayslipsApiSalaryRunsRunIdPayslipsGetUrl = (runId: string,) => {


  

  return `/api/salary/runs/${runId}/payslips`
}

export const listRunPayslipsApiSalaryRunsRunIdPayslipsGet = async (runId: string, options?: RequestInit): Promise<PayslipListResponse> => {
  
  return apiFetch<PayslipListResponse>(getListRunPayslipsApiSalaryRunsRunIdPayslipsGetUrl(runId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List My Payslips
 */
export const getListMyPayslipsApiSalaryPayslipsMineGetUrl = (params?: ListMyPayslipsApiSalaryPayslipsMineGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/salary/payslips/mine?${stringifiedParams}` : `/api/salary/payslips/mine`
}

export const listMyPayslipsApiSalaryPayslipsMineGet = async (params?: ListMyPayslipsApiSalaryPayslipsMineGetParams, options?: RequestInit): Promise<PayslipListResponse> => {
  
  return apiFetch<PayslipListResponse>(getListMyPayslipsApiSalaryPayslipsMineGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Payslip
 */
export const getGetPayslipApiSalaryPayslipsPayslipIdGetUrl = (payslipId: string,) => {


  

  return `/api/salary/payslips/${payslipId}`
}

export const getPayslipApiSalaryPayslipsPayslipIdGet = async (payslipId: string, options?: RequestInit): Promise<PayslipDetailResponse> => {
  
  return apiFetch<PayslipDetailResponse>(getGetPayslipApiSalaryPayslipsPayslipIdGetUrl(payslipId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Confirm Payslip
 */
export const getConfirmPayslipApiSalaryPayslipsPayslipIdConfirmPostUrl = (payslipId: string,) => {


  

  return `/api/salary/payslips/${payslipId}/confirm`
}

export const confirmPayslipApiSalaryPayslipsPayslipIdConfirmPost = async (payslipId: string, options?: RequestInit): Promise<PayslipResponse> => {
  
  return apiFetch<PayslipResponse>(getConfirmPayslipApiSalaryPayslipsPayslipIdConfirmPostUrl(payslipId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Dispute Payslip
 */
export const getDisputePayslipApiSalaryPayslipsPayslipIdDisputePostUrl = (payslipId: string,) => {


  

  return `/api/salary/payslips/${payslipId}/dispute`
}

export const disputePayslipApiSalaryPayslipsPayslipIdDisputePost = async (payslipId: string,
    payslipDisputeRequest: PayslipDisputeRequest, options?: RequestInit): Promise<PayslipResponse> => {
  
  return apiFetch<PayslipResponse>(getDisputePayslipApiSalaryPayslipsPayslipIdDisputePostUrl(payslipId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      payslipDisputeRequest,)
  }
);}



/**
 * @summary List Benefit Usage
 */
export const getListBenefitUsageApiSalaryBenefitUsageGetUrl = (params: ListBenefitUsageApiSalaryBenefitUsageGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/salary/benefit-usage?${stringifiedParams}` : `/api/salary/benefit-usage`
}

export const listBenefitUsageApiSalaryBenefitUsageGet = async (params: ListBenefitUsageApiSalaryBenefitUsageGetParams, options?: RequestInit): Promise<BenefitUsageListResponse> => {
  
  return apiFetch<BenefitUsageListResponse>(getListBenefitUsageApiSalaryBenefitUsageGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Benefit Usage
 */
export const getCreateBenefitUsageApiSalaryBenefitUsagePostUrl = () => {


  

  return `/api/salary/benefit-usage`
}

export const createBenefitUsageApiSalaryBenefitUsagePost = async (benefitUsageCreateRequest: BenefitUsageCreateRequest, options?: RequestInit): Promise<BenefitUsageResponse> => {
  
  return apiFetch<BenefitUsageResponse>(getCreateBenefitUsageApiSalaryBenefitUsagePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      benefitUsageCreateRequest,)
  }
);}



/**
 * The configured tenders in display order. The POS payment step calls this
with ``?enabled=true&outletId=X``.
 * @summary List Payment Types
 */
export const getListPaymentTypesApiFinancePaymentTypesGetUrl = (params?: ListPaymentTypesApiFinancePaymentTypesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/payment-types?${stringifiedParams}` : `/api/finance/payment-types`
}

export const listPaymentTypesApiFinancePaymentTypesGet = async (params?: ListPaymentTypesApiFinancePaymentTypesGetParams, options?: RequestInit): Promise<PaymentTypeListResponse> => {
  
  return apiFetch<PaymentTypeListResponse>(getListPaymentTypesApiFinancePaymentTypesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Payment Type
 */
export const getCreatePaymentTypeApiFinancePaymentTypesPostUrl = () => {


  

  return `/api/finance/payment-types`
}

export const createPaymentTypeApiFinancePaymentTypesPost = async (paymentTypeCreate: PaymentTypeCreate, options?: RequestInit): Promise<PaymentTypeResponse> => {
  
  return apiFetch<PaymentTypeResponse>(getCreatePaymentTypeApiFinancePaymentTypesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      paymentTypeCreate,)
  }
);}



/**
 * Set ``sortOrder`` to each id's index in ``ids`` (drag-drop). Every id must
exist; ids omitted from the payload keep their current order value.
 * @summary Reorder Payment Types
 */
export const getReorderPaymentTypesApiFinancePaymentTypesReorderPostUrl = () => {


  

  return `/api/finance/payment-types/reorder`
}

export const reorderPaymentTypesApiFinancePaymentTypesReorderPost = async (reorderRequest: ReorderRequest, options?: RequestInit): Promise<PaymentTypeListResponse> => {
  
  return apiFetch<PaymentTypeListResponse>(getReorderPaymentTypesApiFinancePaymentTypesReorderPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderRequest,)
  }
);}



/**
 * Seed the 17 Studio Manager tenders. Idempotent — a tender whose ``code``
already exists is skipped, never overwritten.
 * @summary Seed Payment Types Endpoint
 */
export const getSeedPaymentTypesEndpointApiFinancePaymentTypesSeedPostUrl = () => {


  

  return `/api/finance/payment-types/seed`
}

export const seedPaymentTypesEndpointApiFinancePaymentTypesSeedPost = async ( options?: RequestInit): Promise<SalesConfigSeedResult> => {
  
  return apiFetch<SalesConfigSeedResult>(getSeedPaymentTypesEndpointApiFinancePaymentTypesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Update Payment Type
 */
export const getUpdatePaymentTypeApiFinancePaymentTypesPaymentTypeIdPatchUrl = (paymentTypeId: string,) => {


  

  return `/api/finance/payment-types/${paymentTypeId}`
}

export const updatePaymentTypeApiFinancePaymentTypesPaymentTypeIdPatch = async (paymentTypeId: string,
    paymentTypeUpdate: PaymentTypeUpdate, options?: RequestInit): Promise<PaymentTypeResponse> => {
  
  return apiFetch<PaymentTypeResponse>(getUpdatePaymentTypeApiFinancePaymentTypesPaymentTypeIdPatchUrl(paymentTypeId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      paymentTypeUpdate,)
  }
);}



/**
 * Hard-delete (spec §Admin UI): nothing references ``PaymentType`` by FK yet.
The join rows go with it via ``delete-orphan``.
 * @summary Delete Payment Type
 */
export const getDeletePaymentTypeApiFinancePaymentTypesPaymentTypeIdDeleteUrl = (paymentTypeId: string,) => {


  

  return `/api/finance/payment-types/${paymentTypeId}`
}

export const deletePaymentTypeApiFinancePaymentTypesPaymentTypeIdDelete = async (paymentTypeId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeletePaymentTypeApiFinancePaymentTypesPaymentTypeIdDeleteUrl(paymentTypeId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * The configured taxes in the order they are applied (SAL-39-02).
 * @summary List Taxes
 */
export const getListTaxesApiFinanceTaxesGetUrl = (params?: ListTaxesApiFinanceTaxesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/finance/taxes?${stringifiedParams}` : `/api/finance/taxes`
}

export const listTaxesApiFinanceTaxesGet = async (params?: ListTaxesApiFinanceTaxesGetParams, options?: RequestInit): Promise<TaxListResponse> => {
  
  return apiFetch<TaxListResponse>(getListTaxesApiFinanceTaxesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * New Tax (SAL-39-04): needs at least one rate.
 * @summary Create Tax
 */
export const getCreateTaxApiFinanceTaxesPostUrl = () => {


  

  return `/api/finance/taxes`
}

export const createTaxApiFinanceTaxesPost = async (taxCreate: TaxCreate, options?: RequestInit): Promise<TaxResponse> => {
  
  return apiFetch<TaxResponse>(getCreateTaxApiFinanceTaxesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taxCreate,)
  }
);}



/**
 * Seed GST across every outlet, with its rate history. Idempotent on ``Tax.name``.
 * @summary Seed Taxes Endpoint
 */
export const getSeedTaxesEndpointApiFinanceTaxesSeedPostUrl = () => {


  

  return `/api/finance/taxes/seed`
}

export const seedTaxesEndpointApiFinanceTaxesSeedPost = async ( options?: RequestInit): Promise<SalesConfigSeedResult> => {
  
  return apiFetch<SalesConfigSeedResult>(getSeedTaxesEndpointApiFinanceTaxesSeedPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * SAL-39-02 — drag to change the order the taxes are applied in.
 * @summary Reorder Taxes
 */
export const getReorderTaxesApiFinanceTaxesReorderPostUrl = () => {


  

  return `/api/finance/taxes/reorder`
}

export const reorderTaxesApiFinanceTaxesReorderPost = async (reorderRequest: ReorderRequest, options?: RequestInit): Promise<TaxListResponse> => {
  
  return apiFetch<TaxListResponse>(getReorderTaxesApiFinanceTaxesReorderPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderRequest,)
  }
);}



/**
 * Edit Tax (SAL-39-03/05/06): a rate that has started is never changed;
new rates must start after the latest started rate; rates that have not
started yet may be replaced (``replaceFutureRates``).
 * @summary Update Tax
 */
export const getUpdateTaxApiFinanceTaxesTaxIdPatchUrl = (taxId: string,) => {


  

  return `/api/finance/taxes/${taxId}`
}

export const updateTaxApiFinanceTaxesTaxIdPatch = async (taxId: string,
    taxUpdate: TaxUpdate, options?: RequestInit): Promise<TaxResponse> => {
  
  return apiFetch<TaxResponse>(getUpdateTaxApiFinanceTaxesTaxIdPatchUrl(taxId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taxUpdate,)
  }
);}



/**
 * SAL-39-09 — only a tax on no saved invoice is deleted.
 * @summary Delete Tax
 */
export const getDeleteTaxApiFinanceTaxesTaxIdDeleteUrl = (taxId: string,) => {


  

  return `/api/finance/taxes/${taxId}`
}

export const deleteTaxApiFinanceTaxesTaxIdDelete = async (taxId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDeleteTaxApiFinanceTaxesTaxIdDeleteUrl(taxId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Schedule Daily
 */
export const getScheduleDailyApiScheduleGetUrl = (params?: ScheduleDailyApiScheduleGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/schedule?${stringifiedParams}` : `/api/schedule`
}

export const scheduleDailyApiScheduleGet = async (params?: ScheduleDailyApiScheduleGetParams, options?: RequestInit): Promise<DailyScheduleResponse> => {
  
  return apiFetch<DailyScheduleResponse>(getScheduleDailyApiScheduleGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Schedule Weekly
 */
export const getScheduleWeeklyApiScheduleWeeklyGetUrl = (params?: ScheduleWeeklyApiScheduleWeeklyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/schedule/weekly?${stringifiedParams}` : `/api/schedule/weekly`
}

export const scheduleWeeklyApiScheduleWeeklyGet = async (params?: ScheduleWeeklyApiScheduleWeeklyGetParams, options?: RequestInit): Promise<WeeklyScheduleResponse> => {
  
  return apiFetch<WeeklyScheduleResponse>(getScheduleWeeklyApiScheduleWeeklyGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Auto Schedule Endpoint
 */
export const getAutoScheduleEndpointApiSchedulingAutoPostUrl = () => {


  

  return `/api/scheduling/auto`
}

export const autoScheduleEndpointApiSchedulingAutoPost = async (autoScheduleRequest: AutoScheduleRequest, options?: RequestInit): Promise<SchedulingResult> => {
  
  return apiFetch<SchedulingResult>(getAutoScheduleEndpointApiSchedulingAutoPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      autoScheduleRequest,)
  }
);}



/**
 * @summary Consultation Endpoint
 */
export const getConsultationEndpointApiSchedulingConsultationPostUrl = () => {


  

  return `/api/scheduling/consultation`
}

export const consultationEndpointApiSchedulingConsultationPost = async (consultationRequest: ConsultationRequest, options?: RequestInit): Promise<ConsultationResult> => {
  
  return apiFetch<ConsultationResult>(getConsultationEndpointApiSchedulingConsultationPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      consultationRequest,)
  }
);}



/**
 * @summary List Users
 */
export const getListUsersApiUsersGetUrl = (params?: ListUsersApiUsersGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users?${stringifiedParams}` : `/api/users`
}

export const listUsersApiUsersGet = async (params?: ListUsersApiUsersGetParams, options?: RequestInit): Promise<UserListResponse> => {
  
  return apiFetch<UserListResponse>(getListUsersApiUsersGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create User
 */
export const getCreateUserApiUsersPostUrl = () => {


  

  return `/api/users`
}

export const createUserApiUsersPost = async (userCreateRequest: UserCreateRequest, options?: RequestInit): Promise<UserResponse> => {
  
  return apiFetch<UserResponse>(getCreateUserApiUsersPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userCreateRequest,)
  }
);}



/**
 * HR-11-03: accounts with no login ID and the ID each would get (read-only).
 * @summary Login Id Suggestions
 */
export const getLoginIdSuggestionsApiUsersLoginIdSuggestionsGetUrl = () => {


  

  return `/api/users/login-id-suggestions`
}

export const loginIdSuggestionsApiUsersLoginIdSuggestionsGet = async ( options?: RequestInit): Promise<LoginIdSuggestionsResponse> => {
  
  return apiFetch<LoginIdSuggestionsResponse>(getLoginIdSuggestionsApiUsersLoginIdSuggestionsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-11-03: save the READY suggestions; the rest stay for HQ to type.
 * @summary Fill Login Ids
 */
export const getFillLoginIdsApiUsersLoginIdSuggestionsFillPostUrl = () => {


  

  return `/api/users/login-id-suggestions/fill`
}

export const fillLoginIdsApiUsersLoginIdSuggestionsFillPost = async ( options?: RequestInit): Promise<LoginIdSuggestionsResponse> => {
  
  return apiFetch<LoginIdSuggestionsResponse>(getFillLoginIdsApiUsersLoginIdSuggestionsFillPostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Change Password
 */
export const getChangePasswordApiUsersChangePasswordPostUrl = () => {


  

  return `/api/users/change-password`
}

export const changePasswordApiUsersChangePasswordPost = async (changePasswordRequest: ChangePasswordRequest, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getChangePasswordApiUsersChangePasswordPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changePasswordRequest,)
  }
);}



/**
 * @summary Get User
 */
export const getGetUserApiUsersUserIdGetUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const getUserApiUsersUserIdGet = async (userId: string, options?: RequestInit): Promise<UserResponse> => {
  
  return apiFetch<UserResponse>(getGetUserApiUsersUserIdGetUrl(userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update User
 */
export const getUpdateUserApiUsersUserIdPutUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const updateUserApiUsersUserIdPut = async (userId: string,
    userUpdateRequest: UserUpdateRequest, options?: RequestInit): Promise<UserResponse> => {
  
  return apiFetch<UserResponse>(getUpdateUserApiUsersUserIdPutUrl(userId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userUpdateRequest,)
  }
);}



/**
 * @summary Delete User
 */
export const getDeleteUserApiUsersUserIdDeleteUrl = (userId: string,) => {


  

  return `/api/users/${userId}`
}

export const deleteUserApiUsersUserIdDelete = async (userId: string, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getDeleteUserApiUsersUserIdDeleteUrl(userId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * Staff Details > User > Save: the User ID is the staff member's Display
name. Sets Staff.name and the login ID in one transaction; refuses (409,
nothing changed) when another account already has that login ID.
 * @summary Set User Id
 */
export const getSetUserIdApiUsersUserIdUserIdPutUrl = (userId: string,) => {


  

  return `/api/users/${userId}/user-id`
}

export const setUserIdApiUsersUserIdUserIdPut = async (userId: string,
    userIdRequest: UserIdRequest, options?: RequestInit): Promise<UserResponse> => {
  
  return apiFetch<UserResponse>(getSetUserIdApiUsersUserIdUserIdPutUrl(userId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userIdRequest,)
  }
);}



/**
 * @summary Reset Password
 */
export const getResetPasswordApiUsersUserIdResetPasswordPostUrl = (userId: string,) => {


  

  return `/api/users/${userId}/reset-password`
}

export const resetPasswordApiUsersUserIdResetPasswordPost = async (userId: string,
    resetPasswordRequest: ResetPasswordRequest, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getResetPasswordApiUsersUserIdResetPasswordPostUrl(userId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resetPasswordRequest,)
  }
);}



/**
 * The rows of Meeting Log. HQ: every meeting. Outlet staff: Company
meetings plus Meeting rows of the outlets they may see.
 * @summary List Meeting Log Meetings
 */
export const getListMeetingLogMeetingsApiMeetingFilesMeetingsGetUrl = (params: ListMeetingLogMeetingsApiMeetingFilesMeetingsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meeting-files/meetings?${stringifiedParams}` : `/api/meeting-files/meetings`
}

export const listMeetingLogMeetingsApiMeetingFilesMeetingsGet = async (params: ListMeetingLogMeetingsApiMeetingFilesMeetingsGetParams, options?: RequestInit): Promise<StaffMeeting[]> => {
  
  return apiFetch<StaffMeeting[]>(getListMeetingLogMeetingsApiMeetingFilesMeetingsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Meeting Files
 */
export const getListMeetingFilesApiMeetingFilesGetUrl = (params: ListMeetingFilesApiMeetingFilesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meeting-files?${stringifiedParams}` : `/api/meeting-files`
}

export const listMeetingFilesApiMeetingFilesGet = async (params: ListMeetingFilesApiMeetingFilesGetParams, options?: RequestInit): Promise<MeetingFileListResponse> => {
  
  return apiFetch<MeetingFileListResponse>(getListMeetingFilesApiMeetingFilesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Add Meeting File
 */
export const getAddMeetingFileApiMeetingFilesPostUrl = () => {


  

  return `/api/meeting-files`
}

export const addMeetingFileApiMeetingFilesPost = async (meetingFileCreate: MeetingFileCreate, options?: RequestInit): Promise<MeetingFileResponse> => {
  
  return apiFetch<MeetingFileResponse>(getAddMeetingFileApiMeetingFilesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      meetingFileCreate,)
  }
);}



/**
 * HR-16-10 - the Monthly Team Meeting deck for a month, as a PowerPoint file.
It shows both outlets' sales and KPIs, so it needs the Business overview right.
 * @summary Download Meeting Deck
 */
export const getDownloadMeetingDeckApiMeetingFilesDeckGetUrl = (params: DownloadMeetingDeckApiMeetingFilesDeckGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meeting-files/deck?${stringifiedParams}` : `/api/meeting-files/deck`
}

export const downloadMeetingDeckApiMeetingFilesDeckGet = async (params: DownloadMeetingDeckApiMeetingFilesDeckGetParams, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDownloadMeetingDeckApiMeetingFilesDeckGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Remove Meeting File
 */
export const getRemoveMeetingFileApiMeetingFilesFileIdDeleteUrl = (fileId: string,) => {


  

  return `/api/meeting-files/${fileId}`
}

export const removeMeetingFileApiMeetingFilesFileIdDelete = async (fileId: string, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getRemoveMeetingFileApiMeetingFilesFileIdDeleteUrl(fileId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Publish Meeting File
 */
export const getPublishMeetingFileApiMeetingFilesFileIdPublishPostUrl = (fileId: string,) => {


  

  return `/api/meeting-files/${fileId}/publish`
}

export const publishMeetingFileApiMeetingFilesFileIdPublishPost = async (fileId: string, options?: RequestInit): Promise<MeetingFileResponse> => {
  
  return apiFetch<MeetingFileResponse>(getPublishMeetingFileApiMeetingFilesFileIdPublishPostUrl(fileId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Unpublish Meeting File
 */
export const getUnpublishMeetingFileApiMeetingFilesFileIdUnpublishPostUrl = (fileId: string,) => {


  

  return `/api/meeting-files/${fileId}/unpublish`
}

export const unpublishMeetingFileApiMeetingFilesFileIdUnpublishPost = async (fileId: string, options?: RequestInit): Promise<MeetingFileResponse> => {
  
  return apiFetch<MeetingFileResponse>(getUnpublishMeetingFileApiMeetingFilesFileIdUnpublishPostUrl(fileId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Meeting Minutes
 */
export const getListMeetingMinutesApiMeetingMinutesGetUrl = (params?: ListMeetingMinutesApiMeetingMinutesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meeting-minutes?${stringifiedParams}` : `/api/meeting-minutes`
}

export const listMeetingMinutesApiMeetingMinutesGet = async (params?: ListMeetingMinutesApiMeetingMinutesGetParams, options?: RequestInit): Promise<MinutesListResponse> => {
  
  return apiFetch<MinutesListResponse>(getListMeetingMinutesApiMeetingMinutesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Make minutes: the deck's sections, summaries filled with the figures of
the month the meeting reviews.
 * @summary Make Meeting Minutes
 */
export const getMakeMeetingMinutesApiMeetingMinutesPostUrl = () => {


  

  return `/api/meeting-minutes`
}

export const makeMeetingMinutesApiMeetingMinutesPost = async (minutesCreate: MinutesCreate, options?: RequestInit): Promise<MinutesResponse> => {
  
  return apiFetch<MinutesResponse>(getMakeMeetingMinutesApiMeetingMinutesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      minutesCreate,)
  }
);}



/**
 * @summary Get Meeting Minutes
 */
export const getGetMeetingMinutesApiMeetingMinutesMinutesIdGetUrl = (minutesId: string,) => {


  

  return `/api/meeting-minutes/${minutesId}`
}

export const getMeetingMinutesApiMeetingMinutesMinutesIdGet = async (minutesId: string, options?: RequestInit): Promise<MinutesResponse> => {
  
  return apiFetch<MinutesResponse>(getGetMeetingMinutesApiMeetingMinutesMinutesIdGetUrl(minutesId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Save Meeting Minutes
 */
export const getSaveMeetingMinutesApiMeetingMinutesMinutesIdPutUrl = (minutesId: string,) => {


  

  return `/api/meeting-minutes/${minutesId}`
}

export const saveMeetingMinutesApiMeetingMinutesMinutesIdPut = async (minutesId: string,
    minutesUpdate: MinutesUpdate, options?: RequestInit): Promise<MinutesResponse> => {
  
  return apiFetch<MinutesResponse>(getSaveMeetingMinutesApiMeetingMinutesMinutesIdPutUrl(minutesId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      minutesUpdate,)
  }
);}



/**
 * @summary Download Meeting Minutes
 */
export const getDownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetUrl = (minutesId: string,
    params?: DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/meeting-minutes/${minutesId}/download?${stringifiedParams}` : `/api/meeting-minutes/${minutesId}/download`
}

export const downloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGet = async (minutesId: string,
    params?: DownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetParams, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getDownloadMeetingMinutesApiMeetingMinutesMinutesIdDownloadGetUrl(minutesId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Documents
 */
export const getListDocumentsApiAiKnowledgeDocumentsGetUrl = (params?: ListDocumentsApiAiKnowledgeDocumentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai/knowledge/documents?${stringifiedParams}` : `/api/ai/knowledge/documents`
}

export const listDocumentsApiAiKnowledgeDocumentsGet = async (params?: ListDocumentsApiAiKnowledgeDocumentsGetParams, options?: RequestInit): Promise<AiDocumentListResponse> => {
  
  return apiFetch<AiDocumentListResponse>(getListDocumentsApiAiKnowledgeDocumentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Add Document
 */
export const getAddDocumentApiAiKnowledgeDocumentsPostUrl = () => {


  

  return `/api/ai/knowledge/documents`
}

export const addDocumentApiAiKnowledgeDocumentsPost = async (bodyAddDocumentApiAiKnowledgeDocumentsPost: BodyAddDocumentApiAiKnowledgeDocumentsPost, options?: RequestInit): Promise<AiDocumentOut> => {
    const formData = new FormData();
formData.append(`file`, bodyAddDocumentApiAiKnowledgeDocumentsPost.file)
formData.append(`title`, bodyAddDocumentApiAiKnowledgeDocumentsPost.title)
formData.append(`area`, bodyAddDocumentApiAiKnowledgeDocumentsPost.area)
formData.append(`version`, bodyAddDocumentApiAiKnowledgeDocumentsPost.version)
if(bodyAddDocumentApiAiKnowledgeDocumentsPost.effectiveFrom !== undefined && bodyAddDocumentApiAiKnowledgeDocumentsPost.effectiveFrom !== null) {
 formData.append(`effectiveFrom`, bodyAddDocumentApiAiKnowledgeDocumentsPost.effectiveFrom)
 }
if(bodyAddDocumentApiAiKnowledgeDocumentsPost.whoCanAsk !== undefined) {
 formData.append(`whoCanAsk`, bodyAddDocumentApiAiKnowledgeDocumentsPost.whoCanAsk)
 }
if(bodyAddDocumentApiAiKnowledgeDocumentsPost.status !== undefined) {
 formData.append(`status`, bodyAddDocumentApiAiKnowledgeDocumentsPost.status)
 }

  return apiFetch<AiDocumentOut>(getAddDocumentApiAiKnowledgeDocumentsPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary Update Document
 */
export const getUpdateDocumentApiAiKnowledgeDocumentsDocIdPatchUrl = (docId: string,) => {


  

  return `/api/ai/knowledge/documents/${docId}`
}

export const updateDocumentApiAiKnowledgeDocumentsDocIdPatch = async (docId: string,
    aiDocumentUpdate: AiDocumentUpdate, options?: RequestInit): Promise<AiDocumentOut> => {
  
  return apiFetch<AiDocumentOut>(getUpdateDocumentApiAiKnowledgeDocumentsDocIdPatchUrl(docId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiDocumentUpdate,)
  }
);}



/**
 * @summary Replace Document File
 */
export const getReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePutUrl = (docId: string,) => {


  

  return `/api/ai/knowledge/documents/${docId}/file`
}

export const replaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut = async (docId: string,
    bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut: BodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut, options?: RequestInit): Promise<AiDocumentOut> => {
    const formData = new FormData();
formData.append(`file`, bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.file)
if(bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.version !== undefined && bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.version !== null) {
 formData.append(`version`, bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.version)
 }
if(bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.effectiveFrom !== undefined && bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.effectiveFrom !== null) {
 formData.append(`effectiveFrom`, bodyReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePut.effectiveFrom)
 }

  return apiFetch<AiDocumentOut>(getReplaceDocumentFileApiAiKnowledgeDocumentsDocIdFilePutUrl(docId),
  {      
    ...options,
    method: 'PUT'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary Download Document File
 */
export const getDownloadDocumentFileApiAiKnowledgeDocumentsDocIdFileGetUrl = (docId: string,) => {


  

  return `/api/ai/knowledge/documents/${docId}/file`
}

export const downloadDocumentFileApiAiKnowledgeDocumentsDocIdFileGet = async (docId: string, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getDownloadDocumentFileApiAiKnowledgeDocumentsDocIdFileGetUrl(docId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Preview Document
 */
export const getPreviewDocumentApiAiKnowledgeDocumentsDocIdPreviewGetUrl = (docId: string,) => {


  

  return `/api/ai/knowledge/documents/${docId}/preview`
}

export const previewDocumentApiAiKnowledgeDocumentsDocIdPreviewGet = async (docId: string, options?: RequestInit): Promise<AiDocumentPreview> => {
  
  return apiFetch<AiDocumentPreview>(getPreviewDocumentApiAiKnowledgeDocumentsDocIdPreviewGetUrl(docId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ only: the best-matching passages with their source (to test the Knowledge).
 * @summary Search
 */
export const getSearchApiAiKnowledgeSearchGetUrl = (params: SearchApiAiKnowledgeSearchGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai/knowledge/search?${stringifiedParams}` : `/api/ai/knowledge/search`
}

export const searchApiAiKnowledgeSearchGet = async (params: SearchApiAiKnowledgeSearchGetParams, options?: RequestInit): Promise<AiSearchResponse> => {
  
  return apiFetch<AiSearchResponse>(getSearchApiAiKnowledgeSearchGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List Documents
 */
export const getListDocumentsApiHrSopLibraryDocumentsGetUrl = (params?: ListDocumentsApiHrSopLibraryDocumentsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/sop-library/documents?${stringifiedParams}` : `/api/hr/sop-library/documents`
}

export const listDocumentsApiHrSopLibraryDocumentsGet = async (params?: ListDocumentsApiHrSopLibraryDocumentsGetParams, options?: RequestInit): Promise<SopDocumentListResponse> => {
  
  return apiFetch<SopDocumentListResponse>(getListDocumentsApiHrSopLibraryDocumentsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Add Document
 */
export const getAddDocumentApiHrSopLibraryDocumentsPostUrl = () => {


  

  return `/api/hr/sop-library/documents`
}

export const addDocumentApiHrSopLibraryDocumentsPost = async (bodyAddDocumentApiHrSopLibraryDocumentsPost: BodyAddDocumentApiHrSopLibraryDocumentsPost, options?: RequestInit): Promise<SopDocumentOut> => {
    const formData = new FormData();
formData.append(`file`, bodyAddDocumentApiHrSopLibraryDocumentsPost.file)
formData.append(`name`, bodyAddDocumentApiHrSopLibraryDocumentsPost.name)
formData.append(`area`, bodyAddDocumentApiHrSopLibraryDocumentsPost.area)
if(bodyAddDocumentApiHrSopLibraryDocumentsPost.versionLabel !== undefined && bodyAddDocumentApiHrSopLibraryDocumentsPost.versionLabel !== null) {
 formData.append(`versionLabel`, bodyAddDocumentApiHrSopLibraryDocumentsPost.versionLabel)
 }
if(bodyAddDocumentApiHrSopLibraryDocumentsPost.effectiveFrom !== undefined && bodyAddDocumentApiHrSopLibraryDocumentsPost.effectiveFrom !== null) {
 formData.append(`effectiveFrom`, bodyAddDocumentApiHrSopLibraryDocumentsPost.effectiveFrom)
 }
if(bodyAddDocumentApiHrSopLibraryDocumentsPost.trainingSopId !== undefined && bodyAddDocumentApiHrSopLibraryDocumentsPost.trainingSopId !== null) {
 formData.append(`trainingSopId`, bodyAddDocumentApiHrSopLibraryDocumentsPost.trainingSopId)
 }
if(bodyAddDocumentApiHrSopLibraryDocumentsPost.note !== undefined && bodyAddDocumentApiHrSopLibraryDocumentsPost.note !== null) {
 formData.append(`note`, bodyAddDocumentApiHrSopLibraryDocumentsPost.note)
 }

  return apiFetch<SopDocumentOut>(getAddDocumentApiHrSopLibraryDocumentsPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * The Training Status SOP items a Library SOP can be linked to.
 * @summary Training Sops
 */
export const getTrainingSopsApiHrSopLibraryTrainingSopsGetUrl = () => {


  

  return `/api/hr/sop-library/training-sops`
}

export const trainingSopsApiHrSopLibraryTrainingSopsGet = async ( options?: RequestInit): Promise<TrainingSopOptionsResponse> => {
  
  return apiFetch<TrainingSopOptionsResponse>(getTrainingSopsApiHrSopLibraryTrainingSopsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Document
 */
export const getUpdateDocumentApiHrSopLibraryDocumentsSopIdPatchUrl = (sopId: string,) => {


  

  return `/api/hr/sop-library/documents/${sopId}`
}

export const updateDocumentApiHrSopLibraryDocumentsSopIdPatch = async (sopId: string,
    sopDocumentUpdate: SopDocumentUpdate, options?: RequestInit): Promise<SopDocumentOut> => {
  
  return apiFetch<SopDocumentOut>(getUpdateDocumentApiHrSopLibraryDocumentsSopIdPatchUrl(sopId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sopDocumentUpdate,)
  }
);}



/**
 * Replace file = a new VERSION. The earlier versions stay listed.
 * @summary Replace File
 */
export const getReplaceFileApiHrSopLibraryDocumentsSopIdFilePutUrl = (sopId: string,) => {


  

  return `/api/hr/sop-library/documents/${sopId}/file`
}

export const replaceFileApiHrSopLibraryDocumentsSopIdFilePut = async (sopId: string,
    bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut: BodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut, options?: RequestInit): Promise<SopDocumentOut> => {
    const formData = new FormData();
formData.append(`file`, bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.file)
if(bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.versionLabel !== undefined && bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.versionLabel !== null) {
 formData.append(`versionLabel`, bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.versionLabel)
 }
if(bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.effectiveFrom !== undefined && bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.effectiveFrom !== null) {
 formData.append(`effectiveFrom`, bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.effectiveFrom)
 }
if(bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.note !== undefined && bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.note !== null) {
 formData.append(`note`, bodyReplaceFileApiHrSopLibraryDocumentsSopIdFilePut.note)
 }

  return apiFetch<SopDocumentOut>(getReplaceFileApiHrSopLibraryDocumentsSopIdFilePutUrl(sopId),
  {      
    ...options,
    method: 'PUT'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary List Versions
 */
export const getListVersionsApiHrSopLibraryDocumentsSopIdVersionsGetUrl = (sopId: string,) => {


  

  return `/api/hr/sop-library/documents/${sopId}/versions`
}

export const listVersionsApiHrSopLibraryDocumentsSopIdVersionsGet = async (sopId: string, options?: RequestInit): Promise<SopVersionListResponse> => {
  
  return apiFetch<SopVersionListResponse>(getListVersionsApiHrSopLibraryDocumentsSopIdVersionsGetUrl(sopId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Open (``inline``) or download (``attachment``) a version's own file.
 * @summary Version File
 */
export const getVersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetUrl = (sopId: string,
    versionId: string,
    params?: VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hr/sop-library/documents/${sopId}/versions/${versionId}/file?${stringifiedParams}` : `/api/hr/sop-library/documents/${sopId}/versions/${versionId}/file`
}

export const versionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGet = async (sopId: string,
    versionId: string,
    params?: VersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getVersionFileApiHrSopLibraryDocumentsSopIdVersionsVersionIdFileGetUrl(sopId,versionId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The file's text, for the in-browser preview of Word / PowerPoint files.
 * @summary Version Text
 */
export const getVersionTextApiHrSopLibraryDocumentsSopIdVersionsVersionIdTextGetUrl = (sopId: string,
    versionId: string,) => {


  

  return `/api/hr/sop-library/documents/${sopId}/versions/${versionId}/text`
}

export const versionTextApiHrSopLibraryDocumentsSopIdVersionsVersionIdTextGet = async (sopId: string,
    versionId: string, options?: RequestInit): Promise<SopTextPreview> => {
  
  return apiFetch<SopTextPreview>(getVersionTextApiHrSopLibraryDocumentsSopIdVersionsVersionIdTextGetUrl(sopId,versionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Answer one question (phase 1: a search of the Knowledge documents) and save it.
 * @summary Ask
 */
export const getAskApiAiAskPostUrl = () => {


  

  return `/api/ai/ask`
}

export const askApiAiAskPost = async (aiAskRequest: AiAskRequest, options?: RequestInit): Promise<AiAskResponse> => {
  
  return apiFetch<AiAskResponse>(getAskApiAiAskPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiAskRequest,)
  }
);}



/**
 * @summary History
 */
export const getHistoryApiAiHistoryGetUrl = (params?: HistoryApiAiHistoryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai/history?${stringifiedParams}` : `/api/ai/history`
}

export const historyApiAiHistoryGet = async (params?: HistoryApiAiHistoryGetParams, options?: RequestInit): Promise<AiHistoryResponse> => {
  
  return apiFetch<AiHistoryResponse>(getHistoryApiAiHistoryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Export History
 */
export const getExportHistoryApiAiHistoryExportGetUrl = (params?: ExportHistoryApiAiHistoryExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai/history/export?${stringifiedParams}` : `/api/ai/history/export`
}

export const exportHistoryApiAiHistoryExportGet = async (params?: ExportHistoryApiAiHistoryExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportHistoryApiAiHistoryExportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * GEN-12-09 — the FAQ in the panel: active, In FAQ, and askable by her role.
 * @summary Get Faq
 */
export const getGetFaqApiAiFaqGetUrl = () => {


  

  return `/api/ai/faq`
}

export const getFaqApiAiFaqGet = async ( options?: RequestInit): Promise<AiFaqList> => {
  
  return apiFetch<AiFaqList>(getGetFaqApiAiFaqGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * GEN-12-13 — Q&A setup: FAQ rows first in FAQ order, then the rest.
 * @summary List Qa
 */
export const getListQaApiAiQaGetUrl = () => {


  

  return `/api/ai/qa`
}

export const listQaApiAiQaGet = async ( options?: RequestInit): Promise<AiQaList> => {
  
  return apiFetch<AiQaList>(getListQaApiAiQaGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Qa
 */
export const getCreateQaApiAiQaPostUrl = () => {


  

  return `/api/ai/qa`
}

export const createQaApiAiQaPost = async (aiQaWrite: AiQaWrite, options?: RequestInit): Promise<AiQaItem> => {
  
  return apiFetch<AiQaItem>(getCreateQaApiAiQaPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiQaWrite,)
  }
);}



/**
 * @summary Update Qa
 */
export const getUpdateQaApiAiQaQaIdPutUrl = (qaId: string,) => {


  

  return `/api/ai/qa/${qaId}`
}

export const updateQaApiAiQaQaIdPut = async (qaId: string,
    aiQaWrite: AiQaWrite, options?: RequestInit): Promise<AiQaItem> => {
  
  return apiFetch<AiQaItem>(getUpdateQaApiAiQaQaIdPutUrl(qaId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiQaWrite,)
  }
);}



/**
 * GEN-12-17 — HQ dragged the FAQ rows: saved at once.
 * @summary Set Faq Order
 */
export const getSetFaqOrderApiAiQaFaqOrderPutUrl = () => {


  

  return `/api/ai/qa-faq-order`
}

export const setFaqOrderApiAiQaFaqOrderPut = async (aiFaqOrder: AiFaqOrder, options?: RequestInit): Promise<AiQaList> => {
  
  return apiFetch<AiQaList>(getSetFaqOrderApiAiQaFaqOrderPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiFaqOrder,)
  }
);}



/**
 * GEN-12-12 — the questions Sunny could not answer; Open first.
 * @summary List Unanswered
 */
export const getListUnansweredApiAiUnansweredGetUrl = (params?: ListUnansweredApiAiUnansweredGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ai/unanswered?${stringifiedParams}` : `/api/ai/unanswered`
}

export const listUnansweredApiAiUnansweredGet = async (params?: ListUnansweredApiAiUnansweredGetParams, options?: RequestInit): Promise<AiUnansweredList> => {
  
  return apiFetch<AiUnansweredList>(getListUnansweredApiAiUnansweredGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Answer → a new active fixed Q&A; Sunny tells the person who asked (GEN-12-15).
 * @summary Answer Unanswered
 */
export const getAnswerUnansweredApiAiUnansweredQuestionIdAnswerPostUrl = (questionId: string,) => {


  

  return `/api/ai/unanswered/${questionId}/answer`
}

export const answerUnansweredApiAiUnansweredQuestionIdAnswerPost = async (questionId: string,
    aiQaWrite: AiQaWrite, options?: RequestInit): Promise<AiUnansweredItem> => {
  
  return apiFetch<AiUnansweredItem>(getAnswerUnansweredApiAiUnansweredQuestionIdAnswerPostUrl(questionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiQaWrite,)
  }
);}



/**
 * @summary Dismiss Unanswered
 */
export const getDismissUnansweredApiAiUnansweredQuestionIdDismissPostUrl = (questionId: string,) => {


  

  return `/api/ai/unanswered/${questionId}/dismiss`
}

export const dismissUnansweredApiAiUnansweredQuestionIdDismissPost = async (questionId: string, options?: RequestInit): Promise<AiUnansweredItem> => {
  
  return apiFetch<AiUnansweredItem>(getDismissUnansweredApiAiUnansweredQuestionIdDismissPostUrl(questionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * GEN-12-15 — HQ's answers to her questions, each given to her once.
 * @summary Take Hq Answers
 */
export const getTakeHqAnswersApiAiHqAnswersTakePostUrl = () => {


  

  return `/api/ai/hq-answers/take`
}

export const takeHqAnswersApiAiHqAnswersTakePost = async ( options?: RequestInit): Promise<AiHqAnswers> => {
  
  return apiFetch<AiHqAnswers>(getTakeHqAnswersApiAiHqAnswersTakePostUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Home
 */
export const getGetHomeApiAiHomeGetUrl = () => {


  

  return `/api/ai/home`
}

export const getHomeApiAiHomeGet = async ( options?: RequestInit): Promise<AiHome> => {
  
  return apiFetch<AiHome>(getGetHomeApiAiHomeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * The red number on the ✦ Yakson AI icon.
 * @summary Get Unread Count
 */
export const getGetUnreadCountApiAiUnreadCountGetUrl = () => {


  

  return `/api/ai/unread-count`
}

export const getUnreadCountApiAiUnreadCountGet = async ( options?: RequestInit): Promise<AiUnreadCount> => {
  
  return apiFetch<AiUnreadCount>(getGetUnreadCountApiAiUnreadCountGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * She opened this chat: its HQ answer is no longer unread. Returns the new count.
 * @summary Mark Chat Seen
 */
export const getMarkChatSeenApiAiRecentQuestionIdSeenPostUrl = (questionId: string,) => {


  

  return `/api/ai/recent/${questionId}/seen`
}

export const markChatSeenApiAiRecentQuestionIdSeenPost = async (questionId: string, options?: RequestInit): Promise<AiUnreadCount> => {
  
  return apiFetch<AiUnreadCount>(getMarkChatSeenApiAiRecentQuestionIdSeenPostUrl(questionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary List Leave Types
 */
export const getListLeaveTypesApiLeaveTypesGetUrl = () => {


  

  return `/api/leave/types`
}

export const listLeaveTypesApiLeaveTypesGet = async ( options?: RequestInit): Promise<LeaveTypeListResponse> => {
  
  return apiFetch<LeaveTypeListResponse>(getListLeaveTypesApiLeaveTypesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Leave Type
 */
export const getCreateLeaveTypeApiLeaveTypesPostUrl = () => {


  

  return `/api/leave/types`
}

export const createLeaveTypeApiLeaveTypesPost = async (leaveTypeCreateRequest: LeaveTypeCreateRequest, options?: RequestInit): Promise<LeaveTypeResponse> => {
  
  return apiFetch<LeaveTypeResponse>(getCreateLeaveTypeApiLeaveTypesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveTypeCreateRequest,)
  }
);}



/**
 * @summary List Available Leave Types
 */
export const getListAvailableLeaveTypesApiLeaveTypesAvailableGetUrl = () => {


  

  return `/api/leave/types/available`
}

export const listAvailableLeaveTypesApiLeaveTypesAvailableGet = async ( options?: RequestInit): Promise<AvailableLeaveTypesResponse> => {
  
  return apiFetch<AvailableLeaveTypesResponse>(getListAvailableLeaveTypesApiLeaveTypesAvailableGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Leave Type
 */
export const getUpdateLeaveTypeApiLeaveTypesTypeIdPatchUrl = (typeId: string,) => {


  

  return `/api/leave/types/${typeId}`
}

export const updateLeaveTypeApiLeaveTypesTypeIdPatch = async (typeId: string,
    leaveTypeUpdateRequest: LeaveTypeUpdateRequest, options?: RequestInit): Promise<LeaveTypeResponse> => {
  
  return apiFetch<LeaveTypeResponse>(getUpdateLeaveTypeApiLeaveTypesTypeIdPatchUrl(typeId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveTypeUpdateRequest,)
  }
);}



/**
 * @summary Set Leave Type Staff
 */
export const getSetLeaveTypeStaffApiLeaveTypesTypeIdStaffPutUrl = (typeId: string,) => {


  

  return `/api/leave/types/${typeId}/staff`
}

export const setLeaveTypeStaffApiLeaveTypesTypeIdStaffPut = async (typeId: string,
    leaveTypeStaffUpdateRequest: LeaveTypeStaffUpdateRequest, options?: RequestInit): Promise<LeaveTypeResponse> => {
  
  return apiFetch<LeaveTypeResponse>(getSetLeaveTypeStaffApiLeaveTypesTypeIdStaffPutUrl(typeId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leaveTypeStaffUpdateRequest,)
  }
);}



/**
 * @summary Deactivate Leave Type
 */
export const getDeactivateLeaveTypeApiLeaveTypesTypeIdDeactivatePostUrl = (typeId: string,) => {


  

  return `/api/leave/types/${typeId}/deactivate`
}

export const deactivateLeaveTypeApiLeaveTypesTypeIdDeactivatePost = async (typeId: string, options?: RequestInit): Promise<LeaveTypeResponse> => {
  
  return apiFetch<LeaveTypeResponse>(getDeactivateLeaveTypeApiLeaveTypesTypeIdDeactivatePostUrl(typeId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Reactivate Leave Type
 */
export const getReactivateLeaveTypeApiLeaveTypesTypeIdReactivatePostUrl = (typeId: string,) => {


  

  return `/api/leave/types/${typeId}/reactivate`
}

export const reactivateLeaveTypeApiLeaveTypesTypeIdReactivatePost = async (typeId: string, options?: RequestInit): Promise<LeaveTypeResponse> => {
  
  return apiFetch<LeaveTypeResponse>(getReactivateLeaveTypeApiLeaveTypesTypeIdReactivatePostUrl(typeId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get Promotion Template
 */
export const getGetPromotionTemplateApiPromotionTemplateGetUrl = () => {


  

  return `/api/promotion/template`
}

export const getPromotionTemplateApiPromotionTemplateGet = async ( options?: RequestInit): Promise<PromotionTemplateResponse> => {
  
  return apiFetch<PromotionTemplateResponse>(getGetPromotionTemplateApiPromotionTemplateGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Save Promotion Template
 */
export const getSavePromotionTemplateApiPromotionTemplatePutUrl = () => {


  

  return `/api/promotion/template`
}

export const savePromotionTemplateApiPromotionTemplatePut = async (promotionTemplateSave: PromotionTemplateSave, options?: RequestInit): Promise<PromotionTemplateResponse> => {
  
  return apiFetch<PromotionTemplateResponse>(getSavePromotionTemplateApiPromotionTemplatePutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      promotionTemplateSave,)
  }
);}



/**
 * @summary Get Promotion Status
 */
export const getGetPromotionStatusApiPromotionStatusGetUrl = (params?: GetPromotionStatusApiPromotionStatusGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/promotion/status?${stringifiedParams}` : `/api/promotion/status`
}

export const getPromotionStatusApiPromotionStatusGet = async (params?: GetPromotionStatusApiPromotionStatusGetParams, options?: RequestInit): Promise<PromotionStatusResponse> => {
  
  return apiFetch<PromotionStatusResponse>(getGetPromotionStatusApiPromotionStatusGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Promote Staff
 */
export const getPromoteStaffApiPromotionPromotePostUrl = () => {


  

  return `/api/promotion/promote`
}

export const promoteStaffApiPromotionPromotePost = async (promoteRequest: PromoteRequest, options?: RequestInit): Promise<StaffPromotionOut> => {
  
  return apiFetch<StaffPromotionOut>(getPromoteStaffApiPromotionPromotePostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      promoteRequest,)
  }
);}



/**
 * @summary Get Promotion History
 */
export const getGetPromotionHistoryApiPromotionHistoryGetUrl = (params?: GetPromotionHistoryApiPromotionHistoryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/promotion/history?${stringifiedParams}` : `/api/promotion/history`
}

export const getPromotionHistoryApiPromotionHistoryGet = async (params?: GetPromotionHistoryApiPromotionHistoryGetParams, options?: RequestInit): Promise<PromotionHistoryResponse> => {
  
  return apiFetch<PromotionHistoryResponse>(getGetPromotionHistoryApiPromotionHistoryGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Submission: her department's allowance this month and her own claims.
 * @summary My Claims
 */
export const getMyClaimsApiStaffClaimsMeGetUrl = (params?: MyClaimsApiStaffClaimsMeGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff-claims/me?${stringifiedParams}` : `/api/staff-claims/me`
}

export const myClaimsApiStaffClaimsMeGet = async (params?: MyClaimsApiStaffClaimsMeGetParams, options?: RequestInit): Promise<MyClaims> => {
  
  return apiFetch<MyClaims>(getMyClaimsApiStaffClaimsMeGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Submit Claim
 */
export const getSubmitClaimApiStaffClaimsPostUrl = () => {


  

  return `/api/staff-claims`
}

export const submitClaimApiStaffClaimsPost = async (staffClaimCreate: StaffClaimCreate, options?: RequestInit): Promise<StaffClaimSaved> => {
  
  return apiFetch<StaffClaimSaved>(getSubmitClaimApiStaffClaimsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffClaimCreate,)
  }
);}



/**
 * Her own claim, only while it is Uploaded.
 * @summary Update Claim
 */
export const getUpdateClaimApiStaffClaimsClaimIdPutUrl = (claimId: string,) => {


  

  return `/api/staff-claims/${claimId}`
}

export const updateClaimApiStaffClaimsClaimIdPut = async (claimId: string,
    staffClaimCreate: StaffClaimCreate, options?: RequestInit): Promise<StaffClaimSaved> => {
  
  return apiFetch<StaffClaimSaved>(getUpdateClaimApiStaffClaimsClaimIdPutUrl(claimId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffClaimCreate,)
  }
);}



/**
 * @summary Withdraw Claim
 */
export const getWithdrawClaimApiStaffClaimsClaimIdWithdrawPostUrl = (claimId: string,) => {


  

  return `/api/staff-claims/${claimId}/withdraw`
}

export const withdrawClaimApiStaffClaimsClaimIdWithdrawPost = async (claimId: string, options?: RequestInit): Promise<StaffClaimOut> => {
  
  return apiFetch<StaffClaimOut>(getWithdrawClaimApiStaffClaimsClaimIdWithdrawPostUrl(claimId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * Responses (HQ): every department's allowance card and claim lines.
 * @summary Claim Responses
 */
export const getClaimResponsesApiStaffClaimsResponsesGetUrl = (params?: ClaimResponsesApiStaffClaimsResponsesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staff-claims/responses?${stringifiedParams}` : `/api/staff-claims/responses`
}

export const claimResponsesApiStaffClaimsResponsesGet = async (params?: ClaimResponsesApiStaffClaimsResponsesGetParams, options?: RequestInit): Promise<ClaimResponses> => {
  
  return apiFetch<ClaimResponses>(getClaimResponsesApiStaffClaimsResponsesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Mark Claim Paid
 */
export const getMarkClaimPaidApiStaffClaimsClaimIdPaidPostUrl = (claimId: string,) => {


  

  return `/api/staff-claims/${claimId}/paid`
}

export const markClaimPaidApiStaffClaimsClaimIdPaidPost = async (claimId: string, options?: RequestInit): Promise<StaffClaimOut> => {
  
  return apiFetch<StaffClaimOut>(getMarkClaimPaidApiStaffClaimsClaimIdPaidPostUrl(claimId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Reject Claim
 */
export const getRejectClaimApiStaffClaimsClaimIdRejectPostUrl = (claimId: string,) => {


  

  return `/api/staff-claims/${claimId}/reject`
}

export const rejectClaimApiStaffClaimsClaimIdRejectPost = async (claimId: string,
    staffClaimReject: StaffClaimReject, options?: RequestInit): Promise<StaffClaimOut> => {
  
  return apiFetch<StaffClaimOut>(getRejectClaimApiStaffClaimsClaimIdRejectPostUrl(claimId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffClaimReject,)
  }
);}



/**
 * @summary List Training Sessions
 */
export const getListTrainingSessionsApiTrainingSessionsGetUrl = (params: ListTrainingSessionsApiTrainingSessionsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/training/sessions?${stringifiedParams}` : `/api/training/sessions`
}

export const listTrainingSessionsApiTrainingSessionsGet = async (params: ListTrainingSessionsApiTrainingSessionsGetParams, options?: RequestInit): Promise<TrainingSessionListResponse> => {
  
  return apiFetch<TrainingSessionListResponse>(getListTrainingSessionsApiTrainingSessionsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Training Session
 */
export const getCreateTrainingSessionApiTrainingSessionsPostUrl = () => {


  

  return `/api/training/sessions`
}

export const createTrainingSessionApiTrainingSessionsPost = async (trainingSessionCreate: TrainingSessionCreate, options?: RequestInit): Promise<TrainingSessionResponse> => {
  
  return apiFetch<TrainingSessionResponse>(getCreateTrainingSessionApiTrainingSessionsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingSessionCreate,)
  }
);}



/**
 * @summary Update Training Session
 */
export const getUpdateTrainingSessionApiTrainingSessionsSessionIdPatchUrl = (sessionId: string,) => {


  

  return `/api/training/sessions/${sessionId}`
}

export const updateTrainingSessionApiTrainingSessionsSessionIdPatch = async (sessionId: string,
    trainingSessionUpdate: TrainingSessionUpdate, options?: RequestInit): Promise<TrainingSessionResponse> => {
  
  return apiFetch<TrainingSessionResponse>(getUpdateTrainingSessionApiTrainingSessionsSessionIdPatchUrl(sessionId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainingSessionUpdate,)
  }
);}



/**
 * HQ turns a Head Master's request into a session on the calendar.
 * @summary Approve Training Request
 */
export const getApproveTrainingRequestApiTrainingSessionsSessionIdApprovePostUrl = (sessionId: string,) => {


  

  return `/api/training/sessions/${sessionId}/approve`
}

export const approveTrainingRequestApiTrainingSessionsSessionIdApprovePost = async (sessionId: string, options?: RequestInit): Promise<TrainingSessionResponse> => {
  
  return apiFetch<TrainingSessionResponse>(getApproveTrainingRequestApiTrainingSessionsSessionIdApprovePostUrl(sessionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HQ declines a request; it is kept for the record and leaves the calendar.
 * @summary Decline Training Request
 */
export const getDeclineTrainingRequestApiTrainingSessionsSessionIdDeclinePostUrl = (sessionId: string,) => {


  

  return `/api/training/sessions/${sessionId}/decline`
}

export const declineTrainingRequestApiTrainingSessionsSessionIdDeclinePost = async (sessionId: string, options?: RequestInit): Promise<TrainingSessionResponse> => {
  
  return apiFetch<TrainingSessionResponse>(getDeclineTrainingRequestApiTrainingSessionsSessionIdDeclinePostUrl(sessionId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * The treatment steps and SOPs a sheet Topic can be mapped to.
 * @summary Topic Map Options
 */
export const getTopicMapOptionsApiTrainingSessionsImportTopicMapOptionsGetUrl = () => {


  

  return `/api/training/sessions/import/topic-map/options`
}

export const topicMapOptionsApiTrainingSessionsImportTopicMapOptionsGet = async ( options?: RequestInit): Promise<TopicMapOptions> => {
  
  return apiFetch<TopicMapOptions>(getTopicMapOptionsApiTrainingSessionsImportTopicMapOptionsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Save the Topic -> step / SOP answers HQ gave on the import screen. They are
reused by every later import; an entry with no step and no SOP clears it.
 * @summary Save Topic Map
 */
export const getSaveTopicMapApiTrainingSessionsImportTopicMapPutUrl = () => {


  

  return `/api/training/sessions/import/topic-map`
}

export const saveTopicMapApiTrainingSessionsImportTopicMapPut = async (topicMapSave: TopicMapSave, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getSaveTopicMapApiTrainingSessionsImportTopicMapPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      topicMapSave,)
  }
);}



/**
 * HQ uploads the 'training log sheet (Responses)' export and sees what
would be created: rows ready, rows already imported, staff names and
outlets that could not be matched. Nothing is saved.
 * @summary Preview Training Import
 */
export const getPreviewTrainingImportApiTrainingSessionsImportPreviewPostUrl = () => {


  

  return `/api/training/sessions/import/preview`
}

export const previewTrainingImportApiTrainingSessionsImportPreviewPost = async (bodyPreviewTrainingImportApiTrainingSessionsImportPreviewPost: BodyPreviewTrainingImportApiTrainingSessionsImportPreviewPost, options?: RequestInit): Promise<TrainingImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyPreviewTrainingImportApiTrainingSessionsImportPreviewPost.file)

  return apiFetch<TrainingImportPreview>(getPreviewTrainingImportApiTrainingSessionsImportPreviewPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * Create one session per READY row of the same file; rows already imported
(same fingerprint) and rows with problems are left out.
 * @summary Run Training Import
 */
export const getRunTrainingImportApiTrainingSessionsImportPostUrl = () => {


  

  return `/api/training/sessions/import`
}

export const runTrainingImportApiTrainingSessionsImportPost = async (bodyRunTrainingImportApiTrainingSessionsImportPost: BodyRunTrainingImportApiTrainingSessionsImportPost, options?: RequestInit): Promise<TrainingImportResult> => {
    const formData = new FormData();
formData.append(`file`, bodyRunTrainingImportApiTrainingSessionsImportPost.file)

  return apiFetch<TrainingImportResult>(getRunTrainingImportApiTrainingSessionsImportPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary List Rounds
 */
export const getListRoundsApiPerformanceReviewRoundsGetUrl = () => {


  

  return `/api/performance-review/rounds`
}

export const listRoundsApiPerformanceReviewRoundsGet = async ( options?: RequestInit): Promise<ReviewRoundListResponse> => {
  
  return apiFetch<ReviewRoundListResponse>(getListRoundsApiPerformanceReviewRoundsGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Round
 */
export const getCreateRoundApiPerformanceReviewRoundsPostUrl = () => {


  

  return `/api/performance-review/rounds`
}

export const createRoundApiPerformanceReviewRoundsPost = async (reviewRoundCreate: ReviewRoundCreate, options?: RequestInit): Promise<ReviewRoundResponse> => {
  
  return apiFetch<ReviewRoundResponse>(getCreateRoundApiPerformanceReviewRoundsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewRoundCreate,)
  }
);}



/**
 * @summary Close Round
 */
export const getCloseRoundApiPerformanceReviewRoundsRoundIdClosePostUrl = (roundId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/close`
}

export const closeRoundApiPerformanceReviewRoundsRoundIdClosePost = async (roundId: string, options?: RequestInit): Promise<ReviewRoundResponse> => {
  
  return apiFetch<ReviewRoundResponse>(getCloseRoundApiPerformanceReviewRoundsRoundIdClosePostUrl(roundId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Reopen Round
 */
export const getReopenRoundApiPerformanceReviewRoundsRoundIdReopenPostUrl = (roundId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/reopen`
}

export const reopenRoundApiPerformanceReviewRoundsRoundIdReopenPost = async (roundId: string, options?: RequestInit): Promise<ReviewRoundResponse> => {
  
  return apiFetch<ReviewRoundResponse>(getReopenRoundApiPerformanceReviewRoundsRoundIdReopenPostUrl(roundId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Release Results
 */
export const getReleaseResultsApiPerformanceReviewRoundsRoundIdReleasePostUrl = (roundId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/release`
}

export const releaseResultsApiPerformanceReviewRoundsRoundIdReleasePost = async (roundId: string, options?: RequestInit): Promise<ReviewRoundResponse> => {
  
  return apiFetch<ReviewRoundResponse>(getReleaseResultsApiPerformanceReviewRoundsRoundIdReleasePostUrl(roundId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary My Colleagues
 */
export const getMyColleaguesApiPerformanceReviewRoundsRoundIdMyColleaguesGetUrl = (roundId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/my-colleagues`
}

export const myColleaguesApiPerformanceReviewRoundsRoundIdMyColleaguesGet = async (roundId: string, options?: RequestInit): Promise<MyColleaguesResponse> => {
  
  return apiFetch<MyColleaguesResponse>(getMyColleaguesApiPerformanceReviewRoundsRoundIdMyColleaguesGetUrl(roundId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Submit Review
 */
export const getSubmitReviewApiPerformanceReviewRoundsRoundIdResponsesPostUrl = (roundId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/responses`
}

export const submitReviewApiPerformanceReviewRoundsRoundIdResponsesPost = async (roundId: string,
    reviewSubmitRequest: ReviewSubmitRequest, options?: RequestInit): Promise<ReviewResponseOut> => {
  
  return apiFetch<ReviewResponseOut>(getSubmitReviewApiPerformanceReviewRoundsRoundIdResponsesPostUrl(roundId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewSubmitRequest,)
  }
);}



/**
 * @summary Edit Review
 */
export const getEditReviewApiPerformanceReviewResponsesResponseIdPatchUrl = (responseId: string,) => {


  

  return `/api/performance-review/responses/${responseId}`
}

export const editReviewApiPerformanceReviewResponsesResponseIdPatch = async (responseId: string,
    reviewEditRequest: ReviewEditRequest, options?: RequestInit): Promise<ReviewResponseOut> => {
  
  return apiFetch<ReviewResponseOut>(getEditReviewApiPerformanceReviewResponsesResponseIdPatchUrl(responseId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewEditRequest,)
  }
);}



/**
 * @summary Results
 */
export const getResultsApiPerformanceReviewRoundsRoundIdResultsGetUrl = (roundId: string,
    params?: ResultsApiPerformanceReviewRoundsRoundIdResultsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/performance-review/rounds/${roundId}/results?${stringifiedParams}` : `/api/performance-review/rounds/${roundId}/results`
}

export const resultsApiPerformanceReviewRoundsRoundIdResultsGet = async (roundId: string,
    params?: ResultsApiPerformanceReviewRoundsRoundIdResultsGetParams, options?: RequestInit): Promise<ResultsResponse> => {
  
  return apiFetch<ResultsResponse>(getResultsApiPerformanceReviewRoundsRoundIdResultsGetUrl(roundId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Export Results
 */
export const getExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetUrl = (roundId: string,
    params?: ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/performance-review/rounds/${roundId}/results/export?${stringifiedParams}` : `/api/performance-review/rounds/${roundId}/results/export`
}

export const exportResultsApiPerformanceReviewRoundsRoundIdResultsExportGet = async (roundId: string,
    params?: ExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetParams, options?: RequestInit): Promise<unknown> => {
  
  return apiFetch<unknown>(getExportResultsApiPerformanceReviewRoundsRoundIdResultsExportGetUrl(roundId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Score Card
 */
export const getScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdGetUrl = (roundId: string,
    staffId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/score-card/${staffId}`
}

export const scoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdGet = async (roundId: string,
    staffId: string, options?: RequestInit): Promise<ScoreCardResponse> => {
  
  return apiFetch<ScoreCardResponse>(getScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdGetUrl(roundId,staffId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update Score Card
 */
export const getUpdateScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdPutUrl = (roundId: string,
    staffId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/score-card/${staffId}`
}

export const updateScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdPut = async (roundId: string,
    staffId: string,
    scoreCardUpdate: ScoreCardUpdate, options?: RequestInit): Promise<ScoreCardResponse> => {
  
  return apiFetch<ScoreCardResponse>(getUpdateScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdPutUrl(roundId,staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scoreCardUpdate,)
  }
);}



/**
 * @summary Acknowledge Score Card
 */
export const getAcknowledgeScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdAcknowledgePostUrl = (roundId: string,
    staffId: string,) => {


  

  return `/api/performance-review/rounds/${roundId}/score-card/${staffId}/acknowledge`
}

export const acknowledgeScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdAcknowledgePost = async (roundId: string,
    staffId: string, options?: RequestInit): Promise<SuccessResponse> => {
  
  return apiFetch<SuccessResponse>(getAcknowledgeScoreCardApiPerformanceReviewRoundsRoundIdScoreCardStaffIdAcknowledgePostUrl(roundId,staffId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HQ uploads a '<year> Q<n> Performance Review (Responses)' export and sees
what would be created — the round, rows ready / already imported / skipped,
names that could not be matched. Nothing is saved.
 * @summary Preview Review Import
 */
export const getPreviewReviewImportApiPerformanceReviewImportPreviewPostUrl = () => {


  

  return `/api/performance-review/import/preview`
}

export const previewReviewImportApiPerformanceReviewImportPreviewPost = async (bodyPreviewReviewImportApiPerformanceReviewImportPreviewPost: BodyPreviewReviewImportApiPerformanceReviewImportPreviewPost, options?: RequestInit): Promise<ReviewImportPreview> => {
    const formData = new FormData();
formData.append(`file`, bodyPreviewReviewImportApiPerformanceReviewImportPreviewPost.file)
if(bodyPreviewReviewImportApiPerformanceReviewImportPreviewPost.quarter !== undefined && bodyPreviewReviewImportApiPerformanceReviewImportPreviewPost.quarter !== null) {
 formData.append(`quarter`, bodyPreviewReviewImportApiPerformanceReviewImportPreviewPost.quarter)
 }

  return apiFetch<ReviewImportPreview>(getPreviewReviewImportApiPerformanceReviewImportPreviewPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * Create the round (closed, results not released) if it does not exist and
one response per READY row; rows already there or with problems are left out.
 * @summary Run Review Import
 */
export const getRunReviewImportApiPerformanceReviewImportPostUrl = () => {


  

  return `/api/performance-review/import`
}

export const runReviewImportApiPerformanceReviewImportPost = async (bodyRunReviewImportApiPerformanceReviewImportPost: BodyRunReviewImportApiPerformanceReviewImportPost, options?: RequestInit): Promise<ReviewImportResult> => {
    const formData = new FormData();
formData.append(`file`, bodyRunReviewImportApiPerformanceReviewImportPost.file)
if(bodyRunReviewImportApiPerformanceReviewImportPost.quarter !== undefined && bodyRunReviewImportApiPerformanceReviewImportPost.quarter !== null) {
 formData.append(`quarter`, bodyRunReviewImportApiPerformanceReviewImportPost.quarter)
 }

  return apiFetch<ReviewImportResult>(getRunReviewImportApiPerformanceReviewImportPostUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}



/**
 * @summary List Fields
 */
export const getListFieldsApiCustomerFieldsGetUrl = (params?: ListFieldsApiCustomerFieldsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-fields?${stringifiedParams}` : `/api/customer-fields`
}

export const listFieldsApiCustomerFieldsGet = async (params?: ListFieldsApiCustomerFieldsGetParams, options?: RequestInit): Promise<CustomerFieldListResponse> => {
  
  return apiFetch<CustomerFieldListResponse>(getListFieldsApiCustomerFieldsGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create Field
 */
export const getCreateFieldApiCustomerFieldsPostUrl = () => {


  

  return `/api/customer-fields`
}

export const createFieldApiCustomerFieldsPost = async (customerFieldCreate: CustomerFieldCreate, options?: RequestInit): Promise<CustomerFieldResponse> => {
  
  return apiFetch<CustomerFieldResponse>(getCreateFieldApiCustomerFieldsPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerFieldCreate,)
  }
);}



/**
 * @summary Reorder Fields
 */
export const getReorderFieldsApiCustomerFieldsReorderPutUrl = () => {


  

  return `/api/customer-fields/reorder`
}

export const reorderFieldsApiCustomerFieldsReorderPut = async (customerFieldReorder: CustomerFieldReorder, options?: RequestInit): Promise<CustomerFieldListResponse> => {
  
  return apiFetch<CustomerFieldListResponse>(getReorderFieldsApiCustomerFieldsReorderPutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerFieldReorder,)
  }
);}



/**
 * @summary Bulk Values
 */
export const getBulkValuesApiCustomerFieldsValuesGetUrl = (params?: BulkValuesApiCustomerFieldsValuesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customer-fields/values?${stringifiedParams}` : `/api/customer-fields/values`
}

export const bulkValuesApiCustomerFieldsValuesGet = async (params?: BulkValuesApiCustomerFieldsValuesGetParams, options?: RequestInit): Promise<CustomerFieldBulkValuesResponse> => {
  
  return apiFetch<CustomerFieldBulkValuesResponse>(getBulkValuesApiCustomerFieldsValuesGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get Values
 */
export const getGetValuesApiCustomerFieldsCustomersCustomerIdGetUrl = (customerId: string,) => {


  

  return `/api/customer-fields/customers/${customerId}`
}

export const getValuesApiCustomerFieldsCustomersCustomerIdGet = async (customerId: string, options?: RequestInit): Promise<CustomerFieldValuesResponse> => {
  
  return apiFetch<CustomerFieldValuesResponse>(getGetValuesApiCustomerFieldsCustomersCustomerIdGetUrl(customerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Put Values
 */
export const getPutValuesApiCustomerFieldsCustomersCustomerIdPutUrl = (customerId: string,) => {


  

  return `/api/customer-fields/customers/${customerId}`
}

export const putValuesApiCustomerFieldsCustomersCustomerIdPut = async (customerId: string,
    customerFieldValuesUpdate: CustomerFieldValuesUpdate, options?: RequestInit): Promise<CustomerFieldValuesResponse> => {
  
  return apiFetch<CustomerFieldValuesResponse>(getPutValuesApiCustomerFieldsCustomersCustomerIdPutUrl(customerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerFieldValuesUpdate,)
  }
);}



/**
 * @summary Update Field
 */
export const getUpdateFieldApiCustomerFieldsFieldIdPutUrl = (fieldId: string,) => {


  

  return `/api/customer-fields/${fieldId}`
}

export const updateFieldApiCustomerFieldsFieldIdPut = async (fieldId: string,
    customerFieldUpdate: CustomerFieldUpdate, options?: RequestInit): Promise<CustomerFieldResponse> => {
  
  return apiFetch<CustomerFieldResponse>(getUpdateFieldApiCustomerFieldsFieldIdPutUrl(fieldId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerFieldUpdate,)
  }
);}



/**
 * Hides a custom field; its customer values are kept.
 * @summary Archive Field
 */
export const getArchiveFieldApiCustomerFieldsFieldIdDeleteUrl = (fieldId: string,) => {


  

  return `/api/customer-fields/${fieldId}`
}

export const archiveFieldApiCustomerFieldsFieldIdDelete = async (fieldId: string, options?: RequestInit): Promise<CustomerFieldResponse> => {
  
  return apiFetch<CustomerFieldResponse>(getArchiveFieldApiCustomerFieldsFieldIdDeleteUrl(fieldId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List Devices
 */
export const getListDevicesApiAttendanceDevicesGetUrl = () => {


  

  return `/api/attendance/devices`
}

export const listDevicesApiAttendanceDevicesGet = async ( options?: RequestInit): Promise<DeviceListResponse> => {
  
  return apiFetch<DeviceListResponse>(getListDevicesApiAttendanceDevicesGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HQ registers THIS iPad for an outlet. The token comes back once; the
iPad keeps it, the OS keeps only its hash. Any earlier iPad of that outlet
is retired.
 * @summary Register Device
 */
export const getRegisterDeviceApiAttendanceDevicesPostUrl = () => {


  

  return `/api/attendance/devices`
}

export const registerDeviceApiAttendanceDevicesPost = async (deviceRegister: DeviceRegister, options?: RequestInit): Promise<DeviceRegistered> => {
  
  return apiFetch<DeviceRegistered>(getRegisterDeviceApiAttendanceDevicesPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceRegister,)
  }
);}



/**
 * @summary Revoke Device
 */
export const getRevokeDeviceApiAttendanceDevicesDeviceIdRevokePostUrl = (deviceId: string,) => {


  

  return `/api/attendance/devices/${deviceId}/revoke`
}

export const revokeDeviceApiAttendanceDevicesDeviceIdRevokePost = async (deviceId: string, options?: RequestInit): Promise<DeviceOut> => {
  
  return apiFetch<DeviceOut>(getRevokeDeviceApiAttendanceDevicesDeviceIdRevokePostUrl(deviceId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * HQ sets (or resets) a staff member's 4-digit PIN; stored hashed.
 * @summary Set Staff Pin
 */
export const getSetStaffPinApiAttendanceStaffStaffIdPinPutUrl = (staffId: string,) => {


  

  return `/api/attendance/staff/${staffId}/pin`
}

export const setStaffPinApiAttendanceStaffStaffIdPinPut = async (staffId: string,
    pinSet: PinSet, options?: RequestInit): Promise<void> => {
  
  return apiFetch<void>(getSetStaffPinApiAttendanceStaffStaffIdPinPutUrl(staffId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pinSet,)
  }
);}



/**
 * 'Today at <outlet>' for the registered iPad — no login, the token is the key.
 * @summary Kiosk
 */
export const getKioskApiAttendanceKioskGetUrl = () => {


  

  return `/api/attendance/kiosk`
}

export const kioskApiAttendanceKioskGet = async ( options?: RequestInit): Promise<KioskResponse> => {
  
  return apiFetch<KioskResponse>(getKioskApiAttendanceKioskGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * One press. Wrong PIN or a press out of order → refused, nothing saved.
 * @summary Kiosk Clock
 */
export const getKioskClockApiAttendanceKioskClockPostUrl = () => {


  

  return `/api/attendance/kiosk/clock`
}

export const kioskClockApiAttendanceKioskClockPost = async (kioskClock: KioskClock, options?: RequestInit): Promise<KioskClockResponse> => {
  
  return apiFetch<KioskClockResponse>(getKioskClockApiAttendanceKioskClockPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      kioskClock,)
  }
);}



/**
 * My Profile > Time attendance: the signed-in user's own line today, and
whether this browser is the outlet's registered iPad (HR-21-08).
 * @summary My Clock State
 */
export const getMyClockStateApiAttendanceMeGetUrl = () => {


  

  return `/api/attendance/me`
}

export const myClockStateApiAttendanceMeGet = async ( options?: RequestInit): Promise<MyClockState> => {
  
  return apiFetch<MyClockState>(getMyClockStateApiAttendanceMeGetUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * One press for the signed-in staff member herself — no PIN, no staffId in
the body. Refused (403) unless the request carries the outlet iPad's token.
 * @summary My Clock
 */
export const getMyClockApiAttendanceMeClockPostUrl = () => {


  

  return `/api/attendance/me/clock`
}

export const myClockApiAttendanceMeClockPost = async (myClock: MyClock, options?: RequestInit): Promise<KioskClockResponse> => {
  
  return apiFetch<KioskClockResponse>(getMyClockApiAttendanceMeClockPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      myClock,)
  }
);}



/**
 * @summary Attendance Report
 */
export const getAttendanceReportApiAttendanceReportGetUrl = (params: AttendanceReportApiAttendanceReportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/attendance/report?${stringifiedParams}` : `/api/attendance/report`
}

export const attendanceReportApiAttendanceReportGet = async (params: AttendanceReportApiAttendanceReportGetParams, options?: RequestInit): Promise<AttendanceReport> => {
  
  return apiFetch<AttendanceReport>(getAttendanceReportApiAttendanceReportGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-21-10 (Angela, 24 Oct 2026) — Staff Details > Time attendance: one
staff member's month. Staff see their own only; HQ (office) sees everyone.
``format`` gives the detail view as Excel.
 * @summary Staff Attendance Month
 */
export const getStaffAttendanceMonthApiAttendanceStaffStaffIdMonthGetUrl = (staffId: string,
    params: StaffAttendanceMonthApiAttendanceStaffStaffIdMonthGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/attendance/staff/${staffId}/month?${stringifiedParams}` : `/api/attendance/staff/${staffId}/month`
}

export const staffAttendanceMonthApiAttendanceStaffStaffIdMonthGet = async (staffId: string,
    params: StaffAttendanceMonthApiAttendanceStaffStaffIdMonthGetParams, options?: RequestInit): Promise<StaffAttendanceMonth> => {
  
  return apiFetch<StaffAttendanceMonth>(getStaffAttendanceMonthApiAttendanceStaffStaffIdMonthGetUrl(staffId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * HR-21-05 / D24-6 — HQ decides one To check line of the Attendance
Report: Fix time · Accept · Note · Mark leave · Approve OT · Reject. Saved
once with who and when; an approved OT goes to the OT balance (HR > Leave),
never to Payroll.
 * @summary Decide Check
 */
export const getDecideCheckApiAttendanceChecksPostUrl = () => {


  

  return `/api/attendance/checks`
}

export const decideCheckApiAttendanceChecksPost = async (checkDecide: CheckDecide, options?: RequestInit): Promise<ToCheckItem> => {
  
  return apiFetch<ToCheckItem>(getDecideCheckApiAttendanceChecksPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkDecide,)
  }
);}
